// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/core/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/daygrid/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/timegrid/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/timeline/main.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/resource-timeline/main.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAABGdBTUEAALGPC/xhBQAAAbtJREFUWAntmMtKw0AUhhMvS5cuxILgQlRUpIggIoKIIoigG1eC+AA+jo+i6FIXBfeuXIgoeKVeitVWJX5HWhhDksnUpp3FDPyZk3Nm5nycmZKkXhAEOXSA3lG7muTeRzmfy6HneUvIhnYkQK+Q9NhAA0Opg0vBEhjBKHiyb8iGMyQMOYuK41BcBSypAL+MYXSKjtFAW7EAGEO3qN4uMQbbAkXiSfRQJ1H6a+yhlkKRcAoVFYiweYNjtCVQJJpBz2GCiPt7fBOZQpFgDpUikse5HgnkM4Fi4QX0Fpc5wf9EbLqpUCy4jMoJSXWhFwbMNgWKhVbRhy5jirhs9fy/oFhgHVVTJEs7RLZ8sSEoJm6iz7SZDMbJ+/OKERQTttCXQRLToRUmrKWCYuA2+jbN0MB4OQobYShfdTCgn/sL1K36M7TLrN3n+758aPy2rrpR6+/od5E8tf/A1uLS9aId5T7J3CNYihkQ4D9PiMdMC7mp4rjB9kjFjZp8BlnVHJBuO1yFXIV0FdDF3RlyFdJVQBdv5AxVdIsq8apiZ2PyYO1EVykesGfZEESsCkweyR8MUW+V8uJ1gkYipmpdP1pm2aJVPEGzAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/*
Author         : G-axon
Template Name  : Wieldy Antd React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
        02. Colors Class

    B. Base
        01. Base Styles
        02. Row Col Styles
        03. Margin Padding Styles
        04. Typography Styles
        05. Flex Styles

    C. Layouts
        01. Ant Layout Style
        02. Header Style
        03. Sidebar Style
        04. Navbar(Ant Menu) Style
        05. Footer Styles
        06. Customizer Style
        07. Drawer Style

    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. BackTop Styles
        04. Badges Styles
        05. Button Styles
        06. Cards Styles
        07. Cascader Styles
        08. Chart Styles
        09. Form Styles
        10. Icon Styles
        11. Input Styles
        12. List Styles
        13. Loader Styles
        14. Pagination Styles
        15. Pickers Styles
        16. Progress Styles
        17. Slider Styles
        18. Steps Styles
        19. Tables Styles
        20. Tabs Styles
        21. Time Lines Style

    E. Apps
        01. Apps Style
        02. Mails Apps Styles
        03. Chat Apps Styles
        04. Contact Apps Styles
        05. Calendar Apps Style
        06. Profile App Style
        07. Wall App Style

    F. Pages
        01. Callout Styles
        02. E-commerce Styles
        03. Pricing Tables Styles
        04. Login Styles
        05. Dashboard Styles
        06. Error Styles
        07. Editor Styles
        08. Testimonial Styles
        09. Algolia Styles

  =============================================================*/
/* stylelint-disable at-rule-no-unknown */
html,
body {
  width: 100%;
  height: 100%;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@-ms-viewport {
  width: device-width;
}
article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}
body {
  margin: 0;
  color: #545454;
  font-size: 14px;
  font-family: "DM Sans", sans-serif;
  font-variant: tabular-nums;
  line-height: 1.3;
  background-color: #f5f5f5;
  font-feature-settings: 'tnum';
}
[tabindex='-1']:focus {
  outline: none !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 500;
}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}
address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}
input[type='text'],
input[type='password'],
input[type='number'],
textarea {
  -webkit-appearance: none;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1em;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 500;
}
dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1em;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #2EB1EF;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: #58cefc;
}
a:active {
  color: #1c8dc9;
}
a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}
pre,
code,
kbd,
samp {
  font-size: 1em;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}
figure {
  margin: 0 0 1em;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
a,
area,
button,
[role='button'],
input:not([type='range']),
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: #595959;
  text-align: left;
  caption-side: bottom;
}
th {
  text-align: inherit;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type='radio'],
input[type='checkbox'] {
  box-sizing: border-box;
  padding: 0;
}
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
mark {
  padding: 0.2em;
  background-color: #feffe6;
}
::selection {
  color: #fff;
  background: #2EB1EF;
}
.clearfix {
  zoom: 1;
}
.clearfix::before,
.clearfix::after {
  display: table;
  content: '';
}
.clearfix::after {
  clear: both;
}
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.anticon > * {
  line-height: 1;
}
.anticon svg {
  display: inline-block;
}
.anticon::before {
  display: none;
}
.anticon .anticon-icon {
  display: block;
}
.anticon[tabindex] {
  cursor: pointer;
}
.anticon-spin::before {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.anticon-spin {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.fade-enter,
.fade-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.fade-enter.fade-enter-active,
.fade-appear.fade-appear-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}
.fade-leave.fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}
.fade-enter,
.fade-appear {
  opacity: 0;
  animation-timing-function: linear;
}
.fade-leave {
  animation-timing-function: linear;
}
@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.move-up-enter,
.move-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-up-enter.move-up-enter-active,
.move-up-appear.move-up-appear-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}
.move-up-leave.move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-up-enter,
.move-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-down-enter,
.move-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-down-enter.move-down-enter-active,
.move-down-appear.move-down-appear-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}
.move-down-leave.move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-down-enter,
.move-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-left-enter,
.move-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-left-enter.move-left-enter-active,
.move-left-appear.move-left-appear-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}
.move-left-leave.move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-left-enter,
.move-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-right-enter,
.move-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-right-enter.move-right-enter-active,
.move-right-appear.move-right-appear-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}
.move-right-leave.move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-right-enter,
.move-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
@keyframes antMoveDownIn {
  0% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveRightOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes loadingCircle {
  100% {
    transform: rotate(360deg);
  }
}
[ant-click-animating='true'],
[ant-click-animating-without-extra-node='true'] {
  position: relative;
}
html {
  --antd-wave-shadow-color: #2EB1EF;
}
[ant-click-animating-without-extra-node='true']::after,
.ant-click-animating-node {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  border-radius: inherit;
  box-shadow: 0 0 0 0 #2EB1EF;
  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);
  opacity: 0.2;
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-fill-mode: forwards;
  content: '';
  pointer-events: none;
}
@keyframes waveEffect {
  100% {
    box-shadow: 0 0 0 #2EB1EF;
    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);
  }
}
@keyframes fadeEffect {
  100% {
    opacity: 0;
  }
}
.slide-up-enter,
.slide-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-up-enter.slide-up-enter-active,
.slide-up-appear.slide-up-appear-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}
.slide-up-leave.slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-up-enter,
.slide-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-down-enter,
.slide-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-down-enter.slide-down-enter-active,
.slide-down-appear.slide-down-appear-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}
.slide-down-leave.slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-down-enter,
.slide-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-left-enter,
.slide-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-left-enter.slide-left-enter-active,
.slide-left-appear.slide-left-appear-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}
.slide-left-leave.slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-left-enter,
.slide-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-right-enter,
.slide-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-right-enter.slide-right-enter-active,
.slide-right-appear.slide-right-appear-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}
.slide-right-leave.slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-right-enter,
.slide-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
@keyframes antSlideUpIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideDownIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes antSlideDownOut {
  0% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
}
@keyframes antSlideLeftIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideLeftOut {
  0% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideRightIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
}
@keyframes antSlideRightOut {
  0% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
}
.swing-enter,
.swing-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.swing-enter.swing-enter-active,
.swing-appear.swing-appear-active {
  animation-name: antSwingIn;
  animation-play-state: running;
}
@keyframes antSwingIn {
  0%,
  100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(10px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
}
.zoom-enter,
.zoom-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-enter.zoom-enter-active,
.zoom-appear.zoom-appear-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}
.zoom-leave.zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-enter,
.zoom-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-big-enter,
.zoom-big-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-enter.zoom-big-enter-active,
.zoom-big-appear.zoom-big-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.zoom-big-leave.zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-big-enter,
.zoom-big-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-big-fast-enter,
.zoom-big-fast-appear {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-fast-enter.zoom-big-fast-enter-active,
.zoom-big-fast-appear.zoom-big-fast-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.zoom-big-fast-leave.zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-big-fast-enter,
.zoom-big-fast-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-up-enter,
.zoom-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-up-enter.zoom-up-enter-active,
.zoom-up-appear.zoom-up-appear-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}
.zoom-up-leave.zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-up-enter,
.zoom-up-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-down-enter,
.zoom-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-down-enter.zoom-down-enter-active,
.zoom-down-appear.zoom-down-appear-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}
.zoom-down-leave.zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-down-enter,
.zoom-down-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-left-enter,
.zoom-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-left-enter.zoom-left-enter-active,
.zoom-left-appear.zoom-left-appear-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}
.zoom-left-leave.zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-left-enter,
.zoom-left-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-right-enter,
.zoom-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-right-enter.zoom-right-enter-active,
.zoom-right-appear.zoom-right-appear-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}
.zoom-right-leave.zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-right-enter,
.zoom-right-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
@keyframes antZoomIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
    opacity: 0;
  }
}
@keyframes antZoomBigIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes antZoomUpIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
}
@keyframes antZoomUpOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
}
@keyframes antZoomLeftIn {
  0% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
}
@keyframes antZoomRightIn {
  0% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
}
@keyframes antZoomRightOut {
  0% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
}
@keyframes antZoomDownIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@keyframes antZoomDownOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
}
.ant-motion-collapse-legacy {
  overflow: hidden;
}
.ant-motion-collapse-legacy-active {
  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-motion-collapse {
  overflow: hidden;
  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-affix {
  position: fixed;
  z-index: 10;
}
.ant-alert {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding: 8px 15px 8px 37px;
  word-wrap: break-word;
  border-radius: 6px;
}
.ant-alert.ant-alert-no-icon {
  padding: 8px 15px;
}
.ant-alert.ant-alert-closable {
  padding-right: 30px;
}
.ant-alert-icon {
  position: absolute;
  top: 10.1px;
  left: 16px;
}
.ant-alert-description {
  display: none;
  font-size: 14px;
  line-height: 22px;
}
.ant-alert-success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}
.ant-alert-success .ant-alert-icon {
  color: #52c41a;
}
.ant-alert-info {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}
.ant-alert-info .ant-alert-icon {
  color: #1890ff;
}
.ant-alert-warning {
  background-color: #fff7e6;
  border: 1px solid #ffd591;
}
.ant-alert-warning .ant-alert-icon {
  color: #fa8c16;
}
.ant-alert-error {
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
}
.ant-alert-error .ant-alert-icon {
  color: #f5222d;
}
.ant-alert-close-icon {
  position: absolute;
  top: 8px;
  right: 16px;
  padding: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 22px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.ant-alert-close-icon .anticon-close {
  color: #595959;
  transition: color 0.3s;
}
.ant-alert-close-icon .anticon-close:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-close-text {
  color: #595959;
  transition: color 0.3s;
}
.ant-alert-close-text:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-with-description {
  position: relative;
  padding: 15px 15px 15px 64px;
  color: #545454;
  line-height: 1.3;
  border-radius: 6px;
}
.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px;
}
.ant-alert-with-description .ant-alert-icon {
  position: absolute;
  top: 16px;
  left: 24px;
  font-size: 24px;
}
.ant-alert-with-description .ant-alert-close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 14px;
  cursor: pointer;
}
.ant-alert-with-description .ant-alert-message {
  display: block;
  margin-bottom: 4px;
  color: #535353;
  font-size: 16px;
}
.ant-alert-message {
  color: #535353;
}
.ant-alert-with-description .ant-alert-description {
  display: block;
}
.ant-alert.ant-alert-closing {
  height: 0 !important;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  transform-origin: 50% 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-alert-slide-up-leave {
  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: both;
}
.ant-alert-banner {
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
}
@keyframes antAlertSlideUpIn {
  0% {
    transform: scaleY(0);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antAlertSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
.ant-anchor {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding-left: 2px;
}
.ant-anchor-wrapper {
  margin-left: -4px;
  padding-left: 4px;
  overflow: auto;
  background-color: #fff;
}
.ant-anchor-ink {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.ant-anchor-ink::before {
  position: relative;
  display: block;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: #e8e8e8;
  content: ' ';
}
.ant-anchor-ink-ball {
  position: absolute;
  left: 50%;
  display: none;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 2px solid #2EB1EF;
  border-radius: 8px;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out;
}
.ant-anchor-ink-ball.visible {
  display: inline-block;
}
.ant-anchor.fixed .ant-anchor-ink .ant-anchor-ink-ball {
  display: none;
}
.ant-anchor-link {
  padding: 7px 0 7px 16px;
  line-height: 1.143;
}
.ant-anchor-link-title {
  position: relative;
  display: block;
  margin-bottom: 6px;
  overflow: hidden;
  color: #545454;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-anchor-link-title:only-child {
  margin-bottom: 0;
}
.ant-anchor-link-active > .ant-anchor-link-title {
  color: #2EB1EF;
}
.ant-anchor-link .ant-anchor-link {
  padding-top: 5px;
  padding-bottom: 5px;
}
.ant-select-auto-complete {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-select-auto-complete.ant-select .ant-select-selection {
  border: 0;
  box-shadow: none;
}
.ant-select-auto-complete.ant-select .ant-select-selection__rendered {
  height: 100%;
  margin-right: 0;
  margin-left: 0;
  line-height: 36px;
}
.ant-select-auto-complete.ant-select .ant-select-selection__placeholder {
  margin-right: 12px;
  margin-left: 12px;
}
.ant-select-auto-complete.ant-select .ant-select-selection--single {
  height: auto;
}
.ant-select-auto-complete.ant-select .ant-select-search--inline {
  position: static;
  float: left;
}
.ant-select-auto-complete.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {
  margin-right: 0 !important;
}
.ant-select-auto-complete.ant-select .ant-input {
  height: 36px;
  line-height: 1.3;
  background: transparent;
  border-width: 1px;
}
.ant-select-auto-complete.ant-select .ant-input:focus,
.ant-select-auto-complete.ant-select .ant-input:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-select-auto-complete.ant-select .ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
  background-color: transparent;
}
.ant-select-auto-complete.ant-select .ant-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-select-auto-complete.ant-select-lg .ant-select-selection__rendered {
  line-height: 40px;
}
.ant-select-auto-complete.ant-select-lg .ant-input {
  height: 40px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.ant-select-auto-complete.ant-select-sm .ant-select-selection__rendered {
  line-height: 24px;
}
.ant-select-auto-complete.ant-select-sm .ant-input {
  height: 24px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.ant-input-group > .ant-select-auto-complete .ant-select-search__field.ant-input-affix-wrapper {
  display: inline;
  float: none;
}
.ant-avatar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background: #ccc;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}
.ant-avatar-image {
  background: transparent;
}
.ant-avatar-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar.ant-avatar-icon {
  font-size: 18px;
}
.ant-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
}
.ant-avatar-lg-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar-lg.ant-avatar-icon {
  font-size: 24px;
}
.ant-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
}
.ant-avatar-sm-string {
  position: absolute;
  left: 50%;
  transform-origin: 0 center;
}
.ant-avatar-sm.ant-avatar-icon {
  font-size: 14px;
}
.ant-avatar-square {
  border-radius: 6px;
}
.ant-avatar > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ant-back-top {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  right: 100px;
  bottom: 50px;
  z-index: 10;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.ant-back-top-content {
  width: 40px;
  height: 40px;
  overflow: hidden;
  color: #fff;
  text-align: center;
  background-color: #595959;
  border-radius: 20px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-back-top-content:hover {
  background-color: #545454;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-back-top-icon {
  width: 14px;
  height: 16px;
  margin: 12px auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 100%/100% no-repeat;
}
@media screen and (max-width: 768px) {
  .ant-back-top {
    right: 60px;
  }
}
@media screen and (max-width: 480px) {
  .ant-back-top {
    right: 20px;
  }
}
.ant-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  color: unset;
  line-height: 1;
}
.ant-badge-count {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #f5222d;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-count a,
.ant-badge-count a:hover {
  color: #fff;
}
.ant-badge-multiple-words {
  padding: 0 8px;
}
.ant-badge-dot {
  width: 6px;
  height: 6px;
  background: #f5222d;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-count,
.ant-badge-dot,
.ant-badge .ant-scroll-number-custom-component {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  transform: translate(50%, -50%);
  transform-origin: 100% 0%;
}
.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.ant-badge-status-dot {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}
.ant-badge-status-success {
  background-color: #52c41a;
}
.ant-badge-status-processing {
  position: relative;
  background-color: #2EB1EF;
}
.ant-badge-status-processing::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #2EB1EF;
  border-radius: 50%;
  animation: antStatusProcessing 1.2s infinite ease-in-out;
  content: '';
}
.ant-badge-status-default {
  background-color: #d9d9d9;
}
.ant-badge-status-error {
  background-color: #f5222d;
}
.ant-badge-status-warning {
  background-color: #fa8c16;
}
.ant-badge-status-pink {
  background: #eb2f96;
}
.ant-badge-status-magenta {
  background: #eb2f96;
}
.ant-badge-status-red {
  background: #f5222d;
}
.ant-badge-status-volcano {
  background: #fa541c;
}
.ant-badge-status-orange {
  background: #fa8c16;
}
.ant-badge-status-yellow {
  background: #fadb14;
}
.ant-badge-status-gold {
  background: #faad14;
}
.ant-badge-status-cyan {
  background: #13c2c2;
}
.ant-badge-status-lime {
  background: #a0d911;
}
.ant-badge-status-green {
  background: #52c41a;
}
.ant-badge-status-blue {
  background: #1890ff;
}
.ant-badge-status-geekblue {
  background: #2f54eb;
}
.ant-badge-status-purple {
  background: #722ed1;
}
.ant-badge-status-text {
  margin-left: 8px;
  color: #545454;
  font-size: 14px;
}
.ant-badge-zoom-appear,
.ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}
.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}
.ant-badge-not-a-wrapper:not(.ant-badge-status) {
  vertical-align: middle;
}
.ant-badge-not-a-wrapper .ant-scroll-number {
  position: relative;
  top: auto;
  display: block;
}
.ant-badge-not-a-wrapper .ant-badge-count {
  transform: none;
}
@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
}
.ant-scroll-number-only {
  display: inline-block;
  height: 20px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-scroll-number-only > p.ant-scroll-number-only-unit {
  height: 20px;
  margin: 0;
}
.ant-scroll-number-symbol {
  vertical-align: top;
}
@keyframes antZoomBadgeIn {
  0% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
  100% {
    transform: scale(1) translate(50%, -50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translate(50%, -50%);
  }
  100% {
    transform: scale(0) translate(50%, -50%);
    opacity: 0;
  }
}
.ant-breadcrumb {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  color: #595959;
  font-size: 14px;
}
.ant-breadcrumb .anticon {
  font-size: 14px;
}
.ant-breadcrumb a {
  color: #595959;
  transition: color 0.3s;
}
.ant-breadcrumb a:hover {
  color: #58cefc;
}
.ant-breadcrumb > span:last-child {
  color: #545454;
}
.ant-breadcrumb > span:last-child a {
  color: #545454;
}
.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {
  display: none;
}
.ant-breadcrumb-separator {
  margin: 0 8px;
  color: #595959;
}
.ant-breadcrumb-link > .anticon + span {
  margin-left: 4px;
}
.ant-breadcrumb-overlay-link > .anticon {
  margin-left: 4px;
}
.ant-btn {
  line-height: 1.299;
  position: relative;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: solid 1px #d9d9d9;
  padding: 0 15px;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 15px;
  color: #545454;
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-btn > .anticon {
  line-height: 1;
}
.ant-btn,
.ant-btn:active,
.ant-btn:focus {
  outline: 0;
}
.ant-btn:not([disabled]):hover {
  text-decoration: none;
}
.ant-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}
.ant-btn.disabled,
.ant-btn[disabled] {
  cursor: not-allowed;
}
.ant-btn.disabled > *,
.ant-btn[disabled] > * {
  pointer-events: none;
}
.ant-btn-lg {
  height: 40px;
  padding: 0 15px;
  font-size: 16px;
  border-radius: 4px;
}
.ant-btn-sm {
  height: 24px;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
}
.ant-btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn:not(:last-child) {
    margin-right: 10px;
  }
}
@media screen and (max-width: 575px) {
  .ant-btn {
    margin-bottom: 10px;
  }
}
.ant-btn:focus,
.ant-btn:hover {
  text-decoration: none;
}
.ant-btn:focus,
.ant-btn.focus {
  outline: 0;
}
.ant-btn.disabled,
.ant-btn:disabled {
  opacity: 0.65;
}
.ant-btn:not([disabled]):not(.disabled) {
  cursor: pointer;
}
.gx-btn-list .ant-btn {
  margin-bottom: 6px;
}
.gx-sub-popover .ant-btn {
  border: 0 none;
  margin-bottom: 5px;
}
.gx-sub-popover .ant-btn:focus,
.gx-sub-popover .ant-btn:hover {
  background-color: #f5f5f5;
}
.gx-sub-popover .ant-btn:not(:last-child) {
  margin-right: 5px;
}
.gx-login-content .ant-btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.ant-btn > a:only-child {
  color: currentColor;
}
.ant-btn > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus {
  color: #58cefc;
  background-color: #fff;
  border-color: #58cefc;
}
.ant-btn:hover > a:only-child,
.ant-btn:focus > a:only-child {
  color: currentColor;
}
.ant-btn:hover > a:only-child::after,
.ant-btn:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:active,
.ant-btn.active {
  color: #1c8dc9;
  background-color: #fff;
  border-color: #1c8dc9;
}
.ant-btn:active > a:only-child,
.ant-btn.active > a:only-child {
  color: currentColor;
}
.ant-btn:active > a:only-child::after,
.ant-btn.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-disabled,
.ant-btn.disabled,
.ant-btn[disabled],
.ant-btn-disabled:hover,
.ant-btn.disabled:hover,
.ant-btn[disabled]:hover,
.ant-btn-disabled:focus,
.ant-btn.disabled:focus,
.ant-btn[disabled]:focus,
.ant-btn-disabled:active,
.ant-btn.disabled:active,
.ant-btn[disabled]:active,
.ant-btn-disabled.active,
.ant-btn.disabled.active,
.ant-btn[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-disabled > a:only-child,
.ant-btn.disabled > a:only-child,
.ant-btn[disabled] > a:only-child,
.ant-btn-disabled:hover > a:only-child,
.ant-btn.disabled:hover > a:only-child,
.ant-btn[disabled]:hover > a:only-child,
.ant-btn-disabled:focus > a:only-child,
.ant-btn.disabled:focus > a:only-child,
.ant-btn[disabled]:focus > a:only-child,
.ant-btn-disabled:active > a:only-child,
.ant-btn.disabled:active > a:only-child,
.ant-btn[disabled]:active > a:only-child,
.ant-btn-disabled.active > a:only-child,
.ant-btn.disabled.active > a:only-child,
.ant-btn[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-disabled > a:only-child::after,
.ant-btn.disabled > a:only-child::after,
.ant-btn[disabled] > a:only-child::after,
.ant-btn-disabled:hover > a:only-child::after,
.ant-btn.disabled:hover > a:only-child::after,
.ant-btn[disabled]:hover > a:only-child::after,
.ant-btn-disabled:focus > a:only-child::after,
.ant-btn.disabled:focus > a:only-child::after,
.ant-btn[disabled]:focus > a:only-child::after,
.ant-btn-disabled:active > a:only-child::after,
.ant-btn.disabled:active > a:only-child::after,
.ant-btn[disabled]:active > a:only-child::after,
.ant-btn-disabled.active > a:only-child::after,
.ant-btn.disabled.active > a:only-child::after,
.ant-btn[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus,
.ant-btn:active,
.ant-btn.active {
  text-decoration: none;
  background: #fff;
}
.ant-btn > i,
.ant-btn > span {
  display: inline-block;
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  pointer-events: none;
}
.ant-btn-primary {
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  color: #ffffff;
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-btn-primary > a:only-child {
  color: currentColor;
}
.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #fff;
  background-color: #58cefc;
  border-color: #58cefc;
}
.ant-btn-primary:hover > a:only-child,
.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.ant-btn-primary:hover > a:only-child::after,
.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:active,
.ant-btn-primary.active {
  color: #fff;
  background-color: #1c8dc9;
  border-color: #1c8dc9;
}
.ant-btn-primary:active > a:only-child,
.ant-btn-primary.active > a:only-child {
  color: currentColor;
}
.ant-btn-primary:active > a:only-child::after,
.ant-btn-primary.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary-disabled,
.ant-btn-primary.disabled,
.ant-btn-primary[disabled],
.ant-btn-primary-disabled:hover,
.ant-btn-primary.disabled:hover,
.ant-btn-primary[disabled]:hover,
.ant-btn-primary-disabled:focus,
.ant-btn-primary.disabled:focus,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary-disabled:active,
.ant-btn-primary.disabled:active,
.ant-btn-primary[disabled]:active,
.ant-btn-primary-disabled.active,
.ant-btn-primary.disabled.active,
.ant-btn-primary[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-primary-disabled > a:only-child,
.ant-btn-primary.disabled > a:only-child,
.ant-btn-primary[disabled] > a:only-child,
.ant-btn-primary-disabled:hover > a:only-child,
.ant-btn-primary.disabled:hover > a:only-child,
.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-primary-disabled:focus > a:only-child,
.ant-btn-primary.disabled:focus > a:only-child,
.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-primary-disabled:active > a:only-child,
.ant-btn-primary.disabled:active > a:only-child,
.ant-btn-primary[disabled]:active > a:only-child,
.ant-btn-primary-disabled.active > a:only-child,
.ant-btn-primary.disabled.active > a:only-child,
.ant-btn-primary[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-primary-disabled > a:only-child::after,
.ant-btn-primary.disabled > a:only-child::after,
.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-primary-disabled:hover > a:only-child::after,
.ant-btn-primary.disabled:hover > a:only-child::after,
.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-primary-disabled:focus > a:only-child::after,
.ant-btn-primary.disabled:focus > a:only-child::after,
.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-primary-disabled:active > a:only-child::after,
.ant-btn-primary.disabled:active > a:only-child::after,
.ant-btn-primary[disabled]:active > a:only-child::after,
.ant-btn-primary-disabled.active > a:only-child::after,
.ant-btn-primary.disabled.active > a:only-child::after,
.ant-btn-primary[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.ant-btn-primary.disabled,
.ant-btn-primary:disabled {
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.ant-btn-primary:not([disabled]):not(.disabled):active,
.ant-btn-primary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #58cefc;
  border-left-color: #58cefc;
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #d9d9d9;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #58cefc;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #d9d9d9;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child),
.ant-btn-group .ant-btn-primary + .ant-btn-primary {
  border-left-color: #58cefc;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],
.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {
  border-left-color: #d9d9d9;
}
.ant-btn-ghost {
  color: #545454;
  background-color: transparent;
  border-color: #d9d9d9;
}
.ant-btn-ghost > a:only-child {
  color: currentColor;
}
.ant-btn-ghost > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:hover,
.ant-btn-ghost:focus {
  color: #58cefc;
  background-color: transparent;
  border-color: #58cefc;
}
.ant-btn-ghost:hover > a:only-child,
.ant-btn-ghost:focus > a:only-child {
  color: currentColor;
}
.ant-btn-ghost:hover > a:only-child::after,
.ant-btn-ghost:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:active,
.ant-btn-ghost.active {
  color: #1c8dc9;
  background-color: transparent;
  border-color: #1c8dc9;
}
.ant-btn-ghost:active > a:only-child,
.ant-btn-ghost.active > a:only-child {
  color: currentColor;
}
.ant-btn-ghost:active > a:only-child::after,
.ant-btn-ghost.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost-disabled,
.ant-btn-ghost.disabled,
.ant-btn-ghost[disabled],
.ant-btn-ghost-disabled:hover,
.ant-btn-ghost.disabled:hover,
.ant-btn-ghost[disabled]:hover,
.ant-btn-ghost-disabled:focus,
.ant-btn-ghost.disabled:focus,
.ant-btn-ghost[disabled]:focus,
.ant-btn-ghost-disabled:active,
.ant-btn-ghost.disabled:active,
.ant-btn-ghost[disabled]:active,
.ant-btn-ghost-disabled.active,
.ant-btn-ghost.disabled.active,
.ant-btn-ghost[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-ghost-disabled > a:only-child,
.ant-btn-ghost.disabled > a:only-child,
.ant-btn-ghost[disabled] > a:only-child,
.ant-btn-ghost-disabled:hover > a:only-child,
.ant-btn-ghost.disabled:hover > a:only-child,
.ant-btn-ghost[disabled]:hover > a:only-child,
.ant-btn-ghost-disabled:focus > a:only-child,
.ant-btn-ghost.disabled:focus > a:only-child,
.ant-btn-ghost[disabled]:focus > a:only-child,
.ant-btn-ghost-disabled:active > a:only-child,
.ant-btn-ghost.disabled:active > a:only-child,
.ant-btn-ghost[disabled]:active > a:only-child,
.ant-btn-ghost-disabled.active > a:only-child,
.ant-btn-ghost.disabled.active > a:only-child,
.ant-btn-ghost[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-ghost-disabled > a:only-child::after,
.ant-btn-ghost.disabled > a:only-child::after,
.ant-btn-ghost[disabled] > a:only-child::after,
.ant-btn-ghost-disabled:hover > a:only-child::after,
.ant-btn-ghost.disabled:hover > a:only-child::after,
.ant-btn-ghost[disabled]:hover > a:only-child::after,
.ant-btn-ghost-disabled:focus > a:only-child::after,
.ant-btn-ghost.disabled:focus > a:only-child::after,
.ant-btn-ghost[disabled]:focus > a:only-child::after,
.ant-btn-ghost-disabled:active > a:only-child::after,
.ant-btn-ghost.disabled:active > a:only-child::after,
.ant-btn-ghost[disabled]:active > a:only-child::after,
.ant-btn-ghost-disabled.active > a:only-child::after,
.ant-btn-ghost.disabled.active > a:only-child::after,
.ant-btn-ghost[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed {
  color: #545454;
  background-color: #fff;
  border-color: #d9d9d9;
  border-style: dashed;
}
.ant-btn-dashed > a:only-child {
  color: currentColor;
}
.ant-btn-dashed > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:hover,
.ant-btn-dashed:focus {
  color: #58cefc;
  background-color: #fff;
  border-color: #58cefc;
}
.ant-btn-dashed:hover > a:only-child,
.ant-btn-dashed:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dashed:hover > a:only-child::after,
.ant-btn-dashed:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:active,
.ant-btn-dashed.active {
  color: #1c8dc9;
  background-color: #fff;
  border-color: #1c8dc9;
}
.ant-btn-dashed:active > a:only-child,
.ant-btn-dashed.active > a:only-child {
  color: currentColor;
}
.ant-btn-dashed:active > a:only-child::after,
.ant-btn-dashed.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed-disabled,
.ant-btn-dashed.disabled,
.ant-btn-dashed[disabled],
.ant-btn-dashed-disabled:hover,
.ant-btn-dashed.disabled:hover,
.ant-btn-dashed[disabled]:hover,
.ant-btn-dashed-disabled:focus,
.ant-btn-dashed.disabled:focus,
.ant-btn-dashed[disabled]:focus,
.ant-btn-dashed-disabled:active,
.ant-btn-dashed.disabled:active,
.ant-btn-dashed[disabled]:active,
.ant-btn-dashed-disabled.active,
.ant-btn-dashed.disabled.active,
.ant-btn-dashed[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dashed-disabled > a:only-child,
.ant-btn-dashed.disabled > a:only-child,
.ant-btn-dashed[disabled] > a:only-child,
.ant-btn-dashed-disabled:hover > a:only-child,
.ant-btn-dashed.disabled:hover > a:only-child,
.ant-btn-dashed[disabled]:hover > a:only-child,
.ant-btn-dashed-disabled:focus > a:only-child,
.ant-btn-dashed.disabled:focus > a:only-child,
.ant-btn-dashed[disabled]:focus > a:only-child,
.ant-btn-dashed-disabled:active > a:only-child,
.ant-btn-dashed.disabled:active > a:only-child,
.ant-btn-dashed[disabled]:active > a:only-child,
.ant-btn-dashed-disabled.active > a:only-child,
.ant-btn-dashed.disabled.active > a:only-child,
.ant-btn-dashed[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-dashed-disabled > a:only-child::after,
.ant-btn-dashed.disabled > a:only-child::after,
.ant-btn-dashed[disabled] > a:only-child::after,
.ant-btn-dashed-disabled:hover > a:only-child::after,
.ant-btn-dashed.disabled:hover > a:only-child::after,
.ant-btn-dashed[disabled]:hover > a:only-child::after,
.ant-btn-dashed-disabled:focus > a:only-child::after,
.ant-btn-dashed.disabled:focus > a:only-child::after,
.ant-btn-dashed[disabled]:focus > a:only-child::after,
.ant-btn-dashed-disabled:active > a:only-child::after,
.ant-btn-dashed.disabled:active > a:only-child::after,
.ant-btn-dashed[disabled]:active > a:only-child::after,
.ant-btn-dashed-disabled.active > a:only-child::after,
.ant-btn-dashed.disabled.active > a:only-child::after,
.ant-btn-dashed[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-danger > a:only-child {
  color: currentColor;
}
.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:hover,
.ant-btn-danger:focus {
  color: #fff;
  background-color: #ff7875;
  border-color: #ff7875;
}
.ant-btn-danger:hover > a:only-child,
.ant-btn-danger:focus > a:only-child {
  color: currentColor;
}
.ant-btn-danger:hover > a:only-child::after,
.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:active,
.ant-btn-danger.active {
  color: #fff;
  background-color: #d9363e;
  border-color: #d9363e;
}
.ant-btn-danger:active > a:only-child,
.ant-btn-danger.active > a:only-child {
  color: currentColor;
}
.ant-btn-danger:active > a:only-child::after,
.ant-btn-danger.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger-disabled,
.ant-btn-danger.disabled,
.ant-btn-danger[disabled],
.ant-btn-danger-disabled:hover,
.ant-btn-danger.disabled:hover,
.ant-btn-danger[disabled]:hover,
.ant-btn-danger-disabled:focus,
.ant-btn-danger.disabled:focus,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger-disabled:active,
.ant-btn-danger.disabled:active,
.ant-btn-danger[disabled]:active,
.ant-btn-danger-disabled.active,
.ant-btn-danger.disabled.active,
.ant-btn-danger[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-danger-disabled > a:only-child,
.ant-btn-danger.disabled > a:only-child,
.ant-btn-danger[disabled] > a:only-child,
.ant-btn-danger-disabled:hover > a:only-child,
.ant-btn-danger.disabled:hover > a:only-child,
.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-danger-disabled:focus > a:only-child,
.ant-btn-danger.disabled:focus > a:only-child,
.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-danger-disabled:active > a:only-child,
.ant-btn-danger.disabled:active > a:only-child,
.ant-btn-danger[disabled]:active > a:only-child,
.ant-btn-danger-disabled.active > a:only-child,
.ant-btn-danger.disabled.active > a:only-child,
.ant-btn-danger[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-danger-disabled > a:only-child::after,
.ant-btn-danger.disabled > a:only-child::after,
.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-danger-disabled:hover > a:only-child::after,
.ant-btn-danger.disabled:hover > a:only-child::after,
.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-danger-disabled:focus > a:only-child::after,
.ant-btn-danger.disabled:focus > a:only-child::after,
.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-danger-disabled:active > a:only-child::after,
.ant-btn-danger.disabled:active > a:only-child::after,
.ant-btn-danger[disabled]:active > a:only-child::after,
.ant-btn-danger-disabled.active > a:only-child::after,
.ant-btn-danger.disabled.active > a:only-child::after,
.ant-btn-danger[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link {
  color: #2EB1EF;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}
.ant-btn-link > a:only-child {
  color: currentColor;
}
.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover,
.ant-btn-link:focus {
  color: #58cefc;
  background-color: transparent;
  border-color: #58cefc;
}
.ant-btn-link:hover > a:only-child,
.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-link:hover > a:only-child::after,
.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:active,
.ant-btn-link.active {
  color: #1c8dc9;
  background-color: transparent;
  border-color: #1c8dc9;
}
.ant-btn-link:active > a:only-child,
.ant-btn-link.active > a:only-child {
  color: currentColor;
}
.ant-btn-link:active > a:only-child::after,
.ant-btn-link.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link-disabled,
.ant-btn-link.disabled,
.ant-btn-link[disabled],
.ant-btn-link-disabled:hover,
.ant-btn-link.disabled:hover,
.ant-btn-link[disabled]:hover,
.ant-btn-link-disabled:focus,
.ant-btn-link.disabled:focus,
.ant-btn-link[disabled]:focus,
.ant-btn-link-disabled:active,
.ant-btn-link.disabled:active,
.ant-btn-link[disabled]:active,
.ant-btn-link-disabled.active,
.ant-btn-link.disabled.active,
.ant-btn-link[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link-disabled > a:only-child,
.ant-btn-link.disabled > a:only-child,
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link-disabled:hover > a:only-child,
.ant-btn-link.disabled:hover > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link-disabled:focus > a:only-child,
.ant-btn-link.disabled:focus > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link-disabled:active > a:only-child,
.ant-btn-link.disabled:active > a:only-child,
.ant-btn-link[disabled]:active > a:only-child,
.ant-btn-link-disabled.active > a:only-child,
.ant-btn-link.disabled.active > a:only-child,
.ant-btn-link[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-link-disabled > a:only-child::after,
.ant-btn-link.disabled > a:only-child::after,
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link-disabled:hover > a:only-child::after,
.ant-btn-link.disabled:hover > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link-disabled:focus > a:only-child::after,
.ant-btn-link.disabled:focus > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link-disabled:active > a:only-child::after,
.ant-btn-link.disabled:active > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after,
.ant-btn-link-disabled.active > a:only-child::after,
.ant-btn-link.disabled.active > a:only-child::after,
.ant-btn-link[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover,
.ant-btn-link:focus,
.ant-btn-link:active {
  border-color: transparent;
}
.ant-btn-link-disabled,
.ant-btn-link.disabled,
.ant-btn-link[disabled],
.ant-btn-link-disabled:hover,
.ant-btn-link.disabled:hover,
.ant-btn-link[disabled]:hover,
.ant-btn-link-disabled:focus,
.ant-btn-link.disabled:focus,
.ant-btn-link[disabled]:focus,
.ant-btn-link-disabled:active,
.ant-btn-link.disabled:active,
.ant-btn-link[disabled]:active,
.ant-btn-link-disabled.active,
.ant-btn-link.disabled.active,
.ant-btn-link[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: transparent;
  border-color: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link-disabled > a:only-child,
.ant-btn-link.disabled > a:only-child,
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link-disabled:hover > a:only-child,
.ant-btn-link.disabled:hover > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link-disabled:focus > a:only-child,
.ant-btn-link.disabled:focus > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link-disabled:active > a:only-child,
.ant-btn-link.disabled:active > a:only-child,
.ant-btn-link[disabled]:active > a:only-child,
.ant-btn-link-disabled.active > a:only-child,
.ant-btn-link.disabled.active > a:only-child,
.ant-btn-link[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-link-disabled > a:only-child::after,
.ant-btn-link.disabled > a:only-child::after,
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link-disabled:hover > a:only-child::after,
.ant-btn-link.disabled:hover > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link-disabled:focus > a:only-child::after,
.ant-btn-link.disabled:focus > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link-disabled:active > a:only-child::after,
.ant-btn-link.disabled:active > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after,
.ant-btn-link-disabled.active > a:only-child::after,
.ant-btn-link.disabled.active > a:only-child::after,
.ant-btn-link[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-icon-only {
  width: 36px;
  height: 36px;
  padding: 0;
  font-size: 16px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-lg {
  width: 40px;
  height: 40px;
  padding: 0;
  font-size: 18px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-sm {
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  border-radius: 4px;
}
.ant-btn-icon-only > i {
  vertical-align: middle;
}
.ant-btn-round {
  height: 36px;
  padding: 0 18px;
  font-size: 14px;
  border-radius: 36px;
}
.ant-btn-round.ant-btn-lg {
  height: 40px;
  padding: 0 20px;
  font-size: 16px;
  border-radius: 40px;
}
.ant-btn-round.ant-btn-sm {
  height: 24px;
  padding: 0 12px;
  font-size: 14px;
  border-radius: 24px;
}
.ant-btn-round.ant-btn-icon-only {
  width: auto;
}
.ant-btn-circle,
.ant-btn-circle-outline {
  min-width: 36px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-lg,
.ant-btn-circle-outline.ant-btn-lg {
  min-width: 40px;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-sm,
.ant-btn-circle-outline.ant-btn-sm {
  min-width: 24px;
  border-radius: 50%;
}
.ant-btn::before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
  display: none;
  background: #fff;
  border-radius: inherit;
  opacity: 0.35;
  transition: opacity 0.2s;
  content: '';
  pointer-events: none;
}
.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-btn .anticon.anticon-plus > svg,
.ant-btn .anticon.anticon-minus > svg {
  shape-rendering: optimizeSpeed;
}
.ant-btn.ant-btn-loading {
  position: relative;
}
.ant-btn.ant-btn-loading:not([disabled]) {
  pointer-events: none;
}
.ant-btn.ant-btn-loading::before {
  display: block;
}
.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {
  padding-left: 29px;
}
.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon:not(:last-child) {
  margin-left: -14px;
}
.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {
  padding-left: 24px;
}
.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon {
  margin-left: -17px;
}
.ant-btn-group {
  position: relative;
  display: inline-block;
}
.ant-btn-group > .ant-btn,
.ant-btn-group > span > .ant-btn {
  position: relative;
}
.ant-btn-group > .ant-btn:hover,
.ant-btn-group > span > .ant-btn:hover,
.ant-btn-group > .ant-btn:focus,
.ant-btn-group > span > .ant-btn:focus,
.ant-btn-group > .ant-btn:active,
.ant-btn-group > span > .ant-btn:active,
.ant-btn-group > .ant-btn.active,
.ant-btn-group > span > .ant-btn.active {
  z-index: 2;
}
.ant-btn-group > .ant-btn:disabled,
.ant-btn-group > span > .ant-btn:disabled {
  z-index: 0;
}
.ant-btn-group > .ant-btn-icon-only {
  font-size: 14px;
}
.ant-btn-group-lg > .ant-btn,
.ant-btn-group-lg > span > .ant-btn {
  height: 40px;
  padding: 0 15px;
  font-size: 16px;
  border-radius: 0;
  line-height: 38px;
}
.ant-btn-group-lg > .ant-btn.ant-btn-icon-only {
  width: 40px;
  height: 40px;
  padding-right: 0;
  padding-left: 0;
}
.ant-btn-group-sm > .ant-btn,
.ant-btn-group-sm > span > .ant-btn {
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 0;
  line-height: 22px;
}
.ant-btn-group-sm > .ant-btn > .anticon,
.ant-btn-group-sm > span > .ant-btn > .anticon {
  font-size: 14px;
}
.ant-btn-group-sm > .ant-btn.ant-btn-icon-only {
  width: 24px;
  height: 24px;
  padding-right: 0;
  padding-left: 0;
}
.ant-btn-group .ant-btn + .ant-btn,
.ant-btn + .ant-btn-group,
.ant-btn-group span + .ant-btn,
.ant-btn-group .ant-btn + span,
.ant-btn-group > span + span,
.ant-btn-group + .ant-btn,
.ant-btn-group + .ant-btn-group {
  margin-left: -1px;
}
.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}
.ant-btn-group .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn:first-child,
.ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}
.ant-btn-group > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group > .ant-btn-group {
  float: left;
}
.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {
  padding-left: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn:focus > span,
.ant-btn:active > span {
  position: relative;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 8px;
}
.ant-btn-background-ghost {
  color: #fff;
  background: transparent !important;
  border-color: #fff;
}
.ant-btn-background-ghost.ant-btn-primary {
  color: #2EB1EF;
  background-color: transparent;
  border-color: #2EB1EF;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:hover,
.ant-btn-background-ghost.ant-btn-primary:focus {
  color: #58cefc;
  background-color: transparent;
  border-color: #58cefc;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:active,
.ant-btn-background-ghost.ant-btn-primary.active {
  color: #1c8dc9;
  background-color: transparent;
  border-color: #1c8dc9;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary-disabled,
.ant-btn-background-ghost.ant-btn-primary.disabled,
.ant-btn-background-ghost.ant-btn-primary[disabled],
.ant-btn-background-ghost.ant-btn-primary-disabled:hover,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,
.ant-btn-background-ghost.ant-btn-primary-disabled:focus,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,
.ant-btn-background-ghost.ant-btn-primary-disabled:active,
.ant-btn-background-ghost.ant-btn-primary.disabled:active,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active,
.ant-btn-background-ghost.ant-btn-primary-disabled.active,
.ant-btn-background-ghost.ant-btn-primary.disabled.active,
.ant-btn-background-ghost.ant-btn-primary[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger {
  color: #ff4d4f;
  background-color: transparent;
  border-color: #ff4d4f;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:hover,
.ant-btn-background-ghost.ant-btn-danger:focus {
  color: #ff7875;
  background-color: transparent;
  border-color: #ff7875;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:active,
.ant-btn-background-ghost.ant-btn-danger.active {
  color: #d9363e;
  background-color: transparent;
  border-color: #d9363e;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger-disabled,
.ant-btn-background-ghost.ant-btn-danger.disabled,
.ant-btn-background-ghost.ant-btn-danger[disabled],
.ant-btn-background-ghost.ant-btn-danger-disabled:hover,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,
.ant-btn-background-ghost.ant-btn-danger-disabled:focus,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,
.ant-btn-background-ghost.ant-btn-danger-disabled:active,
.ant-btn-background-ghost.ant-btn-danger.disabled:active,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active,
.ant-btn-background-ghost.ant-btn-danger-disabled.active,
.ant-btn-background-ghost.ant-btn-danger.disabled.active,
.ant-btn-background-ghost.ant-btn-danger[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-link {
  color: #2EB1EF;
  background-color: transparent;
  border-color: transparent;
  text-shadow: none;
  color: #fff;
}
.ant-btn-background-ghost.ant-btn-link > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-link:hover,
.ant-btn-background-ghost.ant-btn-link:focus {
  color: #58cefc;
  background-color: transparent;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-link:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-link:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-link:active,
.ant-btn-background-ghost.ant-btn-link.active {
  color: #1c8dc9;
  background-color: transparent;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-link:active > a:only-child,
.ant-btn-background-ghost.ant-btn-link.active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-link:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-link-disabled,
.ant-btn-background-ghost.ant-btn-link.disabled,
.ant-btn-background-ghost.ant-btn-link[disabled],
.ant-btn-background-ghost.ant-btn-link-disabled:hover,
.ant-btn-background-ghost.ant-btn-link.disabled:hover,
.ant-btn-background-ghost.ant-btn-link[disabled]:hover,
.ant-btn-background-ghost.ant-btn-link-disabled:focus,
.ant-btn-background-ghost.ant-btn-link.disabled:focus,
.ant-btn-background-ghost.ant-btn-link[disabled]:focus,
.ant-btn-background-ghost.ant-btn-link-disabled:active,
.ant-btn-background-ghost.ant-btn-link.disabled:active,
.ant-btn-background-ghost.ant-btn-link[disabled]:active,
.ant-btn-background-ghost.ant-btn-link-disabled.active,
.ant-btn-background-ghost.ant-btn-link.disabled.active,
.ant-btn-background-ghost.ant-btn-link[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child,
.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child,
.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child,
.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child,
.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child::after,
.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-two-chinese-chars::first-letter {
  letter-spacing: 0.34em;
}
.ant-btn-two-chinese-chars > *:not(.anticon) {
  margin-right: -0.34em;
  letter-spacing: 0.34em;
}
.ant-btn-block {
  width: 100%;
}
.ant-btn:empty {
  vertical-align: top;
}
a.ant-btn {
  padding-top: 0.1px;
  line-height: 34px;
}
a.ant-btn-lg {
  line-height: 38px;
}
a.ant-btn-sm {
  line-height: 22px;
}
.ant-fullcalendar {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  border-top: 1px solid #d9d9d9;
  outline: none;
}
.ant-select.ant-fullcalendar-year-select {
  min-width: 90px;
}
.ant-select.ant-fullcalendar-year-select.ant-select-sm {
  min-width: 70px;
}
.ant-select.ant-fullcalendar-month-select {
  min-width: 80px;
  margin-left: 8px;
}
.ant-select.ant-fullcalendar-month-select.ant-select-sm {
  min-width: 70px;
}
.ant-fullcalendar-header {
  padding: 11px 16px 11px 0;
  text-align: right;
}
.ant-fullcalendar-header .ant-select-dropdown {
  text-align: left;
}
.ant-fullcalendar-header .ant-radio-group {
  margin-left: 8px;
  text-align: left;
}
.ant-fullcalendar-header label.ant-radio-button {
  height: 22px;
  padding: 0 10px;
  line-height: 20px;
}
.ant-fullcalendar-date-panel {
  position: relative;
  outline: none;
}
.ant-fullcalendar-calendar-body {
  padding: 8px 12px;
}
.ant-fullcalendar table {
  width: 100%;
  max-width: 100%;
  height: 256px;
  background-color: transparent;
  border-collapse: collapse;
}
.ant-fullcalendar table,
.ant-fullcalendar th,
.ant-fullcalendar td {
  border: 0;
}
.ant-fullcalendar td {
  position: relative;
}
.ant-fullcalendar-calendar-table {
  margin-bottom: 0;
  border-spacing: 0;
}
.ant-fullcalendar-column-header {
  width: 33px;
  padding: 0;
  line-height: 18px;
  text-align: center;
}
.ant-fullcalendar-column-header .ant-fullcalendar-column-header-inner {
  display: block;
  font-weight: normal;
}
.ant-fullcalendar-week-number-header .ant-fullcalendar-column-header-inner {
  display: none;
}
.ant-fullcalendar-month,
.ant-fullcalendar-date {
  text-align: center;
  transition: all 0.3s;
}
.ant-fullcalendar-value {
  display: block;
  width: 24px;
  height: 24px;
  margin: 0 auto;
  padding: 0;
  color: #545454;
  line-height: 24px;
  background: transparent;
  border-radius: 4px;
  transition: all 0.3s;
}
.ant-fullcalendar-value:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-fullcalendar-value:active {
  color: #fff;
  background: #2EB1EF;
}
.ant-fullcalendar-month-panel-cell .ant-fullcalendar-value {
  width: 48px;
}
.ant-fullcalendar-today .ant-fullcalendar-value,
.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
  box-shadow: 0 0 0 1px #2EB1EF inset;
}
.ant-fullcalendar-selected-day .ant-fullcalendar-value,
.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
  color: #fff;
  background: #2EB1EF;
}
.ant-fullcalendar-disabled-cell-first-of-row .ant-fullcalendar-value {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-fullcalendar-disabled-cell-last-of-row .ant-fullcalendar-value {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ant-fullcalendar-last-month-cell .ant-fullcalendar-value,
.ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {
  color: rgba(0, 0, 0, 0.25);
}
.ant-fullcalendar-month-panel-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.ant-fullcalendar-content {
  position: absolute;
  bottom: -9px;
  left: 0;
  width: 100%;
}
.ant-fullcalendar-fullscreen {
  border-top: 0;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-table {
  table-layout: fixed;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-header .ant-radio-group {
  margin-left: 16px;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-header label.ant-radio-button {
  height: 36px;
  line-height: 34px;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date {
  display: block;
  height: 116px;
  margin: 0 4px;
  padding: 4px 8px;
  color: #545454;
  text-align: left;
  border-top: 2px solid #e8e8e8;
  transition: background 0.3s;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month:active,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date:active {
  background: #d4f7ff;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-column-header {
  padding-right: 12px;
  padding-bottom: 5px;
  text-align: right;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-value {
  width: auto;
  text-align: right;
  background: transparent;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {
  color: #545454;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {
  background: transparent;
  border-top-color: #2EB1EF;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value,
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {
  box-shadow: none;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
  background: #f0fdff;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,
.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {
  color: #2EB1EF;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,
.ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date {
  color: rgba(0, 0, 0, 0.25);
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-content {
  position: static;
  width: auto;
  height: 88px;
  overflow-y: auto;
}
.ant-fullcalendar-disabled-cell .ant-fullcalendar-date,
.ant-fullcalendar-disabled-cell .ant-fullcalendar-date:hover {
  cursor: not-allowed;
}
.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date,
.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date:hover {
  background: transparent;
}
.ant-fullcalendar-disabled-cell .ant-fullcalendar-value {
  width: auto;
  color: rgba(0, 0, 0, 0.25);
  border-radius: 0;
  cursor: not-allowed;
}
.ant-card {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  background: #fff;
  border-radius: 4px;
  transition: all 0.3s;
}
.ant-card-hoverable {
  cursor: pointer;
}
.ant-card-hoverable:hover {
  border-color: rgba(0, 0, 0, 0.09);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}
.ant-card-bordered {
  border: 1px solid #e8e8e8;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  zoom: 1;
}
.ant-card-head::before,
.ant-card-head::after {
  display: table;
  content: '';
}
.ant-card-head::after {
  clear: both;
}
.ant-card-head::before,
.ant-card-head::after {
  display: table;
  content: '';
}
.ant-card-head::after {
  clear: both;
}
.ant-card-head-wrapper {
  display: flex;
  align-items: center;
}
.ant-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 16px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-card-head .ant-tabs {
  clear: both;
  margin-bottom: -17px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
}
.ant-card-head .ant-tabs-bar {
  border-bottom: 1px solid #e8e8e8;
}
.ant-card-extra {
  float: right;
  margin-left: auto;
  padding: 16px 0;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
}
.ant-card-body {
  padding: 24px;
  zoom: 1;
}
.ant-card-body::before,
.ant-card-body::after {
  display: table;
  content: '';
}
.ant-card-body::after {
  clear: both;
}
.ant-card-body::before,
.ant-card-body::after {
  display: table;
  content: '';
}
.ant-card-body::after {
  clear: both;
}
.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {
  margin: -1px 0 0 -1px;
  padding: 0;
}
.ant-card-grid {
  float: left;
  width: 33.33%;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset, 0 1px 0 0 #e8e8e8 inset;
  transition: all 0.3s;
}
.ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {
  min-height: 32px;
  padding-bottom: 0;
}
.ant-card-contain-tabs > .ant-card-head .ant-card-extra {
  padding-bottom: 0;
}
.ant-card-cover > * {
  display: block;
  width: 100%;
}
.ant-card-cover img {
  border-radius: 4px 4px 0 0;
}
.ant-card-actions {
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  zoom: 1;
}
.ant-card-actions::before,
.ant-card-actions::after {
  display: table;
  content: '';
}
.ant-card-actions::after {
  clear: both;
}
.ant-card-actions::before,
.ant-card-actions::after {
  display: table;
  content: '';
}
.ant-card-actions::after {
  clear: both;
}
.ant-card-actions > li {
  float: left;
  margin: 12px 0;
  color: #595959;
  text-align: center;
}
.ant-card-actions > li > span {
  position: relative;
  display: block;
  min-width: 32px;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}
.ant-card-actions > li > span:hover {
  color: #2EB1EF;
  transition: color 0.3s;
}
.ant-card-actions > li > span a:not(.ant-btn),
.ant-card-actions > li > span > .anticon {
  display: inline-block;
  width: 100%;
  color: #595959;
  line-height: 22px;
  transition: color 0.3s;
}
.ant-card-actions > li > span a:not(.ant-btn):hover,
.ant-card-actions > li > span > .anticon:hover {
  color: #2EB1EF;
}
.ant-card-actions > li > span > .anticon {
  font-size: 16px;
  line-height: 22px;
}
.ant-card-actions > li:not(:last-child) {
  border-right: 1px solid #e8e8e8;
}
.ant-card-type-inner .ant-card-head {
  padding: 0 24px;
  background: #fafafa;
}
.ant-card-type-inner .ant-card-head-title {
  padding: 12px 0;
  font-size: 14px;
}
.ant-card-type-inner .ant-card-body {
  padding: 16px 24px;
}
.ant-card-type-inner .ant-card-extra {
  padding: 13.5px 0;
}
.ant-card-meta {
  margin: -4px 0;
  zoom: 1;
}
.ant-card-meta::before,
.ant-card-meta::after {
  display: table;
  content: '';
}
.ant-card-meta::after {
  clear: both;
}
.ant-card-meta::before,
.ant-card-meta::after {
  display: table;
  content: '';
}
.ant-card-meta::after {
  clear: both;
}
.ant-card-meta-avatar {
  float: left;
  padding-right: 16px;
}
.ant-card-meta-detail {
  overflow: hidden;
}
.ant-card-meta-detail > div:not(:last-child) {
  margin-bottom: 8px;
}
.ant-card-meta-title {
  overflow: hidden;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-card-meta-description {
  color: #595959;
}
.ant-card-loading {
  overflow: hidden;
}
.ant-card-loading .ant-card-body {
  user-select: none;
}
.ant-card-loading-content p {
  margin: 0;
}
.ant-card-loading-block {
  height: 14px;
  margin: 4px 0;
  background: linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2));
  background-size: 600% 600%;
  border-radius: 4px;
  animation: card-loading 1.4s ease infinite;
}
@keyframes card-loading {
  0%,
  100% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
.ant-card-small > .ant-card-head {
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
}
.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {
  padding: 8px 0;
}
.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {
  padding: 8px 0;
  font-size: 14px;
}
.ant-card-small > .ant-card-body {
  padding: 12px;
}
.ant-carousel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-carousel .slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.ant-carousel .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.ant-carousel .slick-list:focus {
  outline: none;
}
.ant-carousel .slick-list.dragging {
  cursor: pointer;
}
.ant-carousel .slick-list .slick-slide {
  pointer-events: none;
}
.ant-carousel .slick-list .slick-slide input.ant-radio-input,
.ant-carousel .slick-list .slick-slide input.ant-checkbox-input {
  visibility: hidden;
}
.ant-carousel .slick-list .slick-slide.slick-active {
  pointer-events: auto;
}
.ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input,
.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input {
  visibility: visible;
}
.ant-carousel .slick-slider .slick-track,
.ant-carousel .slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}
.ant-carousel .slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
}
.ant-carousel .slick-track::before,
.ant-carousel .slick-track::after {
  display: table;
  content: '';
}
.ant-carousel .slick-track::after {
  clear: both;
}
.slick-loading .ant-carousel .slick-track {
  visibility: hidden;
}
.ant-carousel .slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
[dir='rtl'] .ant-carousel .slick-slide {
  float: right;
}
.ant-carousel .slick-slide img {
  display: block;
}
.ant-carousel .slick-slide.slick-loading img {
  display: none;
}
.ant-carousel .slick-slide.dragging img {
  pointer-events: none;
}
.ant-carousel .slick-initialized .slick-slide {
  display: block;
}
.ant-carousel .slick-loading .slick-slide {
  visibility: hidden;
}
.ant-carousel .slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}
.ant-carousel .slick-arrow.slick-hidden {
  display: none;
}
.ant-carousel .slick-prev,
.ant-carousel .slick-next {
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  padding: 0;
  color: transparent;
  font-size: 0;
  line-height: 0;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}
.ant-carousel .slick-prev:hover,
.ant-carousel .slick-next:hover,
.ant-carousel .slick-prev:focus,
.ant-carousel .slick-next:focus {
  color: transparent;
  background: transparent;
  outline: none;
}
.ant-carousel .slick-prev:hover::before,
.ant-carousel .slick-next:hover::before,
.ant-carousel .slick-prev:focus::before,
.ant-carousel .slick-next:focus::before {
  opacity: 1;
}
.ant-carousel .slick-prev.slick-disabled::before,
.ant-carousel .slick-next.slick-disabled::before {
  opacity: 0.25;
}
.ant-carousel .slick-prev {
  left: -25px;
}
.ant-carousel .slick-prev::before {
  content: '←';
}
.ant-carousel .slick-next {
  right: -25px;
}
.ant-carousel .slick-next::before {
  content: '→';
}
.ant-carousel .slick-dots {
  position: absolute;
  display: block;
  width: 100%;
  height: 3px;
  margin: 0;
  padding: 0;
  text-align: center;
  list-style: none;
}
.ant-carousel .slick-dots-bottom {
  bottom: 12px;
}
.ant-carousel .slick-dots-top {
  top: 12px;
}
.ant-carousel .slick-dots li {
  position: relative;
  display: inline-block;
  margin: 0 2px;
  padding: 0;
  text-align: center;
  vertical-align: top;
}
.ant-carousel .slick-dots li button {
  display: block;
  width: 16px;
  height: 3px;
  padding: 0;
  color: transparent;
  font-size: 0;
  background: #fff;
  border: 0;
  border-radius: 1px;
  outline: none;
  cursor: pointer;
  opacity: 0.3;
  transition: all 0.5s;
}
.ant-carousel .slick-dots li button:hover,
.ant-carousel .slick-dots li button:focus {
  opacity: 0.75;
}
.ant-carousel .slick-dots li.slick-active button {
  width: 24px;
  background: #fff;
  opacity: 1;
}
.ant-carousel .slick-dots li.slick-active button:hover,
.ant-carousel .slick-dots li.slick-active button:focus {
  opacity: 1;
}
.ant-carousel-vertical .slick-dots {
  top: 50%;
  bottom: auto;
  width: 3px;
  height: auto;
  transform: translateY(-50%);
}
.ant-carousel-vertical .slick-dots-left {
  left: 12px;
}
.ant-carousel-vertical .slick-dots-right {
  right: 12px;
}
.ant-carousel-vertical .slick-dots li {
  margin: 0 2px;
  vertical-align: baseline;
}
.ant-carousel-vertical .slick-dots li button {
  width: 3px;
  height: 16px;
}
.ant-carousel-vertical .slick-dots li.slick-active button {
  width: 3px;
  height: 24px;
}
.ant-cascader {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-cascader-input.ant-input {
  position: static;
  width: 100%;
  padding-right: 24px;
  background-color: transparent !important;
  cursor: pointer;
}
.ant-cascader-picker-show-search .ant-cascader-input.ant-input {
  position: relative;
}
.ant-cascader-picker {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  background-color: #fff;
  border-radius: 6px;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}
.ant-cascader-picker-with-value .ant-cascader-picker-label {
  color: transparent;
}
.ant-cascader-picker-disabled {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  cursor: not-allowed;
}
.ant-cascader-picker-disabled .ant-cascader-input {
  cursor: not-allowed;
}
.ant-cascader-picker:focus .ant-cascader-input {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-cascader-picker-show-search.ant-cascader-picker-focused {
  color: rgba(0, 0, 0, 0.25);
}
.ant-cascader-picker-label {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 20px;
  margin-top: -10px;
  padding: 0 20px 0 12px;
  overflow: hidden;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-cascader-picker-clear {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 2;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 12px;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  transition: color 0.3s ease, opacity 0.15s ease;
}
.ant-cascader-picker-clear:hover {
  color: #595959;
}
.ant-cascader-picker:hover .ant-cascader-picker-clear {
  opacity: 1;
}
.ant-cascader-picker-arrow {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 1;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 12px;
  transition: transform 0.2s;
}
.ant-cascader-picker-arrow.ant-cascader-picker-arrow-expand {
  transform: rotate(180deg);
}
.ant-cascader-picker-label:hover + .ant-cascader-input {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-cascader-picker-small .ant-cascader-picker-clear,
.ant-cascader-picker-small .ant-cascader-picker-arrow {
  right: 8px;
}
.ant-cascader-menus {
  position: absolute;
  z-index: 1050;
  font-size: 14px;
  white-space: nowrap;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-cascader-menus ul,
.ant-cascader-menus ol {
  margin: 0;
  list-style: none;
}
.ant-cascader-menus-empty,
.ant-cascader-menus-hidden {
  display: none;
}
.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-bottomLeft,
.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-bottomLeft {
  animation-name: antSlideUpIn;
}
.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-topLeft,
.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-topLeft {
  animation-name: antSlideDownIn;
}
.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-bottomLeft {
  animation-name: antSlideUpOut;
}
.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-topLeft {
  animation-name: antSlideDownOut;
}
.ant-cascader-menu {
  display: inline-block;
  min-width: 111px;
  height: 180px;
  margin: 0;
  padding: 4px 0;
  overflow: auto;
  vertical-align: top;
  list-style: none;
  border-right: 1px solid #e8e8e8;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.ant-cascader-menu:first-child {
  border-radius: 6px 0 0 6px;
}
.ant-cascader-menu:last-child {
  margin-right: -1px;
  border-right-color: transparent;
  border-radius: 0 6px 6px 0;
}
.ant-cascader-menu:only-child {
  border-radius: 6px;
}
.ant-cascader-menu-item {
  padding: 5px 12px;
  line-height: 22px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-cascader-menu-item:hover {
  background: #f0fdff;
}
.ant-cascader-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-cascader-menu-item-disabled:hover {
  background: transparent;
}
.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),
.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
  font-weight: 600;
  background-color: #fafafa;
}
.ant-cascader-menu-item-expand {
  position: relative;
  padding-right: 24px;
}
.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,
.ant-cascader-menu-item-loading-icon {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  position: absolute;
  right: 12px;
  color: #595959;
}
:root .ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,
:root .ant-cascader-menu-item-loading-icon {
  font-size: 12px;
}
.ant-cascader-menu-item .ant-cascader-menu-item-keyword {
  color: #f5222d;
}
@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
.ant-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: -0.09em;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  outline: none;
  cursor: pointer;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #2EB1EF;
}
.ant-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #2EB1EF;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-checkbox:hover::after,
.ant-checkbox-wrapper:hover .ant-checkbox::after {
  visibility: visible;
}
.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 22%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-checkbox-checked .ant-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-checkbox-disabled {
  cursor: not-allowed;
}
.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-checkbox-disabled .ant-checkbox-input {
  cursor: not-allowed;
}
.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-checkbox-disabled .ant-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-checkbox-disabled:hover::after,
.ant-checkbox-wrapper:hover .ant-checkbox-disabled::after {
  visibility: hidden;
}
.ant-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  line-height: unset;
  cursor: pointer;
}
.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 8px;
}
.ant-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-checkbox-group-item {
  display: inline-block;
  margin-right: 8px;
}
.ant-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-checkbox-group-item + .ant-checkbox-group-item {
  margin-left: 0;
}
.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #2EB1EF;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-collapse {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 6px;
}
.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}
.ant-collapse > .ant-collapse-item:last-child,
.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 6px 6px;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px;
  padding-left: 40px;
  color: #535353;
  line-height: 22px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  left: 16px;
  display: inline-block;
  font-size: 12px;
  transform: translateY(-50%);
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow > * {
  line-height: 1;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  display: inline-block;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow::before {
  display: none;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow-icon {
  display: block;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {
  transition: transform 0.24s;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
  float: right;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {
  outline: none;
}
.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
  padding-left: 12px;
}
.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 12px 16px;
  padding-right: 40px;
}
.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  right: 16px;
  left: auto;
}
.ant-collapse-anim-active {
  transition: height 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.ant-collapse-content {
  overflow: hidden;
  color: #545454;
  background-color: #fff;
  border-top: 1px solid #d9d9d9;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 16px;
}
.ant-collapse-content-inactive {
  display: none;
}
.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 0 6px 6px;
}
.ant-collapse-borderless {
  background-color: #fafafa;
  border: 0;
}
.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #d9d9d9;
}
.ant-collapse-borderless > .ant-collapse-item:last-child,
.ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-top: 4px;
}
.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,
.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-comment {
  position: relative;
}
.ant-comment-inner {
  display: flex;
  padding: 16px 0;
}
.ant-comment-avatar {
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
  cursor: pointer;
}
.ant-comment-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.ant-comment-content {
  position: relative;
  flex: 1 1 auto;
  min-width: 1px;
  font-size: 14px;
  word-wrap: break-word;
}
.ant-comment-content-author {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 4px;
  font-size: 14px;
}
.ant-comment-content-author > a,
.ant-comment-content-author > span {
  padding-right: 8px;
  font-size: 12px;
  line-height: 18px;
}
.ant-comment-content-author-name {
  color: #595959;
  font-size: 14px;
  transition: color 0.3s;
}
.ant-comment-content-author-name > * {
  color: #595959;
}
.ant-comment-content-author-name > *:hover {
  color: #595959;
}
.ant-comment-content-author-time {
  color: #ccc;
  white-space: nowrap;
  cursor: auto;
}
.ant-comment-content-detail p {
  white-space: pre-wrap;
}
.ant-comment-actions {
  margin-top: 12px;
  padding-left: 0;
}
.ant-comment-actions > li {
  display: inline-block;
  color: #595959;
}
.ant-comment-actions > li > span {
  padding-right: 10px;
  color: #595959;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  user-select: none;
}
.ant-comment-actions > li > span:hover {
  color: #595959;
}
.ant-comment-nested {
  margin-left: 44px;
}
.ant-calendar-picker-container {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  z-index: 1050;
  font-family: "DM Sans", sans-serif;
}
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-calendar-picker {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  outline: none;
  cursor: text;
  transition: opacity 0.3s;
}
.ant-calendar-picker-input {
  outline: none;
}
.ant-calendar-picker-input.ant-input {
  line-height: 1.3;
}
.ant-calendar-picker-input.ant-input-sm {
  padding-top: 0;
  padding-bottom: 0;
}
.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
  border-color: #58cefc;
}
.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled) {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-calendar-picker-clear,
.ant-calendar-picker-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 1;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  font-size: 12px;
  line-height: 14px;
  transition: all 0.3s;
  user-select: none;
}
.ant-calendar-picker-clear {
  z-index: 2;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
}
.ant-calendar-picker-clear:hover {
  color: #595959;
}
.ant-calendar-picker:hover .ant-calendar-picker-clear {
  opacity: 1;
  pointer-events: auto;
}
.ant-calendar-picker-icon {
  display: inline-block;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  line-height: 1;
}
.ant-input-disabled + .ant-calendar-picker-icon {
  cursor: not-allowed;
}
.ant-calendar-picker-small .ant-calendar-picker-clear,
.ant-calendar-picker-small .ant-calendar-picker-icon {
  right: 8px;
}
.ant-calendar {
  position: relative;
  width: 280px;
  font-size: 14px;
  line-height: 1.3;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-calendar-input-wrap {
  height: 34px;
  padding: 6px 10px;
  border-bottom: 1px solid #e8e8e8;
}
.ant-calendar-input {
  width: 100%;
  height: 22px;
  color: #545454;
  background: #fff;
  border: 0;
  outline: 0;
  cursor: auto;
}
.ant-calendar-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-calendar-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-calendar-week-number {
  width: 286px;
}
.ant-calendar-week-number-cell {
  text-align: center;
}
.ant-calendar-header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  user-select: none;
}
.ant-calendar-header a:hover {
  color: #58cefc;
}
.ant-calendar-header .ant-calendar-century-select,
.ant-calendar-header .ant-calendar-decade-select,
.ant-calendar-header .ant-calendar-year-select,
.ant-calendar-header .ant-calendar-month-select {
  display: inline-block;
  padding: 0 2px;
  color: #535353;
  font-weight: 500;
  line-height: 40px;
}
.ant-calendar-header .ant-calendar-century-select-arrow,
.ant-calendar-header .ant-calendar-decade-select-arrow,
.ant-calendar-header .ant-calendar-year-select-arrow,
.ant-calendar-header .ant-calendar-month-select-arrow {
  display: none;
}
.ant-calendar-header .ant-calendar-prev-century-btn,
.ant-calendar-header .ant-calendar-next-century-btn,
.ant-calendar-header .ant-calendar-prev-decade-btn,
.ant-calendar-header .ant-calendar-next-decade-btn,
.ant-calendar-header .ant-calendar-prev-month-btn,
.ant-calendar-header .ant-calendar-next-month-btn,
.ant-calendar-header .ant-calendar-prev-year-btn,
.ant-calendar-header .ant-calendar-next-year-btn {
  position: absolute;
  top: 0;
  display: inline-block;
  padding: 0 5px;
  color: #595959;
  font-size: 16px;
  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;
  line-height: 40px;
}
.ant-calendar-header .ant-calendar-prev-century-btn,
.ant-calendar-header .ant-calendar-prev-decade-btn,
.ant-calendar-header .ant-calendar-prev-year-btn {
  left: 7px;
  height: 100%;
}
.ant-calendar-header .ant-calendar-prev-century-btn::before,
.ant-calendar-header .ant-calendar-prev-decade-btn::before,
.ant-calendar-header .ant-calendar-prev-year-btn::before,
.ant-calendar-header .ant-calendar-prev-century-btn::after,
.ant-calendar-header .ant-calendar-prev-decade-btn::after,
.ant-calendar-header .ant-calendar-prev-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-header .ant-calendar-prev-century-btn:hover::before,
.ant-calendar-header .ant-calendar-prev-decade-btn:hover::before,
.ant-calendar-header .ant-calendar-prev-year-btn:hover::before,
.ant-calendar-header .ant-calendar-prev-century-btn:hover::after,
.ant-calendar-header .ant-calendar-prev-decade-btn:hover::after,
.ant-calendar-header .ant-calendar-prev-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-header .ant-calendar-prev-century-btn::after,
.ant-calendar-header .ant-calendar-prev-decade-btn::after,
.ant-calendar-header .ant-calendar-prev-year-btn::after {
  display: none;
}
.ant-calendar-header .ant-calendar-prev-century-btn::after,
.ant-calendar-header .ant-calendar-prev-decade-btn::after,
.ant-calendar-header .ant-calendar-prev-year-btn::after {
  position: relative;
  left: -3px;
  display: inline-block;
}
.ant-calendar-header .ant-calendar-next-century-btn,
.ant-calendar-header .ant-calendar-next-decade-btn,
.ant-calendar-header .ant-calendar-next-year-btn {
  right: 7px;
  height: 100%;
}
.ant-calendar-header .ant-calendar-next-century-btn::before,
.ant-calendar-header .ant-calendar-next-decade-btn::before,
.ant-calendar-header .ant-calendar-next-year-btn::before,
.ant-calendar-header .ant-calendar-next-century-btn::after,
.ant-calendar-header .ant-calendar-next-decade-btn::after,
.ant-calendar-header .ant-calendar-next-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-header .ant-calendar-next-century-btn:hover::before,
.ant-calendar-header .ant-calendar-next-decade-btn:hover::before,
.ant-calendar-header .ant-calendar-next-year-btn:hover::before,
.ant-calendar-header .ant-calendar-next-century-btn:hover::after,
.ant-calendar-header .ant-calendar-next-decade-btn:hover::after,
.ant-calendar-header .ant-calendar-next-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-header .ant-calendar-next-century-btn::after,
.ant-calendar-header .ant-calendar-next-decade-btn::after,
.ant-calendar-header .ant-calendar-next-year-btn::after {
  display: none;
}
.ant-calendar-header .ant-calendar-next-century-btn::before,
.ant-calendar-header .ant-calendar-next-decade-btn::before,
.ant-calendar-header .ant-calendar-next-year-btn::before,
.ant-calendar-header .ant-calendar-next-century-btn::after,
.ant-calendar-header .ant-calendar-next-decade-btn::after,
.ant-calendar-header .ant-calendar-next-year-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-header .ant-calendar-next-century-btn::before,
.ant-calendar-header .ant-calendar-next-decade-btn::before,
.ant-calendar-header .ant-calendar-next-year-btn::before {
  position: relative;
  left: 3px;
}
.ant-calendar-header .ant-calendar-next-century-btn::after,
.ant-calendar-header .ant-calendar-next-decade-btn::after,
.ant-calendar-header .ant-calendar-next-year-btn::after {
  display: inline-block;
}
.ant-calendar-header .ant-calendar-prev-month-btn {
  left: 29px;
  height: 100%;
}
.ant-calendar-header .ant-calendar-prev-month-btn::before,
.ant-calendar-header .ant-calendar-prev-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-header .ant-calendar-prev-month-btn:hover::before,
.ant-calendar-header .ant-calendar-prev-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-header .ant-calendar-prev-month-btn::after {
  display: none;
}
.ant-calendar-header .ant-calendar-next-month-btn {
  right: 29px;
  height: 100%;
}
.ant-calendar-header .ant-calendar-next-month-btn::before,
.ant-calendar-header .ant-calendar-next-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-header .ant-calendar-next-month-btn:hover::before,
.ant-calendar-header .ant-calendar-next-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-header .ant-calendar-next-month-btn::after {
  display: none;
}
.ant-calendar-header .ant-calendar-next-month-btn::before,
.ant-calendar-header .ant-calendar-next-month-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-body {
  padding: 8px 12px;
}
.ant-calendar table {
  width: 100%;
  max-width: 100%;
  background-color: transparent;
  border-collapse: collapse;
}
.ant-calendar table,
.ant-calendar th,
.ant-calendar td {
  text-align: center;
  border: 0;
}
.ant-calendar-calendar-table {
  margin-bottom: 0;
  border-spacing: 0;
}
.ant-calendar-column-header {
  width: 33px;
  padding: 6px 0;
  line-height: 18px;
  text-align: center;
}
.ant-calendar-column-header .ant-calendar-column-header-inner {
  display: block;
  font-weight: normal;
}
.ant-calendar-week-number-header .ant-calendar-column-header-inner {
  display: none;
}
.ant-calendar-cell {
  height: 30px;
  padding: 3px 0;
}
.ant-calendar-date {
  display: block;
  width: 24px;
  height: 24px;
  margin: 0 auto;
  padding: 0;
  color: #545454;
  line-height: 22px;
  text-align: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-date-panel {
  position: relative;
  outline: none;
}
.ant-calendar-date:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-calendar-date:active {
  color: #fff;
  background: #58cefc;
}
.ant-calendar-today .ant-calendar-date {
  color: #2EB1EF;
  font-weight: bold;
  border-color: #2EB1EF;
}
.ant-calendar-selected-day .ant-calendar-date {
  background: #d4f7ff;
}
.ant-calendar-last-month-cell .ant-calendar-date,
.ant-calendar-next-month-btn-day .ant-calendar-date,
.ant-calendar-last-month-cell .ant-calendar-date:hover,
.ant-calendar-next-month-btn-day .ant-calendar-date:hover {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border-color: transparent;
}
.ant-calendar-disabled-cell .ant-calendar-date {
  position: relative;
  width: auto;
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 0;
  cursor: not-allowed;
}
.ant-calendar-disabled-cell .ant-calendar-date:hover {
  background: #f5f5f5;
}
.ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date::before {
  position: absolute;
  top: -1px;
  left: 5px;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  content: '';
}
.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {
  position: relative;
  padding-right: 5px;
  padding-left: 5px;
}
.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date::before {
  position: absolute;
  top: -1px;
  left: 5px;
  width: 24px;
  height: 24px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  content: ' ';
}
.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-calendar-footer {
  padding: 0 12px;
  line-height: 38px;
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-footer:empty {
  border-top: 0;
}
.ant-calendar-footer-btn {
  display: block;
  text-align: center;
}
.ant-calendar-footer-extra {
  text-align: left;
}
.ant-calendar .ant-calendar-today-btn,
.ant-calendar .ant-calendar-clear-btn {
  display: inline-block;
  margin: 0 0 0 8px;
  text-align: center;
}
.ant-calendar .ant-calendar-today-btn-disabled,
.ant-calendar .ant-calendar-clear-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-calendar .ant-calendar-today-btn:only-child,
.ant-calendar .ant-calendar-clear-btn:only-child {
  margin: 0;
}
.ant-calendar .ant-calendar-clear-btn {
  position: absolute;
  top: 7px;
  right: 5px;
  display: none;
  width: 20px;
  height: 20px;
  margin: 0;
  overflow: hidden;
  line-height: 20px;
  text-align: center;
  text-indent: -76px;
}
.ant-calendar .ant-calendar-clear-btn::after {
  display: inline-block;
  width: 20px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  line-height: 1;
  text-indent: 43px;
  transition: color 0.3s ease;
}
.ant-calendar .ant-calendar-clear-btn:hover::after {
  color: #595959;
}
.ant-calendar .ant-calendar-ok-btn {
  position: relative;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  display: inline-block;
  font-weight: 400;
  color: #545454;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: solid 1px #d9d9d9;
  padding: 0 15px;
  height: 36px;
  line-height: 34px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 15px;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  color: #ffffff;
  background-color: #2EB1EF;
  border-color: #2EB1EF;
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
  border-radius: 6px;
  line-height: 22px;
}
.ant-calendar .ant-calendar-ok-btn > .anticon {
  line-height: 1;
}
.ant-calendar .ant-calendar-ok-btn,
.ant-calendar .ant-calendar-ok-btn:active,
.ant-calendar .ant-calendar-ok-btn:focus {
  outline: 0;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {
  text-decoration: none;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn[disabled] {
  cursor: not-allowed;
}
.ant-calendar .ant-calendar-ok-btn.disabled > *,
.ant-calendar .ant-calendar-ok-btn[disabled] > * {
  pointer-events: none;
}
.ant-calendar .ant-calendar-ok-btn-lg {
  height: 40px;
  padding: 0 15px;
  font-size: 16px;
  border-radius: 4px;
}
.ant-calendar .ant-calendar-ok-btn-sm {
  height: 24px;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
}
.ant-calendar .ant-calendar-ok-btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-calendar .ant-calendar-ok-btn:not(:last-child) {
    margin-right: 10px;
  }
}
@media screen and (max-width: 575px) {
  .ant-calendar .ant-calendar-ok-btn {
    margin-bottom: 10px;
  }
}
.ant-calendar .ant-calendar-ok-btn:focus,
.ant-calendar .ant-calendar-ok-btn:hover {
  text-decoration: none;
}
.ant-calendar .ant-calendar-ok-btn:focus,
.ant-calendar .ant-calendar-ok-btn.focus {
  outline: 0;
}
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn:disabled {
  opacity: 0.65;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled) {
  cursor: pointer;
}
.gx-btn-list .ant-calendar .ant-calendar-ok-btn {
  margin-bottom: 6px;
}
.gx-sub-popover .ant-calendar .ant-calendar-ok-btn {
  border: 0 none;
  margin-bottom: 5px;
}
.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:focus,
.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:hover {
  background-color: #f5f5f5;
}
.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:not(:last-child) {
  margin-right: 5px;
}
.gx-login-content .ant-calendar .ant-calendar-ok-btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.ant-calendar .ant-calendar-ok-btn > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-calendar .ant-calendar-ok-btn:hover,
.ant-calendar .ant-calendar-ok-btn:focus {
  color: #fff;
  background-color: #58cefc;
  border-color: #58cefc;
}
.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-calendar .ant-calendar-ok-btn:active,
.ant-calendar .ant-calendar-ok-btn.active {
  color: #fff;
  background-color: #1c8dc9;
  border-color: #1c8dc9;
}
.ant-calendar .ant-calendar-ok-btn:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.active > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-calendar .ant-calendar-ok-btn-disabled,
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn[disabled],
.ant-calendar .ant-calendar-ok-btn-disabled:hover,
.ant-calendar .ant-calendar-ok-btn.disabled:hover,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover,
.ant-calendar .ant-calendar-ok-btn-disabled:focus,
.ant-calendar .ant-calendar-ok-btn.disabled:focus,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus,
.ant-calendar .ant-calendar-ok-btn-disabled:active,
.ant-calendar .ant-calendar-ok-btn.disabled:active,
.ant-calendar .ant-calendar-ok-btn[disabled]:active,
.ant-calendar .ant-calendar-ok-btn-disabled.active,
.ant-calendar .ant-calendar-ok-btn.disabled.active,
.ant-calendar .ant-calendar-ok-btn[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-calendar .ant-calendar-ok-btn:hover,
.ant-calendar .ant-calendar-ok-btn:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn:disabled {
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled):active,
.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.ant-calendar .ant-calendar-ok-btn-disabled,
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn[disabled],
.ant-calendar .ant-calendar-ok-btn-disabled:hover,
.ant-calendar .ant-calendar-ok-btn.disabled:hover,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover,
.ant-calendar .ant-calendar-ok-btn-disabled:focus,
.ant-calendar .ant-calendar-ok-btn.disabled:focus,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus,
.ant-calendar .ant-calendar-ok-btn-disabled:active,
.ant-calendar .ant-calendar-ok-btn.disabled:active,
.ant-calendar .ant-calendar-ok-btn[disabled]:active,
.ant-calendar .ant-calendar-ok-btn-disabled.active,
.ant-calendar .ant-calendar-ok-btn.disabled.active,
.ant-calendar .ant-calendar-ok-btn[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-calendar-range-picker-input {
  width: 44%;
  height: 99%;
  text-align: center;
  background-color: transparent;
  border: 0;
  outline: 0;
}
.ant-calendar-range-picker-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-calendar-range-picker-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-range-picker-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-range-picker-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-calendar-range-picker-input[disabled] {
  cursor: not-allowed;
}
.ant-calendar-range-picker-separator {
  display: inline-block;
  min-width: 10px;
  height: 100%;
  color: #595959;
  white-space: nowrap;
  text-align: center;
  vertical-align: top;
  pointer-events: none;
}
.ant-calendar-range {
  width: 552px;
  overflow: hidden;
}
.ant-calendar-range .ant-calendar-date-panel::after {
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
  content: '.';
}
.ant-calendar-range-part {
  position: relative;
  width: 50%;
}
.ant-calendar-range-left {
  float: left;
}
.ant-calendar-range-left .ant-calendar-time-picker-inner {
  border-right: 1px solid #e8e8e8;
}
.ant-calendar-range-right {
  float: right;
}
.ant-calendar-range-right .ant-calendar-time-picker-inner {
  border-left: 1px solid #e8e8e8;
}
.ant-calendar-range-middle {
  position: absolute;
  left: 50%;
  z-index: 1;
  height: 34px;
  margin: 1px 0 0 0;
  padding: 0 200px 0 0;
  color: #595959;
  line-height: 34px;
  text-align: center;
  transform: translateX(-50%);
  pointer-events: none;
}
.ant-calendar-range-right .ant-calendar-date-input-wrap {
  margin-left: -90px;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-range-middle {
  padding: 0 10px 0 0;
  transform: translateX(-50%);
}
.ant-calendar-range .ant-calendar-today :not(.ant-calendar-disabled-cell) :not(.ant-calendar-last-month-cell) :not(.ant-calendar-next-month-btn-day) .ant-calendar-date {
  color: #2EB1EF;
  background: #d4f7ff;
  border-color: #2EB1EF;
}
.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,
.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date {
  color: #fff;
  background: #2EB1EF;
  border: 1px solid transparent;
}
.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date:hover,
.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date:hover {
  background: #2EB1EF;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-range-right .ant-calendar-date-input-wrap {
  margin-left: 0;
}
.ant-calendar-range .ant-calendar-input-wrap {
  position: relative;
  height: 34px;
}
.ant-calendar-range .ant-calendar-input,
.ant-calendar-range .ant-calendar-time-picker-input {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  height: 24px;
  padding-right: 0;
  padding-left: 0;
  line-height: 24px;
  border: 0;
  box-shadow: none;
}
.ant-calendar-range .ant-calendar-input::-moz-placeholder,
.ant-calendar-range .ant-calendar-time-picker-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-calendar-range .ant-calendar-input:-ms-input-placeholder,
.ant-calendar-range .ant-calendar-time-picker-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-range .ant-calendar-input::-webkit-input-placeholder,
.ant-calendar-range .ant-calendar-time-picker-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-calendar-range .ant-calendar-input:placeholder-shown,
.ant-calendar-range .ant-calendar-time-picker-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-calendar-range .ant-calendar-input:hover,
.ant-calendar-range .ant-calendar-time-picker-input:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-calendar-range .ant-calendar-input:focus,
.ant-calendar-range .ant-calendar-time-picker-input:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-calendar-range .ant-calendar-input-disabled,
.ant-calendar-range .ant-calendar-time-picker-input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-calendar-range .ant-calendar-input-disabled:hover,
.ant-calendar-range .ant-calendar-time-picker-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-calendar-range .ant-calendar-input[disabled],
.ant-calendar-range .ant-calendar-time-picker-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-calendar-range .ant-calendar-input[disabled]:hover,
.ant-calendar-range .ant-calendar-time-picker-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-calendar-range .ant-calendar-input,
textarea.ant-calendar-range .ant-calendar-time-picker-input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-calendar-range .ant-calendar-input-lg,
.ant-calendar-range .ant-calendar-time-picker-input-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-calendar-range .ant-calendar-input-sm,
.ant-calendar-range .ant-calendar-time-picker-input-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-calendar-range .ant-calendar-input:focus,
.ant-calendar-range .ant-calendar-time-picker-input:focus {
  box-shadow: none;
}
.ant-calendar-range .ant-calendar-time-picker-icon {
  display: none;
}
.ant-calendar-range.ant-calendar-week-number {
  width: 574px;
}
.ant-calendar-range.ant-calendar-week-number .ant-calendar-range-part {
  width: 286px;
}
.ant-calendar-range .ant-calendar-year-panel,
.ant-calendar-range .ant-calendar-month-panel,
.ant-calendar-range .ant-calendar-decade-panel {
  top: 34px;
}
.ant-calendar-range .ant-calendar-month-panel .ant-calendar-year-panel {
  top: 0;
}
.ant-calendar-range .ant-calendar-decade-panel-table,
.ant-calendar-range .ant-calendar-year-panel-table,
.ant-calendar-range .ant-calendar-month-panel-table {
  height: 208px;
}
.ant-calendar-range .ant-calendar-in-range-cell {
  position: relative;
  border-radius: 0;
}
.ant-calendar-range .ant-calendar-in-range-cell > div {
  position: relative;
  z-index: 1;
}
.ant-calendar-range .ant-calendar-in-range-cell::before {
  position: absolute;
  top: 4px;
  right: 0;
  bottom: 4px;
  left: 0;
  display: block;
  background: #f0fdff;
  border: 0;
  border-radius: 0;
  content: '';
}
.ant-calendar-range .ant-calendar-footer-extra {
  float: left;
}
div.ant-calendar-range-quick-selector {
  text-align: left;
}
div.ant-calendar-range-quick-selector > a {
  margin-right: 8px;
}
.ant-calendar-range .ant-calendar-header,
.ant-calendar-range .ant-calendar-month-panel-header,
.ant-calendar-range .ant-calendar-year-panel-header,
.ant-calendar-range .ant-calendar-decade-panel-header {
  border-bottom: 0;
}
.ant-calendar-range .ant-calendar-body,
.ant-calendar-range .ant-calendar-month-panel-body,
.ant-calendar-range .ant-calendar-year-panel-body,
.ant-calendar-range .ant-calendar-decade-panel-body {
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker {
  top: 68px;
  z-index: 2;
  width: 100%;
  height: 207px;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-panel {
  height: 267px;
  margin-top: -34px;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-inner {
  height: 100%;
  padding-top: 40px;
  background: none;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-combobox {
  display: inline-block;
  height: 100%;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select {
  height: 100%;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select ul {
  max-height: 100%;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {
  margin-right: 8px;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-today-btn {
  height: 22px;
  margin: 8px 12px;
  line-height: 22px;
}
.ant-calendar-range-with-ranges.ant-calendar-time .ant-calendar-time-picker {
  height: 233px;
}
.ant-calendar-range.ant-calendar-show-time-picker .ant-calendar-body {
  border-top-color: transparent;
}
.ant-calendar-time-picker {
  position: absolute;
  top: 40px;
  width: 100%;
  background-color: #fff;
}
.ant-calendar-time-picker-panel {
  position: absolute;
  z-index: 1050;
  width: 100%;
}
.ant-calendar-time-picker-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  outline: none;
}
.ant-calendar-time-picker-combobox {
  width: 100%;
}
.ant-calendar-time-picker-column-1,
.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {
  width: 100%;
}
.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {
  width: 50%;
}
.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {
  width: 33.33%;
}
.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {
  width: 25%;
}
.ant-calendar-time-picker-input-wrap {
  display: none;
}
.ant-calendar-time-picker-select {
  position: relative;
  float: left;
  height: 226px;
  overflow: hidden;
  font-size: 14px;
  border-right: 1px solid #e8e8e8;
}
.ant-calendar-time-picker-select:hover {
  overflow-y: auto;
}
.ant-calendar-time-picker-select:first-child {
  margin-left: 0;
  border-left: 0;
}
.ant-calendar-time-picker-select:last-child {
  border-right: 0;
}
.ant-calendar-time-picker-select ul {
  width: 100%;
  max-height: 206px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-calendar-time-picker-select li {
  width: 100%;
  height: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  list-style: none;
  cursor: pointer;
  transition: all .3s;
  user-select: none;
}
.ant-calendar-time-picker-select li:last-child::after {
  display: block;
  height: 202px;
  content: '';
}
.ant-calendar-time-picker-select li:hover {
  background: #f0fdff;
}
.ant-calendar-time-picker-select li:focus {
  color: #2EB1EF;
  font-weight: 600;
  outline: none;
}
li.ant-calendar-time-picker-select-option-selected {
  font-weight: 600;
  background: #f5f5f5;
}
li.ant-calendar-time-picker-select-option-disabled {
  color: rgba(0, 0, 0, 0.25);
}
li.ant-calendar-time-picker-select-option-disabled:hover {
  background: transparent;
  cursor: not-allowed;
}
.ant-calendar-time .ant-calendar-day-select {
  display: inline-block;
  padding: 0 2px;
  color: #535353;
  font-weight: 500;
  line-height: 34px;
}
.ant-calendar-time .ant-calendar-footer {
  position: relative;
  height: auto;
}
.ant-calendar-time .ant-calendar-footer-btn {
  text-align: right;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {
  float: left;
  margin: 0;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {
  display: inline-block;
  margin-right: 8px;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-month-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  border-radius: 6px;
  outline: none;
}
.ant-calendar-month-panel > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ant-calendar-month-panel-hidden {
  display: none;
}
.ant-calendar-month-panel-header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  user-select: none;
  position: relative;
}
.ant-calendar-month-panel-header a:hover {
  color: #58cefc;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {
  display: inline-block;
  padding: 0 2px;
  color: #535353;
  font-weight: 500;
  line-height: 40px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {
  position: absolute;
  top: 0;
  display: inline-block;
  padding: 0 5px;
  color: #595959;
  font-size: 16px;
  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;
  line-height: 40px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {
  left: 7px;
  height: 100%;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {
  position: relative;
  left: -3px;
  display: inline-block;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {
  right: 7px;
  height: 100%;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before {
  position: relative;
  left: 3px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {
  display: inline-block;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {
  left: 29px;
  height: 100%;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {
  right: 29px;
  height: 100%;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-month-panel-body {
  flex: 1;
}
.ant-calendar-month-panel-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-month-panel-footer .ant-calendar-footer-extra {
  padding: 0 12px;
}
.ant-calendar-month-panel-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-month-panel-cell {
  text-align: center;
}
.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,
.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  cursor: not-allowed;
}
.ant-calendar-month-panel-month {
  display: inline-block;
  height: 24px;
  margin: 0 auto;
  padding: 0 8px;
  color: #545454;
  line-height: 24px;
  text-align: center;
  background: transparent;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-month-panel-month:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-calendar-year-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  border-radius: 6px;
  outline: none;
}
.ant-calendar-year-panel > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ant-calendar-year-panel-hidden {
  display: none;
}
.ant-calendar-year-panel-header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  user-select: none;
  position: relative;
}
.ant-calendar-year-panel-header a:hover {
  color: #58cefc;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {
  display: inline-block;
  padding: 0 2px;
  color: #535353;
  font-weight: 500;
  line-height: 40px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {
  position: absolute;
  top: 0;
  display: inline-block;
  padding: 0 5px;
  color: #595959;
  font-size: 16px;
  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;
  line-height: 40px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {
  left: 7px;
  height: 100%;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {
  position: relative;
  left: -3px;
  display: inline-block;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {
  right: 7px;
  height: 100%;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before {
  position: relative;
  left: 3px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {
  display: inline-block;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {
  left: 29px;
  height: 100%;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {
  right: 29px;
  height: 100%;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-year-panel-body {
  flex: 1;
}
.ant-calendar-year-panel-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-year-panel-footer .ant-calendar-footer-extra {
  padding: 0 12px;
}
.ant-calendar-year-panel-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.ant-calendar-year-panel-cell {
  text-align: center;
}
.ant-calendar-year-panel-year {
  display: inline-block;
  height: 24px;
  margin: 0 auto;
  padding: 0 8px;
  color: #545454;
  line-height: 24px;
  text-align: center;
  background: transparent;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-year-panel-year:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,
.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {
  color: rgba(0, 0, 0, 0.25);
  user-select: none;
}
.ant-calendar-decade-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  outline: none;
}
.ant-calendar-decade-panel-hidden {
  display: none;
}
.ant-calendar-decade-panel-header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  user-select: none;
  position: relative;
}
.ant-calendar-decade-panel-header a:hover {
  color: #58cefc;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {
  display: inline-block;
  padding: 0 2px;
  color: #535353;
  font-weight: 500;
  line-height: 40px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
  position: absolute;
  top: 0;
  display: inline-block;
  padding: 0 5px;
  color: #595959;
  font-size: 16px;
  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;
  line-height: 40px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {
  left: 7px;
  height: 100%;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {
  position: relative;
  left: -3px;
  display: inline-block;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
  right: 7px;
  height: 100%;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before {
  position: relative;
  left: 3px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {
  display: inline-block;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {
  left: 29px;
  height: 100%;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {
  right: 29px;
  height: 100%;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border: 0 solid #aaa;
  border-width: 1.5px 0 0 1.5px;
  border-radius: 1px;
  transform: rotate(-45deg) scale(0.8);
  transition: all 0.3s;
  content: '';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::after {
  border-color: #545454;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {
  transform: rotate(135deg) scale(0.8);
}
.ant-calendar-decade-panel-body {
  flex: 1;
}
.ant-calendar-decade-panel-footer {
  border-top: 1px solid #e8e8e8;
}
.ant-calendar-decade-panel-footer .ant-calendar-footer-extra {
  padding: 0 12px;
}
.ant-calendar-decade-panel-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.ant-calendar-decade-panel-cell {
  white-space: nowrap;
  text-align: center;
}
.ant-calendar-decade-panel-decade {
  display: inline-block;
  height: 24px;
  margin: 0 auto;
  padding: 0 6px;
  color: #545454;
  line-height: 24px;
  text-align: center;
  background: transparent;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-decade-panel-decade:hover {
  background: #f0fdff;
  cursor: pointer;
}
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {
  color: #fff;
  background: #2EB1EF;
}
.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,
.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {
  color: rgba(0, 0, 0, 0.25);
  user-select: none;
}
.ant-calendar-month .ant-calendar-month-header-wrap {
  position: relative;
  height: 288px;
}
.ant-calendar-month .ant-calendar-month-panel,
.ant-calendar-month .ant-calendar-year-panel {
  top: 0;
  height: 100%;
}
.ant-calendar-week-number-cell {
  opacity: 0.5;
}
.ant-calendar-week-number .ant-calendar-body tr {
  cursor: pointer;
  transition: all 0.3s;
}
.ant-calendar-week-number .ant-calendar-body tr:hover {
  background: #f0fdff;
}
.ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {
  font-weight: bold;
  background: #d4f7ff;
}
.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day .ant-calendar-date,
.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day:hover .ant-calendar-date {
  color: #545454;
  background: transparent;
}
.ant-descriptions-title {
  margin-bottom: 20px;
  color: #535353;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.3;
}
.ant-descriptions-view {
  width: 100%;
  overflow: hidden;
  border-radius: 6px;
}
.ant-descriptions-view table {
  width: 100%;
  table-layout: fixed;
}
.ant-descriptions-row > th,
.ant-descriptions-row > td {
  padding-bottom: 16px;
}
.ant-descriptions-row:last-child {
  border-bottom: none;
}
.ant-descriptions-item-label {
  color: #535353;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.3;
}
.ant-descriptions-item-label::after {
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
  content: ' ';
}
.ant-descriptions-item-colon::after {
  content: ':';
}
.ant-descriptions-item-no-label::after {
  margin: 0;
  content: '';
}
.ant-descriptions-item-content {
  display: table-cell;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
}
.ant-descriptions-item {
  padding-bottom: 0;
}
.ant-descriptions-item > span {
  display: inline-block;
}
.ant-descriptions-middle .ant-descriptions-row > th,
.ant-descriptions-middle .ant-descriptions-row > td {
  padding-bottom: 12px;
}
.ant-descriptions-small .ant-descriptions-row > th,
.ant-descriptions-small .ant-descriptions-row > td {
  padding-bottom: 8px;
}
.ant-descriptions-bordered .ant-descriptions-view {
  border: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-view > table {
  table-layout: auto;
}
.ant-descriptions-bordered .ant-descriptions-item-label,
.ant-descriptions-bordered .ant-descriptions-item-content {
  padding: 16px 24px;
  border-right: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-item-label:last-child,
.ant-descriptions-bordered .ant-descriptions-item-content:last-child {
  border-right: none;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fafafa;
}
.ant-descriptions-bordered .ant-descriptions-item-label::after {
  display: none;
}
.ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #e8e8e8;
}
.ant-descriptions-bordered .ant-descriptions-row:last-child {
  border-bottom: none;
}
.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label,
.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content {
  padding: 12px 24px;
}
.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label,
.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content {
  padding: 8px 16px;
}
.ant-divider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  background: #e8e8e8;
}
.ant-divider,
.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  width: 1px;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
}
.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 24px 0;
}
.ant-divider-horizontal.ant-divider-with-text-center,
.ant-divider-horizontal.ant-divider-with-text-left,
.ant-divider-horizontal.ant-divider-with-text-right {
  display: table;
  margin: 16px 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-align: center;
  background: transparent;
}
.ant-divider-horizontal.ant-divider-with-text-center::before,
.ant-divider-horizontal.ant-divider-with-text-left::before,
.ant-divider-horizontal.ant-divider-with-text-right::before,
.ant-divider-horizontal.ant-divider-with-text-center::after,
.ant-divider-horizontal.ant-divider-with-text-left::after,
.ant-divider-horizontal.ant-divider-with-text-right::after {
  position: relative;
  top: 50%;
  display: table-cell;
  width: 50%;
  border-top: 1px solid #e8e8e8;
  transform: translateY(50%);
  content: '';
}
.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text,
.ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text {
  display: inline-block;
  padding: 0 10px;
}
.ant-divider-horizontal.ant-divider-with-text-left::before {
  top: 50%;
  width: 5%;
}
.ant-divider-horizontal.ant-divider-with-text-left::after {
  top: 50%;
  width: 95%;
}
.ant-divider-horizontal.ant-divider-with-text-right::before {
  top: 50%;
  width: 95%;
}
.ant-divider-horizontal.ant-divider-with-text-right::after {
  top: 50%;
  width: 5%;
}
.ant-divider-inner-text {
  display: inline-block;
  padding: 0 24px;
}
.ant-divider-dashed {
  background: none;
  border-color: #e8e8e8;
  border-style: dashed;
  border-width: 1px 0 0;
}
.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed,
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed {
  border-top: 0;
}
.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed::before,
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed::before,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed::before,
.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed::after,
.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed::after,
.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed::after {
  border-style: dashed none none;
}
.ant-divider-vertical.ant-divider-dashed {
  border-width: 0 0 0 1px;
}
.ant-drawer {
  position: fixed;
  z-index: 1000;
  width: 0%;
  height: 100%;
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1), height 0s ease 0.3s, width 0s ease 0.3s;
}
.ant-drawer > * {
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1), box-shadow 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}
.ant-drawer-content-wrapper {
  position: absolute;
}
.ant-drawer .ant-drawer-content {
  width: 100%;
  height: 100%;
}
.ant-drawer-left,
.ant-drawer-right {
  top: 0;
  width: 0%;
  height: 100%;
}
.ant-drawer-left .ant-drawer-content-wrapper,
.ant-drawer-right .ant-drawer-content-wrapper {
  height: 100%;
}
.ant-drawer-left.ant-drawer-open,
.ant-drawer-right.ant-drawer-open {
  width: 100%;
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}
.ant-drawer-left.ant-drawer-open.no-mask,
.ant-drawer-right.ant-drawer-open.no-mask {
  width: 0%;
}
.ant-drawer-left.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
}
.ant-drawer-right {
  right: 0;
}
.ant-drawer-right .ant-drawer-content-wrapper {
  right: 0;
}
.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.ant-drawer-right.ant-drawer-open.no-mask {
  right: 1px;
  transform: translateX(1px);
}
.ant-drawer-top,
.ant-drawer-bottom {
  left: 0;
  width: 100%;
  height: 0%;
}
.ant-drawer-top .ant-drawer-content-wrapper,
.ant-drawer-bottom .ant-drawer-content-wrapper {
  width: 100%;
}
.ant-drawer-top.ant-drawer-open,
.ant-drawer-bottom.ant-drawer-open {
  height: 100%;
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}
.ant-drawer-top.ant-drawer-open.no-mask,
.ant-drawer-bottom.ant-drawer-open.no-mask {
  height: 0%;
}
.ant-drawer-top {
  top: 0;
}
.ant-drawer-top.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-drawer-bottom {
  bottom: 0;
}
.ant-drawer-bottom .ant-drawer-content-wrapper {
  bottom: 0;
}
.ant-drawer-bottom.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
}
.ant-drawer-bottom.ant-drawer-open.no-mask {
  bottom: 1px;
  transform: translateY(1px);
}
.ant-drawer.ant-drawer-open .ant-drawer-mask {
  height: 100%;
  opacity: 1;
  transition: none;
  animation: antdDrawerFadeIn 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}
.ant-drawer-title {
  margin: 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.ant-drawer-content {
  position: relative;
  z-index: 1;
  overflow: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
}
.ant-drawer-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  display: block;
  width: 56px;
  height: 56px;
  padding: 0;
  color: #595959;
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
  line-height: 56px;
  text-align: center;
  text-transform: none;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  text-rendering: auto;
}
.ant-drawer-close:focus,
.ant-drawer-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}
.ant-drawer-header {
  position: relative;
  padding: 16px 24px;
  color: #545454;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-drawer-header-no-title {
  color: #545454;
  background: #fff;
}
.ant-drawer-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.3;
  word-wrap: break-word;
}
.ant-drawer-wrapper-body {
  height: 100%;
  overflow: auto;
}
.ant-drawer-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: rgba(0, 0, 0, 0.45);
  opacity: 0;
  filter: alpha(opacity=45);
  transition: opacity 0.3s linear, height 0s ease 0.3s;
}
.ant-drawer-open-content {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
@keyframes antdDrawerFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.ant-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  display: block;
}
.ant-dropdown::before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: -7px;
  left: -7px;
  z-index: -9999;
  opacity: 0.0001;
  content: ' ';
}
.ant-dropdown-wrap {
  position: relative;
}
.ant-dropdown-wrap .ant-btn > .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
:root .ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 12px;
}
.ant-dropdown-wrap .anticon-down::before {
  transition: transform 0.2s;
}
.ant-dropdown-wrap-open .anticon-down::before {
  transform: rotate(180deg);
}
.ant-dropdown-hidden,
.ant-dropdown-menu-hidden {
  display: none;
}
.ant-dropdown-menu {
  position: relative;
  margin: 0;
  padding: 4px 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  -webkit-transform: translate3d(0, 0, 0);
}
.ant-dropdown-menu-item-group-title {
  padding: 5px 12px;
  color: #595959;
  transition: all 0.3s;
}
.ant-dropdown-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
}
.ant-dropdown-menu-submenu-popup > .ant-dropdown-menu {
  transform-origin: 0 0;
}
.ant-dropdown-menu-submenu-popup ul,
.ant-dropdown-menu-submenu-popup li {
  list-style: none;
}
.ant-dropdown-menu-submenu-popup ul {
  margin-right: 0.3em;
  margin-left: 0.3em;
  padding: 0;
}
.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
  clear: both;
  margin: 0;
  padding: 5px 12px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-dropdown-menu-item > .anticon:first-child,
.ant-dropdown-menu-submenu-title > .anticon:first-child,
.ant-dropdown-menu-item > span > .anticon:first-child,
.ant-dropdown-menu-submenu-title > span > .anticon:first-child {
  min-width: 12px;
  margin-right: 8px;
  font-size: 12px;
}
.ant-dropdown-menu-item > a,
.ant-dropdown-menu-submenu-title > a {
  display: block;
  margin: -5px -12px;
  padding: 5px 12px;
  color: #545454;
  transition: all 0.3s;
}
.ant-dropdown-menu-item-selected,
.ant-dropdown-menu-submenu-title-selected,
.ant-dropdown-menu-item-selected > a,
.ant-dropdown-menu-submenu-title-selected > a {
  color: #2EB1EF;
  background-color: #f0fdff;
}
.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background-color: #f0fdff;
}
.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-dropdown-menu-item-divider,
.ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  margin: 4px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow {
  position: absolute;
  right: 8px;
}
.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,
.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  color: #595959;
  font-style: normal;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
:root .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,
:root .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  font-size: 12px;
}
.ant-dropdown-menu-item-group-list {
  margin: 0 8px;
  padding: 0;
  list-style: none;
}
.ant-dropdown-menu-submenu-title {
  padding-right: 26px;
}
.ant-dropdown-menu-submenu-vertical {
  position: relative;
}
.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {
  color: #2EB1EF;
}
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-dropdown-trigger > .anticon.anticon-down,
.ant-dropdown-link > .anticon.anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
:root .ant-dropdown-trigger > .anticon.anticon-down,
:root .ant-dropdown-link > .anticon.anticon-down {
  font-size: 12px;
}
.ant-dropdown-button {
  white-space: nowrap;
}
.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-dropdown-button .anticon.anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
:root .ant-dropdown-button .anticon.anticon-down {
  font-size: 12px;
}
.ant-dropdown-menu-dark,
.ant-dropdown-menu-dark .ant-dropdown-menu {
  background: #003366;
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {
  color: rgba(255, 255, 255, 0.65);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow::after,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow::after {
  color: rgba(255, 255, 255, 0.65);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {
  color: #fff;
  background: transparent;
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  color: #fff;
  background: #2EB1EF;
}
.ant-empty {
  margin: 0 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}
.ant-empty-image {
  height: 100px;
  margin-bottom: 8px;
}
.ant-empty-image img {
  height: 100%;
}
.ant-empty-image svg {
  height: 100%;
  margin: auto;
}
.ant-empty-description {
  margin: 0;
}
.ant-empty-footer {
  margin-top: 16px;
}
.ant-empty-normal {
  margin: 32px 0;
  color: rgba(0, 0, 0, 0.25);
}
.ant-empty-normal .ant-empty-image {
  height: 40px;
}
.ant-empty-small {
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.25);
}
.ant-empty-small .ant-empty-image {
  height: 35px;
}
.ant-form {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-form legend {
  display: block;
  width: 100%;
  margin-bottom: 20px;
  padding: 0;
  color: #595959;
  font-size: 16px;
  line-height: inherit;
  border: 0;
  border-bottom: 1px solid #d9d9d9;
}
.ant-form label {
  font-size: 14px;
}
.ant-form input[type='search'] {
  box-sizing: border-box;
}
.ant-form input[type='radio'],
.ant-form input[type='checkbox'] {
  line-height: normal;
}
.ant-form input[type='file'] {
  display: block;
}
.ant-form input[type='range'] {
  display: block;
  width: 100%;
}
.ant-form select[multiple],
.ant-form select[size] {
  height: auto;
}
.ant-form input[type='file']:focus,
.ant-form input[type='radio']:focus,
.ant-form input[type='checkbox']:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.ant-form output {
  display: block;
  padding-top: 15px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
}
.ant-form-item-required::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.ant-form-hide-required-mark .ant-form-item-required::before {
  display: none;
}
.ant-form-item-label > label {
  color: #535353;
}
.ant-form-item-label > label::after {
  content: ':';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}
.ant-form-item-label > label.ant-form-item-no-colon::after {
  content: ' ';
}
.ant-form-item {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  margin-bottom: 20px;
  vertical-align: top;
}
.ant-form-item label {
  position: relative;
}
.ant-form-item label > .anticon {
  font-size: 14px;
  vertical-align: top;
}
.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}
.ant-form-item-control::before,
.ant-form-item-control::after {
  display: table;
  content: '';
}
.ant-form-item-control::after {
  clear: both;
}
.ant-form-item-control::before,
.ant-form-item-control::after {
  display: table;
  content: '';
}
.ant-form-item-control::after {
  clear: both;
}
.ant-form-item-children {
  position: relative;
}
.ant-form-item-with-help {
  margin-bottom: 2px;
}
.ant-form-item-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}
.ant-form-item-label-left {
  text-align: left;
}
.ant-form-item .ant-switch {
  margin: 2px 0 4px;
}
.ant-form-explain,
.ant-form-extra {
  clear: both;
  min-height: 19px;
  margin-top: 0px;
  color: #595959;
  font-size: 14px;
  line-height: 1.3;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.ant-form-explain {
  margin-bottom: -1px;
}
.ant-form-extra {
  padding-top: 4px;
}
.ant-form-text {
  display: inline-block;
  padding-right: 8px;
}
.ant-form-split {
  display: block;
  text-align: center;
}
form .has-feedback .ant-input {
  padding-right: 30px;
}
form .has-feedback .ant-input-affix-wrapper .ant-input-suffix {
  padding-right: 18px;
}
form .has-feedback .ant-input-affix-wrapper .ant-input {
  padding-right: 49px;
}
form .has-feedback .ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input {
  padding-right: 68px;
}
form .has-feedback > .ant-select .ant-select-arrow,
form .has-feedback > .ant-select .ant-select-selection__clear,
form .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,
form .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection__clear {
  right: 30px;
}
form .has-feedback > .ant-select .ant-select-selection-selected-value,
form .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {
  padding-right: 42px;
}
form .has-feedback .ant-cascader-picker-arrow {
  margin-right: 19px;
}
form .has-feedback .ant-cascader-picker-clear {
  right: 30px;
}
form .has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {
  right: 30px;
}
form .has-feedback .ant-calendar-picker-icon,
form .has-feedback .ant-time-picker-icon,
form .has-feedback .ant-calendar-picker-clear,
form .has-feedback .ant-time-picker-clear {
  right: 30px;
}
form .ant-mentions,
form textarea.ant-input {
  height: auto;
  margin-bottom: 4px;
}
form .ant-upload {
  background: transparent;
}
form input[type='radio'],
form input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
form .ant-radio-inline,
form .ant-checkbox-inline {
  display: inline-block;
  margin-left: 8px;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
form .ant-radio-inline:first-child,
form .ant-checkbox-inline:first-child {
  margin-left: 0;
}
form .ant-checkbox-vertical,
form .ant-radio-vertical {
  display: block;
}
form .ant-checkbox-vertical + .ant-checkbox-vertical,
form .ant-radio-vertical + .ant-radio-vertical {
  margin-left: 0;
}
form .ant-input-number + .ant-form-text {
  margin-left: 8px;
}
form .ant-input-number-handler-wrap {
  z-index: 2;
}
form .ant-select,
form .ant-cascader-picker {
  width: 100%;
}
form .ant-input-group .ant-select,
form .ant-input-group .ant-cascader-picker {
  width: auto;
}
form :not(.ant-input-group-wrapper) > .ant-input-group,
form .ant-input-group-wrapper {
  display: inline-block;
  vertical-align: middle;
}
form:not(.ant-form-vertical) :not(.ant-input-group-wrapper) > .ant-input-group,
form:not(.ant-form-vertical) .ant-input-group-wrapper {
  position: relative;
  top: -1px;
}
.ant-form-vertical .ant-form-item-label,
.ant-col-24.ant-form-item-label,
.ant-col-xl-24.ant-form-item-label {
  display: block;
  margin: 0;
  padding: 0 0 8px;
  line-height: 1.3;
  white-space: initial;
  text-align: left;
}
.ant-form-vertical .ant-form-item-label label::after,
.ant-col-24.ant-form-item-label label::after,
.ant-col-xl-24.ant-form-item-label label::after {
  display: none;
}
.ant-form-vertical .ant-form-item {
  padding-bottom: 8px;
}
.ant-form-vertical .ant-form-item-control {
  line-height: 1.3;
}
.ant-form-vertical .ant-form-explain {
  margin-top: 2px;
  margin-bottom: -5px;
}
.ant-form-vertical .ant-form-extra {
  margin-top: 2px;
  margin-bottom: -4px;
}
@media (max-width: 575px) {
  .ant-form-item-label,
  .ant-form-item-control-wrapper {
    display: block;
    width: 100%;
  }
  .ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-form-item-label label::after {
    display: none;
  }
  .ant-col-xs-24.ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-xs-24.ant-form-item-label label::after {
    display: none;
  }
}
@media (max-width: 767px) {
  .ant-col-sm-24.ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-sm-24.ant-form-item-label label::after {
    display: none;
  }
}
@media (max-width: 991px) {
  .ant-col-md-24.ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-md-24.ant-form-item-label label::after {
    display: none;
  }
}
@media (max-width: 1199px) {
  .ant-col-lg-24.ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-lg-24.ant-form-item-label label::after {
    display: none;
  }
}
@media (max-width: 1599px) {
  .ant-col-xl-24.ant-form-item-label {
    display: block;
    margin: 0;
    padding: 0 0 8px;
    line-height: 1.3;
    white-space: initial;
    text-align: left;
  }
  .ant-col-xl-24.ant-form-item-label label::after {
    display: none;
  }
}
.ant-form-inline .ant-form-item {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 0;
}
.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 20px;
}
.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper,
.ant-form-inline .ant-form-item > .ant-form-item-label {
  display: inline-block;
  vertical-align: top;
}
.ant-form-inline .ant-form-text {
  display: inline-block;
}
.ant-form-inline .has-feedback {
  display: inline-block;
}
.has-success.has-feedback .ant-form-item-children-icon,
.has-warning.has-feedback .ant-form-item-children-icon,
.has-error.has-feedback .ant-form-item-children-icon,
.is-validating.has-feedback .ant-form-item-children-icon {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 1;
  width: 36px;
  height: 20px;
  margin-top: -10px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  visibility: visible;
  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  pointer-events: none;
}
.has-success.has-feedback .ant-form-item-children-icon svg,
.has-warning.has-feedback .ant-form-item-children-icon svg,
.has-error.has-feedback .ant-form-item-children-icon svg,
.is-validating.has-feedback .ant-form-item-children-icon svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.has-success.has-feedback .ant-form-item-children-icon {
  color: #52c41a;
  animation-name: diffZoomIn1 !important;
}
.has-warning .ant-form-explain,
.has-warning .ant-form-split {
  color: #fa8c16;
}
.has-warning .ant-input,
.has-warning .ant-input:hover {
  background-color: #fff;
  border-color: #fa8c16;
}
.has-warning .ant-input:focus {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-input:not([disabled]):hover {
  border-color: #fa8c16;
}
.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-input-affix-wrapper .ant-input,
.has-warning .ant-input-affix-wrapper .ant-input:hover {
  background-color: #fff;
  border-color: #fa8c16;
}
.has-warning .ant-input-affix-wrapper .ant-input:focus {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #fa8c16;
}
.has-warning .ant-input-prefix {
  color: #fa8c16;
}
.has-warning .ant-input-group-addon {
  color: #fa8c16;
  background-color: #fff;
  border-color: #fa8c16;
}
.has-warning .has-feedback {
  color: #fa8c16;
}
.has-warning.has-feedback .ant-form-item-children-icon {
  color: #fa8c16;
  animation-name: diffZoomIn3 !important;
}
.has-warning .ant-select-selection {
  border-color: #fa8c16;
}
.has-warning .ant-select-selection:hover {
  border-color: #fa8c16;
}
.has-warning .ant-select-open .ant-select-selection,
.has-warning .ant-select-focused .ant-select-selection {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-calendar-picker-icon::after,
.has-warning .ant-time-picker-icon::after,
.has-warning .ant-picker-icon::after,
.has-warning .ant-select-arrow,
.has-warning .ant-cascader-picker-arrow {
  color: #fa8c16;
}
.has-warning .ant-input-number,
.has-warning .ant-time-picker-input {
  border-color: #fa8c16;
}
.has-warning .ant-input-number-focused,
.has-warning .ant-time-picker-input-focused,
.has-warning .ant-input-number:focus,
.has-warning .ant-time-picker-input:focus {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-input-number:not([disabled]):hover,
.has-warning .ant-time-picker-input:not([disabled]):hover {
  border-color: #fa8c16;
}
.has-warning .ant-cascader-picker:focus .ant-cascader-input {
  border-color: #ffa940;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.has-warning .ant-cascader-picker:hover .ant-cascader-input {
  border-color: #fa8c16;
}
.has-error .ant-form-explain,
.has-error .ant-form-split {
  color: #f5222d;
}
.has-error .ant-input,
.has-error .ant-input:hover {
  background-color: #fff;
  border-color: #f5222d;
}
.has-error .ant-input:focus {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-input:not([disabled]):hover {
  border-color: #f5222d;
}
.has-error .ant-calendar-picker-open .ant-calendar-picker-input {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-input-affix-wrapper .ant-input,
.has-error .ant-input-affix-wrapper .ant-input:hover {
  background-color: #fff;
  border-color: #f5222d;
}
.has-error .ant-input-affix-wrapper .ant-input:focus {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #f5222d;
}
.has-error .ant-input-prefix {
  color: #f5222d;
}
.has-error .ant-input-group-addon {
  color: #f5222d;
  background-color: #fff;
  border-color: #f5222d;
}
.has-error .has-feedback {
  color: #f5222d;
}
.has-error.has-feedback .ant-form-item-children-icon {
  color: #f5222d;
  animation-name: diffZoomIn2 !important;
}
.has-error .ant-select-selection {
  border-color: #f5222d;
}
.has-error .ant-select-selection:hover {
  border-color: #f5222d;
}
.has-error .ant-select-open .ant-select-selection,
.has-error .ant-select-focused .ant-select-selection {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-select.ant-select-auto-complete .ant-input:focus {
  border-color: #f5222d;
}
.has-error .ant-input-group-addon .ant-select-selection {
  border-color: transparent;
  box-shadow: none;
}
.has-error .ant-calendar-picker-icon::after,
.has-error .ant-time-picker-icon::after,
.has-error .ant-picker-icon::after,
.has-error .ant-select-arrow,
.has-error .ant-cascader-picker-arrow {
  color: #f5222d;
}
.has-error .ant-input-number,
.has-error .ant-time-picker-input {
  border-color: #f5222d;
}
.has-error .ant-input-number-focused,
.has-error .ant-time-picker-input-focused,
.has-error .ant-input-number:focus,
.has-error .ant-time-picker-input:focus {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-input-number:not([disabled]):hover,
.has-error .ant-time-picker-input:not([disabled]):hover {
  border-color: #f5222d;
}
.has-error .ant-mention-wrapper .ant-mention-editor,
.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover {
  border-color: #f5222d;
}
.has-error .ant-mention-wrapper.ant-mention-active:not([disabled]) .ant-mention-editor,
.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-cascader-picker:focus .ant-cascader-input {
  border-color: #ff4d4f;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
}
.has-error .ant-cascader-picker:hover .ant-cascader-input {
  border-color: #f5222d;
}
.has-error .ant-transfer-list {
  border-color: #f5222d;
}
.has-error .ant-transfer-list-search:not([disabled]) {
  border-color: #d9d9d9;
}
.has-error .ant-transfer-list-search:not([disabled]):hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.has-error .ant-transfer-list-search:not([disabled]):focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.is-validating.has-feedback .ant-form-item-children-icon {
  display: inline-block;
  color: #2EB1EF;
}
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 20px;
}
.ant-advanced-search-form .ant-form-item-with-help {
  margin-bottom: 2px;
}
.show-help-enter,
.show-help-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.show-help-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.show-help-enter.show-help-enter-active,
.show-help-appear.show-help-appear-active {
  animation-name: antShowHelpIn;
  animation-play-state: running;
}
.show-help-leave.show-help-leave-active {
  animation-name: antShowHelpOut;
  animation-play-state: running;
  pointer-events: none;
}
.show-help-enter,
.show-help-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}
.show-help-leave {
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}
@keyframes antShowHelpIn {
  0% {
    transform: translateY(-5px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes antShowHelpOut {
  to {
    transform: translateY(-5px);
    opacity: 0;
  }
}
@keyframes diffZoomIn1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes diffZoomIn2 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes diffZoomIn3 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.ant-row {
  position: relative;
  height: auto;
  margin-right: -16px;
  margin-left: -16px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
}
.ant-row::before,
.ant-row::after {
  display: table;
  content: '';
}
.ant-row::after {
  clear: both;
}
.ant-row::before,
.ant-row::after {
  display: table;
  content: '';
}
.ant-row::after {
  clear: both;
}
.ant-row + .ant-row::before {
  clear: both;
}
.ant-row-flex {
  display: flex;
  flex-flow: row wrap;
}
.ant-row-flex::before,
.ant-row-flex::after {
  display: flex;
}
.ant-row-flex-start {
  justify-content: flex-start;
}
.ant-row-flex-center {
  justify-content: center;
}
.ant-row-flex-end {
  justify-content: flex-end;
}
.ant-row-flex-space-between {
  justify-content: space-between;
}
.ant-row-flex-space-around {
  justify-content: space-around;
}
.ant-row-flex-top {
  align-items: flex-start;
}
.ant-row-flex-middle {
  align-items: center;
}
.ant-row-flex-bottom {
  align-items: flex-end;
}
.ant-col {
  position: relative;
  min-height: 1px;
}
.ant-col-1, .ant-col-xs-1, .ant-col-sm-1, .ant-col-md-1, .ant-col-lg-1, .ant-col-2, .ant-col-xs-2, .ant-col-sm-2, .ant-col-md-2, .ant-col-lg-2, .ant-col-3, .ant-col-xs-3, .ant-col-sm-3, .ant-col-md-3, .ant-col-lg-3, .ant-col-4, .ant-col-xs-4, .ant-col-sm-4, .ant-col-md-4, .ant-col-lg-4, .ant-col-5, .ant-col-xs-5, .ant-col-sm-5, .ant-col-md-5, .ant-col-lg-5, .ant-col-6, .ant-col-xs-6, .ant-col-sm-6, .ant-col-md-6, .ant-col-lg-6, .ant-col-7, .ant-col-xs-7, .ant-col-sm-7, .ant-col-md-7, .ant-col-lg-7, .ant-col-8, .ant-col-xs-8, .ant-col-sm-8, .ant-col-md-8, .ant-col-lg-8, .ant-col-9, .ant-col-xs-9, .ant-col-sm-9, .ant-col-md-9, .ant-col-lg-9, .ant-col-10, .ant-col-xs-10, .ant-col-sm-10, .ant-col-md-10, .ant-col-lg-10, .ant-col-11, .ant-col-xs-11, .ant-col-sm-11, .ant-col-md-11, .ant-col-lg-11, .ant-col-12, .ant-col-xs-12, .ant-col-sm-12, .ant-col-md-12, .ant-col-lg-12, .ant-col-13, .ant-col-xs-13, .ant-col-sm-13, .ant-col-md-13, .ant-col-lg-13, .ant-col-14, .ant-col-xs-14, .ant-col-sm-14, .ant-col-md-14, .ant-col-lg-14, .ant-col-15, .ant-col-xs-15, .ant-col-sm-15, .ant-col-md-15, .ant-col-lg-15, .ant-col-16, .ant-col-xs-16, .ant-col-sm-16, .ant-col-md-16, .ant-col-lg-16, .ant-col-17, .ant-col-xs-17, .ant-col-sm-17, .ant-col-md-17, .ant-col-lg-17, .ant-col-18, .ant-col-xs-18, .ant-col-sm-18, .ant-col-md-18, .ant-col-lg-18, .ant-col-19, .ant-col-xs-19, .ant-col-sm-19, .ant-col-md-19, .ant-col-lg-19, .ant-col-20, .ant-col-xs-20, .ant-col-sm-20, .ant-col-md-20, .ant-col-lg-20, .ant-col-21, .ant-col-xs-21, .ant-col-sm-21, .ant-col-md-21, .ant-col-lg-21, .ant-col-22, .ant-col-xs-22, .ant-col-sm-22, .ant-col-md-22, .ant-col-lg-22, .ant-col-23, .ant-col-xs-23, .ant-col-sm-23, .ant-col-md-23, .ant-col-lg-23, .ant-col-24, .ant-col-xs-24, .ant-col-sm-24, .ant-col-md-24, .ant-col-lg-24 {
  position: relative;
  padding-right: 16px;
  padding-left: 16px;
}
.ant-col-1, .ant-col-xs-1, .ant-col-sm-1, .ant-col-md-1, .ant-col-lg-1, .ant-col-2, .ant-col-xs-2, .ant-col-sm-2, .ant-col-md-2, .ant-col-lg-2, .ant-col-3, .ant-col-xs-3, .ant-col-sm-3, .ant-col-md-3, .ant-col-lg-3, .ant-col-4, .ant-col-xs-4, .ant-col-sm-4, .ant-col-md-4, .ant-col-lg-4, .ant-col-5, .ant-col-xs-5, .ant-col-sm-5, .ant-col-md-5, .ant-col-lg-5, .ant-col-6, .ant-col-xs-6, .ant-col-sm-6, .ant-col-md-6, .ant-col-lg-6, .ant-col-7, .ant-col-xs-7, .ant-col-sm-7, .ant-col-md-7, .ant-col-lg-7, .ant-col-8, .ant-col-xs-8, .ant-col-sm-8, .ant-col-md-8, .ant-col-lg-8, .ant-col-9, .ant-col-xs-9, .ant-col-sm-9, .ant-col-md-9, .ant-col-lg-9, .ant-col-10, .ant-col-xs-10, .ant-col-sm-10, .ant-col-md-10, .ant-col-lg-10, .ant-col-11, .ant-col-xs-11, .ant-col-sm-11, .ant-col-md-11, .ant-col-lg-11, .ant-col-12, .ant-col-xs-12, .ant-col-sm-12, .ant-col-md-12, .ant-col-lg-12, .ant-col-13, .ant-col-xs-13, .ant-col-sm-13, .ant-col-md-13, .ant-col-lg-13, .ant-col-14, .ant-col-xs-14, .ant-col-sm-14, .ant-col-md-14, .ant-col-lg-14, .ant-col-15, .ant-col-xs-15, .ant-col-sm-15, .ant-col-md-15, .ant-col-lg-15, .ant-col-16, .ant-col-xs-16, .ant-col-sm-16, .ant-col-md-16, .ant-col-lg-16, .ant-col-17, .ant-col-xs-17, .ant-col-sm-17, .ant-col-md-17, .ant-col-lg-17, .ant-col-18, .ant-col-xs-18, .ant-col-sm-18, .ant-col-md-18, .ant-col-lg-18, .ant-col-19, .ant-col-xs-19, .ant-col-sm-19, .ant-col-md-19, .ant-col-lg-19, .ant-col-20, .ant-col-xs-20, .ant-col-sm-20, .ant-col-md-20, .ant-col-lg-20, .ant-col-21, .ant-col-xs-21, .ant-col-sm-21, .ant-col-md-21, .ant-col-lg-21, .ant-col-22, .ant-col-xs-22, .ant-col-sm-22, .ant-col-md-22, .ant-col-lg-22, .ant-col-23, .ant-col-xs-23, .ant-col-sm-23, .ant-col-md-23, .ant-col-lg-23, .ant-col-24, .ant-col-xs-24, .ant-col-sm-24, .ant-col-md-24, .ant-col-lg-24 {
  padding-left: 16px;
  padding-right: 16px;
  float: none !important;
}
.ant-col-1, .ant-col-2, .ant-col-3, .ant-col-4, .ant-col-5, .ant-col-6, .ant-col-7, .ant-col-8, .ant-col-9, .ant-col-10, .ant-col-11, .ant-col-12, .ant-col-13, .ant-col-14, .ant-col-15, .ant-col-16, .ant-col-17, .ant-col-18, .ant-col-19, .ant-col-20, .ant-col-21, .ant-col-22, .ant-col-23, .ant-col-24 {
  flex: 0 0 auto;
  float: left;
}
.ant-col-24 {
  display: block;
  box-sizing: border-box;
  width: 100%;
}
.ant-col-push-24 {
  left: 100%;
}
.ant-col-pull-24 {
  right: 100%;
}
.ant-col-offset-24 {
  margin-left: 100%;
}
.ant-col-order-24 {
  order: 24;
}
.ant-col-23 {
  display: block;
  box-sizing: border-box;
  width: 95.83333333%;
}
.ant-col-push-23 {
  left: 95.83333333%;
}
.ant-col-pull-23 {
  right: 95.83333333%;
}
.ant-col-offset-23 {
  margin-left: 95.83333333%;
}
.ant-col-order-23 {
  order: 23;
}
.ant-col-22 {
  display: block;
  box-sizing: border-box;
  width: 91.66666667%;
}
.ant-col-push-22 {
  left: 91.66666667%;
}
.ant-col-pull-22 {
  right: 91.66666667%;
}
.ant-col-offset-22 {
  margin-left: 91.66666667%;
}
.ant-col-order-22 {
  order: 22;
}
.ant-col-21 {
  display: block;
  box-sizing: border-box;
  width: 87.5%;
}
.ant-col-push-21 {
  left: 87.5%;
}
.ant-col-pull-21 {
  right: 87.5%;
}
.ant-col-offset-21 {
  margin-left: 87.5%;
}
.ant-col-order-21 {
  order: 21;
}
.ant-col-20 {
  display: block;
  box-sizing: border-box;
  width: 83.33333333%;
}
.ant-col-push-20 {
  left: 83.33333333%;
}
.ant-col-pull-20 {
  right: 83.33333333%;
}
.ant-col-offset-20 {
  margin-left: 83.33333333%;
}
.ant-col-order-20 {
  order: 20;
}
.ant-col-19 {
  display: block;
  box-sizing: border-box;
  width: 79.16666667%;
}
.ant-col-push-19 {
  left: 79.16666667%;
}
.ant-col-pull-19 {
  right: 79.16666667%;
}
.ant-col-offset-19 {
  margin-left: 79.16666667%;
}
.ant-col-order-19 {
  order: 19;
}
.ant-col-18 {
  display: block;
  box-sizing: border-box;
  width: 75%;
}
.ant-col-push-18 {
  left: 75%;
}
.ant-col-pull-18 {
  right: 75%;
}
.ant-col-offset-18 {
  margin-left: 75%;
}
.ant-col-order-18 {
  order: 18;
}
.ant-col-17 {
  display: block;
  box-sizing: border-box;
  width: 70.83333333%;
}
.ant-col-push-17 {
  left: 70.83333333%;
}
.ant-col-pull-17 {
  right: 70.83333333%;
}
.ant-col-offset-17 {
  margin-left: 70.83333333%;
}
.ant-col-order-17 {
  order: 17;
}
.ant-col-16 {
  display: block;
  box-sizing: border-box;
  width: 66.66666667%;
}
.ant-col-push-16 {
  left: 66.66666667%;
}
.ant-col-pull-16 {
  right: 66.66666667%;
}
.ant-col-offset-16 {
  margin-left: 66.66666667%;
}
.ant-col-order-16 {
  order: 16;
}
.ant-col-15 {
  display: block;
  box-sizing: border-box;
  width: 62.5%;
}
.ant-col-push-15 {
  left: 62.5%;
}
.ant-col-pull-15 {
  right: 62.5%;
}
.ant-col-offset-15 {
  margin-left: 62.5%;
}
.ant-col-order-15 {
  order: 15;
}
.ant-col-14 {
  display: block;
  box-sizing: border-box;
  width: 58.33333333%;
}
.ant-col-push-14 {
  left: 58.33333333%;
}
.ant-col-pull-14 {
  right: 58.33333333%;
}
.ant-col-offset-14 {
  margin-left: 58.33333333%;
}
.ant-col-order-14 {
  order: 14;
}
.ant-col-13 {
  display: block;
  box-sizing: border-box;
  width: 54.16666667%;
}
.ant-col-push-13 {
  left: 54.16666667%;
}
.ant-col-pull-13 {
  right: 54.16666667%;
}
.ant-col-offset-13 {
  margin-left: 54.16666667%;
}
.ant-col-order-13 {
  order: 13;
}
.ant-col-12 {
  display: block;
  box-sizing: border-box;
  width: 50%;
}
.ant-col-push-12 {
  left: 50%;
}
.ant-col-pull-12 {
  right: 50%;
}
.ant-col-offset-12 {
  margin-left: 50%;
}
.ant-col-order-12 {
  order: 12;
}
.ant-col-11 {
  display: block;
  box-sizing: border-box;
  width: 45.83333333%;
}
.ant-col-push-11 {
  left: 45.83333333%;
}
.ant-col-pull-11 {
  right: 45.83333333%;
}
.ant-col-offset-11 {
  margin-left: 45.83333333%;
}
.ant-col-order-11 {
  order: 11;
}
.ant-col-10 {
  display: block;
  box-sizing: border-box;
  width: 41.66666667%;
}
.ant-col-push-10 {
  left: 41.66666667%;
}
.ant-col-pull-10 {
  right: 41.66666667%;
}
.ant-col-offset-10 {
  margin-left: 41.66666667%;
}
.ant-col-order-10 {
  order: 10;
}
.ant-col-9 {
  display: block;
  box-sizing: border-box;
  width: 37.5%;
}
.ant-col-push-9 {
  left: 37.5%;
}
.ant-col-pull-9 {
  right: 37.5%;
}
.ant-col-offset-9 {
  margin-left: 37.5%;
}
.ant-col-order-9 {
  order: 9;
}
.ant-col-8 {
  display: block;
  box-sizing: border-box;
  width: 33.33333333%;
}
.ant-col-push-8 {
  left: 33.33333333%;
}
.ant-col-pull-8 {
  right: 33.33333333%;
}
.ant-col-offset-8 {
  margin-left: 33.33333333%;
}
.ant-col-order-8 {
  order: 8;
}
.ant-col-7 {
  display: block;
  box-sizing: border-box;
  width: 29.16666667%;
}
.ant-col-push-7 {
  left: 29.16666667%;
}
.ant-col-pull-7 {
  right: 29.16666667%;
}
.ant-col-offset-7 {
  margin-left: 29.16666667%;
}
.ant-col-order-7 {
  order: 7;
}
.ant-col-6 {
  display: block;
  box-sizing: border-box;
  width: 25%;
}
.ant-col-push-6 {
  left: 25%;
}
.ant-col-pull-6 {
  right: 25%;
}
.ant-col-offset-6 {
  margin-left: 25%;
}
.ant-col-order-6 {
  order: 6;
}
.ant-col-5 {
  display: block;
  box-sizing: border-box;
  width: 20.83333333%;
}
.ant-col-push-5 {
  left: 20.83333333%;
}
.ant-col-pull-5 {
  right: 20.83333333%;
}
.ant-col-offset-5 {
  margin-left: 20.83333333%;
}
.ant-col-order-5 {
  order: 5;
}
.ant-col-4 {
  display: block;
  box-sizing: border-box;
  width: 16.66666667%;
}
.ant-col-push-4 {
  left: 16.66666667%;
}
.ant-col-pull-4 {
  right: 16.66666667%;
}
.ant-col-offset-4 {
  margin-left: 16.66666667%;
}
.ant-col-order-4 {
  order: 4;
}
.ant-col-3 {
  display: block;
  box-sizing: border-box;
  width: 12.5%;
}
.ant-col-push-3 {
  left: 12.5%;
}
.ant-col-pull-3 {
  right: 12.5%;
}
.ant-col-offset-3 {
  margin-left: 12.5%;
}
.ant-col-order-3 {
  order: 3;
}
.ant-col-2 {
  display: block;
  box-sizing: border-box;
  width: 8.33333333%;
}
.ant-col-push-2 {
  left: 8.33333333%;
}
.ant-col-pull-2 {
  right: 8.33333333%;
}
.ant-col-offset-2 {
  margin-left: 8.33333333%;
}
.ant-col-order-2 {
  order: 2;
}
.ant-col-1 {
  display: block;
  box-sizing: border-box;
  width: 4.16666667%;
}
.ant-col-push-1 {
  left: 4.16666667%;
}
.ant-col-pull-1 {
  right: 4.16666667%;
}
.ant-col-offset-1 {
  margin-left: 4.16666667%;
}
.ant-col-order-1 {
  order: 1;
}
.ant-col-0 {
  display: none;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-offset-0 {
  margin-left: 0;
}
.ant-col-order-0 {
  order: 0;
}
.ant-col-xs-1, .ant-col-xs-2, .ant-col-xs-3, .ant-col-xs-4, .ant-col-xs-5, .ant-col-xs-6, .ant-col-xs-7, .ant-col-xs-8, .ant-col-xs-9, .ant-col-xs-10, .ant-col-xs-11, .ant-col-xs-12, .ant-col-xs-13, .ant-col-xs-14, .ant-col-xs-15, .ant-col-xs-16, .ant-col-xs-17, .ant-col-xs-18, .ant-col-xs-19, .ant-col-xs-20, .ant-col-xs-21, .ant-col-xs-22, .ant-col-xs-23, .ant-col-xs-24 {
  flex: 0 0 auto;
  float: left;
}
.ant-col-xs-24 {
  display: block;
  box-sizing: border-box;
  width: 100%;
}
.ant-col-xs-push-24 {
  left: 100%;
}
.ant-col-xs-pull-24 {
  right: 100%;
}
.ant-col-xs-offset-24 {
  margin-left: 100%;
}
.ant-col-xs-order-24 {
  order: 24;
}
.ant-col-xs-23 {
  display: block;
  box-sizing: border-box;
  width: 95.83333333%;
}
.ant-col-xs-push-23 {
  left: 95.83333333%;
}
.ant-col-xs-pull-23 {
  right: 95.83333333%;
}
.ant-col-xs-offset-23 {
  margin-left: 95.83333333%;
}
.ant-col-xs-order-23 {
  order: 23;
}
.ant-col-xs-22 {
  display: block;
  box-sizing: border-box;
  width: 91.66666667%;
}
.ant-col-xs-push-22 {
  left: 91.66666667%;
}
.ant-col-xs-pull-22 {
  right: 91.66666667%;
}
.ant-col-xs-offset-22 {
  margin-left: 91.66666667%;
}
.ant-col-xs-order-22 {
  order: 22;
}
.ant-col-xs-21 {
  display: block;
  box-sizing: border-box;
  width: 87.5%;
}
.ant-col-xs-push-21 {
  left: 87.5%;
}
.ant-col-xs-pull-21 {
  right: 87.5%;
}
.ant-col-xs-offset-21 {
  margin-left: 87.5%;
}
.ant-col-xs-order-21 {
  order: 21;
}
.ant-col-xs-20 {
  display: block;
  box-sizing: border-box;
  width: 83.33333333%;
}
.ant-col-xs-push-20 {
  left: 83.33333333%;
}
.ant-col-xs-pull-20 {
  right: 83.33333333%;
}
.ant-col-xs-offset-20 {
  margin-left: 83.33333333%;
}
.ant-col-xs-order-20 {
  order: 20;
}
.ant-col-xs-19 {
  display: block;
  box-sizing: border-box;
  width: 79.16666667%;
}
.ant-col-xs-push-19 {
  left: 79.16666667%;
}
.ant-col-xs-pull-19 {
  right: 79.16666667%;
}
.ant-col-xs-offset-19 {
  margin-left: 79.16666667%;
}
.ant-col-xs-order-19 {
  order: 19;
}
.ant-col-xs-18 {
  display: block;
  box-sizing: border-box;
  width: 75%;
}
.ant-col-xs-push-18 {
  left: 75%;
}
.ant-col-xs-pull-18 {
  right: 75%;
}
.ant-col-xs-offset-18 {
  margin-left: 75%;
}
.ant-col-xs-order-18 {
  order: 18;
}
.ant-col-xs-17 {
  display: block;
  box-sizing: border-box;
  width: 70.83333333%;
}
.ant-col-xs-push-17 {
  left: 70.83333333%;
}
.ant-col-xs-pull-17 {
  right: 70.83333333%;
}
.ant-col-xs-offset-17 {
  margin-left: 70.83333333%;
}
.ant-col-xs-order-17 {
  order: 17;
}
.ant-col-xs-16 {
  display: block;
  box-sizing: border-box;
  width: 66.66666667%;
}
.ant-col-xs-push-16 {
  left: 66.66666667%;
}
.ant-col-xs-pull-16 {
  right: 66.66666667%;
}
.ant-col-xs-offset-16 {
  margin-left: 66.66666667%;
}
.ant-col-xs-order-16 {
  order: 16;
}
.ant-col-xs-15 {
  display: block;
  box-sizing: border-box;
  width: 62.5%;
}
.ant-col-xs-push-15 {
  left: 62.5%;
}
.ant-col-xs-pull-15 {
  right: 62.5%;
}
.ant-col-xs-offset-15 {
  margin-left: 62.5%;
}
.ant-col-xs-order-15 {
  order: 15;
}
.ant-col-xs-14 {
  display: block;
  box-sizing: border-box;
  width: 58.33333333%;
}
.ant-col-xs-push-14 {
  left: 58.33333333%;
}
.ant-col-xs-pull-14 {
  right: 58.33333333%;
}
.ant-col-xs-offset-14 {
  margin-left: 58.33333333%;
}
.ant-col-xs-order-14 {
  order: 14;
}
.ant-col-xs-13 {
  display: block;
  box-sizing: border-box;
  width: 54.16666667%;
}
.ant-col-xs-push-13 {
  left: 54.16666667%;
}
.ant-col-xs-pull-13 {
  right: 54.16666667%;
}
.ant-col-xs-offset-13 {
  margin-left: 54.16666667%;
}
.ant-col-xs-order-13 {
  order: 13;
}
.ant-col-xs-12 {
  display: block;
  box-sizing: border-box;
  width: 50%;
}
.ant-col-xs-push-12 {
  left: 50%;
}
.ant-col-xs-pull-12 {
  right: 50%;
}
.ant-col-xs-offset-12 {
  margin-left: 50%;
}
.ant-col-xs-order-12 {
  order: 12;
}
.ant-col-xs-11 {
  display: block;
  box-sizing: border-box;
  width: 45.83333333%;
}
.ant-col-xs-push-11 {
  left: 45.83333333%;
}
.ant-col-xs-pull-11 {
  right: 45.83333333%;
}
.ant-col-xs-offset-11 {
  margin-left: 45.83333333%;
}
.ant-col-xs-order-11 {
  order: 11;
}
.ant-col-xs-10 {
  display: block;
  box-sizing: border-box;
  width: 41.66666667%;
}
.ant-col-xs-push-10 {
  left: 41.66666667%;
}
.ant-col-xs-pull-10 {
  right: 41.66666667%;
}
.ant-col-xs-offset-10 {
  margin-left: 41.66666667%;
}
.ant-col-xs-order-10 {
  order: 10;
}
.ant-col-xs-9 {
  display: block;
  box-sizing: border-box;
  width: 37.5%;
}
.ant-col-xs-push-9 {
  left: 37.5%;
}
.ant-col-xs-pull-9 {
  right: 37.5%;
}
.ant-col-xs-offset-9 {
  margin-left: 37.5%;
}
.ant-col-xs-order-9 {
  order: 9;
}
.ant-col-xs-8 {
  display: block;
  box-sizing: border-box;
  width: 33.33333333%;
}
.ant-col-xs-push-8 {
  left: 33.33333333%;
}
.ant-col-xs-pull-8 {
  right: 33.33333333%;
}
.ant-col-xs-offset-8 {
  margin-left: 33.33333333%;
}
.ant-col-xs-order-8 {
  order: 8;
}
.ant-col-xs-7 {
  display: block;
  box-sizing: border-box;
  width: 29.16666667%;
}
.ant-col-xs-push-7 {
  left: 29.16666667%;
}
.ant-col-xs-pull-7 {
  right: 29.16666667%;
}
.ant-col-xs-offset-7 {
  margin-left: 29.16666667%;
}
.ant-col-xs-order-7 {
  order: 7;
}
.ant-col-xs-6 {
  display: block;
  box-sizing: border-box;
  width: 25%;
}
.ant-col-xs-push-6 {
  left: 25%;
}
.ant-col-xs-pull-6 {
  right: 25%;
}
.ant-col-xs-offset-6 {
  margin-left: 25%;
}
.ant-col-xs-order-6 {
  order: 6;
}
.ant-col-xs-5 {
  display: block;
  box-sizing: border-box;
  width: 20.83333333%;
}
.ant-col-xs-push-5 {
  left: 20.83333333%;
}
.ant-col-xs-pull-5 {
  right: 20.83333333%;
}
.ant-col-xs-offset-5 {
  margin-left: 20.83333333%;
}
.ant-col-xs-order-5 {
  order: 5;
}
.ant-col-xs-4 {
  display: block;
  box-sizing: border-box;
  width: 16.66666667%;
}
.ant-col-xs-push-4 {
  left: 16.66666667%;
}
.ant-col-xs-pull-4 {
  right: 16.66666667%;
}
.ant-col-xs-offset-4 {
  margin-left: 16.66666667%;
}
.ant-col-xs-order-4 {
  order: 4;
}
.ant-col-xs-3 {
  display: block;
  box-sizing: border-box;
  width: 12.5%;
}
.ant-col-xs-push-3 {
  left: 12.5%;
}
.ant-col-xs-pull-3 {
  right: 12.5%;
}
.ant-col-xs-offset-3 {
  margin-left: 12.5%;
}
.ant-col-xs-order-3 {
  order: 3;
}
.ant-col-xs-2 {
  display: block;
  box-sizing: border-box;
  width: 8.33333333%;
}
.ant-col-xs-push-2 {
  left: 8.33333333%;
}
.ant-col-xs-pull-2 {
  right: 8.33333333%;
}
.ant-col-xs-offset-2 {
  margin-left: 8.33333333%;
}
.ant-col-xs-order-2 {
  order: 2;
}
.ant-col-xs-1 {
  display: block;
  box-sizing: border-box;
  width: 4.16666667%;
}
.ant-col-xs-push-1 {
  left: 4.16666667%;
}
.ant-col-xs-pull-1 {
  right: 4.16666667%;
}
.ant-col-xs-offset-1 {
  margin-left: 4.16666667%;
}
.ant-col-xs-order-1 {
  order: 1;
}
.ant-col-xs-0 {
  display: none;
}
.ant-col-push-0 {
  left: auto;
}
.ant-col-pull-0 {
  right: auto;
}
.ant-col-xs-push-0 {
  left: auto;
}
.ant-col-xs-pull-0 {
  right: auto;
}
.ant-col-xs-offset-0 {
  margin-left: 0;
}
.ant-col-xs-order-0 {
  order: 0;
}
@media (min-width: 576px) {
  .ant-col-sm-1, .ant-col-sm-2, .ant-col-sm-3, .ant-col-sm-4, .ant-col-sm-5, .ant-col-sm-6, .ant-col-sm-7, .ant-col-sm-8, .ant-col-sm-9, .ant-col-sm-10, .ant-col-sm-11, .ant-col-sm-12, .ant-col-sm-13, .ant-col-sm-14, .ant-col-sm-15, .ant-col-sm-16, .ant-col-sm-17, .ant-col-sm-18, .ant-col-sm-19, .ant-col-sm-20, .ant-col-sm-21, .ant-col-sm-22, .ant-col-sm-23, .ant-col-sm-24 {
    flex: 0 0 auto;
    float: left;
  }
  .ant-col-sm-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-sm-push-24 {
    left: 100%;
  }
  .ant-col-sm-pull-24 {
    right: 100%;
  }
  .ant-col-sm-offset-24 {
    margin-left: 100%;
  }
  .ant-col-sm-order-24 {
    order: 24;
  }
  .ant-col-sm-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-sm-push-23 {
    left: 95.83333333%;
  }
  .ant-col-sm-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-sm-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-sm-order-23 {
    order: 23;
  }
  .ant-col-sm-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-sm-push-22 {
    left: 91.66666667%;
  }
  .ant-col-sm-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-sm-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-sm-order-22 {
    order: 22;
  }
  .ant-col-sm-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-sm-push-21 {
    left: 87.5%;
  }
  .ant-col-sm-pull-21 {
    right: 87.5%;
  }
  .ant-col-sm-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-sm-order-21 {
    order: 21;
  }
  .ant-col-sm-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-sm-push-20 {
    left: 83.33333333%;
  }
  .ant-col-sm-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-sm-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-sm-order-20 {
    order: 20;
  }
  .ant-col-sm-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-sm-push-19 {
    left: 79.16666667%;
  }
  .ant-col-sm-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-sm-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-sm-order-19 {
    order: 19;
  }
  .ant-col-sm-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-sm-push-18 {
    left: 75%;
  }
  .ant-col-sm-pull-18 {
    right: 75%;
  }
  .ant-col-sm-offset-18 {
    margin-left: 75%;
  }
  .ant-col-sm-order-18 {
    order: 18;
  }
  .ant-col-sm-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-sm-push-17 {
    left: 70.83333333%;
  }
  .ant-col-sm-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-sm-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-sm-order-17 {
    order: 17;
  }
  .ant-col-sm-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-sm-push-16 {
    left: 66.66666667%;
  }
  .ant-col-sm-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-sm-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-sm-order-16 {
    order: 16;
  }
  .ant-col-sm-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-sm-push-15 {
    left: 62.5%;
  }
  .ant-col-sm-pull-15 {
    right: 62.5%;
  }
  .ant-col-sm-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-sm-order-15 {
    order: 15;
  }
  .ant-col-sm-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-sm-push-14 {
    left: 58.33333333%;
  }
  .ant-col-sm-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-sm-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-sm-order-14 {
    order: 14;
  }
  .ant-col-sm-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-sm-push-13 {
    left: 54.16666667%;
  }
  .ant-col-sm-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-sm-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-sm-order-13 {
    order: 13;
  }
  .ant-col-sm-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-sm-push-12 {
    left: 50%;
  }
  .ant-col-sm-pull-12 {
    right: 50%;
  }
  .ant-col-sm-offset-12 {
    margin-left: 50%;
  }
  .ant-col-sm-order-12 {
    order: 12;
  }
  .ant-col-sm-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-sm-push-11 {
    left: 45.83333333%;
  }
  .ant-col-sm-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-sm-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-sm-order-11 {
    order: 11;
  }
  .ant-col-sm-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-sm-push-10 {
    left: 41.66666667%;
  }
  .ant-col-sm-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-sm-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-sm-order-10 {
    order: 10;
  }
  .ant-col-sm-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-sm-push-9 {
    left: 37.5%;
  }
  .ant-col-sm-pull-9 {
    right: 37.5%;
  }
  .ant-col-sm-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-sm-order-9 {
    order: 9;
  }
  .ant-col-sm-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-sm-push-8 {
    left: 33.33333333%;
  }
  .ant-col-sm-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-sm-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-sm-order-8 {
    order: 8;
  }
  .ant-col-sm-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-sm-push-7 {
    left: 29.16666667%;
  }
  .ant-col-sm-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-sm-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-sm-order-7 {
    order: 7;
  }
  .ant-col-sm-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-sm-push-6 {
    left: 25%;
  }
  .ant-col-sm-pull-6 {
    right: 25%;
  }
  .ant-col-sm-offset-6 {
    margin-left: 25%;
  }
  .ant-col-sm-order-6 {
    order: 6;
  }
  .ant-col-sm-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-sm-push-5 {
    left: 20.83333333%;
  }
  .ant-col-sm-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-sm-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-sm-order-5 {
    order: 5;
  }
  .ant-col-sm-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-sm-push-4 {
    left: 16.66666667%;
  }
  .ant-col-sm-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-sm-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-sm-order-4 {
    order: 4;
  }
  .ant-col-sm-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-sm-push-3 {
    left: 12.5%;
  }
  .ant-col-sm-pull-3 {
    right: 12.5%;
  }
  .ant-col-sm-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-sm-order-3 {
    order: 3;
  }
  .ant-col-sm-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-sm-push-2 {
    left: 8.33333333%;
  }
  .ant-col-sm-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-sm-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-sm-order-2 {
    order: 2;
  }
  .ant-col-sm-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-sm-push-1 {
    left: 4.16666667%;
  }
  .ant-col-sm-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-sm-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-sm-order-1 {
    order: 1;
  }
  .ant-col-sm-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-sm-push-0 {
    left: auto;
  }
  .ant-col-sm-pull-0 {
    right: auto;
  }
  .ant-col-sm-offset-0 {
    margin-left: 0;
  }
  .ant-col-sm-order-0 {
    order: 0;
  }
}
@media (min-width: 768px) {
  .ant-col-md-1, .ant-col-md-2, .ant-col-md-3, .ant-col-md-4, .ant-col-md-5, .ant-col-md-6, .ant-col-md-7, .ant-col-md-8, .ant-col-md-9, .ant-col-md-10, .ant-col-md-11, .ant-col-md-12, .ant-col-md-13, .ant-col-md-14, .ant-col-md-15, .ant-col-md-16, .ant-col-md-17, .ant-col-md-18, .ant-col-md-19, .ant-col-md-20, .ant-col-md-21, .ant-col-md-22, .ant-col-md-23, .ant-col-md-24 {
    flex: 0 0 auto;
    float: left;
  }
  .ant-col-md-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-md-push-24 {
    left: 100%;
  }
  .ant-col-md-pull-24 {
    right: 100%;
  }
  .ant-col-md-offset-24 {
    margin-left: 100%;
  }
  .ant-col-md-order-24 {
    order: 24;
  }
  .ant-col-md-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-md-push-23 {
    left: 95.83333333%;
  }
  .ant-col-md-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-md-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-md-order-23 {
    order: 23;
  }
  .ant-col-md-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-md-push-22 {
    left: 91.66666667%;
  }
  .ant-col-md-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-md-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-md-order-22 {
    order: 22;
  }
  .ant-col-md-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-md-push-21 {
    left: 87.5%;
  }
  .ant-col-md-pull-21 {
    right: 87.5%;
  }
  .ant-col-md-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-md-order-21 {
    order: 21;
  }
  .ant-col-md-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-md-push-20 {
    left: 83.33333333%;
  }
  .ant-col-md-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-md-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-md-order-20 {
    order: 20;
  }
  .ant-col-md-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-md-push-19 {
    left: 79.16666667%;
  }
  .ant-col-md-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-md-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-md-order-19 {
    order: 19;
  }
  .ant-col-md-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-md-push-18 {
    left: 75%;
  }
  .ant-col-md-pull-18 {
    right: 75%;
  }
  .ant-col-md-offset-18 {
    margin-left: 75%;
  }
  .ant-col-md-order-18 {
    order: 18;
  }
  .ant-col-md-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-md-push-17 {
    left: 70.83333333%;
  }
  .ant-col-md-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-md-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-md-order-17 {
    order: 17;
  }
  .ant-col-md-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-md-push-16 {
    left: 66.66666667%;
  }
  .ant-col-md-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-md-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-md-order-16 {
    order: 16;
  }
  .ant-col-md-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-md-push-15 {
    left: 62.5%;
  }
  .ant-col-md-pull-15 {
    right: 62.5%;
  }
  .ant-col-md-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-md-order-15 {
    order: 15;
  }
  .ant-col-md-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-md-push-14 {
    left: 58.33333333%;
  }
  .ant-col-md-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-md-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-md-order-14 {
    order: 14;
  }
  .ant-col-md-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-md-push-13 {
    left: 54.16666667%;
  }
  .ant-col-md-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-md-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-md-order-13 {
    order: 13;
  }
  .ant-col-md-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-md-push-12 {
    left: 50%;
  }
  .ant-col-md-pull-12 {
    right: 50%;
  }
  .ant-col-md-offset-12 {
    margin-left: 50%;
  }
  .ant-col-md-order-12 {
    order: 12;
  }
  .ant-col-md-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-md-push-11 {
    left: 45.83333333%;
  }
  .ant-col-md-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-md-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-md-order-11 {
    order: 11;
  }
  .ant-col-md-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-md-push-10 {
    left: 41.66666667%;
  }
  .ant-col-md-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-md-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-md-order-10 {
    order: 10;
  }
  .ant-col-md-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-md-push-9 {
    left: 37.5%;
  }
  .ant-col-md-pull-9 {
    right: 37.5%;
  }
  .ant-col-md-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-md-order-9 {
    order: 9;
  }
  .ant-col-md-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-md-push-8 {
    left: 33.33333333%;
  }
  .ant-col-md-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-md-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-md-order-8 {
    order: 8;
  }
  .ant-col-md-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-md-push-7 {
    left: 29.16666667%;
  }
  .ant-col-md-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-md-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-md-order-7 {
    order: 7;
  }
  .ant-col-md-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-md-push-6 {
    left: 25%;
  }
  .ant-col-md-pull-6 {
    right: 25%;
  }
  .ant-col-md-offset-6 {
    margin-left: 25%;
  }
  .ant-col-md-order-6 {
    order: 6;
  }
  .ant-col-md-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-md-push-5 {
    left: 20.83333333%;
  }
  .ant-col-md-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-md-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-md-order-5 {
    order: 5;
  }
  .ant-col-md-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-md-push-4 {
    left: 16.66666667%;
  }
  .ant-col-md-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-md-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-md-order-4 {
    order: 4;
  }
  .ant-col-md-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-md-push-3 {
    left: 12.5%;
  }
  .ant-col-md-pull-3 {
    right: 12.5%;
  }
  .ant-col-md-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-md-order-3 {
    order: 3;
  }
  .ant-col-md-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-md-push-2 {
    left: 8.33333333%;
  }
  .ant-col-md-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-md-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-md-order-2 {
    order: 2;
  }
  .ant-col-md-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-md-push-1 {
    left: 4.16666667%;
  }
  .ant-col-md-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-md-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-md-order-1 {
    order: 1;
  }
  .ant-col-md-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-md-push-0 {
    left: auto;
  }
  .ant-col-md-pull-0 {
    right: auto;
  }
  .ant-col-md-offset-0 {
    margin-left: 0;
  }
  .ant-col-md-order-0 {
    order: 0;
  }
}
@media (min-width: 992px) {
  .ant-col-lg-1, .ant-col-lg-2, .ant-col-lg-3, .ant-col-lg-4, .ant-col-lg-5, .ant-col-lg-6, .ant-col-lg-7, .ant-col-lg-8, .ant-col-lg-9, .ant-col-lg-10, .ant-col-lg-11, .ant-col-lg-12, .ant-col-lg-13, .ant-col-lg-14, .ant-col-lg-15, .ant-col-lg-16, .ant-col-lg-17, .ant-col-lg-18, .ant-col-lg-19, .ant-col-lg-20, .ant-col-lg-21, .ant-col-lg-22, .ant-col-lg-23, .ant-col-lg-24 {
    flex: 0 0 auto;
    float: left;
  }
  .ant-col-lg-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-lg-push-24 {
    left: 100%;
  }
  .ant-col-lg-pull-24 {
    right: 100%;
  }
  .ant-col-lg-offset-24 {
    margin-left: 100%;
  }
  .ant-col-lg-order-24 {
    order: 24;
  }
  .ant-col-lg-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-lg-push-23 {
    left: 95.83333333%;
  }
  .ant-col-lg-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-lg-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-lg-order-23 {
    order: 23;
  }
  .ant-col-lg-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-lg-push-22 {
    left: 91.66666667%;
  }
  .ant-col-lg-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-lg-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-lg-order-22 {
    order: 22;
  }
  .ant-col-lg-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-lg-push-21 {
    left: 87.5%;
  }
  .ant-col-lg-pull-21 {
    right: 87.5%;
  }
  .ant-col-lg-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-lg-order-21 {
    order: 21;
  }
  .ant-col-lg-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-lg-push-20 {
    left: 83.33333333%;
  }
  .ant-col-lg-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-lg-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-lg-order-20 {
    order: 20;
  }
  .ant-col-lg-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-lg-push-19 {
    left: 79.16666667%;
  }
  .ant-col-lg-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-lg-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-lg-order-19 {
    order: 19;
  }
  .ant-col-lg-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-lg-push-18 {
    left: 75%;
  }
  .ant-col-lg-pull-18 {
    right: 75%;
  }
  .ant-col-lg-offset-18 {
    margin-left: 75%;
  }
  .ant-col-lg-order-18 {
    order: 18;
  }
  .ant-col-lg-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-lg-push-17 {
    left: 70.83333333%;
  }
  .ant-col-lg-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-lg-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-lg-order-17 {
    order: 17;
  }
  .ant-col-lg-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-lg-push-16 {
    left: 66.66666667%;
  }
  .ant-col-lg-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-lg-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-lg-order-16 {
    order: 16;
  }
  .ant-col-lg-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-lg-push-15 {
    left: 62.5%;
  }
  .ant-col-lg-pull-15 {
    right: 62.5%;
  }
  .ant-col-lg-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-lg-order-15 {
    order: 15;
  }
  .ant-col-lg-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-lg-push-14 {
    left: 58.33333333%;
  }
  .ant-col-lg-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-lg-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-lg-order-14 {
    order: 14;
  }
  .ant-col-lg-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-lg-push-13 {
    left: 54.16666667%;
  }
  .ant-col-lg-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-lg-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-lg-order-13 {
    order: 13;
  }
  .ant-col-lg-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-lg-push-12 {
    left: 50%;
  }
  .ant-col-lg-pull-12 {
    right: 50%;
  }
  .ant-col-lg-offset-12 {
    margin-left: 50%;
  }
  .ant-col-lg-order-12 {
    order: 12;
  }
  .ant-col-lg-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-lg-push-11 {
    left: 45.83333333%;
  }
  .ant-col-lg-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-lg-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-lg-order-11 {
    order: 11;
  }
  .ant-col-lg-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-lg-push-10 {
    left: 41.66666667%;
  }
  .ant-col-lg-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-lg-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-lg-order-10 {
    order: 10;
  }
  .ant-col-lg-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-lg-push-9 {
    left: 37.5%;
  }
  .ant-col-lg-pull-9 {
    right: 37.5%;
  }
  .ant-col-lg-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-lg-order-9 {
    order: 9;
  }
  .ant-col-lg-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-lg-push-8 {
    left: 33.33333333%;
  }
  .ant-col-lg-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-lg-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-lg-order-8 {
    order: 8;
  }
  .ant-col-lg-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-lg-push-7 {
    left: 29.16666667%;
  }
  .ant-col-lg-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-lg-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-lg-order-7 {
    order: 7;
  }
  .ant-col-lg-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-lg-push-6 {
    left: 25%;
  }
  .ant-col-lg-pull-6 {
    right: 25%;
  }
  .ant-col-lg-offset-6 {
    margin-left: 25%;
  }
  .ant-col-lg-order-6 {
    order: 6;
  }
  .ant-col-lg-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-lg-push-5 {
    left: 20.83333333%;
  }
  .ant-col-lg-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-lg-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-lg-order-5 {
    order: 5;
  }
  .ant-col-lg-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-lg-push-4 {
    left: 16.66666667%;
  }
  .ant-col-lg-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-lg-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-lg-order-4 {
    order: 4;
  }
  .ant-col-lg-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-lg-push-3 {
    left: 12.5%;
  }
  .ant-col-lg-pull-3 {
    right: 12.5%;
  }
  .ant-col-lg-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-lg-order-3 {
    order: 3;
  }
  .ant-col-lg-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-lg-push-2 {
    left: 8.33333333%;
  }
  .ant-col-lg-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-lg-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-lg-order-2 {
    order: 2;
  }
  .ant-col-lg-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-lg-push-1 {
    left: 4.16666667%;
  }
  .ant-col-lg-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-lg-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-lg-order-1 {
    order: 1;
  }
  .ant-col-lg-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-lg-push-0 {
    left: auto;
  }
  .ant-col-lg-pull-0 {
    right: auto;
  }
  .ant-col-lg-offset-0 {
    margin-left: 0;
  }
  .ant-col-lg-order-0 {
    order: 0;
  }
}
@media (min-width: 1200px) {
  .ant-col-xl-1, .ant-col-xl-2, .ant-col-xl-3, .ant-col-xl-4, .ant-col-xl-5, .ant-col-xl-6, .ant-col-xl-7, .ant-col-xl-8, .ant-col-xl-9, .ant-col-xl-10, .ant-col-xl-11, .ant-col-xl-12, .ant-col-xl-13, .ant-col-xl-14, .ant-col-xl-15, .ant-col-xl-16, .ant-col-xl-17, .ant-col-xl-18, .ant-col-xl-19, .ant-col-xl-20, .ant-col-xl-21, .ant-col-xl-22, .ant-col-xl-23, .ant-col-xl-24 {
    flex: 0 0 auto;
    float: left;
  }
  .ant-col-xl-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-xl-push-24 {
    left: 100%;
  }
  .ant-col-xl-pull-24 {
    right: 100%;
  }
  .ant-col-xl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xl-order-24 {
    order: 24;
  }
  .ant-col-xl-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-xl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xl-order-23 {
    order: 23;
  }
  .ant-col-xl-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-xl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xl-order-22 {
    order: 22;
  }
  .ant-col-xl-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-xl-push-21 {
    left: 87.5%;
  }
  .ant-col-xl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xl-order-21 {
    order: 21;
  }
  .ant-col-xl-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-xl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xl-order-20 {
    order: 20;
  }
  .ant-col-xl-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-xl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xl-order-19 {
    order: 19;
  }
  .ant-col-xl-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-xl-push-18 {
    left: 75%;
  }
  .ant-col-xl-pull-18 {
    right: 75%;
  }
  .ant-col-xl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xl-order-18 {
    order: 18;
  }
  .ant-col-xl-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-xl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xl-order-17 {
    order: 17;
  }
  .ant-col-xl-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-xl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xl-order-16 {
    order: 16;
  }
  .ant-col-xl-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-xl-push-15 {
    left: 62.5%;
  }
  .ant-col-xl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xl-order-15 {
    order: 15;
  }
  .ant-col-xl-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-xl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xl-order-14 {
    order: 14;
  }
  .ant-col-xl-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-xl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xl-order-13 {
    order: 13;
  }
  .ant-col-xl-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-xl-push-12 {
    left: 50%;
  }
  .ant-col-xl-pull-12 {
    right: 50%;
  }
  .ant-col-xl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xl-order-12 {
    order: 12;
  }
  .ant-col-xl-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-xl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xl-order-11 {
    order: 11;
  }
  .ant-col-xl-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-xl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xl-order-10 {
    order: 10;
  }
  .ant-col-xl-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-xl-push-9 {
    left: 37.5%;
  }
  .ant-col-xl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xl-order-9 {
    order: 9;
  }
  .ant-col-xl-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-xl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xl-order-8 {
    order: 8;
  }
  .ant-col-xl-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-xl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xl-order-7 {
    order: 7;
  }
  .ant-col-xl-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-xl-push-6 {
    left: 25%;
  }
  .ant-col-xl-pull-6 {
    right: 25%;
  }
  .ant-col-xl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xl-order-6 {
    order: 6;
  }
  .ant-col-xl-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-xl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xl-order-5 {
    order: 5;
  }
  .ant-col-xl-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-xl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xl-order-4 {
    order: 4;
  }
  .ant-col-xl-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-xl-push-3 {
    left: 12.5%;
  }
  .ant-col-xl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xl-order-3 {
    order: 3;
  }
  .ant-col-xl-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-xl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xl-order-2 {
    order: 2;
  }
  .ant-col-xl-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-xl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xl-order-1 {
    order: 1;
  }
  .ant-col-xl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xl-push-0 {
    left: auto;
  }
  .ant-col-xl-pull-0 {
    right: auto;
  }
  .ant-col-xl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xl-order-0 {
    order: 0;
  }
}
@media (min-width: 1600px) {
  .ant-col-xxl-1, .ant-col-xxl-2, .ant-col-xxl-3, .ant-col-xxl-4, .ant-col-xxl-5, .ant-col-xxl-6, .ant-col-xxl-7, .ant-col-xxl-8, .ant-col-xxl-9, .ant-col-xxl-10, .ant-col-xxl-11, .ant-col-xxl-12, .ant-col-xxl-13, .ant-col-xxl-14, .ant-col-xxl-15, .ant-col-xxl-16, .ant-col-xxl-17, .ant-col-xxl-18, .ant-col-xxl-19, .ant-col-xxl-20, .ant-col-xxl-21, .ant-col-xxl-22, .ant-col-xxl-23, .ant-col-xxl-24 {
    flex: 0 0 auto;
    float: left;
  }
  .ant-col-xxl-24 {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
  .ant-col-xxl-push-24 {
    left: 100%;
  }
  .ant-col-xxl-pull-24 {
    right: 100%;
  }
  .ant-col-xxl-offset-24 {
    margin-left: 100%;
  }
  .ant-col-xxl-order-24 {
    order: 24;
  }
  .ant-col-xxl-23 {
    display: block;
    box-sizing: border-box;
    width: 95.83333333%;
  }
  .ant-col-xxl-push-23 {
    left: 95.83333333%;
  }
  .ant-col-xxl-pull-23 {
    right: 95.83333333%;
  }
  .ant-col-xxl-offset-23 {
    margin-left: 95.83333333%;
  }
  .ant-col-xxl-order-23 {
    order: 23;
  }
  .ant-col-xxl-22 {
    display: block;
    box-sizing: border-box;
    width: 91.66666667%;
  }
  .ant-col-xxl-push-22 {
    left: 91.66666667%;
  }
  .ant-col-xxl-pull-22 {
    right: 91.66666667%;
  }
  .ant-col-xxl-offset-22 {
    margin-left: 91.66666667%;
  }
  .ant-col-xxl-order-22 {
    order: 22;
  }
  .ant-col-xxl-21 {
    display: block;
    box-sizing: border-box;
    width: 87.5%;
  }
  .ant-col-xxl-push-21 {
    left: 87.5%;
  }
  .ant-col-xxl-pull-21 {
    right: 87.5%;
  }
  .ant-col-xxl-offset-21 {
    margin-left: 87.5%;
  }
  .ant-col-xxl-order-21 {
    order: 21;
  }
  .ant-col-xxl-20 {
    display: block;
    box-sizing: border-box;
    width: 83.33333333%;
  }
  .ant-col-xxl-push-20 {
    left: 83.33333333%;
  }
  .ant-col-xxl-pull-20 {
    right: 83.33333333%;
  }
  .ant-col-xxl-offset-20 {
    margin-left: 83.33333333%;
  }
  .ant-col-xxl-order-20 {
    order: 20;
  }
  .ant-col-xxl-19 {
    display: block;
    box-sizing: border-box;
    width: 79.16666667%;
  }
  .ant-col-xxl-push-19 {
    left: 79.16666667%;
  }
  .ant-col-xxl-pull-19 {
    right: 79.16666667%;
  }
  .ant-col-xxl-offset-19 {
    margin-left: 79.16666667%;
  }
  .ant-col-xxl-order-19 {
    order: 19;
  }
  .ant-col-xxl-18 {
    display: block;
    box-sizing: border-box;
    width: 75%;
  }
  .ant-col-xxl-push-18 {
    left: 75%;
  }
  .ant-col-xxl-pull-18 {
    right: 75%;
  }
  .ant-col-xxl-offset-18 {
    margin-left: 75%;
  }
  .ant-col-xxl-order-18 {
    order: 18;
  }
  .ant-col-xxl-17 {
    display: block;
    box-sizing: border-box;
    width: 70.83333333%;
  }
  .ant-col-xxl-push-17 {
    left: 70.83333333%;
  }
  .ant-col-xxl-pull-17 {
    right: 70.83333333%;
  }
  .ant-col-xxl-offset-17 {
    margin-left: 70.83333333%;
  }
  .ant-col-xxl-order-17 {
    order: 17;
  }
  .ant-col-xxl-16 {
    display: block;
    box-sizing: border-box;
    width: 66.66666667%;
  }
  .ant-col-xxl-push-16 {
    left: 66.66666667%;
  }
  .ant-col-xxl-pull-16 {
    right: 66.66666667%;
  }
  .ant-col-xxl-offset-16 {
    margin-left: 66.66666667%;
  }
  .ant-col-xxl-order-16 {
    order: 16;
  }
  .ant-col-xxl-15 {
    display: block;
    box-sizing: border-box;
    width: 62.5%;
  }
  .ant-col-xxl-push-15 {
    left: 62.5%;
  }
  .ant-col-xxl-pull-15 {
    right: 62.5%;
  }
  .ant-col-xxl-offset-15 {
    margin-left: 62.5%;
  }
  .ant-col-xxl-order-15 {
    order: 15;
  }
  .ant-col-xxl-14 {
    display: block;
    box-sizing: border-box;
    width: 58.33333333%;
  }
  .ant-col-xxl-push-14 {
    left: 58.33333333%;
  }
  .ant-col-xxl-pull-14 {
    right: 58.33333333%;
  }
  .ant-col-xxl-offset-14 {
    margin-left: 58.33333333%;
  }
  .ant-col-xxl-order-14 {
    order: 14;
  }
  .ant-col-xxl-13 {
    display: block;
    box-sizing: border-box;
    width: 54.16666667%;
  }
  .ant-col-xxl-push-13 {
    left: 54.16666667%;
  }
  .ant-col-xxl-pull-13 {
    right: 54.16666667%;
  }
  .ant-col-xxl-offset-13 {
    margin-left: 54.16666667%;
  }
  .ant-col-xxl-order-13 {
    order: 13;
  }
  .ant-col-xxl-12 {
    display: block;
    box-sizing: border-box;
    width: 50%;
  }
  .ant-col-xxl-push-12 {
    left: 50%;
  }
  .ant-col-xxl-pull-12 {
    right: 50%;
  }
  .ant-col-xxl-offset-12 {
    margin-left: 50%;
  }
  .ant-col-xxl-order-12 {
    order: 12;
  }
  .ant-col-xxl-11 {
    display: block;
    box-sizing: border-box;
    width: 45.83333333%;
  }
  .ant-col-xxl-push-11 {
    left: 45.83333333%;
  }
  .ant-col-xxl-pull-11 {
    right: 45.83333333%;
  }
  .ant-col-xxl-offset-11 {
    margin-left: 45.83333333%;
  }
  .ant-col-xxl-order-11 {
    order: 11;
  }
  .ant-col-xxl-10 {
    display: block;
    box-sizing: border-box;
    width: 41.66666667%;
  }
  .ant-col-xxl-push-10 {
    left: 41.66666667%;
  }
  .ant-col-xxl-pull-10 {
    right: 41.66666667%;
  }
  .ant-col-xxl-offset-10 {
    margin-left: 41.66666667%;
  }
  .ant-col-xxl-order-10 {
    order: 10;
  }
  .ant-col-xxl-9 {
    display: block;
    box-sizing: border-box;
    width: 37.5%;
  }
  .ant-col-xxl-push-9 {
    left: 37.5%;
  }
  .ant-col-xxl-pull-9 {
    right: 37.5%;
  }
  .ant-col-xxl-offset-9 {
    margin-left: 37.5%;
  }
  .ant-col-xxl-order-9 {
    order: 9;
  }
  .ant-col-xxl-8 {
    display: block;
    box-sizing: border-box;
    width: 33.33333333%;
  }
  .ant-col-xxl-push-8 {
    left: 33.33333333%;
  }
  .ant-col-xxl-pull-8 {
    right: 33.33333333%;
  }
  .ant-col-xxl-offset-8 {
    margin-left: 33.33333333%;
  }
  .ant-col-xxl-order-8 {
    order: 8;
  }
  .ant-col-xxl-7 {
    display: block;
    box-sizing: border-box;
    width: 29.16666667%;
  }
  .ant-col-xxl-push-7 {
    left: 29.16666667%;
  }
  .ant-col-xxl-pull-7 {
    right: 29.16666667%;
  }
  .ant-col-xxl-offset-7 {
    margin-left: 29.16666667%;
  }
  .ant-col-xxl-order-7 {
    order: 7;
  }
  .ant-col-xxl-6 {
    display: block;
    box-sizing: border-box;
    width: 25%;
  }
  .ant-col-xxl-push-6 {
    left: 25%;
  }
  .ant-col-xxl-pull-6 {
    right: 25%;
  }
  .ant-col-xxl-offset-6 {
    margin-left: 25%;
  }
  .ant-col-xxl-order-6 {
    order: 6;
  }
  .ant-col-xxl-5 {
    display: block;
    box-sizing: border-box;
    width: 20.83333333%;
  }
  .ant-col-xxl-push-5 {
    left: 20.83333333%;
  }
  .ant-col-xxl-pull-5 {
    right: 20.83333333%;
  }
  .ant-col-xxl-offset-5 {
    margin-left: 20.83333333%;
  }
  .ant-col-xxl-order-5 {
    order: 5;
  }
  .ant-col-xxl-4 {
    display: block;
    box-sizing: border-box;
    width: 16.66666667%;
  }
  .ant-col-xxl-push-4 {
    left: 16.66666667%;
  }
  .ant-col-xxl-pull-4 {
    right: 16.66666667%;
  }
  .ant-col-xxl-offset-4 {
    margin-left: 16.66666667%;
  }
  .ant-col-xxl-order-4 {
    order: 4;
  }
  .ant-col-xxl-3 {
    display: block;
    box-sizing: border-box;
    width: 12.5%;
  }
  .ant-col-xxl-push-3 {
    left: 12.5%;
  }
  .ant-col-xxl-pull-3 {
    right: 12.5%;
  }
  .ant-col-xxl-offset-3 {
    margin-left: 12.5%;
  }
  .ant-col-xxl-order-3 {
    order: 3;
  }
  .ant-col-xxl-2 {
    display: block;
    box-sizing: border-box;
    width: 8.33333333%;
  }
  .ant-col-xxl-push-2 {
    left: 8.33333333%;
  }
  .ant-col-xxl-pull-2 {
    right: 8.33333333%;
  }
  .ant-col-xxl-offset-2 {
    margin-left: 8.33333333%;
  }
  .ant-col-xxl-order-2 {
    order: 2;
  }
  .ant-col-xxl-1 {
    display: block;
    box-sizing: border-box;
    width: 4.16666667%;
  }
  .ant-col-xxl-push-1 {
    left: 4.16666667%;
  }
  .ant-col-xxl-pull-1 {
    right: 4.16666667%;
  }
  .ant-col-xxl-offset-1 {
    margin-left: 4.16666667%;
  }
  .ant-col-xxl-order-1 {
    order: 1;
  }
  .ant-col-xxl-0 {
    display: none;
  }
  .ant-col-push-0 {
    left: auto;
  }
  .ant-col-pull-0 {
    right: auto;
  }
  .ant-col-xxl-push-0 {
    left: auto;
  }
  .ant-col-xxl-pull-0 {
    right: auto;
  }
  .ant-col-xxl-offset-0 {
    margin-left: 0;
  }
  .ant-col-xxl-order-0 {
    order: 0;
  }
}
.ant-input {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-input:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-input-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-group[class*='col-'] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}
.ant-input-group > [class*='col-'] {
  padding-right: 8px;
}
.ant-input-group > [class*='col-']:last-child {
  padding-right: 0;
}
.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group > .ant-input {
  display: table-cell;
}
.ant-input-group-addon:not(:first-child):not(:last-child),
.ant-input-group-wrap:not(:first-child):not(:last-child),
.ant-input-group > .ant-input:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-group-wrap > * {
  display: block !important;
}
.ant-input-group .ant-input {
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
}
.ant-input-group .ant-input:focus {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-group .ant-input:hover {
  z-index: 1;
  border-right-width: 1px;
}
.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-input-group-addon .ant-select {
  margin: -5px -11px;
}
.ant-input-group-addon .ant-select .ant-select-selection {
  margin: -1px;
  background-color: inherit;
  border: 1px solid transparent;
  box-shadow: none;
}
.ant-input-group-addon .ant-select-open .ant-select-selection,
.ant-input-group-addon .ant-select-focused .ant-select-selection {
  color: #2EB1EF;
}
.ant-input-group-addon > i:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';
}
.ant-input-group > .ant-input:first-child,
.ant-input-group-addon:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,
.ant-input-group-addon:first-child .ant-select .ant-select-selection {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input-group-addon:first-child {
  border-right: 0;
}
.ant-input-group-addon:last-child {
  border-left: 0;
}
.ant-input-group > .ant-input:last-child,
.ant-input-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,
.ant-input-group-addon:last-child .ant-select .ant-select-selection {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group-lg .ant-input,
.ant-input-group-lg > .ant-input-group-addon {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-input-group-sm .ant-input,
.ant-input-group-sm > .ant-input-group-addon {
  height: 24px;
  padding: 1px 7px;
}
.ant-input-group-lg .ant-select-selection--single {
  height: 40px;
}
.ant-input-group-sm .ant-select-selection--single {
  height: 24px;
}
.ant-input-group .ant-input-affix-wrapper {
  display: table-cell;
  float: left;
  width: 100%;
}
.ant-input-group.ant-input-group-compact {
  display: block;
  zoom: 1;
}
.ant-input-group.ant-input-group-compact::before,
.ant-input-group.ant-input-group-compact::after {
  display: table;
  content: '';
}
.ant-input-group.ant-input-group-compact::after {
  clear: both;
}
.ant-input-group.ant-input-group-compact::before,
.ant-input-group.ant-input-group-compact::after {
  display: table;
  content: '';
}
.ant-input-group.ant-input-group-compact::after {
  clear: both;
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child),
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child),
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {
  border-right-width: 1px;
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,
.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,
.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > * {
  display: inline-block;
  float: none;
  vertical-align: top;
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact > *:not(:last-child) {
  margin-right: -1px;
  border-right-width: 1px;
}
.ant-input-group.ant-input-group-compact .ant-input {
  float: none;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,
.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,
.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,
.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input {
  border-right-width: 1px;
  border-radius: 0;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:hover,
.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:hover,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover,
.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:hover,
.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:hover,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:focus,
.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:focus,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus,
.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:focus,
.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:focus,
.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus {
  z-index: 1;
}
.ant-input-group.ant-input-group-compact > *:first-child,
.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,
.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,
.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.ant-input-group.ant-input-group-compact > *:last-child,
.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,
.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input,
.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,
.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {
  border-right-width: 1px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {
  vertical-align: top;
}
.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}
.ant-input-affix-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: start;
}
.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-input-affix-wrapper .ant-input {
  position: relative;
  text-align: inherit;
}
.ant-input-affix-wrapper .ant-input-prefix,
.ant-input-affix-wrapper .ant-input-suffix {
  position: absolute;
  top: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  color: #545454;
  line-height: 0;
  transform: translateY(-50%);
}
.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 1.3;
}
.ant-input-affix-wrapper .ant-input-disabled ~ .ant-input-suffix .anticon {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-input-affix-wrapper .ant-input-prefix {
  left: 12px;
}
.ant-input-affix-wrapper .ant-input-suffix {
  right: 12px;
}
.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 30px;
}
.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 30px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input:not(:last-child) {
  padding-right: 49px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input {
  padding-right: 22px;
}
.ant-input-affix-wrapper .ant-input {
  min-height: 100%;
}
.ant-input-password-icon {
  color: #595959;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-input-password-icon:hover {
  color: #333;
}
.ant-input-clear-icon {
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  vertical-align: 0;
}
.ant-input-clear-icon:hover {
  color: #595959;
}
.ant-input-clear-icon:active {
  color: #545454;
}
.ant-input-clear-icon + i {
  margin-left: 6px;
}
.ant-input-textarea-clear-icon {
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
  position: absolute;
  top: 0;
  right: 0;
  margin: 8px 8px 0 0;
}
.ant-input-textarea-clear-icon:hover {
  color: #595959;
}
.ant-input-textarea-clear-icon:active {
  color: #545454;
}
.ant-input-textarea-clear-icon + i {
  margin-left: 6px;
}
.ant-input-search-icon {
  color: #595959;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-input-search-icon:hover {
  color: rgba(0, 0, 0, 0.8);
}
.ant-input-search-enter-button input {
  border-right: 0;
}
.ant-input-search-enter-button + .ant-input-group-addon,
.ant-input-search-enter-button input + .ant-input-group-addon {
  padding: 0;
  border: 0;
}
.ant-input-search-enter-button + .ant-input-group-addon .ant-input-search-button,
.ant-input-search-enter-button input + .ant-input-group-addon .ant-input-search-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-number {
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  display: inline-block;
  width: 90px;
  margin: 0;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-input-number::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-input-number:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-input-number::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-input-number:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-number:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-input-number:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-input-number-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-input-number[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-input-number-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-input-number-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-input-number-handler {
  position: relative;
  display: block;
  width: 100%;
  height: 50%;
  overflow: hidden;
  color: #595959;
  font-weight: bold;
  line-height: 0;
  text-align: center;
  transition: all 0.1s linear;
}
.ant-input-number-handler:active {
  background: #f4f4f4;
}
.ant-input-number-handler:hover .ant-input-number-handler-up-inner,
.ant-input-number-handler:hover .ant-input-number-handler-down-inner {
  color: #58cefc;
}
.ant-input-number-handler-up-inner,
.ant-input-number-handler-down-inner {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  right: 4px;
  width: 12px;
  height: 12px;
  color: #595959;
  line-height: 12px;
  transition: all 0.1s linear;
  user-select: none;
}
.ant-input-number-handler-up-inner > *,
.ant-input-number-handler-down-inner > * {
  line-height: 1;
}
.ant-input-number-handler-up-inner svg,
.ant-input-number-handler-down-inner svg {
  display: inline-block;
}
.ant-input-number-handler-up-inner::before,
.ant-input-number-handler-down-inner::before {
  display: none;
}
.ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon,
.ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon,
.ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon,
.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon {
  display: block;
}
.ant-input-number:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-input-number-focused {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-input-number-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-input-number-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-input-number-disabled .ant-input-number-input {
  cursor: not-allowed;
}
.ant-input-number-disabled .ant-input-number-handler-wrap {
  display: none;
}
.ant-input-number-input {
  width: 100%;
  height: 34px;
  padding: 0 11px;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 6px;
  outline: 0;
  transition: all 0.3s linear;
  -moz-appearance: textfield !important;
}
.ant-input-number-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-input-number-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-input-number-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-input-number-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-input-number-input[type='number']::-webkit-inner-spin-button,
.ant-input-number-input[type='number']::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.ant-input-number-lg {
  padding: 0;
  font-size: 16px;
}
.ant-input-number-lg input {
  height: 38px;
}
.ant-input-number-sm {
  padding: 0;
}
.ant-input-number-sm input {
  height: 22px;
  padding: 0 7px;
}
.ant-input-number-handler-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 100%;
  background: #fff;
  border-left: 1px solid #d9d9d9;
  border-radius: 0 6px 6px 0;
  opacity: 0;
  transition: opacity 0.24s linear 0.1s;
}
.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,
.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {
  display: inline-block;
  font-size: 12px;
  font-size: 7px \\9;
  transform: scale(0.58333333) rotate(0deg);
  min-width: auto;
  margin-right: 0;
}
:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,
:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {
  font-size: 12px;
}
.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}
.ant-input-number:hover .ant-input-number-handler-wrap {
  opacity: 1;
}
.ant-input-number-handler-up {
  border-top-right-radius: 6px;
  cursor: pointer;
}
.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -5px;
  text-align: center;
}
.ant-input-number-handler-up:hover {
  height: 60% !important;
}
.ant-input-number-handler-down {
  top: 0;
  border-top: 1px solid #d9d9d9;
  border-bottom-right-radius: 6px;
  cursor: pointer;
}
.ant-input-number-handler-down-inner {
  top: 50%;
  margin-top: -6px;
  text-align: center;
}
.ant-input-number-handler-down:hover {
  height: 60% !important;
}
.ant-input-number-handler-up-disabled,
.ant-input-number-handler-down-disabled {
  cursor: not-allowed;
}
.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner,
.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner {
  color: rgba(0, 0, 0, 0.25);
}
.ant-layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  /* fix firefox can't set height smaller than content on flex item */
  min-height: 0;
  background: #f5f5f5;
}
.ant-layout,
.ant-layout * {
  box-sizing: border-box;
}
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}
.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: hidden;
}
.ant-layout-header,
.ant-layout-footer {
  flex: 0 0 auto;
}
.ant-layout-header {
  height: 72px;
  padding: 0 32px;
  line-height: 72px;
  background: #fefefe;
}
.ant-layout-footer {
  padding: 14px 32px;
  color: #545454;
  font-size: 14px;
  background: #fffffe;
}
.ant-layout-content {
  flex: auto;
  /* fix firefox can't set height smaller than content on flex item */
  min-height: 0;
}
.ant-layout-sider {
  position: relative;
  /* fix firefox can't set width smaller than content on flex item */
  min-width: 0;
  background: #003366;
  transition: all 0.2s;
}
.ant-layout-sider-children {
  height: 100%;
  margin-top: -0.1px;
  padding-top: 0.1px;
}
.ant-layout-sider-has-trigger {
  padding-bottom: 30px;
}
.ant-layout-sider-right {
  order: 1;
}
.ant-layout-sider-trigger {
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 30px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  background: #002140;
  cursor: pointer;
  transition: all 0.2s;
}
.ant-layout-sider-zero-width > * {
  overflow: hidden;
}
.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 72px;
  right: -36px;
  z-index: 1;
  width: 36px;
  height: 28px;
  color: #ffffff;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  background: #003366;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-layout-sider-zero-width-trigger:hover {
  background: #194775;
}
.ant-layout-sider-zero-width-trigger-right {
  left: -36px;
  border-radius: 6px 0 0 6px;
}
.ant-layout-sider-light {
  background: #fff;
}
.ant-layout-sider-light .ant-layout-sider-trigger {
  color: #545454;
  background: #fff;
}
.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
  color: #545454;
  background: #fff;
}
.ant-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
}
.ant-list * {
  outline: none;
}
.ant-list-pagination {
  margin-top: 24px;
  text-align: right;
}
.ant-list-pagination .ant-pagination-options {
  text-align: left;
}
.ant-list-more {
  margin-top: 12px;
  text-align: center;
}
.ant-list-more button {
  padding-right: 32px;
  padding-left: 32px;
}
.ant-list-spin {
  min-height: 40px;
  text-align: center;
}
.ant-list-empty-text {
  padding: 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
}
.ant-list-items {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}
.ant-list-item-content {
  color: #545454;
}
.ant-list-item-meta {
  display: flex;
  flex: 1;
  align-items: flex-start;
  font-size: 0;
}
.ant-list-item-meta-avatar {
  margin-right: 16px;
}
.ant-list-item-meta-content {
  flex: 1 0;
}
.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: #545454;
  font-size: 14px;
  line-height: 22px;
}
.ant-list-item-meta-title > a {
  color: #545454;
  transition: all 0.3s;
}
.ant-list-item-meta-title > a:hover {
  color: #2EB1EF;
}
.ant-list-item-meta-description {
  color: #595959;
  font-size: 14px;
  line-height: 22px;
}
.ant-list-item-action {
  flex: 0 0 auto;
  margin-left: 48px;
  padding: 0;
  font-size: 0;
  list-style: none;
}
.ant-list-item-action > li {
  position: relative;
  display: inline-block;
  padding: 0 8px;
  color: #595959;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
}
.ant-list-item-action > li:first-child {
  padding-left: 0;
}
.ant-list-item-action-split {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 14px;
  margin-top: -7px;
  background-color: #e8e8e8;
}
.ant-list-header {
  background: transparent;
}
.ant-list-footer {
  background: transparent;
}
.ant-list-header,
.ant-list-footer {
  padding-top: 12px;
  padding-bottom: 12px;
}
.ant-list-empty {
  padding: 16px 0;
  color: #595959;
  font-size: 12px;
  text-align: center;
}
.ant-list-split .ant-list-item {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-split .ant-list-item:last-child {
  border-bottom: none;
}
.ant-list-split .ant-list-header {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-loading .ant-list-spin-nested-loading {
  min-height: 32px;
}
.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-lg .ant-list-item {
  padding-top: 16px;
  padding-bottom: 16px;
}
.ant-list-sm .ant-list-item {
  padding-top: 8px;
  padding-bottom: 8px;
}
.ant-list-vertical .ant-list-item {
  align-items: initial;
}
.ant-list-vertical .ant-list-item-main {
  display: block;
  flex: 1;
}
.ant-list-vertical .ant-list-item-extra {
  margin-left: 40px;
}
.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 16px;
}
.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 12px;
  color: #535353;
  font-size: 16px;
  line-height: 24px;
}
.ant-list-vertical .ant-list-item-action {
  margin-top: 16px;
  margin-left: auto;
}
.ant-list-vertical .ant-list-item-action > li {
  padding: 0 16px;
}
.ant-list-vertical .ant-list-item-action > li:first-child {
  padding-left: 0;
}
.ant-list-grid .ant-col > .ant-list-item {
  display: block;
  max-width: 100%;
  margin-bottom: 16px;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.ant-list-item-no-flex {
  display: block;
}
.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {
  float: right;
}
.ant-list-bordered {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-list-bordered .ant-list-header {
  padding-right: 24px;
  padding-left: 24px;
}
.ant-list-bordered .ant-list-footer {
  padding-right: 24px;
  padding-left: 24px;
}
.ant-list-bordered .ant-list-item {
  padding-right: 24px;
  padding-left: 24px;
  border-bottom: 1px solid #e8e8e8;
}
.ant-list-bordered .ant-list-pagination {
  margin: 16px 24px;
}
.ant-list-bordered.ant-list-sm .ant-list-item {
  padding-right: 16px;
  padding-left: 16px;
}
.ant-list-bordered.ant-list-sm .ant-list-header,
.ant-list-bordered.ant-list-sm .ant-list-footer {
  padding: 8px 16px;
}
.ant-list-bordered.ant-list-lg .ant-list-header,
.ant-list-bordered.ant-list-lg .ant-list-footer {
  padding: 16px 24px;
}
@media screen and (max-width: 768px) {
  .ant-list-item-action {
    margin-left: 24px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin-left: 24px;
  }
}
@media screen and (max-width: 576px) {
  .ant-list-item {
    flex-wrap: wrap;
  }
  .ant-list-item-action {
    margin-left: 12px;
  }
  .ant-list-vertical .ant-list-item {
    flex-wrap: wrap-reverse;
  }
  .ant-list-vertical .ant-list-item-main {
    min-width: 220px;
  }
  .ant-list-vertical .ant-list-item-extra {
    margin: auto auto 16px;
  }
}
.ant-mentions-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: middle;
}
.ant-mentions-wrapper .ant-mentions-editor {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  display: block;
  height: auto;
  min-height: 36px;
  padding: 0;
  line-height: 1.3;
}
.ant-mentions-wrapper .ant-mentions-editor::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-mentions-wrapper .ant-mentions-editor:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions-wrapper .ant-mentions-editor::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions-wrapper .ant-mentions-editor:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-mentions-wrapper .ant-mentions-editor:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-mentions-wrapper .ant-mentions-editor:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-mentions-wrapper .ant-mentions-editor-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-wrapper .ant-mentions-editor-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-mentions-wrapper .ant-mentions-editor[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-wrapper .ant-mentions-editor[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-mentions-wrapper .ant-mentions-editor {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-mentions-wrapper .ant-mentions-editor-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-mentions-wrapper .ant-mentions-editor-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-mentions-wrapper .ant-mentions-editor-wrapper {
  height: auto;
  overflow-y: auto;
}
.ant-mentions-wrapper.ant-mentions-active:not(.disabled) .ant-mentions-editor {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-mentions-wrapper.disabled .ant-mentions-editor {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-wrapper.disabled .ant-mentions-editor:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-mentions-wrapper .public-DraftEditorPlaceholder-root {
  position: absolute;
  pointer-events: none;
}
.ant-mentions-wrapper .public-DraftEditorPlaceholder-root .public-DraftEditorPlaceholder-inner {
  height: auto;
  padding: 5px 11px;
  color: #bfbfbf;
  white-space: pre-wrap;
  word-wrap: break-word;
  outline: none;
  opacity: 1;
}
.ant-mentions-wrapper .DraftEditor-editorContainer .public-DraftEditor-content {
  height: auto;
  padding: 5px 11px;
}
.ant-mentions-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  min-width: 120px;
  max-height: 250px;
  margin-top: 1.5em;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-mentions-dropdown-placement-top {
  margin-top: -0.1em;
}
.ant-mentions-dropdown-notfound.ant-mentions-dropdown-item {
  color: rgba(0, 0, 0, 0.25);
}
.ant-mentions-dropdown-notfound.ant-mentions-dropdown-item .anticon-loading {
  display: block;
  color: #2EB1EF;
  text-align: center;
}
.ant-mentions-dropdown-item {
  position: relative;
  display: block;
  padding: 5px 12px;
  overflow: hidden;
  color: #545454;
  font-weight: normal;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s;
}
.ant-mentions-dropdown-item:hover {
  background-color: #f0fdff;
}
.ant-mentions-dropdown-item.focus,
.ant-mentions-dropdown-item-active {
  background-color: #f0fdff;
}
.ant-mentions-dropdown-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-mentions-dropdown-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-mentions-dropdown-item-selected,
.ant-mentions-dropdown-item-selected:hover {
  color: #545454;
  font-weight: bold;
  background-color: #f5f5f5;
}
.ant-mentions-dropdown-item-divider {
  height: 1px;
  margin: 1px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-mentions {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
  height: auto;
  padding: 0;
  overflow: hidden;
  line-height: 1.3;
  white-space: pre-wrap;
  vertical-align: bottom;
}
.ant-mentions::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-mentions:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-mentions:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-mentions:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-mentions-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-mentions[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-mentions {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-mentions-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-mentions-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-mentions-disabled > textarea {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-mentions-disabled > textarea:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-mentions-focused {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-mentions > textarea,
.ant-mentions-measure {
  min-height: 34px;
  margin: 0;
  padding: 4px 11px;
  overflow: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-size-adjust: inherit;
  font-stretch: inherit;
  line-height: inherit;
  direction: inherit;
  letter-spacing: inherit;
  white-space: inherit;
  text-align: inherit;
  vertical-align: top;
  word-wrap: break-word;
  word-break: inherit;
  tab-size: inherit;
}
.ant-mentions > textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
}
.ant-mentions > textarea::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-mentions > textarea:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions > textarea::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-mentions > textarea:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-mentions > textarea:read-only {
  cursor: default;
}
.ant-mentions-measure {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  color: transparent;
  pointer-events: none;
}
.ant-mentions-measure > span {
  display: inline-block;
  min-height: 1em;
}
.ant-mentions-dropdown {
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  font-size: 14px;
  font-variant: initial;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-mentions-dropdown-hidden {
  display: none;
}
.ant-mentions-dropdown-menu {
  max-height: 250px;
  margin-bottom: 0;
  padding-left: 0;
  overflow: auto;
  list-style: none;
  outline: none;
}
.ant-mentions-dropdown-menu-item {
  position: relative;
  display: block;
  min-width: 100px;
  padding: 5px 12px;
  overflow: hidden;
  color: #545454;
  font-weight: normal;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-mentions-dropdown-menu-item:hover {
  background-color: #f0fdff;
}
.ant-mentions-dropdown-menu-item:first-child {
  border-radius: 6px 6px 0 0;
}
.ant-mentions-dropdown-menu-item:last-child {
  border-radius: 0 0 6px 6px;
}
.ant-mentions-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-mentions-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-mentions-dropdown-menu-item-selected {
  color: #545454;
  font-weight: 600;
  background-color: #fafafa;
}
.ant-mentions-dropdown-menu-item-active {
  background-color: #f0fdff;
}
.ant-menu {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  margin-bottom: 0;
  padding-left: 0;
  color: #545454;
  line-height: 0;
  list-style: none;
  background: #fff;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: background 0.3s, width 0.2s;
  zoom: 1;
}
.ant-menu::before,
.ant-menu::after {
  display: table;
  content: '';
}
.ant-menu::after {
  clear: both;
}
.ant-menu::before,
.ant-menu::after {
  display: table;
  content: '';
}
.ant-menu::after {
  clear: both;
}
.ant-menu ul,
.ant-menu ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-menu-hidden {
  display: none;
}
.ant-menu-item-group-title {
  padding: 8px 16px;
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
  transition: all 0.3s;
}
.ant-menu-submenu,
.ant-menu-submenu-inline {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-selected {
  color: #2EB1EF;
}
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #f0fdff;
}
.ant-menu-submenu .ant-menu-sub {
  cursor: initial;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-item > a {
  display: block;
  color: #545454;
}
.ant-menu-item > a:hover {
  color: #2EB1EF;
}
.ant-menu-item > a::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  content: '';
}
.ant-menu-item > .ant-badge > a {
  color: #545454;
}
.ant-menu-item > .ant-badge > a:hover {
  color: #2EB1EF;
}
.ant-menu-item-divider {
  height: 1px;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: #2EB1EF;
}
.ant-menu-horizontal .ant-menu-item,
.ant-menu-horizontal .ant-menu-submenu {
  margin-top: -1px;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}
.ant-menu-item-selected {
  color: #2EB1EF;
}
.ant-menu-item-selected > a,
.ant-menu-item-selected > a:hover {
  color: #2EB1EF;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #f0fdff;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 1px solid #e8e8e8;
}
.ant-menu-vertical-right {
  border-left: 1px solid #e8e8e8;
}
.ant-menu-vertical.ant-menu-sub,
.ant-menu-vertical-left.ant-menu-sub,
.ant-menu-vertical-right.ant-menu-sub {
  min-width: 160px;
  padding: 0;
  border-right: 0;
  transform-origin: 0 0;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {
  transform-origin: 0 0;
}
.ant-menu-horizontal.ant-menu-sub {
  min-width: 114px;
}
.ant-menu-item,
.ant-menu-submenu-title {
  position: relative;
  display: block;
  margin: 0;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  min-width: 14px;
  margin-right: 10px;
  font-size: 14px;
  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-item .anticon + span,
.ant-menu-submenu-title .anticon + span {
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu > .ant-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  padding: 0;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: #fff;
  border-radius: 6px;
}
.ant-menu-submenu-popup .submenu-title-wrapper {
  padding-right: 20px;
}
.ant-menu-submenu-popup::before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.0001;
  content: ' ';
}
.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 6px;
}
.ant-menu-submenu > .ant-menu-submenu-title::after {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  position: absolute;
  width: 6px;
  height: 1.5px;
  background: #fff;
  background: #545454 \\9;
  background-image: linear-gradient(to right, #545454, #545454);
  background-image: none \\9;
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: '';
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateY(-2px);
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateY(2px);
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {
  background: linear-gradient(to right, #2EB1EF, #2EB1EF);
}
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  transform: rotate(-45deg) translateX(2px);
}
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  transform: rotate(45deg) translateX(-2px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  transform: translateY(-2px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateX(-2px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateX(2px);
}
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  color: #2EB1EF;
}
.ant-menu-vertical .ant-menu-submenu-selected > a,
.ant-menu-vertical-left .ant-menu-submenu-selected > a,
.ant-menu-vertical-right .ant-menu-submenu-selected > a {
  color: #2EB1EF;
}
.ant-menu-horizontal {
  line-height: 46px;
  white-space: nowrap;
  border: 0;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: none;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: bottom;
  border-bottom: 2px solid transparent;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: #2EB1EF;
  border-bottom: 2px solid #2EB1EF;
}
.ant-menu-horizontal > .ant-menu-item > a {
  display: block;
  color: #545454;
}
.ant-menu-horizontal > .ant-menu-item > a:hover {
  color: #2EB1EF;
}
.ant-menu-horizontal > .ant-menu-item > a::before {
  bottom: -2px;
}
.ant-menu-horizontal > .ant-menu-item-selected > a {
  color: #2EB1EF;
}
.ant-menu-horizontal::after {
  display: block;
  clear: both;
  height: 0;
  content: '\\20';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item {
  position: relative;
}
.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 3px solid #2EB1EF;
  transform: scaleY(0.0001);
  opacity: 0;
  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  content: '';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  height: 42px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 0 16px;
  overflow: hidden;
  font-size: 14px;
  line-height: 42px;
  text-overflow: ellipsis;
}
.ant-menu-vertical .ant-menu-submenu,
.ant-menu-vertical-left .ant-menu-submenu,
.ant-menu-vertical-right .ant-menu-submenu,
.ant-menu-inline .ant-menu-submenu {
  padding-bottom: 0.02px;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 8px;
}
.ant-menu-vertical > .ant-menu-item,
.ant-menu-vertical-left > .ant-menu-item,
.ant-menu-vertical-right > .ant-menu-item,
.ant-menu-inline > .ant-menu-item,
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 42px;
  line-height: 42px;
}
.ant-menu-inline {
  width: 100%;
}
.ant-menu-inline .ant-menu-selected::after,
.ant-menu-inline .ant-menu-item-selected::after {
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  width: calc(100% + 1px);
}
.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 34px;
}
.ant-menu-inline-collapsed {
  width: 80px;
}
.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 32px !important;
  text-overflow: clip;
}
.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none;
}
.ant-menu-inline-collapsed > .ant-menu-item .anticon,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {
  margin: 0;
  font-size: 16px;
  line-height: 42px;
}
.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  display: inline-block;
  max-width: 0;
  opacity: 0;
}
.ant-menu-inline-collapsed-tooltip {
  pointer-events: none;
}
.ant-menu-inline-collapsed-tooltip .anticon {
  display: none;
}
.ant-menu-inline-collapsed-tooltip a {
  color: rgba(255, 255, 255, 0.85);
}
.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-right: 4px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}
.ant-menu-root.ant-menu-vertical,
.ant-menu-root.ant-menu-vertical-left,
.ant-menu-root.ant-menu-vertical-right,
.ant-menu-root.ant-menu-inline {
  box-shadow: none;
}
.ant-menu-sub.ant-menu-inline {
  padding: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 42px;
  line-height: 42px;
  list-style-position: inside;
  list-style-type: disc;
}
.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-left: 32px;
}
.ant-menu-item-disabled,
.ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background: none;
  border-color: transparent !important;
  cursor: not-allowed;
}
.ant-menu-item-disabled > a,
.ant-menu-submenu-disabled > a {
  color: rgba(0, 0, 0, 0.25) !important;
  pointer-events: none;
}
.ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
}
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  color: #038fdd;
  background: #003366;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0.45;
  transition: all 0.3s;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background: #038fdd;
}
.ant-menu-dark.ant-menu-submenu-popup {
  background: transparent;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #004285;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45) inset;
}
.ant-menu-dark.ant-menu-horizontal {
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
  border-color: #003366;
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {
  bottom: 0;
}
.ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-item-group-title,
.ant-menu-dark .ant-menu-item > a {
  color: #038fdd;
}
.ant-menu-dark.ant-menu-inline,
.ant-menu-dark.ant-menu-vertical,
.ant-menu-dark.ant-menu-vertical-left,
.ant-menu-dark.ant-menu-vertical-right {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-vertical .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-open,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu-dark .ant-menu-submenu-title:hover {
  color: #089265;
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item:hover > a,
.ant-menu-dark .ant-menu-item-active > a,
.ant-menu-dark .ant-menu-submenu-active > a,
.ant-menu-dark .ant-menu-submenu-open > a,
.ant-menu-dark .ant-menu-submenu-selected > a,
.ant-menu-dark .ant-menu-submenu-title:hover > a {
  color: #089265;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow {
  opacity: 1;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {
  background: #089265;
}
.ant-menu-dark .ant-menu-item:hover {
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item-selected {
  color: #089265;
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected::after {
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected > a,
.ant-menu-dark .ant-menu-item-selected > a:hover {
  color: #089265;
}
.ant-menu-dark .ant-menu-item-selected .anticon {
  color: #fff;
}
.ant-menu-dark .ant-menu-item-selected .anticon + span {
  color: #fff;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: #ffffff;
}
.ant-menu-dark .ant-menu-item-disabled,
.ant-menu-dark .ant-menu-submenu-disabled,
.ant-menu-dark .ant-menu-item-disabled > a,
.ant-menu-dark .ant-menu-submenu-disabled > a {
  color: rgba(255, 255, 255, 0.35) !important;
  opacity: 0.8;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(255, 255, 255, 0.35) !important;
}
.ant-message {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  top: 16px;
  left: 0;
  z-index: 1010;
  width: 100%;
  pointer-events: none;
}
.ant-message-notice {
  padding: 8px;
  text-align: center;
}
.ant-message-notice:first-child {
  margin-top: -8px;
}
.ant-message-notice-content {
  display: inline-block;
  padding: 10px 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: all;
}
.ant-message-success .anticon {
  color: #52c41a;
}
.ant-message-error .anticon {
  color: #f5222d;
}
.ant-message-warning .anticon {
  color: #fa8c16;
}
.ant-message-info .anticon,
.ant-message-loading .anticon {
  color: #1890ff;
}
.ant-message .anticon {
  position: relative;
  top: 1px;
  margin-right: 8px;
  font-size: 16px;
}
.ant-message-notice.move-up-leave.move-up-leave-active {
  overflow: hidden;
  animation-name: MessageMoveOut;
  animation-duration: 0.3s;
}
@keyframes MessageMoveOut {
  0% {
    max-height: 150px;
    padding: 8px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-modal {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 100px;
  width: auto;
  margin: 0 auto;
  padding-bottom: 24px;
  pointer-events: none;
}
.ant-modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
  -webkit-overflow-scrolling: touch;
}
.ant-modal-title {
  margin: 0;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  word-wrap: break-word;
}
.ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}
.ant-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: #595959;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}
.ant-modal-close-x {
  display: block;
  width: 56px;
  height: 56px;
  font-size: 16px;
  font-style: normal;
  line-height: 56px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
}
.ant-modal-close:focus,
.ant-modal-close:hover {
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
}
.ant-modal-header {
  padding: 16px 24px;
  color: #545454;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.3;
  word-wrap: break-word;
}
.ant-modal-footer {
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-modal-footer button + button {
  margin-bottom: 0;
  margin-left: 8px;
}
.ant-modal.zoom-enter,
.ant-modal.zoom-appear {
  transform: none;
  opacity: 0;
  animation-duration: 0.3s;
  user-select: none;
}
.ant-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
}
.ant-modal-mask-hidden {
  display: none;
}
.ant-modal-open {
  overflow: hidden;
}
.ant-modal-centered {
  text-align: center;
}
.ant-modal-centered::before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.ant-modal-centered .ant-modal {
  top: 0;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(84vw);
    margin: 8px auto;
  }
  .ant-modal-centered .ant-modal {
    flex: 1;
  }
}
.ant-modal-confirm .ant-modal-header {
  display: none;
}
.ant-modal-confirm .ant-modal-close {
  display: none;
}
.ant-modal-confirm .ant-modal-body {
  padding: 32px 32px 24px;
}
.ant-modal-confirm-body-wrapper {
  zoom: 1;
}
.ant-modal-confirm-body-wrapper::before,
.ant-modal-confirm-body-wrapper::after {
  display: table;
  content: '';
}
.ant-modal-confirm-body-wrapper::after {
  clear: both;
}
.ant-modal-confirm-body-wrapper::before,
.ant-modal-confirm-body-wrapper::after {
  display: table;
  content: '';
}
.ant-modal-confirm-body-wrapper::after {
  clear: both;
}
.ant-modal-confirm-body .ant-modal-confirm-title {
  display: block;
  overflow: hidden;
  color: #535353;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
}
.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 8px;
  color: #545454;
  font-size: 14px;
}
.ant-modal-confirm-body > .anticon {
  float: left;
  margin-right: 16px;
  font-size: 22px;
}
.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-left: 38px;
}
.ant-modal-confirm .ant-modal-confirm-btns {
  float: right;
  margin-top: 24px;
}
.ant-modal-confirm .ant-modal-confirm-btns button + button {
  margin-bottom: 0;
  margin-left: 8px;
}
.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {
  color: #f5222d;
}
.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,
.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {
  color: #fa8c16;
}
.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {
  color: #1890ff;
}
.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {
  color: #52c41a;
}
.ant-notification {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: fixed;
  z-index: 1010;
  width: 384px;
  max-width: calc(100vw - 32px);
  margin-right: 24px;
}
.ant-notification-topLeft,
.ant-notification-bottomLeft {
  margin-right: 0;
  margin-left: 24px;
}
.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,
.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationLeftFadeIn;
}
.ant-notification-close-icon {
  font-size: 14px;
  cursor: pointer;
}
.ant-notification-notice {
  position: relative;
  margin-bottom: 16px;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.ant-notification-notice-message {
  display: inline-block;
  margin-bottom: 8px;
  color: #535353;
  font-size: 16px;
  line-height: 24px;
}
.ant-notification-notice-message-single-line-auto-margin {
  display: block;
  width: calc(384px - 24px * 2 - 24px - 48px - 100%);
  max-width: 4px;
  background-color: transparent;
  pointer-events: none;
}
.ant-notification-notice-message-single-line-auto-margin::before {
  display: block;
  content: '';
}
.ant-notification-notice-description {
  font-size: 14px;
}
.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 24px;
}
.ant-notification-notice-with-icon .ant-notification-notice-message {
  margin-bottom: 4px;
  margin-left: 48px;
  font-size: 16px;
}
.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 48px;
  font-size: 14px;
}
.ant-notification-notice-icon {
  position: absolute;
  margin-left: 4px;
  font-size: 24px;
  line-height: 24px;
}
.anticon.ant-notification-notice-icon-success {
  color: #52c41a;
}
.anticon.ant-notification-notice-icon-info {
  color: #1890ff;
}
.anticon.ant-notification-notice-icon-warning {
  color: #fa8c16;
}
.anticon.ant-notification-notice-icon-error {
  color: #f5222d;
}
.ant-notification-notice-close {
  position: absolute;
  top: 16px;
  right: 22px;
  color: #595959;
  outline: none;
}
.ant-notification-notice-close:hover {
  color: #353535;
}
.ant-notification-notice-btn {
  float: right;
  margin-top: 16px;
}
.ant-notification .notification-fade-effect {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
}
.ant-notification-fade-enter,
.ant-notification-fade-appear {
  opacity: 0;
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-notification-fade-leave {
  animation-duration: 0.24s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: both;
  animation-duration: 0.2s;
  animation-play-state: paused;
}
.ant-notification-fade-enter.ant-notification-fade-enter-active,
.ant-notification-fade-appear.ant-notification-fade-appear-active {
  animation-name: NotificationFadeIn;
  animation-play-state: running;
}
.ant-notification-fade-leave.ant-notification-fade-leave-active {
  animation-name: NotificationFadeOut;
  animation-play-state: running;
}
@keyframes NotificationFadeIn {
  0% {
    left: 384px;
    opacity: 0;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes NotificationLeftFadeIn {
  0% {
    right: 384px;
    opacity: 0;
  }
  100% {
    right: 0;
    opacity: 1;
  }
}
@keyframes NotificationFadeOut {
  0% {
    max-height: 150px;
    margin-bottom: 16px;
    padding-top: 16px 24px;
    padding-bottom: 16px 24px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
  }
}
.ant-page-header {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding: 16px 24px;
  background-color: #fff;
}
.ant-page-header-ghost {
  background-color: inherit;
}
.ant-page-header.has-breadcrumb {
  padding-top: 12px;
}
.ant-page-header.has-footer {
  padding-bottom: 0;
}
.ant-page-header-back {
  float: left;
  margin: 8px 0;
  margin-right: 16px;
  font-size: 16px;
  line-height: 1;
}
.ant-page-header-back-button {
  color: #2EB1EF;
  text-decoration: none;
  outline: none;
  transition: color 0.3s;
  color: #000;
  cursor: pointer;
}
.ant-page-header-back-button:focus,
.ant-page-header-back-button:hover {
  color: #58cefc;
}
.ant-page-header-back-button:active {
  color: #1c8dc9;
}
.ant-page-header .ant-divider-vertical {
  height: 14px;
  margin: 0 12px;
  vertical-align: middle;
}
.ant-breadcrumb + .ant-page-header-heading {
  margin-top: 8px;
}
.ant-page-header-heading {
  width: 100%;
  overflow: hidden;
}
.ant-page-header-heading-title {
  display: block;
  float: left;
  margin-bottom: 0;
  padding-right: 12px;
  color: #535353;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.ant-page-header-heading .ant-avatar {
  float: left;
  margin-right: 12px;
}
.ant-page-header-heading-sub-title {
  float: left;
  margin: 5px 0;
  margin-right: 12px;
  color: #595959;
  font-size: 14px;
  line-height: 22px;
}
.ant-page-header-heading-tags {
  float: left;
  margin: 4px 0;
}
.ant-page-header-heading-extra {
  float: right;
}
.ant-page-header-heading-extra > * {
  margin-left: 8px;
}
.ant-page-header-heading-extra > *:first-child {
  margin-left: 0;
}
.ant-page-header-content {
  padding-top: 12px;
  overflow: hidden;
}
.ant-page-header-footer {
  margin-top: 16px;
}
.ant-page-header-footer .ant-tabs-bar {
  margin-bottom: 1px;
  border-bottom: 0;
}
.ant-page-header-footer .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
  padding: 8px;
  font-size: 16px;
}
@media (max-width: 576px) {
  .ant-page-header-heading-extra {
    display: block;
    float: unset;
    width: 100%;
    padding-top: 12px;
    overflow: hidden;
  }
}
.ant-pagination {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-pagination ul,
.ant-pagination ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-pagination::after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: ' ';
}
.ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-right: 8px;
  line-height: 30px;
  vertical-align: middle;
}
.ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: Arial;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: 0;
  cursor: pointer;
  user-select: none;
}
.ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: #545454;
  transition: none;
}
.ant-pagination-item a:hover {
  text-decoration: none;
}
.ant-pagination-item:focus,
.ant-pagination-item:hover {
  border-color: #2EB1EF;
  transition: all 0.3s;
}
.ant-pagination-item:focus a,
.ant-pagination-item:hover a {
  color: #2EB1EF;
}
.ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #2EB1EF;
}
.ant-pagination-item-active a {
  color: #2EB1EF;
}
.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  border-color: #58cefc;
}
.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  color: #58cefc;
}
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  outline: 0;
}
.ant-pagination-jump-prev .ant-pagination-item-container,
.ant-pagination-jump-next .ant-pagination-item-container {
  position: relative;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  display: inline-block;
  font-size: 12px;
  font-size: 12px \\9;
  transform: scale(1) rotate(0deg);
  color: #2EB1EF;
  letter-spacing: -1px;
  opacity: 0;
  transition: all 0.2s;
}
:root .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
:root .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  font-size: 12px;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  color: rgba(0, 0, 0, 0.25);
  letter-spacing: 2px;
  text-align: center;
  text-indent: 0.13em;
  opacity: 1;
  transition: all 0.2s;
}
.ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,
.ant-pagination-jump-next:focus .ant-pagination-item-link-icon,
.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,
.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {
  opacity: 1;
}
.ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,
.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {
  opacity: 0;
}
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  margin-right: 8px;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  color: #545454;
  font-family: Arial;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-pagination-prev,
.ant-pagination-next {
  outline: 0;
}
.ant-pagination-prev a,
.ant-pagination-next a {
  color: #545454;
  user-select: none;
}
.ant-pagination-prev:hover a,
.ant-pagination-next:hover a {
  border-color: #58cefc;
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  display: block;
  height: 100%;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
  transition: all 0.3s;
}
.ant-pagination-prev:focus .ant-pagination-item-link,
.ant-pagination-next:focus .ant-pagination-item-link,
.ant-pagination-prev:hover .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link {
  color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-pagination-disabled,
.ant-pagination-disabled:hover,
.ant-pagination-disabled:focus {
  cursor: not-allowed;
}
.ant-pagination-disabled a,
.ant-pagination-disabled:hover a,
.ant-pagination-disabled:focus a,
.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-disabled:hover .ant-pagination-item-link,
.ant-pagination-disabled:focus .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-slash {
  margin: 0 10px 0 5px;
}
.ant-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}
.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  width: auto;
  margin-right: 8px;
}
.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  vertical-align: top;
}
.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  width: 50px;
  margin: 0 8px;
}
.ant-pagination-options-quick-jumper input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-pagination-options-quick-jumper input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-pagination-options-quick-jumper input:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-pagination-options-quick-jumper input:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-pagination-options-quick-jumper input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-pagination-options-quick-jumper input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-pagination-options-quick-jumper input-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-pagination-options-quick-jumper input-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-pagination-simple .ant-pagination-prev,
.ant-pagination-simple .ant-pagination-next {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {
  height: 24px;
  border: 0;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}
.ant-pagination-simple .ant-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.3s;
}
.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #2EB1EF;
}
.ant-pagination.mini .ant-pagination-total-text,
.ant-pagination.mini .ant-pagination-simple-pager {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-item {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
}
.ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.mini .ant-pagination-prev,
.ant-pagination.mini .ant-pagination-next {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-jump-prev,
.ant-pagination.mini .ant-pagination-jump-next {
  height: 24px;
  margin-right: 0;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-options {
  margin-left: 2px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper input {
  height: 24px;
  padding: 1px 7px;
  width: 44px;
}
.ant-pagination.ant-pagination-disabled {
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background: #dbdbdb;
  border-color: transparent;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
  color: #fff;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:hover,
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:focus {
  color: #595959;
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-link-icon {
  opacity: 0;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {
  opacity: 1;
}
@media only screen and (max-width: 992px) {
  .ant-pagination-item-after-jump-prev,
  .ant-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .ant-pagination-options {
    display: none;
  }
}
.ant-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  font-weight: normal;
  white-space: normal;
  text-align: left;
  cursor: auto;
  user-select: text;
}
.ant-popover::after {
  position: absolute;
  background: rgba(255, 255, 255, 0.01);
  content: '';
}
.ant-popover-hidden {
  display: none;
}
.ant-popover-placement-top,
.ant-popover-placement-topLeft,
.ant-popover-placement-topRight {
  padding-bottom: 10px;
}
.ant-popover-placement-right,
.ant-popover-placement-rightTop,
.ant-popover-placement-rightBottom {
  padding-left: 10px;
}
.ant-popover-placement-bottom,
.ant-popover-placement-bottomLeft,
.ant-popover-placement-bottomRight {
  padding-top: 10px;
}
.ant-popover-placement-left,
.ant-popover-placement-leftTop,
.ant-popover-placement-leftBottom {
  padding-right: 10px;
}
.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15) \\9;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-popover {
    /* IE10+ */
  }
  .ant-popover-inner {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}
.ant-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: #535353;
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
}
.ant-popover-inner-content {
  padding: 12px 16px;
  color: #545454;
}
.ant-popover-message {
  position: relative;
  padding: 4px 0 12px;
  color: #545454;
  font-size: 14px;
}
.ant-popover-message > .anticon {
  position: absolute;
  top: 8px;
  color: #fa8c16;
  font-size: 14px;
}
.ant-popover-message-title {
  padding-left: 22px;
}
.ant-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}
.ant-popover-buttons button {
  margin-left: 8px;
}
.ant-popover-arrow {
  position: absolute;
  display: block;
  width: 8.48528137px;
  height: 8.48528137px;
  background: transparent;
  border-style: solid;
  border-width: 4.24264069px;
  transform: rotate(45deg);
}
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {
  bottom: 6.2px;
  border-top-color: transparent;
  border-right-color: #fff;
  border-bottom-color: #fff;
  border-left-color: transparent;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
}
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}
.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {
  left: 6px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: #fff;
  border-left-color: #fff;
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
}
.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}
.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {
  bottom: 12px;
}
.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  top: 6px;
  border-top-color: #fff;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #fff;
  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);
}
.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}
.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,
.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {
  right: 6px;
  border-top-color: #fff;
  border-right-color: #fff;
  border-bottom-color: transparent;
  border-left-color: transparent;
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
}
.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}
.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {
  bottom: 12px;
}
.ant-progress {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-progress-line {
  position: relative;
  width: 100%;
  font-size: 14px;
}
.ant-progress-small.ant-progress-line,
.ant-progress-small.ant-progress-line .ant-progress-text .anticon {
  font-size: 12px;
}
.ant-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}
.ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-2em - 8px);
  padding-right: calc(2em + 8px);
}
.ant-progress-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  background-color: #f5f5f5;
  border-radius: 100px;
}
.ant-progress-circle-trail {
  stroke: #f5f5f5;
}
.ant-progress-circle-path {
  animation: ant-progress-appear 0.3s;
}
.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #2EB1EF;
}
.ant-progress-success-bg,
.ant-progress-bg {
  position: relative;
  background-color: #2EB1EF;
  border-radius: 100px;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}
.ant-progress-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #52c41a;
}
.ant-progress-text {
  display: inline-block;
  width: 2em;
  margin-left: 8px;
  color: #595959;
  font-size: 1em;
  line-height: 1;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  word-break: normal;
}
.ant-progress-text .anticon {
  font-size: 14px;
}
.ant-progress-status-active .ant-progress-bg::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  content: '';
}
.ant-progress-status-exception .ant-progress-bg {
  background-color: #f5222d;
}
.ant-progress-status-exception .ant-progress-text {
  color: #f5222d;
}
.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #f5222d;
}
.ant-progress-status-success .ant-progress-bg {
  background-color: #52c41a;
}
.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}
.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {
  stroke: #52c41a;
}
.ant-progress-circle .ant-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}
.ant-progress-circle .ant-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  margin: 0;
  padding: 0;
  color: #545454;
  line-height: 1;
  white-space: normal;
  text-align: center;
  transform: translate(-50%, -50%);
}
.ant-progress-circle .ant-progress-text .anticon {
  font-size: 1.16666667em;
}
.ant-progress-circle.ant-progress-status-exception .ant-progress-text {
  color: #f5222d;
}
.ant-progress-circle.ant-progress-status-success .ant-progress-text {
  color: #52c41a;
}
@keyframes ant-progress-active {
  0% {
    width: 0;
    opacity: 0.1;
  }
  20% {
    width: 0;
    opacity: 0.5;
  }
  100% {
    width: 100%;
    opacity: 0;
  }
}
.ant-radio-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-radio-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  margin-right: 8px;
  white-space: nowrap;
  cursor: pointer;
}
.ant-radio {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  vertical-align: sub;
  outline: none;
  cursor: pointer;
}
.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus + .ant-radio-inner {
  border-color: #2EB1EF;
}
.ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px rgba(46, 177, 239, 0.08);
}
.ant-radio-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #2EB1EF;
  border-radius: 50%;
  visibility: hidden;
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: both;
  content: '';
}
.ant-radio:hover::after,
.ant-radio-wrapper:hover .ant-radio::after {
  visibility: visible;
}
.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-color: #d9d9d9;
  border-style: solid;
  border-width: 1px;
  border-radius: 100px;
  transition: all 0.3s;
}
.ant-radio-inner::after {
  position: absolute;
  top: 3px;
  left: 3px;
  display: table;
  width: 8px;
  height: 8px;
  background-color: #2EB1EF;
  border-top: 0;
  border-left: 0;
  border-radius: 8px;
  transform: scale(0);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: ' ';
}
.ant-radio-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}
.ant-radio-checked .ant-radio-inner {
  border-color: #2EB1EF;
}
.ant-radio-checked .ant-radio-inner::after {
  transform: scale(1);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-radio-disabled .ant-radio-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
  cursor: not-allowed;
}
.ant-radio-disabled .ant-radio-inner::after {
  background-color: rgba(0, 0, 0, 0.2);
}
.ant-radio-disabled .ant-radio-input {
  cursor: not-allowed;
}
.ant-radio-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
span.ant-radio + * {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-radio-button-wrapper {
  position: relative;
  display: inline-block;
  height: 36px;
  margin: 0;
  padding: 0 15px;
  color: #545454;
  line-height: 34px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-left: 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s;
}
.ant-radio-button-wrapper a {
  color: #545454;
}
.ant-radio-button-wrapper > .ant-radio-button {
  display: block;
  width: 0;
  height: 0;
  margin-left: 0;
}
.ant-radio-group-large .ant-radio-button-wrapper {
  height: 40px;
  font-size: 16px;
  line-height: 38px;
}
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 24px;
  padding: 0 7px;
  line-height: 22px;
}
.ant-radio-button-wrapper:not(:first-child)::before {
  position: absolute;
  top: 0;
  left: -1px;
  display: block;
  width: 1px;
  height: 100%;
  background-color: #d9d9d9;
  content: '';
}
.ant-radio-button-wrapper:first-child {
  border-left: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
}
.ant-radio-button-wrapper:last-child {
  border-radius: 0 6px 6px 0;
}
.ant-radio-button-wrapper:first-child:last-child {
  border-radius: 6px;
}
.ant-radio-button-wrapper:hover {
  position: relative;
  color: #2EB1EF;
}
.ant-radio-button-wrapper:focus-within {
  outline: 3px solid rgba(46, 177, 239, 0.06);
}
.ant-radio-button-wrapper .ant-radio-inner,
.ant-radio-button-wrapper input[type='checkbox'],
.ant-radio-button-wrapper input[type='radio'] {
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  z-index: 1;
  color: #2EB1EF;
  background: #fff;
  border-color: #2EB1EF;
  box-shadow: -1px 0 0 0 #2EB1EF;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: #2EB1EF !important;
  opacity: 0.1;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
  border-color: #2EB1EF;
  box-shadow: none !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #58cefc;
  border-color: #58cefc;
  box-shadow: -1px 0 0 0 #58cefc;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #1c8dc9;
  border-color: #1c8dc9;
  box-shadow: -1px 0 0 0 #1c8dc9;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  outline: 3px solid rgba(46, 177, 239, 0.06);
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
  background: #58cefc;
  border-color: #58cefc;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #fff;
  background: #1c8dc9;
  border-color: #1c8dc9;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  outline: 3px solid rgba(46, 177, 239, 0.06);
}
.ant-radio-button-wrapper-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-radio-button-wrapper-disabled:first-child,
.ant-radio-button-wrapper-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
.ant-radio-button-wrapper-disabled:first-child {
  border-left-color: #d9d9d9;
}
.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: #fff;
  background-color: #e6e6e6;
  border-color: #d9d9d9;
  box-shadow: none;
}
@keyframes antRadioEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
@supports (-moz-appearance: meterbar) and (background-blend-mode: difference, normal) {
  .ant-radio {
    vertical-align: text-bottom;
  }
}
.ant-rate {
  box-sizing: border-box;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  display: inline-block;
  margin: 0;
  padding: 0;
  color: #fadb14;
  font-size: 20px;
  line-height: unset;
  list-style: none;
  outline: none;
}
.ant-rate-disabled .ant-rate-star {
  cursor: default;
}
.ant-rate-disabled .ant-rate-star:hover {
  transform: scale(1);
}
.ant-rate-star {
  position: relative;
  display: inline-block;
  margin: 0;
  padding: 0;
  color: inherit;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-rate-star:not(:last-child) {
  margin-right: 8px;
}
.ant-rate-star > div:focus {
  outline: 0;
}
.ant-rate-star > div:hover,
.ant-rate-star > div:focus {
  transform: scale(1.1);
}
.ant-rate-star-first,
.ant-rate-star-second {
  color: #e8e8e8;
  transition: all 0.3s;
  user-select: none;
}
.ant-rate-star-first .anticon,
.ant-rate-star-second .anticon {
  vertical-align: middle;
}
.ant-rate-star-first {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
}
.ant-rate-star-half .ant-rate-star-first,
.ant-rate-star-half .ant-rate-star-second {
  opacity: 1;
}
.ant-rate-star-half .ant-rate-star-first,
.ant-rate-star-full .ant-rate-star-second {
  color: inherit;
}
.ant-rate-text {
  display: inline-block;
  margin-left: 8px;
  font-size: 14px;
}
.ant-result {
  padding: 48px 32px;
}
.ant-result-success .ant-result-icon > .anticon {
  color: #52c41a;
}
.ant-result-error .ant-result-icon > .anticon {
  color: #f5222d;
}
.ant-result-info .ant-result-icon > .anticon {
  color: #1890ff;
}
.ant-result-warning .ant-result-icon > .anticon {
  color: #fa8c16;
}
.ant-result-image {
  width: 250px;
  height: 295px;
  margin: auto;
}
.ant-result-icon {
  margin-bottom: 24px;
  text-align: center;
}
.ant-result-icon > .anticon {
  font-size: 72px;
}
.ant-result-title {
  color: #535353;
  font-size: 24px;
  line-height: 1.8;
  text-align: center;
}
.ant-result-subtitle {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
.ant-result-extra {
  margin-top: 32px;
  text-align: center;
}
.ant-result-extra > * {
  margin-right: 8px;
}
.ant-result-extra > *:last-child {
  margin-right: 0;
}
.ant-result-content {
  margin-top: 24px;
  padding: 24px 40px;
  background-color: #fafafa;
}
.ant-select {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  outline: 0;
}
.ant-select ul,
.ant-select ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-select > ul > li > a {
  padding: 0;
  background-color: #fff;
}
.ant-select-arrow {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  transform-origin: 50% 50%;
}
.ant-select-arrow > * {
  line-height: 1;
}
.ant-select-arrow svg {
  display: inline-block;
}
.ant-select-arrow::before {
  display: none;
}
.ant-select-arrow .ant-select-arrow-icon {
  display: block;
}
.ant-select-arrow .ant-select-arrow-icon svg {
  transition: transform 0.3s;
}
.ant-select-selection {
  display: block;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 6px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
}
.ant-select-selection:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-select-selection__clear {
  position: absolute;
  top: 50%;
  right: 11px;
  z-index: 1;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  text-align: center;
  text-transform: none;
  background: #fff;
  cursor: pointer;
  opacity: 0;
  transition: color 0.3s ease, opacity 0.15s ease;
  text-rendering: auto;
}
.ant-select-selection__clear::before {
  display: block;
}
.ant-select-selection__clear:hover {
  color: #595959;
}
.ant-select-selection:hover .ant-select-selection__clear {
  opacity: 1;
}
.ant-select-selection-selected-value {
  float: left;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-select-no-arrow .ant-select-selection-selected-value {
  padding-right: 0;
}
.ant-select-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-disabled .ant-select-selection {
  background: #f5f5f5;
  cursor: not-allowed;
}
.ant-select-disabled .ant-select-selection:hover,
.ant-select-disabled .ant-select-selection:focus,
.ant-select-disabled .ant-select-selection:active {
  border-color: #d9d9d9;
  box-shadow: none;
}
.ant-select-disabled .ant-select-selection__clear {
  display: none;
  visibility: hidden;
  pointer-events: none;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.33);
  background: #f5f5f5;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {
  display: none;
}
.ant-select-selection--single {
  position: relative;
  height: 36px;
  cursor: pointer;
}
.ant-select-selection--single .ant-select-selection__rendered {
  margin-right: 24px;
}
.ant-select-no-arrow .ant-select-selection__rendered {
  margin-right: 11px;
}
.ant-select-selection__rendered {
  position: relative;
  display: block;
  margin-right: 11px;
  margin-left: 11px;
  line-height: 34px;
}
.ant-select-selection__rendered::after {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '.';
  pointer-events: none;
}
.ant-select-lg {
  font-size: 16px;
}
.ant-select-lg .ant-select-selection--single {
  height: 40px;
}
.ant-select-lg .ant-select-selection__rendered {
  line-height: 38px;
}
.ant-select-lg .ant-select-selection--multiple {
  min-height: 40px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 32px;
  line-height: 32px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear,
.ant-select-lg .ant-select-selection--multiple .ant-select-arrow {
  top: 20px;
}
.ant-select-sm .ant-select-selection--single {
  height: 24px;
}
.ant-select-sm .ant-select-selection__rendered {
  margin-left: 7px;
  line-height: 22px;
}
.ant-select-sm .ant-select-selection--multiple {
  min-height: 24px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 16px;
  line-height: 14px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear,
.ant-select-sm .ant-select-selection--multiple .ant-select-arrow {
  top: 12px;
}
.ant-select-sm .ant-select-selection__clear,
.ant-select-sm .ant-select-arrow {
  right: 8px;
}
.ant-select-disabled .ant-select-selection__choice__remove {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
}
.ant-select-disabled .ant-select-selection__choice__remove:hover {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-search__field__wrap {
  position: relative;
  display: inline-block;
}
.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  position: absolute;
  top: 50%;
  right: 9px;
  left: 0;
  max-width: 100%;
  height: 20px;
  margin-top: -10px;
  overflow: hidden;
  color: #bfbfbf;
  line-height: 20px;
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
}
.ant-select-search__field__placeholder {
  left: 12px;
}
.ant-select-search__field__mirror {
  position: absolute;
  top: 0;
  left: 0;
  white-space: pre;
  opacity: 0;
  pointer-events: none;
}
.ant-select-search--inline {
  position: absolute;
  width: 100%;
  height: 100%;
}
.ant-select-search--inline .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-search--inline .ant-select-search__field {
  width: 100%;
  height: 100%;
  font-size: 100%;
  line-height: 1;
  background: transparent;
  border-width: 0;
  border-radius: 6px;
  outline: 0;
}
.ant-select-search--inline > i {
  float: right;
}
.ant-select-selection--multiple {
  min-height: 36px;
  padding-bottom: 3px;
  cursor: text;
  zoom: 1;
}
.ant-select-selection--multiple::before,
.ant-select-selection--multiple::after {
  display: table;
  content: '';
}
.ant-select-selection--multiple::after {
  clear: both;
}
.ant-select-selection--multiple::before,
.ant-select-selection--multiple::after {
  display: table;
  content: '';
}
.ant-select-selection--multiple::after {
  clear: both;
}
.ant-select-selection--multiple .ant-select-search--inline {
  position: static;
  float: left;
  width: auto;
  max-width: 100%;
  padding: 0;
}
.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {
  width: 0.75em;
  max-width: 100%;
  padding: 1px;
}
.ant-select-selection--multiple .ant-select-selection__rendered {
  height: auto;
  margin-bottom: -3px;
  margin-left: 5px;
}
.ant-select-selection--multiple .ant-select-selection__placeholder {
  margin-left: 6px;
}
.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  height: 28px;
  margin-top: 3px;
  line-height: 26px;
}
.ant-select-selection--multiple .ant-select-selection__choice {
  position: relative;
  float: left;
  max-width: 99%;
  margin-right: 4px;
  padding: 0 20px 0 10px;
  overflow: hidden;
  color: #545454;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection--multiple .ant-select-selection__choice__disabled {
  padding: 0 10px;
}
.ant-select-selection--multiple .ant-select-selection__choice__content {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection--multiple .ant-select-selection__choice__remove {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  right: 4px;
  color: #595959;
  font-weight: bold;
  line-height: inherit;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
.ant-select-selection--multiple .ant-select-selection__choice__remove > * {
  line-height: 1;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove svg {
  display: inline-block;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove::before {
  display: none;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove .ant-select-selection--multiple .ant-select-selection__choice__remove-icon {
  display: block;
}
:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 12px;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-select-selection--multiple .ant-select-selection__clear,
.ant-select-selection--multiple .ant-select-arrow {
  top: 18px;
}
.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,
.ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-open .ant-select-arrow-icon svg {
  transform: rotate(180deg);
}
.ant-select-open .ant-select-selection {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-select-combobox .ant-select-arrow {
  display: none;
}
.ant-select-combobox .ant-select-search--inline {
  float: none;
  width: 100%;
  height: 100%;
}
.ant-select-combobox .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-combobox .ant-select-search__field {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  box-shadow: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0s;
}
.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered,
.ant-select-combobox.ant-select-show-arrow .ant-select-selection:hover .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-dropdown {
  margin: 0;
  padding: 0;
  color: #545454;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: 1050;
  box-sizing: border-box;
  font-size: 14px;
  font-variant: initial;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}
.ant-select-dropdown-hidden {
  display: none;
}
.ant-select-dropdown-menu {
  max-height: 250px;
  margin-bottom: 0;
  padding: 4px 0;
  padding-left: 0;
  overflow: auto;
  list-style: none;
  outline: none;
}
.ant-select-dropdown-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {
  padding-left: 20px;
}
.ant-select-dropdown-menu-item-group-title {
  height: 32px;
  padding: 0 12px;
  color: #595959;
  font-size: 12px;
  line-height: 32px;
}
.ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:first-child:not(:last-child),
.ant-select-dropdown-menu-item-group:not(:last-child) .ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:last-child {
  border-radius: 0;
}
.ant-select-dropdown-menu-item {
  position: relative;
  display: block;
  padding: 5px 12px;
  overflow: hidden;
  color: #545454;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
}
.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
  background-color: #f0fdff;
}
.ant-select-dropdown-menu-item-selected {
  color: #545454;
  font-weight: 600;
  background-color: #fafafa;
}
.ant-select-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
  background-color: #f0fdff;
}
.ant-select-dropdown-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  overflow: hidden;
  line-height: 0;
  background-color: #e8e8e8;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {
  padding-right: 32px;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item .ant-select-selected-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  color: transparent;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;
  transform: translateY(-50%);
  transition: all 0.2s;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover .ant-select-selected-icon {
  color: rgba(0, 0, 0, 0.87);
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled .ant-select-selected-icon {
  display: none;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected .ant-select-selected-icon,
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover .ant-select-selected-icon {
  display: inline-block;
  color: #2EB1EF;
}
.ant-select-dropdown--empty.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {
  padding-right: 12px;
}
.ant-select-dropdown-container-open .ant-select-dropdown,
.ant-select-dropdown-open .ant-select-dropdown {
  display: block;
}
.ant-skeleton {
  display: table;
  width: 100%;
}
.ant-skeleton-header {
  display: table-cell;
  padding-right: 16px;
  vertical-align: top;
}
.ant-skeleton-header .ant-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: #f2f2f2;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-header .ant-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-header .ant-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {
  border-radius: 50%;
}
.ant-skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}
.ant-skeleton-content .ant-skeleton-title {
  width: 100%;
  height: 16px;
  margin-top: 16px;
  background: #f2f2f2;
}
.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 24px;
}
.ant-skeleton-content .ant-skeleton-paragraph {
  padding: 0;
}
.ant-skeleton-content .ant-skeleton-paragraph > li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: #f2f2f2;
}
.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {
  width: 61%;
}
.ant-skeleton-content .ant-skeleton-paragraph > li + li {
  margin-top: 16px;
}
.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {
  margin-top: 12px;
}
.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
  margin-top: 28px;
}
.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,
.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: ant-skeleton-loading 1.4s ease infinite;
}
.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar {
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: ant-skeleton-loading 1.4s ease infinite;
}
@keyframes ant-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.ant-slider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  height: 12px;
  margin: 14px 6px 10px;
  padding: 4px 0;
  cursor: pointer;
  touch-action: none;
}
.ant-slider-vertical {
  width: 12px;
  height: 100%;
  margin: 6px 10px;
  padding: 0 4px;
}
.ant-slider-vertical .ant-slider-rail {
  width: 4px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-track {
  width: 4px;
}
.ant-slider-vertical .ant-slider-handle {
  margin-bottom: -7px;
  margin-left: -5px;
}
.ant-slider-vertical .ant-slider-mark {
  top: 0;
  left: 12px;
  width: 18px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-mark-text {
  left: 4px;
  white-space: nowrap;
}
.ant-slider-vertical .ant-slider-step {
  width: 4px;
  height: 100%;
}
.ant-slider-vertical .ant-slider-dot {
  top: auto;
  left: 2px;
  margin-bottom: -4px;
}
.ant-slider-tooltip .ant-tooltip-inner {
  min-width: unset;
}
.ant-slider-with-marks {
  margin-bottom: 28px;
}
.ant-slider-rail {
  position: absolute;
  width: 100%;
  height: 4px;
  background-color: #f5f5f5;
  border-radius: 4px;
  transition: background-color 0.3s;
}
.ant-slider-track {
  position: absolute;
  height: 4px;
  background-color: #abedff;
  border-radius: 6px;
  transition: background-color 0.3s;
}
.ant-slider-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  margin-top: -5px;
  background-color: #fff;
  border: solid 2px #abedff;
  border-radius: 50%;
  box-shadow: 0;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}
.ant-slider-handle:focus {
  border-color: #58c1f2;
  outline: none;
  box-shadow: 0 0 0 5px rgba(46, 177, 239, 0.2);
}
.ant-slider-handle.ant-tooltip-open {
  border-color: #2EB1EF;
}
.ant-slider:hover .ant-slider-rail {
  background-color: #e1e1e1;
}
.ant-slider:hover .ant-slider-track {
  background-color: #82e0ff;
}
.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #82e0ff;
}
.ant-slider-mark {
  position: absolute;
  top: 14px;
  left: 0;
  width: 100%;
  font-size: 14px;
}
.ant-slider-mark-text {
  position: absolute;
  display: inline-block;
  color: #595959;
  text-align: center;
  word-break: keep-all;
  cursor: pointer;
}
.ant-slider-mark-text-active {
  color: #545454;
}
.ant-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}
.ant-slider-dot {
  position: absolute;
  top: -2px;
  width: 8px;
  height: 8px;
  margin-left: -4px;
  background-color: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 50%;
  cursor: pointer;
}
.ant-slider-dot:first-child {
  margin-left: -4px;
}
.ant-slider-dot:last-child {
  margin-left: -4px;
}
.ant-slider-dot-active {
  border-color: #97d8f7;
}
.ant-slider-disabled {
  cursor: not-allowed;
}
.ant-slider-disabled .ant-slider-track {
  background-color: rgba(0, 0, 0, 0.25) !important;
}
.ant-slider-disabled .ant-slider-handle,
.ant-slider-disabled .ant-slider-dot {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: none;
  cursor: not-allowed;
}
.ant-slider-disabled .ant-slider-mark-text,
.ant-slider-disabled .ant-slider-dot {
  cursor: not-allowed !important;
}
.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  display: none;
  color: #2EB1EF;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-spin-spinning {
  position: static;
  display: inline-block;
  opacity: 1;
}
.ant-spin-nested-loading {
  position: relative;
}
.ant-spin-nested-loading > div > .ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
}
.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 2px;
}
.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 11px;
}
.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}
.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
}
.ant-spin-container::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none \\9;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
  transition: all 0.3s;
  content: '';
  pointer-events: none;
}
.ant-spin-blur {
  clear: both;
  overflow: hidden;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
}
.ant-spin-blur::after {
  opacity: 0.4;
  pointer-events: auto;
}
.ant-spin-tip {
  color: #595959;
}
.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
}
.ant-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: #2EB1EF;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s infinite linear alternate;
}
.ant-spin-dot-item:nth-child(1) {
  top: 0;
  left: 0;
}
.ant-spin-dot-item:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}
.ant-spin-dot-item:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}
.ant-spin-dot-item:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}
.ant-spin-dot-spin {
  transform: rotate(45deg);
  animation: antRotate 1.2s infinite linear;
}
.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
}
.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}
.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
}
.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}
.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ */
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@keyframes antRotate {
  to {
    transform: rotate(405deg);
  }
}
.ant-statistic {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-statistic-title {
  margin-bottom: 4px;
  color: #595959;
  font-size: 14px;
}
.ant-statistic-content {
  color: #535353;
  font-size: 24px;
  font-family: "DM Sans", sans-serif;
}
.ant-statistic-content-value-decimal {
  font-size: 16px;
}
.ant-statistic-content-prefix,
.ant-statistic-content-suffix {
  display: inline-block;
}
.ant-statistic-content-prefix {
  margin-right: 4px;
}
.ant-statistic-content-suffix {
  margin-left: 4px;
  font-size: 16px;
}
.ant-steps {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: flex;
  width: 100%;
  font-size: 0;
}
.ant-steps-item {
  position: relative;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  vertical-align: top;
}
.ant-steps-item-container {
  outline: none;
}
.ant-steps-item:last-child {
  flex: none;
}
.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail,
.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  display: none;
}
.ant-steps-item-icon,
.ant-steps-item-content {
  display: inline-block;
  vertical-align: top;
}
.ant-steps-item-icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  font-size: 16px;
  font-family: "DM Sans", sans-serif;
  line-height: 32px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  transition: background-color 0.3s, border-color 0.3s;
}
.ant-steps-item-icon > .ant-steps-icon {
  position: relative;
  top: -1px;
  color: #2EB1EF;
  line-height: 1;
}
.ant-steps-item-tail {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  padding: 0 10px;
}
.ant-steps-item-tail::after {
  display: inline-block;
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  border-radius: 1px;
  transition: background 0.3s;
  content: '';
}
.ant-steps-item-title {
  position: relative;
  display: inline-block;
  padding-right: 16px;
  color: #545454;
  font-size: 16px;
  line-height: 32px;
}
.ant-steps-item-title::after {
  position: absolute;
  top: 16px;
  left: 100%;
  display: block;
  width: 9999px;
  height: 1px;
  background: #e8e8e8;
  content: '';
}
.ant-steps-item-subtitle {
  display: inline;
  margin-left: 8px;
  color: #595959;
  font-weight: normal;
  font-size: 14px;
}
.ant-steps-item-description {
  color: #595959;
  font-size: 14px;
}
.ant-steps-item-wait .ant-steps-item-icon {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: rgba(0, 0, 0, 0.25);
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #595959;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #595959;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process .ant-steps-item-icon {
  background-color: #fff;
  border-color: #2EB1EF;
}
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #2EB1EF;
}
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #2EB1EF;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #535353;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #545454;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item-process .ant-steps-item-icon {
  background: #2EB1EF;
}
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #fff;
}
.ant-steps-item-process .ant-steps-item-title {
  font-weight: 500;
}
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #fff;
  border-color: #2EB1EF;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #2EB1EF;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #2EB1EF;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #545454;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #2EB1EF;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #595959;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #2EB1EF;
}
.ant-steps-item-error .ant-steps-item-icon {
  background-color: #fff;
  border-color: #f5222d;
}
.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {
  color: #f5222d;
}
.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  color: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #e8e8e8;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
  color: #f5222d;
}
.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #e8e8e8;
}
.ant-steps-item.ant-steps-next-error .ant-steps-item-title::after {
  background: #f5222d;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] {
  cursor: pointer;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-title,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-description,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-icon .ant-steps-icon {
  transition: color 0.3s;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle,
.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {
  color: #2EB1EF;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {
  border-color: #2EB1EF;
}
.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {
  color: #2EB1EF;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  margin-right: 16px;
  white-space: nowrap;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {
  margin-right: 0;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {
  padding-right: 0;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {
  display: none;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
  max-width: 140px;
  white-space: normal;
}
.ant-steps-item-custom .ant-steps-item-icon {
  height: auto;
  background: none;
  border: 0;
}
.ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  top: 0;
  left: 0.5px;
  width: 32px;
  height: 32px;
  font-size: 24px;
  line-height: 32px;
}
.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #2EB1EF;
}
.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {
  width: auto;
}
.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
  margin-right: 12px;
}
.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {
  margin-right: 0;
}
.ant-steps-small .ant-steps-item-icon {
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  border-radius: 24px;
}
.ant-steps-small .ant-steps-item-title {
  padding-right: 12px;
  font-size: 14px;
  line-height: 24px;
}
.ant-steps-small .ant-steps-item-title::after {
  top: 12px;
}
.ant-steps-small .ant-steps-item-description {
  color: #595959;
  font-size: 14px;
}
.ant-steps-small .ant-steps-item-tail {
  top: 8px;
}
.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  background: none;
  border: 0;
  border-radius: 0;
}
.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  font-size: 24px;
  line-height: 24px;
  transform: none;
}
.ant-steps-vertical {
  display: block;
}
.ant-steps-vertical .ant-steps-item {
  display: block;
  overflow: visible;
}
.ant-steps-vertical .ant-steps-item-icon {
  float: left;
  margin-right: 16px;
}
.ant-steps-vertical .ant-steps-item-content {
  display: block;
  min-height: 48px;
  overflow: hidden;
}
.ant-steps-vertical .ant-steps-item-title {
  line-height: 32px;
}
.ant-steps-vertical .ant-steps-item-description {
  padding-bottom: 12px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 16px;
  width: 1px;
  height: 100%;
  padding: 38px 0 6px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {
  width: 1px;
  height: 100%;
}
.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {
  display: block;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  display: none;
}
.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
  position: absolute;
  top: 0;
  left: 12px;
  padding: 30px 0 6px;
}
.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
  line-height: 24px;
}
@media (max-width: 480px) {
  .ant-steps-horizontal.ant-steps-label-horizontal {
    display: block;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {
    display: block;
    overflow: visible;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {
    float: left;
    margin-right: 16px;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
    display: block;
    min-height: 48px;
    overflow: hidden;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {
    line-height: 32px;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-description {
    padding-bottom: 12px;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
    position: absolute;
    top: 0;
    left: 16px;
    width: 1px;
    height: 100%;
    padding: 38px 0 6px;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {
    width: 1px;
    height: 100%;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {
    display: block;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    display: none;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {
    position: absolute;
    top: 0;
    left: 12px;
    padding: 30px 0 6px;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
    line-height: 24px;
  }
}
.ant-steps-label-vertical .ant-steps-item {
  overflow: visible;
}
.ant-steps-label-vertical .ant-steps-item-tail {
  margin-left: 58px;
  padding: 3.5px 24px;
}
.ant-steps-label-vertical .ant-steps-item-content {
  display: block;
  width: 116px;
  margin-top: 8px;
  text-align: center;
}
.ant-steps-label-vertical .ant-steps-item-icon {
  display: inline-block;
  margin-left: 42px;
}
.ant-steps-label-vertical .ant-steps-item-title {
  padding-right: 0;
}
.ant-steps-label-vertical .ant-steps-item-title::after {
  display: none;
}
.ant-steps-label-vertical .ant-steps-item-subtitle {
  display: block;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 1.3;
}
.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
  margin-left: 46px;
}
.ant-steps-dot .ant-steps-item-title,
.ant-steps-dot.ant-steps-small .ant-steps-item-title {
  line-height: 1.3;
}
.ant-steps-dot .ant-steps-item-tail,
.ant-steps-dot.ant-steps-small .ant-steps-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 70px;
  padding: 0;
}
.ant-steps-dot .ant-steps-item-tail::after,
.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: 12px;
}
.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 2px;
}
.ant-steps-dot .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 67px;
  padding-right: 0;
  line-height: 8px;
  background: transparent;
  border: 0;
}
.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  transition: all 0.3s;
  /* expand hover area */
}
.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  background: rgba(0, 0, 0, 0.001);
  content: '';
}
.ant-steps-dot .ant-steps-item-content,
.ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: 140px;
}
.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {
  width: 10px;
  height: 10px;
  line-height: 10px;
}
.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot,
.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot {
  top: -1px;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-top: 8px;
  margin-left: 0;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
  top: 2px;
  left: -9px;
  margin: 0;
  padding: 22px 0 4px;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {
  left: 0;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
  left: -2px;
}
.ant-steps-navigation {
  padding-top: 12px;
}
.ant-steps-navigation.ant-steps-small .ant-steps-item-container {
  margin-left: -12px;
}
.ant-steps-navigation .ant-steps-item {
  overflow: visible;
  text-align: center;
}
.ant-steps-navigation .ant-steps-item-container {
  display: inline-block;
  height: 100%;
  margin-left: -16px;
  padding-bottom: 12px;
  text-align: left;
  transition: opacity 0.3s;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {
  max-width: auto;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {
  max-width: 100%;
  padding-right: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title::after {
  display: none;
}
.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button'] {
  cursor: pointer;
}
.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button']:hover {
  opacity: 0.85;
}
.ant-steps-navigation .ant-steps-item:last-child {
  flex: 1;
}
.ant-steps-navigation .ant-steps-item:last-child::after {
  display: none;
}
.ant-steps-navigation .ant-steps-item::after {
  position: absolute;
  top: 50%;
  left: 100%;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: -14px;
  margin-left: -2px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: none;
  border-left: none;
  transform: rotate(45deg);
  content: '';
}
.ant-steps-navigation .ant-steps-item::before {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: inline-block;
  width: 0;
  height: 3px;
  background-color: #2EB1EF;
  transition: width 0.3s, left 0.3s;
  transition-timing-function: ease-out;
  content: '';
}
.ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {
  left: 0;
  width: 100%;
}
@media (max-width: 480px) {
  .ant-steps-navigation > .ant-steps-item {
    margin-right: 0 !important;
  }
  .ant-steps-navigation > .ant-steps-item::before {
    display: none;
  }
  .ant-steps-navigation > .ant-steps-item.ant-steps-item-active::before {
    top: 0;
    right: 0;
    left: unset;
    display: block;
    width: 3px;
    height: calc(76%);
  }
  .ant-steps-navigation > .ant-steps-item::after {
    position: relative;
    top: -2px;
    left: 50%;
    display: block;
    width: 8px;
    height: 8px;
    margin-bottom: 8px;
    text-align: center;
    transform: rotate(135deg);
  }
  .ant-steps-navigation > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
    visibility: hidden;
  }
}
.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {
  margin-left: -16px;
  padding-left: 16px;
  background: #fff;
}
.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item {
  margin-left: -12px;
  padding-left: 12px;
}
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child {
  overflow: hidden;
}
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child .ant-steps-icon-dot::after {
  right: -200px;
  width: 200px;
}
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::before,
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {
  position: absolute;
  top: 0;
  left: -10px;
  width: 10px;
  height: 8px;
  background: #fff;
  content: '';
}
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {
  right: -10px;
  left: auto;
}
.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #ccc;
}
.ant-switch {
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  min-width: 44px;
  height: 22px;
  line-height: 20px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.25);
  border: 1px solid transparent;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.36s;
  user-select: none;
}
.ant-switch-inner {
  display: block;
  margin-right: 6px;
  margin-left: 24px;
  color: #fff;
  font-size: 12px;
}
.ant-switch-loading-icon,
.ant-switch::after {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: ' ';
}
.ant-switch::after {
  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);
}
.ant-switch:not(.ant-switch-disabled):active::before,
.ant-switch:not(.ant-switch-disabled):active::after {
  width: 24px;
}
.ant-switch-loading-icon {
  z-index: 1;
  display: none;
  font-size: 12px;
  background: transparent;
}
.ant-switch-loading-icon svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-switch-loading .ant-switch-loading-icon {
  display: inline-block;
  color: #545454;
}
.ant-switch-checked.ant-switch-loading .ant-switch-loading-icon {
  color: #2EB1EF;
}
.ant-switch:focus {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-switch:focus:hover {
  box-shadow: none;
}
.ant-switch-small {
  min-width: 28px;
  height: 16px;
  line-height: 14px;
}
.ant-switch-small .ant-switch-inner {
  margin-right: 3px;
  margin-left: 18px;
  font-size: 12px;
}
.ant-switch-small::after {
  width: 12px;
  height: 12px;
}
.ant-switch-small:active::before,
.ant-switch-small:active::after {
  width: 16px;
}
.ant-switch-small .ant-switch-loading-icon {
  width: 12px;
  height: 12px;
}
.ant-switch-small.ant-switch-checked .ant-switch-inner {
  margin-right: 18px;
  margin-left: 3px;
}
.ant-switch-small.ant-switch-checked .ant-switch-loading-icon {
  left: 100%;
  margin-left: -13px;
}
.ant-switch-small.ant-switch-loading .ant-switch-loading-icon {
  font-weight: bold;
  transform: scale(0.66667);
}
.ant-switch-checked {
  background-color: #2EB1EF;
}
.ant-switch-checked .ant-switch-inner {
  margin-right: 24px;
  margin-left: 6px;
}
.ant-switch-checked::after {
  left: 100%;
  margin-left: -1px;
  transform: translateX(-100%);
}
.ant-switch-checked .ant-switch-loading-icon {
  left: 100%;
  margin-left: -19px;
}
.ant-switch-loading,
.ant-switch-disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.ant-switch-loading *,
.ant-switch-disabled * {
  cursor: not-allowed;
}
.ant-switch-loading::before,
.ant-switch-disabled::before,
.ant-switch-loading::after,
.ant-switch-disabled::after {
  cursor: not-allowed;
}
@keyframes AntSwitchSmallLoadingCircle {
  0% {
    transform: rotate(0deg) scale(0.66667);
    transform-origin: 50% 50%;
  }
  100% {
    transform: rotate(360deg) scale(0.66667);
    transform-origin: 50% 50%;
  }
}
.ant-table-wrapper {
  zoom: 1;
}
.ant-table-wrapper::before,
.ant-table-wrapper::after {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  clear: both;
}
.ant-table-wrapper::before,
.ant-table-wrapper::after {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  clear: both;
}
.ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  clear: both;
}
.ant-table-body {
  transition: opacity 0.3s;
}
.ant-table-empty .ant-table-body {
  overflow-x: auto !important;
  overflow-y: hidden !important;
}
.ant-table table {
  width: 100%;
  text-align: left;
  border-radius: 6px 6px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-table-layout-fixed table {
  table-layout: fixed;
}
.ant-table-thead > tr > th {
  color: #535353;
  font-weight: 500;
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s ease;
}
.ant-table-thead > tr > th[colspan]:not([colspan='1']) {
  text-align: center;
}
.ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 28px;
  height: 100%;
  color: #bfbfbf;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-table-thead > tr > th .anticon-filter > svg,
.ant-table-thead > tr > th .ant-table-filter-icon > svg {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -5px;
  margin-left: -6px;
}
.ant-table-thead > tr > th .ant-table-filter-selected.anticon {
  color: #2EB1EF;
}
.ant-table-thead > tr > th .ant-table-column-sorter {
  display: table-cell;
  vertical-align: middle;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner {
  height: 1em;
  margin-top: 0.35em;
  margin-left: 0.57142857em;
  color: #bfbfbf;
  line-height: 1em;
  text-align: center;
  transition: all 0.3s;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {
  display: inline-block;
  font-size: 12px;
  font-size: 11px \\9;
  transform: scale(0.91666667) rotate(0deg);
  display: block;
  height: 1em;
  line-height: 1em;
  transition: all 0.3s;
}
:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,
:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {
  font-size: 12px;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {
  color: #2EB1EF;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full {
  margin-top: -0.15em;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-up,
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {
  height: 0.5em;
  line-height: 0.5em;
}
.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {
  margin-top: 0.125em;
}
.ant-table-thead > tr > th.ant-table-column-has-actions {
  position: relative;
  background-clip: padding-box;
  /* stylelint-disable-next-line */
  -webkit-background-clip: border-box;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {
  padding-right: 30px !important;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .anticon-filter.ant-table-filter-open,
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .ant-table-filter-icon.ant-table-filter-open {
  color: #595959;
  background: #e5e5e5;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:hover,
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:hover {
  color: #595959;
  background: #e5e5e5;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:active,
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:active {
  color: #545454;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
  cursor: pointer;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background: #f2f2f2;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .anticon-filter,
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .ant-table-filter-icon {
  background: #f2f2f2;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-up:not(.on),
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-down:not(.on) {
  color: #595959;
}
.ant-table-thead > tr > th .ant-table-header-column {
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
}
.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters {
  display: table;
}
.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > .ant-table-column-title {
  display: table-cell;
  vertical-align: middle;
}
.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > *:not(.ant-table-column-sorter) {
  position: relative;
}
.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  transition: all 0.3s;
  content: '';
}
.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters:hover::before {
  background: rgba(0, 0, 0, 0.04);
}
.ant-table-thead > tr > th.ant-table-column-has-sorters {
  user-select: none;
}
.ant-table-thead > tr:first-child > th:first-child {
  border-top-left-radius: 6px;
}
.ant-table-thead > tr:first-child > th:last-child {
  border-top-right-radius: 6px;
}
.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s, border 0s;
}
.ant-table-thead > tr,
.ant-table-tbody > tr {
  transition: all 0.3s, height 0s;
}
.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #f0fdff;
}
.ant-table-thead > tr.ant-table-row-selected > td.ant-table-column-sort,
.ant-table-tbody > tr.ant-table-row-selected > td.ant-table-column-sort {
  background: #fafafa;
}
.ant-table-thead > tr:hover.ant-table-row-selected > td,
.ant-table-tbody > tr:hover.ant-table-row-selected > td {
  background: #fafafa;
}
.ant-table-thead > tr:hover.ant-table-row-selected > td.ant-table-column-sort,
.ant-table-tbody > tr:hover.ant-table-row-selected > td.ant-table-column-sort {
  background: #fafafa;
}
.ant-table-thead > tr:hover {
  background: none;
}
.ant-table-footer {
  position: relative;
  padding: 16px 16px;
  color: #535353;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-table-footer::before {
  position: absolute;
  top: -1px;
  left: 0;
  width: 100%;
  height: 1px;
  background: #fafafa;
  content: '';
}
.ant-table.ant-table-bordered .ant-table-footer {
  border: 1px solid #e8e8e8;
}
.ant-table-title {
  position: relative;
  top: 1px;
  padding: 16px 0;
  border-radius: 6px 6px 0 0;
}
.ant-table.ant-table-bordered .ant-table-title {
  padding-right: 16px;
  padding-left: 16px;
  border: 1px solid #e8e8e8;
}
.ant-table-title + .ant-table-content {
  position: relative;
  border-radius: 6px 6px 0 0;
}
.ant-table-bordered .ant-table-title + .ant-table-content,
.ant-table-bordered .ant-table-title + .ant-table-content table,
.ant-table-bordered .ant-table-title + .ant-table-content .ant-table-thead > tr:first-child > th {
  border-radius: 0;
}
.ant-table-without-column-header .ant-table-title + .ant-table-content,
.ant-table-without-column-header table {
  border-radius: 0;
}
.ant-table-without-column-header.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-top: 1px solid #e8e8e8;
  border-radius: 6px;
}
.ant-table-tbody > tr.ant-table-row-selected td {
  color: inherit;
  background: #fafafa;
}
.ant-table-thead > tr > th.ant-table-column-sort {
  background: #f5f5f5;
}
.ant-table-tbody > tr > td.ant-table-column-sort {
  background: rgba(0, 0, 0, 0.01);
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 16px;
  overflow-wrap: break-word;
}
.ant-table-expand-icon-th,
.ant-table-row-expand-icon-cell {
  width: 50px;
  min-width: 50px;
  text-align: center;
}
.ant-table-header {
  overflow: hidden;
  background: #fafafa;
}
.ant-table-header table {
  border-radius: 6px 6px 0 0;
}
.ant-table-loading {
  position: relative;
}
.ant-table-loading .ant-table-body {
  background: #fff;
  opacity: 0.5;
}
.ant-table-loading .ant-table-spin-holder {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 20px;
  margin-left: -30px;
  line-height: 20px;
}
.ant-table-loading .ant-table-with-pagination {
  margin-top: -20px;
}
.ant-table-loading .ant-table-without-pagination {
  margin-top: 10px;
}
.ant-table-bordered .ant-table-header > table,
.ant-table-bordered .ant-table-body > table,
.ant-table-bordered .ant-table-fixed-left table,
.ant-table-bordered .ant-table-fixed-right table {
  border: 1px solid #e8e8e8;
  border-right: 0;
  border-bottom: 0;
}
.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  border-right: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {
  border-bottom: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-header + .ant-table-body > table,
.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {
  border-top: 0;
}
.ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e8e8e8;
}
.ant-table-placeholder {
  position: relative;
  z-index: 1;
  margin-top: -1px;
  padding: 16px 16px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  text-align: center;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 0;
}
.ant-table-filter-dropdown {
  position: relative;
  min-width: 96px;
  margin-left: -8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: calc(100vh - 130px);
  overflow-x: hidden;
  border: 0;
  border-radius: 6px 6px 0 0;
  box-shadow: none;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {
  padding-right: 0;
}
.ant-table-filter-dropdown .ant-dropdown-menu-sub {
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title::after {
  color: #2EB1EF;
  font-weight: bold;
  text-shadow: 0 0 2px #d4f7ff;
}
.ant-table-filter-dropdown .ant-dropdown-menu-item {
  overflow: hidden;
}
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,
.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0;
}
.ant-table-filter-dropdown-btns {
  padding: 7px 8px;
  overflow: hidden;
  border-top: 1px solid #e8e8e8;
}
.ant-table-filter-dropdown-link {
  color: #2EB1EF;
}
.ant-table-filter-dropdown-link:hover {
  color: #58cefc;
}
.ant-table-filter-dropdown-link:active {
  color: #1c8dc9;
}
.ant-table-filter-dropdown-link.confirm {
  float: left;
}
.ant-table-filter-dropdown-link.clear {
  float: right;
}
.ant-table-selection {
  white-space: nowrap;
}
.ant-table-selection-select-all-custom {
  margin-right: 4px !important;
}
.ant-table-selection .anticon-down {
  color: #bfbfbf;
  transition: all 0.3s;
}
.ant-table-selection-menu {
  min-width: 96px;
  margin-top: 5px;
  margin-left: -30px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-table-selection-menu .ant-action-down {
  color: #bfbfbf;
}
.ant-table-selection-down {
  display: inline-block;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}
.ant-table-selection-down:hover .anticon-down {
  color: rgba(0, 0, 0, 0.6);
}
.ant-table-row-expand-icon {
  color: #2EB1EF;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
  display: inline-block;
  width: 17px;
  height: 17px;
  color: inherit;
  line-height: 13px;
  text-align: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s;
  user-select: none;
}
.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover {
  color: #58cefc;
}
.ant-table-row-expand-icon:active {
  color: #1c8dc9;
}
.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover,
.ant-table-row-expand-icon:active {
  border-color: currentColor;
}
.ant-table-row-expanded::after {
  content: '-';
}
.ant-table-row-collapsed::after {
  content: '+';
}
.ant-table-row-spaced {
  visibility: hidden;
}
.ant-table-row-spaced::after {
  content: '.';
}
.ant-table-row-cell-ellipsis,
.ant-table-row-cell-ellipsis .ant-table-column-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-table-row-cell-ellipsis .ant-table-column-title {
  display: block;
}
.ant-table-row-cell-break-word {
  word-wrap: break-word;
  word-break: break-word;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #fbfbfb;
}
tr.ant-table-expanded-row td > .ant-table-wrapper {
  margin: -16px -16px -17px;
}
.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 8px;
}
.ant-table-scroll {
  overflow: auto;
  overflow-x: hidden;
}
.ant-table-scroll table {
  min-width: 100%;
}
.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) {
  color: transparent;
}
.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) > * {
  visibility: hidden;
}
.ant-table-body-inner {
  height: 100%;
}
.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  position: relative;
  background: #fff;
}
.ant-table-fixed-header .ant-table-body-inner {
  overflow: scroll;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  margin-bottom: -20px;
  padding-bottom: 20px;
  overflow: scroll;
  opacity: 0.9999;
}
.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {
  border: 1px solid #e8e8e8;
  border-width: 0 0 1px 0;
}
.ant-table-hide-scrollbar {
  scrollbar-color: transparent transparent;
  min-width: unset;
}
.ant-table-hide-scrollbar::-webkit-scrollbar {
  min-width: inherit;
  background-color: transparent;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {
  border: 1px solid #e8e8e8;
  border-width: 1px 1px 1px 0;
}
.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header.ant-table-hide-scrollbar .ant-table-thead > tr:only-child > th:last-child {
  border-right-color: transparent;
}
.ant-table-fixed-left,
.ant-table-fixed-right {
  position: absolute;
  top: 0;
  z-index: 1;
  overflow: hidden;
  border-radius: 0;
  transition: box-shadow 0.3s ease;
}
.ant-table-fixed-left table,
.ant-table-fixed-right table {
  width: auto;
  background: #fff;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,
.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {
  border-radius: 0;
}
.ant-table-fixed-left {
  left: 0;
  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);
}
.ant-table-fixed-left .ant-table-header {
  overflow-y: hidden;
}
.ant-table-fixed-left .ant-table-body-inner {
  margin-right: -20px;
  padding-right: 20px;
}
.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {
  padding-right: 0;
}
.ant-table-fixed-left,
.ant-table-fixed-left table {
  border-radius: 6px 0 0 0;
}
.ant-table-fixed-left .ant-table-thead > tr > th:last-child {
  border-top-right-radius: 0;
}
.ant-table-fixed-right {
  right: 0;
  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);
}
.ant-table-fixed-right,
.ant-table-fixed-right table {
  border-radius: 0 6px 0 0;
}
.ant-table-fixed-right .ant-table-expanded-row {
  color: transparent;
  pointer-events: none;
}
.ant-table-fixed-right .ant-table-thead > tr > th:first-child {
  border-top-left-radius: 0;
}
.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {
  box-shadow: none;
}
.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {
  box-shadow: none;
}
.ant-table colgroup > col.ant-table-selection-col {
  width: 60px;
}
.ant-table-thead > tr > th.ant-table-selection-column-custom .ant-table-selection {
  margin-right: -15px;
}
.ant-table-thead > tr > th.ant-table-selection-column,
.ant-table-tbody > tr > td.ant-table-selection-column {
  text-align: center;
}
.ant-table-thead > tr > th.ant-table-selection-column .ant-radio-wrapper,
.ant-table-tbody > tr > td.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}
.ant-table-row[class*='ant-table-row-level-0'] .ant-table-selection-column > span {
  display: inline-block;
}
.ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {
  padding-left: 8px;
}
/**
* Another fix of Firefox:
*/
@supports (-moz-appearance: meterbar) {
  .ant-table-thead > tr > th.ant-table-column-has-actions {
    background-clip: padding-box;
  }
}
.ant-table-middle > .ant-table-title,
.ant-table-middle > .ant-table-content > .ant-table-footer {
  padding: 12px 8px;
}
.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,
.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {
  padding: 12px 8px;
}
.ant-table-middle tr.ant-table-expanded-row td > .ant-table-wrapper {
  margin: -12px -8px -13px;
}
.ant-table-small {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.ant-table-small > .ant-table-title,
.ant-table-small > .ant-table-content > .ant-table-footer {
  padding: 8px 8px;
}
.ant-table-small > .ant-table-title {
  top: 0;
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-small > .ant-table-content > .ant-table-footer {
  background-color: transparent;
  border-top: 1px solid #e8e8e8;
}
.ant-table-small > .ant-table-content > .ant-table-footer::before {
  background-color: transparent;
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 8px;
}
.ant-table-small > .ant-table-content > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {
  border: 0;
}
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {
  padding: 8px 8px;
}
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th {
  background-color: transparent;
}
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr {
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort {
  background-color: rgba(0, 0, 0, 0.01);
}
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {
  padding: 0;
}
.ant-table-small > .ant-table-content .ant-table-header {
  background-color: transparent;
  border-radius: 6px 6px 0 0;
}
.ant-table-small > .ant-table-content .ant-table-placeholder,
.ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 0;
}
.ant-table-small.ant-table-bordered {
  border-right: 0;
}
.ant-table-small.ant-table-bordered .ant-table-title {
  border: 0;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-small.ant-table-bordered .ant-table-content {
  border-right: 1px solid #e8e8e8;
}
.ant-table-small.ant-table-bordered .ant-table-footer {
  border: 0;
  border-top: 1px solid #e8e8e8;
}
.ant-table-small.ant-table-bordered .ant-table-footer::before {
  display: none;
}
.ant-table-small.ant-table-bordered .ant-table-placeholder {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
.ant-table-small.ant-table-bordered .ant-table-thead > tr > th.ant-table-row-cell-last,
.ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child {
  border-right: none;
}
.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-thead > tr > th:last-child,
.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-tbody > tr > td:last-child {
  border-right: 1px solid #e8e8e8;
}
.ant-table-small.ant-table-bordered .ant-table-fixed-right {
  border-right: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
}
.ant-table-small tr.ant-table-expanded-row td > .ant-table-wrapper {
  margin: -8px -8px -9px;
}
.ant-table-small.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  border-radius: 0 0 6px 6px;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
  height: 40px;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-ink-bar {
  visibility: hidden;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  height: 40px;
  margin: 0;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #2EB1EF;
  background: #fff;
  border-color: #e8e8e8;
  border-bottom: 1px solid #fff;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active::before {
  border-top: 2px solid transparent;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-disabled {
  color: #2EB1EF;
  color: rgba(0, 0, 0, 0.25);
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-inactive {
  padding: 0;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x {
  width: 16px;
  height: 16px;
  height: 14px;
  margin-right: -5px;
  margin-left: 3px;
  overflow: hidden;
  color: #595959;
  font-size: 12px;
  vertical-align: middle;
  transition: all 0.3s;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x:hover {
  color: #535353;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-content > .ant-tabs-tabpane,
.ant-tabs.ant-tabs-editable-card .ant-tabs-card-content > .ant-tabs-tabpane {
  transition: none !important;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-content > .ant-tabs-tabpane-inactive,
.ant-tabs.ant-tabs-editable-card .ant-tabs-card-content > .ant-tabs-tabpane-inactive {
  overflow: hidden;
}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:hover .anticon-close {
  opacity: 1;
}
.ant-tabs-extra-content {
  line-height: 42.2px;
}
.ant-tabs-extra-content .ant-tabs-new-tab {
  position: relative;
  width: 20px;
  height: 20px;
  color: #545454;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-tabs-extra-content .ant-tabs-new-tab:hover {
  color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-tabs-extra-content .ant-tabs-new-tab svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-tabs.ant-tabs-large .ant-tabs-extra-content {
  line-height: 52.8px;
}
.ant-tabs.ant-tabs-small .ant-tabs-extra-content {
  line-height: 34.2px;
}
.ant-tabs.ant-tabs-card .ant-tabs-extra-content {
  line-height: 40px;
}
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-nav-container,
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-nav-container {
  height: 100%;
}
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab,
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab {
  margin-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab-active,
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab-active {
  padding-bottom: 4px;
}
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab:last-child,
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab:last-child {
  margin-bottom: 8px;
}
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-new-tab,
.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-new-tab {
  width: 90%;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-nav-wrap {
  margin-right: 0;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab {
  margin-right: 1px;
  border-right: 0;
  border-radius: 6px 0 0 6px;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab-active {
  margin-right: -1px;
  padding-right: 18px;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-nav-wrap {
  margin-left: 0;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab {
  margin-left: 1px;
  border-left: 0;
  border-radius: 0 6px 6px 0;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab-active {
  margin-left: -1px;
  padding-left: 18px;
}
.ant-tabs .ant-tabs-card-bar.ant-tabs-bottom-bar .ant-tabs-tab {
  height: auto;
  border-top: 0;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-tabs .ant-tabs-card-bar.ant-tabs-bottom-bar .ant-tabs-tab-active {
  padding-top: 1px;
  padding-bottom: 0;
  color: #2EB1EF;
}
.ant-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  overflow: hidden;
  zoom: 1;
}
.ant-tabs::before,
.ant-tabs::after {
  display: table;
  content: '';
}
.ant-tabs::after {
  clear: both;
}
.ant-tabs::before,
.ant-tabs::after {
  display: table;
  content: '';
}
.ant-tabs::after {
  clear: both;
}
.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 1;
  box-sizing: border-box;
  width: 0;
  height: 2px;
  background-color: #2EB1EF;
  transform-origin: 0 0;
}
.ant-tabs-bar {
  margin: 0 0 16px 0;
  border-bottom: 1px solid #e8e8e8;
  outline: none;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-nav-container {
  position: relative;
  box-sizing: border-box;
  margin-bottom: -1px;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.3;
  white-space: nowrap;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  zoom: 1;
}
.ant-tabs-nav-container::before,
.ant-tabs-nav-container::after {
  display: table;
  content: '';
}
.ant-tabs-nav-container::after {
  clear: both;
}
.ant-tabs-nav-container::before,
.ant-tabs-nav-container::after {
  display: table;
  content: '';
}
.ant-tabs-nav-container::after {
  clear: both;
}
.ant-tabs-nav-container-scrolling {
  padding-right: 32px;
  padding-left: 32px;
}
.ant-tabs-bottom .ant-tabs-bottom-bar {
  margin-top: 16px;
  margin-bottom: 0;
  border-top: 1px solid #e8e8e8;
  border-bottom: none;
}
.ant-tabs-bottom .ant-tabs-bottom-bar .ant-tabs-ink-bar {
  top: 1px;
  bottom: auto;
}
.ant-tabs-bottom .ant-tabs-bottom-bar .ant-tabs-nav-container {
  margin-top: -1px;
  margin-bottom: 0;
}
.ant-tabs-tab-prev,
.ant-tabs-tab-next {
  position: absolute;
  z-index: 2;
  width: 0;
  height: 100%;
  color: #595959;
  text-align: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  opacity: 0;
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  pointer-events: none;
}
.ant-tabs-tab-prev.ant-tabs-tab-arrow-show,
.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  width: 32px;
  height: 100%;
  opacity: 1;
  pointer-events: auto;
}
.ant-tabs-tab-prev:hover,
.ant-tabs-tab-next:hover {
  color: #545454;
}
.ant-tabs-tab-prev-icon,
.ant-tabs-tab-next-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-weight: bold;
  font-style: normal;
  font-variant: normal;
  line-height: inherit;
  text-align: center;
  text-transform: none;
  transform: translate(-50%, -50%);
}
.ant-tabs-tab-prev-icon-target,
.ant-tabs-tab-next-icon-target {
  display: block;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
}
:root .ant-tabs-tab-prev-icon-target,
:root .ant-tabs-tab-next-icon-target {
  font-size: 12px;
}
.ant-tabs-tab-btn-disabled {
  cursor: not-allowed;
}
.ant-tabs-tab-btn-disabled,
.ant-tabs-tab-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
}
.ant-tabs-tab-next {
  right: 2px;
}
.ant-tabs-tab-prev {
  left: 0;
}
:root .ant-tabs-tab-prev {
  filter: none;
}
.ant-tabs-nav-wrap {
  margin-bottom: -1px;
  overflow: hidden;
}
.ant-tabs-nav-scroll {
  overflow: hidden;
  white-space: nowrap;
}
.ant-tabs-nav {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin: 0;
  padding-left: 0;
  list-style: none;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-nav::before,
.ant-tabs-nav::after {
  display: table;
  content: ' ';
}
.ant-tabs-nav::after {
  clear: both;
}
.ant-tabs-nav .ant-tabs-tab {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  margin: 0 32px 0 0;
  padding: 12px 16px;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-nav .ant-tabs-tab::before {
  position: absolute;
  top: -1px;
  left: 0;
  width: 100%;
  border-top: 2px solid transparent;
  border-radius: 6px 6px 0 0;
  transition: all 0.3s;
  content: '';
  pointer-events: none;
}
.ant-tabs-nav .ant-tabs-tab:last-child {
  margin-right: 0;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: #58cefc;
}
.ant-tabs-nav .ant-tabs-tab:active {
  color: #1c8dc9;
}
.ant-tabs-nav .ant-tabs-tab .anticon {
  margin-right: 8px;
}
.ant-tabs-nav .ant-tabs-tab-active {
  color: #2EB1EF;
  font-weight: 500;
}
.ant-tabs-nav .ant-tabs-tab-disabled,
.ant-tabs-nav .ant-tabs-tab-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tabs .ant-tabs-large-bar .ant-tabs-nav-container {
  font-size: 16px;
}
.ant-tabs .ant-tabs-large-bar .ant-tabs-tab {
  padding: 16px;
}
.ant-tabs .ant-tabs-small-bar .ant-tabs-nav-container {
  font-size: 14px;
}
.ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
  padding: 8px 16px;
}
.ant-tabs-content::before {
  display: block;
  overflow: hidden;
  content: '';
}
.ant-tabs .ant-tabs-top-content,
.ant-tabs .ant-tabs-bottom-content {
  width: 100%;
}
.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane,
.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  -webkit-backface-visibility: hidden;
  opacity: 1;
  transition: opacity 0.45s;
}
.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive,
.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive {
  height: 0;
  padding: 0 !important;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive input,
.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive input {
  visibility: hidden;
}
.ant-tabs .ant-tabs-top-content.ant-tabs-content-animated,
.ant-tabs .ant-tabs-bottom-content.ant-tabs-content-animated {
  display: flex;
  flex-direction: row;
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  will-change: margin-left;
}
.ant-tabs .ant-tabs-left-bar,
.ant-tabs .ant-tabs-right-bar {
  height: 100%;
  border-bottom: 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-arrow-show,
.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-arrow-show {
  width: 100%;
  height: 32px;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab,
.ant-tabs .ant-tabs-right-bar .ant-tabs-tab {
  display: block;
  float: none;
  margin: 0 0 16px 0;
  padding: 8px 24px;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab:last-child,
.ant-tabs .ant-tabs-right-bar .ant-tabs-tab:last-child {
  margin-bottom: 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-extra-content,
.ant-tabs .ant-tabs-right-bar .ant-tabs-extra-content {
  text-align: center;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-scroll,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-scroll {
  width: auto;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container,
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {
  height: 100%;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container {
  margin-bottom: 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {
  padding: 32px 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav,
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav {
  width: 100%;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar,
.ant-tabs .ant-tabs-right-bar .ant-tabs-ink-bar {
  top: 0;
  bottom: auto;
  left: auto;
  width: 2px;
  height: 0;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-next,
.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-next {
  right: 0;
  bottom: 0;
  width: 100%;
  height: 32px;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-prev,
.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-prev {
  top: 0;
  width: 100%;
  height: 32px;
}
.ant-tabs .ant-tabs-left-content,
.ant-tabs .ant-tabs-right-content {
  width: auto;
  margin-top: 0 !important;
  overflow: hidden;
}
.ant-tabs .ant-tabs-left-bar {
  float: left;
  margin-right: -1px;
  margin-bottom: 0;
  border-right: 1px solid #e8e8e8;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-tab {
  text-align: right;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container {
  margin-right: -1px;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap {
  margin-right: -1px;
}
.ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar {
  right: 1px;
}
.ant-tabs .ant-tabs-left-content {
  padding-left: 24px;
  border-left: 1px solid #e8e8e8;
}
.ant-tabs .ant-tabs-right-bar {
  float: right;
  margin-bottom: 0;
  margin-left: -1px;
  border-left: 1px solid #e8e8e8;
}
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container {
  margin-left: -1px;
}
.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {
  margin-left: -1px;
}
.ant-tabs .ant-tabs-right-bar .ant-tabs-ink-bar {
  left: 1px;
}
.ant-tabs .ant-tabs-right-content {
  padding-right: 24px;
  border-right: 1px solid #e8e8e8;
}
.ant-tabs-top .ant-tabs-ink-bar-animated,
.ant-tabs-bottom .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-left .ant-tabs-ink-bar-animated,
.ant-tabs-right .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.no-flex > .ant-tabs-content > .ant-tabs-content-animated,
.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-content-animated {
  margin-left: 0 !important;
  transform: none !important;
}
.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive {
  height: 0;
  padding: 0 !important;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive input,
.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive input {
  visibility: hidden;
}
.ant-tabs-left-content > .ant-tabs-content-animated,
.ant-tabs-right-content > .ant-tabs-content-animated {
  margin-left: 0 !important;
  transform: none !important;
}
.ant-tabs-left-content > .ant-tabs-tabpane-inactive,
.ant-tabs-right-content > .ant-tabs-tabpane-inactive {
  height: 0;
  padding: 0 !important;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.ant-tabs-left-content > .ant-tabs-tabpane-inactive input,
.ant-tabs-right-content > .ant-tabs-tabpane-inactive input {
  visibility: hidden;
}
.ant-tag {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  height: auto;
  margin-right: 8px;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: default;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-tag:hover {
  opacity: 0.85;
}
.ant-tag,
.ant-tag a,
.ant-tag a:hover {
  color: #545454;
}
.ant-tag > a:first-child:last-child {
  display: inline-block;
  margin: 0 -8px;
  padding: 0 8px;
}
.ant-tag .anticon-close {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  margin-left: 3px;
  color: #595959;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
:root .ant-tag .anticon-close {
  font-size: 12px;
}
.ant-tag .anticon-close:hover {
  color: #535353;
}
.ant-tag-has-color {
  border-color: transparent;
}
.ant-tag-has-color,
.ant-tag-has-color a,
.ant-tag-has-color a:hover,
.ant-tag-has-color .anticon-close,
.ant-tag-has-color .anticon-close:hover {
  color: #fff;
}
.ant-tag-checkable {
  background-color: transparent;
  border-color: transparent;
}
.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
  color: #2EB1EF;
}
.ant-tag-checkable:active,
.ant-tag-checkable-checked {
  color: #fff;
}
.ant-tag-checkable-checked {
  background-color: #2EB1EF;
}
.ant-tag-checkable:active {
  background-color: #1c8dc9;
}
.ant-tag-hidden {
  display: none;
}
.ant-tag-pink {
  color: #eb2f96;
  background: #fff0f6;
  border-color: #ffadd2;
}
.ant-tag-pink-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}
.ant-tag-magenta {
  color: #eb2f96;
  background: #fff0f6;
  border-color: #ffadd2;
}
.ant-tag-magenta-inverse {
  color: #fff;
  background: #eb2f96;
  border-color: #eb2f96;
}
.ant-tag-red {
  color: #f5222d;
  background: #fff1f0;
  border-color: #ffa39e;
}
.ant-tag-red-inverse {
  color: #fff;
  background: #f5222d;
  border-color: #f5222d;
}
.ant-tag-volcano {
  color: #fa541c;
  background: #fff2e8;
  border-color: #ffbb96;
}
.ant-tag-volcano-inverse {
  color: #fff;
  background: #fa541c;
  border-color: #fa541c;
}
.ant-tag-orange {
  color: #fa8c16;
  background: #fff7e6;
  border-color: #ffd591;
}
.ant-tag-orange-inverse {
  color: #fff;
  background: #fa8c16;
  border-color: #fa8c16;
}
.ant-tag-yellow {
  color: #fadb14;
  background: #feffe6;
  border-color: #fffb8f;
}
.ant-tag-yellow-inverse {
  color: #fff;
  background: #fadb14;
  border-color: #fadb14;
}
.ant-tag-gold {
  color: #faad14;
  background: #fffbe6;
  border-color: #ffe58f;
}
.ant-tag-gold-inverse {
  color: #fff;
  background: #faad14;
  border-color: #faad14;
}
.ant-tag-cyan {
  color: #13c2c2;
  background: #e6fffb;
  border-color: #87e8de;
}
.ant-tag-cyan-inverse {
  color: #fff;
  background: #13c2c2;
  border-color: #13c2c2;
}
.ant-tag-lime {
  color: #a0d911;
  background: #fcffe6;
  border-color: #eaff8f;
}
.ant-tag-lime-inverse {
  color: #fff;
  background: #a0d911;
  border-color: #a0d911;
}
.ant-tag-green {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}
.ant-tag-green-inverse {
  color: #fff;
  background: #52c41a;
  border-color: #52c41a;
}
.ant-tag-blue {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}
.ant-tag-blue-inverse {
  color: #fff;
  background: #1890ff;
  border-color: #1890ff;
}
.ant-tag-geekblue {
  color: #2f54eb;
  background: #f0f5ff;
  border-color: #adc6ff;
}
.ant-tag-geekblue-inverse {
  color: #fff;
  background: #2f54eb;
  border-color: #2f54eb;
}
.ant-tag-purple {
  color: #722ed1;
  background: #f9f0ff;
  border-color: #d3adf7;
}
.ant-tag-purple-inverse {
  color: #fff;
  background: #722ed1;
  border-color: #722ed1;
}
.ant-time-picker-panel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  z-index: 1050;
  font-family: "DM Sans", sans-serif;
}
.ant-time-picker-panel-inner {
  position: relative;
  left: -2px;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 6px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-time-picker-panel-input {
  width: 100%;
  max-width: 154px;
  margin: 0;
  padding: 0;
  line-height: normal;
  border: 0;
  outline: 0;
  cursor: auto;
}
.ant-time-picker-panel-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-time-picker-panel-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-time-picker-panel-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-time-picker-panel-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-time-picker-panel-input-wrap {
  position: relative;
  padding: 7px 2px 7px 12px;
  border-bottom: 1px solid #e8e8e8;
}
.ant-time-picker-panel-input-invalid {
  border-color: #f5222d;
}
.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {
  max-width: 112px;
}
.ant-time-picker-panel-select {
  position: relative;
  float: left;
  width: 56px;
  max-height: 192px;
  overflow: hidden;
  font-size: 14px;
  border-left: 1px solid #e8e8e8;
}
.ant-time-picker-panel-select:hover {
  overflow-y: auto;
}
.ant-time-picker-panel-select:first-child {
  margin-left: 0;
  border-left: 0;
}
.ant-time-picker-panel-select:last-child {
  border-right: 0;
}
.ant-time-picker-panel-select:only-child {
  width: 100%;
}
.ant-time-picker-panel-select ul {
  width: 56px;
  margin: 0;
  padding: 0 0 160px;
  list-style: none;
}
.ant-time-picker-panel-select li {
  width: 100%;
  height: 32px;
  margin: 0;
  padding: 0 0 0 12px;
  line-height: 32px;
  text-align: left;
  list-style: none;
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
}
.ant-time-picker-panel-select li:focus {
  color: #2EB1EF;
  font-weight: 600;
  outline: none;
}
.ant-time-picker-panel-select li:hover {
  background: #f0fdff;
}
li.ant-time-picker-panel-select-option-selected {
  font-weight: 600;
  background: #f5f5f5;
}
li.ant-time-picker-panel-select-option-selected:hover {
  background: #f5f5f5;
}
li.ant-time-picker-panel-select-option-disabled {
  color: rgba(0, 0, 0, 0.25);
}
li.ant-time-picker-panel-select-option-disabled:hover {
  background: transparent;
  cursor: not-allowed;
}
li.ant-time-picker-panel-select-option-disabled:focus {
  color: rgba(0, 0, 0, 0.25);
  font-weight: inherit;
}
.ant-time-picker-panel-combobox {
  zoom: 1;
}
.ant-time-picker-panel-combobox::before,
.ant-time-picker-panel-combobox::after {
  display: table;
  content: '';
}
.ant-time-picker-panel-combobox::after {
  clear: both;
}
.ant-time-picker-panel-combobox::before,
.ant-time-picker-panel-combobox::after {
  display: table;
  content: '';
}
.ant-time-picker-panel-combobox::after {
  clear: both;
}
.ant-time-picker-panel-addon {
  padding: 8px;
  border-top: 1px solid #e8e8e8;
}
.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,
.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,
.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,
.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,
.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,
.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,
.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,
.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,
.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-time-picker {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 128px;
  outline: none;
  cursor: text;
  transition: opacity 0.3s;
}
.ant-time-picker-input {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 36px;
  padding: 4px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}
.ant-time-picker-input::-moz-placeholder {
  color: #bfbfbf;
  opacity: 1;
}
.ant-time-picker-input:-ms-input-placeholder {
  color: #bfbfbf;
}
.ant-time-picker-input::-webkit-input-placeholder {
  color: #bfbfbf;
}
.ant-time-picker-input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-time-picker-input:hover {
  border-color: #58cefc;
  border-right-width: 1px !important;
}
.ant-time-picker-input:focus {
  border-color: #58cefc;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);
}
.ant-time-picker-input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-time-picker-input-disabled:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-time-picker-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-time-picker-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
textarea.ant-time-picker-input {
  max-width: 100%;
  height: auto;
  min-height: 36px;
  line-height: 1.3;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-time-picker-input-lg {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-time-picker-input-sm {
  height: 24px;
  padding: 1px 7px;
}
.ant-time-picker-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.ant-time-picker-input[disabled]:hover {
  border-color: #d9d9d9;
  border-right-width: 1px !important;
}
.ant-time-picker-open {
  opacity: 0;
}
.ant-time-picker-icon,
.ant-time-picker-clear {
  position: absolute;
  top: 50%;
  right: 11px;
  z-index: 1;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 14px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
}
.ant-time-picker-icon .ant-time-picker-clock-icon,
.ant-time-picker-clear .ant-time-picker-clock-icon {
  display: block;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
}
.ant-time-picker-clear {
  z-index: 2;
  background: #fff;
  opacity: 0;
  pointer-events: none;
}
.ant-time-picker-clear:hover {
  color: #595959;
}
.ant-time-picker:hover .ant-time-picker-clear {
  opacity: 1;
  pointer-events: auto;
}
.ant-time-picker-large .ant-time-picker-input {
  height: 40px;
  padding: 6px 11px;
  font-size: 16px;
}
.ant-time-picker-small .ant-time-picker-input {
  height: 24px;
  padding: 1px 7px;
}
.ant-time-picker-small .ant-time-picker-icon,
.ant-time-picker-small .ant-time-picker-clear {
  right: 7px;
}
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) and (stroke-color: transparent) {
    .ant-input {
      line-height: 1.3;
    }
  }
}
.ant-timeline {
  box-sizing: border-box;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  font-feature-settings: 'tnum';
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-timeline-item {
  position: relative;
  margin: 0;
  padding: 0 0 20px;
  font-size: 14px;
  list-style: none;
}
.ant-timeline-item-tail {
  position: absolute;
  top: 10px;
  left: 4px;
  height: calc(90%);
  border-left: 2px solid #e8e8e8;
}
.ant-timeline-item-pending .ant-timeline-item-head {
  font-size: 12px;
  background-color: transparent;
}
.ant-timeline-item-pending .ant-timeline-item-tail {
  display: none;
}
.ant-timeline-item-head {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 100px;
}
.ant-timeline-item-head-blue {
  color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-timeline-item-head-red {
  color: #f5222d;
  border-color: #f5222d;
}
.ant-timeline-item-head-green {
  color: #52c41a;
  border-color: #52c41a;
}
.ant-timeline-item-head-gray {
  color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-timeline-item-head-custom {
  position: absolute;
  top: 5.5px;
  left: 5px;
  width: auto;
  height: auto;
  margin-top: 0;
  padding: 3px 1px;
  line-height: 1;
  text-align: center;
  border: 0;
  border-radius: 0;
  transform: translate(-50%, -50%);
}
.ant-timeline-item-content {
  position: relative;
  top: -3.2px;
  margin: 0 0 0 18px;
  word-break: break-word;
}
.ant-timeline-item-last > .ant-timeline-item-tail {
  display: none;
}
.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 48px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,
.ant-timeline.ant-timeline-right .ant-timeline-item-tail,
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-head,
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  left: 50%;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-head {
  margin-left: -4px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,
.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {
  margin-left: 1px;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,
.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
  left: calc(46%);
  width: calc(36%);
  text-align: left;
}
.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(38%);
  margin: 0;
  text-align: right;
}
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {
  left: calc(94%);
}
.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
  width: calc(82%);
}
.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  display: block;
  height: calc(86%);
  border-left: 2px dotted #e8e8e8;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {
  display: none;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {
  top: 15px;
  display: block;
  height: calc(85%);
  border-left: 2px dotted #e8e8e8;
}
.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {
  min-height: 48px;
}
.ant-tooltip {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  z-index: 1060;
  display: block;
  max-width: 250px;
  visibility: visible;
}
.ant-tooltip-hidden {
  display: none;
}
.ant-tooltip-placement-top,
.ant-tooltip-placement-topLeft,
.ant-tooltip-placement-topRight {
  padding-bottom: 8px;
}
.ant-tooltip-placement-right,
.ant-tooltip-placement-rightTop,
.ant-tooltip-placement-rightBottom {
  padding-left: 8px;
}
.ant-tooltip-placement-bottom,
.ant-tooltip-placement-bottomLeft,
.ant-tooltip-placement-bottomRight {
  padding-top: 8px;
}
.ant-tooltip-placement-left,
.ant-tooltip-placement-leftTop,
.ant-tooltip-placement-leftBottom {
  padding-right: 8px;
}
.ant-tooltip-inner {
  min-width: 30px;
  min-height: 32px;
  padding: 6px 8px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-tooltip-arrow {
  position: absolute;
  display: block;
  width: 13.07106781px;
  height: 13.07106781px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}
.ant-tooltip-arrow::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 5px;
  height: 5px;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.75);
  content: '';
  pointer-events: auto;
}
.ant-tooltip-placement-top .ant-tooltip-arrow,
.ant-tooltip-placement-topLeft .ant-tooltip-arrow,
.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  bottom: -5.07106781px;
}
.ant-tooltip-placement-top .ant-tooltip-arrow::before,
.ant-tooltip-placement-topLeft .ant-tooltip-arrow::before,
.ant-tooltip-placement-topRight .ant-tooltip-arrow::before {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-6.53553391px) rotate(45deg);
}
.ant-tooltip-placement-top .ant-tooltip-arrow {
  left: 50%;
  transform: translateX(-50%);
}
.ant-tooltip-placement-topLeft .ant-tooltip-arrow {
  left: 13px;
}
.ant-tooltip-placement-topRight .ant-tooltip-arrow {
  right: 13px;
}
.ant-tooltip-placement-right .ant-tooltip-arrow,
.ant-tooltip-placement-rightTop .ant-tooltip-arrow,
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  left: -5.07106781px;
}
.ant-tooltip-placement-right .ant-tooltip-arrow::before,
.ant-tooltip-placement-rightTop .ant-tooltip-arrow::before,
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow::before {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(6.53553391px) rotate(45deg);
}
.ant-tooltip-placement-right .ant-tooltip-arrow {
  top: 50%;
  transform: translateY(-50%);
}
.ant-tooltip-placement-rightTop .ant-tooltip-arrow {
  top: 5px;
}
.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
  bottom: 5px;
}
.ant-tooltip-placement-left .ant-tooltip-arrow,
.ant-tooltip-placement-leftTop .ant-tooltip-arrow,
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  right: -5.07106781px;
}
.ant-tooltip-placement-left .ant-tooltip-arrow::before,
.ant-tooltip-placement-leftTop .ant-tooltip-arrow::before,
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow::before {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-6.53553391px) rotate(45deg);
}
.ant-tooltip-placement-left .ant-tooltip-arrow {
  top: 50%;
  transform: translateY(-50%);
}
.ant-tooltip-placement-leftTop .ant-tooltip-arrow {
  top: 5px;
}
.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
  bottom: 5px;
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: -5.07106781px;
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow::before,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow::before,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow::before {
  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(6.53553391px) rotate(45deg);
}
.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  left: 50%;
  transform: translateX(-50%);
}
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {
  left: 13px;
}
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  right: 13px;
}
.ant-transfer-customize-list {
  display: flex;
}
.ant-transfer-customize-list .ant-transfer-operation {
  flex: none;
  align-self: center;
}
.ant-transfer-customize-list .ant-transfer-list {
  flex: auto;
  width: auto;
  height: auto;
  min-height: 200px;
}
.ant-transfer-customize-list .ant-transfer-list-body-with-search {
  padding-top: 0;
}
.ant-transfer-customize-list .ant-transfer-list-body-search-wrapper {
  position: relative;
  padding-bottom: 0;
}
.ant-transfer-customize-list .ant-transfer-list-body-customize-wrapper {
  padding: 12px;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {
  border: 0;
  border-radius: 0;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  background: #fafafa;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {
  border-bottom: 1px solid #e8e8e8;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {
  margin: 0;
}
.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 16px 0 4px;
}
.ant-transfer {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
}
.ant-transfer-disabled .ant-transfer-list {
  background: #f5f5f5;
}
.ant-transfer-list {
  position: relative;
  display: inline-block;
  width: 180px;
  height: 200px;
  padding-top: 40px;
  vertical-align: middle;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-transfer-list-with-footer {
  padding-bottom: 34px;
}
.ant-transfer-list-search {
  padding: 0 24px 0 8px;
}
.ant-transfer-list-search-action {
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  width: 28px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 36px;
  text-align: center;
}
.ant-transfer-list-search-action .anticon {
  color: rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
}
.ant-transfer-list-search-action .anticon:hover {
  color: #595959;
}
span.ant-transfer-list-search-action {
  pointer-events: none;
}
.ant-transfer-list-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 9.4px 12px 10.4px;
  overflow: hidden;
  color: #545454;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 6px 6px 0 0;
}
.ant-transfer-list-header-title {
  position: absolute;
  right: 12px;
}
.ant-transfer-list-header .ant-checkbox-wrapper + span {
  padding-left: 8px;
}
.ant-transfer-list-body {
  position: relative;
  height: 100%;
  font-size: 14px;
}
.ant-transfer-list-body-search-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 12px;
}
.ant-transfer-list-body-with-search {
  padding-top: 60px;
}
.ant-transfer-list-content {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}
.ant-transfer-list-content > .LazyLoad {
  animation: transferHighlightIn 1s;
}
.ant-transfer-list-content-item {
  min-height: 32px;
  padding: 6px 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-transfer-list-content-item > span {
  padding-right: 0;
}
.ant-transfer-list-content-item-text {
  padding-left: 8px;
}
.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background-color: #f0fdff;
  cursor: pointer;
}
.ant-transfer-list-content-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-transfer-list-body-not-found {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 0;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  transform: translateY(-50%);
}
.ant-transfer-list-body-with-search .ant-transfer-list-body-not-found {
  margin-top: 18px;
}
.ant-transfer-list-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 6px 6px;
}
.ant-transfer-operation {
  display: inline-block;
  margin: 0 8px;
  overflow: hidden;
  vertical-align: middle;
}
.ant-transfer-operation .ant-btn {
  display: block;
}
.ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 4px;
}
.ant-transfer-operation .ant-btn .anticon {
  font-size: 12px;
}
@keyframes transferHighlightIn {
  0% {
    background: #d4f7ff;
  }
  100% {
    background: transparent;
  }
}
.ant-tree.ant-tree-directory {
  position: relative;
}
.ant-tree.ant-tree-directory > li span.ant-tree-switcher,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-switcher {
  position: relative;
  z-index: 1;
}
.ant-tree.ant-tree-directory > li span.ant-tree-switcher.ant-tree-switcher-noop,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-switcher.ant-tree-switcher-noop {
  pointer-events: none;
}
.ant-tree.ant-tree-directory > li span.ant-tree-checkbox,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-checkbox {
  position: relative;
  z-index: 1;
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper {
  border-radius: 0;
  user-select: none;
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper:hover,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper:hover::before,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper:hover::before {
  background: #f0fdff;
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper.ant-tree-node-selected,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: #fff;
  background: transparent;
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before {
  position: absolute;
  right: 0;
  left: 0;
  height: 24px;
  transition: all 0.3s;
  content: '';
}
.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper > span,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper > span {
  position: relative;
  z-index: 1;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-switcher,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-switcher {
  color: #fff;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox .ant-tree-checkbox-inner,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox .ant-tree-checkbox-inner {
  border-color: #2EB1EF;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked::after,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked::after {
  border-color: #fff;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background: #fff;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  border-color: #2EB1EF;
}
.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before {
  background: #2EB1EF;
}
.ant-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: -0.09em;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  outline: none;
  cursor: pointer;
}
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox:hover .ant-tree-checkbox-inner,
.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {
  border-color: #2EB1EF;
}
.ant-tree-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #2EB1EF;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-tree-checkbox:hover::after,
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox::after {
  visibility: visible;
}
.ant-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-tree-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 22%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-input {
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-tree-checkbox-disabled:hover::after,
.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled::after {
  visibility: hidden;
}
.ant-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  line-height: unset;
  cursor: pointer;
}
.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {
  margin-left: 8px;
}
.ant-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-tree-checkbox-group-item {
  display: inline-block;
  margin-right: 8px;
}
.ant-tree-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {
  margin-left: 0;
}
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #2EB1EF;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-tree {
  /* see https://github.com/ant-design/ant-design/issues/16259 */
  box-sizing: border-box;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  margin: 0;
  padding: 0;
}
.ant-tree-checkbox-checked::after {
  position: absolute;
  top: 16.67%;
  left: 0;
  width: 100%;
  height: 66.67%;
}
.ant-tree ol,
.ant-tree ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-tree li {
  margin: 0;
  padding: 4px 0;
  white-space: nowrap;
  list-style: none;
  outline: 0;
}
.ant-tree li span[draggable],
.ant-tree li span[draggable='true'] {
  line-height: 20px;
  border-top: 2px transparent solid;
  border-bottom: 2px transparent solid;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
.ant-tree li.drag-over > span[draggable] {
  color: white;
  background-color: #2EB1EF;
  opacity: 0.8;
}
.ant-tree li.drag-over-gap-top > span[draggable] {
  border-top-color: #2EB1EF;
}
.ant-tree li.drag-over-gap-bottom > span[draggable] {
  border-bottom-color: #2EB1EF;
}
.ant-tree li.filter-node > span {
  color: #f5222d !important;
  font-weight: 500 !important;
}
.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-loading-icon,
.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-loading-icon {
  position: absolute;
  left: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  color: #2EB1EF;
  font-size: 14px;
  transform: none;
}
.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-loading-icon svg,
.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-loading-icon svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
:root .ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open::after,
:root .ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close::after {
  opacity: 0;
}
.ant-tree li ul {
  margin: 0;
  padding: 0 0 0 18px;
}
.ant-tree li .ant-tree-node-content-wrapper {
  display: inline-block;
  height: 24px;
  margin: 0;
  padding: 0 5px;
  color: #545454;
  line-height: 24px;
  text-decoration: none;
  vertical-align: top;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-tree li .ant-tree-node-content-wrapper:hover {
  background-color: #f0fdff;
}
.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #d4f7ff;
}
.ant-tree li span.ant-tree-checkbox {
  top: initial;
  height: 24px;
  margin: 0 4px 0 2px;
  padding: 4px 0;
}
.ant-tree li span.ant-tree-switcher,
.ant-tree li span.ant-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
  border: 0 none;
  outline: none;
  cursor: pointer;
}
.ant-tree li span.ant-tree-iconEle:empty {
  display: none;
}
.ant-tree li span.ant-tree-switcher {
  position: relative;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
  cursor: default;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  display: inline-block;
  font-weight: bold;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {
  font-size: 12px;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon svg,
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  display: inline-block;
  font-weight: bold;
}
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,
:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {
  font-size: 12px;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg,
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {
  transform: rotate(-90deg);
}
.ant-tree li:last-child > span.ant-tree-switcher::before,
.ant-tree li:last-child > span.ant-tree-iconEle::before {
  display: none;
}
.ant-tree > li:first-child {
  padding-top: 7px;
}
.ant-tree > li:last-child {
  padding-bottom: 7px;
}
.ant-tree-child-tree > li:first-child {
  padding-top: 8px;
}
.ant-tree-child-tree > li:last-child {
  padding-bottom: 0;
}
li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}
.ant-tree-icon__close {
  margin-right: 2px;
  vertical-align: top;
}
.ant-tree.ant-tree-show-line li {
  position: relative;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  color: #595959;
  background: #fff;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-tree-switcher-icon,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-select-switcher-icon {
  display: inline-block;
  font-weight: normal;
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-tree-switcher-icon svg,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {
  display: inline-block;
  font-weight: normal;
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon svg,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {
  display: inline-block;
  font-weight: normal;
  font-size: 12px;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg,
.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-tree.ant-tree-show-line li:not(:last-child)::before {
  position: absolute;
  left: 12px;
  width: 1px;
  height: 100%;
  height: calc(78%);
  margin: 22px 0 0;
  border-left: 1px solid #d9d9d9;
  content: ' ';
}
.ant-tree.ant-tree-icon-hide .ant-tree-treenode-loading .ant-tree-iconEle {
  display: none;
}
.ant-tree.ant-tree-block-node li .ant-tree-node-content-wrapper {
  width: calc(100% - 24px);
}
.ant-tree.ant-tree-block-node li span.ant-tree-checkbox + .ant-tree-node-content-wrapper {
  width: calc(100% - 46px);
}
.ant-select-tree-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: -0.09em;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  outline: none;
  cursor: pointer;
}
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {
  border-color: #2EB1EF;
}
.ant-select-tree-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #2EB1EF;
  border-radius: 4px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.ant-select-tree-checkbox:hover::after,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox::after {
  visibility: visible;
}
.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  border-collapse: separate;
  transition: all 0.3s;
}
.ant-select-tree-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 22%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.ant-select-tree-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled:hover::after,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled::after {
  visibility: hidden;
}
.ant-select-tree-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
  line-height: unset;
  cursor: pointer;
}
.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {
  margin-left: 8px;
}
.ant-select-tree-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.ant-select-tree-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.ant-select-tree-checkbox-group-item {
  display: inline-block;
  margin-right: 8px;
}
.ant-select-tree-checkbox-group-item:last-child {
  margin-right: 0;
}
.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {
  margin-left: 0;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #2EB1EF;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree {
  box-sizing: border-box;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  margin: 0;
  margin-top: -4px;
  padding: 0 4px;
}
.ant-select-tree li {
  margin: 8px 0;
  padding: 0;
  white-space: nowrap;
  list-style: none;
  outline: 0;
}
.ant-select-tree li.filter-node > span {
  font-weight: 500;
}
.ant-select-tree li ul {
  margin: 0;
  padding: 0 0 0 18px;
}
.ant-select-tree li .ant-select-tree-node-content-wrapper {
  display: inline-block;
  width: calc(100% - 24px);
  margin: 0;
  padding: 3px 5px;
  color: #545454;
  text-decoration: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-select-tree li .ant-select-tree-node-content-wrapper:hover {
  background-color: #f0fdff;
}
.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #d4f7ff;
}
.ant-select-tree li span.ant-select-tree-checkbox {
  margin: 0 4px 0 0;
}
.ant-select-tree li span.ant-select-tree-checkbox + .ant-select-tree-node-content-wrapper {
  width: calc(100% - 46px);
}
.ant-select-tree li span.ant-select-tree-switcher,
.ant-select-tree li span.ant-select-tree-iconEle {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
  text-align: center;
  vertical-align: middle;
  border: 0 none;
  outline: none;
  cursor: pointer;
}
.ant-select-tree li span.ant-select-icon_loading .ant-select-switcher-loading-icon {
  position: absolute;
  left: 0;
  display: inline-block;
  color: #2EB1EF;
  font-size: 14px;
  transform: none;
}
.ant-select-tree li span.ant-select-icon_loading .ant-select-switcher-loading-icon svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-select-tree li span.ant-select-tree-switcher {
  position: relative;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher-noop {
  cursor: auto;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon {
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  display: inline-block;
  font-weight: bold;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon,
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon {
  font-size: 12px;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon svg,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon {
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  display: inline-block;
  font-weight: bold;
}
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon,
:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon {
  font-size: 12px;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon svg,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon svg {
  transition: transform 0.3s;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon svg {
  transform: rotate(-90deg);
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-loading-icon,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-loading-icon {
  position: absolute;
  left: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  color: #2EB1EF;
  font-size: 14px;
  transform: none;
}
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-loading-icon svg,
.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-loading-icon svg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-select-tree .ant-select-tree-treenode-loading .ant-select-tree-iconEle {
  display: none;
}
.ant-select-tree-child-tree {
  display: none;
}
.ant-select-tree-child-tree-open {
  display: block;
}
li.ant-select-tree-treenode-disabled > span:not(.ant-select-tree-switcher),
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper,
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
li.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-select-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}
.ant-select-tree-icon__close {
  margin-right: 2px;
  vertical-align: top;
}
.ant-select-tree-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-select-tree-dropdown .ant-select-dropdown-search {
  position: sticky;
  top: 0;
  z-index: 1;
  display: block;
  padding: 4px;
  background: #fff;
}
.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field__wrap {
  width: 100%;
}
.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field {
  box-sizing: border-box;
  width: 100%;
  padding: 4px 7px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
}
.ant-select-tree-dropdown .ant-select-dropdown-search.ant-select-search--hide {
  display: none;
}
.ant-select-tree-dropdown .ant-select-not-found {
  display: block;
  padding: 7px 16px;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-typography {
  color: #545454;
}
.ant-typography.ant-typography-secondary {
  color: #595959;
}
.ant-typography.ant-typography-warning {
  color: #fa8c16;
}
.ant-typography.ant-typography-danger {
  color: #f5222d;
}
.ant-typography.ant-typography-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  user-select: none;
}
div.ant-typography,
.ant-typography p {
  margin-bottom: 1em;
}
h1.ant-typography,
.ant-typography h1 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 38px;
  line-height: 1.23;
}
h2.ant-typography,
.ant-typography h2 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 30px;
  line-height: 1.35;
}
h3.ant-typography,
.ant-typography h3 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}
h4.ant-typography,
.ant-typography h4 {
  margin-bottom: 0.5em;
  color: #535353;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
}
.ant-typography + h1.ant-typography,
.ant-typography + h2.ant-typography,
.ant-typography + h3.ant-typography,
.ant-typography + h4.ant-typography {
  margin-top: 1.2em;
}
.ant-typography div + h1,
.ant-typography ul + h1,
.ant-typography li + h1,
.ant-typography p + h1,
.ant-typography h1 + h1,
.ant-typography h2 + h1,
.ant-typography h3 + h1,
.ant-typography h4 + h1,
.ant-typography div + h2,
.ant-typography ul + h2,
.ant-typography li + h2,
.ant-typography p + h2,
.ant-typography h1 + h2,
.ant-typography h2 + h2,
.ant-typography h3 + h2,
.ant-typography h4 + h2,
.ant-typography div + h3,
.ant-typography ul + h3,
.ant-typography li + h3,
.ant-typography p + h3,
.ant-typography h1 + h3,
.ant-typography h2 + h3,
.ant-typography h3 + h3,
.ant-typography h4 + h3,
.ant-typography div + h4,
.ant-typography ul + h4,
.ant-typography li + h4,
.ant-typography p + h4,
.ant-typography h1 + h4,
.ant-typography h2 + h4,
.ant-typography h3 + h4,
.ant-typography h4 + h4 {
  margin-top: 1.2em;
}
span.ant-typography-ellipsis {
  display: inline-block;
}
.ant-typography a {
  color: #2EB1EF;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
}
.ant-typography a:focus,
.ant-typography a:hover {
  color: #58cefc;
}
.ant-typography a:active {
  color: #1c8dc9;
}
.ant-typography a:active,
.ant-typography a:hover {
  text-decoration: none;
}
.ant-typography a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}
.ant-typography code {
  margin: 0 0.2em;
  padding: 0.2em 0.4em 0.1em;
  font-size: 85%;
  background: rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}
.ant-typography mark {
  padding: 0;
  background-color: #ffe58f;
}
.ant-typography u,
.ant-typography ins {
  text-decoration: underline;
  text-decoration-skip-ink: auto;
}
.ant-typography s,
.ant-typography del {
  text-decoration: line-through;
}
.ant-typography strong {
  font-weight: 600;
}
.ant-typography-expand,
.ant-typography-edit,
.ant-typography-copy {
  color: #2EB1EF;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  margin-left: 8px;
}
.ant-typography-expand:focus,
.ant-typography-edit:focus,
.ant-typography-copy:focus,
.ant-typography-expand:hover,
.ant-typography-edit:hover,
.ant-typography-copy:hover {
  color: #58cefc;
}
.ant-typography-expand:active,
.ant-typography-edit:active,
.ant-typography-copy:active {
  color: #1c8dc9;
}
.ant-typography-copy-success,
.ant-typography-copy-success:hover,
.ant-typography-copy-success:focus {
  color: #52c41a;
}
.ant-typography-edit-content {
  position: relative;
}
div.ant-typography-edit-content {
  left: -12px;
  margin-top: -5px;
  margin-bottom: calc(-5em);
}
.ant-typography-edit-content-confirm {
  position: absolute;
  right: 10px;
  bottom: 8px;
  color: #595959;
  pointer-events: none;
}
.ant-typography-edit-content textarea {
  -moz-transition: none;
}
.ant-typography ul,
.ant-typography ol {
  margin: 0 0 1em 0;
  padding: 0;
}
.ant-typography ul li,
.ant-typography ol li {
  margin: 0 0 0 20px;
  padding: 0 0 0 4px;
}
.ant-typography ul li {
  list-style-type: circle;
}
.ant-typography ul li li {
  list-style-type: disc;
}
.ant-typography ol li {
  list-style-type: decimal;
}
.ant-typography-ellipsis-single-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-typography-ellipsis-multiple-line {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ant-upload {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  outline: 0;
}
.ant-upload p {
  margin: 0;
}
.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}
.ant-upload input[type='file'] {
  cursor: pointer;
}
.ant-upload.ant-upload-select {
  display: inline-block;
}
.ant-upload.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-select-picture-card {
  display: table;
  float: left;
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: table-cell;
  width: 100%;
  height: 100%;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}
.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #2EB1EF;
}
.ant-upload.ant-upload-drag {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.ant-upload.ant-upload-drag .ant-upload {
  padding: 16px 0;
}
.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border-color: #1c8dc9;
}
.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}
.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #58cefc;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 20px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #58cefc;
  font-size: 48px;
}
.ant-upload.ant-upload-drag p.ant-upload-text {
  margin: 0 0 4px;
  color: #535353;
  font-size: 16px;
}
.ant-upload.ant-upload-drag p.ant-upload-hint {
  color: #595959;
  font-size: 14px;
}
.ant-upload.ant-upload-drag .anticon-plus {
  color: rgba(0, 0, 0, 0.25);
  font-size: 30px;
  transition: all 0.3s;
}
.ant-upload.ant-upload-drag .anticon-plus:hover {
  color: #595959;
}
.ant-upload.ant-upload-drag:hover .anticon-plus {
  color: #595959;
}
.ant-upload-picture-card-wrapper {
  zoom: 1;
  display: inline-block;
  width: 100%;
}
.ant-upload-picture-card-wrapper::before,
.ant-upload-picture-card-wrapper::after {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  clear: both;
}
.ant-upload-picture-card-wrapper::before,
.ant-upload-picture-card-wrapper::after {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  clear: both;
}
.ant-upload-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  zoom: 1;
}
.ant-upload-list::before,
.ant-upload-list::after {
  display: table;
  content: '';
}
.ant-upload-list::after {
  clear: both;
}
.ant-upload-list::before,
.ant-upload-list::after {
  display: table;
  content: '';
}
.ant-upload-list::after {
  clear: both;
}
.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {
  padding-right: 14px;
}
.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {
  padding-right: 28px;
}
.ant-upload-list-item {
  position: relative;
  height: 22px;
  margin-top: 8px;
  font-size: 14px;
}
.ant-upload-list-item-name {
  display: inline-block;
  width: 100%;
  padding-left: 22px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-upload-list-item-name-icon-count-1 {
  padding-right: 14px;
}
.ant-upload-list-item-card-actions {
  position: absolute;
  right: 0;
  opacity: 0;
}
.ant-upload-list-item-card-actions.picture {
  top: 25px;
  line-height: 1;
  opacity: 1;
}
.ant-upload-list-item-card-actions .anticon {
  padding-right: 6px;
  color: rgba(0, 0, 0, 0.45);
}
.ant-upload-list-item-info {
  height: 100%;
  padding: 0 12px 0 4px;
  transition: background-color 0.3s;
}
.ant-upload-list-item-info > span {
  display: block;
  width: 100%;
  height: 100%;
}
.ant-upload-list-item-info .anticon-loading,
.ant-upload-list-item-info .anticon-paper-clip {
  position: absolute;
  top: 5px;
  color: #595959;
  font-size: 14px;
}
.ant-upload-list-item .anticon-close {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \\9;
  transform: scale(0.83333333) rotate(0deg);
  position: absolute;
  top: 6px;
  right: 4px;
  color: #595959;
  line-height: 0;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s;
}
:root .ant-upload-list-item .anticon-close {
  font-size: 12px;
}
.ant-upload-list-item .anticon-close:hover {
  color: #545454;
}
.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #f0fdff;
}
.ant-upload-list-item:hover .anticon-close {
  opacity: 1;
}
.ant-upload-list-item:hover .ant-upload-list-item-card-actions {
  opacity: 1;
}
.ant-upload-list-item-error,
.ant-upload-list-item-error .anticon-paper-clip,
.ant-upload-list-item-error .ant-upload-list-item-name {
  color: #f5222d;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions {
  opacity: 1;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  color: #f5222d;
}
.ant-upload-list-item-progress {
  position: absolute;
  bottom: -12px;
  width: 100%;
  padding-left: 26px;
  font-size: 14px;
  line-height: 0;
}
.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-picture-card .ant-upload-list-item {
  position: relative;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.ant-upload-list-picture .ant-upload-list-item:hover,
.ant-upload-list-picture-card .ant-upload-list-item:hover {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #f5222d;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-uploading,
.ant-upload-list-picture-card .ant-upload-list-item-uploading {
  border-style: dashed;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 48px;
  height: 48px;
  font-size: 26px;
  line-height: 54px;
  text-align: center;
  opacity: 0.8;
}
.ant-upload-list-picture .ant-upload-list-item-icon,
.ant-upload-list-picture-card .ant-upload-list-item-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 26px;
  transform: translate(-50%, -50%);
}
.ant-upload-list-picture .ant-upload-list-item-image,
.ant-upload-list-picture-card .ant-upload-list-item-image {
  max-width: 100%;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail img,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  display: block;
  width: 48px;
  height: 48px;
  overflow: hidden;
}
.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 0 0 8px;
  padding-right: 8px;
  padding-left: 48px;
  overflow: hidden;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,
.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {
  padding-right: 18px;
}
.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,
.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {
  padding-right: 36px;
}
.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {
  line-height: 28px;
}
.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 14px;
  width: calc(100% - 24px);
  margin-top: 0;
  padding-left: 56px;
}
.ant-upload-list-picture .anticon-close,
.ant-upload-list-picture-card .anticon-close {
  position: absolute;
  top: 8px;
  right: 8px;
  line-height: 1;
  opacity: 1;
}
.ant-upload-list-picture-card.ant-upload-list::after {
  display: none;
}
.ant-upload-list-picture-card-container {
  float: left;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
}
.ant-upload-list-picture-card .ant-upload-list-item {
  float: left;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
}
.ant-upload-list-picture-card .ant-upload-list-item-info {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.ant-upload-list-picture-card .ant-upload-list-item-info::before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s;
  content: ' ';
}
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
  z-index: 10;
  width: 16px;
  margin: 0 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {
  color: #fff;
}
.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,
.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  position: static;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
  margin: 8px 0 0;
  padding: 0;
  line-height: 1.3;
  text-align: center;
}
.ant-upload-list-picture-card .anticon-picture + .ant-upload-list-item-name {
  position: absolute;
  bottom: 10px;
  display: block;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fafafa;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye-o,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading-text {
  margin-top: 18px;
  color: #595959;
}
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 32px;
  padding-left: 0;
}
.ant-upload-list .ant-upload-success-icon {
  color: #52c41a;
  font-weight: bold;
}
.ant-upload-list .ant-upload-animate-enter,
.ant-upload-list .ant-upload-animate-leave,
.ant-upload-list .ant-upload-animate-inline-enter,
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: 0.3s;
  animation-fill-mode: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-upload-list .ant-upload-animate-enter {
  animation-name: uploadAnimateIn;
}
.ant-upload-list .ant-upload-animate-leave {
  animation-name: uploadAnimateOut;
}
.ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}
@keyframes uploadAnimateIn {
  from {
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateOut {
  to {
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineIn {
  from {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
/* color classes */
.gx-bg-primary {
  background-color: #2EB1EF !important;
}
a.gx-bg-primary:hover,
a.gx-bg-primary:focus {
  background-color: #2EB1EF !important;
}
.gx-bg-primary-light {
  background-color: #82e0ff !important;
}
.gx-bg-secondary {
  background-color: #089265 !important;
}
a.gx-bg-secondary:hover,
a.gx-bg-secondary:focus {
  background-color: #089265 !important;
}
.gx-bg-success {
  background-color: #52c41a !important;
}
a.gx-bg-success:hover,
a.gx-bg-success:focus {
  background-color: #3f9714 !important;
}
.gx-bg-success-dark {
  background-color: #368011 !important;
}
a.gx-bg-success-dark:hover,
a.gx-bg-success-dark:focus {
  background-color: #2c6a0e !important;
}
.gx-bg-info {
  background-color: #1890ff !important;
}
a.gx-bg-info:hover,
a.gx-bg-info:focus {
  background-color: #0076e4 !important;
}
.gx-bg-warning {
  background-color: #fa8c16 !important;
}
a.gx-bg-warning:hover,
a.gx-bg-warning:focus {
  background-color: #d87205 !important;
}
.gx-bg-danger {
  background-color: #f44336 !important;
}
a.gx-bg-danger:hover,
a.gx-bg-danger:focus {
  background-color: #ea1c0d !important;
}
.gx-bg-light {
  background-color: #e8e8e8 !important;
}
a.gx-bg-light:hover,
a.gx-bg-light:focus {
  background-color: #d9d9d9 !important;
}
.gx-bg-dark {
  background-color: #000000 !important;
}
a.gx-bg-dark:hover,
a.gx-bg-dark:focus {
  background-color: #1a1a1a !important;
}
.gx-bg-white {
  background-color: #ffffff !important;
}
a.gx-bg-white:hover,
a.gx-bg-white:focus {
  background-color: #f2f2f2 !important;
}
.gx-bg-grey {
  background-color: #cccccc !important;
}
a.gx-bg-grey:hover,
a.gx-bg-grey:focus {
  background-color: #b2b2b2 !important;
}
.gx-bg-light-grey {
  background-color: #fafafa !important;
}
.gx-bg-transparent {
  background-color: transparent !important;
}
.gx-bg-pink {
  background-color: #eb2f96 !important;
}
a.gx-bg-pink:hover,
a.gx-bg-pink:focus {
  background-color: #d3147d !important;
}
.gx-bg-green {
  background-color: #52c41a !important;
}
a.gx-bg-green:hover,
a.gx-bg-green:focus {
  background-color: #3f9714 !important;
}
.gx-bg-green-light {
  background-color: #caf5b5 !important;
}
a.gx-bg-green-light:hover,
a.gx-bg-green-light:focus {
  background-color: #8ae95b !important;
}
.gx-bg-red {
  background-color: #f5222d !important;
}
a.gx-bg-red:hover,
a.gx-bg-red:focus {
  background-color: #da0a15 !important;
}
.gx-bg-amber {
  background-color: #fadb14 !important;
}
a.gx-bg-amber:hover,
a.gx-bg-amber:focus {
  background-color: #d6ba05 !important;
}
.gx-bg-amber-light {
  background-color: #fdf2aa !important;
}
a.gx-bg-amber-light:hover,
a.gx-bg-amber-light:focus {
  background-color: #fcea78 !important;
}
.gx-bg-blue {
  background-color: #1890ff !important;
}
a.gx-bg-blue:hover,
a.gx-bg-blue:focus {
  background-color: #0076e4 !important;
}
.gx-bg-light-blue {
  background-color: #329cff !important;
}
a.gx-bg-light-blue:hover,
a.gx-bg-light-blue:focus {
  background-color: #4ba9ff !important;
}
.gx-bg-indigo {
  background-color: #3c1991 !important;
}
a.gx-bg-indigo:hover,
a.gx-bg-indigo:focus {
  background-color: #2a1166 !important;
}
.gx-bg-purple {
  background-color: #722ed1 !important;
}
a.gx-bg-purple:hover,
a.gx-bg-purple:focus {
  background-color: #5b25a7 !important;
}
.gx-bg-orange {
  background-color: #fa8c16 !important;
}
a.gx-bg-orange:hover,
a.gx-bg-orange:focus {
  background-color: #d87205 !important;
}
.gx-bg-yellow {
  background-color: #fadb14 !important;
}
a.gx-bg-yellow:hover,
a.gx-bg-yellow:focus {
  background-color: #d6ba05 !important;
}
.gx-bg-teal {
  background-color: #20c997 !important;
}
a.gx-bg-teal:hover,
a.gx-bg-teal:focus {
  background-color: #199d76 !important;
}
.gx-bg-cyan {
  background-color: #13c2c2 !important;
}
a.gx-bg-cyan:hover,
a.gx-bg-cyan:focus {
  background-color: #0e9494 !important;
}
.gx-bg-sepia {
  background-color: #7c3535 !important;
}
a.gx-bg-sepia:hover,
a.gx-bg-sepia:focus {
  background-color: #582626 !important;
}
.gx-bg-geekblue {
  background-color: #030852 !important;
}
a.gx-bg-geekblue:hover,
a.gx-bg-geekblue:focus {
  background-color: #010321 !important;
}
.gx-text-white {
  color: #ffffff !important;
}
.gx-text-primary {
  color: #2EB1EF !important;
}
a.gx-text-primary:hover,
a.gx-text-primary:focus {
  color: #2EB1EF !important;
}
.gx-text-secondary {
  color: #089265 !important;
}
a.gx-text-secondary:hover,
a.gx-text-secondary:focus {
  color: #089265 !important;
}
.gx-text-success {
  color: #52c41a !important;
}
a.gx-text-success:hover,
a.gx-text-success:focus {
  color: #49ad17 !important;
}
.gx-text-success-dark {
  color: #368011 !important;
}
a.gx-text-success-dark:hover,
a.gx-text-success-dark:focus {
  color: #2c6a0e !important;
}
.gx-text-info {
  color: #1890ff !important;
}
a.gx-text-info:hover,
a.gx-text-info:focus {
  color: #0084fe !important;
}
.gx-text-warning {
  color: #fa8c16 !important;
}
a.gx-text-warning:hover,
a.gx-text-warning:focus {
  color: #f17f05 !important;
}
.gx-text-danger {
  color: #f44336 !important;
}
a.gx-text-danger:hover,
a.gx-text-danger:focus {
  color: #f32c1e !important;
}
.gx-text-light {
  color: #ababab !important;
}
a.gx-text-light:hover,
a.gx-text-light:focus {
  color: #787878 !important;
}
.gx-text-light-grey {
  color: #cccccc !important;
}
a.gx-text-light-grey:hover,
a.gx-text-light-grey:focus {
  color: #bfbfbf !important;
}
.gx-text-grey {
  color: #8c8c8c !important;
}
a.gx-text-grey:hover,
a.gx-text-grey:focus {
  color: #262626 !important;
}
.gx-text-dark {
  color: #595959 !important;
}
a.gx-text-dark:hover,
a.gx-text-dark:focus {
  color: #4c4c4c !important;
}
.gx-text-black {
  color: #000000 !important;
}
a.gx-text-black:hover,
a.gx-text-black:focus {
  color: #4c4c4c !important;
}
.gx-text-pink {
  color: #eb2f96 !important;
}
a.gx-text-pink:hover,
a.gx-text-pink:focus {
  color: #e9188a !important;
}
.gx-text-green {
  color: #52c41a !important;
}
a.gx-text-green:hover,
a.gx-text-green:focus {
  color: #49ad17 !important;
}
.gx-text-red {
  color: #f5222d !important;
}
a.gx-text-red:hover,
a.gx-text-red:focus {
  color: #f30b17 !important;
}
.gx-text-amber {
  color: #fadb14 !important;
}
a.gx-text-amber:hover,
a.gx-text-amber:focus {
  color: #efd005 !important;
}
.gx-text-blue {
  color: #1890ff !important;
}
a.gx-text-blue:hover,
a.gx-text-blue:focus {
  color: #0084fe !important;
}
.gx-text-indigo {
  color: #3c1991 !important;
}
a.gx-text-indigo:hover,
a.gx-text-indigo:focus {
  color: #33157b !important;
}
.gx-text-purple {
  color: #722ed1 !important;
}
a.gx-text-purple:hover,
a.gx-text-purple:focus {
  color: #6729bc !important;
}
.gx-text-orange {
  color: #fa8c16 !important;
}
a.gx-text-orange:hover,
a.gx-text-orange:focus {
  color: #f17f05 !important;
}
.gx-text-yellow {
  color: #fadb14 !important;
}
a.gx-text-yellow:hover,
a.gx-text-yellow:focus {
  color: #efd005 !important;
}
.gx-text-teal {
  color: #20c997 !important;
}
a.gx-text-teal:hover,
a.gx-text-teal:focus {
  color: #1cb386 !important;
}
.gx-text-cyan {
  color: #13c2c2 !important;
}
a.gx-text-cyan:hover,
a.gx-text-cyan:focus {
  color: #11abab !important;
}
.gx-text-muted {
  color: #8c8c8c !important;
}
.gx-text-geekblue {
  color: #030852 !important;
}
a.gx-text-geekblue:hover,
a.gx-text-geekblue:focus {
  color: #10239e !important;
}
.gx-text-sepia {
  color: #7c3535 !important;
}
a.gx-text-sepia:hover,
a.gx-text-sepia:focus {
  color: #7c3535 !important;
}
.gx-icon-white {
  color: #ffffff !important;
}
.gx-border-primary {
  border-color: #2EB1EF !important;
}
.gx-border-secondary {
  border-color: #089265 !important;
}
.gx-border-success {
  border-color: #52c41a !important;
}
.gx-border-success-dark {
  border-color: #368011 !important;
}
.gx-border-info {
  border-color: #1890ff !important;
}
.gx-border-warning {
  border-color: #fa8c16 !important;
}
.gx-border-danger {
  border-color: #f44336 !important;
}
.gx-border-light {
  border-color: #bfbfbf !important;
}
.gx-border-dark {
  border-color: #595959 !important;
}
.gx-border-white {
  border-color: #ffffff !important;
}
.gx-border-grey {
  border-color: #bfbfbf !important;
}
.gx-border-pink {
  border-color: #eb2f96 !important;
}
.gx-border-green {
  border-color: #52c41a !important;
}
.gx-border-red {
  border-color: #f5222d !important;
}
.gx-border-amber {
  border-color: #fadb14 !important;
}
.gx-border-blue {
  border-color: #1890ff !important;
}
.gx-border-indigo {
  border-color: #3c1991 !important;
}
.gx-border-purple {
  border-color: #722ed1 !important;
}
.gx-border-orange {
  border-color: #fa8c16 !important;
}
.gx-border-yellow {
  border-color: #fadb14 !important;
}
.gx-border-teal {
  border-color: #1890ff !important;
}
.gx-border-cyan {
  border-color: #13c2c2 !important;
}
.gx-border-sepia {
  border-color: #7c3535 !important;
}
.gx-border-geekblue {
  border-color: #030852 !important;
}
.gx-btn-primary,
a.gx-btn-primary,
.btn-primary {
  color: #ffffff;
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.gx-btn-primary:hover,
a.gx-btn-primary:hover,
.btn-primary:hover,
.gx-btn-primary:focus,
a.gx-btn-primary:focus,
.btn-primary:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.gx-btn-primary.disabled,
a.gx-btn-primary.disabled,
.btn-primary.disabled,
.gx-btn-primary:disabled,
a.gx-btn-primary:disabled,
.btn-primary:disabled {
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.gx-btn-primary:not([disabled]):not(.disabled):active,
a.gx-btn-primary:not([disabled]):not(.disabled):active,
.btn-primary:not([disabled]):not(.disabled):active,
.gx-btn-primary:not([disabled]):not(.disabled).active,
a.gx-btn-primary:not([disabled]):not(.disabled).active,
.btn-primary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.gx-btn-primary-light,
a.gx-btn-primary-light,
.btn-primary-light {
  color: #595959 !important;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-primary-light:hover,
a.gx-btn-primary-light:hover,
.btn-primary-light:hover,
.gx-btn-primary-light:focus,
a.gx-btn-primary-light:focus,
.btn-primary-light:focus {
  color: #595959 !important;
  background-color: #bce6fa !important;
  border-color: #bce6fa !important;
}
.gx-btn-primary-light.disabled,
a.gx-btn-primary-light.disabled,
.btn-primary-light.disabled,
.gx-btn-primary-light:disabled,
a.gx-btn-primary-light:disabled,
.btn-primary-light:disabled {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-primary-light:not([disabled]):not(.disabled):active,
a.gx-btn-primary-light:not([disabled]):not(.disabled):active,
.btn-primary-light:not([disabled]):not(.disabled):active,
.gx-btn-primary-light:not([disabled]):not(.disabled).active,
a.gx-btn-primary-light:not([disabled]):not(.disabled).active,
.btn-primary-light:not([disabled]):not(.disabled).active {
  color: #595959;
  background-color: #ebf8fe !important;
  border-color: #ebf8fe !important;
}
.gx-btn-secondary,
a.gx-btn-secondary {
  color: #ffffff !important;
  background-color: #089265 !important;
  border-color: #089265 !important;
}
.gx-btn-secondary:hover,
a.gx-btn-secondary:hover,
.gx-btn-secondary:focus,
a.gx-btn-secondary:focus {
  color: #ffffff;
  background-color: #089265 !important;
  border-color: #089265 !important;
}
.gx-btn-secondary.disabled,
a.gx-btn-secondary.disabled,
.gx-btn-secondary:disabled,
a.gx-btn-secondary:disabled {
  background-color: #089265 !important;
  border-color: #089265 !important;
}
.gx-btn-secondary:not([disabled]):not(.disabled):active,
a.gx-btn-secondary:not([disabled]):not(.disabled):active,
.gx-btn-secondary:not([disabled]):not(.disabled).active,
a.gx-btn-secondary:not([disabled]):not(.disabled).active {
  color: #ffffff;
  background-color: #089265 !important;
  border-color: #089265 !important;
}
.gx-btn-success,
a.gx-btn-success {
  color: #ffffff !important;
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success:hover,
a.gx-btn-success:hover,
.gx-btn-success:focus,
a.gx-btn-success:focus {
  color: #ffffff !important;
  background-color: #3f9714 !important;
  border-color: #3f9714 !important;
}
.gx-btn-success.disabled,
a.gx-btn-success.disabled,
.gx-btn-success:disabled,
a.gx-btn-success:disabled {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success:not([disabled]):not(.disabled):active,
a.gx-btn-success:not([disabled]):not(.disabled):active,
.gx-btn-success:not([disabled]):not(.disabled).active,
a.gx-btn-success:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #3f9714 !important;
  border-color: #3f9714 !important;
}
.gx-btn-success-dark,
a.gx-btn-success-dark {
  color: #ffffff !important;
  background-color: #368011 !important;
  border-color: #368011 !important;
}
.gx-btn-success-dark:hover,
a.gx-btn-success-dark:hover,
.gx-btn-success-dark:focus,
a.gx-btn-success-dark:focus {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-success-dark.disabled,
a.gx-btn-success-dark.disabled,
.gx-btn-success-dark:disabled,
a.gx-btn-success-dark:disabled {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-success-dark:not([disabled]):not(.disabled):active,
a.gx-btn-success-dark:not([disabled]):not(.disabled):active,
.gx-btn-success-dark:not([disabled]):not(.disabled).active,
a.gx-btn-success-dark:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-info,
a.gx-btn-info {
  color: #ffffff !important;
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-info:hover,
a.gx-btn-info:hover,
.gx-btn-info:focus,
a.gx-btn-info:focus {
  color: #ffffff !important;
  background-color: #0076e4 !important;
  border-color: #0076e4 !important;
}
.gx-btn-info.disabled,
a.gx-btn-info.disabled,
.gx-btn-info:disabled,
a.gx-btn-info:disabled {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-info:not([disabled]):not(.disabled):active,
a.gx-btn-info:not([disabled]):not(.disabled):active,
.gx-btn-info:not([disabled]):not(.disabled).active,
a.gx-btn-info:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0076e4 !important;
  border-color: #0076e4 !important;
}
.gx-btn-warning,
a.gx-btn-warning {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-warning:hover,
a.gx-btn-warning:hover,
.gx-btn-warning:focus,
a.gx-btn-warning:focus {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-warning.disabled,
a.gx-btn-warning.disabled,
.gx-btn-warning:disabled,
a.gx-btn-warning:disabled {
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-warning:not([disabled]):not(.disabled):active,
a.gx-btn-warning:not([disabled]):not(.disabled):active,
.gx-btn-warning:not([disabled]):not(.disabled).active,
a.gx-btn-warning:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-yellow,
a.gx-btn-yellow {
  color: #262626 !important;
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.gx-btn-yellow:hover,
a.gx-btn-yellow:hover,
.gx-btn-yellow:focus,
a.gx-btn-yellow:focus {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.gx-btn-yellow.disabled,
a.gx-btn-yellow.disabled,
.gx-btn-yellow:disabled,
a.gx-btn-yellow:disabled {
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.gx-btn-yellow:not([disabled]):not(.disabled):active,
a.gx-btn-yellow:not([disabled]):not(.disabled):active,
.gx-btn-yellow:not([disabled]):not(.disabled).active,
a.gx-btn-yellow:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.gx-btn-danger,
a.gx-btn-danger,
.gx-btn-red,
a.gx-btn-red {
  color: #ffffff !important;
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-danger:hover,
a.gx-btn-danger:hover,
.gx-btn-red:hover,
a.gx-btn-red:hover,
.gx-btn-danger:focus,
a.gx-btn-danger:focus,
.gx-btn-red:focus,
a.gx-btn-red:focus {
  color: #ffffff !important;
  background-color: #ea1c0d !important;
  border-color: #ea1c0d !important;
}
.gx-btn-danger.disabled,
a.gx-btn-danger.disabled,
.gx-btn-red.disabled,
a.gx-btn-red.disabled,
.gx-btn-danger:disabled,
a.gx-btn-danger:disabled,
.gx-btn-red:disabled,
a.gx-btn-red:disabled {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-danger:not([disabled]):not(.disabled):active,
a.gx-btn-danger:not([disabled]):not(.disabled):active,
.gx-btn-red:not([disabled]):not(.disabled):active,
a.gx-btn-red:not([disabled]):not(.disabled):active,
.gx-btn-danger:not([disabled]):not(.disabled).active,
a.gx-btn-danger:not([disabled]):not(.disabled).active,
.gx-btn-red:not([disabled]):not(.disabled).active,
a.gx-btn-red:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #ea1c0d !important;
  border-color: #ea1c0d !important;
}
.gx-btn-light,
a.gx-btn-light {
  color: #8c8c8c !important;
  background-color: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
}
.gx-btn-light:hover,
a.gx-btn-light:hover,
.gx-btn-light:focus,
a.gx-btn-light:focus {
  color: #8c8c8c !important;
  background-color: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-light.disabled,
a.gx-btn-light.disabled,
.gx-btn-light:disabled,
a.gx-btn-light:disabled {
  background-color: #f5f5f5 !important;
  border-color: #f5f5f5 !important;
}
.gx-btn-light:not([disabled]):not(.disabled):active,
a.gx-btn-light:not([disabled]):not(.disabled):active,
.gx-btn-light:not([disabled]):not(.disabled).active,
a.gx-btn-light:not([disabled]):not(.disabled).active {
  color: #262626 !important;
  background-color: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
}
.gx-btn-dark,
a.gx-btn-dark {
  color: #ffffff !important;
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-dark:hover,
a.gx-btn-dark:hover,
.gx-btn-dark:focus,
a.gx-btn-dark:focus {
  color: #ffffff !important;
  background-color: #0c0c0c !important;
  border-color: #0c0c0c !important;
}
.gx-btn-dark.disabled,
a.gx-btn-dark.disabled,
.gx-btn-dark:disabled,
a.gx-btn-dark:disabled {
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-dark:not([disabled]):not(.disabled):active,
a.gx-btn-dark:not([disabled]):not(.disabled):active,
.gx-btn-dark:not([disabled]):not(.disabled).active,
a.gx-btn-dark:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0c0c0c !important;
  border-color: #0c0c0c !important;
}
.gx-btn-purple,
a.gx-btn-purple {
  color: #ffffff !important;
  background-color: #722ed1 !important;
  border-color: #722ed1 !important;
}
.gx-btn-purple:hover,
a.gx-btn-purple:hover,
.gx-btn-purple:focus,
a.gx-btn-purple:focus {
  color: #ffffff !important;
  background-color: #5b25a7 !important;
  border-color: #5b25a7 !important;
}
.gx-btn-purple.disabled,
a.gx-btn-purple.disabled,
.gx-btn-purple:disabled,
a.gx-btn-purple:disabled {
  background-color: #722ed1 !important;
  border-color: #722ed1 !important;
}
.gx-btn-purple:not([disabled]):not(.disabled):active,
a.gx-btn-purple:not([disabled]):not(.disabled):active,
.gx-btn-purple:not([disabled]):not(.disabled).active,
a.gx-btn-purple:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #5b25a7 !important;
  border-color: #5b25a7 !important;
}
.gx-btn-sepia,
a.gx-btn-sepia {
  color: #ffffff !important;
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-sepia:hover,
a.gx-btn-sepia:hover,
.gx-btn-sepia:focus,
a.gx-btn-sepia:focus {
  color: #ffffff !important;
  background-color: #461e1e !important;
  border-color: #461e1e !important;
}
.gx-btn-sepia.disabled,
a.gx-btn-sepia.disabled,
.gx-btn-sepia:disabled,
a.gx-btn-sepia:disabled {
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-sepia:not([disabled]):not(.disabled):active,
a.gx-btn-sepia:not([disabled]):not(.disabled):active,
.gx-btn-sepia:not([disabled]):not(.disabled).active,
a.gx-btn-sepia:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #461e1e !important;
  border-color: #461e1e !important;
}
.gx-btn-geekblue,
a.gx-btn-geekblue {
  color: #ffffff !important;
  background-color: #10239e !important;
  border-color: #10239e !important;
}
.gx-btn-geekblue:hover,
a.gx-btn-geekblue:hover,
.gx-btn-geekblue:focus,
a.gx-btn-geekblue:focus {
  color: #ffffff !important;
  background-color: #0b1970 !important;
  border-color: #0b1970 !important;
}
.gx-btn-geekblue.disabled,
a.gx-btn-geekblue.disabled,
.gx-btn-geekblue:disabled,
a.gx-btn-geekblue:disabled {
  background-color: #10239e !important;
  border-color: #10239e !important;
}
.gx-btn-geekblue:not([disabled]):not(.disabled):active,
a.gx-btn-geekblue:not([disabled]):not(.disabled):active,
.gx-btn-geekblue:not([disabled]):not(.disabled).active,
a.gx-btn-geekblue:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #091459 !important;
  border-color: #091459 !important;
}
.gx-btn-cyan,
a.gx-btn-cyan {
  color: #ffffff !important;
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.gx-btn-cyan:hover,
a.gx-btn-cyan:hover,
.gx-btn-cyan:focus,
a.gx-btn-cyan:focus {
  color: #ffffff !important;
  background-color: #0e9494 !important;
  border-color: #0e9494 !important;
}
.gx-btn-cyan.disabled,
a.gx-btn-cyan.disabled,
.gx-btn-cyan:disabled,
a.gx-btn-cyan:disabled {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.gx-btn-cyan:not([disabled]):not(.disabled):active,
a.gx-btn-cyan:not([disabled]):not(.disabled):active,
.gx-btn-cyan:not([disabled]):not(.disabled).active,
a.gx-btn-cyan:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #0e8a8a !important;
  border-color: #0e8a8a !important;
}
.gx-btn-white,
a.gx-btn-white {
  color: #545454 !important;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-white:hover,
a.gx-btn-white:hover,
.gx-btn-white:focus,
a.gx-btn-white:focus {
  color: #545454 !important;
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
}
.gx-btn-white.disabled,
a.gx-btn-white.disabled,
.gx-btn-white:disabled,
a.gx-btn-white:disabled {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
.gx-btn-white:not([disabled]):not(.disabled):active,
a.gx-btn-white:not([disabled]):not(.disabled):active,
.gx-btn-white:not([disabled]):not(.disabled).active,
a.gx-btn-white:not([disabled]):not(.disabled).active {
  color: #545454 !important;
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
}
.gx-btn-orange,
a.gx-btn-orange {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-orange:hover,
a.gx-btn-orange:hover,
.gx-btn-orange:focus,
a.gx-btn-orange:focus {
  color: #ffffff !important;
  background-color: #d87205 !important;
  border-color: #d87205 !important;
}
.gx-btn-orange.disabled,
a.gx-btn-orange.disabled,
.gx-btn-orange:disabled,
a.gx-btn-orange:disabled {
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-orange:not([disabled]):not(.disabled):active,
a.gx-btn-orange:not([disabled]):not(.disabled):active,
.gx-btn-orange:not([disabled]):not(.disabled).active,
a.gx-btn-orange:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #ce6d04 !important;
  border-color: #ce6d04 !important;
}
.gx-btn-outline-primary,
a.gx-btn-outline-primary {
  color: #2EB1EF !important;
  background-color: transparent !important;
  border-color: #2EB1EF !important;
}
.gx-btn-outline-primary:hover,
a.gx-btn-outline-primary:hover,
.gx-btn-outline-primary:focus,
a.gx-btn-outline-primary:focus {
  color: #ffffff !important;
  background-color: #2EB1EF !important;
  border-color: #2EB1EF !important;
}
.gx-btn-outline-primary.disabled,
a.gx-btn-outline-primary.disabled,
.gx-btn-outline-primary:disabled,
a.gx-btn-outline-primary:disabled {
  color: #2EB1EF !important;
  background-color: transparent !important;
}
.gx-btn-outline-secondary,
a.gx-btn-outline-secondary {
  color: #089265 !important;
  background-color: transparent !important;
  border-color: #089265 !important;
}
.gx-btn-outline-secondary:hover,
a.gx-btn-outline-secondary:hover,
.gx-btn-outline-secondary:focus,
a.gx-btn-outline-secondary:focus {
  color: #ffffff !important;
  background-color: #089265 !important;
  border-color: #089265 !important;
}
.gx-btn-outline-secondary.disabled,
a.gx-btn-outline-secondary.disabled,
.gx-btn-outline-secondary:disabled,
a.gx-btn-outline-secondary:disabled {
  color: #089265 !important;
  background-color: transparent !important;
}
.gx-btn-outline-success,
a.gx-btn-outline-success {
  color: #52c41a !important;
  background-color: transparent !important;
  border-color: #52c41a !important;
}
.gx-btn-outline-success:hover,
a.gx-btn-outline-success:hover,
.gx-btn-outline-success:focus,
a.gx-btn-outline-success:focus {
  color: #ffffff !important;
  background-color: #52c41a !important;
  border-color: #52c41a !important;
}
.gx-btn-outline-success.disabled,
a.gx-btn-outline-success.disabled,
.gx-btn-outline-success:disabled,
a.gx-btn-outline-success:disabled {
  color: #52c41a !important;
  background-color: transparent !important;
}
.gx-btn-outline-success-dark,
a.gx-btn-outline-success-dark {
  color: #52c41a !important;
  background-color: transparent !important;
  border-color: #368011 !important;
}
.gx-btn-outline-success-dark:hover,
a.gx-btn-outline-success-dark:hover,
.gx-btn-outline-success-dark:focus,
a.gx-btn-outline-success-dark:focus {
  color: #ffffff !important;
  background-color: #2c6a0e !important;
  border-color: #2c6a0e !important;
}
.gx-btn-outline-success-dark.disabled,
a.gx-btn-outline-success-dark.disabled,
.gx-btn-outline-success-dark:disabled,
a.gx-btn-outline-success-dark:disabled {
  color: #2c6a0e !important;
  background-color: transparent !important;
}
.gx-btn-outline-info,
a.gx-btn-outline-info {
  color: #1890ff !important;
  background-color: transparent !important;
  border-color: #1890ff !important;
}
.gx-btn-outline-info:hover,
a.gx-btn-outline-info:hover,
.gx-btn-outline-info:focus,
a.gx-btn-outline-info:focus {
  color: #ffffff !important;
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
.gx-btn-outline-info.disabled,
a.gx-btn-outline-info.disabled,
.gx-btn-outline-info:disabled,
a.gx-btn-outline-info:disabled {
  color: #1890ff !important;
  background-color: transparent !important;
}
.gx-btn-outline-warning,
a.gx-btn-outline-warning {
  color: #fa8c16 !important;
  background-color: transparent !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-warning:hover,
a.gx-btn-outline-warning:hover,
.gx-btn-outline-warning:focus,
a.gx-btn-outline-warning:focus {
  color: #262626 !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-warning.disabled,
a.gx-btn-outline-warning.disabled,
.gx-btn-outline-warning:disabled,
a.gx-btn-outline-warning:disabled {
  color: #fa8c16 !important;
  background-color: transparent !important;
}
.gx-btn-outline-danger,
a.gx-btn-outline-danger,
.gx-btn-outline-red,
a.gx-btn-outline-red {
  color: #f44336 !important;
  background-color: transparent !important;
  border-color: #f44336 !important;
}
.gx-btn-outline-danger:hover,
a.gx-btn-outline-danger:hover,
.gx-btn-outline-red:hover,
a.gx-btn-outline-red:hover,
.gx-btn-outline-danger:focus,
a.gx-btn-outline-danger:focus,
.gx-btn-outline-red:focus,
a.gx-btn-outline-red:focus {
  color: #ffffff !important;
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.gx-btn-outline-danger.disabled,
a.gx-btn-outline-danger.disabled,
.gx-btn-outline-red.disabled,
a.gx-btn-outline-red.disabled,
.gx-btn-outline-danger:disabled,
a.gx-btn-outline-danger:disabled,
.gx-btn-outline-red:disabled,
a.gx-btn-outline-red:disabled {
  color: #f44336 !important;
  background-color: transparent !important;
}
.gx-btn-outline-light,
a.gx-btn-outline-light {
  color: #8c8c8c !important;
  background-color: transparent !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-outline-light:hover,
a.gx-btn-outline-light:hover,
.gx-btn-outline-light:focus,
a.gx-btn-outline-light:focus {
  color: #8c8c8c !important;
  background-color: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
}
.gx-btn-outline-light.disabled,
a.gx-btn-outline-light.disabled,
.gx-btn-outline-light:disabled,
a.gx-btn-outline-light:disabled {
  color: #e8e8e8 !important;
  background-color: transparent !important;
}
.gx-btn-outline-dark,
a.gx-btn-outline-dark {
  color: #262626 !important;
  background-color: transparent !important;
  border-color: #262626 !important;
}
.gx-btn-outline-dark:hover,
a.gx-btn-outline-dark:hover,
.gx-btn-outline-dark:focus,
a.gx-btn-outline-dark:focus {
  color: #ffffff !important;
  background-color: #262626 !important;
  border-color: #262626 !important;
}
.gx-btn-outline-dark.disabled,
a.gx-btn-outline-dark.disabled,
.gx-btn-outline-dark:disabled,
a.gx-btn-outline-dark:disabled {
  color: #262626 !important;
  background-color: transparent !important;
}
.gx-btn-outline-sepia,
a.gx-btn-outline-sepia {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #7c3535 !important;
}
.gx-btn-outline-sepia:hover,
a.gx-btn-outline-sepia:hover,
.gx-btn-outline-sepia:focus,
a.gx-btn-outline-sepia:focus {
  color: #ffffff !important;
  background-color: #7c3535 !important;
  border-color: #7c3535 !important;
}
.gx-btn-outline-sepia.disabled,
a.gx-btn-outline-sepia.disabled,
.gx-btn-outline-sepia:disabled,
a.gx-btn-outline-sepia:disabled {
  color: #7c3535 !important;
  background-color: transparent !important;
}
.gx-btn-outline-geekblue,
a.gx-btn-outline-geekblue {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #030852 !important;
}
.gx-btn-outline-geekblue:hover,
a.gx-btn-outline-geekblue:hover,
.gx-btn-outline-geekblue:focus,
a.gx-btn-outline-geekblue:focus {
  color: #ffffff !important;
  background-color: #030852 !important;
  border-color: #030852 !important;
}
.gx-btn-outline-geekblue.disabled,
a.gx-btn-outline-geekblue.disabled,
.gx-btn-outline-geekblue:disabled,
a.gx-btn-outline-geekblue:disabled {
  color: #2f54eb !important;
  background-color: transparent !important;
}
.gx-btn-outline-orange,
a.gx-btn-outline-orange {
  color: #ffffff !important;
  background-color: transparent !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-orange:hover,
a.gx-btn-outline-orange:hover,
.gx-btn-outline-orange:focus,
a.gx-btn-outline-orange:focus {
  color: #ffffff !important;
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
}
.gx-btn-outline-orange.disabled,
a.gx-btn-outline-orange.disabled,
.gx-btn-outline-orange:disabled,
a.gx-btn-outline-orange:disabled {
  color: #fa8c16 !important;
  background-color: transparent !important;
}
.gx-badge-primary {
  background-color: #2EB1EF !important;
}
.gx-badge-primary-light {
  background-color: #82e0ff !important;
}
.gx-badge-secondary {
  background-color: #089265 !important;
}
.gx-badge-success {
  background-color: #52c41a !important;
}
.gx-badge-success-dark {
  background-color: #368011 !important;
}
.gx-badge-info {
  background-color: #1890ff !important;
}
.gx-badge-warning {
  background-color: #fa8c16 !important;
}
.gx-badge-danger {
  background-color: #f44336 !important;
}
.gx-badge-light {
  background-color: #e8e8e8 !important;
}
.gx-badge-dark {
  background-color: #000000 !important;
}
.gx-badge-white {
  background-color: #ffffff !important;
}
.gx-badge-grey {
  background-color: #bfbfbf !important;
}
.gx-badge-light-grey {
  background-color: #d9d9d9 !important;
}
.gx-badge-pink {
  background-color: #eb2f96 !important;
}
.gx-badge-green {
  background-color: #52c41a !important;
}
.gx-badge-green-light {
  background-color: #caf5b5 !important;
}
.gx-badge-red {
  background-color: #f5222d !important;
}
.gx-badge-amber {
  background-color: #fadb14 !important;
}
.gx-badge-amber-light {
  background-color: #fdf2aa !important;
}
.gx-badge-blue {
  background-color: #1890ff !important;
}
.gx-badge-light-blue {
  background-color: #329cff !important;
}
.gx-badge-indigo {
  background-color: #3c1991 !important;
}
.gx-badge-purple {
  background-color: #722ed1 !important;
}
.gx-badge-orange {
  background-color: #fa8c16 !important;
}
.gx-badge-yellow {
  background-color: #fadb14 !important;
}
.gx-badge-teal {
  background-color: #20c997 !important;
}
.gx-badge-cyan {
  background-color: #13c2c2 !important;
}
.gx-badge-sepia {
  background-color: #7c3535 !important;
}
.gx-badge-geekblue {
  background-color: #030852 !important;
}
/* Ripple magic */
.gx-ripple-effect {
  position: relative;
  overflow: hidden;
}
.gx-ripple-effect:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.gx-ripple-effect:hover:after {
  animation: ripple 1s ease-out;
}
@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
.gx-pulse-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
.gx-online-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}
@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}
.gx-away-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  animation: away 2s infinite;
}
@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
    box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);
  }
}
.gx-orange-effect {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  animation: away 2s infinite;
}
@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
    box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
  }
}
@-webkit-keyframes fxicon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fxicon-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.fxicon-hc-spin {
  -webkit-animation: fxicon-spin 1.5s infinite linear;
  animation: fxicon-spin 1.5s infinite linear;
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadein {
  -webkit-animation-name: fadein;
  animation-name: fadein;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeout {
  -webkit-animation-name: fadeout;
  animation-name: fadeout;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  /* This is more usable for users trying to click it. */
  background-color: rgba(100, 100, 100, 0.1);
  -webkit-border-radius: 100px;
}
/* hover effect for both scrollbar area, and scrollbar 'thumb' */
::-webkit-scrollbar:hover {
  background-color: rgba(0, 0, 0, 0.09);
}
/* The scrollbar 'thumb' ...that marque oval shape in a scrollbar */
::-webkit-scrollbar-thumb {
  /* This is the EXACT color of Mac OS scrollbars.
     Yes, I pulled out digital color meter */
  background: #9BA4AC;
  -webkit-border-radius: 100px;
}
::-webkit-scrollbar-thumb:active {
  background: #9BA4AC;
  /* Some darker color when you click it */
  -webkit-border-radius: 100px;
}
/*Dark Mode */
.dark-theme ::-webkit-scrollbar-thumb {
  /* This is the EXACT color of Mac OS scrollbars.
      Yes, I pulled out digital color meter */
  background: #226380;
  -webkit-border-radius: 100px;
}
.dark-theme ::-webkit-scrollbar-thumb:active {
  background: #226380;
  /* Some darker color when you click it */
  -webkit-border-radius: 100px;
}
/* Hide the print-only version by default on screen */
.showWhenPrint {
  display: none !important;
}
@media print {
  /* 4. Hide the screen-only version (MousePanZoom) */
  .hideWhenPrint {
    display: none !important;
  }
  /* 5. Show the print-only version and ensure it fills the page */
  .showWhenPrint {
    display: block !important;
  }
}
/*Base Styles*/
body {
  overflow: hidden;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  width: 100% !important;
  position: relative;
  font-weight: 400;
}
body.framed-layout {
  padding: 20px;
  background-color: #2EB1EF;
}
@media screen and (max-width: 991px) {
  body.framed-layout {
    padding: 0;
  }
}
body.boxed-layout {
  background-color: #2EB1EF;
  max-width: 1280px;
  margin: 0 auto;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
@media screen and (min-width: 1600px) {
  body.boxed-layout {
    max-width: 1500px;
  }
}
body.full-scroll {
  overflow: inherit;
}
#root {
  height: 100vh;
}
.framed-layout #root {
  height: calc(100vh - 40px);
  overflow: hidden;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
}
@media screen and (max-width: 991px) {
  .framed-layout #root {
    height: 100vh;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.gx-pointer,
.gx-link {
  cursor: pointer;
}
a,
.gx-link {
  color: #2EB1EF;
}
a:hover,
.gx-link:hover,
a:focus,
.gx-link:focus {
  color: #2EB1EF;
}
a:focus {
  text-decoration: none;
}
ol,
ul,
dl {
  padding-left: 30px;
  margin-bottom: 10px;
}
img {
  max-width: 100%;
}
.gx-w-25 {
  width: 25% !important;
}
.gx-w-50 {
  width: 50% !important;
}
.gx-w-75 {
  width: 75% !important;
}
.gx-w-100 {
  width: 100% !important;
}
.gx-h-25 {
  height: 25% !important;
}
.gx-h-50 {
  height: 50% !important;
}
.gx-h-75 {
  height: 75% !important;
}
.gx-h-100 {
  height: 100% !important;
}
.gx-mw-100 {
  max-width: 100% !important;
}
.gx-mh-100 {
  max-height: 100% !important;
}
.gx-minw50 {
  min-width: 50px;
}
.gx-border {
  border: solid 1px #e8e8e8;
}
.gx-border-2 {
  border: solid 2px #e8e8e8;
}
.gx-border-top {
  border-top: solid 1px #e8e8e8;
}
.gx-border-bottom {
  border-bottom: solid 1px #e8e8e8;
}
.gx-border-bottom-2 {
  border-bottom: solid 2px #e8e8e8;
}
.gx-border-left {
  border-left: solid 1px #e8e8e8;
}
.gx-border-right {
  border-right: solid 1px #e8e8e8;
}
.gx-border-0 {
  border: 0 none !important;
}
.gx-page-heading {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-page-heading {
    margin-bottom: 20px;
  }
}
.gx-page-title {
  font-size: 20px;
  margin-bottom: 0;
}
.gx-size-200 {
  height: 200px !important;
  width: 200px !important;
  line-height: 200px !important;
}
.gx-size-150 {
  height: 150px !important;
  width: 150px !important;
  line-height: 150px !important;
}
.gx-size-120 {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px !important;
}
.gx-size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px !important;
}
.gx-size-90 {
  height: 90px !important;
  width: 90px !important;
  line-height: 90px !important;
}
.gx-size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px !important;
}
.gx-size-60 {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px !important;
}
.gx-size-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px !important;
}
.gx-size-40 {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px !important;
}
.gx-size-36 {
  height: 36px !important;
  width: 36px !important;
  line-height: 36px !important;
}
.gx-size-30 {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px !important;
}
.gx-size-24 {
  height: 24px !important;
  width: 24px !important;
  line-height: 24px !important;
}
.gx-size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px !important;
}
.gx-size-15 {
  height: 15px !important;
  width: 15px !important;
  line-height: 14px !important;
}
.gx-size-10 {
  height: 10px !important;
  width: 10px !important;
  line-height: 10px !important;
}
.gx-size-8 {
  height: 8px !important;
  width: 8px !important;
  line-height: 8px !important;
}
.gx-width-175 {
  width: 175px !important;
}
.gx-img-fluid,
.gx-img-thumbnail {
  max-width: 100%;
  height: auto;
}
.gx-img-fluid-full {
  width: 100%;
}
/*Social Style*/
.gx-social-link {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin: 0 -5px 10px;
}
.gx-social-link li {
  padding: 0 5px;
  margin-bottom: 5px;
  line-height: 1;
}
.gx-social-link li a,
.gx-social-link li .gx-link,
.gx-social-link li i {
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 34px;
  font-size: 16px;
  text-align: center;
  color: #2EB1EF;
  border: solid 1px #2EB1EF;
  border-radius: 50%;
}
.gx-social-link li.active a,
.gx-social-link li.active .gx-link,
.gx-social-link li.active i,
.gx-social-link li a:hover,
.gx-social-link li .gx-link:hover,
.gx-social-link li i:hover,
.gx-social-link li a:focus,
.gx-social-link li .gx-link:focus,
.gx-social-link li i:focus {
  color: #ffffff;
  background: #2EB1EF;
}
.gx-card-social .gx-social-link {
  margin-bottom: 0;
  -webkit-justify-content: space-around;
  -ms-justify-content: space-around;
  justify-content: space-around;
}
.gx-float-left {
  float: left !important;
}
.gx-float-right {
  float: right !important;
}
.gx-float-none {
  float: none !important;
}
@media (min-width: 576px) {
  .gx-float-sm-left {
    float: left !important;
  }
  .gx-float-sm-right {
    float: right !important;
  }
  .gx-float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .gx-float-md-left {
    float: left !important;
  }
  .gx-float-md-right {
    float: right !important;
  }
  .gx-float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .gx-float-lg-left {
    float: left !important;
  }
  .gx-float-lg-right {
    float: right !important;
  }
  .gx-float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .gx-float-xl-left {
    float: left !important;
  }
  .gx-float-xl-right {
    float: right !important;
  }
  .gx-float-xl-none {
    float: none !important;
  }
}
.gx-position-static {
  position: static !important;
}
.gx-position-relative {
  position: relative !important;
}
.gx-position-absolute {
  position: absolute !important;
}
.gx-position-fixed {
  position: fixed !important;
}
.gx-position-sticky {
  position: sticky !important;
}
.gx-fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.gx-fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.gx-top-0 {
  top: 0 !important;
}
.gx-bottom-0 {
  bottom: 0 !important;
}
.gx-left-0 {
  left: 0 !important;
}
.gx-right-0 {
  right: 0 !important;
}
/*Embed Responsive Classes*/
.gx-embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.gx-embed-responsive:before {
  display: block;
  content: "";
}
.gx-embed-responsive .gx-embed-responsive-item,
.gx-embed-responsive iframe,
.gx-embed-responsive embed,
.gx-embed-responsive object,
.gx-embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.gx-embed-responsive-21by9:before {
  padding-top: 42.8571428571%;
}
.gx-embed-responsive-16by9:before {
  padding-top: 56.25%;
}
.gx-embed-responsive-4by3:before {
  padding-top: 75%;
}
.gx-embed-responsive-1by1:before {
  padding-top: 100%;
}
/*Media Object Classes*/
.gx-media {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
}
.gx-media-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
/*Overflow styles*/
.gx-overflow-auto {
  overflow: auto;
}
.gx-z-index-20 {
  position: relative;
  z-index: 20;
}
/*Hr style*/
hr {
  border-color: rgba(250, 250, 250, 0.2);
  margin: 15px 0;
}
/*Status style*/
.gx-status-pos {
  position: relative;
}
.gx-status-pos .gx-status {
  display: block;
  position: absolute;
  left: 0;
  top: 2px;
  z-index: 1;
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-status-pos .gx-status.gx-small {
  width: 8px;
  height: 8px;
}
.gx-status-pos .gx-status.gx-status-rtl {
  top: -4px;
  left: auto;
  right: -4px;
}
.gx-status-pos .gx-status.gx-online {
  background-color: #52c41a;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
.gx-status-pos .gx-status.gx-offline {
  background-color: #ffffff;
  border: solid 1px #52c41a;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);
  animation: online 2s infinite;
}
.gx-status-pos .gx-status.gx-away {
  background-color: #fadb14;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);
  animation: away 2s infinite;
}
.gx-status-pos .gx-status.gx-orange {
  background-color: #fa8c16;
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);
  animation: away 2s infinite;
}
.gx-box-shadow {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
.gx-no-box-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.gx-rounded-xs {
  -webkit-border-radius: 2px !important;
  -moz-border-radius: 2px !important;
  border-radius: 2px !important;
}
.gx-rounded-sm {
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
}
.gx-rounded-base {
  -webkit-border-radius: 6px !important;
  -moz-border-radius: 6px !important;
  border-radius: 6px !important;
}
.gx-rounded-lg {
  -webkit-border-radius: 10px !important;
  -moz-border-radius: 10px !important;
  border-radius: 10px !important;
}
.gx-rounded-xxl {
  -webkit-border-radius: 30px !important;
  -moz-border-radius: 30px !important;
  border-radius: 30px !important;
}
.gx-rounded-circle {
  -webkit-border-radius: 50% !important;
  -moz-border-radius: 50% !important;
  border-radius: 50% !important;
}
.gx-border-radius-top-left-0 {
  -moz-border-top-left-radius: 0;
  -webkit-border-top-left-radius: 0;
  border-top-left-radius: 0;
}
.gx-border-radius-top-right-0 {
  -moz-border-top-right-radius: 0;
  -webkit-border-top-right-radius: 0;
  border-top-right-radius: 0;
}
.gx-border-radius-bottom-left-0 {
  -moz-border-bottom-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  border-bottom-left-radius: 0;
}
.gx-border-radius-bottom-right-0 {
  -moz-border-bottom-right-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  border-bottom-right-radius: 0;
}
.gx-vertical-align-top {
  vertical-align: top;
}
.gx-vertical-align-middle {
  vertical-align: middle;
}
.gx-vertical-align-bottom {
  vertical-align: bottom;
}
.gx-separator {
  background-color: #2EB1EF;
  width: 20px;
  height: 2px;
  margin: 0 auto 10px;
}
.gx-loader-400 {
  height: 400px;
}
@media screen and (max-width: 1199px) {
  .gx-loader-400 {
    height: 300px;
  }
}
.gx-object-cover {
  object-fit: cover;
}
.cke_editable,
.cke_editor_editor2 {
  font-family: "DM Sans", sans-serif !important;
}
.gx-top2 {
  position: relative;
  top: 2px;
}
@media screen and (max-width: 1366px) {
  .gx-hide-1366 {
    display: none;
  }
}
/*flex Styles*/
.gx-d-flex {
  display: flex !important;
}
.gx-d-none {
  display: none !important;
}
.gx-d-inline-block {
  display: inline-block !important;
}
.gx-d-block {
  display: block !important;
}
.gx-d-inline-flex {
  display: inline-flex !important;
}
.gx-flex-1 {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
/*Display Flex Classes*/
.gx-flex-row {
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: -ms-flex !important;
  display: flex !important;
  -webkit-flex-direction: row !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
  -webkit-flex-wrap: wrap !important;
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}
.gx-flex-column {
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: -ms-flex !important;
  display: flex !important;
  -webkit-flex-direction: column !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
  -webkit-flex-wrap: nowrap !important;
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
}
.gx-flex-nowrap {
  flex-wrap: nowrap !important;
}
.gx-flex-row-reverse {
  flex-direction: row-reverse !important;
}
.gx-flex-column-reverse {
  flex-direction: column-reverse !important;
}
.gx-justify-content-start {
  -webkit-justify-content: flex-start !important;
  -ms-justify-content: flex-start !important;
  justify-content: flex-start !important;
}
.gx-justify-content-end {
  -webkit-justify-content: flex-end !important;
  -ms-justify-content: flex-end !important;
  justify-content: flex-end !important;
}
.gx-justify-content-center {
  -webkit-justify-content: center !important;
  -ms-justify-content: center !important;
  justify-content: center !important;
}
.gx-justify-content-between {
  -webkit-justify-content: space-between !important;
  -ms-justify-content: space-between !important;
  justify-content: space-between !important;
}
.gx-justify-content-around {
  -webkit-justify-content: space-around !important;
  -ms-justify-content: space-around !important;
  justify-content: space-around !important;
}
.gx-align-items-start {
  -webkit-align-items: flex-start !important;
  -ms-align-items: flex-start !important;
  align-items: flex-start !important;
}
.gx-align-items-end {
  -webkit-align-items: flex-end !important;
  -ms-align-items: flex-end !important;
  align-items: flex-end !important;
}
.gx-align-items-center {
  -webkit-align-items: center !important;
  -ms-align-items: center !important;
  align-items: center !important;
}
.gx-align-items-stretch {
  -webkit-align-items: stretch !important;
  -ms-align-items: stretch !important;
  align-items: stretch !important;
}
.gx-align-content-start {
  -webkit-align-content: flex-start !important;
  -ms-align-content: flex-start !important;
  align-content: flex-start !important;
}
.gx-align-content-end {
  -webkit-align-content: flex-end !important;
  -ms-align-content: flex-end !important;
  align-content: flex-end !important;
}
.gx-align-content-center {
  -webkit-align-content: center !important;
  -ms-align-content: center !important;
  align-content: center !important;
}
.gx-align-content-between {
  -webkit-align-content: space-between !important;
  -ms-align-content: space-between !important;
  align-content: space-between !important;
}
.gx-align-content-around {
  -webkit-align-content: space-around !important;
  -ms-align-content: space-around !important;
  align-content: space-around !important;
}
.gx-align-content-stretch {
  -webkit-align-content: stretch !important;
  -ms-align-content: stretch !important;
  align-content: stretch !important;
}
.gx-align-self-auto {
  -webkit-align-self: auto !important;
  -ms-align-self: auto !important;
  align-self: auto !important;
}
.gx-align-self-start {
  -webkit-align-self: flex-start !important;
  -ms-align-self: flex-start !important;
  align-self: flex-start !important;
}
.gx-align-self-end {
  -webkit-align-self: flex-end !important;
  -ms-align-self: flex-end !important;
  align-self: flex-end !important;
}
.gx-align-self-center {
  -webkit-align-self: center !important;
  -ms-align-self: center !important;
  align-self: center !important;
}
.gx-align-self-baseline {
  -webkit-align-self: baseline !important;
  -ms-align-self: baseline !important;
  align-self: baseline !important;
}
.gx-align-self-stretch {
  -webkit-align-self: stretch !important;
  -ms-align-self: stretch !important;
  align-self: stretch !important;
}
.gx-order-first {
  -ms-flex-order: -1;
  order: -1;
}
.gx-order-1 {
  -ms-flex-order: 1;
  order: 1;
}
.gx-order-2 {
  -ms-flex-order: 2;
  order: 2;
}
.gx-order-3 {
  -ms-flex-order: 3;
  order: 3;
}
.gx-order-4 {
  -ms-flex-order: 4;
  order: 4;
}
.gx-order-5 {
  -ms-flex-order: 5;
  order: 5;
}
.gx-order-6 {
  -ms-flex-order: 6;
  order: 6;
}
.gx-order-7 {
  -ms-flex-order: 7;
  order: 7;
}
.gx-order-8 {
  -ms-flex-order: 8;
  order: 8;
}
.gx-order-9 {
  -ms-flex-order: 9;
  order: 9;
}
.gx-order-10 {
  -ms-flex-order: 10;
  order: 10;
}
.gx-order-11 {
  -ms-flex-order: 11;
  order: 11;
}
.gx-order-12 {
  -ms-flex-order: 12;
  order: 12;
}
.gx-offset-1 {
  margin-left: 8.333333%;
}
.gx-offset-2 {
  margin-left: 16.666667%;
}
.gx-offset-3 {
  margin-left: 25%;
}
.gx-offset-4 {
  margin-left: 33.333333%;
}
.gx-offset-5 {
  margin-left: 41.666667%;
}
.gx-offset-6 {
  margin-left: 50%;
}
.gx-offset-7 {
  margin-left: 58.333333%;
}
.gx-offset-8 {
  margin-left: 66.666667%;
}
.gx-offset-9 {
  margin-left: 75%;
}
.gx-offset-10 {
  margin-left: 83.333333%;
}
.gx-offset-11 {
  margin-left: 91.666667%;
}
@media screen and (min-width: 576px) {
  .gx-d-sm-none {
    display: none !important;
  }
  .gx-d-sm-inline-block {
    display: inline-block !important;
  }
  .gx-d-sm-block {
    display: block !important;
  }
  .gx-d-sm-flex {
    display: flex !important;
  }
  .gx-d-sm-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-sm-row {
    flex-direction: row !important;
  }
  .gx-flex-sm-column {
    flex-direction: column !important;
  }
  .gx-flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-sm-center {
    justify-content: center !important;
  }
  .gx-justify-content-sm-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-sm-around {
    justify-content: space-around !important;
  }
  .gx-align-items-sm-start {
    align-items: flex-start !important;
  }
  .gx-align-items-sm-end {
    align-items: flex-end !important;
  }
  .gx-align-items-sm-center {
    align-items: center !important;
  }
  .gx-align-items-sm-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-sm-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-sm-start {
    align-content: flex-start !important;
  }
  .gx-align-content-sm-end {
    align-content: flex-end !important;
  }
  .gx-align-content-sm-center {
    align-content: center !important;
  }
  .gx-align-content-sm-between {
    align-content: space-between !important;
  }
  .gx-align-content-sm-around {
    align-content: space-around !important;
  }
  .gx-align-content-sm-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-sm-auto {
    align-self: auto !important;
  }
  .gx-align-self-sm-start {
    align-self: flex-start !important;
  }
  .gx-align-self-sm-end {
    align-self: flex-end !important;
  }
  .gx-align-self-sm-center {
    align-self: center !important;
  }
  .gx-align-self-sm-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-sm-stretch {
    align-self: stretch !important;
  }
  .gx-order-sm-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-sm-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-sm-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-sm-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-sm-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-sm-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-sm-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-sm-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-sm-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-sm-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-sm-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-sm-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-sm-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-sm-0 {
    margin-left: 0;
  }
  .gx-offset-sm-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-sm-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-sm-3 {
    margin-left: 25%;
  }
  .gx-offset-sm-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-sm-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-sm-6 {
    margin-left: 50%;
  }
  .gx-offset-sm-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-sm-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-sm-9 {
    margin-left: 75%;
  }
  .gx-offset-sm-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-sm-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 768px) {
  .gx-d-md-none {
    display: none !important;
  }
  .gx-d-md-inline-block {
    display: inline-block !important;
  }
  .gx-d-md-block {
    display: block !important;
  }
  .gx-d-md-flex {
    display: flex !important;
  }
  .gx-d-md-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-md-row {
    flex-direction: row !important;
  }
  .gx-flex-md-column {
    flex-direction: column !important;
  }
  .gx-flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-md-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-md-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-md-center {
    justify-content: center !important;
  }
  .gx-justify-content-md-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-md-around {
    justify-content: space-around !important;
  }
  .gx-align-items-md-start {
    align-items: flex-start !important;
  }
  .gx-align-items-md-end {
    align-items: flex-end !important;
  }
  .gx-align-items-md-center {
    align-items: center !important;
  }
  .gx-align-items-md-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-md-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-md-start {
    align-content: flex-start !important;
  }
  .gx-align-content-md-end {
    align-content: flex-end !important;
  }
  .gx-align-content-md-center {
    align-content: center !important;
  }
  .gx-align-content-md-between {
    align-content: space-between !important;
  }
  .gx-align-content-md-around {
    align-content: space-around !important;
  }
  .gx-align-content-md-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-md-auto {
    align-self: auto !important;
  }
  .gx-align-self-md-start {
    align-self: flex-start !important;
  }
  .gx-align-self-md-end {
    align-self: flex-end !important;
  }
  .gx-align-self-md-center {
    align-self: center !important;
  }
  .gx-align-self-md-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-md-stretch {
    align-self: stretch !important;
  }
  .gx-order-md-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-md-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-md-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-md-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-md-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-md-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-md-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-md-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-md-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-md-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-md-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-md-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-md-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-md-0 {
    margin-left: 0;
  }
  .gx-offset-md-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-md-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-md-3 {
    margin-left: 25%;
  }
  .gx-offset-md-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-md-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-md-6 {
    margin-left: 50%;
  }
  .gx-offset-md-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-md-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-md-9 {
    margin-left: 75%;
  }
  .gx-offset-md-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-md-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 992px) {
  .gx-d-lg-none {
    display: none !important;
  }
  .gx-d-lg-inline-block {
    display: inline-block !important;
  }
  .gx-d-lg-block {
    display: block !important;
  }
  .gx-d-lg-flex {
    display: flex !important;
  }
  .gx-d-lg-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-lg-row {
    flex-direction: row !important;
  }
  .gx-flex-lg-column {
    flex-direction: column !important;
  }
  .gx-flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-lg-center {
    justify-content: center !important;
  }
  .gx-justify-content-lg-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-lg-around {
    justify-content: space-around !important;
  }
  .gx-align-items-lg-start {
    align-items: flex-start !important;
  }
  .gx-align-items-lg-end {
    align-items: flex-end !important;
  }
  .gx-align-items-lg-center {
    align-items: center !important;
  }
  .gx-align-items-lg-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-lg-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-lg-start {
    align-content: flex-start !important;
  }
  .gx-align-content-lg-end {
    align-content: flex-end !important;
  }
  .gx-align-content-lg-center {
    align-content: center !important;
  }
  .gx-align-content-lg-between {
    align-content: space-between !important;
  }
  .gx-align-content-lg-around {
    align-content: space-around !important;
  }
  .gx-align-content-lg-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-lg-auto {
    align-self: auto !important;
  }
  .gx-align-self-lg-start {
    align-self: flex-start !important;
  }
  .gx-align-self-lg-end {
    align-self: flex-end !important;
  }
  .gx-align-self-lg-center {
    align-self: center !important;
  }
  .gx-align-self-lg-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-lg-stretch {
    align-self: stretch !important;
  }
  .gx-order-lg-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-lg-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-lg-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-lg-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-lg-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-lg-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-lg-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-lg-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-lg-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-lg-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-lg-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-lg-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-lg-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-lg-0 {
    margin-left: 0;
  }
  .gx-offset-lg-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-lg-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-lg-3 {
    margin-left: 25%;
  }
  .gx-offset-lg-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-lg-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-lg-6 {
    margin-left: 50%;
  }
  .gx-offset-lg-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-lg-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-lg-9 {
    margin-left: 75%;
  }
  .gx-offset-lg-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-lg-11 {
    margin-left: 91.666667%;
  }
}
@media screen and (min-width: 1200px) {
  .gx-d-xl-none {
    display: none !important;
  }
  .gx-d-xl-inline-block {
    display: inline-block !important;
  }
  .gx-d-xl-block {
    display: block !important;
  }
  .gx-d-xl-flex {
    display: flex !important;
  }
  .gx-d-xl-inline-flex {
    display: inline-flex !important;
  }
  .gx-flex-xl-row {
    flex-direction: row !important;
  }
  .gx-flex-xl-column {
    flex-direction: column !important;
  }
  .gx-flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .gx-flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .gx-flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .gx-flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .gx-flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gx-justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .gx-justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .gx-justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .gx-justify-content-xl-around {
    justify-content: space-around !important;
  }
  .gx-align-items-xl-start {
    align-items: flex-start !important;
  }
  .gx-align-items-xl-end {
    align-items: flex-end !important;
  }
  .gx-align-items-xl-center {
    align-items: center !important;
  }
  .gx-align-items-xl-baseline {
    align-items: baseline !important;
  }
  .gx-align-items-xl-stretch {
    align-items: stretch !important;
  }
  .gx-align-content-xl-start {
    align-content: flex-start !important;
  }
  .gx-align-content-xl-end {
    align-content: flex-end !important;
  }
  .gx-align-content-xl-center {
    align-content: center !important;
  }
  .gx-align-content-xl-between {
    align-content: space-between !important;
  }
  .gx-align-content-xl-around {
    align-content: space-around !important;
  }
  .gx-align-content-xl-stretch {
    align-content: stretch !important;
  }
  .gx-align-self-xl-auto {
    align-self: auto !important;
  }
  .gx-align-self-xl-start {
    align-self: flex-start !important;
  }
  .gx-align-self-xl-end {
    align-self: flex-end !important;
  }
  .gx-align-self-xl-center {
    align-self: center !important;
  }
  .gx-align-self-xl-baseline {
    align-self: baseline !important;
  }
  .gx-align-self-xl-stretch {
    align-self: stretch !important;
  }
  .gx-order-xl-first {
    -ms-flex-order: -1;
    order: -1;
  }
  .gx-order-xl-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .gx-order-xl-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .gx-order-xl-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .gx-order-xl-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  .gx-order-xl-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  .gx-order-xl-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  .gx-order-xl-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  .gx-order-xl-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  .gx-order-xl-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  .gx-order-xl-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  .gx-order-xl-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  .gx-order-xl-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  .gx-offset-xl-0 {
    margin-left: 0;
  }
  .gx-offset-xl-1 {
    margin-left: 8.333333%;
  }
  .gx-offset-xl-2 {
    margin-left: 16.666667%;
  }
  .gx-offset-xl-3 {
    margin-left: 25%;
  }
  .gx-offset-xl-4 {
    margin-left: 33.333333%;
  }
  .gx-offset-xl-5 {
    margin-left: 41.666667%;
  }
  .gx-offset-xl-6 {
    margin-left: 50%;
  }
  .gx-offset-xl-7 {
    margin-left: 58.333333%;
  }
  .gx-offset-xl-8 {
    margin-left: 66.666667%;
  }
  .gx-offset-xl-9 {
    margin-left: 75%;
  }
  .gx-offset-xl-10 {
    margin-left: 83.333333%;
  }
  .gx-offset-xl-11 {
    margin-left: 91.666667%;
  }
}
.ant-row {
  margin-left: -16px;
  margin-right: -16px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.ant-row > [class*=ant-col-] {
  margin: 0 -0.3px;
}
.gx-col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (max-width: 480px) {
  .gx-col-full {
    width: 100%;
  }
}
/*Margin Padding Styles*/
.gx-mb-30 {
  margin-bottom: 30px !important;
}
.gx-mb-10 {
  margin-bottom: 10px !important;
}
.gx-m-0 {
  margin: 0 !important;
}
.gx-mt-0,
.gx-my-0 {
  margin-top: 0 !important;
}
.gx-mr-0,
.gx-mx-0 {
  margin-right: 0 !important;
}
.gx-mb-0,
.gx-my-0 {
  margin-bottom: 0 !important;
}
.gx-ml-0,
.gx-mx-0 {
  margin-left: 0 !important;
}
.gx-m-1 {
  margin: 0.25rem !important;
}
.gx-mt-1,
.gx-my-1 {
  margin-top: 0.25rem !important;
}
.gx-mr-1,
.gx-mx-1 {
  margin-right: 0.25rem !important;
}
.gx-mb-1,
.gx-my-1 {
  margin-bottom: 0.25rem !important;
}
.gx-ml-1,
.gx-mx-1 {
  margin-left: 0.25rem !important;
}
.gx-m-2 {
  margin: 0.5rem !important;
}
.gx-mt-2,
.gx-my-2 {
  margin-top: 0.5rem !important;
}
.gx-mr-2,
.gx-mx-2 {
  margin-right: 0.5rem !important;
}
.gx-mb-2,
.gx-my-2 {
  margin-bottom: 0.5rem !important;
}
.gx-ml-2,
.gx-mx-2 {
  margin-left: 0.5rem !important;
}
.gx-m-3 {
  margin: 1rem !important;
}
.gx-mt-3,
.gx-my-3 {
  margin-top: 1rem !important;
}
.gx-mr-3,
.gx-mx-3 {
  margin-right: 1rem !important;
}
.gx-mb-3,
.gx-my-3 {
  margin-bottom: 1rem !important;
}
.gx-ml-3,
.gx-mx-3 {
  margin-left: 1rem !important;
}
.gx-m-4 {
  margin: 1.5rem !important;
}
.gx-mt-4,
.gx-my-4 {
  margin-top: 1.5rem !important;
}
.gx-mr-4,
.gx-mx-4 {
  margin-right: 1.5rem !important;
}
.gx-mb-4,
.gx-my-4 {
  margin-bottom: 1.5rem !important;
}
.gx-ml-4,
.gx-mx-4 {
  margin-left: 1.5rem !important;
}
.gx-m-5 {
  margin: 3rem !important;
}
.gx-mt-5,
.gx-my-5 {
  margin-top: 3rem !important;
}
.gx-mr-5,
.gx-mx-5 {
  margin-right: 3rem !important;
}
.gx-mb-5,
.gx-my-5 {
  margin-bottom: 3rem !important;
}
.gx-ml-5,
.gx-mx-5 {
  margin-left: 3rem !important;
}
.gx-p-0 {
  padding: 0 !important;
}
.gx-pt-0,
.gx-py-0 {
  padding-top: 0 !important;
}
.gx-pr-0,
.gx-px-0 {
  padding-right: 0 !important;
}
.gx-pb-0,
.gx-py-0 {
  padding-bottom: 0 !important;
}
.gx-pl-0,
.gx-px-0 {
  padding-left: 0 !important;
}
.gx-p-1 {
  padding: 0.25rem !important;
}
.gx-pt-1,
.gx-py-1 {
  padding-top: 0.25rem !important;
}
.gx-pr-1,
.gx-px-1 {
  padding-right: 0.25rem !important;
}
.gx-pb-1,
.gx-py-1 {
  padding-bottom: 0.25rem !important;
}
.gx-pl-1,
.gx-px-1 {
  padding-left: 0.25rem !important;
}
.gx-p-2 {
  padding: 0.5rem !important;
}
.gx-pt-2,
.gx-py-2 {
  padding-top: 0.5rem !important;
}
.gx-pr-2,
.gx-px-2 {
  padding-right: 0.5rem !important;
}
.gx-pb-2,
.gx-py-2 {
  padding-bottom: 0.5rem !important;
}
.gx-pl-2,
.gx-px-2 {
  padding-left: 0.5rem !important;
}
.gx-p-3 {
  padding: 1rem !important;
}
.gx-pt-3,
.gx-py-3 {
  padding-top: 1rem !important;
}
.gx-pr-3,
.gx-px-3 {
  padding-right: 1rem !important;
}
.gx-pb-3,
.gx-py-3 {
  padding-bottom: 1rem !important;
}
.gx-pl-3,
.gx-px-3 {
  padding-left: 1rem !important;
}
.gx-p-4 {
  padding: 1.5rem !important;
}
.gx-pt-4,
.gx-py-4 {
  padding-top: 1.5rem !important;
}
.gx-pr-4,
.gx-px-4 {
  padding-right: 1.5rem !important;
}
.gx-pb-4,
.gx-py-4 {
  padding-bottom: 1.5rem !important;
}
.gx-pl-4,
.gx-px-4 {
  padding-left: 1.5rem !important;
}
.gx-p-5 {
  padding: 2rem !important;
}
.gx-pt-5,
.gx-py-5 {
  padding-top: 2rem !important;
}
.gx-pr-5,
.gx-px-5 {
  padding-right: 2rem !important;
}
.gx-pb-5,
.gx-py-5 {
  padding-bottom: 2rem !important;
}
.gx-pl-5,
.gx-px-5 {
  padding-left: 2rem !important;
}
.gx-m-auto {
  margin: auto !important;
}
.gx-mt-auto,
.gx-my-auto {
  margin-top: auto !important;
}
.gx-mr-auto,
.gx-mx-auto {
  margin-right: auto !important;
}
.gx-mb-auto,
.gx-my-auto {
  margin-bottom: auto !important;
}
.gx-ml-auto,
.gx-mx-auto {
  margin-left: auto !important;
}
@media (min-width: 576px) {
  .gx-m-sm-0 {
    margin: 0 !important;
  }
  .gx-mt-sm-0,
  .gx-my-sm-0 {
    margin-top: 0 !important;
  }
  .gx-mr-sm-0,
  .gx-mx-sm-0 {
    margin-right: 0 !important;
  }
  .gx-mb-sm-0,
  .gx-my-sm-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-sm-0,
  .gx-mx-sm-0 {
    margin-left: 0 !important;
  }
  .gx-m-sm-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-sm-1,
  .gx-my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-sm-1,
  .gx-mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-sm-1,
  .gx-my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-sm-1,
  .gx-mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-sm-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-sm-2,
  .gx-my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-sm-2,
  .gx-mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-sm-2,
  .gx-my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-sm-2,
  .gx-mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-sm-3 {
    margin: 1rem !important;
  }
  .gx-mt-sm-3,
  .gx-my-sm-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-sm-3,
  .gx-mx-sm-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-sm-3,
  .gx-my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-sm-3,
  .gx-mx-sm-3 {
    margin-left: 1rem !important;
  }
  .gx-m-sm-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-sm-4,
  .gx-my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-sm-4,
  .gx-mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-sm-4,
  .gx-my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-sm-4,
  .gx-mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-sm-5 {
    margin: 3rem !important;
  }
  .gx-mt-sm-5,
  .gx-my-sm-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-sm-5,
  .gx-mx-sm-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-sm-5,
  .gx-my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-sm-5,
  .gx-mx-sm-5 {
    margin-left: 3rem !important;
  }
  .gx-p-sm-0 {
    padding: 0 !important;
  }
  .gx-pt-sm-0,
  .gx-py-sm-0 {
    padding-top: 0 !important;
  }
  .gx-pr-sm-0,
  .gx-px-sm-0 {
    padding-right: 0 !important;
  }
  .gx-pb-sm-0,
  .gx-py-sm-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-sm-0,
  .gx-px-sm-0 {
    padding-left: 0 !important;
  }
  .gx-p-sm-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-sm-1,
  .gx-py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-sm-1,
  .gx-px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-sm-1,
  .gx-py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-sm-1,
  .gx-px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-sm-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-sm-2,
  .gx-py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-sm-2,
  .gx-px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-sm-2,
  .gx-py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-sm-2,
  .gx-px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-sm-3 {
    padding: 1rem !important;
  }
  .gx-pt-sm-3,
  .gx-py-sm-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-sm-3,
  .gx-px-sm-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-sm-3,
  .gx-py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-sm-3,
  .gx-px-sm-3 {
    padding-left: 1rem !important;
  }
  .gx-p-sm-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-sm-4,
  .gx-py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-sm-4,
  .gx-px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-sm-4,
  .gx-py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-sm-4,
  .gx-px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-sm-5 {
    padding: 2rem !important;
  }
  .gx-pt-sm-5,
  .gx-py-sm-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-sm-5,
  .gx-px-sm-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-sm-5,
  .py-sm-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-sm-5,
  .gx-px-sm-5 {
    padding-left: 2rem !important;
  }
  .gx-m-sm-auto {
    margin: auto !important;
  }
  .gx-mt-sm-auto,
  .gx-my-sm-auto {
    margin-top: auto !important;
  }
  .gx-mr-sm-auto,
  .gx-mx-sm-auto {
    margin-right: auto !important;
  }
  .gx-mb-sm-auto,
  .gx-my-sm-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-sm-auto,
  .gx-mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .gx-m-md-0 {
    margin: 0 !important;
  }
  .gx-mt-md-0,
  .gx-my-md-0 {
    margin-top: 0 !important;
  }
  .gx-mr-md-0,
  .gx-mx-md-0 {
    margin-right: 0 !important;
  }
  .gx-mb-md-0,
  .gx-my-md-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-md-0,
  .gx-mx-md-0 {
    margin-left: 0 !important;
  }
  .gx-m-md-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-md-1,
  .gx-my-md-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-md-1,
  .gx-mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-md-1,
  .gx-my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-md-1,
  .gx-mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-md-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-md-2,
  .gx-my-md-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-md-2,
  .gx-mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-md-2,
  .gx-my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-md-2,
  .gx-mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-md-3 {
    margin: 1rem !important;
  }
  .gx-mt-md-3,
  .gx-my-md-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-md-3,
  .gx-mx-md-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-md-3,
  .gx-my-md-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-md-3,
  .gx-mx-md-3 {
    margin-left: 1rem !important;
  }
  .gx-m-md-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-md-4,
  .gx-my-md-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-md-4,
  .gx-mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-md-4,
  .gx-my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-md-4,
  .gx-mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-md-5 {
    margin: 3rem !important;
  }
  .gx-mt-md-5,
  .gx-my-md-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-md-5,
  .gx-mx-md-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-md-5,
  .gx-my-md-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-md-5,
  .gx-mx-md-5 {
    margin-left: 3rem !important;
  }
  .gx-p-md-0 {
    padding: 0 !important;
  }
  .gx-pt-md-0,
  .gx-py-md-0 {
    padding-top: 0 !important;
  }
  .gx-pr-md-0,
  .gx-px-md-0 {
    padding-right: 0 !important;
  }
  .gx-pb-md-0,
  .gx-py-md-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-md-0,
  .gx-px-md-0 {
    padding-left: 0 !important;
  }
  .gx-p-md-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-md-1,
  .gx-py-md-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-md-1,
  .gx-px-md-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-md-1,
  .gx-py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-md-1,
  .gx-px-md-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-md-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-md-2,
  .gx-py-md-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-md-2,
  .gx-px-md-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-md-2,
  .gx-py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-md-2,
  .gx-px-md-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-md-3 {
    padding: 1rem !important;
  }
  .gx-pt-md-3,
  .gx-py-md-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-md-3,
  .gx-px-md-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-md-3,
  .gx-py-md-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-md-3,
  .gx-px-md-3 {
    padding-left: 1rem !important;
  }
  .gx-p-md-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-md-4,
  .gx-py-md-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-md-4,
  .gx-px-md-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-md-4,
  .gx-py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-md-4,
  .gx-px-md-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-md-5 {
    padding: 2rem !important;
  }
  .gx-pt-md-5,
  .gx-py-md-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-md-5,
  .gx-px-md-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-md-5,
  .gx-py-md-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-md-5,
  .gx-px-md-5 {
    padding-left: 2rem !important;
  }
  .gx-m-md-auto {
    margin: auto !important;
  }
  .gx-mt-md-auto,
  .gx-my-md-auto {
    margin-top: auto !important;
  }
  .gx-mr-md-auto,
  .gx-mx-md-auto {
    margin-right: auto !important;
  }
  .gx-mb-md-auto,
  .gx-my-md-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-md-auto,
  .gx-mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .gx-m-lg-0 {
    margin: 0 !important;
  }
  .gx-mt-lg-0,
  .gx-my-lg-0 {
    margin-top: 0 !important;
  }
  .gx-mr-lg-0,
  .gx-mx-lg-0 {
    margin-right: 0 !important;
  }
  .gx-mb-lg-0,
  .gx-my-lg-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-lg-0,
  .gx-mx-lg-0 {
    margin-left: 0 !important;
  }
  .gx-m-lg-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-lg-1,
  .gx-mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-lg-1,
  .gx-my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-lg-1,
  .gx-mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-lg-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-lg-2,
  .gx-my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-lg-2,
  .gx-mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-lg-2,
  .gx-my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-lg-2,
  .gx-mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-lg-3 {
    margin: 1rem !important;
  }
  .gx-mt-lg-3,
  .gx-my-lg-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-lg-3,
  .gx-mx-lg-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-lg-3,
  .gx-my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-lg-3,
  .gx-mx-lg-3 {
    margin-left: 1rem !important;
  }
  .gx-m-lg-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-lg-4,
  .gx-my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-lg-4,
  .gx-mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-lg-4,
  .gx-my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-lg-4,
  .gx-mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-lg-5 {
    margin: 3rem !important;
  }
  .gx-mt-lg-5,
  .gx-my-lg-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-lg-5,
  .gx-mx-lg-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-lg-5,
  .gx-my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-lg-5,
  .gx-mx-lg-5 {
    margin-left: 3rem !important;
  }
  .gx-p-lg-0 {
    padding: 0 !important;
  }
  .gx-pt-lg-0,
  .gx-py-lg-0 {
    padding-top: 0 !important;
  }
  .gx-pr-lg-0,
  .gx-px-lg-0 {
    padding-right: 0 !important;
  }
  .gx-pb-lg-0,
  .gx-py-lg-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-lg-0,
  .gx-px-lg-0 {
    padding-left: 0 !important;
  }
  .gx-p-lg-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-lg-1,
  .gx-py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-lg-1,
  .gx-px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-lg-1,
  .gx-py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-lg-1,
  .gx-px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-lg-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-lg-2,
  .gx-py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-lg-2,
  .gx-px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-lg-2,
  .gx-py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-lg-2,
  .gx-px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-lg-3 {
    padding: 1rem !important;
  }
  .gx-pt-lg-3,
  .gx-py-lg-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-lg-3,
  .gx-px-lg-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-lg-3,
  .gx-py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-lg-3,
  .gx-px-lg-3 {
    padding-left: 1rem !important;
  }
  .gx-p-lg-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-lg-4,
  .gx-py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-lg-4,
  .gx-px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-lg-4,
  .gx-py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-lg-4,
  .gx-px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-lg-5 {
    padding: 2rem !important;
  }
  .gx-pt-lg-5,
  .gx-py-lg-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-lg-5,
  .gx-px-lg-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-lg-5,
  .gx-py-lg-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-lg-5,
  .gx-px-lg-5 {
    padding-left: 2rem !important;
  }
  .gx-m-lg-auto {
    margin: auto !important;
  }
  .gx-mt-lg-auto,
  .gx-my-lg-auto {
    margin-top: auto !important;
  }
  .gx-mr-lg-auto,
  .gx-mx-lg-auto {
    margin-right: auto !important;
  }
  .gx-mb-lg-auto,
  .gx-my-lg-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-lg-auto,
  .gx-mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .gx-m-xl-0 {
    margin: 0 !important;
  }
  .gx-mt-xl-0,
  .gx-my-xl-0 {
    margin-top: 0 !important;
  }
  .gx-mr-xl-0,
  .gx-mx-xl-0 {
    margin-right: 0 !important;
  }
  .gx-mb-xl-0,
  .gx-my-xl-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-xl-0,
  .gx-mx-xl-0 {
    margin-left: 0 !important;
  }
  .gx-m-xl-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-xl-1,
  .gx-my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-xl-1,
  .gx-mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-xl-1,
  .gx-my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-xl-1,
  .gx-mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-xl-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-xl-2,
  .gx-my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-xl-2,
  .gx-mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-xl-2,
  .gx-my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-xl-2,
  .gx-mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-xl-3 {
    margin: 1rem !important;
  }
  .gx-mt-xl-3,
  .gx-my-xl-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-xl-3,
  .gx-mx-xl-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-xl-3,
  .gx-my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-xl-3,
  .gx-mx-xl-3 {
    margin-left: 1rem !important;
  }
  .gx-m-xl-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-xl-4,
  .gx-my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-xl-4,
  .gx-mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-xl-4,
  .gx-my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-xl-4,
  .gx-mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-xl-5 {
    margin: 3rem !important;
  }
  .gx-mt-xl-5,
  .gx-my-xl-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-xl-5,
  .gx-mx-xl-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-xl-5,
  .gx-my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-xl-5,
  .gx-mx-xl-5 {
    margin-left: 3rem !important;
  }
  .gx-p-xl-0 {
    padding: 0 !important;
  }
  .gx-pt-xl-0,
  .gx-py-xl-0 {
    padding-top: 0 !important;
  }
  .gx-pr-xl-0,
  .gx-px-xl-0 {
    padding-right: 0 !important;
  }
  .gx-pb-xl-0,
  .gx-py-xl-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-xl-0,
  .gx-px-xl-0 {
    padding-left: 0 !important;
  }
  .gx-p-xl-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-xl-1,
  .gx-py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-xl-1,
  .gx-px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-xl-1,
  .gx-py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-xl-1,
  .gx-px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-xl-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-xl-2,
  .gx-py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-xl-2,
  .gx-px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-xl-2,
  .gx-py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-xl-2,
  .gx-px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-xl-3 {
    padding: 1rem !important;
  }
  .gx-pt-xl-3,
  .gx-py-xl-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-xl-3,
  .gx-px-xl-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-xl-3,
  .gx-py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-xl-3,
  .gx-px-xl-3 {
    padding-left: 1rem !important;
  }
  .gx-p-xl-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-xl-4,
  .gx-py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-xl-4,
  .gx-px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-xl-4,
  .gx-py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-xl-4,
  .gx-px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-xl-5 {
    padding: 2rem !important;
  }
  .gx-pt-xl-5,
  .gx-py-xl-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-xl-5,
  .gx-px-xl-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-xl-5,
  .gx-py-xl-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-xl-5,
  .gx-px-xl-5 {
    padding-left: 2rem !important;
  }
  .gx-m-xl-auto {
    margin: auto !important;
  }
  .gx-mt-xl-auto,
  .gx-my-xl-auto {
    margin-top: auto !important;
  }
  .gx-mr-xl-auto,
  .gx-mx-xl-auto {
    margin-right: auto !important;
  }
  .gx-mb-xl-auto,
  .gx-my-xl-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-xl-auto,
  .gx-mx-xl-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1368px) {
  .gx-m-xxl-0 {
    margin: 0 !important;
  }
  .gx-mt-xxl-0,
  .gx-my-xxl-0 {
    margin-top: 0 !important;
  }
  .gx-mr-xxl-0,
  .gx-mx-xxl-0 {
    margin-right: 0 !important;
  }
  .gx-mb-xxl-0,
  .gx-my-xxl-0 {
    margin-bottom: 0 !important;
  }
  .gx-ml-xxl-0,
  .gx-mx-xxl-0 {
    margin-left: 0 !important;
  }
  .gx-m-xxl-1 {
    margin: 0.25rem !important;
  }
  .gx-mt-xxl-1,
  .gx-my-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .gx-mr-xxl-1,
  .gx-mx-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .gx-mb-xxl-1,
  .gx-my-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .gx-ml-xxl-1,
  .gx-mx-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .gx-m-xxl-2 {
    margin: 0.5rem !important;
  }
  .gx-mt-xxl-2,
  .gx-my-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .gx-mr-xxl-2,
  .gx-mx-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .gx-mb-xxl-2,
  .gx-my-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .gx-ml-xxl-2,
  .gx-mx-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .gx-m-xxl-3 {
    margin: 1rem !important;
  }
  .gx-mt-xxl-3,
  .gx-my-xxl-3 {
    margin-top: 1rem !important;
  }
  .gx-mr-xxl-3,
  .gx-mx-xxl-3 {
    margin-right: 1rem !important;
  }
  .gx-mb-xxl-3,
  .gx-my-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .gx-ml-xxl-3,
  .gx-mx-xxl-3 {
    margin-left: 1rem !important;
  }
  .gx-m-xxl-4 {
    margin: 1.5rem !important;
  }
  .gx-mt-xxl-4,
  .gx-my-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .gx-mr-xxl-4,
  .gx-mx-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .gx-mb-xxl-4,
  .gx-my-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .gx-ml-xxl-4,
  .gx-mx-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .gx-m-xxl-5 {
    margin: 3rem !important;
  }
  .gx-mt-xxl-5,
  .gx-my-xxl-5 {
    margin-top: 3rem !important;
  }
  .gx-mr-xxl-5,
  .gx-mx-xxl-5 {
    margin-right: 3rem !important;
  }
  .gx-mb-xxl-5,
  .gx-my-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .gx-ml-xxl-5,
  .gx-mx-xxl-5 {
    margin-left: 3rem !important;
  }
  .gx-p-xxl-0 {
    padding: 0 !important;
  }
  .gx-pt-xxl-0,
  .gx-py-xxl-0 {
    padding-top: 0 !important;
  }
  .gx-pr-xxl-0,
  .gx-px-xxl-0 {
    padding-right: 0 !important;
  }
  .gx-pb-xxl-0,
  .gx-py-xxl-0 {
    padding-bottom: 0 !important;
  }
  .gx-pl-xxl-0,
  .gx-px-xxl-0 {
    padding-left: 0 !important;
  }
  .gx-p-xxl-1 {
    padding: 0.25rem !important;
  }
  .gx-pt-xxl-1,
  .gx-py-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .gx-pr-xxl-1,
  .gx-px-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .gx-pb-xxl-1,
  .gx-py-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .gx-pl-xxl-1,
  .gx-px-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .gx-p-xxl-2 {
    padding: 0.5rem !important;
  }
  .gx-pt-xxl-2,
  .gx-py-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .gx-pr-xxl-2,
  .gx-px-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .gx-pb-xxl-2,
  .gx-py-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .gx-pl-xxl-2,
  .gx-px-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .gx-p-xxl-3 {
    padding: 1rem !important;
  }
  .gx-pt-xxl-3,
  .gx-py-xxl-3 {
    padding-top: 1rem !important;
  }
  .gx-pr-xxl-3,
  .gx-px-xxl-3 {
    padding-right: 1rem !important;
  }
  .gx-pb-xxl-3,
  .gx-py-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .gx-pl-xxl-3,
  .gx-px-xxl-3 {
    padding-left: 1rem !important;
  }
  .gx-p-xxl-4 {
    padding: 1.5rem !important;
  }
  .gx-pt-xxl-4,
  .gx-py-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .gx-pr-xxl-4,
  .gx-px-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .gx-pb-xxl-4,
  .gx-py-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .gx-pl-xxl-4,
  .gx-px-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .gx-p-xxl-5 {
    padding: 2rem !important;
  }
  .gx-pt-xxl-5,
  .gx-py-xxl-5 {
    padding-top: 2rem !important;
  }
  .gx-pr-xxl-5,
  .gx-px-xxl-5 {
    padding-right: 2rem !important;
  }
  .gx-pb-xxl-5,
  .gx-py-xxl-5 {
    padding-bottom: 2rem !important;
  }
  .gx-pl-xxl-5,
  .gx-px-xxl-5 {
    padding-left: 2rem !important;
  }
  .gx-m-xxl-auto {
    margin: auto !important;
  }
  .gx-mt-xxl-auto,
  .gx-my-xxl-auto {
    margin-top: auto !important;
  }
  .gx-mr-xxl-auto,
  .gx-mx-xxl-auto {
    margin-right: auto !important;
  }
  .gx-mb-xxl-auto,
  .gx-my-xxl-auto {
    margin-bottom: auto !important;
  }
  .gx-ml-xxl-auto,
  .gx-mx-xxl-auto {
    margin-left: auto !important;
  }
}
/*Typography Styles*/
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #262626;
  font-weight: 400;
  line-height: 1.2;
}
h1,
.h1 {
  font-size: 22px;
}
.framed-layout h1,
.framed-layout .h1 {
  font-size: 20px;
}
@media screen and (max-width: 767px) {
  .framed-layout h1,
  .framed-layout .h1 {
    font-size: 18px;
  }
}
.boxed-layout h1,
.boxed-layout .h1 {
  font-size: 18px;
}
@media screen and (max-width: 767px) {
  .boxed-layout h1,
  .boxed-layout .h1 {
    font-size: 16px;
  }
}
@media screen and (min-width: 1600px) {
  h1,
  .h1 {
    font-size: 28px;
  }
  .boxed-layout h1,
  .boxed-layout .h1 {
    font-size: 18px;
  }
}
h2,
.h2 {
  font-size: 20px;
}
h3,
.h3 {
  font-size: 18px;
}
h4,
.h4 {
  font-size: 16px;
}
h5,
.h5 {
  font-size: 14px;
}
h6,
.h6 {
  font-size: 12px;
}
.gx-h1-lg {
  font-size: 28px;
}
.gx-text-strikethrough {
  text-decoration: line-through !important;
}
.gx-text-underline {
  text-decoration: underline !important;
}
/*Font size Classes*/
/*8px*/
.gx-fs-xxs {
  font-size: 8px;
}
/*10px*/
.gx-fs-xs {
  font-size: 10px;
}
/*11px*/
.gx-fs-11 {
  font-size: 11px;
}
/*12px*/
.gx-fs-sm {
  font-size: 12px;
  line-height: 1.5;
}
/*14px*/
.gx-fs-md {
  font-size: 14px;
  line-height: 1;
}
/*16px*/
.gx-fs-lg {
  font-size: 16px;
  line-height: 1;
}
/*20px*/
.gx-fs-xl {
  font-size: 20px;
  line-height: 1;
}
/*24px*/
.gx-fs-xxl {
  font-size: 24px;
  line-height: 1.3;
}
@media screen and (max-width: 1199px) {
  .gx-fs-xxl {
    font-size: 20px;
  }
}
/*28px*/
.gx-fs-2xl {
  font-size: 28px !important;
  line-height: 1;
}
@media screen and (max-width: 1199px) {
  .gx-fs-2xl {
    font-size: 20px !important;
  }
}
/*30px*/
.gx-fs-xxxl {
  font-size: 30px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-xxxl {
    font-size: 28px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-fs-xxxl {
    font-size: 26px;
  }
}
@media screen and (max-width: 991px) {
  .gx-fs-xxxl {
    font-size: 24px;
  }
}
/*40px*/
.gx-fs-xlxl {
  font-size: 40px;
  line-height: 1;
}
@media screen and (max-width: 1199px) {
  .gx-fs-xlxl {
    font-size: 32px;
  }
}
@media screen and (max-width: 991px) {
  .gx-fs-xlxl {
    font-size: 28px;
  }
}
/*50px*/
.gx-fs-icon-lg {
  font-size: 50px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-icon-lg {
    font-size: 38px;
  }
}
@media screen and (max-width: 575px) {
  .gx-fs-icon-lg {
    font-size: 30px;
  }
}
/*54px*/
.gx-fs-iconcard {
  font-size: 54px;
  line-height: 1;
}
@media screen and (max-width: 1366px) {
  .gx-fs-iconcard {
    font-size: 34px;
  }
}
.gx-text-lowercase {
  text-transform: lowercase;
}
.gx-text-uppercase {
  text-transform: uppercase;
}
.gx-text-capitalize {
  text-transform: capitalize;
}
.gx-font-weight-light {
  font-weight: 300;
}
.gx-font-weight-normal {
  font-weight: 400;
}
.gx-font-weight-medium {
  font-weight: 500;
}
.gx-font-weight-semi-bold {
  font-weight: 600;
}
.gx-font-weight-bold {
  font-weight: 700;
}
.gx-font-weight-heavy {
  font-weight: 900;
}
.gx-font-italic {
  font-style: italic;
}
.gx-letter-spacing-base {
  letter-spacing: 3px;
}
.gx-letter-spacing-lg {
  letter-spacing: 6px;
}
.gx-letter-spacing-xl {
  letter-spacing: 8px;
}
.gx-text-justify {
  text-align: justify !important;
}
.gx-text-nowrap {
  white-space: nowrap !important;
}
.gx-text-left {
  text-align: left !important;
}
.gx-text-right {
  text-align: right !important;
}
.gx-text-center {
  text-align: center !important;
}
.gx-text-truncate {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Ant Layout Style */
.ant-layout {
  position: relative;
  background: none;
}
.ant-layout > .gx-layout-content {
  overflow-x: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.full-scroll .ant-layout > .gx-layout-content {
  overflow-x: inherit;
}
.ant-layout.ant-layout-has-sider > .ant-layout {
  position: relative;
  background: #f5f5f5;
}
.framed-layout .ant-layout,
.boxed-layout .ant-layout {
  background: #f5f5f5;
}
.framed-layout .ant-layout,
.boxed-layout .ant-layout {
  background: #f5f5f5;
}
.ant-layout.gx-app-layout {
  height: 100vh;
}
.framed-layout .ant-layout.gx-app-layout {
  height: calc(100vh - 40px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-layout.gx-app-layout {
    height: 100vh;
  }
}
.framed-layout.full-scroll .ant-layout.gx-app-layout,
.boxed-layout.full-scroll .ant-layout.gx-app-layout {
  overflow-y: scroll;
}
.ant-layout.gx-app-layout > .ant-layout {
  height: 100vh;
}
.framed-layout .ant-layout.gx-app-layout > .ant-layout {
  height: calc(100vh - 40px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-layout.gx-app-layout > .ant-layout {
    height: 100vh;
  }
}
.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout,
.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: inherit;
}
.gx-main-content-wrapper {
  flex: 1;
}
.gx-container-wrap .gx-main-content-wrapper {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container-wrap .gx-main-content-wrapper {
    width: 1400px;
  }
}
.gx-main-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  flex: 1;
  height: 100%;
}
.gx-container {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container {
    width: 1400px;
  }
}
/* Header Style */
.ant-layout-header {
  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  line-height: 1;
  padding: 0 32px;
  height: 72px;
  position: relative;
  z-index: 10;
  color: #262626;
}
.ant-layout-header .gx-loader-view {
  position: absolute;
  z-index: 10;
  background: rgba(255, 255, 255, 0.4);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0;
}
@media screen and (max-width: 991px) {
  .ant-layout-header {
    padding: 0 15px;
  }
}
@media screen and (max-width: 575px) {
  .ant-layout-header {
    height: 50px;
  }
}
.gx-nav-header {
  padding: 0 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background-color: #fefefe;
}
.gx-nav-header .ant-menu-horizontal {
  margin-bottom: -1px;
  border-bottom-color: transparent;
}
.gx-nav-header-below {
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  -moz-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);
  position: relative;
  z-index: 999;
}
.ant-dropdown-menu-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-linebar {
  font-size: 20px;
}
.gx-header-horizontal-dark .gx-linebar {
  color: #ffffff;
}
.gx-header-notifications {
  list-style: none;
  margin: 0;
  padding-left: 0;
  width: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-header-notifications > li {
  font-size: 18px;
}
.gx-header-notifications > li h1 {
  margin-bottom: 0px;
}
.gx-header-notifications > li.gx-language {
  font-size: 14px;
}
@media screen and (max-width: 575px) {
  .gx-header-notifications > li.gx-language .gx-language-name,
  .gx-header-notifications > li.gx-language .icon {
    display: none;
  }
  .gx-header-notifications > li.gx-language .flag.flag-24 {
    width: 20px;
    height: 20px;
    margin-top: -4px;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-notifications > li.gx-notify,
  .gx-header-notifications > li.gx-msg {
    margin-top: 2px;
  }
  .gx-header-notifications > li.gx-language {
    margin-bottom: 2px;
  }
}
.gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
  margin-left: 50px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-left: 0;
  }
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {
    margin-left: 0;
  }
}
.dark-theme .gx-header-notifications > li h1 {
  color: #E9F6FF;
}
.dark-theme .gx-header-notifications .ant-btn-link {
  line-height: 1;
}
.gx-header-horizontal-main .gx-header-notifications li > span {
  color: #545454;
}
.gx-header-horizontal-dark .gx-header-horizontal-main .gx-header-notifications li > span {
  color: #089265;
}
.gx-popover-scroll {
  height: 280px !important;
  width: 300px !important;
  margin: 0 -16px;
  overflow-y: auto;
}
@media screen and (max-width: 575px) {
  .gx-popover-scroll {
    height: 280px !important;
    width: 200px !important;
  }
}
.gx-popover-lang-scroll {
  height: 220px !important;
  width: 160px !important;
  margin: 0 -16px;
}
.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
  right: 10px;
}
.gx-popover-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  border-bottom: solid 1px #e8e8e8;
  margin: 0 -16px;
  padding: 0 16px 12px;
}
.gx-sub-popover {
  list-style: none;
  margin: 0 16px;
  padding-left: 0;
}
.gx-sub-popover li {
  padding: 20px 0 14px;
}
.gx-popover-lang-scroll .gx-sub-popover li {
  padding: 5px 0;
}
.gx-sub-popover li:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-user-popover {
  margin: -12px -16px;
  padding: 7px 0;
  list-style: none;
}
.gx-user-popover li {
  cursor: pointer;
  padding: 3px 15px;
  width: 150px;
}
.gx-user-popover li:hover,
.gx-user-popover li:focus {
  background-color: #fafafa;
}
@media screen and (max-width: 575px) {
  .gx-user-popover li {
    width: 100%;
  }
}
.gx-header-horizontal {
  position: relative;
  color: #089265;
  background-color: #ffffff;
}
.gx-header-horizontal-dark {
  position: relative;
  background-color: #003366;
  color: #089265;
}
.gx-header-horizontal-dark:before {
  content: '';
  position: absolute;
  right: 169px;
  top: -212px;
  background-color: rgba(255, 255, 255, 0.2);
  width: 280px;
  height: 350px;
  -webkit-border-radius: 0 0 135px 135px;
  -moz-border-radius: 0 0 135px 135px;
  border-radius: 0 0 135px 135px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 1;
}
@media screen and (max-width: 1049px) {
  .gx-header-horizontal-dark:before {
    right: 110px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-header-horizontal-dark:before {
    top: -184px;
    right: 80px;
    height: 300px;
  }
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-dark:before {
    top: -154px;
    right: 140px;
    height: 240px;
    width: 200px;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-horizontal-dark:before {
    right: 60px;
    display: none;
  }
}
.gx-header-horizontal-dark > div {
  position: relative;
  z-index: 2;
}
.gx-header-horizontal-top {
  padding: 12px 0;
  font-size: 14px;
}
.gx-header-horizontal-top-flex,
.gx-header-horizontal-nav-flex,
.gx-header-horizontal-main-flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-header-horizontal-top-left {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-right: 15px;
}
@media screen and (max-width: 767px) {
  .gx-header-horizontal-top-left {
    margin-right: 0;
    width: 100%;
  }
}
.gx-header-horizontal-main {
  display: -webkit-block;
  display: -ms-blockbox;
  display: -ms-block;
  display: block;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  padding: 25px 0 35px;
  height: auto;
  background-color: transparent;
}
@media screen and (max-width: 1199px) {
  .gx-header-horizontal-main {
    padding: 20px 0;
  }
  .gx-header-horizontal-main .gx-w-logo {
    padding: 7px 5px;
  }
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main {
    padding: 0;
  }
}
@media screen and (max-width: 575px) {
  .gx-header-horizontal-main .gx-w-logo {
    padding-right: 0;
  }
}
.gx-inside-header-horizontal .gx-header-horizontal-main {
  padding: 0;
}
.gx-header-horizontal-nav {
  background-color: #003366;
  color: #fffffd;
}
.gx-header-horizontal-dark .gx-header-horizontal-nav {
  background-color: transparent;
}
.gx-below-header-horizontal .gx-header-horizontal-nav,
.gx-above-header-horizontal .gx-header-horizontal-nav {
  background-color: #fefefe;
  color: #7a7a7a;
}
.gx-inside-header-horizontal .gx-logo {
  margin-right: 25px;
}
.gx-inside-header-horizontal:before {
  top: -230px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal:before {
    top: -190px;
  }
}
@media screen and (max-width: 991px) {
  .gx-inside-header-horizontal:before {
    top: -154px;
  }
}
.gx-above-header-horizontal:before {
  top: -165px;
}
@media screen and (max-width: 991px) {
  .gx-above-header-horizontal:before {
    top: -154px;
  }
}
.gx-login-list {
  list-style: none;
  margin-left: auto;
  margin-bottom: 0;
}
.gx-login-list li {
  padding: 0 10px;
  text-transform: uppercase;
  color: #089265;
  font-size: 12px;
  line-height: 12px;
  display: inline-block;
  cursor: pointer;
}
.gx-login-list li:not(:first-child) {
  border-left: solid 1px #e8e8e8;
}
.gx-header-horizontal-dark .gx-login-list li:not(:first-child) {
  border: 0 none;
}
@media screen and (max-width: 767px) {
  .gx-login-list {
    display: none;
  }
}
.gx-header-search {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-left: 28px;
}
.gx-header-search .ant-select-selection {
  -webkit-border-radius: 0 4px 4px 0;
  -moz-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
  background-color: #003366;
  border-color: #003366;
  color: #fffffd;
  margin-bottom: 0;
}
.gx-header-search .ant-select-selection:focus {
  background-color: #003366;
  border-color: #003366;
  color: #fffffd;
}
.gx-header-horizontal-dark .gx-header-search .ant-select-selection {
  color: #fffffd;
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
  margin-left: 1px;
}
.gx-header-horizontal-dark .gx-header-search .ant-select-selection:focus {
  color: #fffffd;
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
}
.gx-header-search .ant-select-arrow {
  color: #fffffd;
}
.gx-popover-horizantal .ant-btn {
  margin: 0 !important;
  border: 0 none;
  border-right: solid 1px #e8e8e8;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  height: 24px;
  line-height: 24px;
}
.gx-popover-horizantal .gx-popover-search-bar {
  margin: 0;
}
.gx-popover-horizantal .gx-popover-search-bar .ant-input {
  height: 24px;
  line-height: 24px;
}
@media screen and (max-width: 575px) {
  .gx-popover-horizantal {
    left: 0 !important;
    padding-top: 0;
    margin-top: -9px;
  }
  .gx-popover-horizantal .ant-popover-inner-content {
    width: 100vw;
  }
  .gx-popover-horizantal .ant-popover-arrow {
    display: none;
  }
  .gx-popover-horizantal .gx-popover-search-bar {
    width: 100%;
  }
  .gx-popover-horizantal .gx-popover-scroll,
  .gx-popover-horizantal .gx-popover-lang-scroll {
    width: 100% !important;
    margin: 0;
  }
  .gx-popover-horizantal .gx-sub-popover {
    margin: 0;
    padding-left: 5px;
  }
}
.gx-no-header-horizontal {
  padding: 14px 32px 13px 79px;
  text-align: center;
  position: relative;
}
.gx-no-header-horizontal-top {
  padding: 10px 20px;
  background-color: #d9f7be;
  color: #237804;
  border-radius: 4px;
  display: inline-block;
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal-top {
    width: 100%;
    font-size: 12px;
  }
}
.gx-no-header-horizontal-top-center {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-no-header-horizontal .gx-linebar {
  position: absolute;
  left: 32px;
  top: 15px;
  z-index: 1;
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal .gx-linebar {
    left: 15px;
  }
}
@media screen and (max-width: 575px) {
  .gx-no-header-horizontal {
    padding: 14px 15px 13px 60px;
  }
}
.notifications-popover .gx-popover-scroll {
  padding: 0 10px;
}
.dark-theme .notifications-popover .gx-popover-header,
.dark-theme .notifications-popover .ant-list-items li.ant-list-item {
  border-bottom-color: #0a2238;
}
/* Sidebar Style */
.gx-app-sidebar {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ant-layout-sider {
  background-color: #fffffc;
  color: #545454;
  flex: 0 0 auto !important;
  max-width: none !important;
  min-width: 10px !important;
  width: 280px !important;
  overflow: hidden;
}
@media screen and (max-width: 1366px) {
  .ant-layout-sider {
    width: 240px !important;
  }
}
.ant-layout-sider-collapsed {
  width: 80px !important;
}
@media screen and (max-width: 991px) {
  .ant-layout-sider-collapsed.gx-mini-custom-sidebar {
    width: 0 !important;
    min-width: 0 !important;
  }
}
.ant-layout-sider.gx-collapsed-sidebar {
  width: 0 !important;
  min-width: 0 !important;
}
@media screen and (max-width: 991px) {
  .ant-layout-sider {
    width: 0 !important;
    min-width: 0 !important;
  }
}
.gx-layout-sider-dark {
  background-color: #003366;
  color: #038fdd;
}
.gx-layout-sider-header {
  padding: 15px 20px;
  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 575px) {
  .gx-layout-sider-header {
    height: 50px;
  }
}
.gx-layout-sider-header .gx-linebar {
  position: absolute;
  left: 20px;
  z-index: 1;
  top: 15px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {
  left: 20px;
}
@media screen and (max-width: 991px) {
  .gx-layout-sider-header .gx-linebar {
    display: none;
  }
}
.ant-layout-sider-collapsed .gx-layout-sider-header {
  padding: 15px;
  display: flex;
  justify-content: center;
}
.gx-drawer-sidebar .gx-layout-sider-header {
  padding-left: 30px;
}
.gx-drawer-sidebar-dark .gx-layout-sider-header {
  background-color: rgba(0, 0, 0, 0.3);
}
.gx-layout-sider-dark .gx-layout-sider-header {
  background-color: rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.gx-mini-custom-sidebar .gx-layout-sider-header {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  background-color: transparent;
}
.gx-custom-sidebar .gx-layout-sider-header {
  padding-left: 30px;
  background-color: transparent;
}
.gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,
.gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-right: 1px solid #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-layout-sider-header {
    padding-left: 30px;
  }
}
.gx-layout-sider-header,
.gx-layout-sider-dark .gx-layout-sider-header {
  background-color: transparent;
  box-shadow: none;
}
.gx-app-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #04A0A1;
}
.gx-sidebar-content {
  position: relative;
  border-right: 1px solid #e8e8e8;
}
.gx-layout-sider-dark .gx-sidebar-content,
.gx-drawer-sidebar-dark .gx-sidebar-content {
  border-right: 0 none;
}
.gx-sidebar-content .ant-menu .ant-menu-item,
.gx-sidebar-content .ant-menu .ant-menu-item a {
  display: flex;
  align-items: center;
  gap: 10px;
}
@media screen and (min-width: 1600px) {
  .gx-sidebar-content .ant-menu .ant-menu-item,
  .gx-sidebar-content .ant-menu .ant-menu-item a {
    font-size: 16px;
  }
}
.gx-sidebar-content .ant-menu .ant-menu-item-selected a,
.gx-sidebar-content .ant-menu .ant-menu-item a-selected a {
  color: #ffffff;
}
.gx-sidebar-content .ant-menu .ant-menu-item-selected a svg path,
.gx-sidebar-content .ant-menu .ant-menu-item a-selected a svg path {
  fill: #ffffff;
}
.gx-sidebar-content .ant-menu-item .anticon-rocket {
  font-size: 18px;
}
.gx-sidebar-notifications {
  padding: 30px 10px 10px;
  margin: 0 20px 10px;
  border-bottom: solid 1px #e8e8e8;
}
.ant-layout-sider-dark .gx-sidebar-notifications,
.gx-drawer-sidebar-dark .gx-sidebar-notifications {
  border-bottom-color: #038fdd;
}
@media screen and (max-width: 991px) {
  .gx-sidebar-notifications {
    display: none;
  }
}
@media screen and (max-width: 991px) {
  .gx-sidebar-notifications.gx-no-header-notifications {
    display: block;
  }
}
.gx-app-nav {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin: 0 -20px;
  color: #2EB1EF;
}
.ant-layout-sider-dark .gx-app-nav,
.gx-drawer-sidebar-dark .gx-app-nav {
  color: #038fdd;
}
.gx-app-nav li {
  padding: 0 20px;
  font-size: 20px;
}
.gx-app-nav li .icon {
  cursor: pointer;
}
.ant-layout-sider-collapsed .gx-app-nav {
  display: none;
}
.gx-mini-custom-sidebar .gx-app-nav {
  display: block;
  margin-top: 15px;
}
.gx-mini-custom-sidebar .gx-app-nav li:not(:last-child) {
  margin-bottom: 5px;
}
.gx-avatar-name {
  cursor: pointer;
}
.ant-layout-sider-collapsed .gx-avatar-name {
  display: none;
}
.ant-layout-sider-collapsed .gx-avatar-row {
  margin-bottom: 0 !important;
}
.gx-avatar-row .ant-avatar {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  position: relative;
  left: 0;
}
.ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {
  margin: 0 !important;
  left: -10px;
}
.gx-app-sidebar.ant-layout-sider .ant-menu-item-group-title {
  padding: 10px 20px;
  font-size: 16px;
}
.gx-app-sidebar.ant-layout-sider .ant-menu-inline .ant-menu-item {
  padding-left: 30px !important;
}
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item {
  padding: 0 30px !important;
}
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item.logout-item {
  padding: 0px 26px 0px 32px !important;
}
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item.logout-item svg {
  margin-left: 3px;
}
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item > span,
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item a > span {
  display: none;
}
.gx-layouts-view .gx-pointer {
  display: block;
  margin-bottom: 15px;
}
.gx-layouts-view .gx-pointer img {
  width: 100%;
}
.gx-layouts-view .gx-pointer.active {
  box-shadow: 0 0 10px 0 #2EB1EF;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
}
/* Ant Menu Style */
.ant-menu {
  color: #545454;
  background: #fff;
}
.ant-menu-horizontal {
  background: none;
}
.ant-menu-item-group-title {
  color: #fff;
  font-size: 11px;
  line-height: 1.3;
  padding: 10px 30px;
}
.ant-menu-submenu-popup .ant-menu-item-group-title {
  padding-left: 20px;
}
.ant-layout-sider .ant-menu-item-group-title {
  padding-top: 40px;
}
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #f0fdff;
}
.ant-menu-item .icon {
  min-width: 14px;
  margin-right: 2px;
}
.ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-item .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-menu-sub .ant-menu-item .icon {
  font-size: 12px;
}
.ant-menu-item > a {
  color: #545454;
}
.ant-menu-item > a:hover {
  color: #2EB1EF;
}
.ant-menu-item-divider {
  background-color: #e8e8e8;
}
.ant-menu-submenu-inline {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: #2EB1EF;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}
.ant-menu-item-selected {
  color: #2EB1EF;
}
.ant-menu-item-selected > a {
  color: #545454;
}
.ant-menu-item-selected > a:hover {
  color: #2EB1EF;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #f0fdff;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 1px solid #e8e8e8;
}
.ant-layout-sider .ant-menu-inline,
.ant-layout-sider .ant-menu-vertical,
.ant-layout-sider .ant-menu-vertical-left,
.gx-drawer-sidebar .ant-menu-inline,
.gx-drawer-sidebar .ant-menu-vertical,
.gx-drawer-sidebar .ant-menu-vertical-left {
  border-right: 0 none;
}
.ant-menu-vertical-right {
  border-left: 1px solid #e8e8e8;
}
.ant-menu-item,
.ant-menu-submenu-title {
  padding: 0 20px;
}
.gx-inside-header-horizontal .ant-menu-item,
.gx-inside-header-horizontal .ant-menu-submenu-title {
  padding: 0 10px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .ant-menu-item,
  .gx-inside-header-horizontal .ant-menu-submenu-title {
    padding: 0 6px;
  }
}
.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  margin-right: 02px;
}
.ant-menu > .ant-menu-item-divider {
  background-color: #e8e8e8;
}
.ant-menu-sub > li > a {
  position: relative;
}
.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 0;
}
.ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 54px !important;
}
.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,
.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
  padding-left: 80px !important;
}
.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,
.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {
  padding-left: 106px !important;
}
.ant-menu-submenu-popup {
  border-radius: 0;
  z-index: 1050 !important;
}
.ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {
  padding-left: 20px !important;
}
.ant-menu-submenu-vertical .ant-menu-item:not(:last-child),
.ant-menu-submenu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-submenu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-submenu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0;
}
.gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 22px;
  right: auto;
}
.ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 22px;
  right: auto;
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {
  background-image: linear-gradient(to right, #545454, #545454);
}
.gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  left: 60px;
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,
.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {
  background: linear-gradient(to right, #2EB1EF, #2EB1EF);
}
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  color: #2EB1EF;
}
.ant-menu-vertical .ant-menu-submenu-selected > a,
.ant-menu-vertical-left .ant-menu-submenu-selected > a,
.ant-menu-vertical-right .ant-menu-submenu-selected > a {
  color: #2EB1EF;
}
.ant-menu-horizontal {
  border-bottom: 1px solid #e8e8e8;
  line-height: 46px;
  padding: 0;
}
.ant-layout-header .ant-menu-horizontal {
  border-bottom: 0 none;
  line-height: 70px;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: 2px solid transparent;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom: 2px solid #2EB1EF;
  color: #2EB1EF;
}
.ant-menu-horizontal > .ant-menu-item > a,
.ant-menu-horizontal > .ant-menu-submenu > a {
  color: #545454;
}
.ant-menu-horizontal > .ant-menu-item > a:hover,
.ant-menu-horizontal > .ant-menu-submenu > a:hover {
  color: #2EB1EF;
}
.ant-menu-horizontal > .ant-menu-item > a:before,
.ant-menu-horizontal > .ant-menu-submenu > a:before {
  bottom: -2px;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0;
}
.ant-menu-vertical .ant-menu-item:after,
.ant-menu-vertical-left .ant-menu-item:after,
.ant-menu-vertical-right .ant-menu-item:after,
.ant-menu-inline .ant-menu-item:after {
  border-right: 3px solid #2EB1EF;
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  padding: 0 30px 0 20px !important;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  text-overflow: inherit;
}
.ant-layout-sider .ant-menu-vertical .ant-menu-item,
.ant-layout-sider .ant-menu-vertical-left .ant-menu-item,
.ant-layout-sider .ant-menu-vertical-right .ant-menu-item,
.ant-layout-sider .ant-menu-inline .ant-menu-item,
.ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical .ant-menu-item,
.ant-drawer .ant-menu-vertical-left .ant-menu-item,
.ant-drawer .ant-menu-vertical-right .ant-menu-item,
.ant-drawer .ant-menu-inline .ant-menu-item,
.ant-drawer .ant-menu-vertical .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,
.ant-drawer .ant-menu-inline .ant-menu-submenu-title {
  padding-left: 40px !important;
}
.ant-menu-vertical .ant-menu-item .icon,
.ant-menu-vertical-left .ant-menu-item .icon,
.ant-menu-vertical-right .ant-menu-item .icon,
.ant-menu-inline .ant-menu-item .icon,
.ant-menu-vertical .ant-menu-submenu-title .icon,
.ant-menu-vertical-left .ant-menu-submenu-title .icon,
.ant-menu-vertical-right .ant-menu-submenu-title .icon,
.ant-menu-inline .ant-menu-submenu-title .icon {
  min-width: 14px;
  margin-right: 02px;
}
.ant-menu-vertical .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical-left .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical-right .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-inline .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-vertical .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical-left .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical-right .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-inline .ant-menu-submenu-title .icon[class^="icon-"]::before,
.ant-menu-vertical .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical-left .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical-right .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-inline .ant-menu-item .icon[class*=" icon-"]::before,
.ant-menu-vertical .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-vertical-left .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-vertical-right .ant-menu-submenu-title .icon[class*=" icon-"]::before,
.ant-menu-inline .ant-menu-submenu-title .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .icon + span,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .icon + span {
  max-width: 0;
  display: inline-block;
  opacity: 0;
}
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none;
}
.ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 54px !important;
}
.ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,
.ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {
  padding-left: 80px !important;
}
.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 30px !important;
}
.ant-menu-inline-collapsed {
  width: 80px;
}
.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 32px !important;
}
.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none;
}
.ant-menu-inline-collapsed > .ant-menu-item .icon + span,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .icon + span,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .icon + span {
  max-width: 0;
  display: inline-block;
  opacity: 0;
}
.ant-menu-inline-collapsed-tooltip .icon {
  display: none;
}
.ant-menu-inline-collapsed-tooltip a {
  color: rgba(255, 255, 255, 0.85);
}
.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-left: 4px;
  padding-right: 4px;
  display: none;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  line-height: 42px;
  height: 42px;
}
.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding: 0 30px 0 80px;
  line-height: 42px;
  height: 42px;
  text-transform: uppercase;
}
.ant-menu-item-disabled,
.ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-item-disabled > a,
.ant-menu-submenu-disabled > a {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-menu-submenu-selected .ant-menu-submenu-title {
  color: #2EB1EF;
}
.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: linear-gradient(to right, #2EB1EF, #2EB1EF);
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  color: #038fdd;
  background: #003366;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #038fdd;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: none;
  box-shadow: none;
}
.ant-menu-dark.ant-menu-horizontal {
  border-bottom-color: #003366;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  border-color: #003366;
}
.ant-menu-dark .ant-menu-item .icon {
  min-width: 14px;
  margin-right: 2px;
}
.ant-menu-dark .ant-menu-item .icon[class^="icon-"]::before,
.ant-menu-dark .ant-menu-item .icon[class*=" icon-"]::before {
  position: relative;
  top: 2px;
}
.ant-menu-dark .ant-menu-item-group-title {
  color: #038fdd;
}
.ant-menu-dark .ant-menu-item {
  color: #038fdd;
}
.ant-menu-dark .ant-menu-item > a {
  color: #038fdd;
}
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-item-selected > a {
  color: #089265;
}
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu-dark .ant-menu-submenu-title:hover,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover {
  color: #089265;
}
.ant-menu-dark .ant-menu-item:hover > a,
.ant-menu-dark .ant-menu-item-active > a,
.ant-menu-dark .ant-menu-submenu-active > a,
.ant-menu-dark .ant-menu-submenu-selected > a,
.ant-menu-dark .ant-menu-submenu-title:hover > a,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > a {
  color: #089265;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before {
  background: #089265;
}
.ant-menu-dark .ant-menu-submenu-open {
  color: #ffffff;
}
.ant-menu-dark.ant-menu-inline-collapsed .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open .ant-menu-submenu-title span,
.ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-active .ant-menu-submenu-title span {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-item-selected {
  color: #089265;
}
.ant-menu-dark .ant-menu-item-selected > a,
.ant-menu-dark .ant-menu-item-selected > a:hover {
  color: #089265;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item-disabled,
.ant-menu-dark .ant-menu-submenu-disabled,
.ant-menu-dark .ant-menu-item-disabled > a,
.ant-menu-dark .ant-menu-submenu-disabled > a {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {
  color: #038fdd;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title {
  color: #ffffff;
}
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title:hover,
.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title:hover {
  color: #089265;
}
.ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #262626;
}
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-vertical:hover > .ant-menu-submenu-title {
  color: #ffffff;
}
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-layout-sider .ant-menu .ant-menu-item .icon,
.ant-drawer .ant-menu .ant-menu-item .icon {
  font-size: 20px;
}
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,
.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,
.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {
  font-size: 14px;
  margin-right: 12px;
}
.ant-layout-sider .ant-menu .ant-menu-submenu-title span,
.ant-drawer .ant-menu .ant-menu-submenu-title span {
  display: flex;
}
.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background-image: linear-gradient(to right, #2EB1EF, #2EB1EF);
}
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {
  background: #ffffff;
}
.gx-navbar-nav {
  list-style: none;
  padding-left: 0;
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-navbar-nav li {
  padding: 0 5px;
}
.gx-navbar-nav li a {
  display: block;
  padding: 4px 10px;
  background-color: #2EB1EF;
  color: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-profile-banner .gx-navbar-nav li a {
  background-color: transparent;
  color: #ffffff;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding: 0;
}
.gx-navbar-nav li a * {
  color: #bfbfbf;
}
.gx-navbar-nav li a:hover,
.gx-navbar-nav li a:focus {
  background-color: #1199d9;
  color: #ffffff;
}
.gx-profile-banner .gx-navbar-nav li a:hover,
.gx-profile-banner .gx-navbar-nav li a:focus {
  background-color: transparent;
  color: #089265;
}
.gx-profile-banner .gx-navbar-nav li {
  padding: 0 15px;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner .gx-navbar-nav li {
    padding: 0 6px;
  }
}
.gx-profile-banner .gx-navbar-nav {
  margin: 0 -15px;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner .gx-navbar-nav {
    -webkit-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    margin: 0 -6px;
  }
}
.gx-header-horizontal-nav .ant-menu-horizontal {
  border-bottom: 0 none;
}
.gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #ffffff;
}
.gx-below-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title,
.gx-above-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #7a7a7a;
}
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom-color: #089265;
  color: #089265;
}
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,
.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: #089265;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: 0 none;
  margin-top: 0;
  top: 0;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected {
  position: relative;
  border-bottom: 0 none;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {
  position: relative;
}
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  content: "\\e049";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  text-align: center;
  font-family: "gaxon" !important;
  font-size: 31px;
  line-height: 5px;
}
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  color: #f5f5f5;
}
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  color: #003366;
}
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: #089265;
}
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: #ffffff;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-top: -7px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:first-child {
  -webkit-border-radius: 10px 10px 0 0;
  -moz-border-radius: 10px 10px 0 0;
  border-radius: 10px 10px 0 0;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:last-child {
  -webkit-border-radius: 0 0 10px 10px;
  -moz-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu > .ant-menu {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #089265;
  color: #003366;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {
  color: #003366;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title {
  color: #089265;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background-image: linear-gradient(to right, #089265, #089265);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background-image: linear-gradient(to right, #089265, #089265);
}
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item > a:hover,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item:hover,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item-active,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-active,
.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-title:hover {
  color: #089265;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
  color: #089265;
}
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,
.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {
  color: #089265;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed {
  padding-bottom: 10px;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0 20px !important;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > span,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > span,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > span {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > a,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > a {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item.ant-menu-item-selected > a,
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item.ant-menu-item-selected > a {
  color: #003366;
  background-color: #089265;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title > span {
  color: #003366;
  background-color: #089265;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-item .icon,
.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-submenu-title .icon,
.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-submenu-title .icon {
  margin-right: 0;
}
.gx-no-header-submenu-popup .ant-menu-sub {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
/* Footer Style */
.ant-layout-footer {
  border-top: solid 1px #e8e8e8;
  background-color: transparent;
}
@media screen and (max-width: 575px) {
  .ant-layout-footer {
    padding: 14px 15px;
  }
}
.gx-container-wrap .ant-layout-footer {
  padding-left: 0;
  padding-right: 0;
}
.gx-container-wrap .gx-layout-footer-content {
  width: 94vw;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}
@media screen and (min-width: 768px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 920px;
  }
}
@media screen and (min-width: 1200px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1100px;
  }
}
@media screen and (min-width: 1367px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1200px;
  }
}
@media screen and (min-width: 1600px) {
  .gx-container-wrap .gx-layout-footer-content {
    width: 1400px;
  }
}
/* Customizer Style */
.gx-customizer {
  height: calc(100vh - 30px) !important;
}
.gx-customizer-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.gx-customizer-item .ant-radio-group .ant-radio-button {
  display: none;
}
.gx-customizer-option {
  position: absolute;
  right: 0;
  top: 150px;
  z-index: 99;
}
.full-scroll .gx-customizer-option {
  position: fixed;
}
.full-scroll.boxed-layout .gx-customizer-option {
  position: absolute;
}
.full-scroll.framed-layout .gx-customizer-option {
  right: 20px;
}
@media screen and (max-width: 991px) {
  .full-scroll.framed-layout .gx-customizer-option {
    right: 0;
  }
}
.horizontal-layout.full-scroll .gx-customizer-option {
  top: 200px;
}
@media screen and (max-width: 575px) {
  .gx-customizer {
    width: 250px !important;
  }
  .gx-customizer .ant-radio-button-wrapper {
    padding: 0 10px;
  }
}
.gx-customizer .gx-list-inline {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.framed-layout .gx-customizer {
  height: calc(100vh - 70px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-customizer {
    height: calc(100vh - 30px) !important;
  }
}
.gx-color-option {
  margin-bottom: 0;
  padding-left: 0;
}
.gx-color-option li {
  font-size: 36px;
  line-height: 1;
}
.gx-color-option li .gx-link {
  width: 40px;
  height: 40px;
  display: block;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}
.gx-color-option li .gx-link:before {
  font-family: "gaxon";
  font-size: 20px;
  content: "\\30";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  display: none;
}
.gx-color-option li .gx-link.active:before {
  display: block;
}
.gx-color-option li .gx-link:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 20px;
  height: 40px;
  background-color: #9283D4;
}
.gx-color-option li .gx-link.gx-color-red:after {
  background-color: #FF2B7A;
}
.gx-color-option li .gx-link.gx-color-blue:after {
  background-color: #3DA4E6;
}
.gx-color-option li .gx-link.gx-color-dark-blue:after {
  background-color: #0469B9;
}
.gx-color-option li .gx-link.gx-color-orange:after {
  background-color: #F18805;
}
.gx-color-option li .gx-link.gx-color-light-blue:after {
  background-color: #6A95FF;
}
.gx-color-option li .gx-link.gx-color-deep-orange:after {
  background-color: #F87060;
}
.gx-color-option li .gx-link.gx-color-light-purple1:after {
  background-color: #A172E7;
}
.gx-color-option li .gx-link.gx-color-light-purple2:after {
  background-color: #956FE7;
}
.gx-cus-customiz {
  padding-right: 20px;
}
.gx-layout-option li,
.gx-nav-option li {
  margin-bottom: 10px;
}
.gx-layout-option li span,
.gx-nav-option li span {
  position: relative;
  display: block;
}
.gx-layout-option li span:before,
.gx-nav-option li span:before {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  font-family: "gaxon" !important;
  content: "\\30";
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: none;
  width: 20px;
  font-size: 12px;
  height: 20px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #2EB1EF;
  text-align: center;
  padding: 2px;
  color: #ffffff;
}
.gx-layout-option li span.active:before,
.gx-nav-option li span.active:before {
  display: block;
}
/* Drawer Style */
.ant-drawer {
  overflow: hidden;
}
.ant-drawer-body {
  padding: 0;
}
.gx-drawer-sidebar-dark .ant-drawer-content {
  background-color: #003366;
  color: #038fdd;
}
.framed-layout .ant-drawer-content-wrapper {
  top: 20px;
  bottom: 20px;
  height: calc(100vh - 40px);
  -webkit-border-radius: 11px 0 0 11px;
  -moz-border-radius: 11px 0 0 11px;
  border-radius: 11px 0 0 11px;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-content-wrapper {
    top: 0;
    bottom: 0;
    height: 100vh;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.ant-drawer-right .ant-drawer-content-wrapper {
  padding: 20px;
}
@media screen and (max-width: 991px) {
  .ant-drawer-right .ant-drawer-content-wrapper {
    width: 300px !important;
  }
}
@media screen and (max-width: 575px) {
  .ant-drawer-right .ant-drawer-content-wrapper {
    width: 280px !important;
  }
}
.framed-layout .ant-drawer-right .ant-drawer-content-wrapper {
  top: 20px;
  bottom: 20px;
  height: calc(100vh - 40px);
  -webkit-border-radius: 0 11px 11px 0;
  -moz-border-radius: 0 11px 11px 0;
  border-radius: 0 11px 11px 0;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {
    top: 0;
    bottom: 0;
    height: 100vh;
    -webkit-border-radius: 0 !important;
    -moz-border-radius: 0 !important;
    border-radius: 0 !important;
  }
}
.framed-layout .ant-drawer-content-wrapper,
.boxed-layout .ant-drawer-content-wrapper {
  position: absolute;
}
.boxed-layout .ant-drawer {
  max-width: 1280px;
  margin: 0 auto;
}
@media screen and (min-width: 1600px) {
  .boxed-layout .ant-drawer {
    max-width: 1500px;
  }
}
.framed-layout .ant-drawer-open {
  width: calc(100% - 40px);
}
@media screen and (max-width: 991px) {
  .framed-layout .ant-drawer-open {
    width: 100%;
  }
}
.ant-drawer-close {
  top: -11px;
}
.ant-drawer-close-x {
  width: 35px;
  height: 35px;
  line-height: 35px;
}
.ant-drawer-mask {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
/*Alert Styles*/
.gx-custom-sweet-alert h2 {
  color: #ffffff;
}
.notification {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.notification .title {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
}
.gx-sweet-alert-top-space {
  padding-top: 40px !important;
}
/*Avatar Styles*/
.gx-avatar-img {
  height: 50px;
  width: 50px;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 1px #e8e8e8;
}
.gx-avatar-img-lg {
  height: 100px;
  width: 100px;
}
.ant-avatar {
  position: relative;
}
.ant-avatar.gx-size-150 > * {
  line-height: 150px;
}
.ant-avatar.gx-size-120 > * {
  line-height: 120px;
}
.ant-avatar.gx-size-100 > * {
  line-height: 100px;
}
.ant-avatar.gx-size-80 > * {
  line-height: 80px;
}
.ant-avatar.gx-size-60 > * {
  line-height: 60px;
}
.ant-avatar.gx-size-50 > * {
  line-height: 50px;
}
.ant-avatar.gx-size-40 > * {
  line-height: 40px;
}
.ant-avatar.gx-size-36 > * {
  line-height: 36px;
}
.ant-avatar.gx-size-30 > * {
  line-height: 30px;
}
.ant-avatar.gx-size-24 > * {
  line-height: 24px;
}
.ant-avatar.gx-size-20 > * {
  line-height: 20px;
}
.ant-avatar.gx-size-15 > * {
  line-height: 14px;
}
.gx-customers-list .ant-avatar {
  width: 70px;
  height: 70px;
}
@media (max-width: 1500px) {
  .gx-customers-list .ant-avatar {
    width: 60px;
    height: 60px;
  }
}
@media (max-width: 1366px) {
  .gx-customers-list .ant-avatar {
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 1199px) {
  .gx-customers-list .ant-avatar {
    width: 60px;
    height: 60px;
  }
}
@media screen and (max-width: 400px) {
  .gx-customers-list .ant-avatar {
    width: 52px;
    height: 52px;
  }
}
.gx-avatar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  overflow: hidden;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  height: 50px;
  width: 50px;
  position: relative;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 1px #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-user-nav .gx-avatar {
    height: 40px;
    width: 40px;
    line-height: 40px;
  }
}
@media screen and (max-width: 575px) {
  .gx-user-nav .gx-avatar {
    height: 30px;
    width: 30px;
    line-height: 30px;
  }
}
.gx-header-horizontal-main .gx-avatar {
  height: 40px;
  width: 40px;
  line-height: 40px;
}
@media screen and (max-width: 991px) {
  .gx-header-horizontal-main .gx-avatar {
    height: 30px;
    width: 30px;
    line-height: 30px;
  }
}
.gx-user-thumb {
  position: relative;
}
.ant-tag {
  margin-bottom: 8px;
}
.ant-tag:hover {
  opacity: 1;
}
.gx-badge {
  display: inline-block;
  padding: 5px 8px 4px;
  font-size: 75%;
  margin-bottom: 6px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-badge:not(:last-child) {
  margin-right: 12px;
}
.gx-chat-date .gx-badge {
  margin-bottom: 0;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 16px;
  padding: 2px;
}
.gx-user-thumb .gx-badge {
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 1;
  margin: 0;
  display: block;
  width: 16px;
  height: 16px;
  padding: 0;
  line-height: 16px;
}
.gx-badge-outline {
  background-color: transparent;
  border: solid 1px #e8e8e8;
}
.gx-badge-radius-sm .ant-badge-count {
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}
#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #1088e9;
  color: #fff;
  text-align: center;
  font-size: 20px;
}
/*Button Styles*/
.ant-btn {
  line-height: 34px;
}
.ant-btn-sm {
  line-height: 24px;
}
.ant-btn-group > .ant-btn-sm {
  line-height: 24px;
}
.ant-btn-lg {
  line-height: 40px;
}
.ant-btn-group > .ant-btn-lg {
  line-height: 40px;
}
.ant-btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn:not(:last-child) {
    margin-right: 10px;
  }
}
.ant-btn-group .ant-btn:not(:last-child),
.ant-transfer-operation .ant-btn:not(:last-child) {
  margin-right: 0;
}
@media (max-width: 1599px) {
  .gx-product-footer .ant-btn:not(:last-child) {
    margin-right: 6px;
  }
}
@media screen and (max-width: 575px) {
  .ant-btn {
    margin-bottom: 10px;
  }
}
.ant-input-search .ant-btn {
  margin-bottom: 0;
}
.gx-customizer-option .ant-btn {
  padding: 0 18px;
  font-size: 18px;
  height: 42px;
  line-height: 42px;
  margin-bottom: 0;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);
  -webkit-border-radius: 30px 0 0 30px;
  -moz-border-radius: 30px 0 0 30px;
  border-radius: 30px 0 0 30px;
  background-color: #fa8c16;
  background: -webkit-gradient(linear, left top, right top, from(#fa8c16), to(#f5222d));
  background: -webkit-linear-gradient(left, #fa8c16, #f5222d);
  background: -moz-linear-gradient(left, #fa8c16, #f5222d);
  background: -ms-linear-gradient(left, #fa8c16, #f5222d);
  background: -o-linear-gradient(left, #fa8c16, #f5222d);
  border: 0 none;
  color: #ffffff;
}
.gx-customizer-option .ant-btn:hover,
.gx-customizer-option .ant-btn:focus {
  background-color: #f5222d;
  background: -webkit-gradient(linear, left top, right top, from(#f5222d), to(#fa8c16));
  background: -webkit-linear-gradient(left, #f5222d, #fa8c16);
  background: -moz-linear-gradient(left, #f5222d, #fa8c16);
  background: -ms-linear-gradient(left, #f5222d, #fa8c16);
  background: -o-linear-gradient(left, #f5222d, #fa8c16);
}
.gx-customizer-option .ant-btn .icon:before {
  display: block;
}
.horizontal-layout.full-scroll .gx-customizer-option .ant-btn {
  margin-right: 0;
}
.gx-module-add-task .ant-btn {
  height: 36px;
}
.gx-module-add-task .ant-btn .icon:before {
  position: relative;
  top: 2px;
}
.ant-modal-footer .ant-btn,
.ant-modal-confirm-btns .ant-btn {
  margin-bottom: 0;
}
.gx-login-content .ant-btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.boxed-layout .ant-btn-group .ant-btn {
  padding: 0 12px;
}
@media (max-width: 1366px) {
  .ant-btn-group .ant-btn {
    padding: 0 12px;
  }
}
@media (max-width: 1366px) {
  .gx-product-footer .ant-btn {
    padding: 0 10px;
    height: 32px;
    font-size: 12px;
    line-height: 32px;
  }
}
.ant-btn-background-ghost.ant-btn-primary {
  border-color: #2EB1EF;
  color: #2EB1EF;
}
.ant-btn-background-ghost.ant-btn-primary:hover,
.ant-btn-background-ghost.ant-btn-primary:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.ant-btn-group:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .ant-btn-group:not(:last-child) {
    margin-right: 10px;
  }
}
.ant-radio-group .ant-radio-button-wrapper {
  margin-bottom: 6px;
}
button {
  outline: none;
}
.ant-confirm .ant-confirm-btns button + button {
  margin-bottom: 8px;
}
.ant-modal.ant-confirm .ant-confirm-btns button + button,
.ant-modal.ant-confirm .ant-btn {
  margin-bottom: 0;
}
.gx-btn,
.btn {
  display: inline-block;
  font-weight: 400;
  color: #545454;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: solid 1px #d9d9d9;
  padding: 0 15px;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 15px;
}
.gx-btn:not(:last-child),
.btn:not(:last-child) {
  margin-right: 15px;
}
@media screen and (max-width: 575px) {
  .gx-btn:not(:last-child),
  .btn:not(:last-child) {
    margin-right: 10px;
  }
}
@media screen and (max-width: 575px) {
  .gx-btn,
  .btn {
    margin-bottom: 10px;
  }
}
.gx-btn:focus,
.btn:focus,
.gx-btn:hover,
.btn:hover {
  text-decoration: none;
}
.gx-btn:focus,
.btn:focus,
.gx-btn.focus,
.btn.focus {
  outline: 0;
}
.gx-btn.disabled,
.btn.disabled,
.gx-btn:disabled,
.btn:disabled {
  opacity: 0.65;
}
.gx-btn:not([disabled]):not(.disabled),
.btn:not([disabled]):not(.disabled) {
  cursor: pointer;
}
.gx-btn-list .gx-btn,
.gx-btn-list .btn {
  margin-bottom: 6px;
}
.gx-sub-popover .gx-btn,
.gx-sub-popover .btn {
  border: 0 none;
  margin-bottom: 5px;
}
.gx-sub-popover .gx-btn:focus,
.gx-sub-popover .btn:focus,
.gx-sub-popover .gx-btn:hover,
.gx-sub-popover .btn:hover {
  background-color: #f5f5f5;
}
.gx-sub-popover .gx-btn:not(:last-child),
.gx-sub-popover .btn:not(:last-child) {
  margin-right: 5px;
}
.gx-login-content .gx-btn,
.gx-login-content .btn {
  padding: 9px 20px !important;
  height: auto;
  line-height: 1;
}
.gx-btn-block {
  display: block;
  width: 100%;
}
a.gx-btn.disabled,
fieldset[disabled] a.gx-btn {
  pointer-events: none;
}
.gx-btn-rounded {
  -webkit-border-radius: 50px !important;
  -moz-border-radius: 50px !important;
  border-radius: 50px !important;
}
.gx-btn-link {
  font-size: 14px;
  font-weight: 400;
  color: #2EB1EF;
  background-color: transparent;
}
.gx-btn-link:hover {
  color: #2EB1EF;
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.gx-btn-link:focus,
.gx-btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
}
.gx-btn-link:disabled,
.gx-btn-link.disabled {
  color: #bfbfbf;
}
.gx-btn-lg,
.gx-btn-group-lg > .gx-btn {
  padding: 0 15px;
  font-size: 16px;
  line-height: 40px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  height: 40px;
}
.gx-btn-sm,
.gx-btn-group-sm > .gx-btn {
  padding: 0 7px;
  font-size: 12px;
  line-height: 24px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  height: 24px;
}
.gx-btn-xs {
  font-size: 10px;
  padding: 0 6px;
  height: 26px;
  line-height: 25px;
}
.gx-btn-block {
  display: block;
  width: 100%;
}
.gx-btn-block + .gx-btn-block {
  margin-top: 0.5rem;
}
.gx-icon-btn {
  width: 40px;
  height: 40px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  cursor: pointer;
}
.gx-icon-btn:focus,
.gx-icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.gx-layout-sider-dark .gx-icon-btn:focus,
.gx-layout-sider-dark .gx-icon-btn:hover {
  background-color: #003366;
}
.gx-popover-header .gx-icon-btn {
  width: 30px;
  height: 30px;
}
.gx-icon-btn .icon-star-o:before,
.gx-icon-btn .icon-star:before {
  position: relative;
  top: 3px;
}
@media screen and (max-width: 575px) {
  .gx-module-box-content .gx-icon-btn.icon {
    font-size: 16px;
  }
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper {
  height: 24px;
  line-height: 24px;
  border: 0 none;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  margin-left: 0;
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  color: #ffffff;
}
.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}
@media screen and (max-width: 575px) {
  .gx-radio-group-link-news {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 575px) {
  .gx-radio-group-link .ant-radio-button-wrapper {
    padding: 0 8px;
  }
}
.gx-radio-group-link-bg-light {
  margin-left: -5px;
  margin-right: -5px;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {
  padding: 0 10px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: #e8e8e8;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  color: #ffffff;
}
.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}
/*Card Styles*/
.ant-card {
  margin-bottom: 32px;
}
.ant-card-head {
  background: none;
}
.ant-card-head-title {
  font-weight: 400;
}
.ant-card-grid {
  text-align: center;
  width: 25%;
}
@media screen and (max-width: 767px) {
  .ant-card-grid {
    width: 33.33%;
  }
}
@media screen and (max-width: 575px) {
  .ant-card-grid {
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  .ant-card {
    margin-bottom: 20px;
  }
}
.ant-card-body .ant-card-head {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.ant-card-type-inner .ant-card-head {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.ant-card-wider-padding .ant-card-body > :last-child {
  margin-bottom: 0;
}
.gx-card-center-vertical {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-card-img {
  position: relative;
  overflow: hidden;
}
.gx-card-img .ant-card-body {
  position: relative;
}
.gx-card-img .gx-badge-up {
  position: absolute;
  right: 60px;
  top: -20px;
  z-index: 1;
  padding: 5px;
  margin: 0;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  line-height: 36px;
  text-align: center;
}
.gx-card-img .gx-badge-up-right {
  right: 10px;
  top: -15px;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  line-height: 32px !important;
}
.gx-card-img-center .ant-card-cover {
  text-align: center;
}
.gx-card-img-center .ant-card-cover > * {
  width: auto;
  display: inline-block;
}
.gx-card-body-border-top .ant-card-cover {
  padding-top: 24px;
}
.gx-card-body-border-top .ant-card-body {
  border-top: solid 1px #e8e8e8;
  margin-top: 32px;
}
@media screen and (max-width: 575px) {
  .gx-card-body-border-top .ant-card-body {
    margin-bottom: 20px;
  }
}
.gx-ant-card-actions {
  list-style: none;
  margin: 0 -10px 10px;
  padding-left: 0;
}
.gx-ant-card-actions li {
  display: inline-block;
  vertical-align: top;
  padding: 0 10px;
}
.gx-ant-card-actions li:not(:last-child) {
  border-right: solid 1px #e8e8e8;
}
.gx-card {
  margin-bottom: 32px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
@media screen and (max-width: 575px) {
  .gx-card {
    margin-bottom: 20px;
  }
}
.gx-card-head {
  padding: 24px;
}
.gx-card-head .gx-card-title {
  margin-bottom: 0;
}
.gx-card-head + .gx-card-body {
  padding-top: 0;
}
.gx-card .ant-card-head {
  border-bottom: 0 none;
  min-height: 10px;
  padding: 0 24px;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-head {
    padding: 0 24px;
  }
}
.gx-card .ant-card-head-title {
  padding: 25px 0 0;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-head-title {
    padding-top: 20px;
  }
}
.gx-card-body,
.gx-card .ant-card-body {
  padding: 24px;
}
@media screen and (max-width: 991px) {
  .gx-card-body,
  .gx-card .ant-card-body {
    padding: 24px;
  }
}
.gx-card.ant-card-bordered {
  border: 0 none;
}
.gx-card.ant-card-hoverable:hover {
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);
}
.gx-card .ant-card-cover {
  padding: 24px;
  padding-bottom: 0;
}
@media screen and (max-width: 991px) {
  .gx-card .ant-card-cover {
    padding: 24px;
    padding-bottom: 0;
  }
}
.gx-card-metrics {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-card-metrics.ant-card-bordered {
  border: 0 none;
}
.gx-card-metrics .ant-card-head {
  border-bottom: 0 none;
  min-height: 10px;
}
.gx-card-metrics .ant-card-head-title {
  padding: 20px 0 0;
  text-transform: uppercase;
  font-size: 14px;
}
.gx-card-widget {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-card-widget.ant-card-bordered {
  border: 0 none;
}
.gx-card-widget .ant-card-head {
  border-bottom: 0 none;
  min-height: 24px;
  padding: 24px 24px 0;
}
.gx-card-widget .ant-card-head-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-card-widget .ant-card-head-title {
  padding: 0;
  text-transform: uppercase;
  font-size: 14px;
}
.gx-card-widget.gx-ch-capitalize .ant-card-head-title {
  text-transform: capitalize;
  font-size: 14px;
}
.gx-card-widget .ant-card-extra {
  padding: 0;
}
.gx-card-widget .ant-card-extra .gx-btn {
  margin-bottom: 0;
}
.gx-card-widget .ant-card-body {
  padding: 24px;
}
.gx-card-equal-height {
  height: calc(100% - 32px);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media screen and (max-width: 575px) {
  .gx-card-equal-height {
    height: calc(100% - 20px);
  }
}
.gx-card-equal-height .ant-card-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-card-equal-height .ant-card-body .gx-rechart {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-card-equal-height .ant-card-body .gx-rechart .recharts-responsive-container {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: flex;
}
.gx-card-sm-p .ant-card-head {
  min-height: 10px;
}
.gx-card-sm-p .ant-card-head-title {
  padding: 14px 14px 0;
}
.gx-card-sm-p .ant-card-body {
  padding: 14px;
}
.gx-card-sm-px .ant-card-head {
  min-height: 10px;
}
.gx-card-sm-px .ant-card-head-title {
  padding-left: 10px;
  padding-right: 10px;
}
.gx-card-sm-px .ant-card-body {
  padding-left: 10px;
  padding-right: 10px;
}
.gx-entry-header {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-entry-header {
    margin-bottom: 20px;
  }
}
.gx-entry-header .gx-entry-heading {
  margin-bottom: 0;
}
.gx-entry-header .gx-entry-description {
  margin-bottom: 0;
  font-size: 13px;
}
.gx-card-full {
  overflow: hidden;
}
.gx-card-full .gx-card-body {
  padding: 0;
}
.gx-card-full .gx-card-body .recharts-legend-wrapper {
  padding: 0 24px;
}
.gx-card-full .ant-card-body {
  padding: 0;
}
.gx-card-full .ant-card-body .recharts-legend-wrapper {
  padding: 0 24px;
}
.gx-card-full .recharts-default-legend {
  margin: 0 -10px !important;
}
.gx-card-full .recharts-default-legend li {
  padding: 0 10px;
  margin: 0 !important;
  display: inline-block;
  vertical-align: top;
}
.gx-card-full .recharts-default-legend li .recharts-legend-item-text {
  margin-left: 10px;
}
.gx-card-overview {
  margin-bottom: 32px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding: 24px;
}
@media screen and (max-width: 575px) {
  .gx-card-overview {
    margin-bottom: 20px;
  }
}
.gx-card-overview .gx-card-title {
  margin-bottom: 20px;
}
.gx-card-profile .ant-card-head {
  padding-top: 15px;
  padding-bottom: 16px;
}
.gx-card-profile.gx-card-tabs .ant-card-head {
  border-bottom: 1px solid #e8e8e8;
}
@media screen and (max-width: 575px) {
  .gx-card-profile.gx-card-tabs .ant-card-head {
    border-bottom: 0 none;
  }
}
.gx-card-profile .ant-card-body,
.gx-card-profile.gx-card-tabs .ant-card-body {
  padding-top: 0;
}
.gx-card-profile.gx-card-tabs .ant-tabs {
  margin-top: -49px;
}
@media screen and (max-width: 575px) {
  .gx-card-profile.gx-card-tabs .ant-tabs {
    margin-top: 0;
  }
}
.gx-card-profile .ant-tabs-tab {
  padding-top: 15px;
  padding-bottom: 18px;
}
.gx-card-profile .ant-card-head-title,
.gx-card-profile.gx-card-tabs .ant-card-head-title {
  font-size: 20px;
  text-transform: capitalize;
}
.gx-card-profile.gx-card-tabs .ant-tabs-nav-container {
  font-size: 14px;
  color: #8c8c8c;
}
.gx-card-profile-sm.gx-card-widget .ant-card-body {
  padding-top: 10px;
}
@media (max-width: 1366px) {
  .gx-card-1367-p .ant-card-head {
    min-height: 10px;
  }
  .gx-card-1367-p .ant-card-head-title {
    padding-left: 14px;
    padding-right: 14px;
  }
  .gx-card-1367-p .ant-card-body {
    padding-left: 14px;
    padding-right: 14px;
  }
}
.ant-divider-horizontal.ant-divider-with-text,
.ant-divider-horizontal.ant-divider-with-text-left,
.ant-divider-horizontal.ant-divider-with-text-right {
  font-size: 14px;
}
/*Cascader Styles*/
.ant-cascader-picker {
  width: 100%;
}
/*Chart Styles*/
.recharts-default-tooltip {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8) !important;
  color: #089265;
}
.recharts-tooltip-item-list li {
  color: #2EB1EF !important;
}
/*Form Styles*/
.ant-form .ant-row {
  margin-left: 0;
  margin-right: 0;
}
.ant-form-inline {
  margin-left: -8px;
  margin-right: -8px;
}
.ant-form-inline .ant-row {
  padding-left: 8px;
  padding-right: 8px;
}
.ant-form-inline .ant-form-item {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .ant-form-inline .ant-form-item {
    display: block;
  }
}
.ant-form-horizontal .ant-row {
  margin-left: -15px;
  margin-right: -15px;
}
.ant-form-vertical .ant-form-item {
  padding-bottom: 0;
}
.ant-form-vertical .ant-row {
  -ms-flex-direction: column;
  flex-direction: column;
}
.ant-form-extra {
  word-break: break-all;
}
@media (max-width: 575px) {
  .ant-form-item-label {
    padding-bottom: 0;
  }
}
.ant-form-item-with-help {
  margin-bottom: 20px;
}
.ant-advanced-search-form .gx-btn-link:hover {
  text-decoration: none;
}
.ant-form-item-control > .ant-form-item:last-child,
.ant-form-item [class^="ant-col-"] > .ant-form-item:only-child {
  margin-bottom: 0;
}
.gx-form-row0 .ant-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.gx-login-form {
  max-width: 350px;
}
.gx-login-form .ant-form-item-control-wrapper {
  width: 100%;
}
.ant-form-inline .gx-form-item-one-fourth {
  width: 25%;
}
@media (max-width: 575px) {
  .ant-form-inline .gx-form-item-one-fourth {
    width: 100%;
  }
}
.ant-form-inline .gx-form-item-two-fourth {
  width: 50%;
}
@media (max-width: 575px) {
  .ant-form-inline .gx-form-item-two-fourth {
    width: 100%;
  }
}
.gx-form-inline-currency {
  margin: 0 -8px;
}
.gx-form-inline-currency .ant-form-item {
  padding: 0 8px;
}
.gx-form-inline-currency .gx-form-item-one-fourth {
  width: 30%;
}
@media (max-width: 575px) {
  .gx-form-inline-currency .gx-form-item-one-fourth {
    width: 40%;
    display: inline-block;
  }
}
.gx-form-inline-currency .gx-form-item-two-fourth {
  width: 40%;
}
@media (max-width: 575px) {
  .gx-form-inline-currency .gx-form-item-two-fourth {
    width: 100%;
    display: block;
  }
}
@media (max-width: 1599px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 15px;
  }
}
@media (max-width: 1199px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 15px;
  }
  .ant-form-item,
  .ant-form-item-with-help {
    margin-bottom: 12px;
  }
  .ant-advanced-search-form .ant-form-item {
    margin-bottom: 12px;
  }
}
@media (max-width: 991px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 15px;
  }
}
@media (max-width: 767px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 15px;
  }
}
@media (max-width: 575px) {
  .ant-form-item-label[class*='ant-col-'] {
    padding: 0 15px;
    margin-bottom: 8px;
  }
  .ant-advanced-search-form .ant-btn,
  .ant-advanced-search-form .gx-btn-link {
    display: block;
    margin: 0 0 10px !important;
  }
}
/*Input Styles*/
.ant-input-search {
  margin-bottom: 16px;
}
.ant-input-search > .ant-input-suffix > .ant-input-search-button {
  margin-right: 0;
}
.ant-input-group > [class*="col-"] {
  padding-left: 0;
  float: left !important;
}
.ant-transfer-list {
  margin-bottom: 10px;
}
.gx-form-group {
  margin-bottom: 10px;
}
.gx-search-bar {
  position: relative;
}
.gx-search-bar .gx-form-group {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
.gx-search-bar input[type="search"] {
  padding-right: 35px;
  background: rgba(250, 250, 250, 0.1);
}
.ant-layout-header .gx-search-bar input[type="search"],
.ant-popover-content .gx-search-bar input[type="search"] {
  border: 0 none;
}
.gx-search-bar input[type="search"]:focus {
  box-shadow: none;
  background-color: rgba(250, 250, 250, 0.3);
}
.gx-search-bar .gx-search-icon {
  background-color: transparent;
  border: 0 none;
  color: #d9d9d9;
  height: 32px;
  width: 30px;
  line-height: 36px;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
}
.gx-algolia-header .gx-search-bar .gx-search-icon {
  margin-top: 2px;
  text-align: left;
}
.gx-search-bar .ant-input-lg + .gx-search-icon {
  height: 40px;
  line-height: 45px;
}
.gx-lt-icon-search-bar input[type="search"] {
  padding-right: 16px;
  padding-left: 35px;
  border: 0 none;
}
.gx-lt-icon-search-bar .gx-search-icon {
  left: 0;
  right: auto;
}
.gx-algolia-header .gx-lt-icon-search-bar {
  margin-right: 10px;
}
@media screen and (max-width: 1199px) {
  .gx-algolia-header .gx-lt-icon-search-bar {
    width: 140px;
  }
}
@media screen and (max-width: 400px) {
  .gx-algolia-header .gx-lt-icon-search-bar {
    margin-right: 0;
    margin-bottom: 10px;
    width: auto;
  }
}
.gx-lt-icon-search-bar-lg {
  width: 350px;
}
.gx-lt-icon-search-bar-lg input[type="search"] {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  height: 46px;
  padding: 10px 18px 10px 40px;
}
@media screen and (max-width: 991px) {
  .gx-lt-icon-search-bar-lg input[type="search"] {
    height: 38px;
    padding: 5px 18px 5px 40px;
  }
}
.gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  background-color: #f5f5f5;
  height: 36px;
  -webkit-border-radius: 4px 0 0 4px;
  -moz-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  border: solid 1px #e8e8e8;
}
.gx-header-search .gx-lt-icon-search-bar-lg input[type="search"]:focus {
  background-color: #f2f2f2;
}
.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  border-color: rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"]:focus {
  background-color: transparent;
}
.gx-lt-icon-search-bar-lg .gx-search-icon {
  width: 35px;
  height: 46px;
  line-height: 50px;
  font-size: 16px;
  left: 0;
  right: auto;
}
@media screen and (max-width: 991px) {
  .gx-lt-icon-search-bar-lg .gx-search-icon {
    height: 38px;
    line-height: 40px;
  }
}
.gx-header-search .gx-lt-icon-search-bar-lg .gx-search-icon {
  height: 36px;
  line-height: 40px;
}
.gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {
  width: 200px;
  margin-right: 10px;
}
@media screen and (max-width: 1199px) {
  .gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {
    width: 120px;
  }
}
@media screen and (max-width: 1199px) {
  .gx-lt-icon-search-bar-lg {
    width: 150px;
  }
}
.gx-popover-search-bar {
  width: 150px;
  margin: -10px -14px;
}
.gx-chat-search-bar {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-width: 100px;
  width: auto;
}
.gx-chat-search-bar input[type="search"] {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  height: 40px;
  border: 0 none;
}
.gx-chat-search-bar input[type="search"]:focus {
  background-color: #ffffff;
}
.gx-chat-search-bar .gx-search-icon {
  height: 40px;
  line-height: 44px;
}
.ant-transfer-list {
  width: 150px;
}
@media screen and (max-width: 575px) {
  .ant-transfer-list {
    width: 100%;
  }
}
.gx-select-sm {
  font-size: 12px;
}
.gx-select-sm .ant-select-selection {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.gx-select-sm .ant-select-selection--single {
  height: 24px;
}
.gx-select-sm .ant-select-selection__rendered {
  line-height: 22px;
  margin-left: 6px;
  margin-right: 6px;
}
.gx-select-sm .ant-select-selection-selected-value {
  padding-right: 20px;
}
.gx-select-sm .ant-select-arrow {
  right: 6px;
}
.gx-select-sm .ant-select-dropdown {
  font-size: 12px;
}
.gx-form-inline-label-up .ant-form-item > .ant-form-item-control-wrapper,
.gx-form-inline-label-up .ant-form-item > .ant-form-item-label {
  display: block;
}
.gx-form-inline-label-up .ant-form-item-label {
  text-align: left;
  color: #bfbfbf;
  line-height: 1;
  margin-bottom: 2px;
}
.gx-form-inline-label-up .ant-select-selection--single,
.gx-form-inline-label-up .ant-input {
  height: 30px;
}
.gx-form-inline-label-up .ant-select-selection__rendered {
  line-height: 28px;
}
@media screen and (max-width: 575px) {
  .gx-ant-transfer-width .ant-transfer-list {
    width: 100% !important;
  }
}
@media screen and (max-width: 475px) {
  .ant-input-group.ant-input-group-compact > * {
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 100% !important;
  }
  .ant-input-group.ant-input-group-compact > *:not(:last-child) {
    margin-bottom: 10px;
  }
  .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,
  .ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,
  .ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,
  .ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {
    border-radius: 4px;
  }
  .ant-input-group.ant-input-group-compact .gx-border-lt-xs {
    border-left: 1px solid #d9d9d9 !important;
  }
}
/*Icon Styles*/
.gx-icon-views {
  position: relative;
  text-align: center;
  padding: 16px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  margin-bottom: 15px;
  height: calc(85%);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-icon-views .icon {
  margin-bottom: 12px;
  font-size: 20px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  line-height: 1;
  display: block;
}
.gx-icon-views:hover {
  background-color: #2EB1EF;
  cursor: pointer;
  color: #ffffff;
}
.gx-icon-views:hover .icon {
  -webkit-transform: scale(1.4);
  -moz-transform: scale(1.4);
  -ms-transform: scale(1.4);
  -o-transform: scale(1.4);
  transform: scale(1.4);
}
.gx-icon-text {
  display: block;
  font-size: 12px;
}
/*List Styles*/
.ant-list-vertical .ant-list-item-main {
  min-width: 200px;
}
@media screen and (max-width: 480px) {
  .ant-list-vertical .ant-list-item-extra {
    margin-bottom: 10px;
  }
}
.gx-list-item .ant-list-item-extra-wrap {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {
  margin-left: 20px;
}
@media screen and (max-width: 575px) {
  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {
    margin-left: 0;
    margin-top: 10px;
  }
  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra img {
    width: 100%;
  }
}
@media screen and (max-width: 575px) {
  .gx-list-item .ant-list-item-extra-wrap {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-user-list {
  width: 100%;
  padding-bottom: 10px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-user-list:not(:first-child) {
  padding-top: 20px;
}
@media screen and (max-width: 575px) {
  .gx-user-list:not(:first-child) {
    padding-top: 0;
  }
}
.gx-user-list.gx-card-list {
  padding: 30px;
  background: #fff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 32px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
.gx-user-list.gx-card-list .gx-avatar-img {
  margin-right: 25px;
}
@media screen and (max-width: 767px) {
  .gx-user-list.gx-card-list {
    padding: 20px;
  }
}
@media screen and (max-width: 575px) {
  .gx-user-list.gx-card-list {
    margin-bottom: 20px;
  }
}
.gx-user-list .gx-avatar-img {
  margin-right: 20px;
  margin-bottom: 10px;
}
.gx-user-list h3 {
  font-weight: 500;
  margin-bottom: 8px;
}
.gx-user-list .gx-link[class*="gx-meta-"] {
  display: inline-block;
  color: #545454;
  font-size: 12px;
  font-weight: 500;
}
.gx-user-list .gx-link[class*="gx-meta-"] i {
  margin-right: 6px;
  vertical-align: middle;
}
.gx-user-list .gx-description {
  width: calc(100% - 120px);
}
@media screen and (max-width: 575px) {
  .gx-user-list .gx-description {
    width: 100%;
  }
}
.gx-user-list .gx-btn-list li:not(:last-child) {
  margin-right: 10px;
}
.gx-list-inline {
  margin-left: -5px;
  margin-right: -5px;
  padding-left: 0;
  list-style: none;
}
.gx-list-inline li {
  padding: 0 5px;
  display: inline-block;
}
.gx-list-inline-lg {
  margin-left: -10px;
  margin-right: -10px;
  padding-left: 0;
  list-style: none;
}
.gx-list-inline-lg li {
  padding: 0 10px;
  display: inline-block;
}
.gx-card-strip {
  margin-bottom: 10px;
}
.gx-card-strip:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-card-list .gx-description {
  width: calc(100% - 230px);
  margin-top: 5px;
}
@media screen and (max-width: 767px) {
  .gx-card-list .gx-description {
    width: calc(100% - 80px);
  }
}
.gx-card-list .gx-card-list-footer {
  padding-left: 15px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  min-width: 150px;
}
.gx-card-list .gx-card-list-footer .ant-btn {
  display: block;
  margin-right: 0;
  width: 120px;
}
.gx-card-list .gx-card-list-footer .ant-btn:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .gx-card-list .gx-card-list-footer {
    padding-left: 0;
    min-width: 10px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .gx-card-list .gx-card-list-footer .ant-btn {
    width: auto;
    margin-right: 12px;
    margin-bottom: 0;
  }
}
.gx-list-group {
  list-style: none;
  padding-left: 0;
}
.gx-list-group li {
  margin-bottom: 6px;
}
.gx-list-group li i {
  margin-right: 12px;
}
.gx-dot-list {
  list-style: none;
  margin: 0 -3px 10px;
  padding-left: 0;
}
.gx-dot-list li {
  display: inline-block;
  vertical-align: top;
  padding: 0 3px;
}
@media screen and (max-width: 575px) {
  .gx-dot-list {
    margin-bottom: 5px;
  }
}
/*Loader Styles*/
.ant-spin {
  margin-right: 16px;
  margin-bottom: 10px;
}
.gx-loader-container {
  text-align: center;
  background-color: #f5f5f5;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 30px 50px;
  margin-right: 0;
  display: block;
}
/*Pagination Styles*/
.ant-pagination > li {
  margin-bottom: 10px;
}
.ant-pagination > li.ant-pagination-options,
.ant-pagination > li.ant-pagination-total-text {
  margin-bottom: 0;
}
.ant-pagination.mini:not(:last-child) {
  margin-bottom: 10px;
}
.ant-pagination.mini li {
  margin-bottom: 5px !important;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  line-height: 30px;
}
/*Pickers Styles*/
.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important;
}
.gx-alpha-pickers {
  position: relative;
  min-height: 250px;
}
.ant-calendar-footer .ant-calendar-ok-btn {
  margin-bottom: 0;
}
/*Progress Styles*/
.ant-progress-line {
  margin-right: 8px;
  margin-bottom: 8px;
}
.ant-progress-circle {
  margin-right: 8px;
  margin-bottom: 8px;
}
/*Steps Styles*/
.ant-steps-dot {
  flex-wrap: wrap;
  overflow: hidden;
  padding: 10px 0;
}
.ant-steps-dot .ant-steps-item {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .ant-steps-dot .ant-steps-item-description {
    display: none;
  }
}
/*Slider Styles*/
.ant-carousel h1,
.ant-carousel h2,
.ant-carousel h3,
.ant-carousel h4,
.ant-carousel h5,
.ant-carousel h6 {
  line-height: inherit;
  margin-bottom: 0;
}
.gx-vertical-slider {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -15px;
}
.gx-vertical-slider-item {
  width: 33.33%;
  padding: 0 15px;
  height: 300px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 575px) {
  .gx-vertical-slider-item {
    width: 50%;
    margin-bottom: 15px;
  }
}
.ant-carousel-vertical .gx-vertical-slide .slick-slide {
  height: 160px;
}
.slick-slider {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .slick-slider {
    margin-bottom: 20px;
  }
}
.slick-slider .slick-prev {
  left: -10px;
}
.slick-slider .slick-prev:before {
  color: #000000;
}
.slick-slider .slick-next {
  right: -10px;
}
.slick-slider .slick-next:before {
  color: #000000;
}
.slick-slider img {
  width: 100%;
  object-fit: cover;
}
.slick-dots li button:before {
  display: none;
}
.gx-slick-slider .slick-dots {
  bottom: 26px;
  padding: 0 24px;
  text-align: left;
}
.gx-slick-slider .slick-dots li {
  width: 10px !important;
  height: 10px !important;
}
.gx-slick-slider .slick-dots li button {
  width: 10px !important;
  height: 10px !important;
}
.gx-slick-slider .slick-dots li button:before {
  width: 10px !important;
  height: 10px !important;
  line-height: 10px !important;
  color: transparent;
  border: solid 2px #000000;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  display: block;
}
.gx-slick-slider .slick-dots li.slick-active button {
  width: 12px !important;
  height: 12px !important;
}
.gx-slick-slider .slick-dots li.slick-active button:before {
  color: transparent;
  border-color: #2EB1EF;
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
}
.gx-slide-item {
  margin-left: 15px;
  margin-right: 15px;
}
@media screen and (max-width: 480px) {
  .gx-slide-item {
    margin-left: 10px;
    margin-right: 10px;
  }
}
.gx-slider {
  position: relative;
}
.gx-slider-img {
  position: relative;
  padding-bottom: 24px;
}
.gx-slider-img .gx-img-up {
  position: absolute;
  left: 24px;
  bottom: -5px;
  z-index: 1;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: auto;
  max-width: 64px;
}
.gx-slider-content {
  padding: 24px;
}
.gx-slick-slider {
  margin-bottom: 0;
  padding-bottom: 24px;
}
.gx-slick-slider-dot-top {
  padding-top: 70px;
  padding-right: 24px;
  padding-bottom: 58px;
}
@media (max-width: 1366px) {
  .gx-slick-slider-dot-top {
    padding-top: 40px;
    padding-bottom: 10px;
  }
}
.gx-slick-slider-dot-top .slick-dots {
  bottom: auto;
  top: 30px;
  padding-left: 0;
}
@media (max-width: 1366px) {
  .gx-slick-slider-dot-top .slick-dots {
    top: 10px;
  }
}
@media screen and (max-width: 575px) {
  .gx-slick-slider-dot-top {
    padding-left: 24px;
  }
}
.gx-slick-slider-lt-thumb {
  height: 100%;
  position: relative;
}
.gx-slick-slider-lt-thumb img {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .gx-slick-slider-lt-thumb img {
    position: relative;
    left: auto;
    top: auto;
  }
}
.ant-modal .slides {
  position: relative;
}
.ant-modal .slides .slick-prev,
.ant-modal .slides .slick-next {
  position: absolute;
  top: 50%;
  z-index: 1;
  margin-top: -10px;
}
.ant-modal .slides .slick-prev {
  left: 20px;
}
.ant-modal .slides .slick-next {
  right: 20px;
}
.ant-modal .slick-slider {
  margin-bottom: 0;
}
/*Tables Styles*/
.ant-table-small > .ant-table-content {
  border: none;
}
.ant-table-small > .ant-table-content > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {
  padding: 0;
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  word-break: normal;
}
.dark-theme .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background: transparent !important;
  border-bottom-color: transparent !important;
}
.gx-table-responsive .ant-table {
  min-height: .01%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .gx-table-responsive .ant-table {
    width: 100%;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: solid 1px #e8e8e8;
  }
  .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {
    border: 0 none;
    border-bottom: solid 1px #e8e8e8;
  }
  .gx-table-responsive .ant-table .ant-table-tbody > tr:last-child > td {
    border-bottom: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-header > table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-body > table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-left table,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-right table {
    border-top: 0 none;
    border-left: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-title {
    border: 0 none;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {
    border: 0 none;
    border-top: solid 1px #e8e8e8;
  }
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-thead > tr > th:last-child,
  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-tbody > tr > td:last-child {
    border-right: 0 none;
  }
  .gx-table-responsive .ant-table-body > table > thead > tr > th,
  .gx-table-responsive .ant-table-body > table > tbody > tr > th,
  .gx-table-responsive .ant-table-body > table > tfoot > tr > th,
  .gx-table-responsive .ant-table-body > table > thead > tr > td,
  .gx-table-responsive .ant-table-body > table > tbody > tr > td,
  .gx-table-responsive .ant-table-body > table > tfoot > tr > td {
    white-space: nowrap;
  }
}
.gx-table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.gx-table th,
.gx-table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: solid 1px #e8e8e8;
}
.gx-table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e8e8e8;
}
.gx-table tbody + tbody {
  border-top: 2px solid #e8e8e8;
}
.gx-table-bordered {
  border: 1px solid #e8e8e8;
}
.gx-table-bordered th,
.gx-table-bordered td {
  border: 1px solid #e8e8e8;
}
.gx-table-bordered thead th,
.gx-table-bordered thead td {
  border-bottom-width: 2px;
}
.gx-table-no-bordered {
  border: 0 none;
}
.gx-table-no-bordered th,
.gx-table-no-bordered td {
  border: 0 none;
}
.gx-table-no-bordered thead th,
.gx-table-no-bordered thead td {
  border-bottom-width: 2px;
}
.gx-table-no-bordered .ant-table {
  border: 0 none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-table-no-bordered .ant-table-thead > tr > th {
  font-weight: 300;
  text-transform: uppercase;
  font-size: 11px;
}
.gx-table-no-bordered .ant-table-tbody > tr > td {
  border-bottom: 0 none;
}
.gx-table-thead-uppercase thead th {
  text-transform: uppercase;
}
.gx-table-padding-lg thead th,
.gx-table-padding-lg tbody td {
  padding: 20px 30px !important;
}
@media screen and (max-width: 991px) {
  .gx-table-padding-lg thead th,
  .gx-table-padding-lg tbody td {
    padding: 15px 20px !important;
  }
}
@media screen and (max-width: 767px) {
  .gx-table-padding-lg thead th,
  .gx-table-padding-lg tbody td {
    padding: 10px !important;
  }
}
.gx-table-padding-lg .ant-table-pagination {
  float: none;
  text-align: center;
  margin: 22px 0;
}
@media screen and (max-width: 991px) {
  .gx-table-padding-lg .ant-table-pagination {
    margin: 16px 0;
  }
}
/*Time Lines Style*/
/*Antd Time Lines Style*/
.ant-timeline-item {
  padding: 0;
}
.ant-timeline-item:not(:last-child) {
  padding-bottom: 20px;
}
@media screen and (max-width: 575px) {
  .ant-timeline-item:not(:last-child) {
    padding-bottom: 15px;
  }
}
.gx-timeline-info {
  position: relative;
}
.gx-timeline-info:not(:last-child) {
  padding-bottom: 20px;
}
.gx-timeline-info-day {
  margin-bottom: 15px;
  font-size: 12px;
  color: #595959;
}
.gx-timeline-info .ant-timeline {
  padding-top: 0;
  padding-left: 0;
}
.gx-timeline-info .ant-timeline-item-head-custom {
  padding: 0;
  margin-right: 15px;
  position: relative;
  left: 0;
  top: 0;
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.gx-timeline-info .ant-timeline-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
}
.gx-timeline-info .ant-timeline-item-content {
  padding-left: 0;
  top: 0;
  margin-left: 0;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #595959;
}
.gx-timeline-info .ant-timeline-item-content .gx-link {
  color: #262626;
}
.gx-timeline-info .ant-timeline-item-content .gx-link:hover,
.gx-timeline-info .ant-timeline-item-content .gx-link:focus {
  color: #2EB1EF;
}
.gx-timeline-info .ant-timeline-item-tail {
  display: none;
}
.gx-img-more {
  width: 60px;
  height: 40px;
  background-color: #ffffff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  border: solid 1px #e8e8e8;
}
/*Custom Time Lines Style*/
.gx-timeline-left {
  float: left;
  margin-right: 20px;
}
.gx-timeline-right {
  float: right;
  margin-left: 20px;
}
.gx-timeline-circle {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-timeline-section {
  margin-bottom: 25px;
  overflow: hidden;
}
.gx-timeline-item {
  padding-bottom: 25px;
  padding-left: 80px;
  position: relative;
}
.gx-timeline-item:before {
  border-left: solid 2px #e8e8e8;
  content: "";
  left: 25px;
  position: absolute;
  top: 25px;
  bottom: -20px;
  width: 2px;
  z-index: 1;
}
.gx-timeline-item:first-child:before {
  border-left-style: dashed;
}
.gx-timeline-item:last-child:before {
  border-left-style: dashed;
  bottom: 25px;
}
.gx-timeline-badge {
  height: 50px;
  width: 50px;
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.gx-timeline-badge.gx-timeline-img {
  background-color: transparent;
}
.gx-timeline-badge.gx-timeline-img:after {
  display: none;
}
.gx-timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #e8e8e8;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  left: 4px;
  top: 4px;
  z-index: 1;
}
.gx-timeline-badge [class^="gx-"]:before,
.gx-timeline-badge [class*="gx-"]:before {
  line-height: 50px;
}
.gx-timeline-img > img,
.gx-timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.gx-timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: solid 1px #e8e8e8;
}
.gx-timeline-panel:after,
.gx-timeline-panel:before {
  content: "";
  position: absolute;
  border-style: solid;
  display: inline-block;
  top: 30px;
}
.gx-timeline-panel:before {
  border-color: transparent #e8e8e8;
  border-width: 10px 17px 10px 0;
  left: -18px;
}
.gx-timeline-panel:after {
  border-color: transparent #ffffff;
  border-width: 10px 16px 10px 0;
  left: -16px;
}
.gx-timeline-no-padding {
  padding: 0;
}
.gx-timeline-panel-header {
  margin-bottom: 10px;
}
.gx-timeline-header-img {
  margin-bottom: 10px;
}
.gx-timeline-inverted .gx-timeline-left {
  float: right;
  margin-right: 0;
  margin-left: 20px;
}
.gx-timeline-heading {
  overflow: hidden;
  margin-bottom: 10px;
}
.gx-timeline-body {
  clear: both;
}
/*Gxtl Center Style*/
.gx-timeline-center .gx-timeline-item {
  clear: both;
  float: right;
  width: 50%;
  padding-left: 55px;
}
.gx-timeline-center .gx-timeline-item:before {
  left: 0;
}
.gx-timeline-center .gx-timeline-badge {
  left: -25px;
  right: auto;
}
.gx-timeline-center .gx-timeline-time {
  position: absolute;
  top: 32px;
  left: -150px;
  right: auto;
  z-index: 2;
}
.gx-timeline-center .gx-timeline-inverted {
  float: left;
  text-align: right;
  padding-left: 0;
  padding-right: 55px;
}
.gx-timeline-center .gx-timeline-inverted:before {
  border-left: 0 none;
  border-right: solid 2px #e8e8e8;
  left: auto;
  right: -2px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
  left: auto;
  right: -25px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {
  border-width: 10px 0 10px 17px;
  left: auto;
  right: -18px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {
  border-width: 10px 0 10px 16px;
  left: auto;
  right: -16px;
}
.gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
  position: absolute;
  top: 32px;
  right: -150px;
  left: auto;
  z-index: 2;
}
/*Gxtl Zigzag Style*/
.gx-timeline-zigzag .gx-timeline-item {
  padding-left: 150px;
}
.gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
  margin-top: -80px;
}
.gx-timeline-zigzag .gx-timeline-img {
  width: 90px;
  height: 90px;
  left: 5px;
}
.gx-timeline-zigzag .gx-timeline-img > img {
  width: 100%;
}
.gx-timeline-zigzag .gx-timeline-inverted .gx-timeline-img {
  right: 5px !important;
}
.gx-timeline-zigzag .gx-timeline-item:before {
  -webkit-transform: rotate(35deg);
  -moz-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px;
}
.gx-timeline-zigzag .gx-timeline-inverted {
  padding-left: 0;
  padding-right: 150px;
}
.gx-timeline-zigzag .gx-timeline-inverted:before {
  -webkit-transform: rotate(-35deg);
  -moz-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  transform: rotate(-35deg);
}
.gx-timeline-zigzag .gx-timeline-item:first-child:before {
  border-left-style: solid;
}
.gx-timeline-zigzag .gx-timeline-item:last-child:before {
  display: none;
}
.gx-timeline-item:last-child:before {
  bottom: 25px;
}
@media screen and (max-width: 991px) {
  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
    margin-top: -60px;
  }
  .gx-timeline-zigzag .gx-timeline-item:before {
    bottom: 0;
  }
  .gx-timeline-zigzag .gx-timeline-item {
    padding-left: 120px;
  }
  .gx-timeline-zigzag .gx-timeline-inverted {
    padding-right: 120px;
    padding-left: 0;
  }
}
@media screen and (max-width: 767px) {
  .gx-timeline-center .gx-timeline-item {
    float: none;
    padding-left: 80px;
    width: auto;
  }
  .gx-timeline-center .gx-timeline-item:before {
    left: 25px;
  }
  .gx-timeline-center .gx-timeline-badge {
    left: 0;
  }
  .gx-timeline-center .gx-timeline-inverted {
    float: none;
    text-align: left;
    padding-right: 0;
  }
  .gx-timeline-center .gx-timeline-inverted:before {
    border-left: solid 2px #e8e8e8;
    border-right: 0 none;
    left: 24px;
    right: auto;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {
    right: auto;
    left: 0;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {
    border-width: 10px 17px 10px 0 !important;
    left: -18px;
    right: auto;
  }
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {
    border-width: 10px 16px 10px 0 !important;
    left: -16px;
    right: auto;
  }
  .gx-timeline-inverted .gx-timeline-panel-header {
    float: none;
  }
  .gx-timeline-inverted .gx-timeline-left {
    float: left;
    margin-left: 0;
    margin-right: 20px;
  }
  .gx-timeline-zigzag .gx-timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible;
  }
  .gx-timeline-zigzag .gx-timeline-item {
    padding-left: 100px;
  }
  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {
    margin-top: 0;
  }
  .gx-timeline-zigzag .gx-timeline-item:before {
    transform: none;
    top: 25px;
    bottom: -25px;
    left: 45px;
  }
  .gx-timeline-zigzag .gx-timeline-item:last-child:before {
    bottom: 0;
  }
  .gx-timeline-zigzag .gx-timeline-inverted:before {
    transform: none;
  }
  .gx-timeline-center .gx-timeline-time,
  .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-bottom: 6px;
  }
  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::before,
  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::after {
    top: 10px;
  }
}
@media screen and (max-width: 399px) {
  .gx-timeline-left {
    float: none;
    margin-right: 0;
  }
  .gx-timeline-right {
    float: none;
    margin-left: 0;
  }
  .gx-timeline-inverted .gx-timeline-left {
    float: none;
    margin-right: 0;
  }
}
/*Tabs Styles*/
.gx-tabs-half .ant-tabs-bar {
  margin-bottom: 0;
}
.gx-tabs-half .ant-tabs-nav {
  display: block;
}
.gx-tabs-half .ant-tabs-nav .ant-tabs-tab {
  margin: 0;
  width: 50%;
  text-align: center;
}
.gx-tabs-half .ant-tabs-nav .ant-tabs-ink-bar {
  width: 50%;
}
.gx-card-tabs .ant-card-head-title {
  text-transform: capitalize;
  font-size: 16px;
}
.gx-card-tabs .ant-card-extra {
  position: relative;
  z-index: 2;
}
.gx-card-tabs .ant-tabs {
  margin-top: -40px;
}
@media screen and (max-width: 575px) {
  .gx-card-tabs .ant-tabs {
    margin-top: 0;
  }
}
.gx-card-tabs .ant-tabs-tab {
  padding-left: 5px;
  padding-right: 5px;
  margin-right: 15px;
}
.gx-card-tabs .ant-tabs-tab-active {
  font-weight: 400;
}
.gx-card-tabs .ant-tabs-nav-container {
  font-size: 16px;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .gx-card-tabs .ant-tabs-nav-container {
    text-align: left;
  }
}
.gx-card-tabs .ant-card-body {
  padding-top: 4px;
}
.gx-card-tabs-right .ant-tabs-nav-container {
  text-align: right;
}
@media screen and (max-width: 575px) {
  .gx-card-tabs-right .ant-tabs-nav-container {
    text-align: left;
  }
}
/* Apps Style */
.gx-app-module {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: -32px -32px 0;
  flex: 1;
}
@media screen and (max-width: 575px) {
  .gx-app-module {
    margin: -20px -15px 0;
  }
}
.gx-container-wrap .gx-app-module {
  margin: 0;
  margin-bottom: 32px;
}
.gx-module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  min-width: 230px;
}
@media screen and (max-width: 991px) {
  .gx-module-side {
    min-width: 260px;
    background-color: #ffffff;
  }
}
.gx-module-side-header {
  padding: 10px;
  min-height: 79px;
  border-bottom: solid 1px #e8e8e8;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  background-color: #fbfbfb;
  color: #545454;
}
@media screen and (max-width: 991px) {
  .gx-module-side-header {
    min-height: 72px;
  }
}
.gx-module-logo {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 20px;
}
.gx-module-logo i {
  font-size: 28px;
  line-height: 18px;
}
.gx-module-user-info,
.gx-module-side-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-module-user-detail {
  font-size: 12px;
}
.gx-module-add-task {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px;
}
.gx-module-add-task .ant-btn {
  margin-bottom: 0;
}
.gx-module-nav {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-module-nav li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-module-nav li .gx-link {
  padding: 5px 29px;
  color: #999999;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  text-decoration: none;
}
.gx-module-nav li .gx-link:hover,
.gx-module-nav li .gx-link:focus {
  color: #000000;
}
.gx-module-nav li .gx-link.active {
  color: #2EB1EF;
}
.gx-module-nav li i {
  margin-right: 16px;
  font-size: 16px;
}
.gx-module-nav li span {
  display: inline-block;
  vertical-align: middle;
}
.gx-module-nav li.gx-module-nav-label {
  padding: 12px 29px;
}
.gx-module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 231px);
}
@media screen and (max-width: 991px) {
  .gx-module-box {
    max-width: 100%;
  }
}
.gx-module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  background-color: #ffffff;
  border-bottom: solid 1px #e8e8e8;
}
@media screen and (max-width: 991px) {
  .gx-module-box-header {
    position: relative;
    min-height: 58px;
    padding: 5px 26px 5px 110px;
  }
}
@media screen and (max-width: 991px) {
  .gx-module-box-header .gx-drawer-btn {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    border-right: solid 1px #e8e8e8;
    height: 58px;
    width: 98px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    font-size: 22px;
    text-align: center;
  }
}
.gx-module-box-header-inner {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
.gx-module-box-header-right {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-left: auto;
}
.gx-module-box-content {
  background-color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-module-box-topbar {
  padding: 8px 28px;
  min-height: 65px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e8e8e8;
}
.gx-module-box-topbar label.ant-checkbox-wrapper {
  margin-right: 10px;
}
.gx-module-box-topbar .ant-dropdown-trigger {
  cursor: pointer;
  margin-right: 10px;
}
.gx-module-box-topbar .ant-dropdown-trigger .icon:before {
  position: relative;
  top: 3px;
}
.gx-module-box-topbar-todo {
  padding-left: 28px;
}
@media screen and (max-width: 991px) {
  .gx-module-box-topbar {
    min-height: 58px;
    padding-left: 28px;
    padding-right: 28px;
  }
}
.gx-module-list-icon {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  padding-right: 10px;
}
.gx-module-list-icon .gx-bar-icon .gx-icon-menu:before {
  top: 3px;
  position: relative;
}
.gx-toolbar-separator {
  border-left: solid 1px #e8e8e8;
  height: 100%;
  width: 1px;
  margin: 0 12px;
}
.gx-module-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.gx-module-list-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  padding: 15px 28px;
  z-index: 5;
  position: relative;
  cursor: pointer;
}
.gx-module-list-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-module-list-item.gx-mail-cell {
  -webkit-align-items: start;
  -ms-align-items: start;
  align-items: start;
}
@media screen and (max-width: 575px) {
  .gx-module-list-item {
    padding-bottom: 10px;
    padding-top: 10px;
  }
}
.gx-module-detail-header {
  margin-bottom: 10px;
}
@media screen and (max-width: 575px) {
  .gx-module-detail-header {
    margin-bottom: 0;
  }
}
.gx-module-list-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 140px);
}
@media screen and (max-width: 575px) {
  .gx-module-list-info {
    max-width: calc(100% - 100px);
  }
}
.gx-module-todo-content {
  position: relative;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-module-todo-content .gx-subject {
  margin-bottom: 5px;
}
.gx-module-todo-right {
  margin-left: 8px;
}
.gx-module-sidenav {
  background-color: #ffffff;
  border-right: solid 1px #e8e8e8;
  position: relative;
  z-index: 9;
}
.gx-module-sidenav .gx-chat-sidenav-main {
  max-width: 300px;
  min-width: 300px;
  width: 90%;
}
.gx-module-date {
  max-width: 160px;
}
.gx-module-detail-item {
  padding: 10px 28px;
}
.gx-task-title {
  font-size: 18px;
}
@media screen and (max-width: 991px) {
  .gx-task-title {
    font-size: 16px;
  }
}
.gx-chat-todo-avatar {
  margin-right: 15px;
}
.gx-module-side-scroll {
  height: calc(100vh - 201px) !important;
}
.framed-layout .gx-module-side-scroll {
  height: calc(100vh - 241px) !important;
}
@media screen and (max-width: 991px) {
  .gx-module-side-scroll {
    height: calc(100vh - 72px) !important;
  }
  .framed-layout .gx-module-side-scroll {
    height: calc(100vh - 72px) !important;
  }
}
.gx-module-side-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-module-content-scroll {
  height: calc(100vh - 266px) !important;
}
.framed-layout .gx-module-content-scroll {
  height: calc(100vh - 306px) !important;
}
@media screen and (max-width: 991px) {
  .gx-module-content-scroll {
    height: calc(100vh - 238px) !important;
  }
  .framed-layout .gx-module-content-scroll {
    height: calc(100vh - 238px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-module-content-scroll {
    height: calc(100vh - 216px) !important;
  }
}
.gx-module-content-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-todo-detail-content-scroll {
  height: calc(100vh - 319px) !important;
}
.framed-layout .gx-todo-detail-content-scroll {
  height: calc(100vh - 359px) !important;
}
@media screen and (max-width: 991px) {
  .gx-todo-detail-content-scroll {
    height: calc(100vh - 291px) !important;
  }
  .framed-layout .gx-todo-detail-content-scroll {
    height: calc(100vh - 291px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-todo-detail-content-scroll {
    height: calc(100vh - 270px) !important;
  }
}
.gx-todo-detail-content-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-loader-view {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.gx-loader-view .ant-spin {
  margin: 0;
}
.gx-app-module .gx-loader-view {
  height: calc(100vh - 266px) !important;
}
.framed-layout .gx-app-module .gx-loader-view {
  height: calc(100vh - 306px) !important;
}
@media screen and (max-width: 991px) {
  .gx-app-module .gx-loader-view {
    height: calc(100vh - 238px) !important;
  }
  .framed-layout .gx-app-module .gx-loader-view {
    height: calc(100vh - 238px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-app-module .gx-loader-view {
    height: calc(100vh - 244px) !important;
  }
}
.gx-chat-module .gx-loader-view {
  height: calc(100vh - 122px) !important;
}
.framed-layout .gx-chat-module .gx-loader-view {
  height: calc(100vh - 162px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-chat-module .gx-loader-view {
    height: calc(100vh - 122px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-chat-module .gx-loader-view {
    height: calc(100vh - 100px) !important;
  }
}
.gx-module-default {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px;
}
.gx-no-content-found {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
}
.gx-task-des,
.gx-task-input {
  padding-left: 0;
}
/*Mails Apps Styles*/
.gx-module-box-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.gx-module-box-column,
.gx-module-list-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-mail-list-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-left: 10px;
  max-width: calc(100% - 150px);
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
@media screen and (max-width: 575px) {
  .gx-mail-list-info {
    max-width: 100%;
    margin-top: 10px;
    padding-left: 0;
  }
}
.gx-mail-user-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-left: 10px;
}
.gx-mail-user-info .gx-avatar {
  margin-right: 10px;
}
.gx-mail-user-info .gx-badge {
  margin-bottom: 0;
}
.gx-mail-user-des {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-bottom: 3px;
}
.gx-mail-user-des .gx-time,
.gx-mail-user-des .gx-icon-btn {
  margin-left: auto;
}
.gx-mail-detail-inner {
  padding: 24px;
}
@media screen and (max-width: 991px) {
  .gx-mail-detail-inner {
    padding-right: 28px;
    padding-left: 28px;
  }
}
.gx-mail-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media screen and (max-width: 498px) {
  .gx-mail-header {
    display: block;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-mail-header-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-mail-header-content .gx-subject {
  margin-bottom: 5px;
}
.gx-show-link {
  cursor: pointer;
  margin-bottom: 8px;
  color: #2EB1EF;
}
.gx-show-detail {
  margin-bottom: 12px;
}
.gx-module-list-content .gx-subject {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-module-list-content .gx-message {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: #8d8d8d;
  font-size: 13px;
}
.gx-module-list-content .gx-message p {
  margin-bottom: 8px;
}
.gx-size {
  margin: 5px 0;
}
.gx-sender-name {
  margin-right: 0;
  font-weight: 500;
  font-size: 15px;
}
.gx-send-subject {
  width: calc(100% - 220px);
}
@media screen and (max-width: 575px) {
  .gx-send-subject {
    width: calc(100% - 180px);
    margin-right: 6px;
  }
}
.gx-mail-header-actions {
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  justify-content: flex-end;
  min-width: 100px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-mail-header-actions .icon-btn:not(:last-child) {
  margin-right: 3px;
}
@media screen and (max-width: 498px) {
  .gx-mail-header-actions {
    -webkit-justify-content: flex-start;
    -ms-justify-content: flex-start;
    justify-content: flex-start;
    min-width: 10px;
  }
}
.gx-attachment-block {
  position: relative;
}
.gx-attachment-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -10px;
}
@media screen and (max-width: 575px) {
  .gx-attachment-row {
    margin: 0 -5px;
  }
}
.gx-attachment-col {
  padding: 0 10px;
}
.gx-attachment-col img {
  width: 80px;
}
.gx-attachment-col .size {
  padding-top: 5px;
}
@media screen and (max-width: 575px) {
  .gx-attachment-col {
    padding: 0 5px;
  }
}
@media screen and (max-width: 575px) {
  .gx-mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-right: 0 none;
  }
  .gx-mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
  }
}
/*Chat Apps Styles*/
.gx-chat-module {
  position: relative;
}
.gx-chat-module-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #fafafa;
  position: relative;
  width: 100%;
}
.gx-chat-sidenav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-right: solid 1px #e8e8e8;
}
.gx-chat-sidenav-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: #fbfbfb;
  border-bottom: solid 1px #e8e8e8;
}
.gx-chat-user-hd {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 25px;
}
.gx-chat-search-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.gx-chat-avatar {
  min-width: 50px;
}
.gx-chat-user-row .gx-chat-avatar {
  padding: 0 5px;
  min-width: 10px;
}
.gx-chat-user-hd .gx-chat-avatar {
  cursor: pointer;
}
.gx-chat-sidenav-scroll {
  height: calc(100vh - 295px) !important;
}
.framed-layout .gx-chat-sidenav-scroll {
  height: calc(100vh - 335px) !important;
}
@media screen and (max-width: 991px) {
  .gx-chat-sidenav-scroll {
    height: calc(100vh - 175px) !important;
  }
  .framed-layout .gx-chat-sidenav-scroll {
    height: calc(100vh - 175px) !important;
  }
}
.gx-chat-sidenav-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-sidenav-scroll-tab-1,
.gx-chat-sidenav-scroll-tab-2 {
  height: calc(100vh - 320px) !important;
}
.framed-layout .gx-chat-sidenav-scroll-tab-1,
.framed-layout .gx-chat-sidenav-scroll-tab-2 {
  height: calc(100vh - 360px) !important;
}
@media screen and (max-width: 991px) {
  .gx-chat-sidenav-scroll-tab-1,
  .gx-chat-sidenav-scroll-tab-2 {
    height: calc(100vh - 198px) !important;
  }
  .framed-layout .gx-chat-sidenav-scroll-tab-1,
  .framed-layout .gx-chat-sidenav-scroll-tab-2 {
    height: calc(100vh - 198px) !important;
  }
}
.gx-chat-sidenav-scroll-tab-1 > div:first-child,
.gx-chat-sidenav-scroll-tab-2 > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-list-scroll {
  height: calc(100vh - 268px) !important;
}
.framed-layout .gx-chat-list-scroll {
  height: calc(100vh - 308px) !important;
}
@media screen and (max-width: 1199px) {
  .gx-chat-list-scroll {
    height: calc(100vh - 242px) !important;
  }
  .framed-layout .gx-chat-list-scroll {
    height: calc(100vh - 282px) !important;
  }
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-chat-list-scroll {
    height: calc(100vh - 242px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-chat-list-scroll {
    height: calc(100vh - 220px) !important;
  }
}
.gx-chat-list-scroll > div:first-child {
  overflow-y: scroll !important;
}
.gx-chat-sidenav-content {
  background-color: #ffffff;
}
.gx-chat-sidenav-title {
  padding: 10px 16px;
  font-size: 14px;
  color: #1890ff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
@media screen and (max-width: 1199px) {
  .gx-chat-sidenav-title {
    font-size: 16px;
  }
}
@media screen and (max-width: 767px) {
  .gx-chat-sidenav-title {
    font-size: 15px;
  }
}
.gx-chat-tabs-header {
  background-color: #fbfbfb !important;
}
.gx-chat-user {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-chat-user.gx-chat-user-center {
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-chat-user.gx-chat-user-center .gx-chat-avatar {
  margin-left: auto;
}
.gx-chat-user-item {
  padding: 16px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px;
}
.gx-chat-user-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-chat-user-item.active,
.gx-chat-user-item:hover {
  background-color: #f0fdff;
}
.gx-chat-user-row {
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-chat-info {
  max-width: calc(100% - 80px);
  padding: 0 5px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-chat-info p {
  margin-bottom: 0;
}
.gx-chat-info .h4 {
  display: block;
  margin-bottom: 3px;
}
.gx-chat-info-des {
  color: #595959;
  font-size: 13px;
}
.gx-chat-contact-col {
  max-width: calc(100% - 50px);
  padding: 0 5px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-chat-contact-col p {
  margin-bottom: 0;
}
.gx-chat-contact-col .h4 {
  display: block;
  margin-bottom: 3px;
}
.gx-chat-date {
  padding: 0 5px;
  text-align: right;
}
.gx-fs-80 {
  font-size: 80px !important;
  line-height: 80px !important;
}
.gx-comment-box .gx-fs-80 {
  text-align: center;
  margin-bottom: 12px;
}
@media screen and (max-width: 575px) {
  .gx-fs-80 {
    font-size: 60px !important;
    line-height: 60px !important;
  }
}
.gx-comment-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: calc(100vh - 122px) !important;
}
.framed-layout .gx-comment-box {
  height: calc(100vh - 162px) !important;
}
@media screen and (max-width: 991px) {
  .framed-layout .gx-comment-box {
    height: calc(100vh - 122px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-comment-box {
    height: calc(100vh - 100px) !important;
  }
}
.gx-chat-box {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2;
}
.gx-chat-main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.gx-chat-main-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e8e8e8;
  padding: 16px;
  background-color: #ffffff;
  width: 100%;
}
@media screen and (max-width: 1199px) {
  .gx-chat-main-header {
    padding: 8px 16px;
  }
}
@media screen and (max-width: 991px) {
  .gx-chat-main-header {
    padding: 8px 30px;
  }
}
.gx-chat-main-header-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-right: auto;
}
.gx-chat-contact-name {
  font-size: 20px;
  font-weight: 500;
}
@media screen and (max-width: 1199px) {
  .gx-chat-contact-name {
    font-size: 16px;
  }
}
@media screen and (max-width: 767px) {
  .gx-chat-contact-name {
    font-size: 15px;
  }
}
.gx-chat-main-footer {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e8e8e8;
  padding: 6px 16px;
  background-color: #ffffff;
  width: 100%;
}
.gx-chat-main-footer .gx-form-group {
  margin-bottom: 0;
}
.gx-chat-item {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 16px;
}
@media screen and (max-width: 991px) {
  .gx-chat-item {
    padding: 16px 30px;
  }
}
.gx-chat-item .gx-bubble-block {
  width: calc(100% - 40px);
}
.gx-chat-item .gx-bubble {
  padding: 12px 15px;
  background-color: #ffffff;
  -webkit-border-radius: 20px 20px 20px 0px;
  -moz-border-radius: 20px 20px 20px 0px;
  border-radius: 20px 20px 20px 0px;
  position: relative;
  margin-left: 16px;
  max-width: 600px;
  border: solid 1px #d9d9d9;
  display: inline-block;
}
.gx-chat-item.gx-flex-row-reverse .gx-bubble-block {
  text-align: right;
}
.gx-chat-item.gx-flex-row-reverse .gx-bubble {
  margin-right: 16px;
  margin-left: 0;
  background-color: #f0fdff;
  -webkit-border-radius: 20px 20px 0 20px;
  -moz-border-radius: 20px 20px 0 20px;
  border-radius: 20px 20px 0 20px;
  text-align: left;
}
.gx-chat-item .ant-avatar {
  display: block;
}
.gx-chat-btn {
  font-size: 38px !important;
  margin-right: 20px;
}
textarea.gx-chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-chat-sent {
  min-width: 40px;
  line-height: 40px;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
}
.gx-last-message-time {
  font-size: 11px;
  color: #8c8c8c;
}
@media screen and (max-width: 1199px) {
  .gx-chat-main-header .gx-size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px;
  }
  .gx-chat-main-header button {
    margin-bottom: 0;
  }
  .gx-chat-main-header-info .gx-status-pos {
    max-width: 50px;
  }
}
@media screen and (max-width: 575px) {
  .gx-module-default h1 {
    font-size: 17px;
  }
}
/*Contact Apps Styles*/
.gx-contact-item {
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 8px 28px;
}
.gx-contact-item:not(:last-child) {
  border-bottom: solid 1px #e8e8e8;
}
.gx-dragndrop-item {
  padding: 24px 16px;
}
.gx-dragndrop-item .gx-draggable-icon {
  margin-left: -16px;
}
@media screen and (max-width: 575px) {
  .gx-dragndrop-item {
    padding-right: 5px;
  }
}
.gx-contact-list-info {
  padding-left: 10px;
}
.gx-contact-list-info .gx-email {
  word-break: break-all;
}
.gx-contact-list-info .gx-toolbar-separator {
  display: inline-block;
}
@media screen and (max-width: 575px) {
  .gx-contact-list-info .gx-toolbar-separator {
    display: none;
  }
}
@media screen and (max-width: 575px) {
  .gx-contact-list-info {
    padding-left: 0;
    max-width: calc(100% - 50px);
  }
  .gx-contact-list-info .gx-job-title {
    display: none;
  }
}
.gx-module-contact-content {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-module-contact-right {
  margin-left: 8px;
}
.gx-contact-name {
  font-size: 15px;
}
.gx-draggable-icon {
  cursor: all-scroll;
  color: #8c8c8c;
}
.gx-draggable-icon:hover,
.gx-draggable-icon:focus,
.gx-draggable-icon:active {
  cursor: all-scroll;
  color: #262626;
}
.gx-module-side-nav {
  padding: 20px 0;
}
.gx-modal-box-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-modal-box-row .gx-modal-box-avatar {
  -webkit-order: 2;
  -ms-order: 2;
  order: 2;
  margin-left: 16px;
}
.gx-modal-box-row .gx-modal-box-avatar .ant-avatar {
  width: 120px;
  height: 120px;
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row .gx-modal-box-avatar {
    -webkit-order: 1;
    -ms-order: 1;
    order: 1;
    margin-left: 0;
    margin-bottom: 16px;
    text-align: center;
  }
}
.gx-modal-box-row .gx-modal-box-form-item {
  -webkit-order: 1;
  -ms-order: 1;
  order: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row .gx-modal-box-form-item {
    -webkit-order: 2;
    -ms-order: 2;
    order: 2;
  }
}
@media screen and (max-width: 575px) {
  .gx-modal-box-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
.gx-dragndrop-actions {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
/* Calendar Apps Style */
.gx-rbc-calendar {
  overflow: hidden;
  padding-bottom: 32px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
@media screen and (max-width: 575px) {
  .gx-rbc-calendar {
    margin-bottom: 20px;
  }
}
.gx-rbc-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: 100%;
}
.rbc-event {
  background-color: #2EB1EF;
}
.rbc-event.rbc-selected {
  background-color: #1c8dc9;
}
.rbc-slot-selection {
  background-color: #abedff;
}
.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #ffffff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  background-color: #82e0ff;
  border-color: #2EB1EF;
}
.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus,
.rbc-toolbar button:focus,
.rbc-toolbar button:hover {
  color: #ffffff;
  background-color: #82e0ff;
  border-color: #2EB1EF;
}
.rbc-month-row {
  min-height: 100px;
}
.rbc-event {
  min-height: 50px;
}
.rbc-btn-group button {
  cursor: pointer;
}
@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
}
@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px;
  }
  .rbc-toolbar button {
    padding: 5px 10px;
  }
}
/* Calendar Components Style */
.gx-com-calendar .ant-fullcalendar-header .ant-select {
  margin-left: 8px;
  margin-bottom: 8px;
}
@media screen and (max-width: 349px) {
  .gx-com-calendar {
    margin: 0 -20px;
  }
}
.gx-com-calendar-card {
  border: solid 1px #e8e8e8;
  max-width: 300px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
@media screen and (max-width: 349px) {
  .gx-com-calendar-card .gx-com-calendar {
    margin: 0;
  }
}
.gx-profileon {
  margin-bottom: 20px;
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.gx-profileon-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.9)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
}
.gx-profileon-content * {
  color: #ffffff;
}
.gx-agents-list .gx-profileon-content {
  padding: 10px;
}
.gx-profileon-thumb {
  position: relative;
}
.gx-profileon-thumb > img {
  width: 100%;
}
.gx-profileon-thumb-htctrcrop {
  overflow: hidden;
  padding-bottom: 80%;
  position: relative;
}
.gx-profileon-thumb-htctrcrop > img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  width: 100%;
}
.gx-profileon-title {
  margin-bottom: 5px;
}
.gx-agents-list .gx-profileon {
  margin-bottom: 0;
}
.gx-follower {
  border-bottom: solid 1px #d9d9d9;
  padding-bottom: 20px;
  margin-bottom: 15px;
}
.gx-follower-list {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style: none;
  padding-left: 0;
  margin: 0 -5px;
}
.gx-profile-banner .gx-follower-list {
  margin: 0 -20px;
}
.gx-follower-list li {
  color: #8c8c8c;
  font-size: 14px;
  padding: 0 5px;
  width: 33.33%;
}
.gx-profile-banner .gx-follower-list li {
  color: #ffffff;
  padding: 0 20px;
  width: auto;
}
.gx-follower-list li:not(:first-child) {
  border-left: solid 1px #d9d9d9;
}
.gx-profile-banner .gx-follower-list li:not(:first-child) {
  border-left-color: #ffffff;
}
.gx-follower-title {
  display: block;
  color: #262626;
  font-size: 14px;
}
.gx-profile-banner .gx-follower-title {
  color: #ffffff;
}
.gx-wall-scroll {
  height: calc(100vh - 154px) !important;
}
.framed-layout .gx-wall-scroll {
  height: calc(100vh - 192px) !important;
}
@media screen and (max-width: 991px) {
  .gx-wall-scroll {
    height: calc(100vh - 124px) !important;
  }
  .framed-layout .gx-wall-scroll {
    height: calc(100vh - 124px) !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-wall-scroll {
    height: calc(100vh - 132px) !important;
  }
}
.gx-wall-postlist {
  padding: 5px;
}
.gx-entry-sec {
  position: relative;
  margin-bottom: 20px;
}
.ant-card .gx-entry-sec,
.gx-card .gx-entry-sec {
  margin-bottom: 0;
}
.gx-entry-title {
  border-bottom: solid 1px #d9d9d9;
  padding-bottom: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  position: relative;
}
.gx-entry-title:before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  z-index: 1;
  height: 3px;
  width: 42px;
  background-color: #2EB1EF;
}
.ant-card .gx-entry-title:before,
.gx-card .gx-entry-title:before {
  display: none;
}
.ant-card .gx-entry-title,
.gx-card .gx-entry-title {
  border-bottom: 0 none;
  margin-bottom: 15px;
  padding-bottom: 0;
}
.gx-fnd-list {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -5px 20px;
}
.gx-fnd-list li {
  width: 33.33%;
  padding: 0 5px;
}
@media (max-width: 399px) {
  .gx-fnd-list li {
    width: 50%;
  }
}
.gx-user-fnd {
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.gx-user-fnd > img {
  width: 100%;
}
.gx-user-fnd-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(rgba(0, 0, 0, 0.95)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));
  color: #ffffff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-user-fnd-content h6 {
  color: #ffffff;
  -ms-flex-item-align: end;
  align-self: flex-end;
  margin-bottom: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-user-fnd-content .ant-badge {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  margin: 0;
  width: 10px;
  height: 10px;
  display: block;
}
.gx-user-fnd-content .ant-badge-status-dot {
  width: 10px;
  height: 10px;
  display: block;
  top: 0;
  border: solid 1px #ffffff;
}
.gx-gallery-list {
  list-style: none;
  padding-left: 0;
  margin: 0 -0.5px 15px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-gallery-list li {
  padding: 0 0.5px;
  margin-bottom: 1px;
  width: 33.33%;
}
@media (max-width: 399px) {
  .gx-gallery-list li {
    width: 50%;
  }
}
.gx-gallery-list li > img {
  width: 100%;
}
.gx-gallery-thumb {
  position: relative;
  cursor: pointer;
}
.gx-gallery-thumb:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.01);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.01)), to(rgba(0, 0, 0, 0.95)));
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));
}
.gx-gallery-thumb-content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 10px;
  color: #ffffff;
}
.gx-gallery-thumb-content h6 {
  color: #ffffff;
  margin-bottom: 0;
  font-size: 10px;
}
.gx-wall-user-info {
  margin-bottom: 6px;
}
.gx-wall-user-title {
  margin-bottom: 4px;
}
.gx-gallery-item {
  position: relative;
  margin-bottom: 15px;
}
.gx-gallery-item img {
  width: 100%;
  cursor: pointer;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.gx-gallery-item-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  color: #ffffff;
}
.gx-gallery-grid {
  margin: 0 -5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gx-gallery-grid .gx-gallery-item {
  padding: 0 5px;
}
.gx-gallery-grid .gx-gallery-item-content {
  left: 5px;
  right: 5px;
}
.gx-gallery-2 .gx-gallery-item,
.gx-gallery-4 .gx-gallery-item,
.gx-gallery-4-more .gx-gallery-item {
  width: 50%;
}
.gx-gallery-3 .gx-gallery-item {
  width: 33.33%;
}
.gx-wall-comment-box {
  padding: 0 30px;
}
@media screen and (max-width: 1199px) {
  .gx-wall-comment-box {
    padding: 0 20px;
  }
}
@media screen and (max-width: 1100px) {
  .gx-wall-comment-box {
    padding: 0;
  }
}
@media screen and (max-width: 991px) {
  .gx-wall-comment-box {
    padding: 0 30px;
  }
}
@media screen and (max-width: 767px) {
  .gx-wall-comment-box {
    padding-right: 0;
    padding-left: 15px;
  }
}
.gx-profile-banner {
  padding: 32px;
  padding-bottom: 88px;
  margin: -32px;
  margin-bottom: -58px;
  background-color: #003366;
  color: #ffffff;
  position: relative;
}
@media screen and (max-width: 575px) {
  .gx-profile-banner {
    padding: 20px 15px;
    padding-bottom: 83px;
    margin: -20px -15px;
    margin-bottom: -58px;
  }
}
.gx-profile-banner:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.gx-profile-banner > div {
  position: relative;
  z-index: 2;
}
.gx-profile-banner-top {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  margin-bottom: 40px;
}
@media (max-width: 575px) {
  .gx-profile-banner-top {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-bottom: 25px;
  }
}
.gx-profile-banner-top-left {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media (max-width: 575px) {
  .gx-profile-banner-top-left {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-bottom: 25px;
  }
}
.gx-profile-banner-avatar {
  margin-right: 1.5rem;
}
@media (max-width: 575px) {
  .gx-profile-banner-avatar {
    margin-bottom: 8px;
    margin-right: 0;
  }
}
.gx-profile-banner-top-right {
  text-align: center;
  margin-left: auto;
}
@media (max-width: 575px) {
  .gx-profile-banner-top-right {
    margin-left: 0;
  }
}
.gx-profile-banner-bottom {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media (max-width: 575px) {
  .gx-profile-banner-bottom {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .gx-profile-banner-bottom .gx-tab-list {
    margin-bottom: 10px;
  }
}
.gx-profile-banner h1,
.gx-profile-banner h2,
.gx-profile-banner h3,
.gx-profile-banner h4,
.gx-profile-banner h5,
.gx-profile-banner h6,
.gx-profile-banner .h1,
.gx-profile-banner .h2,
.gx-profile-banner .h3,
.gx-profile-banner .h4,
.gx-profile-banner .h5,
.gx-profile-banner .h6 {
  color: #ffffff;
}
.gx-profile-banner .gx-link {
  color: #ffffff;
}
.gx-profile-banner .gx-link:hover,
.gx-profile-banner .gx-link:focus {
  color: #089265;
}
.gx-profile-content {
  position: relative;
  z-index: 2;
}
.gx-profile-setting {
  margin-left: auto;
}
@media (max-width: 575px) {
  .gx-profile-setting {
    margin-left: 0;
  }
}
@media (max-width: 575px) {
  .gx-profile-content-right {
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: -ms-flex !important;
    display: flex !important;
    -webkit-flex-direction: row !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
    -webkit-flex-wrap: wrap !important;
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
    -webkit-align-items: center !important;
    -ms-align-items: center !important;
    align-items: center !important;
  }
  .gx-profile-content-right .gx-text-truncate {
    width: auto;
    margin-left: auto;
  }
}
.gx-pro-contact-list:not(:last-child) {
  margin-bottom: 1rem;
}
/*Callout Styles*/
/*Different size images set in Equal block height and width*/
.gx-thumb-equal,
.gx-grid-thumb-equal {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden;
}
.gx-thumb-cover,
.gx-grid-thumb-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}
.gx-thumb-cover-img,
.gx-grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
}
.gx-product-image .gx-grid-thumb-equal {
  padding-bottom: 82%;
}
/*Product listing page styles*/
.gx-product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  text-align: right;
}
.gx-product-row.even {
  text-align: left;
}
.gx-product-col {
  order: 1;
  width: 50%;
}
.odd .gx-product-thumb {
  order: 2;
}
.gx-product-content {
  padding: 20px 55px;
}
.gx-product-content p {
  margin-bottom: 10px;
}
.gx-product-row .gx-grid-thumb-equal {
  padding-bottom: 69%;
}
.gx-product-thumb img {
  width: 100%;
}
.gx-product-content h4 {
  margin-bottom: 25px;
}
@media screen and (max-width: 1230px) {
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 71%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    text-align: center;
  }
  .gx-product-row.even {
    text-align: center;
  }
  .gx-product-content h4 {
    margin-bottom: 10px;
  }
  .gx-product-content {
    padding: 20px 35px;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 100%;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 40%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: right;
  }
  .gx-product-row.even {
    text-align: left;
  }
  .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 120%;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 50%;
  }
  .odd .gx-product-thumb {
    order: 2;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 70%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    text-align: center;
  }
  .gx-product-row.even {
    text-align: center;
  }
  .gx-product-row:last-child .gx-product-col {
    padding-bottom: 0;
  }
  .gx-product-row:last-child .ant-btn {
    margin-bottom: 0;
  }
  .gx-product-content {
    padding: 20px 0;
  }
  .gx-product-col,
  .odd .gx-product-thumb {
    order: 1;
    width: 100%;
  }
  .gx-product-row .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
  .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
}
/*E-commerce Styles*/
.gx-product-item {
  overflow: hidden;
  background: #fff;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  margin-bottom: 32px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
}
@media screen and (max-width: 575px) {
  .gx-product-item {
    margin-bottom: 20px;
  }
}
.gx-product-body {
  padding: 24px;
}
.gx-product-body + .gx-product-footer {
  padding-top: 0;
}
.gx-product-body :last-child {
  margin-bottom: 0;
}
.gx-product-image > img {
  width: 100%;
}
.gx-product-footer {
  padding: 24px;
  padding-bottom: 15px;
}
.gx-product-horizontal {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-product-horizontal .gx-product-image {
  width: 25%;
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-image {
    width: 33.33333%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-image {
    width: 25%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-image {
    width: 100%;
  }
}
.gx-product-horizontal .gx-product-body {
  width: 53%;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-body {
    width: 55%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-body {
    width: 41.66667%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-body {
    width: 50%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-body {
    width: 100%;
  }
}
.gx-product-horizontal .gx-product-body + .gx-product-footer {
  padding-top: 24px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-body + .gx-product-footer {
    padding-top: 0;
  }
}
.gx-product-horizontal .gx-product-footer {
  width: 22%;
  text-align: center;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-footer {
    width: 20%;
  }
}
.gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {
  margin-left: 8px;
  margin-right: 8px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {
    margin-left: 0;
  }
}
.gx-product-horizontal .gx-product-footer .ant-btn:last-child {
  margin-left: 8px;
  margin-right: 8px;
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-footer {
    width: 100%;
    text-align: left;
  }
}
.gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
  padding-bottom: 82%;
}
@media screen and (min-width: 1400px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 55%;
  }
}
@media screen and (max-width: 1199px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 80%;
  }
}
@media screen and (max-width: 1080px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 90%;
  }
}
@media screen and (max-width: 1000px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 110%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 80%;
  }
}
@media screen and (max-width: 991px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 88%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 128%;
  }
}
@media screen and (max-width: 849px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 110%;
  }
}
@media screen and (max-width: 767px) {
  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {
    padding-bottom: 44%;
  }
}
.gx-product-vertical {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: calc(100% - 32px);
}
@media screen and (max-width: 575px) {
  .gx-product-vertical {
    height: calc(100% - 20px);
  }
}
.gx-product-vertical .gx-product-body {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-product-title {
  font-size: 20px;
}
/*Pricing Tables Styles*/
.gx-price-tables {
  position: relative;
}
.gx-package {
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  height: calc(100% - 15px);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
  -ms-transform: scale(0.95);
  -o-transform: scale(0.95);
  transform: scale(0.95);
}
.gx-package:hover,
.gx-package:focus,
.gx-package:active {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);
}
.gx-pt-dark .gx-package:hover,
.gx-pt-dark .gx-package:focus,
.gx-pt-dark .gx-package:active {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.gx-pt-classic .gx-package {
  border: 0 none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.gx-package.gx-highlight {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  z-index: 2;
}
.gx-package-header {
  padding: 30px;
  text-align: center;
}
.gx-package-header > .gx-price {
  display: inline-block;
  font-size: 36px;
  font-weight: 500;
  margin-left: 0;
  margin-bottom: 12px;
  color: #ffffff;
}
.gx-package-header > .gx-price > i {
  display: inline-block;
  margin-right: 6px;
  font-weight: bold;
}
.gx-package-header h5 {
  color: inherit;
}
.gx-package-header.gx-text-black > .gx-price {
  color: #595959 !important;
}
@media only screen and (max-width: 991px) {
  .gx-package-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.gx-package-body {
  padding: 50px 30px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  .gx-package-body {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.gx-package-items {
  list-style: none;
  font-size: 14px;
  margin: 0 0 20px;
  padding-left: 0;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-package-items li {
  margin-bottom: 16px;
  zoom: 1;
  line-height: inherit;
}
.gx-package-items li::before,
.gx-package-items li::after {
  display: table;
  content: '';
}
.gx-package-items li::after {
  clear: both;
}
.gx-package-items li::before,
.gx-package-items li::after {
  display: table;
  content: '';
}
.gx-package-items li::after {
  clear: both;
}
.gx-package-items li i {
  float: left;
  min-width: 20px;
  margin-right: 16px;
  line-height: inherit;
}
.gx-package-items li span {
  display: block;
  overflow: hidden;
}
.gx-package-footer {
  padding-top: 30px;
}
.gx-package-footer .ant-btn {
  text-transform: capitalize;
  border: 0 none;
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .gx-package:hover,
  .gx-package:focus,
  .gx-package:active,
  .gx-package.gx-highlight {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}
.gx-text-black .gx-text-white {
  color: #595959 !important;
}
.gx-pt-circle .gx-package-header {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-pt-circle .gx-package-header .gx-price {
  margin-top: 30px;
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header .gx-price {
    font-size: 26px;
    margin-top: 12px;
    margin-bottom: 6px;
  }
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header .gx-letter-spacing-base {
    letter-spacing: 1px;
  }
}
@media only screen and (max-width: 991px) {
  .gx-pt-circle .gx-package-header {
    height: 150px;
    width: 150px;
  }
}
/*Login & Auth flow Styles*/
.login-container,
.auth-layout-container {
  background-color: #EDF5F7;
  height: 100%;
}
.dark-theme .login-container,
.dark-theme .auth-layout-container {
  background-color: #051B30;
}
.auth-layout-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-app-login-wrap {
  height: 100%;
  display: flex;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  gap: 15px;
}
@media screen and (min-width: 1700px) {
  .gx-app-login-wrap {
    max-width: 1600px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 768px) {
  .gx-app-login-wrap {
    flex-direction: column;
    height: auto;
  }
}
.gx-app-graphic-content {
  flex: 1;
}
@media screen and (max-width: 768px) {
  .gx-app-graphic-content {
    max-width: 325px;
  }
}
.gx-app-login-content {
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  gap: 40px;
}
.gx-app-login-content .ant-form {
  width: 400px;
  padding: 0 15px;
}
.gx-app-login-content .ant-form-item-label {
  line-height: 32px;
  width: 100%;
  text-align: left;
}
.gx-app-login-content .ant-form-item-label label {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
@media screen and (min-width: 1700px) {
  .gx-app-login-content .ant-form-item-label label {
    font-size: 18px;
  }
}
.gx-app-login-content .ant-form-item-label label a {
  color: #9BA4AC;
  font-size: 14px;
}
@media screen and (min-width: 1700px) {
  .gx-app-login-content .ant-form-item-label label a {
    font-size: 16px;
  }
}
.gx-app-login-content .ant-form-item-label label:before,
.gx-app-login-content .ant-form-item-label label:after {
  display: none;
}
.gx-app-login-content .ant-input {
  min-height: 40px;
  background-color: transparent;
}
@media screen and (min-width: 1600px) {
  .gx-app-login-content .ant-input {
    min-height: 50px;
    font-size: 16px;
  }
}
.gx-app-login-content .ant-input:focus {
  box-shadow: none;
}
.gx-app-login-content .gx-btn {
  height: auto;
}
.gx-app-login-content .ant-form-item-control-wrapper {
  width: 100%;
}
.gx-app-login-content .ant-form-item-control-wrapper .ant-btn-primary {
  font-size: 13px;
  font-weight: 500;
  padding: 0px 10px;
}
@media screen and (min-width: 1600px) {
  .gx-app-login-content .ant-form-item-control-wrapper .ant-btn-primary {
    font-size: 16px;
  }
}
.gx-app-login-content .ant-form-item-children {
  display: block;
}
.gx-app-login-content .copy {
  color: #9BA4AC;
  margin-bottom: 0px;
}
.gx-app-login-content p {
  color: #595959;
}
.authenticator-heading {
  font-size: 23px;
  color: #051B30;
  margin: 0;
}
.dark-theme .authenticator-heading {
  color: #ffffff;
}
.verify-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
}
.verify-container .ant-btn-primary {
  max-width: 440px;
  font-weight: 600;
  font-size: 16px;
}
.verify-container .verify-container-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 425px;
  max-width: 440px;
  min-height: 275px;
  padding: 25px 20px;
  background: #ffffff;
  color: white;
  gap: 15px;
  border-radius: 16px;
  margin-bottom: 50px;
}
.dark-theme .verify-container .verify-container-block {
  background: #0B2B41;
}
.verify-container .verify-container-block .authenticator-qr {
  max-width: 200px;
}
@media screen and (min-width: 1700px) {
  .verify-container .verify-container-block .authenticator-qr {
    max-width: 250px;
  }
}
.verify-container .verify-container-block .label-otp {
  font-weight: 500;
  font-size: 18px;
  color: #606E7B;
}
.dark-theme .verify-container .verify-container-block .label-otp {
  color: #ffffff;
}
.verify-container .verify-container-block.forgot-password {
  padding: 15px 20px;
}
.verify-container .verify-container-block.forgot-password .ant-form-item {
  margin-bottom: 10px;
}
.verify-container .verify-container-block .ant-select .ant-select-selection {
  height: 42px;
}
.verify-container .verify-container-block .ant-select .ant-select-selection .ant-select-selection__rendered {
  line-height: 42px;
}
.verify-container .verify-container-block p {
  color: #606E7B;
}
.dark-theme .verify-container .verify-container-block p {
  color: #ffffff;
}
.verify-container .clarity-submit-button {
  margin-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  color: #051B30;
  font-weight: 500;
}
.dark-theme .verify-container .clarity-submit-button {
  color: #ffffff;
}
@media screen and (min-width: 1700px) {
  .verify-container .clarity-submit-button {
    margin-top: 80px;
  }
}
.user-role-card {
  min-height: 290px;
  min-width: 280px;
  background-color: #ffffff !important;
  color: #FFFFFF;
  border-radius: 10px;
  margin: 0;
  border: 0.5px solid #D8DFE5;
}
.dark-theme .user-role-card {
  background-color: #0B2B41 !important;
  border: 0.5px solid #0B2B41;
}
.user-role-card svg path {
  fill: #BDBDBD;
  stroke: #BDBDBD;
}
.dark-theme .user-role-card svg path {
  fill: #214A66;
  stroke: #214A66;
}
.user-role-card svg.receptionist path {
  fill: #BDBDBD;
  stroke: #BDBDBD;
}
.dark-theme .user-role-card svg.receptionist path {
  fill: #214A66;
  stroke: #214A66;
}
.role-sub-container {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.user-card-title {
  font-weight: 500;
  font-size: 22px;
  margin: 0;
  color: #051B30;
}
.dark-theme .user-card-title {
  color: #ffffff;
}
.user-role-card.selected,
.user-role-card:hover {
  border-color: #0590DE;
}
.dark-theme .user-role-card.selected,
.dark-theme .user-role-card:hover {
  border-color: #46baf1;
}
.user-role-card.selected .role-sub-container svg path,
.user-role-card:hover .role-sub-container svg path {
  fill: #0590DE;
  stroke: #0590DE;
}
.dark-theme .user-role-card.selected .role-sub-container svg path,
.dark-theme .user-role-card:hover .role-sub-container svg path {
  fill: #DCDCDC;
  stroke: #DCDCDC;
}
.dark-theme .gx-app-login-content .ant-input {
  background-color: transparent;
  border-color: #20313e;
}
.dark-theme .gx-app-login-content .ant-input:hover,
.dark-theme .gx-app-login-content .ant-input:focus {
  border-color: #2b4d66 !important;
}
.dark-theme .gx-app-login-content .ant-form-item-label label {
  color: #ffffff;
}
.dark-theme .ant-checkbox-wrapper {
  color: #9BA4AC;
}
.dark-theme .gx-signin-form .ant-checkbox-inner {
  background-color: transparent;
  border: 1px solid #0590DE;
}
.dark-theme .gx-signin-form .ant-checkbox-checked .ant-checkbox-inner {
  background-color: transparent;
  border: 1px solid #0590DE;
}
.gx-app-social-block {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
.gx-app-social-block .gx-social-link,
.gx-app-social-block .gx-social-link li {
  margin: 0;
}
.gx-app-social-block .gx-social-link span {
  border: solid 1px #2EB1EF;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  color: #2EB1EF;
}
.gx-app-social-block .gx-social-link span:hover,
.gx-app-social-block .gx-social-link span:focus {
  color: #ffffff;
  background-color: #2EB1EF;
}
.gx-app-social-block p {
  margin-bottom: 0;
}
/*Dashboard Styles*/
.dashboard-container {
  padding: 16px;
  color: #fff;
}
.dashboard-container .ant-card-head {
  color: #14293C;
}
.dashboard-header {
  margin-bottom: 16px;
}
.dashboard-header .dashboard-header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stats-row .stat-card,
.stats-row .stat-card .ant-card-body {
  color: #14293C;
  border: none;
  padding: 8px;
}
.stat-card h2 {
  font-size: 45px;
  margin: 0;
}
.dark-theme .stat-card h2 {
  color: #081C26;
}
.stat-card p {
  font-size: 14px;
  margin: 4px 0;
}
@media screen and (min-width: 1600px) {
  .stat-card p {
    font-size: 18px;
    font-weight: 500;
  }
}
.stat-card span.gx-out-of-count {
  font-size: 11px;
  margin: 5px -16px -16px;
  display: block;
  background: #DAE3E7;
  padding: 12px 8px;
  font-weight: 500;
  color: #051B30;
  min-height: 43px;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 1600px) {
  .stat-card span.gx-out-of-count {
    font-size: 14px;
  }
}
@media screen and (min-width: 1600px) {
  .stat-card span.gx-out-of-count.appointments {
    font-size: 13px;
    padding: 8px 6px;
    line-height: 1.2;
  }
}
.dark-theme .stat-card span.gx-out-of-count {
  background: #14293C;
  color: #ffffff;
  font-weight: 400;
}
.ant-card.todays-stats.ant-card-bordered {
  border: none;
  margin-bottom: 20px;
  background: transparent;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-head {
  border: none;
  min-height: 40px;
  line-height: 1;
  padding: 0 5px;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-head .ant-card-head-title {
  font-weight: 500;
}
.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-head .ant-card-head-title {
  font-weight: 400;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body {
  padding: 10px 20px;
  max-height: 450px;
  overflow-y: auto;
  background-color: #ffffff;
}
.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-body {
  background-color: #14283C;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item {
  border-bottom: none;
}
@media screen and (min-width: 1600px) {
  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item {
    font-size: 15px;
  }
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item strong {
  font-size: 14px;
  margin: 6px 0;
  display: block;
}
@media screen and (min-width: 1600px) {
  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item strong {
    font-size: 17px;
  }
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item .short-inf {
  font-size: 11px;
  font-weight: 400;
}
@media screen and (min-width: 1600px) {
  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item .short-inf {
    font-size: 13px;
  }
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item svg path {
  fill: #89939d;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item svg path {
  fill: #999;
}
.ant-card.todays-stats.ant-card-bordered a {
  color: #37A2B7;
  font-weight: 600;
}
.ant-card.todays-stats.ant-card-bordered .ant-card-head {
  overflow: visible;
}
.appointments-overview-extra {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 18px;
  line-height: 1;
  margin-top: -36px;
  padding-bottom: 4px;
}
.appointments-overview-extra .appointments-overview-refresh {
  color: #37a2b7;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1;
}
.appointments-overview-extra .appointments-overview-refresh:hover {
  color: #4db5ca;
}
.ant-card.todays-stats .ant-list {
  color: #051B30;
  font-weight: 500;
}
.dark-theme .ant-card.todays-stats .ant-list {
  color: #E9F6FF;
}
.ant-card.todays-stats .ant-list .ant-list-item .appId {
  color: #717171;
}
.dark-theme .ant-card.todays-stats .ant-list .ant-list-item .appId {
  color: #D9D9D9;
}
.ant-card.todays-stats .ant-list .ant-list-item p {
  color: #8a8a8a;
  font-size: 12px;
}
.dark-theme .ant-card.todays-stats .ant-list .ant-list-item p {
  color: #BDBDBD;
}
@media screen and (min-width: 1600px) {
  .ant-card.todays-stats .ant-list .ant-list-item p {
    font-size: 14px;
  }
}
.appId {
  color: #8a8a8a;
}
.dark-theme .appId {
  color: #BDBDBD;
}
.unreported-card {
  border: none;
  margin-bottom: 0px;
  border-radius: 4px;
}
.unreported-card .ant-card-body {
  padding: 16px;
  gap: 8px;
  display: flex;
  max-height: 350px;
  overflow-y: auto;
  justify-content: space-between;
  font-weight: 500;
}
.dark-theme .unreported-card .ant-card-body {
  font-weight: 300;
}
.unreported-card .ant-card-body div strong {
  margin: 5px 0;
  display: block;
  color: #051B30;
  font-weight: 600;
}
.unreported-card .ant-card-body div p {
  font-size: 13px;
  margin: 0px;
  font-weight: 600;
}
.dark-theme .unreported-card .ant-card-body div p {
  font-weight: 500;
}
.unreported-card .ant-card-body:before,
.unreported-card .ant-card-body:after {
  display: none;
}
.unreported-card .ant-card-body span.ant-tag,
.ant-card.todays-stats .ant-tag {
  margin: 0px;
  background-color: transparent;
  border: transparent;
  font-weight: 600;
}
@media screen and (min-width: 1600px) {
  .unreported-card .ant-card-body span.ant-tag,
  .ant-card.todays-stats .ant-tag {
    font-size: 14px;
  }
}
.unreported-card-container > .ant-row {
  overflow-x: auto;
  max-width: 100%;
  flex-wrap: nowrap;
  padding-bottom: 10px;
}
.unreported-card-container > .ant-row::-webkit-scrollbar {
  height: 7px !important;
  width: 4px !important;
}
.unreported-card-container > .ant-row::-webkit-scrollbar-thumb:horizontal {
  /* This is the EXACT color of Mac OS scrollbars.
     Yes, I pulled out digital color meter */
  -webkit-border-radius: 100px;
}
.unreported-card-container > .ant-row::-webkit-scrollbar-thumb:horizontal:active {
  -webkit-border-radius: 100px;
}
.dark-theme .dashboard-container {
  background-color: #071b2c;
}
.dark-theme .dashboard-container .ant-select-selection {
  border-color: rgba(250, 250, 250, 0.1);
}
.dark-theme .stats-row .stat-card .ant-card-body {
  padding: 8px;
}
.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-head {
  background: #051B30;
}
.dark-theme .unreported-card {
  background-color: #14283C;
  color: #ffffff;
}
.dark-theme .unreported-card .ant-card-body div strong {
  color: #E9F6FF;
}
/*Algolia Styles*/
.gx-algolia-sidebar {
  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin-bottom: 32px;
  width: 280px !important;
}
@media screen and (max-width: 767px) {
  .gx-algolia-sidebar {
    width: 100% !important;
  }
}
@media screen and (max-width: 575px) {
  .gx-algolia-sidebar {
    margin-bottom: 20px;
  }
}
.gx-algolia-sidebar [class^="ais-"] {
  font-size: 14px;
}
.gx-algolia-sidebar-content {
  padding: 24px;
}
.gx-algolia-sidebar .ais-ClearRefinements {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li {
  margin-bottom: 5px;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a {
  color: #545454;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,
.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {
  color: #2EB1EF;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-count {
  padding: 0 5px;
  font-size: 12px;
  color: #8c8c8c;
  background-color: transparent;
  border-radius: 0;
}
.gx-algolia-sidebar .ais-Panel {
  margin-bottom: 20px;
}
.gx-algolia-sidebar .ais-Panel-header {
  margin-bottom: 8px;
  padding-bottom: 0;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 0 none;
}
.gx-algolia-sidebar .ais-RefinementList-list li {
  margin-bottom: 5px;
}
.gx-algolia-sidebar .ais-RefinementList-checkbox {
  margin-right: 12px;
}
.gx-algolia-sidebar .ais-RefinementList-labelText {
  font-size: 14px;
}
.gx-algolia-sidebar .ais-RefinementList-count {
  padding: 0 5px;
  font-size: 14px;
  color: #8c8c8c;
  background-color: transparent;
  border-radius: 0;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected {
  font-weight: normal;
}
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected > a,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected > a,
.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected > a {
  color: #2EB1EF;
}
.gx-algolia-sidebar .ais-RatingMenu-item--selected {
  font-weight: 600;
}
.gx-algolia-layout-has-sider {
  flex-wrap: nowrap;
}
@media screen and (max-width: 767px) {
  .gx-algolia-layout-has-sider {
    flex-wrap: wrap;
  }
}
.gx-algolia-category-title {
  font-size: 14px;
  margin-bottom: 10px;
  color: #8c8c8c;
}
.gx-algolia-main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 30px;
  margin-bottom: 32px;
}
.gx-algolia-main [class^="ais-"] {
  font-size: 14px;
}
@media screen and (max-width: 767px) {
  .gx-algolia-main {
    padding-left: 0;
  }
}
@media screen and (max-width: 575px) {
  .gx-algolia-main {
    margin-bottom: 20px;
  }
}
.gx-algolia-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.gx-algolia-sort-by {
  margin-left: auto;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.gx-algolia-sort-by label {
  margin-right: 15px;
}
@media screen and (max-width: 400px) {
  .gx-algolia-sort-by {
    margin-left: 0;
  }
}
.gx-algolia-footer {
  padding: 10px;
}
.gx-algolia-footer .ais-Pagination-list {
  flex-wrap: wrap;
}
.gx-algolia-footer .ais-Pagination-list li {
  margin-bottom: 5px;
}
.gx-algolia-content .ais-Stats {
  margin-bottom: 10px;
}
.gx-product-name [class^="ais-"] {
  font-size: 16px;
}
.gx-algolia-refinementList {
  width: 100%;
}
.gx-algolia-refinementList li.ais-RefinementList-item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ais-RangeInput-submit,
.ais-ClearRefinements-button,
.ais-CurrentRefinements-reset,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset,
.ais-HierarchicalMenu-showMore,
.ais-InfiniteHits-loadMore,
.ais-InfiniteResults-loadMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
  background-color: #2EB1EF;
}
.ais-RangeInput-submit:focus,
.ais-ClearRefinements-button:focus,
.ais-CurrentRefinements-reset:focus,
.ais-GeoSearch-redo:focus,
.ais-GeoSearch-reset:focus,
.ais-HierarchicalMenu-showMore:focus,
.ais-InfiniteHits-loadMore:focus,
.ais-InfiniteResults-loadMore:focus,
.ais-Menu-showMore:focus,
.ais-RefinementList-showMore:focus,
.ais-RangeInput-submit:hover,
.ais-ClearRefinements-button:hover,
.ais-CurrentRefinements-reset:hover,
.ais-GeoSearch-redo:hover,
.ais-GeoSearch-reset:hover,
.ais-HierarchicalMenu-showMore:hover,
.ais-InfiniteHits-loadMore:hover,
.ais-InfiniteResults-loadMore:hover,
.ais-Menu-showMore:hover,
.ais-RefinementList-showMore:hover {
  background-color: #2EB1EF;
}
.ais-Breadcrumb-link,
.ais-HierarchicalMenu-link,
.ais-Menu-link,
.ais-Pagination-link,
.ais-RatingMenu-link {
  color: #2EB1EF;
}
.ais-Breadcrumb-link:focus,
.ais-HierarchicalMenu-link:focus,
.ais-Menu-link:focus,
.ais-Pagination-link:focus,
.ais-RatingMenu-link:focus,
.ais-Breadcrumb-link:hover,
.ais-HierarchicalMenu-link:hover,
.ais-Menu-link:hover,
.ais-Pagination-link:hover,
.ais-RatingMenu-link:hover {
  color: #2EB1EF;
}
.ais-Pagination-item--selected .ais-Pagination-link {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
/*Error Styles*/
.gx-page-error-container {
  position: relative;
  height: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.gx-page-error-content {
  margin: 0 auto;
  width: 380px;
  max-width: 94%;
}
.gx-page-error-content h2 {
  margin-bottom: 50px;
}
@media screen and (max-width: 767px) {
  .gx-page-error-content h2 {
    margin-bottom: 20px;
  }
}
.gx-error-code {
  color: #595959;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 500;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);
}
@media screen and (max-width: 991px) {
  .gx-error-code {
    font-size: 130px;
  }
}
@media screen and (max-width: 767px) {
  .gx-error-code {
    font-size: 100px;
  }
}
@media screen and (max-width: 575px) {
  .gx-error-code {
    font-size: 80px;
  }
}
/*Editor Styles*/
.rdw-editor-toolbar .rdw-inline-wrapper {
  flex-wrap: wrap;
}
@media screen and (max-width: 399px) {
  .rdw-editor-toolbar .rdw-inline-wrapper .rdw-option-wrapper {
    margin-bottom: 8px;
  }
}
/*Testimonial Styles*/
.gx-testimonial {
  margin-bottom: 32px;
}
@media screen and (max-width: 575px) {
  .gx-testimonial {
    margin-bottom: 20px;
  }
}
.gx-classic-testimonial .ant-avatar {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
}
.gx-classic-testimonial .ant-avatar img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 575px) {
  .gx-classic-testimonial .ant-avatar {
    width: 80px;
    height: 80px;
    margin-bottom: 15px;
  }
}
.gx-testimonial-bg {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 30px;
  overflow: hidden;
  position: relative;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
@media screen and (max-width: 575px) {
  .gx-testimonial-bg {
    padding: 16px;
  }
}
.gx-testimonial-bg .ant-avatar {
  display: inline-block;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border: 4px solid #2EB1EF;
}
.gx-testimonial-bg .ant-avatar img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 450px) {
  .gx-testimonial-bg .ant-avatar {
    width: 50px;
    height: 50px;
  }
}
.gx-testimonial-bg .gx-description {
  color: #d9d9d9;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  margin-bottom: 15px;
}
.gx-testimonial-bg .gx-title {
  color: #2EB1EF;
  margin-bottom: 2px;
}
.gx-testimonial-des {
  position: relative;
  padding-left: 30px;
}
.gx-testimonial-des:before {
  font-family: "gaxon";
  font-size: 20px;
  content: "\\e066";
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
}
@media screen and (max-width: 475px) {
  .gx-standard .gx-media {
    flex-direction: column;
  }
}
/*Base Styles*/
body.dark-theme.framed-layout,
body.dark-theme.boxed-layout {
  background-color: #000102;
}
.ant-drawer-header {
  padding: 5px;
  background: transparent;
  border: none;
  margin-bottom: 7px;
}
.ant-drawer-close {
  padding: 0;
  margin: 0;
  top: -12px;
  right: 5px;
  width: 40px;
  height: 40px;
}
.ant-drawer-title {
  font-size: 20px;
  color: #051B30;
  font-weight: 600;
}
@media screen and (min-width: 1600px) {
  .ant-drawer-title {
    font-size: 22px;
  }
}
.ant-drawer-body {
  padding: 10px;
}
.ant-drawer-body > .ant-row {
  margin-left: -8px;
  margin-right: -8px;
}
.dark-theme {
  color: #E9F6FF;
  background-color: #051B30;
}
.dark-theme .gx-link {
  color: #b6e1ff;
}
.dark-theme .gx-link:hover,
.dark-theme .gx-link:focus {
  color: #f8fcff;
}
.dark-theme .gx-social-link li .gx-link {
  color: #E9F6FF;
}
.dark-theme .gx-social-link li.active .gx-link,
.dark-theme .gx-social-link li .gx-link:hover,
.dark-theme .gx-social-link li .gx-link:focus {
  color: #ffffff;
}
.dark-theme h1,
.dark-theme h2,
.dark-theme h3,
.dark-theme h4,
.dark-theme h5,
.dark-theme h6,
.dark-theme .h1,
.dark-theme .h2,
.dark-theme .h3,
.dark-theme .h4,
.dark-theme .h5,
.dark-theme .h6 {
  color: #ffffff;
}
.dark-theme .ant-modal h1,
.dark-theme .ant-modal h2,
.dark-theme .ant-modal h3,
.dark-theme .ant-modal h4,
.dark-theme .ant-modal h5,
.dark-theme .ant-modal h6,
.dark-theme .ant-modal .h1,
.dark-theme .ant-modal .h2,
.dark-theme .ant-modal .h3,
.dark-theme .ant-modal .h4,
.dark-theme .ant-modal .h5,
.dark-theme .ant-modal .h6 {
  color: #051B30;
}
.dark-theme .gx-drawer-sidebar-dark .ant-drawer-content {
  background-color: #051B30;
  color: #E9F6FF;
}
.dark-theme .ant-drawer-close {
  color: #051B30;
}
.dark-theme .ant-layout,
.dark-theme .ant-layout.ant-layout-has-sider > .ant-layout {
  background: #051B30;
}
.dark-theme .ant-layout-header {
  background: #051B30;
  color: #ffffff;
}
.dark-theme .gx-news-content {
  color: #E9F6FF;
}
.dark-theme .gx-header-horizontal {
  background: #030e19;
}
.dark-theme .gx-header-horizontal-main {
  color: #E9F6FF;
  background: none;
}
.dark-theme .gx-header-horizontal-dark:before {
  background: #072847;
}
.dark-theme .gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type="search"] {
  border-color: #e8e8e8;
}
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  color: #030e19;
}
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: #089265;
}
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {
  color: #051B30;
}
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,
.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,
.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {
  color: #089265;
}
.dark-theme .gx-menu-horizontal .ant-menu-submenu:hover > .ant-menu-submenu-title,
.dark-theme .gx-menu-horizontal .ant-menu-item-active > .ant-menu-submenu-title,
.dark-theme .gx-menu-horizontal .ant-menu-submenu-active > .ant-menu-submenu-title,
.dark-theme .gx-menu-horizontal .ant-menu-item-open > .ant-menu-submenu-title,
.dark-theme .gx-menu-horizontal .ant-menu-submenu-open > .ant-menu-submenu-title {
  color: #089265;
}
.dark-theme .ant-layout-footer {
  background: #051B30;
  color: #E9F6FF;
  border-top-color: #495762;
}
.dark-theme .gx-nav-header {
  background-color: #051B30;
  border-bottom-color: #495762;
}
.dark-theme .ant-menu {
  color: #E9F6FF;
  background: #051B30;
}
.dark-theme .ant-menu-inline,
.dark-theme .ant-menu-vertical,
.dark-theme .ant-menu-vertical-left {
  border-right-color: #495762;
}
.dark-theme .ant-menu-dark {
  color: #E9F6FF;
  background: #051B30;
  padding-bottom: 20px;
}
.dark-theme .ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.dark-theme .ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.dark-theme .ant-result-title,
.dark-theme .ant-result-subtitle {
  color: #ffffff;
}
.dark-theme .ant-menu-submenu-title:hover {
  color: #089265;
}
.dark-theme .ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {
  color: #E9F6FF;
}
.dark-theme .ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title:hover {
  color: #089265;
}
.dark-theme .ant-menu-dark .ant-menu-sub {
  color: #E9F6FF;
  background: none;
}
.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,
.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {
  background: #089265;
}
.dark-theme .ant-menu-item > a {
  color: #E9F6FF;
}
.dark-theme .ant-menu-item > a:hover {
  color: #ffffff;
}
.dark-theme .ant-menu-item-selected > a:hover {
  color: #ffffff;
}
.dark-theme .ant-menu-dark.ant-menu-submenu-popup,
.dark-theme .ant-menu-submenu-popup {
  background: #051B30;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.dark-theme .ant-menu-dark.ant-menu-submenu-popup .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,
.dark-theme .ant-menu-dark.ant-menu-submenu-popup .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {
  background: #ffffff;
}
.dark-theme .ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.dark-theme .ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background: #089265;
}
.dark-theme .ant-menu-dark.ant-menu-horizontal {
  border-bottom-color: #051B30;
}
.dark-theme .ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.dark-theme .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  border-color: #051B30;
}
.dark-theme .ant-menu-horizontal {
  border-bottom-color: #495762;
  background: #051B30;
}
.dark-theme .gx-header-horizontal-nav .ant-menu-horizontal {
  background: none;
}
.dark-theme .ant-menu-horizontal > .ant-menu-item:hover,
.dark-theme .ant-menu-horizontal > .ant-menu-submenu:hover,
.dark-theme .ant-menu-horizontal > .ant-menu-item-active,
.dark-theme .ant-menu-horizontal > .ant-menu-submenu-active,
.dark-theme .ant-menu-horizontal > .ant-menu-item-open,
.dark-theme .ant-menu-horizontal > .ant-menu-submenu-open,
.dark-theme .ant-menu-horizontal > .ant-menu-item-selected,
.dark-theme .ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom-color: #E9F6FF;
  color: #E9F6FF;
}
.dark-theme .ant-menu-horizontal > .ant-menu-item > a,
.dark-theme .ant-menu-horizontal > .ant-menu-submenu > a {
  color: #E9F6FF;
}
.dark-theme .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #18344f;
  color: #E9F6FF;
}
.dark-theme .ant-layout-sider .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: rgba(255, 255, 255, 0.12);
}
.dark-theme .ant-layout-sider.gx-mini-custom-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}
.dark-theme .ant-layout-sider.gx-mini-custom-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a:hover {
  color: #003366;
}
.dark-theme .ant-menu-submenu > .ant-menu,
.dark-theme .ant-menu-item:active,
.dark-theme .ant-menu-submenu-title:active {
  background-color: #18344f;
  color: #E9F6FF;
}
.dark-theme .ant-layout-sider .ant-menu-submenu > .ant-menu,
.dark-theme .ant-layout-sider .ant-menu-item:active,
.dark-theme .ant-layout-sider .ant-menu-submenu-title:active {
  background-color: transparent;
}
.dark-theme .ant-menu-item-group-title,
.dark-theme .ant-menu-item-selected,
.dark-theme .ant-menu-submenu-selected .ant-menu-submenu-title {
  color: #E9F6FF;
}
.dark-theme .ant-menu-item:hover,
.dark-theme .ant-menu-item-active,
.dark-theme .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.dark-theme .ant-menu-submenu-active {
  color: #E9F6FF;
}
.dark-theme .ant-menu-item-disabled,
.dark-theme .ant-menu-submenu-disabled {
  color: #69c2ff !important;
}
.dark-theme .ant-menu-dark .ant-menu-item-group-title {
  color: #E9F6FF;
}
.dark-theme .ant-menu-dark .ant-menu-item {
  color: #9BA4AC;
}
.dark-theme .ant-menu-dark .ant-menu-item svg path {
  fill: #9BA4AC;
}
.dark-theme .ant-menu-dark .ant-menu-item:hover {
  color: #ffffff;
}
.dark-theme .ant-menu-dark .ant-menu-item:hover svg path {
  fill: #ffffff;
}
.dark-theme .ant-menu-dark .ant-menu-item.stroke svg path {
  fill: none;
}
.dark-theme .ant-menu-dark .ant-menu-item.stroke > a:hover svg path {
  fill: none;
  stroke: #fff;
}
.dark-theme .ant-menu-dark .ant-menu-item > a {
  color: #9BA4AC;
}
.dark-theme .ant-menu-dark .ant-menu-item > a svg {
  width: 20px;
  height: 20px;
}
.dark-theme .ant-menu-dark .ant-menu-item > a:hover {
  color: #ffffff;
}
.dark-theme .ant-menu-dark .ant-menu-item > a:hover svg path {
  fill: #ffffff;
}
.dark-theme .ant-menu-dark .ant-menu-item-selected > a {
  color: #ffffff;
}
.dark-theme .ant-menu-submenu-horizontal > .ant-menu-submenu-title {
  color: #E9F6FF;
}
.dark-theme .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.dark-theme .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.dark-theme .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.dark-theme .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.dark-theme .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.dark-theme .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.dark-theme .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.dark-theme .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background: #ffffff;
}
.dark-theme .ant-menu-vertical .ant-menu-item::after,
.dark-theme .ant-menu-vertical-left .ant-menu-item::after,
.dark-theme .ant-menu-vertical-right .ant-menu-item::after,
.dark-theme .ant-menu-inline .ant-menu-item::after {
  border-right-color: #08090a;
}
.dark-theme .ant-layout-sider,
.dark-theme .gx-layout-sider-dark {
  background-color: #051B30;
  color: #a1a1a1;
  -webkit-box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);
  box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);
  border-right: 1px solid #062039;
}
.dark-theme .gx-task-list-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-task-list-item:hover .gx-text-hover {
  color: #b6e1ff;
}
.dark-theme .gx-card-ticketlist .gx-task-list-item:hover {
  background-color: transparent;
}
.dark-theme .gx-card-ticketlist .gx-task-list-item:hover .gx-task-item-title {
  color: #f8fcff;
}
.dark-theme .gx-card-testimonial-content {
  background-color: #051B30;
}
.dark-theme .gx-card-testimonial-content:before {
  border-right-color: #051B30;
}
.dark-theme .gx-progress-task-list + .gx-progress-task-list {
  border-top-color: #495762;
}
.dark-theme .gx-card-ticketlist .gx-link {
  color: #b6e1ff;
}
.dark-theme .gx-overview-description {
  border-left-color: #495762;
}
@media screen and (max-width: 767px) {
  .dark-theme .gx-overview-description {
    border-top-color: #495762;
    border-bottom-color: #495762;
  }
}
.dark-theme .gx-revenu-total {
  border-bottom-color: #495762;
}
.dark-theme .gx-revenu-col:not(:last-child) {
  border-right-color: #495762;
}
.dark-theme .gx-product-item {
  background: #12273B;
}
.dark-theme .gx-app-login-main-content {
  background-color: #12273B;
}
.dark-theme .gx-app-social-block .gx-social-link span {
  border-color: #051B30;
  color: #051B30;
}
.dark-theme .gx-app-social-block .gx-social-link span:hover,
.dark-theme .gx-app-social-block .gx-social-link span:focus {
  color: #E9F6FF;
  background-color: #051B30;
}
.dark-theme .gx-avatar-img,
.dark-theme .gx-avatar,
.dark-theme .gx-badge-outline {
  border-color: #495762;
}
.dark-theme .gx-btn,
.dark-theme .btn {
  color: #545454;
  border-color: #d9d9d9;
}
.dark-theme .gx-sub-popover .gx-btn:focus,
.dark-theme .gx-sub-popover .btn:focus,
.dark-theme .gx-sub-popover .gx-btn:hover,
.dark-theme .gx-sub-popover .btn:hover {
  background-color: #E9F6FF;
}
.dark-theme .gx-btn-link {
  color: #b6e1ff;
  background-color: transparent;
}
.dark-theme .gx-btn-link:hover {
  color: #f8fcff;
}
.dark-theme .gx-ant-card-actions > li:not(:last-child) {
  border-right-color: #495762;
}
.dark-theme .ant-card {
  color: #E9F6FF;
  background: #12273B;
}
.dark-theme .ant-card-bordered {
  border-color: #495762;
}
.dark-theme .ant-card-head {
  border-color: #495762;
}
.dark-theme .ant-card-head-title {
  color: #E9F6FF;
}
.dark-theme .ant-card-type-inner .ant-card-head {
  background: #12273B;
}
.dark-theme .ant-card-meta-title,
.dark-theme .ant-card-meta-description {
  color: #E9F6FF;
}
.dark-theme .ant-card-actions {
  border-top-color: #495762;
  background: #12273B;
}
.dark-theme .ant-card-actions > li {
  color: #E9F6FF;
}
.dark-theme .ant-card-actions > li:not(:last-child) {
  border-right-color: #495762;
}
.dark-theme .ant-card-actions > li > span:hover {
  color: #f8fcff;
}
.dark-theme .ant-card-grid {
  box-shadow: 1px 0 0 0 #495762, 0 1px 0 0 #495762, 1px 1px 0 0 #495762, 1px 0 0 0 #495762 inset, 0 1px 0 0 #495762 inset;
}
.dark-theme .ant-card-grid:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.dark-theme .gx-card {
  background-color: #12273B;
}
.dark-theme .gx-card-overview {
  background-color: #12273B;
}
.dark-theme .gx-card-metrics,
.dark-theme .gx-card-widget {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}
.dark-theme .gx-icon-views:hover {
  background-color: #051B30;
  color: #E9F6FF;
}
.dark-theme .gx-search-bar input[type="search"] {
  background: rgba(250, 250, 250, 0.1);
}
.dark-theme .gx-search-bar input[type="search"]:focus {
  background-color: rgba(250, 250, 250, 0.3);
}
.dark-theme .gx-search-bar .gx-search-icon {
  color: #d9d9d9;
}
.dark-theme .gx-chat-search-bar input[type="search"]:focus {
  background-color: #12273B;
}
.dark-theme .gx-user-list.gx-card-list {
  background: #12273B;
}
.dark-theme .gx-user-list .gx-link[class*="gx-meta-"] {
  color: #E9F6FF;
}
.dark-theme .gx-card-strip:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-loader-container {
  background-color: #bfbfbf;
}
.dark-theme .gx-table th,
.dark-theme .gx-table td {
  border-top-color: #495762;
}
.dark-theme .gx-table thead th {
  border-bottom-color: #495762;
}
.dark-theme .gx-table tbody + tbody {
  border-top-color: #495762;
}
.dark-theme .gx-table-bordered {
  border-color: #495762;
}
.dark-theme .gx-table-bordered th,
.dark-theme .gx-table-bordered td {
  border-color: #495762;
}
.dark-theme .gx-timeline-item:before {
  border-left-color: #495762;
}
.dark-theme .gx-timeline-badge {
  color: #12273B;
}
.dark-theme .gx-timeline-badge:after {
  border-color: #495762;
}
.dark-theme .gx-timeline-panel {
  background-color: #12273B;
  border-color: #495762;
}
.dark-theme .gx-timeline-panel:before {
  border-color: transparent #495762;
}
.dark-theme .gx-timeline-panel:after {
  border-color: transparent #12273B;
}
.dark-theme .gx-timeline-center .gx-timeline-inverted:before {
  border-right-color: #495762;
}
.dark-theme .gx-timeline-info .ant-timeline-item-content {
  color: #E9F6FF;
}
.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link {
  color: #cfecff;
}
.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link:hover,
.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link:focus {
  color: #ffffff;
}
.dark-theme .gx-img-more {
  background-color: #0b1824;
}
.dark-theme .ant-tabs {
  color: #0a355e;
}
.dark-theme .ant-tabs-nav .ant-tabs-tab-active,
.dark-theme .ant-tabs-nav .ant-tabs-tab:hover {
  color: #051B30;
}
.dark-theme .ant-tabs-ink-bar {
  background-color: #051B30;
}
.dark-theme .ant-tabs-bar {
  border-bottom-color: #495762;
}
.dark-theme .ant-tabs-tab-prev,
.dark-theme .ant-tabs-tab-next {
  color: #E9F6FF;
}
.dark-theme .ant-tabs-tab-prev:hover,
.dark-theme .ant-tabs-tab-next:hover {
  color: #ffffff;
}
.dark-theme .ant-tabs-tab-btn-disabled,
.dark-theme .ant-tabs-tab-btn-disabled:hover {
  color: #1da3ff;
}
.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-bottom-color: #f5f5f5 !important;
  background: #142c43;
  color: #D3D3D3;
  margin-right: 5px;
}
.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  background: #12273B;
  border-color: #1c3c5a;
  border-bottom-color: #f5f5f5;
  color: #ffffff;
}
.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {
  color: #E9F6FF;
}
.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close:hover {
  color: #ffffff;
}
.dark-theme .ant-checkbox-wrapper {
  color: #E9F6FF;
}
.dark-theme .ant-checkbox-disabled + span {
  color: #50b7ff;
}
.dark-theme .ant-checkbox-checked::after,
.dark-theme .ant-checkbox-wrapper:hover .ant-checkbox-inner,
.dark-theme .ant-checkbox:hover .ant-checkbox-inner,
.dark-theme .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #2a5b89;
}
.dark-theme .ant-checkbox-checked .ant-checkbox-inner,
.dark-theme .ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #2a5b89;
  border-color: #2a5b89;
}
.dark-theme .ant-timeline {
  color: #E9F6FF;
}
.dark-theme .ant-timeline-item-head {
  background-color: transparent;
}
.dark-theme .ant-timeline-item-tail {
  border-left-color: #5a6c79;
}
.dark-theme .ant-timeline-item-head-blue {
  border-color: #5a6c79;
  color: #f8fcff;
}
.dark-theme .ant-popover-inner,
.dark-theme .ant-popover-arrow {
  background-color: #12273B;
}
.dark-theme .ant-popover-inner {
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);
}
.dark-theme .ant-popover-inner-content,
.dark-theme .ant-popover-message {
  color: #E9F6FF;
}
.dark-theme .ant-popover-title {
  border-bottom-color: #495762;
  color: #E9F6FF;
}
.dark-theme .ant-popover-arrow {
  border-color: #12273B !important;
}
.dark-theme .gx-sub-popover li:not(:last-child),
.dark-theme .gx-popover-header {
  border-bottom-color: #495762;
}
.dark-theme .gx-user-popover li:hover,
.dark-theme .gx-user-popover li:focus {
  background-color: #18344f;
}
.dark-theme .ant-divider {
  color: #E9F6FF;
  background: #495762;
}
.dark-theme .ant-divider.ant-divider-with-text,
.dark-theme .ant-divider.ant-divider-with-text-left,
.dark-theme .ant-divider.ant-divider-with-text-right {
  background: none;
}
.dark-theme .gx-card-body-border-top .ant-card-body {
  border-top-color: #495762;
}
.dark-theme .ant-list {
  color: #E9F6FF;
}
.dark-theme .ant-list-split .ant-list-item,
.dark-theme .ant-list-split .ant-list-header,
.dark-theme .ant-list-something-after-last-item .ant-spin-container > .ant-list-item:last-child {
  border-bottom-color: #495762;
}
.dark-theme .ant-list-item-meta-description,
.dark-theme .ant-list-vertical .ant-list-item-content,
.dark-theme .ant-list-item-action > li {
  color: #E9F6FF;
}
.dark-theme .ant-list-bordered {
  border-color: #495762;
}
.dark-theme .ant-list-item-action-split {
  background-color: #495762;
}
.dark-theme .gx-btn-light,
.dark-theme .gx-link.gx-btn-light {
  color: #E9F6FF !important;
  background-color: #051B30 !important;
  border-color: #051B30 !important;
}
.dark-theme .gx-btn-light:hover,
.dark-theme .gx-link.gx-btn-light:hover,
.dark-theme .gx-btn-light:focus,
.dark-theme .gx-link.gx-btn-light:focus {
  background-color: #000102 !important;
  border-color: #000102 !important;
}
.dark-theme .ant-table {
  color: #E9F6FF;
}
.dark-theme .ant-table-thead > tr > th {
  background: #051B30;
  color: #E9F6FF;
  border-bottom-color: #051B30;
}
.dark-theme .ant-table-tbody > tr > td {
  border-bottom-color: #051B30;
}
.dark-theme .ant-table-thead > tr.ant-table-row-hover > td,
.dark-theme .ant-table-tbody > tr.ant-table-row-hover > td,
.dark-theme .ant-table-thead > tr:hover > td,
.dark-theme .ant-table-tbody > tr:hover > td {
  background: #18344f;
}
.dark-theme .ant-table-tbody > tr.ant-table-row-selected td {
  background: #18344f;
}
.dark-theme .ant-table-small {
  border: none;
}
.dark-theme .ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,
.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th {
  background: #18344f;
  border-bottom-color: #495762;
}
.dark-theme .ant-table.ant-table-bordered .ant-table-title,
.dark-theme .ant-table-bordered .ant-table-header > table,
.dark-theme .ant-table-bordered .ant-table-body > table,
.dark-theme .ant-table-bordered .ant-table-fixed-left table,
.dark-theme .ant-table-bordered .ant-table-fixed-right table,
.dark-theme .ant-table.ant-table-bordered .ant-table-footer {
  border-color: #495762;
}
.dark-theme .ant-table-header {
  background: #18344f;
}
.dark-theme .ant-table-footer {
  background: #18344f;
}
.dark-theme .ant-table-footer:before {
  background: transparent;
}
.dark-theme .ant-table-bordered .ant-table-thead > tr > th,
.dark-theme .ant-table-bordered .ant-table-tbody > tr > td {
  border-right-color: #495762;
}
.dark-theme .ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {
  border-bottom-color: #495762;
}
.dark-theme .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  background: #12273B;
}
.dark-theme .ant-table-fixed-left table,
.dark-theme .ant-table-fixed-right table {
  background: #18344f;
}
.dark-theme .ant-table-thead > tr > th .anticon-filter:hover,
.dark-theme .ant-table-thead > tr > th .ant-table-filter-icon:hover {
  color: #ffffff;
}
.dark-theme .ant-table-column-sorter {
  color: #E9F6FF;
}
.dark-theme .ant-table-column-sorter-up:hover .anticon,
.dark-theme .ant-table-column-sorter-down:hover .anticon,
.dark-theme .ant-table-column-sorter-up.on .anticon-caret-up,
.dark-theme .ant-table-column-sorter-down.on .anticon-caret-up,
.dark-theme .ant-table-column-sorter-up.on .anticon-caret-down,
.dark-theme .ant-table-column-sorter-down.on .anticon-caret-down {
  color: #ffffff;
}
.dark-theme .ant-table-row-expand-icon {
  background: none;
}
.dark-theme tr.ant-table-expanded-row,
.dark-theme tr.ant-table-expanded-row:hover {
  background: #18344f;
}
.dark-theme .ant-pagination {
  color: #E9F6FF;
}
.dark-theme .ant-pagination-item {
  background-color: #0c1a27;
  border-color: #495762;
}
.dark-theme .ant-pagination-item-active,
.dark-theme .ant-pagination-item:hover,
.dark-theme .ant-pagination-item:focus {
  border-color: #495762;
}
.dark-theme .ant-pagination-item-active .gx-link,
.dark-theme .ant-pagination-item:hover .gx-link,
.dark-theme .ant-pagination-item:focus .gx-link {
  color: #E9F6FF;
}
.dark-theme .ant-pagination-disabled a,
.dark-theme .ant-pagination-disabled:hover a,
.dark-theme .ant-pagination-disabled:focus a,
.dark-theme .ant-pagination-disabled .ant-pagination-item-link,
.dark-theme .ant-pagination-disabled:hover .ant-pagination-item-link,
.dark-theme .ant-pagination-disabled:focus .ant-pagination-item-link {
  color: #051B30;
}
.dark-theme .ant-pagination-prev,
.dark-theme .ant-pagination-next,
.dark-theme .ant-pagination-jump-prev,
.dark-theme .ant-pagination-jump-next {
  color: #E9F6FF;
}
.dark-theme .ant-pagination-prev .ant-pagination-item-link,
.dark-theme .ant-pagination-next .ant-pagination-item-link {
  background-color: #CACACA;
  border-color: #CACACA;
}
.dark-theme .ant-pagination-prev:focus .ant-pagination-item-link,
.dark-theme .ant-pagination-next:focus .ant-pagination-item-link,
.dark-theme .ant-pagination-prev:hover .ant-pagination-item-link,
.dark-theme .ant-pagination-next:hover .ant-pagination-item-link {
  border-color: #495762;
  color: #E9F6FF;
}
.dark-theme .ant-pagination-jump-prev:focus:after,
.dark-theme .ant-pagination-jump-next:focus:after,
.dark-theme .ant-pagination-jump-prev:hover:after,
.dark-theme .ant-pagination-jump-next:hover:after {
  color: #E9F6FF;
}
.dark-theme .ant-pagination-simple .ant-pagination-simple-pager input {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: rgba(250, 250, 250, 0.3);
}
.dark-theme .ant-pagination-options-quick-jumper input {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-pagination-options-quick-jumper input:hover {
  border-color: rgba(250, 250, 250, 0.1);
}
.dark-theme .ant-pagination-options-quick-jumper input:focus {
  border-color: #495762;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-badge {
  color: #E9F6FF;
}
.dark-theme .ant-badge-status-text {
  color: #E9F6FF;
}
.dark-theme .ant-badge-count {
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}
.dark-theme .ant-cascader-picker:focus .ant-cascader-input {
  border-color: #495762;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-cascader-menus {
  background: #0c1a27;
}
.dark-theme .ant-cascader-menu {
  border-right-color: #495762;
}
.dark-theme .ant-cascader-menu-item:hover {
  background: #08121c;
}
.dark-theme .ant-cascader-picker,
.dark-theme .ant-cascader-picker-clear {
  background-color: transparent;
  color: #E9F6FF;
}
.dark-theme .ant-cascader-picker-arrow,
.dark-theme .ant-cascader-menu-item-expand:after {
  color: #E9F6FF;
}
.dark-theme .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),
.dark-theme .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
  background: #18344f;
}
.dark-theme .ant-form-item,
.dark-theme .ant-form-item-label label,
.dark-theme .ant-form-explain,
.dark-theme .ant-form-extra {
  color: #b1b1b1;
}
.dark-theme .ant-input {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #fff;
}
.dark-theme .ant-input:focus,
.dark-theme .ant-input:hover {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-input-disabled {
  background-color: #f5f5f5 !important;
}
.dark-theme .ant-input-number {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-input-number:focus,
.dark-theme .ant-input-number:hover {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #495762;
}
.dark-theme .ant-input-group-addon {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-input-group-addon .ant-select-open .ant-select-selection,
.dark-theme .ant-input-group-addon .ant-select-focused .ant-select-selection {
  color: #E9F6FF;
}
.dark-theme .ant-input-search-icon {
  color: #E9F6FF;
}
.dark-theme .ant-input-affix-wrapper .ant-input-prefix,
.dark-theme .ant-input-affix-wrapper .ant-input-suffix {
  color: #E9F6FF;
}
.dark-theme .ant-input-affix-wrapper .ant-input-prefix i,
.dark-theme .ant-input-affix-wrapper .ant-input-suffix i {
  color: #E9F6FF;
}
.dark-theme .ant-input-affix-wrapper .ant-input-prefix i :not(.anticon),
.dark-theme .ant-input-affix-wrapper .ant-input-suffix i :not(.anticon) {
  margin-top: 5px;
}
.dark-theme .ant-input.gx-chat-textarea {
  background-color: #12273B !important;
  border-color: #12273B;
  color: #E9F6FF;
}
.dark-theme .ant-input.gx-chat-textarea:focus {
  border-color: #495762;
}
.dark-theme .ant-modal .ant-input {
  background-color: #ffffff;
  border-color: #dde2e6;
  color: #595959;
}
.dark-theme .ant-modal .ant-input:focus,
.dark-theme .ant-modal .ant-input:hover {
  border-color: #cfd6db;
}
.dark-theme .ant-modal .ant-upload-list-item-info .anticon-paper-clip {
  color: #595959;
}
.dark-theme .ant-mention-wrapper {
  color: #E9F6FF;
}
.dark-theme .ant-mention-wrapper.disabled .ant-mention-editor {
  background-color: rgba(232, 232, 232, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-mention-wrapper.ant-mention-active:not(.disabled) .ant-mention-editor {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-mention-wrapper .ant-mention-editor {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-mention-wrapper .ant-mention-editor:focus {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-select {
  color: #E9F6FF;
}
.dark-theme .ant-select-selection {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: #dde2e6;
}
.dark-theme .ant-select-selection:hover {
  border-color: rgba(250, 250, 250, 0.1);
}
.dark-theme .ant-select-arrow {
  color: #E9F6FF;
}
.dark-theme .ant-select-focused .ant-select-selection,
.dark-theme .ant-select-selection:focus,
.dark-theme .ant-select-selection:active {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-select-dropdown {
  color: #E9F6FF;
  background-color: #12273B;
}
.dark-theme .ant-select-dropdown-menu-item {
  color: #E9F6FF;
}
.dark-theme .ant-select-dropdown-menu-item:hover {
  background-color: #0a1520;
}
.dark-theme .ant-select-dropdown-menu-item-selected,
.dark-theme .ant-select-dropdown-menu-item-selected:hover,
.dark-theme .ant-select-dropdown-menu-item-active {
  background-color: #08121c;
  color: #E9F6FF;
}
.dark-theme .ant-select-auto-complete.ant-select .ant-input:focus,
.dark-theme .ant-select-auto-complete.ant-select .ant-input:hover {
  border-color: rgba(250, 250, 250, 0.1);
}
.dark-theme .ant-select-dropdown-menu-item-group-title {
  color: #E9F6FF;
}
.dark-theme .ant-select-auto-complete.ant-select textarea.ant-input {
  background: rgba(250, 250, 250, 0.1) !important;
}
.dark-theme .ant-select-tree,
.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper {
  color: #E9F6FF;
}
.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper:hover,
.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #18344f;
}
.dark-theme .ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field,
.dark-theme .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner,
.dark-theme .ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  border-color: #18344f;
  background-color: #18344f;
}
.dark-theme .ant-select-show-search .ant-select-selection {
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.dark-theme .ant-transfer-list-search-action,
.dark-theme .ant-transfer-list-search-action i {
  color: #E9F6FF;
}
.dark-theme .ant-transfer-list {
  border-color: #1c3c5a;
  color: #E9F6FF;
}
.dark-theme .ant-transfer-list-body-with-search {
  background-color: #18344f;
}
.dark-theme .ant-transfer-list-header {
  background-color: #18344f;
  border-color: #1c3c5a;
  color: #E9F6FF;
}
.dark-theme .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {
  background-color: #1c3c5a;
}
.dark-theme .ant-transfer-list-footer {
  border-top-color: #1c3c5a;
  background-color: #18344f;
}
.dark-theme .ant-transfer-list-content-item-disabled {
  color: #1da3ff;
}
.dark-theme .ant-calendar {
  background-color: #18344f;
  border-color: #18344f;
  color: #E9F6FF;
}
.dark-theme .ant-calendar-today .ant-calendar-date {
  border-color: #30689d;
  color: #30689d;
  background-color: #244e76;
}
.dark-theme .ant-calendar-selected-date .ant-calendar-date,
.dark-theme .ant-calendar-selected-start-date .ant-calendar-date,
.dark-theme .ant-calendar-selected-end-date .ant-calendar-date,
.dark-theme .ant-calendar-selected-day .ant-calendar-date {
  background: #30689d;
  color: #E9F6FF;
}
.dark-theme .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover,
.dark-theme .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month,
.dark-theme .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year,
.dark-theme .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover,
.dark-theme .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade,
.dark-theme .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {
  background: #30689d;
  color: #E9F6FF;
}
.dark-theme .ant-calendar-month-panel-month:hover,
.dark-theme .ant-calendar-year-panel-year:hover,
.dark-theme .ant-calendar-decade-panel-decade:hover {
  background: #244e76;
}
.dark-theme .ant-calendar-input {
  color: #E9F6FF;
  background-color: #18344f;
}
.dark-theme .ant-calendar-month-panel,
.dark-theme .ant-calendar-year-panel,
.dark-theme .ant-calendar-decade-panel {
  background-color: #18344f;
}
.dark-theme .ant-calendar-header,
.dark-theme .ant-calendar-input-wrap,
.dark-theme .ant-calendar-month-panel-header,
.dark-theme .ant-calendar-year-panel-header,
.dark-theme .ant-calendar-decade-panel-header {
  border-bottom-color: #1c3c5a;
}
.dark-theme .ant-calendar-footer,
.dark-theme .ant-calendar-range .ant-calendar-body,
.dark-theme .ant-calendar-range .ant-calendar-month-panel-body,
.dark-theme .ant-calendar-range .ant-calendar-year-panel-body {
  border-top-color: #1c3c5a;
}
.dark-theme .ant-calendar-picker-icon,
.dark-theme .ant-calendar-picker-icon:after {
  color: #E9F6FF;
}
.dark-theme .ant-calendar-header .ant-calendar-prev-century-btn,
.dark-theme .ant-calendar-header .ant-calendar-next-century-btn,
.dark-theme .ant-calendar-header .ant-calendar-prev-decade-btn,
.dark-theme .ant-calendar-header .ant-calendar-next-decade-btn,
.dark-theme .ant-calendar-header .ant-calendar-prev-month-btn,
.dark-theme .ant-calendar-header .ant-calendar-next-month-btn,
.dark-theme .ant-calendar-header .ant-calendar-prev-year-btn,
.dark-theme .ant-calendar-header .ant-calendar-next-year-btn,
.dark-theme .ant-calendar-header .ant-calendar-century-select,
.dark-theme .ant-calendar-header .ant-calendar-decade-select,
.dark-theme .ant-calendar-header .ant-calendar-year-select,
.dark-theme .ant-calendar-header .ant-calendar-month-select {
  color: #E9F6FF;
}
.dark-theme .ant-calendar .ant-calendar-disabled-cell .ant-calendar-date {
  background-color: rgba(250, 250, 250, 0.1);
}
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,
.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {
  color: #E9F6FF;
}
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,
.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {
  color: #E9F6FF;
}
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,
.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
  color: #E9F6FF;
}
.dark-theme .ant-calendar-date {
  color: #E9F6FF;
}
.dark-theme .ant-calendar-date:hover {
  background: #244e76;
}
.dark-theme .ant-calendar-last-month-cell .ant-calendar-date,
.dark-theme .ant-calendar-next-month-btn-day .ant-calendar-date,
.dark-theme .ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,
.dark-theme .ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year,
.dark-theme .ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,
.dark-theme .ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {
  color: #83ccff;
}
.dark-theme .ant-calendar-picker-clear {
  color: #E9F6FF;
  background: none;
}
.dark-theme .ant-calendar .ant-calendar-ok-btn {
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
}
.dark-theme .ant-calendar-range .ant-calendar-in-range-cell:before {
  background-color: #1a3956;
}
.dark-theme .ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {
  background: #1a3956;
}
.dark-theme .ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day .ant-calendar-date,
.dark-theme .ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day:hover .ant-calendar-date,
.dark-theme .ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {
  color: #E9F6FF;
}
.dark-theme .ant-fullcalendar {
  color: #E9F6FF;
  border-top-color: #495762;
}
.dark-theme .ant-fullcalendar-value {
  color: #E9F6FF;
}
.dark-theme .ant-fullcalendar-value:hover {
  background: #18344f;
}
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
  color: #E9F6FF;
  border-top-color: #1c3c5a;
}
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
  background: #18344f;
  color: #E9F6FF;
}
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {
  border-top-color: #1c3c5a;
}
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date,
.dark-theme .ant-fullcalendar-last-month-cell .ant-fullcalendar-value,
.dark-theme .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {
  color: #83ccff;
}
.dark-theme .ant-fullcalendar-selected-day .ant-fullcalendar-value,
.dark-theme .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
  background: #18344f;
  color: #E9F6FF;
}
.dark-theme .ant-fullcalendar-today .ant-fullcalendar-value,
.dark-theme .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
  box-shadow: 0 0 0 1px #30689d inset;
  background: #30689d;
}
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,
.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {
  color: #E9F6FF;
  background-color: transparent;
  box-shadow: none;
}
.dark-theme .ant-time-picker-panel,
.dark-theme .ant-time-picker-icon,
.dark-theme .ant-time-picker-icon:after {
  color: #E9F6FF;
}
.dark-theme .ant-time-picker-panel-inner {
  background-color: #18344f;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.dark-theme .ant-time-picker-panel-input-wrap {
  border-bottom-color: #1c3c5a;
}
.dark-theme .ant-time-picker-panel-input-wrap .ant-time-picker-panel-input {
  background-color: transparent;
}
.dark-theme .ant-time-picker-panel-input-wrap .gx-link,
.dark-theme .ant-time-picker-panel-input-wrap .gx-link:hover,
.dark-theme .ant-time-picker-panel-input-wrap .gx-link:focus,
.dark-theme .ant-time-picker-panel-input-wrap .gx-link.ant-time-picker-panel-clear-btn:after {
  color: #E9F6FF;
}
.dark-theme .ant-time-picker-input {
  background-color: rgba(250, 250, 250, 0.1);
  border-color: rgba(250, 250, 250, 0.1);
  color: #E9F6FF;
}
.dark-theme .ant-time-picker-input:focus,
.dark-theme .ant-time-picker-input:hover {
  border-color: rgba(245, 245, 245, 0.1);
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.dark-theme .ant-time-picker-panel-select {
  border-left-color: #1c3c5a;
}
.dark-theme .ant-time-picker-panel-select li:hover {
  background: #1a3956;
}
.dark-theme li.ant-time-picker-panel-select-option-selected {
  background: #1c3c5a;
}
.dark-theme .ant-slider-mark-text {
  color: #1da3ff;
}
.dark-theme .ant-slider-mark-text-active {
  color: #ffffff;
}
.dark-theme .ant-slider-track {
  background-color: #18344f;
}
.dark-theme .ant-slider-active {
  border-color: #18344f;
}
.dark-theme .ant-radio {
  color: #E9F6FF;
}
.dark-theme .ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
.dark-theme .ant-radio:hover .ant-radio-inner,
.dark-theme .ant-radio-focused .ant-radio-inner {
  border-color: #2a5b89;
}
.dark-theme .ant-radio-checked:after {
  border-color: #2a5b89;
}
.dark-theme .ant-radio-checked .ant-radio-inner {
  border-color: #2a5b89;
}
.dark-theme .ant-radio-disabled + span {
  color: #E9F6FF;
}
.dark-theme .ant-radio-button-wrapper {
  color: #2a5b89;
  background-color: transparent;
  border-color: #2a5b89;
}
.dark-theme .ant-radio-button-wrapper:hover,
.dark-theme .ant-radio-button-wrapper:focus {
  color: #E9F6FF;
}
.dark-theme .ant-radio-button-wrapper-checked {
  box-shadow: none;
  border-color: #77a7d5;
  color: #77a7d5;
}
.dark-theme .ant-radio-button-wrapper-checked:hover,
.dark-theme .ant-radio-button-wrapper-checked:focus {
  color: #E9F6FF;
}
.dark-theme .ant-radio-button-wrapper-checked:first-child {
  border-color: #77a7d5;
  color: #77a7d5;
}
.dark-theme .ant-radio-button-wrapper:not(:first-child):before {
  background-color: #2a5b89;
}
.dark-theme .ant-radio-button-wrapper-checked:before {
  background-color: #2a5b89 !important;
}
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {
  color: #2a5b89;
}
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:hover,
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:focus {
  color: #1e4162;
}
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  color: #E9F6FF;
  background-color: #13c2c2;
}
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:hover,
.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:focus {
  color: #ffffff;
}
.dark-theme .ant-btn {
  color: #535353;
}
.dark-theme .ant-btn:hover,
.dark-theme .ant-btn:focus {
  color: #535353;
  border-color: #112437;
}
.dark-theme .ant-btn-primary {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.dark-theme .ant-btn-primary:hover,
.dark-theme .ant-btn-primary:focus {
  background-color: #12a3e8;
  border-color: #12a3e8;
  color: #ffffff;
}
.dark-theme .ant-btn-primary.disabled,
.dark-theme .ant-btn-primary:disabled,
.dark-theme .ant-btn-primary:not([disabled]):not(.disabled):active,
.dark-theme .ant-btn-primary:not([disabled]):not(.disabled).active {
  background-color: #060d14;
  border-color: #060d14;
}
.dark-theme .ant-btn-danger {
  color: #f44336;
  background-color: transparent;
  border-color: #f44336;
}
.dark-theme .ant-btn-danger:hover,
.dark-theme .ant-btn-danger:focus {
  color: #ffffff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme .ant-btn-background-ghost.ant-btn-primary {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
  color: #ffffff;
}
.dark-theme .ant-btn-background-ghost.ant-btn-primary:hover,
.dark-theme .ant-btn-background-ghost.ant-btn-primary:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.dark-theme .verify-container .ant-btn {
  color: #ffffff;
}
.dark-theme .gx-header-search .ant-select-selection {
  background-color: #060d14;
  border-color: #e8e8e8;
  color: #E9F6FF;
  margin-left: -1px;
}
.dark-theme .gx-header-search .ant-select-selection:focus {
  color: #E9F6FF;
  background-color: #000000;
  border-color: #e8e8e8;
}
.dark-theme .gx-header-search .ant-select-arrow {
  color: #E9F6FF;
}
.dark-theme .ant-upload {
  color: #E9F6FF;
}
.dark-theme .ant-upload.ant-upload-drag {
  background-color: #0e1f2f;
  border-color: #0e1f2f;
  color: #E9F6FF;
}
.dark-theme .ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #E9F6FF;
}
.dark-theme .ant-upload.ant-upload-drag p.ant-upload-text,
.dark-theme .ant-upload.ant-upload-drag p.ant-upload-hint {
  color: #E9F6FF;
}
.dark-theme .ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #495762;
}
.dark-theme .ant-upload-list-item a,
.dark-theme .ant-upload-list-item-info .anticon-loading,
.dark-theme .ant-upload-list-item-info .anticon-paper-clip {
  color: #E9F6FF;
}
.dark-theme .ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #18344f;
}
.dark-theme .ant-upload.ant-upload-select-picture-card {
  background-color: #0e1f2f;
  border-color: #0e1f2f;
}
.dark-theme .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #495762;
}
.dark-theme .ant-switch {
  color: #ffffff;
}
.dark-theme .ant-switch-checked {
  background-color: #0c1a27;
}
.dark-theme .gx-bg-grey {
  background-color: #999999 !important;
}
.dark-theme .ant-breadcrumb {
  color: #bfbfbf;
}
.dark-theme .ant-breadcrumb-separator,
.dark-theme .ant-breadcrumb > span:last-child {
  color: #bfbfbf;
}
.dark-theme .ant-dropdown {
  color: #E9F6FF;
}
.dark-theme .ant-dropdown-menu {
  background-color: #08121c;
}
.dark-theme .ant-dropdown-menu-item,
.dark-theme .ant-dropdown-menu-submenu-title {
  color: #E9F6FF;
}
.dark-theme .ant-dropdown-menu-item:hover,
.dark-theme .ant-dropdown-menu-submenu-title:hover {
  background-color: #142c43;
}
.dark-theme .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after,
.dark-theme .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {
  color: #E9F6FF;
}
.dark-theme .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,
.dark-theme .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after {
  color: #83ccff;
}
.dark-theme .ant-steps-item {
  color: #E9F6FF;
}
.dark-theme .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #12273B;
  border-color: #E9F6FF;
}
.dark-theme .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #E9F6FF;
}
.dark-theme .ant-steps-item-process .ant-steps-item-icon {
  background-color: #18344f;
  border-color: #18344f;
}
.dark-theme .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #E9F6FF;
}
.dark-theme .ant-steps-item-wait .ant-steps-item-icon {
  background-color: #12273B;
  border-color: #1e4162;
}
.dark-theme .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
  color: #1e4162;
}
.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-description,
.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-description,
.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-description {
  color: #83ccff;
}
.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title,
.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title,
.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title {
  color: #E9F6FF;
}
.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title:after,
.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title:after,
.dark-theme .ant-steps-item-process > .ant-steps-item-tail:after,
.dark-theme .ant-steps-item-error > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #495762;
}
.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after,
.dark-theme .ant-steps-item-finish > .ant-steps-item-tail:after {
  background-color: #E9F6FF;
}
.dark-theme .ant-steps-item-error .ant-steps-item-icon {
  background-color: #12273B;
}
.dark-theme .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
.dark-theme .ant-steps-item-finish > .ant-steps-item-tail:after,
.dark-theme .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #000102;
}
.dark-theme .ant-steps-item-process > .ant-steps-item-tail:after,
.dark-theme .ant-steps-item-wait > .ant-steps-item-tail:after {
  background-color: #1c3c5a;
}
.dark-theme .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
  background: #1c3c5a;
}
.dark-theme .steps-content {
  border-color: #495762;
  background-color: #18344f;
}
.dark-theme .ant-collapse {
  background-color: #18344f;
  border-color: #1e4162;
  color: #E9F6FF;
}
.dark-theme .ant-collapse.gx-collapse-custom {
  background-color: transparent;
}
.dark-theme .ant-collapse.gx-collapse-custom .ant-collapse-item {
  background-color: #18344f;
}
.dark-theme .ant-collapse > .ant-collapse-item {
  border-color: #1e4162;
}
.dark-theme .ant-collapse .ant-collapse {
  border-color: #2c6091;
}
.dark-theme .ant-collapse .ant-collapse > .ant-collapse-item {
  border-color: #2c6091;
}
.dark-theme .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  color: #E9F6FF;
}
.dark-theme .ant-collapse-content {
  color: #E9F6FF;
  background-color: #20466a;
  border-top-color: #1e4162;
}
.dark-theme .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,
.dark-theme .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
  color: #1da3ff;
}
.dark-theme .ant-carousel {
  color: #E9F6FF;
}
.dark-theme .ant-carousel .slick-slide {
  background-color: #18344f;
}
.dark-theme .ant-tree {
  color: #E9F6FF;
}
.dark-theme .ant-tree li .ant-tree-node-content-wrapper {
  color: #E9F6FF;
}
.dark-theme .ant-tree li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),
.dark-theme .ant-tree li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,
.dark-theme .ant-tree li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
  color: #1da3ff;
}
.dark-theme .ant-tree li .ant-tree-node-content-wrapper:hover,
.dark-theme .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: transparent;
  color: #12273B;
  font-weight: 700;
}
.dark-theme .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,
.dark-theme .ant-tree-checkbox:hover .ant-tree-checkbox-inner,
.dark-theme .ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {
  border-color: #0c1a27;
}
.dark-theme .ant-tree-checkbox-checked .ant-tree-checkbox-inner,
.dark-theme .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
  background-color: #0c1a27;
  border-color: #0c1a27 !important;
}
.dark-theme .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  background: transparent;
  color: #E9F6FF;
}
.dark-theme .ant-tag-checkable {
  color: #E9F6FF;
}
.dark-theme .ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
  color: #ffffff;
}
.dark-theme .ant-progress-text,
.dark-theme .ant-progress-circle .ant-progress-text {
  color: #E9F6FF;
}
.dark-theme .ant-anchor-wrapper {
  background-color: transparent;
}
.dark-theme .ant-anchor-link-active > .ant-anchor-link-title {
  color: #b6e1ff;
}
.dark-theme .rdw-editor-wrapper {
  color: #006cb6;
  background-color: #fff;
}
.dark-theme .rdw-editor-wrapper + textarea {
  color: #006cb6;
}
.dark-theme .gx-contact-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-draggable-icon {
  color: #E9F6FF;
}
.dark-theme .gx-draggable-icon:hover,
.dark-theme .gx-draggable-icon:focus,
.dark-theme .gx-draggable-icon:active {
  color: #ffffff;
}
.dark-theme .sweet-alert,
.dark-theme .gx-map-content {
  color: #006cb6;
}
.dark-theme .sweet-alert h1,
.dark-theme .gx-map-content h1,
.dark-theme .sweet-alert h2,
.dark-theme .gx-map-content h2,
.dark-theme .sweet-alert h3,
.dark-theme .gx-map-content h3,
.dark-theme .sweet-alert h4,
.dark-theme .gx-map-content h4,
.dark-theme .sweet-alert h5,
.dark-theme .gx-map-content h5,
.dark-theme .sweet-alert h6,
.dark-theme .gx-map-content h6,
.dark-theme .sweet-alert .h1,
.dark-theme .gx-map-content .h1,
.dark-theme .sweet-alert .h2,
.dark-theme .gx-map-content .h2,
.dark-theme .sweet-alert .h3,
.dark-theme .gx-map-content .h3,
.dark-theme .sweet-alert .h4,
.dark-theme .gx-map-content .h4,
.dark-theme .sweet-alert .h5,
.dark-theme .gx-map-content .h5,
.dark-theme .sweet-alert .h6,
.dark-theme .gx-map-content .h6 {
  color: #006cb6;
}
@media screen and (max-width: 991px) {
  .dark-theme .gx-module-side {
    background-color: #ffffff;
  }
}
.dark-theme .gx-module-side-header {
  border-bottom-color: #495762;
  background-color: #12273B;
  color: #E9F6FF;
}
.dark-theme .gx-module-nav li .gx-link {
  color: #E9F6FF;
}
.dark-theme .gx-module-nav li .gx-link:hover,
.dark-theme .gx-module-nav li .gx-link:focus,
.dark-theme .gx-module-nav li .gx-link.active {
  color: #ffffff;
}
.dark-theme .gx-module-box-header {
  background-color: #12273B;
  border-bottom-color: #495762;
}
@media screen and (max-width: 991px) {
  .dark-theme .gx-module-box-header .gx-drawer-btn {
    border-right-color: #495762;
  }
}
.dark-theme .gx-module-box-content {
  background-color: #12273B;
}
.dark-theme .gx-module-box-topbar,
.dark-theme .gx-module-list-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-toolbar-separator {
  border-left-color: #495762;
}
.dark-theme .gx-module-sidenav {
  background-color: #12273B;
  border-right-color: #495762;
}
.dark-theme .rbc-event {
  background-color: #2a5b89;
}
.dark-theme .rbc-event.rbc-selected {
  background-color: #060d14;
}
.dark-theme .rbc-slot-selection {
  background-color: #1e4162;
}
.dark-theme .rbc-toolbar button {
  color: #E9F6FF;
  border-color: #E9F6FF;
}
.dark-theme .rbc-toolbar button:active,
.dark-theme .rbc-toolbar button.rbc-active,
.dark-theme .rbc-toolbar button:active:hover,
.dark-theme .rbc-toolbar button.rbc-active:hover,
.dark-theme .rbc-toolbar button:active:focus,
.dark-theme .rbc-toolbar button.rbc-active:focus,
.dark-theme .rbc-toolbar button:focus,
.dark-theme .rbc-toolbar button:hover {
  color: #051B30;
  background-color: #E9F6FF;
  border-color: #E9F6FF;
}
.dark-theme .rbc-date-cell .gx-link {
  color: #E9F6FF;
}
.dark-theme .rbc-date-cell .gx-link:hover,
.dark-theme .rbc-date-cell .gx-link:focus {
  color: #ffffff;
}
.dark-theme .rbc-off-range-bg {
  background: #1e4162;
}
.dark-theme .rbc-off-range-bg .gx-link {
  color: #1da3ff;
}
.dark-theme .rbc-off-range-bg .gx-link:hover,
.dark-theme .rbc-off-range-bg .gx-link:focus {
  color: #E9F6FF;
}
.dark-theme .gx-com-calendar-card {
  border-color: #495762;
}
.dark-theme .gx-chat-module-box {
  background-color: #12273B;
}
.dark-theme .gx-chat-sidenav {
  border-right-color: #495762;
}
.dark-theme .gx-chat-sidenav-header {
  background-color: #18344f;
  border-bottom-color: #495762;
}
.dark-theme .gx-chat-sidenav-content {
  background-color: #12273B;
}
.dark-theme .gx-chat-sidenav-title {
  color: #E9F6FF;
}
.dark-theme .gx-chat-tabs-header {
  background-color: #18344f !important;
}
.dark-theme .gx-chat-user-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-chat-user-item.active,
.dark-theme .gx-chat-user-item:hover {
  background-color: #162f47;
}
.dark-theme .gx-chat-info-des {
  color: #E9F6FF;
}
.dark-theme .gx-chat-main-header {
  border-bottom-color: #495762;
  background-color: #12273B;
}
.dark-theme .gx-chat-main-footer {
  border-top-color: #495762;
  background-color: #12273B;
}
.dark-theme .gx-chat-item .gx-bubble {
  background-color: #142c43;
  border-color: #495762;
}
.dark-theme .gx-chat-item.gx-flex-row-reverse .gx-bubble {
  background-color: #18344f;
}
.dark-theme .gx-error-code {
  color: #E9F6FF;
  text-shadow: 10px 6px 8px rgba(255, 117, 117, 0.8);
}
.dark-theme .gx-btn-yellow,
.dark-theme .gx-link.gx-btn-yellow {
  color: #262626 !important;
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.dark-theme .gx-btn-yellow:hover,
.dark-theme .gx-link.gx-btn-yellow:hover,
.dark-theme .gx-btn-yellow:focus,
.dark-theme .gx-link.gx-btn-yellow:focus {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.dark-theme .gx-btn-yellow.disabled,
.dark-theme .gx-link.gx-btn-yellow.disabled,
.dark-theme .gx-btn-yellow:disabled,
.dark-theme .gx-link.gx-btn-yellow:disabled {
  background-color: #fadb14 !important;
  border-color: #fadb14 !important;
}
.dark-theme .gx-btn-yellow:not([disabled]):not(.disabled):active,
.dark-theme .gx-link.gx-btn-yellow:not([disabled]):not(.disabled):active,
.dark-theme .gx-btn-yellow:not([disabled]):not(.disabled).active,
.dark-theme .gx-link.gx-btn-yellow:not([disabled]):not(.disabled).active {
  color: #ffffff !important;
  background-color: #d6ba05 !important;
  border-color: #d6ba05 !important;
}
.dark-theme .gx-package {
  background-color: #ffffff;
  color: #595959;
}
.dark-theme .gx-package-header > .gx-price {
  color: #ffffff;
}
.dark-theme .gx-package-header.gx-text-white {
  color: #595959 !important;
}
.dark-theme .gx-customizer-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .ant-layout-sider-dark .gx-sidebar-notifications,
.dark-theme .gx-drawer-sidebar-dark .gx-sidebar-notifications {
  border-bottom-color: #495762;
}
.dark-theme .ant-layout-sider-dark .gx-app-nav,
.dark-theme .gx-drawer-sidebar-dark .gx-app-nav {
  color: #E9F6FF;
}
.dark-theme .gx-text-grey {
  color: #E9F6FF !important;
}
.dark-theme .gx-currentplan-col .gx-bg-dark {
  background-color: #E9F6FF !important;
}
.dark-theme .gx-chart-up {
  color: #52c41a;
}
.dark-theme .gx-bg-geekblue .gx-chart-up,
.dark-theme .gx-overlay-primary .gx-chart-up,
.dark-theme .gx-overlay-pink .gx-chart-down {
  color: #ffffff;
}
.dark-theme .gx-chart-down {
  color: #f5222d;
}
.dark-theme .gx-text-black {
  color: #ffffff !important;
}
.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a {
  color: #E9F6FF;
}
.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,
.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {
  color: #2EB1EF;
}
.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-count {
  color: #E9F6FF;
}
.dark-theme .ais-Breadcrumb,
.dark-theme .ais-ClearRefinements,
.dark-theme .ais-CurrentRefinements,
.dark-theme .ais-GeoSearch,
.dark-theme .ais-HierarchicalMenu,
.dark-theme .ais-Hits,
.dark-theme .ais-Results,
.dark-theme .ais-HitsPerPage,
.dark-theme .ais-ResultsPerPage,
.dark-theme .ais-InfiniteHits,
.dark-theme .ais-InfiniteResults,
.dark-theme .ais-Menu,
.dark-theme .ais-MenuSelect,
.dark-theme .ais-NumericMenu,
.dark-theme .ais-NumericSelector,
.dark-theme .ais-Pagination,
.dark-theme .ais-Panel,
.dark-theme .ais-PoweredBy,
.dark-theme .ais-RangeInput,
.dark-theme .ais-RangeSlider,
.dark-theme .ais-RatingMenu,
.dark-theme .ais-RefinementList,
.dark-theme .ais-RefinementList-count,
.dark-theme .ais-SearchBox,
.dark-theme .ais-SortBy,
.dark-theme .ais-Stats,
.dark-theme .ais-ToggleRefinement,
.dark-theme .ais-RatingMenu-count,
.dark-theme .gx-algolia-category-title {
  color: #E9F6FF;
}
.dark-theme .ais-SearchBox-input,
.dark-theme .ais-RangeInput-input,
.dark-theme .ais-MenuSelect-select,
.dark-theme .ais-NumericSelector-select,
.dark-theme .ais-HitsPerPage-select,
.dark-theme .ais-ResultsPerPage-select,
.dark-theme .ais-SortBy-select,
.dark-theme .gx-link.ais-Pagination-link:hover,
.dark-theme .gx-link.ais-Pagination-link:focus {
  color: #051B30;
}
.dark-theme .gx-link.ais-Pagination-link--selected:hover,
.dark-theme .gx-link.ais-Pagination-link--selected:focus {
  color: #ffffff;
}
.dark-theme .ais-RangeInput-submit,
.dark-theme .ais-ClearRefinements-button,
.dark-theme .ais-CurrentRefinements-reset,
.dark-theme .ais-GeoSearch-redo,
.dark-theme .ais-GeoSearch-reset,
.dark-theme .ais-HierarchicalMenu-showMore,
.dark-theme .ais-InfiniteHits-loadMore,
.dark-theme .ais-InfiniteResults-loadMore,
.dark-theme .ais-Menu-showMore,
.dark-theme .ais-RefinementList-showMore {
  background-color: #E9F6FF;
  color: #051B30;
}
.dark-theme .ais-RangeInput-submit:focus,
.dark-theme .ais-ClearRefinements-button:focus,
.dark-theme .ais-CurrentRefinements-reset:focus,
.dark-theme .ais-GeoSearch-redo:focus,
.dark-theme .ais-GeoSearch-reset:focus,
.dark-theme .ais-HierarchicalMenu-showMore:focus,
.dark-theme .ais-InfiniteHits-loadMore:focus,
.dark-theme .ais-InfiniteResults-loadMore:focus,
.dark-theme .ais-Menu-showMore:focus,
.dark-theme .ais-RefinementList-showMore:focus,
.dark-theme .ais-RangeInput-submit:hover,
.dark-theme .ais-ClearRefinements-button:hover,
.dark-theme .ais-CurrentRefinements-reset:hover,
.dark-theme .ais-GeoSearch-redo:hover,
.dark-theme .ais-GeoSearch-reset:hover,
.dark-theme .ais-HierarchicalMenu-showMore:hover,
.dark-theme .ais-InfiniteHits-loadMore:hover,
.dark-theme .ais-InfiniteResults-loadMore:hover,
.dark-theme .ais-Menu-showMore:hover,
.dark-theme .ais-RefinementList-showMore:hover {
  background-color: #E9F6FF;
}
.dark-theme .ais-Breadcrumb-link,
.dark-theme .ais-HierarchicalMenu-link,
.dark-theme .ais-Menu-link,
.dark-theme .ais-Pagination-link,
.dark-theme .ais-RatingMenu-link {
  color: #051B30;
}
.dark-theme .ais-Breadcrumb-link:focus,
.dark-theme .ais-HierarchicalMenu-link:focus,
.dark-theme .ais-Menu-link:focus,
.dark-theme .ais-Pagination-link:focus,
.dark-theme .ais-RatingMenu-link:focus,
.dark-theme .ais-Breadcrumb-link:hover,
.dark-theme .ais-HierarchicalMenu-link:hover,
.dark-theme .ais-Menu-link:hover,
.dark-theme .ais-Pagination-link:hover,
.dark-theme .ais-RatingMenu-link:hover {
  color: #051B30;
}
.dark-theme .ais-Pagination-item--selected .ais-Pagination-link {
  background-color: #2EB1EF;
  border-color: #495762;
}
.dark-theme .gx-card-profile.gx-card-tabs .ant-card-head,
.dark-theme .gx-featured-item:not(:last-child) {
  border-bottom-color: #495762;
}
.dark-theme .gx-follower-list li,
.dark-theme .gx-follower-title {
  color: #E9F6FF;
}
.dark-theme .gx-header-horizontal-main .gx-header-notifications li > span {
  color: #E9F6FF;
}
.dark-theme .gx-profile-banner {
  background-color: #051b30;
}
.dark-theme .gx-text-primary {
  color: #13c2c2 !important;
}
.dark-theme .gx-text-primary.gx-icon-white {
  color: #ffffff !important;
}
.dark-theme .gx-link.gx-text-primary:hover,
.dark-theme .gx-link.gx-text-primary:focus {
  color: #006d75 !important;
}
.dark-theme .gx-bg-primary {
  background-color: #13c2c2 !important;
}
.dark-theme .gx-link.gx-bg-primary:hover,
.dark-theme .gx-link.gx-bg-primary:focus {
  background-color: #006d75 !important;
}
.dark-theme .gx-border-primary {
  border-color: #13c2c2 !important;
}
.dark-theme .gx-btn-primary,
.dark-theme .gx-link.gx-btn-primary,
.dark-theme .btn-primary {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.dark-theme .gx-btn-primary:hover,
.dark-theme .gx-link.gx-btn-primary:hover,
.dark-theme .btn-primary:hover,
.dark-theme .gx-btn-primary:focus,
.dark-theme .gx-link.gx-btn-primary:focus,
.dark-theme .btn-primary:focus {
  background-color: #006d75 !important;
  border-color: #006d75 !important;
}
.dark-theme .gx-btn-primary.disabled,
.dark-theme .gx-link.gx-btn-primary.disabled,
.dark-theme .btn-primary.disabled,
.dark-theme .gx-btn-primary:disabled,
.dark-theme .gx-link.gx-btn-primary:disabled,
.dark-theme .btn-primary:disabled {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.dark-theme .gx-btn-primary:not([disabled]):not(.disabled):active,
.dark-theme .gx-link.gx-btn-primary:not([disabled]):not(.disabled):active,
.dark-theme .btn-primary:not([disabled]):not(.disabled):active,
.dark-theme .gx-btn-primary:not([disabled]):not(.disabled).active,
.dark-theme .gx-link.gx-btn-primary:not([disabled]):not(.disabled).active,
.dark-theme .btn-primary:not([disabled]):not(.disabled).active {
  background-color: #006d75 !important;
  border-color: #006d75 !important;
}
.dark-theme .gx-btn-outline-primary,
.dark-theme .gx-link.gx-btn-outline-primary {
  color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.dark-theme .gx-btn-outline-primary:hover,
.dark-theme .gx-link.gx-btn-outline-primary:hover,
.dark-theme .gx-btn-outline-primary:focus,
.dark-theme .gx-link.gx-btn-outline-primary:focus {
  color: #ffffff !important;
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}
.dark-theme .gx-btn-outline-primary.disabled,
.dark-theme .gx-link.gx-btn-outline-primary.disabled,
.dark-theme .gx-btn-outline-primary:disabled,
.dark-theme .gx-link.gx-btn-outline-primary:disabled {
  color: #13c2c2 !important;
}
.dark-theme .gx-badge-primary,
.dark-theme .gx-entry-title:before {
  background-color: #13c2c2 !important;
}
.dark-theme .gx-bg-white .gx-text-grey {
  color: #051B30 !important;
}
@media screen and (max-width: 991px) {
  .dark-theme .gx-popover-horizantal .gx-search-bar input[type="search"] {
    background: none !important;
  }
  .dark-theme .gx-popover-horizantal .gx-search-bar input[type="search"]:focus,
  .dark-theme .gx-popover-horizantal .gx-search-bar input[type="search"]:hover {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  .dark-theme .gx-popover-horizantal .ant-btn {
    background-color: transparent;
    border-color: transparent;
  }
  .dark-theme .gx-popover-horizantal .ant-btn:hover,
  .dark-theme .gx-popover-horizantal .ant-btn:focus {
    background-color: transparent;
    border-color: transparent;
  }
}
@media screen and (max-width: 767px) {
  .dark-theme .gx-table-responsive .ant-table {
    border: #495762;
  }
  .dark-theme .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {
    border-top-color: #495762;
  }
  .dark-theme .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {
    border-bottom-color: #495762;
  }
  .dark-theme .gx-timeline-center .gx-timeline-inverted:before {
    border-left-color: #495762;
  }
}
@media screen and (max-width: 475px) {
  .dark-theme .ant-input-group.ant-input-group-compact .gx-border-lt-xs {
    border-left-color: #495762 !important;
  }
}
@media screen and (min-width: 1600px) {
  h4,
  .h4 {
    font-size: 18px;
  }
}
.ant-tag-blue {
  font-weight: 400;
}
.ant-btn-primary,
.ant-btn,
.ant-btn.ant-btn-secondary,
.ant-btn-primary.ant-btn {
  min-height: 36px;
  color: #ffffff;
  font-size: 14px;
}
@media screen and (min-width: 1600px) {
  .ant-btn-primary,
  .ant-btn,
  .ant-btn.ant-btn-secondary,
  .ant-btn-primary.ant-btn {
    min-height: 40px;
    font-size: 16px;
  }
}
.ant-btn.ant-btn-primary {
  color: #ffffff;
}
.ant-btn.ant-btn-primary:hover,
.ant-btn.ant-btn-primary:focus {
  color: #ffffff;
}
.ant-btn.ant-btn-secondary {
  background-color: #D9D9D9;
  color: #545454;
  font-weight: 500;
}
.ant-btn.ant-btn-secondary:hover,
.ant-btn.ant-btn-secondary:focus {
  background-color: #e6e6e6;
  border-color: #e6e6e6;
}
.ant-btn.ant-btn-secondary.ant-btn-sm {
  font-size: 12px;
  min-height: 34px;
}
@media screen and (min-width: 1600px) {
  .ant-btn.ant-btn-secondary.ant-btn-sm {
    font-size: 14px;
    min-height: 36px;
  }
}
.green-button,
.drawer-form .green-button.ant-btn,
.green-button.ant-btn {
  background-color: #14B983;
  color: #ffffff;
  height: 40px;
  font-weight: 600;
  border-radius: 20px;
  border: none;
  font-size: 12px;
  min-height: 38px;
  padding: 0 12px;
}
@media screen and (min-width: 1600px) {
  .green-button,
  .drawer-form .green-button.ant-btn,
  .green-button.ant-btn {
    min-height: 40px;
    font-size: 14px;
  }
}
.green-button:hover,
.drawer-form .green-button.ant-btn:hover,
.green-button.ant-btn:hover,
.green-button:focus,
.drawer-form .green-button.ant-btn:focus,
.green-button.ant-btn:focus {
  background-color: #12a273;
  color: #fff;
}
.green-button.rounded-4,
.drawer-form .green-button.ant-btn.rounded-4,
.green-button.ant-btn.rounded-4 {
  border-radius: 4px;
}
.btn-note.ant-btn,
.dark-theme .btn-note.ant-btn {
  padding: 6px 12px;
  line-height: 1.2;
  border-color: #8d97a0;
  color: #545454;
}
.btn-note.ant-btn:hover,
.dark-theme .btn-note.ant-btn:hover,
.btn-note.ant-btn:focus,
.dark-theme .btn-note.ant-btn:focus {
  border-color: #8d97a0;
}
.dark-light-note {
  font-weight: 500;
  color: #383838;
}
.dark-theme .dark-light-note {
  color: #ffffff;
}
.view-full-calendar {
  color: #37A2B7;
  font-size: 14px;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 1600px) {
  .view-full-calendar {
    font-size: 16px;
  }
}
.white-note {
  font-size: 18px;
  color: #ffffff;
}
.ant-btn {
  margin-bottom: 0px;
}
.ant-form-item label {
  font-weight: 600;
}
.ant-btn.ant-btn-primary.secondary {
  background-color: #14B983;
  border-color: #14B983;
  font-weight: 500;
  margin-bottom: 0px;
}
.ant-btn.ant-btn-primary.secondary:hover,
.ant-btn.ant-btn-primary.secondary:focus {
  background-color: #13ab79;
  border-color: #14B983;
}
.ant-btn.prior-scans-visit-link {
  border: none;
  color: #2EB1EF;
  padding: 0px;
}
.ant-btn.prior-scans-visit-link:hover,
.ant-btn.prior-scans-visit-link:focus {
  color: #1199d9;
}
.dark-theme .ant-btn.ant-btn-link,
.ant-btn.ant-btn-link {
  color: #2EB1EF;
  font-size: 13px;
}
@media screen and (min-width: 1600px) {
  .dark-theme .ant-btn.ant-btn-link,
  .ant-btn.ant-btn-link {
    font-size: 15px;
  }
}
.dark-theme .ant-btn.ant-btn-link:hover,
.ant-btn.ant-btn-link:hover,
.dark-theme .ant-btn.ant-btn-link:focus,
.ant-btn.ant-btn-link:focus {
  color: #1199d9;
}
button.ant-btn.calendar-button:hover,
button.ant-btn.calendar-button:focus {
  color: #fff;
}
.ant-modal-confirm-btns .ant-btn {
  color: #6A6A6A;
  background: #E6E6E6;
  border-color: transparent;
}
.ant-modal-confirm-btns .ant-btn:hover,
.ant-modal-confirm-btns .ant-btn:focus {
  color: #6A6A6A;
  background: #d9d9d9;
  border-color: transparent;
}
.ant-modal-confirm-btns .ant-btn-primary {
  background-color: #2EB1EF;
  border-color: #2EB1EF;
}
.ant-modal-confirm-btns .ant-btn-primary:hover,
.ant-modal-confirm-btns .ant-btn-primary:focus {
  background-color: #16a8ed;
  border-color: #16a8ed;
  color: #ffffff;
}
.ant-btn.drawer-action-button,
.dark-theme .ant-btn.drawer-action-button {
  background-color: #CBD1D0;
  color: #051B30;
  border-radius: 10px;
  border: none;
  margin: 0px;
}
.ant-btn.drawer-action-button:hover,
.dark-theme .ant-btn.drawer-action-button:hover,
.ant-btn.drawer-action-buttonfocus,
.dark-theme .ant-btn.drawer-action-buttonfocus {
  background-color: #c3cac9;
}
.ant-btn.drawer-download-button,
.dark-theme .ant-btn.drawer-download-button {
  border: 1px solid #CBD1D0 !important;
  color: #6B6B6B !important;
  border-radius: 10px;
  border: none;
  margin: 0px;
}
.ant-btn.drawer-download-button:hover,
.dark-theme .ant-btn.drawer-download-button:hover,
.ant-btn.drawer-download-buttonfocus,
.dark-theme .ant-btn.drawer-download-buttonfocus {
  border: 1px solid #c3cac9 !important;
}
.ant-btn.delete-appointment-btn,
.dark-theme .ant-btn.delete-appointment-btn {
  background-color: #c44b55;
  color: #FFFFFF;
  border: none;
  margin: 0px;
}
.ant-btn.delete-appointment-btn:hover,
.dark-theme .ant-btn.delete-appointment-btn:hover,
.ant-btn.delete-appointment-btnfocus,
.dark-theme .ant-btn.delete-appointment-btnfocus {
  background-color: #c03f4a;
}
.ant-layout.ant-layout-has-sider > .ant-layout {
  background-color: #F1F1F1;
}
.ant-layout-header {
  height: auto;
  padding: 16px 25px;
  box-shadow: none;
  background-color: #F1F1F1;
}
.ant-layout-header .ant-select-selection-selected-value {
  color: #081C26;
}
.dark-theme .ant-layout-header .ant-select-selection-selected-value {
  color: #E9F6FF;
}
.gx-header-notifications .ant-select-selection {
  background-color: transparent;
  border-color: #9BA4AC;
  box-shadow: none;
}
.gx-header-notifications .ant-select-selection span.ant-select-arrow {
  color: #081C26;
}
.gx-card {
  background-color: transparent;
  box-shadow: none;
}
.dark-theme .gx-card {
  background-color: transparent;
  box-shadow: none;
}
.gx-card .ant-card-body {
  padding: 10px 8px;
}
.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar {
  width: 6px;
}
.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-track {
  height: 6px;
  background: #f5f5f5;
}
.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-track {
  background: #0B2B41;
}
.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}
.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb {
  background: #226380;
}
.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #256c8c;
}
.gx-card.listing-wrapper .ant-btn-link {
  min-height: 30px;
}
.gx-card.listing-wrapper .ant-btn.search-btn {
  background-color: #ffffff;
  border-color: #e3e3e3;
  color: #545454;
  margin: 0px;
  border-radius: 6px;
}
.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn {
  background-color: #082139;
  border-color: #082139;
  color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn:hover,
.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn:focus {
  background-color: #0b2e4f;
}
.gx-card.listing-wrapper .ant-btn.search-btn:hover,
.gx-card.listing-wrapper .ant-btn.search-btn:focus {
  background-color: #e3e3e3;
}
.drawer-form h2 {
  color: #051B30;
  font-size: 16px;
}
.drawer-form .ant-switch {
  height: 26px;
}
.drawer-form .ant-switch.ant-switch-checked {
  background-color: #14B983;
}
.drawer-form .ant-switch::after {
  top: 3px;
}
.drawer-form .ant-btn {
  color: #535353;
}
.drawer-form .ant-btn.ant-btn-primary {
  color: #ffffff;
}
.drawer-form .ant-form-item-label label {
  font-weight: 600;
}
.tabs-wrapper.ris-users-tab .ant-switch-checked {
  background-color: #2EB1EF;
}
.dark-theme .ant-layout-header .ant-select-selection {
  border-radius: 10px;
  background-color: #12273B;
  border-color: #12273B;
}
.dark-theme .gx-header-notifications .ant-select-selection .ant-select-arrow {
  color: #E9F6FF;
}
.dark-theme .ant-select-disabled .ant-select-selection {
  background-color: rgba(232, 232, 232, 0.4);
  border-color: rgba(232, 232, 232, 0.4);
  color: #595959;
}
.dark-theme .ant-btn-primary {
  color: #ffffff;
}
.dark-theme .ant-btn-link {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #82C9D7;
  line-height: 1.5;
  height: auto;
  margin: 0px;
  padding: 0px;
}
.dark-theme .ant-btn-link:hover,
.dark-theme .ant-btn-link:focus {
  background-color: transparent;
  border-color: transparent;
  color: #82C9D7;
}
.dark-theme .ant-select-dropdown.drawer-dropdown {
  background: #fff;
  color: #051B30;
}
.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item {
  color: #051B30;
  transition: .2s ease;
}
.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item:hover,
.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected,
.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
  color: #2e3a49;
  background-color: #f1f5f5;
}
.dark-theme .drawer-form .ant-form-item-label label {
  color: #6B6B6B;
}
.dark-theme tr.ant-table-expanded-row,
.dark-theme tr.ant-table-expanded-row .ant-table-thead > tr > th,
.dark-theme tr.ant-table-expanded-row .ant-table-tbody > tr > td,
.dark-theme tr.ant-table-expanded-row:hover {
  background: #082139;
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  border: none;
}
.dark-theme .examinations-table .ant-table {
  max-height: calc(100vh - 275px);
}
.dark-theme .examinations-table .ant-table-body .ant-table-row-expand-icon {
  font-size: 18px;
  color: #265077;
  border-color: #354D65;
}
.dark-theme .examinations-table .ant-table-thead > tr > th {
  font-size: 14px;
  font-weight: 600;
  background: #051B30;
  color: #E9F6FF;
  border-color: #051B30;
}
.dark-theme .examinations-table .ant-table-tbody > tr > td,
.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  padding: 12px 16px;
  background: transparent;
  font-weight: 300;
  border-bottom: none;
  background: #051B30;
}
.dark-theme .examinations-table .ant-table-tbody > tr > td .status-icon,
.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .status-icon {
  width: 12px;
  height: 12px;
}
.dark-theme .examinations-table .ant-table-tbody > tr > td .icon,
.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .icon {
  color: #354D65;
}
.dark-theme .examinations-table .ant-table-tbody > tr > td .undo-icon,
.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .undo-icon {
  color: #265077;
  font-size: 22px;
}
.dark-theme .examinations-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #082139;
  font-weight: 300;
  border-bottom: none;
}
.dark-theme .examinations-table .ant-select-disabled .ant-select-selection {
  color: #ddd;
}
.dark-theme .patient-visits-sidebar .ant-tree li .ant-tree-node-content-wrapper,
.dark-theme .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
.dark-theme .ant-tree li span.ant-tree-switcher .ant-tree-switcher-icon,
.dark-theme .patient-visits-sidebar .ant-tree .ant-tree-child-tree li .ant-tree-switcher_close .ant-tree-switcher-icon {
  color: #6A6D71;
  font-weight: 400;
}
.dark-theme .visit-history .patient-visits-sidebar .ant-tree li .ant-tree-node-content-wrapper,
.dark-theme .visit-history .patient-visits-sidebar .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
.dark-theme .visit-history .patient-visits-sidebar .ant-tree li span.ant-tree-switcher .ant-tree-switcher-icon,
.dark-theme .visit-history .patient-visits-sidebar .ant-tree .ant-tree-child-tree li .ant-tree-switcher_close .ant-tree-switcher-icon {
  color: #ffffff;
}
.dark-theme .ant-modal .invoices-table .ant-select,
.dark-theme .ant-modal .invoices-table .ant-select-selection-selected-value {
  color: #000000;
}
.dark-theme .ant-modal .invoices-table .ant-select-selection {
  border-color: #d9d9d9;
  margin: 4px;
  font-size: 14px;
}
.dark-theme .ant-modal .invoices-table .ant-calendar-picker {
  padding-right: 4px;
}
.dark-theme .white-box .examinations-table .ant-table-thead > tr > th {
  background-color: #fff;
  color: #6B6B6B;
}
.ant-tree-treenode-switcher-close::before {
  display: none;
}
.ant-tree-treenode-switcher-close.ant-tree-treenode-selected,
.visit-history .ant-tree-treenode-selected {
  background-color: #03AD6F;
  padding: 5px;
  border-radius: 4px;
}
.ant-tree-treenode-switcher-close.ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper,
.visit-history .ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper {
  color: #ffffff;
  font-weight: 500;
}
.ant-modal-body .ant-tree-treenode-switcher-close.ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper,
.ant-modal-body .visit-history .ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper {
  color: #000000;
}
.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected,
.ant-tree li .ant-tree-node-content-wrapper:hover {
  background-color: transparent;
}
.ant-modal-body .ant-tree-treenode-switcher-close.ant-tree-treenode-selected {
  background-color: transparent;
}
.white-box .examinations-table {
  padding: 0 8px;
}
.white-box .examinations-table table {
  display: block;
}
.white-box .examinations-table table thead.ant-table-thead {
  display: none;
}
.white-box .examinations-table .ant-table-tbody {
  display: block;
  width: 100%;
}
.white-box .examinations-table .ant-table-tbody > tr > td,
.white-box .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.white-box .examinations-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: transparent;
  width: 190px;
  padding: 4px;
  border-bottom: none;
}
.white-box .examinations-table .ant-table-tbody > tr {
  display: flex
;
  flex-wrap: wrap;
  width: 100%;
}
.quick-codes.white-box .examinations-table .ant-table-tbody > tr {
  border-bottom: 3px solid #f3f3f3;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.quick-codes.white-box .examinations-table .ant-table-tbody > tr:last-child {
  border-bottom: none;
}
.quick-codes.white-box .examinations-table .ant-table.ant-table-scroll-position-left {
  padding-right: 10px;
}
.quick-codes.white-box .patient-info-button {
  margin-left: auto !important;
}
.dark-theme .white-box .examinations-table .gx-link {
  color: #8B9293;
  background-color: #f5f5f5;
  padding: 6px 9px;
  border-radius: 3px;
  margin-top: 0px;
  display: inline-block;
}
.dark-theme .white-box .examinations-table .ant-select-selection-selected-value,
.white-box .examinations-table .ant-select-selection-selected-value,
.white-box .examinations-table input.ant-select-search__field {
  color: #6B6B6B;
}
.dark-theme .ant-modal-body .examinations-table .ant-table-tbody > tr > td,
.ant-modal-body .examinations-table .ant-table-tbody > tr > td {
  color: #ffffff;
}
.ant-input-disabled {
  color: #545454 !important;
}
.rad-tab-label .ant-badge .ant-badge-count {
  color: #38424B;
}
.search-patient {
  margin-left: 10px;
  width: 100%;
}
.search-site {
  margin-left: 20px;
}
.btn-panel {
  display: block;
  margin: auto;
}
.worklist-block .ant-form-item,
.patient-report-card .ant-form-item {
  margin-bottom: 4px !important;
}
.worklist-block .ant-form-item-label {
  text-align: left !important;
}
.worklist-block {
  margin-bottom: 20px;
}
#dob,
#startDate,
#endDate {
  width: 100% !important;
  margin-bottom: 0px !important;
}
.patient-visits-sidebar.report-sidebar {
  height: 350px;
  overflow-y: auto;
}
.patient-visits-sidebar.report-sidebar::-webkit-scrollbar,
.notes-sidebar::-webkit-scrollbar {
  height: 7px !important;
  width: 4px !important;
}
#visit-table::-webkit-scrollbar,
#visit-table .ant-table-thead::-webkit-scrollbar {
  height: 6px !important;
}
.cke_contents {
  height: 500px;
}
.report-editor .cke_contents {
  height: 316px !important;
}
.report-editor-icon {
  font-size: 20px;
  display: flex;
  justify-content: center;
}
.report-editor-icon:hover {
  cursor: pointer;
}
.custom-header {
  width: 600px;
}
.view-report {
  text-align: center !important;
  width: 103px !important;
}
#visit-table .ant-table-selection-column {
  padding: 0px !important;
}
#custom-sidebar > div::-webkit-scrollbar {
  height: 3px !important;
}
.gx-app-logo img {
  max-width: 155px;
}
.report-sidebar-container {
  border: 1px solid #f3f3f3;
  padding-left: 6px !important;
  padding-right: 0px !important;
  width: 100%;
  margin: auto !important;
  border-radius: 8px;
}
.report-sidebar-container.visit-history {
  border: none;
  padding-left: 0px !important;
}
section.visit-info-history-panel {
  display: flex;
  gap: 20px;
}
.mini-logo {
  margin-right: auto;
}
#visit-table,
#review-pending-report-table {
  font-size: 12px !important;
}
.custom-ant-input .ant-input {
  height: 31px !important;
  font-size: 12px !important;
}
.custom-radio-group span {
  font-size: 12px !important;
}
.custom-width {
  width: 300px;
}
.custom-search {
  margin-top: -5px !important;
  margin-bottom: 0px !important;
}
.custom-select {
  font-size: 12px;
}
.custom-select .ant-select-selection__placeholder {
  line-height: 18px;
}
.custom-select .ant-select-selection__rendered,
.custom-select .ant-select-selection--single {
  line-height: 30px;
  height: 30px;
}
@media screen and (min-width: 1600px) {
  .custom-select {
    font-size: 14px;
  }
}
.custom-input.ant-input {
  font-size: 12px;
  line-height: 30px;
  height: 30px;
}
@media screen and (min-width: 1600px) {
  .custom-input.ant-input {
    font-size: 14px;
  }
}
.calendar-select.ant-select .ant-select-selection {
  height: 40px;
}
.calendar-select.ant-select .ant-select-selection .ant-select-selection__rendered {
  line-height: 40px;
}
@media screen and (min-width: 1600px) {
  .calendar-select.ant-select {
    font-size: 16px;
  }
}
.white-box .custom-select .ant-select-selection__rendered,
.white-box .custom-select .ant-select-selection--single,
.white-box .custom-input.ant-input {
  border-color: #f3f3f3;
}
.macro-editor {
  top: 5px !important;
}
.macro-editor .cke_contents {
  height: 200px !important;
}
#review-pending-report-table button {
  margin: auto;
  display: block;
}
.report-viewer-sidebar {
  overflow-x: scroll;
  overflow-y: auto;
  height: 436px !important;
  padding: 0px !important;
}
.report-viewer-sidebar::-webkit-scrollbar {
  height: 7px !important;
  width: 4px !important;
}
.report-viewer-sidebar-container {
  padding-right: 0px !important;
}
.country-label .ant-form-item-label {
  padding-left: 0px !important;
}
.react-pdf__Page__canvas {
  width: 100% !important;
  height: auto !important;
}
.html-render-section {
  border: 1px solid #f3f3f3;
  padding: 1rem;
  width: 100%;
  border-radius: 4px;
  color: #222;
}
.html-render-section body {
  background-color: white !important;
}
.report-btn-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
  gap: 4px;
}
.report-viewer-editor-container {
  margin: 10px 0px;
}
.mip-submit {
  float: right !important;
}
.accounts-table .ant-table-tbody > tr > td,
.gx-card.listing-wrapper .accounts-table .ant-table-tbody > tr > td,
.accounts-table .ant-table-thead > tr > th,
.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th {
  text-align: center;
}
.accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header,
.gx-card.listing-wrapper .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  overflow: hidden;
}
.dark-theme .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header,
.dark-theme .gx-card.listing-wrapper .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  background: #051B30;
}
.accounts-table .ant-table-thead > tr > th,
.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
}
.accounts-table .ant-table-thead > tr > th > span,
.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th > span {
  display: inline-block;
  vertical-align: middle;
}
.accounts-table .ant-table-tbody > tr:hover > td,
.gx-card.listing-wrapper .accounts-table .ant-table-tbody > tr:hover > td {
  background: inherit !important;
}
.patient-section {
  position: absolute;
  top: -14px;
  font-size: 15px;
  font-weight: 500;
  background: white;
  padding: 4px 05px 3px;
  letter-spacing: 0.2px;
  border: 1px solid #f3f3f3;
  border-radius: 5px;
}
@media screen and (min-width: 1600px) {
  .patient-section {
    font-size: 17px;
  }
}
.dark-theme .patient-claim-form-parent .ant-col .ant-form-item-control-wrapper {
  width: 100% !important;
}
.add-examination-button {
  outline: none;
  border: none;
  color: #ffffff;
  font-size: 12px;
  width: 70px;
  padding: 4px 4px 6px;
  background: transparent;
  cursor: pointer;
  line-height: 1.75;
}
@media screen and (min-width: 1600px) {
  .add-examination-button {
    font-size: 12px;
    width: 70px;
  }
}
.claiming-form-label-disabled {
  color: #989b9d;
  font-weight: 500;
}
.warning-component {
  width: 100%;
  min-height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 08px;
  gap: 8px;
  padding: 14px 20px;
}
.claiming-form-parent {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  min-height: 445px;
}
.claiming-form-input-group {
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 5px;
  flex-grow: 1;
  max-width: 200px;
  margin-bottom: 10px;
}
.claiming-form-radio {
  width: 215px !important;
  overflow: hidden !important;
  color: #323a43 !important;
  border-radius: 06px !important;
}
.claiming-form-radio .ant-radio-wrapper {
  color: #323a43 !important;
  font-size: 12px !important;
}
.dark-theme .ant-checkbox-checked .ant-checkbox-inner.claiming-checkbox-disabled {
  background: #f5f5f5 !important;
  color: #696b6d !important;
}
.dark-theme .ant-checkbox-indeterminate .ant-checkbox-inner.claiming-checkbox-disabled {
  background: #f5f5f5 !important;
  color: #696b6d !important;
}
.claiming-form-input {
  border: 0.5px solid #d9d9d9;
  border-radius: 05px;
  font-size: 11px;
  outline: none;
  width: 100%;
  padding: 08px;
}
.claiming-form-input-disabled {
  border: 0.5px solid #f5f5f5 !important;
  border-radius: 05px;
  font-size: 11px !important;
  outline: none;
  width: 100%;
  padding: 08px;
  color: #696b6d !important;
  border-color: #dde2e6 !important;
}
.claiming-buttons-div {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
  height: 50px;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  margin: 10px 0px;
}
.claiming-button {
  cursor: pointer;
  margin: 0px !important;
}
.claiming-form-parent-input {
  padding: 08px;
  border: 0.5px solid #4b545c29;
  border-radius: 08px;
  background: #4b545c29;
  color: #323a43;
  outline: none;
}
.claiming-form-status-badge {
  padding: 5px 10px;
  font-size: 11px;
  line-height: 1;
  border-radius: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 1600px) {
  .claiming-form-status-badge {
    font-size: 13px;
  }
}
.message-overlay {
  position: absolute;
  top: -20%;
  left: 0;
  z-index: 999999;
  backdrop-filter: blur(4px);
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  user-select: none;
  border-radius: 06px !important;
}
.message-parent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-container {
  min-width: 400px;
  max-width: 450px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 10px 30px;
  text-align: center;
}
.add-examination-row {
  position: absolute;
  right: 0px;
  top: 0px;
  display: flex;
  padding: 0;
  border-radius: 0 8px 0 8px;
  border: none;
  background: #2EB1EF;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
.add-examination-row button + button {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}
.visit-detail-bg {
  color: #ffffff;
  padding: 15px;
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 4px;
}
.visit-detail-bg h3 {
  font-weight: 400;
  font-size: 16px;
  margin: 0px 0px 10px;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg h3 {
    font-size: 18px;
  }
}
.visit-detail-bg .ant-form .ant-row {
  margin: 0px;
}
.visit-detail-bg .ant-form .ant-row.ant-form-item {
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  padding: 0px;
  margin-right: 6px;
  margin-bottom: 6px;
}
.visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {
  color: #7E7E7E;
  font-weight: 600;
}
.visit-detail-bg .patient-info-input,
.visit-detail-bg .ant-calendar-picker-input {
  width: 220px;
  height: 38px;
  border-radius: 4px;
}
.visit-detail-bg .patient-info-select {
  width: 220px;
  height: 38px;
  border-radius: 4px;
}
.visit-detail-bg .patient-info-select.ref-doc {
  width: 525px;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg .patient-info-select.ref-doc {
    width: 600px;
  }
}
.visit-detail-bg .patient-info-select.cc-doc {
  width: 475px;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg .patient-info-select.cc-doc {
    width: 550px;
  }
}
.visit-detail-bg .ant-table-wrapper.examinations-table .ant-table {
  max-height: 220px;
}
.visit-detail-bg .ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,
.visit-detail-bg .ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {
  margin-right: 25px;
}
.visit-detail-bg .ant-select-selection.ant-select-selection--multiple {
  max-height: 85px;
  overflow-y: auto;
}
.visit-detail-bg .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {
  height: 18px;
  line-height: 10px;
  padding: 3px 20px 3px 10px;
  font-size: 13px;
}
.visit-detail-bg .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 11px;
  top: 2px;
}
.patient-info-input.short-input,
.patient-info-select.short-input {
  width: 130px;
  min-width: 130px;
}
@media screen and (min-width: 1600px) {
  .patient-info-input.short-input,
  .patient-info-select.short-input {
    width: 150px;
    min-width: 150px;
  }
}
@media screen and (min-width: 1800px) {
  .patient-info-input.short-input,
  .patient-info-select.short-input {
    width: 180px;
    min-width: 180px;
  }
}
@media screen and (min-width: 2000px) {
  .patient-info-input.short-input,
  .patient-info-select.short-input {
    width: 200px;
  }
}
.visit-detail-bg-container .ant-form .ant-row {
  margin: 0px;
}
.visit-detail-bg-container .ant-form .ant-row.ant-form-item {
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  padding: 0px;
  margin-right: 6px;
  margin-bottom: 6px;
}
.dark-theme .visit-detail-bg {
  background-color: #081F37;
}
.dark-theme .visit-detail-bg .patient-info-input,
.dark-theme .visit-detail-bg .ant-calendar-picker-input {
  background-color: rgba(20, 40, 60, 0.65);
  border-color: rgba(20, 40, 60, 0.65);
  color: #ffffff;
}
.dark-theme .visit-detail-bg .patient-info-select {
  color: #ffffff;
}
.dark-theme .visit-detail-bg .patient-info-select .ant-select-selection {
  background-color: rgba(20, 40, 60, 0.65);
  border-color: rgba(20, 40, 60, 0.65);
}
.dark-theme .visit-detail-bg .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #082139 !important;
}
.dark-theme .visit-detail-bg .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {
  background-color: #051B30;
  color: #ffffff;
  border-color: #051B30;
}
.dark-theme .visit-detail-bg .ant-select-selection--multiple .ant-select-selection__choice__remove {
  color: #9BA4AC;
}
.dark-theme .visit-detail-bg .ant-btn[disabled],
.dark-theme .visit-detail-bg .ant-btn[disabled]:hover,
.dark-theme .visit-detail-bg .ant-btn[disabled]:focus {
  background: transparent;
  border-color: inherit !important;
}
.gx-card.listing-wrapper .visit-detail-bg .patient-info-input.ant-input,
.gx-card.listing-wrapper .visit-detail-bg .ant-calendar-picker-input,
.gx-card.listing-wrapper .visit-detail-bg .patient-info-select.ant-select .ant-select-selection {
  background-color: #F8F8F8;
  border-color: #F8F8F8;
}
.dark-theme .gx-card.listing-wrapper .visit-detail-bg .patient-info-input.ant-input,
.dark-theme .gx-card.listing-wrapper .visit-detail-bg .ant-calendar-picker-input,
.dark-theme .gx-card.listing-wrapper .visit-detail-bg .patient-info-select.ant-select .ant-select-selection {
  background-color: rgba(20, 40, 60, 0.65);
  border-color: rgba(20, 40, 60, 0.65);
}
.ant-form-item-required::before {
  font-size: 12px;
  vertical-align: text-top;
}
.patient-info-button {
  border-radius: 05px;
  padding: 8px;
  height: 30px;
  min-height: 30px;
  line-height: 12px;
  font-size: 10px;
  min-width: 100px;
  margin: 0 !important;
  background-color: #ffffff;
  border-color: #37A2B7;
  color: #37A2B7;
  font-weight: 500;
}
.patient-info-button:hover,
.patient-info-button:focus {
  background-color: #04A0A1;
  color: #ffffff;
  border-color: #04A0A1;
}
@media screen and (min-width: 1600px) {
  .patient-info-button {
    font-size: 12px;
    min-height: 34px;
    padding: 8px 10px;
  }
}
.patient-info-button button.ant-btn {
  border: none;
  height: auto;
  min-height: auto;
  line-height: 1;
  color: #fff;
  font-size: 11px;
}
@media screen and (min-width: 1600px) {
  .patient-info-button button.ant-btn {
    font-size: 12px;
  }
}
.dark-theme .patient-info-button {
  background-color: #051B30;
  border: 1px solid #0590DE;
  color: #ffffff !important;
}
.dark-theme .patient-info-button:hover,
.dark-theme .patient-info-button:focus {
  background-color: #072542;
  border-color: #0590DE !important;
  color: #ffffff !important;
}
.white-box .patient-info-button {
  border-color: #089265 !important;
  background: transparent;
  color: #089265 !important;
  border-radius: 20px;
  min-height: 34px;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 18px;
}
.white-box .patient-info-button:hover,
.white-box .patient-info-button:focus {
  background: #089265 !important;
  border-color: #089265 !important;
  color: #ffffff !important;
}
.edi-span {
  color: #484848;
  background-color: #d7d7d7;
  border: 0.5px solid #484848;
  border-radius: 08px;
  padding: 10px;
  margin-top: 10px;
  font-weight: 600;
}
.visit-audit-input,
.visit-audit-input::placeholder {
  background: #FFFFFF;
  border: 1px solid #f3f3f3 !important;
  border-radius: 08px;
  width: 198px;
  height: 33px;
  color: #6b6b6b !important;
  margin: 1px;
}
.visit-notes-tree {
  background: #fff;
  padding: 15px;
}
.visit-notes-tree.ant-row {
  margin: 0px;
}
.visit-notes-tree .notes-sidebar {
  max-height: 300px;
  overflow-y: auto;
}
.ant-form .ant-row.visit-notes-tree .ant-row {
  margin-left: -15px;
}
.notes-heading {
  color: #051b30 !important;
  font-weight: 600;
  margin-top: 10px;
}
.notes-heading span {
  color: #959595;
  font-style: italic;
  font-size: 11px;
  font-weight: 300;
}
.add-location-button,
.add-location-button:hover,
.add-location-button:focus {
  background: #019461;
  color: #FFFFFF !important;
  border-radius: 20px;
  border: none;
}
.scan-doc-radio.ant-radio-button-wrapper {
  display: inline-flex;
  align-items: center;
  width: 140px;
  height: auto;
  min-height: 38px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 4px;
  background-color: #E6EAEB;
  border: 1px solid #D6D6D6;
  color: #666666;
  margin: 3px 10px 3px 0px;
  font-size: 13px;
  box-shadow: none;
}
@media screen and (min-width: 1600px) {
  .scan-doc-radio.ant-radio-button-wrapper {
    font-size: 14px;
  }
}
.scan-doc-radio.ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  border-color: #051B30;
  background-color: #cfd7d9;
  color: #051B30;
}
.scan-doc-radio.ant-radio-button-wrapper:hover,
.scan-doc-radio.ant-radio-button-wrapper:focus {
  color: #051B30;
  background-color: #cfd7d9;
  border-color: #051B30;
}
.scan-doc-radio.ant-radio-button-wrapper:not(:first-child):before {
  display: none;
}
.eligibilty-exam-form-parent {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
}
.eligibilty-form-parent {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-height: 450px;
  overflow-y: auto;
}
.eligibility-form-checkbx .ant-checkbox {
  transform: scale(1.3);
  transform-origin: top left;
  margin-left: 15px;
  width: 50%;
}
.eligibility-summary-parent {
  border-radius: 08px;
  padding: 08px 10px;
  min-height: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}
.eligibility-form-select {
  width: 215px !important;
  color: #323a43 !important;
  border-radius: 06px !important;
  border-color: #d9d9d9 !important;
}
.dark-theme .ant-modal-content .ant-select.eligibility-form-select-disabled {
  background-color: #f5f5f5 !important;
  width: 215px !important;
  color: #545454 !important;
  border-color: #d9d9d9 !important;
}
.dark-theme .ant-input-disabled.eligibility-form-input-disabled {
  background-color: #f5f5f5 !important;
  color: #545454 !important;
  border-color: #d9d9d9 !important;
}
.dark-theme .ant-select-auto-complete.ant-select .ant-input-disabled {
  background-color: rgba(29, 58, 87, 0.65) !important;
}
.dark-theme .form-desc .ant-popover-inner-content {
  background: #fff !important;
  color: #333;
}
.dark-theme .form-desc .ant-popover-arrow {
  background: #fff !important;
  border-color: #fff !important;
}
.dark-theme .form-desc .ant-descriptions-item-content {
  background: #fff !important;
  color: #535353 !important;
}
.gx-app-login-content .ant-form-item-label {
  line-height: 50px;
}
.dark-theme .gx-app-login-content .ant-input {
  background-color: transparent !important;
}
.dark-theme .visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {
  color: #bebebe;
  font-size: 13px;
}
@media screen and (min-width: 1600px) {
  .dark-theme .visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {
    font-size: 14px;
  }
}
.dark-theme .visit-detail-bg .patient-info-input.ant-input-disabled,
.dark-theme .visit-detail-bg .ant-calendar-picker-input.ant-input-disabled,
.dark-theme .visit-detail-bg .patient-info-input .ant-input-disabled {
  background-color: rgba(29, 58, 87, 0.65) !important;
  color: #ffffff !important;
}
.dark-theme .visit-detail-bg .patient-info-select,
.dark-theme .visit-detail-bg .visit-custom-select {
  color: #ffffff;
}
.dark-theme .visit-detail-bg .patient-info-select .ant-select-selection,
.dark-theme .visit-detail-bg .visit-custom-select .ant-select-selection {
  background-color: rgba(20, 40, 60, 0.65);
  border-color: rgba(20, 40, 60, 0.65);
}
.dark-theme .visit-detail-bg .patient-info-select.ant-select-disabled,
.dark-theme .visit-detail-bg .visit-custom-select.ant-select-disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}
.dark-theme .visit-detail-bg .patient-info-select.ant-select-disabled .ant-select-selection,
.dark-theme .visit-detail-bg .visit-custom-select.ant-select-disabled .ant-select-selection {
  background-color: rgba(29, 58, 87, 0.65) !important;
  border-color: rgba(29, 58, 87, 0.65) !important;
  color: rgba(255, 255, 255, 0.3) !important;
}
.dark-theme .visit-detail-bg .form-select .ant-select-selection {
  background-color: rgba(20, 40, 60, 0.65);
  border-color: rgba(20, 40, 60, 0.65);
  line-height: 38px;
  height: 36px;
}
.dark-theme .visit-detail-bg .form-select .ant-select-selection .ant-select-selection__placeholder {
  line-height: 20px;
}
.dark-theme .visit-detail-bg .form-select.ant-select-disabled .ant-select-selection {
  background-color: rgba(29, 58, 87, 0.65);
  border-color: rgba(250, 250, 250, 0.1);
  color: #b9b9b9;
}
.dark-theme .green-button {
  background-color: #14B983;
  color: #ffffff;
  height: 40px;
  font-weight: 600;
  border-radius: 20px;
  border: none;
  font-size: 12px;
  min-height: 38px;
}
@media screen and (min-width: 1600px) {
  .dark-theme .green-button {
    min-height: 40px;
    font-size: 14px;
  }
}
.dark-theme .green-button:hover,
.dark-theme .green-button :focus {
  background-color: #12a273;
  color: #fff;
}
.dark-theme .site__card {
  background-color: #434f5a !important;
}
.dark-theme .custom-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  min-width: 425px;
  min-height: 400px;
  background: #0B2B41 !important;
  color: white;
  border-radius: 16px;
}
.dark-theme .authenticator-heading {
  font-size: 25px;
  color: #FFFFFF;
  margin: 0;
}
.dark-theme .sub-heading {
  font-weight: 300;
  font-size: 20px;
  color: #E9F6FF;
}
.dark-theme .ant-layout-sider,
.dark-theme .gx-layout-sider-dark {
  color: #fff !important;
}
.dark-theme .ant-calendar-year-panel-year {
  color: #fff;
}
.dark-theme .rbc-timeslot-group {
  border-bottom: 0px !important;
}
.dark-theme .rbc-time-content > * + * > * {
  border-left: 0px !important;
}
.patientinfo-form .ant-form-item-label[class*='ant-col-'] {
  padding: 0px !important;
}
.patientinfo-form .ant-form-item-sm .ant-form-item-label {
  text-align: right !important;
}
.user-role-selection .cardH {
  background: #fff !important;
}
.gx-login-header img {
  max-width: 100px;
  margin: auto;
  display: block;
}
.rbc-time-content > * + * > * {
  border: 1px solid #ffffff !important;
}
.rbc-events-container {
  border: 1px solid #ffffff !important;
}
.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {
  border: 1px solid #ffffff !important;
  background-color: #D8DDE2 !important;
  color: #051B30;
}
.rbc-time-slot {
  display: flex;
  align-items: center;
}
.calendar-container {
  margin: 0px;
  height: 100% !important;
}
.calendar-container .rbc-addons-dnd.rbc-calendar {
  padding: 15px !important;
  padding-top: 0px !important;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-view {
  padding: 0px 3px;
  border: 1px solid #D8DFE5;
  border-radius: 5px;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .ant-form {
  position: sticky;
  top: 0px;
  z-index: 999;
  background: #051B30;
  margin-bottom: 2px;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header {
  position: sticky;
  top: 36px;
  z-index: 10;
  padding: 20px 0px;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header .rbc-header {
  border-bottom: none;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header .rbc-time-header-content {
  display: flex;
  gap: 08px;
  border: none;
}
.calendar-container .rbc-addons-dnd.rbc-calendar .ant-form,
.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header {
  background: #F1F1F1;
}
.calendar-container .rbc-toolbar {
  position: sticky !important;
  top: 0px !important;
  z-index: 999;
  background: #E0E0E0 !important;
  padding-top: 15px !important;
}
.calendar-container .selected__row {
  background-color: transparent !important;
}
.calendar-container #calendar .ant-card-body {
  padding-right: 0px;
  padding-bottom: 0px;
}
.calendar-container .rbc-time-view-resources .rbc-header,
.calendar-container .rbc-time-view-resources .rbc-day-bg {
  color: #051B30;
  font-weight: 600;
}
.calendar-container .rbc-time-view-resources .rbc-time-header-gutter {
  background-color: transparent;
  border: none;
}
.calendar-container .calendar-button-navigation {
  margin: 0;
  background: transparent;
  border: none;
  color: #606E7B;
  padding: 0;
  font-size: 10px;
}
.calendar-container .calendar-button-navigation span {
  color: #606E7B;
}
.calendar-container .calendar-button-navigation:hover {
  background: none;
  color: #038fde;
}
.calendar-container .calendar-select {
  width: 80px;
}
.calendar-container .calendar-button {
  margin: 0;
  background: transparent;
  border: none;
  color: #606E7B;
}
.calendar-container .calendar-button span {
  color: #606E7B;
}
.calendar-container .calendar-date-picker.ant-calendar-picker,
.calendar-container .calendar-date-picker.ant-calendar-picker + span {
  color: #14283C !important;
  font-weight: 500 !important;
  font-size: 14px;
}
.calendar-container .calendar-date-picker.ant-calendar-picker .ant-calendar-picker-icon,
.calendar-container .calendar-date-picker.ant-calendar-picker + span .ant-calendar-picker-icon {
  color: #14283C;
}
.calendar-container .calendar-date-picker .ant-calendar-picker-input,
.calendar-container .calendar-date-picker .ant-calendar-picker-input::placeholder {
  color: #14283C;
}
.dashboard-calendar .calendar-container .rbc-addons-dnd.rbc-calendar {
  padding: 0px !important;
}
#calendar .rbc-timeslot-group {
  min-height: 40px !important;
}
#calendar .rbc-day-slot .rbc-event-content {
  overflow: auto;
}
#calendar .rbc-day-slot .rbc-event-content .ant-dropdown-trigger {
  height: 100%;
}
#calendar .rbc-day-slot .rbc-event {
  min-height: 40px;
  padding: 5px;
}
#calendar .rbc-day-slot .rbc-time-slot {
  border: none;
}
.calendar-card {
  height: 97% !important;
  margin-bottom: 0px !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  z-index: 10;
}
.calendar-card .ant-card-body {
  height: 100%;
}
/*Agenda View*/
.rbc-agenda-view {
  border: 1px solid #e8e8e8;
  padding: 5px;
  border-radius: 6px;
  background: #ffffff;
}
.dark-theme .rbc-agenda-view {
  background: transparent;
}
.rbc-agenda-view table.rbc-agenda-table {
  border: none;
  color: #ffffff;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 8px;
  border: none;
  min-width: 180px !important;
  color: #606E7B;
}
.dark-theme .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  color: #D8DFE5;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th:nth-child(3) {
  text-align: center;
}
@media screen and (min-width: 1600px) {
  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
    font-size: 14px;
  }
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr {
  border: none !important;
  color: #383838 !important;
  opacity: 1 !important;
  border-bottom: 2px solid #d2dae1 !important;
  font-weight: 600;
}
.dark-theme .rbc-agenda-view table.rbc-agenda-table tbody > tr {
  color: #ffffff !important;
  border-color: #0b2e4f;
  font-weight: 500;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 10px;
  min-width: 180px !important;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border: none;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr:last-child {
  border: none !important;
}
.rbc-agenda-table tbody tr[style] {
  background-color: transparent !important;
}
.dark-theme .calendar-button {
  color: #BDBDBD;
}
.dark-theme .calendar-button span {
  color: #BDBDBD;
}
.dark-theme .calendar-button-selected {
  color: #ffffff;
}
.dark-theme .rbc-time-header {
  background: #071b2c;
}
.dark-theme .rbc-today {
  background-color: transparent !important;
}
.dark-theme .rbc-label {
  color: #BDBDBD;
}
.dark-theme .rbc-time-content {
  border-top: none;
}
.dark-theme .rbc-time-view-resources .rbc-time-gutter {
  background-color: transparent !important;
  border: none;
}
.dark-theme .rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {
  border: 1px solid #051B30 !important;
  background-color: #051B30 !important;
  color: #ffffff;
}
.dark-theme .calendar-container .rbc-calendar {
  background-color: transparent !important;
}
.dark-theme .calendar-container .rbc-calendar .rbc-time-view {
  border: 1px solid #e8e8e8;
}
.dark-theme .calendar-container .rbc-calendar .rbc-time-header,
.dark-theme .calendar-container .rbc-calendar .ant-form {
  background: #051B30;
}
.dark-theme .calendar-container .rbc-calendar .rbc-toolbar {
  background: #E0E0E0 !important;
}
.dark-theme .calendar-container .rbc-time-view-resources .rbc-header,
.dark-theme .calendar-container .rbc-time-view-resources .rbc-day-bg {
  color: #ffffff;
  font-weight: 500;
}
.dark-theme .calendar-container .calendar-button,
.dark-theme .calendar-container .calendar-button span,
.dark-theme .calendar-container .calendar-button-navigation span {
  color: #BDBDBD;
}
.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker,
.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker + span {
  color: #ffffff !important;
}
.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker .ant-calendar-picker-icon,
.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker + span .ant-calendar-picker-icon {
  color: #BDBDBD;
}
.dark-theme .rbc-time-content > * + * > * {
  border: 1px solid #051B30 !important;
}
.dark-theme .rbc-events-container {
  border: 1px solid #051B30 !important;
}
.dark-theme .appointment-view-card .ant-form-item,
.dark-theme .appointment-view-card .ant-form-item-label label,
.dark-theme .appointment-view-card .ant-form-extra,
.dark-theme .appointment-view-card .custom-input .ant-form-item label {
  color: #545454 !important;
}
.dark-theme .appointment-view-card .appointment-card-extra {
  color: #E0E0E0 !important;
}
.has-error .ant-input,
.has-error .ant-input:hover,
.has-error .ant-input-affix-wrapper .ant-input,
.has-error .ant-input-affix-wrapper .ant-input:hover {
  background-color: transparent;
}
.has-error .ant-form-explain,
.has-error .ant-form-explain {
  font-size: 11px;
}
@media screen and (min-width: 1600px) {
  .has-error .ant-form-explain,
  .has-error .ant-form-explain {
    font-size: 12px;
  }
}
.has-error .ant-form-explain,
.has-error .ant-form-split {
  color: #f5222d;
}
.dark-theme .has-error .ant-form-explain,
.dark-theme .has-error .ant-form-split {
  color: #f5222d;
}
.invoices-table .ant-input {
  text-align: right;
  margin: 3px 0;
}
.invoices-table .invoice-item {
  border-bottom: 1px solid #ddd;
}
.ant-popover-buttons {
  display: flex;
  flex-direction: row-reverse;
}
.custom-datepicker {
  width: 100% !important;
}
.gx-avatar-name {
  font-size: 12px;
}
.editable-cell {
  position: relative;
}
.editable-cell-value-wrap {
  cursor: pointer;
}
.editable-row:hover .editable-cell-value-wrap,
.mrt-input,
.editable-cell-value-wrap,
.editable-row .editable-cell-value-wrap,
.editable-cell-value-wrap {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 7px 11px !important;
  height: 29px !important;
  width: 98px !important;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.report-editor-search {
  width: 270px !important;
}
.report-sidebar-tree-icon {
  line-height: 28px !important;
}
.report-sidebar .ant-tree-icon__docu,
.report-sidebar .ant-tree-icon__open {
  display: none !important;
}
.cke_bottom .cke_reset_all,
.cke_path {
  display: none !important;
}
.ant-divider-horizontal {
  margin: 6px 0 !important;
}
.gx-app-sidebar.gx-mini-sidebar .sidebar-username {
  margin-left: 50px !important;
}
.gx-app-sidebar.gx-mini-sidebar .gx-avatar-name {
  font-size: 12px;
  margin-left: 18px;
}
.create-visit-icon:hover {
  cursor: pointer;
}
.gx-main-content-wrapper {
  padding: 15px;
  width: 100%;
}
#calendar .gx-card-body,
#calendar .ant-card-body,
#calendar .ant-card-head,
#calendar .ant-card-head-title {
  padding-left: 0px !important;
}
#calendar .ant-card-extra,
#calendar .ant-card-head-title {
  padding-bottom: 0px !important;
  padding-top: 0px;
}
#calendar .ant-card-body {
  padding-top: 0px !important;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  background: transparent !important;
}
.dark-theme .rbc-time-header-content > .rbc-row.rbc-row-resource {
  color: #fff !important;
  border: none;
}
.dark-theme .rbc-time-header-content .rbc-allday-cell {
  display: none !important;
}
.rbc-label {
  font-size: 12px;
}
@media screen and (min-width: 1600px) {
  .rbc-label {
    font-size: 15px;
    font-weight: 500;
  }
}
.dark-theme .calendar-container.lineup .rbc-label {
  color: #fff;
}
.rbc-day-slot .rbc-events-container {
  margin-right: 0px !important;
}
.rbc-event-label {
  display: none !important;
}
.add-modality-btn {
  float: right;
}
.dark-theme .ant-descriptions-item-content {
  color: #fff !important;
}
.dark-theme .calendar-date-setup-header-changes {
  color: #fff !important;
}
.calendar-card {
  color: #545454 !important;
}
@media screen and (max-width: 767px) {
  .report-sidebar-container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
.cutom-login-modal {
  width: 385px !important;
}
.ant-modal-header,
.ant-modal-body,
.custom-login-body {
  margin-top: 10px;
}
.custom-login-body.ant-drawer {
  margin-top: 0px;
}
.terms-container {
  margin: auto !important;
  padding: 20px;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .report-viewer-sidebar {
    height: 503px !important;
    padding: 0px !important;
  }
}
.report-viewer-sidebar .ant-card-body {
  padding: 5px;
}
.gx-header-horizontal-nav .gx-avatar {
  height: 40px;
  width: 40px;
}
.gx-header-horizontal-top {
  padding: 7px 0px !important;
}
.custom-calendar .ant-calendar-picker-icon {
  display: none !important;
}
.patient-modal .ant-modal-footer .ant-btn,
.examination-modal .ant-modal-footer .ant-btn,
.doctor-modal .ant-modal-footer .ant-btn {
  height: auto;
  font-size: 14px;
  border-radius: 4px;
}
@media screen and (min-width: 1600px) {
  .patient-modal .ant-modal-footer .ant-btn,
  .examination-modal .ant-modal-footer .ant-btn,
  .doctor-modal .ant-modal-footer .ant-btn {
    font-size: 16px;
  }
}
.examination-modal {
  width: 800px !important;
}
.examination-modal .ant-form-item-label[class*='ant-col-'] {
  padding: 0 0px !important;
}
.examination-modal .ant-form .ant-row {
  margin-left: 0;
}
.examination-modal .ant-modal-body {
  padding-top: 0;
}
.hl7-modal {
  top: 0px !important;
}
.visit-footer {
  display: flex;
  justify-content: flex-end;
  padding-right: 0px;
  padding-left: 0px;
}
.visit-footer .ant-btn-sm {
  margin-bottom: 0px !important;
}
.btn-sidebar-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.btn-sidebar-container .ant-btn-sm {
  min-width: 70px;
  float: right;
  margin-right: 0px;
}
.note {
  background-color: transparent;
}
.note-modal .notes-sidebar {
  height: 150px !important;
  overflow: scroll;
  padding: 20px;
}
.note-modal .ant-modal-body {
  padding-bottom: 0px;
}
.note-modal .btn-note {
  padding: 2px 14px;
  border: none;
}
@media screen and (min-width: 1024px) {
  .active-appointment-form .ant-time-picker {
    width: 100% !important;
  }
  .active-appointment-form .ant-input-number {
    width: 80% !important;
  }
  .active-appointment-form .description-input {
    width: 103% !important;
    margin-left: -15px !important;
  }
}
.instructions .ant-form-item-label > label::after {
  content: none;
}
.edit-appointment-patient .ant-form-item-control-wrapper {
  display: block !important;
}
.upload-document label::after {
  content: none !important;
}
@media screen and (min-width: 767px) and (max-width: 1023px) {
  .active-appointment-form .ant-input-number {
    width: 75% !important;
  }
  .site__card .site__card-head-title {
    width: 115px !important;
  }
}
.delete-attachment {
  position: absolute !important;
  right: 20px;
  top: 70px;
}
.print-attachment {
  position: absolute !important;
  right: 20px;
  top: 70px;
}
.visit-delete-attachment {
  position: absolute;
  right: 20px;
  top: 20px;
}
.custom-delete-btn {
  height: 28px;
  line-height: 28px;
  min-width: 28px;
}
/* appointment calendar */
.rbc-event.roster-event {
  width: 20% !important;
  left: 0 !important;
  right: auto !important;
  border: none !important;
}
@media screen and (min-width: 1600px) {
  .rbc-event.roster-event {
    width: 15% !important;
  }
}
.rbc-event:not(.roster-event) {
  left: auto !important;
  right: 0 !important;
}
.menu-section-title {
  font-size: 12px;
  display: block;
  font-weight: 500;
  color: #05b9ba;
}
@media screen and (min-width: 1600px) {
  .menu-section-title {
    font-size: 13px;
  }
}
.dark-theme .menu-section-title {
  color: #ffffff;
}
.sidebar-footer {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: space-between;
}
.sidebar-footer p {
  margin-bottom: 0px;
}
.ant-layout-sider-collapsed .sidebar-footer {
  padding: 8px;
  justify-content: center;
}
.gx-layout-sider-header > svg.toggle-icon {
  right: -6px;
  position: absolute;
  width: 30px;
  height: 36px;
  cursor: pointer;
}
.ant-layout-sider-collapsed svg.toggle-icon {
  transform: rotateY(180deg);
}
.ant-layout-sider-collapsed .gx-site-logo {
  margin-right: 8px;
}
.gx-layout-sider-scrollbar {
  height: calc(100vh - 145px) !important;
}
.gx-layout-sider-scrollbar::-webkit-scrollbar {
  width: 3px;
}
.gx-app-sidebar:not(.ant-layout-sider-collapsed) #custom-sidebar .ant-menu,
.gx-drawer-sidebar #custom-sidebar .ant-menu {
  padding-bottom: 96px;
}
.dark-mode-toggle .custom-switch.ant-switch {
  width: auto;
  padding: 6px 8px;
  height: auto;
}
.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch {
  padding: 10px;
  min-width: 38px;
}
.dark-mode-toggle .custom-switch.ant-switch .ant-switch-inner {
  font-size: 14px;
  font-weight: 600;
}
.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch .ant-switch-inner {
  display: none;
}
.dark-mode-toggle .custom-switch.ant-switch::after {
  width: 20px;
  height: 20px;
  top: 6px;
}
.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch::after {
  width: 14px;
  height: 14px;
  top: 3px;
}
.dark-mode-toggle .custom-switch.ant-switch.ant-switch-checked::after,
.dark-mode-toggle.success .ant-switch-checked {
  background: #37A2B7;
}
.dark-mode-toggle .ant-switch-checked {
  background-color: #0c1a27;
}
.dark-mode-toggle .custom-switch.ant-switch.ant-switch-checked::after {
  background: #ffffff;
}
.dark-mode-toggle.critical .ant-switch-checked {
  background-color: #EF5555;
}
.ant-menu-inline-collapsed-tooltip a {
  display: flex;
  align-items: center;
  gap: 5px;
}
/*Custom styled modal*/
.ant-modal-confirm.styled-modal .ant-modal-body {
  padding: 25px;
  height: 275px;
  width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ant-modal-confirm.styled-modal .ant-modal-confirm-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.ant-modal-confirm.styled-modal .ant-modal-confirm-btns {
  float: none;
  margin-top: 0px;
}
.ant-modal-confirm.styled-modal .ant-modal-confirm-btns button.ant-btn {
  min-height: 40px;
  padding: 0 25px;
}
/*Confirm modal Cancel visit*/
.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-body > .anticon {
  margin-right: 10px;
}
.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin-left: 0px;
}
.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-btns button + button {
  margin-left: 0px;
}
.dark-theme .rbc-time-content .rbc-current-time-indicator {
  border-color: #FFFFFF !important;
}
form.edit-appointment-patient .ant-btn.ant-btn-primary {
  box-shadow: none;
}
form.edit-appointment-patient .search-box .ant-btn.ant-btn-primary {
  min-height: 40px;
}
form.edit-appointment-patient .search-box .ant-input {
  background: #E8E8E8;
  border: none;
  margin-bottom: 0px;
  color: #7E7E7E;
  outline: none;
  height: 40px;
}
form.edit-appointment-patient .search-box .ant-input:hover,
form.edit-appointment-patient .search-box .ant-input:focus {
  border: none;
  outline: none;
}
form.edit-appointment-patient .search-box .ant-input::placeholder {
  color: #a9b1b8;
}
form.edit-appointment-patient .search-box .ant-form-item .anticon {
  color: #7E7E7E;
}
form.edit-appointment-patient .search-box .ant-form-item .anticon.anticon-close-circle {
  height: 20px;
  width: 20px;
}
.lock-event {
  display: block;
  min-height: 30px;
  width: 100%;
}
.ant-popover-inner,
.ant-popover-arrow {
  background-color: #ffffff;
  box-shadow: 0 0 4px rgba(61, 60, 60, 0.28);
}
.dark-theme .ant-popover-inner,
.dark-theme .ant-popover-arrow {
  background-color: #051B30;
}
.ant-popover-title {
  color: #000000;
  border: none;
}
.dark-theme .ant-popover-title {
  color: #E9F6FF;
}
.ant-popover-inner-content {
  padding: 10px 16px 12px;
}
.ant-popover-inner-content .ant-card.appointment-card {
  padding: 0px;
  margin: 0px;
  background: transparent;
  font-size: 12px;
  max-width: 325px;
  color: #1e1e1e;
  font-weight: 500;
}
.dark-theme .ant-popover-inner-content .ant-card.appointment-card {
  color: #ffffff;
  font-weight: 400;
}
.ant-popover-inner-content .ant-card.appointment-card .ant-card-body {
  padding: 0px;
}
.ant-popover-inner-content .ant-card.appointment-card .appointment-status {
  background: #e0fafa;
  border: 1px solid #9ef0f0;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #295e64;
}
.dark-theme .ant-popover-inner-content .ant-card.appointment-card .appointment-status {
  background: #1a3c40;
  color: #9ef0f0;
  border-color: transparent;
}
.ant-popover-inner-content .ant-card.appointment-card .appointment-status::before {
  content: "●";
  font-size: 14px;
  margin-right: 4px;
}
@media screen and (min-width: 1600px) {
  .ant-popover-inner-content .ant-card.appointment-card .appointment-status::before {
    font-size: 16px;
  }
}
.ant-popover-inner-content .ant-card.appointment-card .patient-info {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #051B30;
}
.dark-theme .ant-popover-inner-content .ant-card.appointment-card .patient-info {
  color: #ffffff;
}
.ant-popover-inner-content .ant-card.appointment-card.minWidth {
  min-width: 300px;
}
.no-data-note {
  font-size: 15px;
  color: #051B30;
  padding: 10px 5px;
  border-radius: 4px;
  line-height: 1.4;
  margin: 0px;
}
.dark-theme .no-data-note {
  background-color: #14283C;
  color: #9BA4AC;
}
.white-box {
  background: #FFF;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  margin-top: 10px;
}
.white-box .add-new-slot-button {
  min-width: 128px;
  height: auto;
  color: #089265;
  border: 1px solid #089265;
  border-radius: 20px;
  font-weight: 600;
  padding: 0;
  margin: 0;
  line-height: 0;
}
.white-box .add-new-slot-button:hover,
.white-box .add-new-slot-button:focus {
  color: #089265;
  border: 1px solid #089265;
  box-shadow: none;
}
.white-box .remove-event-button {
  background: #ECECEC;
  color: #8B9293;
  border: none;
  padding: 8px 12px;
  min-height: 38px;
  line-height: 1.3;
}
.white-box .remove-event-button:hover,
.white-box .remove-event-button:focus {
  background: #d3d3d3;
  color: #8B9293;
  border: none;
}
.white-box .appointment-form-input,
.white-box .form-input {
  padding: 0 8px;
  border: 1px solid #F3F3F3;
  min-width: 190px;
  max-width: 190px;
  font-size: 12px;
  color: #6B6B6B;
  border-radius: 4px;
  min-height: 38px;
  line-height: 1.8;
}
.white-box .appointment-form-input:hover,
.white-box .form-input:hover,
.white-box .appointment-form-input:focus,
.white-box .form-input:focus {
  box-shadow: none;
  border-color: #e4e4e4;
}
.white-box .appointment-form-input .ant-calendar-picker-input.ant-input,
.white-box .form-input .ant-calendar-picker-input.ant-input,
.white-box .appointment-form-input .ant-time-picker-input,
.white-box .form-input .ant-time-picker-input {
  border: none;
  box-shadow: none;
  color: #6B6B6B;
  padding: 0px 4px;
  height: 36px;
  margin: 0px;
  border-radius: 0;
}
.white-box .appointment-form-input .ant-calendar-picker-input.ant-input:hover,
.white-box .form-input .ant-calendar-picker-input.ant-input:hover,
.white-box .appointment-form-input .ant-time-picker-input:hover,
.white-box .form-input .ant-time-picker-input:hover,
.white-box .appointment-form-input .ant-calendar-picker-input.ant-input:focus,
.white-box .form-input .ant-calendar-picker-input.ant-input:focus,
.white-box .appointment-form-input .ant-time-picker-input:focus,
.white-box .form-input .ant-time-picker-input:focus {
  border: none;
  box-shadow: none;
}
.white-box .appointment-form-input .ant-calendar-picker-input.ant-input::placeholder,
.white-box .form-input .ant-calendar-picker-input.ant-input::placeholder {
  color: #a9b1b8;
}
.white-box .appointment-form-input .ant-select-arrow .ant-select-arrow-icon,
.white-box .form-input .ant-select-arrow .ant-select-arrow-icon,
.white-box .appointment-form-input .anticon,
.white-box .form-input .anticon {
  color: #6B6B6B;
}
.white-box .appointment-form-input.ant-calendar-picker,
.white-box .form-input.ant-calendar-picker {
  padding: 0;
}
@media screen and (min-width: 1600px) {
  .white-box .appointment-form-input,
  .white-box .form-input {
    font-size: 14px;
  }
}
.white-box .form-select {
  border: 1px solid #F3F3F3;
  min-width: 190px;
  max-width: 190px;
  border-radius: 4px;
  min-height: 36px;
}
.white-box .form-select .ant-select-selection {
  border: none;
  box-shadow: none;
}
.white-box .form-select .ant-select-selection__rendered {
  top: 1px;
  line-height: 36px;
}
.white-box .form-select .ant-select-selection__rendered .ant-select-selection__placeholder,
.white-box .form-select .ant-select-selection__rendered .ant-select-search__field__placeholder {
  margin-top: -12px;
  color: #a9b1b8;
}
.white-box .form-select .ant-select-arrow {
  top: 16px;
}
.white-box .form-select .ant-select-selection-selected-value {
  color: #6B6B6B;
  line-height: 35px;
}
.white-box .form-select .ant-select-arrow .ant-select-arrow-icon,
.white-box .form-select .anticon {
  color: #6B6B6B;
}
.white-box .form-select.ant-select-auto-complete.ant-select .ant-input {
  color: #6B6B6B;
  border: none;
}
.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:hover,
.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:focus,
.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:active {
  border: none;
  box-shadow: none;
}
.white-box .form-select .ant-select-search--inline .ant-select-search__field {
  color: #6B6B6B;
}
.white-box .ant-select-selection-selected-value {
  color: #fff;
}
.white-box .appointment-form-input::placeholder {
  color: #a9b1b8;
}
.white-box .view-appointment-patient.drawer-form .ant-form-item,
.white-box .drawer-form .ant-form-item {
  margin-right: 6px;
}
.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label,
.white-box .drawer-form .ant-form-item .ant-form-item-label {
  min-width: 96px;
  text-align: left;
}
.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label,
.white-box .drawer-form .ant-form-item .ant-form-item-label label {
  color: #6B6B6B;
  padding-left: 7px;
  font-size: 12px;
  font-weight: 600;
}
.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label::before,
.white-box .drawer-form .ant-form-item .ant-form-item-label label::before {
  position: absolute;
  left: 0px;
  top: -5px;
  font-size: 12px;
}
@media screen and (min-width: 1600px) {
  .white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label,
  .white-box .drawer-form .ant-form-item .ant-form-item-label label {
    font-size: 14px;
  }
}
.white-box .appointment-form-input.ant-calendar-picker .ant-form-item-control,
.white-box .form-input .ant-time-picker-input .ant-form-item-control,
.white-box .appointment-form-input.ant-calendar-picker > .ant-form-item-label,
.white-box .form-input .ant-time-picker-input > .ant-form-item-label {
  line-height: 24px;
}
.white-box .ant-form-item {
  padding: 0px;
  margin: 0px 3px 10px;
  border: none;
  box-shadow: none;
}
.white-box .ant-form-item .ant-form-item-control,
.white-box .ant-form-item > .ant-form-item-label {
  line-height: 32px;
}
.white-box h3 {
  color: #051B30;
  font-weight: 600;
  font-size: 16px;
  margin: 0px 0px 10px;
}
.white-box .ant-list-item,
.white-box .ant-list-item-meta-description,
.white-box .ant-list-item-meta-title {
  color: #051B30;
}
.white-box .ant-list-split.ant-list {
  max-height: 200px;
  overflow-y: auto;
}
.white-box .ant-list-split .ant-list-item {
  border-color: #F3F3F3;
  padding: 6px 0;
}
.white-box .ant-list-item,
.white-box .ant-list-item-meta-description,
.white-box .ant-list-item-meta-title {
  color: #051B30;
}
.white-box .ant-list-split.ant-list {
  max-height: 200px;
  overflow-y: auto;
}
.white-box .ant-list-split .ant-list-item {
  border-color: #F3F3F3;
  padding: 6px 0;
}
.white-box .ant-tabs .ant-tabs-bar {
  border-bottom-color: #f5f5f5;
}
.white-box .ant-tabs .ant-tabs-ink-bar {
  background-color: #0590DE;
}
.white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  color: #AAADAF;
}
.white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  color: #051B30;
}
@media screen and (min-width: 1600px) {
  .white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab {
    font-size: 15px;
  }
}
.white-box .scan-form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 15px;
}
.white-box .scan-form-row .ant-form-item-label label {
  color: #6B6B6B;
  font-weight: 600;
}
.white-box .ant-row-flex [class*='ant-col-'] {
  padding: 0px;
}
.white-box .textarea-full,
.white-box .textarea-full > .ant-form-item-control-wrapper {
  width: 100%;
}
.white-box .textarea-full .form-input,
.white-box .textarea-full > .ant-form-item-control-wrapper .form-input {
  max-width: 98%;
}
.white-box.vertical {
  margin: 0;
}
.white-box.vertical .ant-form-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.white-box.vertical .ant-form-item.full-width,
.white-box.vertical .ant-form-item.full-width .ant-col {
  width: 100%;
  text-align: left;
}
.white-box.vertical .ant-form-item.full-width .form-input,
.white-box.vertical .ant-form-item.full-width .ant-col .form-input,
.white-box.vertical .ant-form-item.full-width .form-select,
.white-box.vertical .ant-form-item.full-width .ant-col .form-select {
  max-width: 100%;
}
.white-box.vertical .ant-form-item.recurring-dates input[type="text"] {
  border-radius: 20px;
  border-color: #089265;
  min-height: 36px;
  padding-left: 15px;
  color: #089265;
}
.white-box.vertical .ant-form-item.recurring-dates input[type="text"]::placeholder {
  color: #089265;
}
.white-box.vertical .ant-form-item.horizontal {
  flex-direction: row;
  align-items: center;
}
.white-box.vertical .ant-form-item .ant-form-item-label {
  line-height: 2;
}
.white-box.vertical .ant-tabs {
  overflow: visible;
}
.white-box .invoices-table {
  color: #000000;
}
.white-box .invoices-table .ant-input,
.white-box .invoices-table .ant-select,
.white-box .invoices-table .ant-select-selection-selected-value {
  color: #000000;
  border-color: #f3f3f3;
}
.white-box .invoices-table .ant-select-selection {
  border-color: #d9d9d9;
  margin: 4px;
  font-size: 14px;
}
.white-box .invoices-table .ant-calendar-picker {
  padding-right: 4px;
}
.white-box .invoices-table .ant-calendar-picker .ant-calendar-picker-input {
  color: #000000;
  padding-right: 26px;
}
.white-box .invoices-table .ant-calendar-picker .ant-calendar-picker-icon {
  color: #6B6B6B !important;
}
.white-box .invoices-table .ant-select-arrow .anticon {
  color: #6B6B6B !important;
}
.white-box.listing-wrapper {
  color: #222;
  font-weight: 500;
}
.white-box.listing-wrapper .ant-table-body {
  overflow-y: auto;
}
@media screen and (min-width: 1600px) {
  .white-box.listing-wrapper .ant-table-body {
    max-height: 400px;
  }
}
.white-box.listing-wrapper .ant-table-body .ant-table-thead {
  position: sticky;
  top: 0px;
  z-index: 10;
}
.white-box.listing-wrapper .ant-table-body .ant-table-tbody > tr > td {
  border-bottom-color: #ddd;
  padding: 8px;
  color: #222;
}
.white-box.listing-wrapper .ant-table-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background-color: #fefefe;
}
.white-box.listing-wrapper.no-white-onhover .ant-table-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background-color: transparent;
}
.white-box.listing-wrapper .no-data .ant-table-thead {
  display: none;
}
.white-box .send-guidelines {
  margin-bottom: 0px;
  margin-left: 5px;
  min-height: 38px;
  line-height: 1;
}
.white-box .search-resources-input {
  border: none;
  background-color: #F8F8F8;
  min-height: 40px;
}
.white-box .search-resources-input::placeholder {
  color: #9BA4AC;
}
.white-box .search-resources-input .ant-input-suffix {
  font-size: 18px;
  top: 44%;
}
.white-box .search-resources-input .ant-input-suffix .ant-input-search-icon {
  color: #595959;
}
.white-box.listing-wrapper .table-height-limit .ant-table-body {
  max-height: 350px;
}
.white-box.listing-wrapper .warnings-drawer-table .ant-table-body {
  max-height: calc(100vh - 250px);
}
.white-box .ant-input-password.form-input.ant-input-affix-wrapper {
  padding: 0px;
}
.white-box .ant-input-password.form-input.ant-input-affix-wrapper input.ant-input {
  min-height: 40px;
  color: #000;
}
.dark-theme .white-box .ant-input-affix-wrapper .ant-input-suffix i {
  color: #545454 !important;
}
.ant-form-inline .white-box .ant-form-item,
.white-box .ant-form-inline .ant-form-item {
  margin-bottom: 5px;
}
.ant-form-inline {
  margin-left: 0px;
  margin-right: -4px;
}
.ant-form-inline .white-box .ant-form-item,
.white-box .ant-form-inline .ant-form-item {
  margin-bottom: 5px;
}
.ant-form-inline {
  margin-left: 0px;
}
.ant-form-vertical .ant-form-item-label,
.ant-col-24.ant-form-item-label,
.ant-col-xl-24.ant-form-item-label {
  padding: 0 0 3px;
}
.checkbox-wrapper {
  padding: 5px 0;
}
.checkbox-wrapper .ant-form-item {
  margin: 0px 5px 10px;
}
.checkbox-wrapper .ant-form-item .ant-form-item-label {
  padding-bottom: 0px;
}
.room-selector {
  display: block;
  width: 100%;
  margin: 10px 0;
  padding: 0 8px;
  flex-wrap: wrap;
}
.room-selector h3 {
  margin-right: 6px;
}
.room-selector .room-selector-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.room-selector .ant-radio-button-wrapper {
  border: none;
  background: #f1f5f5;
  margin-left: 0;
  border-radius: 6px !important;
  padding: 11px 13px;
  font-weight: 600;
  color: #2e3a49;
  transition: all 0.3s;
  line-height: 1;
}
.room-selector .ant-radio-button-wrapper-checked {
  background: #2ca6b9;
  color: #fff !important;
}
.room-selector .ant-radio-button-wrapper:hover {
  border-color: transparent;
  background: #2ca6b9;
  color: #fff;
}
.room-selector .ant-radio-button-wrapper:not(:first-child)::before {
  display: none !important;
  background-color: transparent;
}
.ant-drawer-body {
  width: 100%;
  height: 97%;
}
.dark-theme .ant-drawer-body .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),
.ant-input-search .ant-input,
.ant-input-search .ant-input:hover {
  border: none;
  box-shadow: none;
  color: #535353;
}
.tabs-wrapper .ant-tabs .ant-tabs-bar,
.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-bar {
  border-bottom-color: #D8DFE5;
  border-bottom-width: 2px;
  margin-bottom: 10px;
}
.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab,
.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  color: #9BA4AC;
}
@media screen and (min-width: 1600px) {
  .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab,
  .dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab {
    font-size: 18px;
  }
}
.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,
.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  color: #ffffff;
}
.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar,
.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar {
  background-color: #3CB2C9;
}
.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-bar {
  border-bottom-color: #0E2835;
}
.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,
.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,
.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  color: #000;
}
.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-bar,
.white-box .tabs-wrapper .ant-tabs .ant-tabs-bar,
.white-table-container .ant-tabs .ant-tabs-bar,
.dark-theme .white-table-container .ant-tabs .ant-tabs-bar {
  border-color: #f5f5f5;
}
.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,
.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,
.white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,
.dark-theme .white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab {
  color: #AAADAF;
}
.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,
.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,
.white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,
.dark-theme .white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active {
  color: #3CB2C9;
}
.dark-theme .white-box .tabs-wrapper .ant-tabs-tabpane .ant-card-body,
.white-box .tabs-wrapper .ant-tabs-tabpane .ant-card-body,
.white-table-container .ant-tabs-tabpane .ant-card-body,
.dark-theme .white-table-container .ant-tabs-tabpane .ant-card-body {
  padding: 0px;
}
.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-checkbox-wrapper,
.white-box .tabs-wrapper .ant-tabs .ant-checkbox-wrapper,
.white-table-container .ant-tabs .ant-checkbox-wrapper,
.dark-theme .white-table-container .ant-tabs .ant-checkbox-wrapper {
  color: #051B30;
  font-weight: 600;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper,
.white-box .tabs-wrapper .gx-card.listing-wrapper,
.white-table-container .gx-card.listing-wrapper,
.dark-theme .white-table-container .gx-card.listing-wrapper {
  box-shadow: none;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table,
.white-table-container .gx-card.listing-wrapper .ant-table,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table {
  color: #383838;
  border: none;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,
.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th {
  border: none;
  color: #383838;
  background: #ffffff;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,
.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td {
  background: #ffffff;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,
.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input {
  background-color: transparent;
  color: #6B6B6B;
  border-color: #F3F3F3;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,
.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked {
  background-color: #03AD6F;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #F8F8F8;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next {
  border-color: #f5f5f5;
  background: #f5f5f5;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled {
  color: #D2D2D2;
  line-height: 1.8;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus {
  background: #dcdcdc;
  color: #051B30;
  border: none;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link {
  border: none;
  color: #051B30;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item {
  background-color: #ffffff;
  color: #444444;
  border-color: #F3F3F3;
  margin: 0 5px;
}
.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,
.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,
.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,
.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a {
  color: #444444;
}
.white-table-container #sites-table .ant-table-body {
  max-height: 200px;
  overflow-y: auto;
}
.white-table-container #sites-table .ant-table-thead {
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 10;
}
.gx-card.listing-wrapper .ant-form-inline .ant-row {
  padding-left: 4px;
  padding-right: 4px;
  margin-bottom: 0px;
}
.gx-card.listing-wrapper .ant-form-inline .ant-row .ant-form-item-control {
  line-height: normal;
}
.gx-card.listing-wrapper .ant-form-inline .ant-row {
  padding-left: 4px;
  padding-right: 4px;
  margin-bottom: 0px;
}
.gx-card.listing-wrapper .ant-form-inline .ant-row .ant-form-item-control {
  line-height: normal;
}
.gx-card.listing-wrapper .ant-select {
  color: #9BA4AC;
}
.gx-card.listing-wrapper .ant-select .ant-select-selection {
  min-height: 40px;
  border: 1px solid transparent;
}
.gx-card.listing-wrapper .ant-select .ant-select-selection:hover,
.gx-card.listing-wrapper .ant-select .ant-select-selection:focus {
  border: 1px solid transparent;
  box-shadow: none;
}
.gx-card.listing-wrapper .ant-select .ant-select-selection .ant-select-selection__rendered {
  line-height: 38px;
  color: #545454;
  margin-left: 10px;
}
.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection .ant-select-selection__rendered {
  color: #ffffff;
}
.gx-card.listing-wrapper .ant-table-tbody td .ant-select .ant-select-selection {
  background-color: #e4e4e4;
}
.dark-theme .gx-card.listing-wrapper .ant-table-tbody td .ant-select .ant-select-selection {
  background-color: #051B30;
}
.gx-card.listing-wrapper .ant-input {
  min-height: 40px;
  border: 1px solid transparent;
}
.gx-card.listing-wrapper .ant-input:hover,
.gx-card.listing-wrapper .ant-input:focus {
  border: 1px solid transparent;
  box-shadow: none;
}
.gx-card.listing-wrapper .ant-input ::placeholder {
  color: #9BA4AC;
}
.gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions {
  background: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions {
  background: transparent;
}
.gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions:hover {
  background: #ffffff;
}
.gx-card.listing-wrapper .ant-table-body .ant-table-row-expand-icon {
  font-size: 18px;
  color: #265077;
  border-color: #354D65;
}
.gx-card.listing-wrapper .ant-table-thead > tr > th {
  font-size: 14px;
  font-weight: 600;
  padding: 12px;
  background: #ffffff;
  border: none;
}
.gx-card.listing-wrapper .ant-table-tbody > tr > td,
.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  padding: 12px 16px;
  background: #ffffff;
  font-weight: 500;
  border-bottom: none;
}
.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr > td,
.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  font-weight: 400;
}
@media screen and (min-width: 1600px) {
  .gx-card.listing-wrapper .ant-table-tbody > tr > td,
  .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    font-size: 14px;
  }
}
.gx-card.listing-wrapper .ant-table-tbody > tr > td .status-icon,
.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .status-icon {
  width: 12px;
  height: 12px;
}
.gx-card.listing-wrapper .ant-table-tbody > tr > td .icon,
.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .icon {
  color: #265077;
}
.gx-card.listing-wrapper .ant-table-tbody > tr > td .undo-icon,
.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .undo-icon {
  color: #265077;
  font-size: 22px;
  cursor: pointer;
}
.gx-card.listing-wrapper .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #f3f2f2;
}
.gx-card.listing-wrapper .icon-cmp-refresh {
  color: #354D65;
  font-size: 18px;
  position: absolute;
  top: 10px;
  right: 5px;
}
.gx-card.listing-wrapper .icon-cmp-refresh.tab-icon {
  right: 5px;
  top: -40px;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item {
  background-color: #ffffff;
  border-color: #E5E5E5;
  margin-bottom: 0px;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item {
  background-color: #0c1a27;
  border-color: #1c2730;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item a {
  color: #545454;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item a {
  color: #B8DFFB;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active {
  border-color: #37A2B7;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active a {
  color: #545454;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active a {
  color: #ffffff;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next {
  margin-bottom: 0px;
  border: 1px solid #DDDDDD;
  background-color: #DDDDDD;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next {
  border: 1px solid #1c2730;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev a,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next a,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev a,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next a {
  border: none;
  background-color: #DDDDDD;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis {
  color: #B8DFFB;
  background-color: #ffffff;
}
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:hover,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:hover,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:hover,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:hover,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:focus,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:focus,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:focus,
.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:focus {
  background-color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis {
  background-color: #0c1a27;
}
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:hover,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:hover,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:hover,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:hover,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:focus,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:focus,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:focus,
.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:focus {
  background-color: #0c1a27;
}
.gx-card.listing-wrapper .ant-calendar-picker {
  width: 100%;
}
.gx-card.listing-wrapper .ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {
  height: 18px;
  color: #7E7E7E;
  line-height: 10px;
  padding: 3px 20px 3px 10px;
  background-color: #c5c5c5;
  border-color: #c5c5c5;
}
.dark-theme .gx-card.listing-wrapper .ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {
  background-color: #051B30;
  border-color: #051B30;
  color: #9BA4AC;
}
.gx-card.listing-wrapper .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 11px;
  color: #9BA4AC;
  top: 2px;
}
.dark-theme .gx-card.listing-wrapper .ant-input {
  background-color: #082139;
  border-color: #082139;
  color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-input:hover,
.dark-theme .gx-card.listing-wrapper .ant-input:focus {
  border-color: #082139;
}
.dark-theme .gx-card.listing-wrapper .ant-btn {
  min-height: 40px;
  padding-left: 10px;
  padding-right: 10px;
}
.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection {
  background-color: #082139;
  border-color: #082139;
  color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection {
  background-color: #082139;
  border-color: #082139;
  color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper .ant-form-inline .ant-row .ant-checkbox-wrapper .ant-checkbox-inner {
  background-color: #082139;
  border-color: #0a2946;
}
.dark-theme .gx-card.listing-wrapper .ant-table-thead > tr > th {
  background: #051B30;
  color: #E9F6FF;
  border-color: #051B30;
}
.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr > td,
.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #051B30;
}
.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #082139;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-card-body {
  padding: 0px;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-table-thead > tr > th {
  background: #081C26 !important;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr > td,
.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #081C26;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #152831;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue {
  background: transparent;
  color: #AAAAAA;
  border-color: #AAAAAA;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.receptionist {
  color: #97D3F4;
  border-color: #97D3F4;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.admin {
  color: #ffffff;
  border-color: #ffffff;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.mis,
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.mrt {
  color: #D59DD5;
  border-color: #D59DD5;
}
.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.typ {
  color: #B9BDAC;
  border-color: #B9BDAC;
}
.ant-drawer-right .ant-drawer-content-wrapper,
.ant-drawer-right .ant-drawer-content {
  min-width: 675px;
  max-width: 675px;
  background: #F3F3F3;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body,
.ant-drawer-right .ant-drawer-content .ant-drawer-body {
  padding: 0px;
  padding-right: 10px;
  overflow: auto;
  padding-bottom: 10px;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar,
.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar {
  width: 5px;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-track,
.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-thumb,
.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-thumb:hover,
.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}
.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body .ant-table-wrapper .ant-table-thead > tr > th,
.ant-drawer-right .ant-drawer-content .ant-drawer-body .ant-table-wrapper .ant-table-thead > tr > th {
  font-weight: 600;
}
.ant-drawer-right .ant-drawer-content-wrapper {
  padding-right: 8px;
}
.ant-drawer-right .ant-drawer-content {
  min-width: calc(675px - 40px);
  overflow: unset;
}
.ant-drawer-right .ant-drawer-wrapper-body {
  overflow: unset;
}
.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper,
.ant-drawer-right.invoice-drawer .ant-drawer-content {
  min-width: 750px;
  max-width: 750px;
  padding-right: 20px;
}
@media screen and (min-width: 1600px) {
  .ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper,
  .ant-drawer-right.invoice-drawer .ant-drawer-content {
    min-width: 800px;
    max-width: 800px;
  }
}
.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table,
.ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table {
  font-size: 13px;
}
@media screen and (min-width: 1600px) {
  .ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table,
  .ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table {
    font-size: 14px;
  }
}
.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table tr td,
.ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table tr td {
  padding: 4px;
  color: #000000;
}
.overlapping-drawer.ant-drawer-open {
  transform: translateX(0px) !important;
}
.white-bg .ant-calendar {
  background-color: #f3f3f3;
}
.white-bg .ant-calendar-input {
  color: #222;
  background-color: #f3f3f3;
}
.white-bg .ant-calendar-header .ant-calendar-prev-century-btn,
.white-bg .ant-calendar-header .ant-calendar-prev-decade-btn,
.white-bg .ant-calendar-header .ant-calendar-next-decade-btn,
.white-bg .ant-calendar-header .ant-calendar-prev-month-btn,
.white-bg .ant-calendar-header .ant-calendar-next-month-btn,
.white-bg .ant-calendar-header .ant-calendar-prev-year-btn,
.white-bg .ant-calendar-header .ant-calendar-next-year-btn,
.white-bg .ant-calendar-header .ant-calendar-century-select,
.white-bg .ant-calendar-header .ant-calendar-decade-select,
.white-bg .ant-calendar-header .ant-calendar-year-select,
.white-bg .ant-calendar-header .ant-calendar-month-select {
  color: #222;
}
.white-bg .ant-calendar-date {
  color: #222;
}
.white-bg .ant-calendar-date:hover,
.white-bg .ant-calendar-date:focus,
.white-bg .ant-calendar-date:active {
  color: #fff;
}
.ant-calendar-picker .ant-calendar-range-picker-separator {
  vertical-align: text-top;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select,
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-combobox {
  border-color: #1c3c5a;
  background: #18344f;
}
.ant-calendar-time .ant-calendar-day-select,
.ant-calendar-month-panel-month,
.ant-calendar-decade-panel-decade {
  color: #E9F6FF;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-inner {
  padding-top: 35px;
}
.ant-calendar-range-right .ant-calendar-time-picker-inner {
  border-color: #1c3c5a;
}
.dark-theme .ant-calendar .ant-calendar-ok-btn.ant-calendar-ok-btn-disabled {
  background-color: #818181;
  border-color: #818181;
  cursor: not-allowed;
}
.ant-calendar-range.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {
  font-size: 15px;
  color: #fff;
}
li.ant-calendar-time-picker-select-option-selected,
.ant-calendar-time-picker-select li:hover {
  background: #13283c;
}
.ant-modal-title {
  font-size: 18px;
  color: #051B30;
}
@media screen and (min-width: 1600px) {
  .ant-modal-title {
    font-size: 20px;
  }
}
.ant-modal.patients-search-modal .ant-modal-body {
  background: #F3F3F3;
}
.ant-modal.patients-search-modal .ant-modal-body .ant-table-body .ant-table-thead > tr > th {
  background: #c3cac9;
  color: #222;
  font-size: 15px;
  border-color: #bbb;
}
.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr > td {
  border-bottom-color: #eee;
  color: #575757;
}
.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr.ant-table-row-selected td {
  background: #c0c8c7;
}
.dark-theme .ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: transparent;
}
.dark-theme .white-box .ant-upload-list-item-info .anticon-paper-clip {
  color: #595959;
}
.ant-modal.view-document-modal {
  top: 25px;
}
.ant-modal.view-document-modal .ant-modal-body,
.ant-modal.view-document-modal .ant-modal-header,
.ant-modal.view-document-modal .ant-modal-footer {
  margin-top: 0px;
  background: #f8f8f8;
  padding: 15px;
}
.ant-modal.view-document-modal .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open,
.ant-modal.view-document-modal .ant-modal.view-document-modal .ant-tree li span.ant-tree-switcher,
.ant-modal.view-document-modal .ant-modal.view-document-modal .ant-tree-node-content-wrapper {
  color: #222 !important;
  font-size: 14px;
}
.ant-modal.view-document-modal .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open {
  font-weight: bold;
}
.dark-theme .ant-modal-body .ant-tree li .ant-tree-node-content-wrapper,
.dark-theme .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  color: #545454;
}
.ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.visit-detail-bg.change-password-wrapper form.ant-form {
  display: flex;
  flex-wrap: wrap;
}
.visit-detail-bg.change-password-wrapper form.ant-form .patient-info-input.ant-input-affix-wrapper {
  width: 275px;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg.change-password-wrapper form.ant-form .patient-info-input.ant-input-affix-wrapper {
    width: 325px;
  }
}
.visit-detail-bg.change-password-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.visit-detail-bg.change-password-wrapper .patient-info-input.ant-input-affix-wrapper {
  width: 275px;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg.change-password-wrapper .patient-info-input.ant-input-affix-wrapper {
    width: 325px;
  }
}
.visit-detail-bg.change-password-wrapper .pwd-policy {
  font-size: 12px;
  font-style: italic;
  color: #9BA4AC;
}
@media screen and (min-width: 1600px) {
  .visit-detail-bg.change-password-wrapper .pwd-policy {
    font-size: 13px;
  }
}
.ant-modal.report-viewer-modal .ant-modal-body {
  padding: 5px;
  padding-top: 0px;
  margin-top: 0px;
  max-height: 800px;
  overflow: auto;
}
.ant-modal.report-viewer-modal .ant-modal-body .report-btn-container .ant-btn-primary.ant-btn-circle {
  min-height: 34px;
  min-width: 33px;
}
@media screen and (min-width: 1600px) {
  .ant-modal.report-viewer-modal .ant-modal-body .ant-btn-primary {
    min-height: 40px;
  }
}
.ant-modal.report-viewer-modal .ant-modal-body .ant-btn:not(:last-child) {
  margin-right: 12px;
}
.ant-menu-light li.ant-menu-item svg {
  width: 20px;
  height: 20px;
}
.ant-menu-light li.ant-menu-item svg path {
  fill: #444444;
}
.dark-theme .ant-modal-body .ant-time-picker-input,
.dark-theme .ant-modal-body .ant-select-selection,
.dark-theme .ant-modal-body .ant-table {
  color: #595959;
}
.dark-theme .ant-modal-body .examinations-table .ant-time-picker-input,
.dark-theme .ant-modal-body .examinations-table .ant-select-selection {
  color: #ffffff;
}
.dark-theme .ant-drawer-body .ant-table {
  color: #595959;
}
.dark-theme .ant-drawer-body .examinations-table,
.dark-theme .ant-drawer-body .examinations-table .ant-table {
  color: #ffffff;
}
.dark-theme .ant-modal.scan-modal .ant-modal-body label.ant-radio-button-wrapper {
  font-size: 13px !important;
  color: #111;
  border-radius: 4px;
  margin: 2px;
  border: 1px solid #ccc !important;
}
.dark-theme .ant-modal.scan-modal .ant-modal-body label.ant-radio-button-wrapper:hover {
  color: #60bbe7;
}
.dark-theme .ant-modal.scan-modal .ant-modal-body .ant-select-selection:hover {
  border-color: #dde2e6;
}
.ant-btn.end-visit-close-btn {
  position: absolute;
  top: -50px;
  right: -25px;
  border: none;
  box-shadow: none;
  color: #000;
  font-size: 16px;
  width: 32px;
  padding: 4px;
  min-height: 32px;
}
.view-images-btn {
  background-color: #00796b !important;
  border-color: #00796b !important;
  color: #fff !important;
}
.ant-card.white-card {
  background: #ffffff;
  border: none;
  color: #383838;
}
.ant-card.white-card .ant-card-body {
  padding: 0px;
}
.notes-confirmation {
  margin-top: 15px;
}
.ant-modal.gx-modal-container .ant-modal-header,
.ant-modal.gx-modal-container .ant-modal-footer {
  background-color: #F3F3F3;
}
.ant-modal.gx-modal-container .ant-modal-header .ant-modal-title,
.ant-modal.gx-modal-container .ant-modal-footer .ant-modal-title {
  font-weight: 600;
}
.ant-modal.gx-modal-container .ant-modal-footer {
  padding: 10px 18px;
}
.ant-modal.gx-modal-container .ant-modal-body {
  background-color: #F3F3F3;
  margin-top: 0px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.ant-modal.gx-modal-container .ant-modal-body .ant-form-item-label label {
  color: #6B6B6B;
  font-weight: 600;
}
.ant-modal.gx-modal-container .ant-modal-body .visit-notes-tree {
  border-radius: 8px;
}
.ant-modal.gx-modal-container .ant-modal-body .ant-table {
  background-color: #fff;
}
.ant-modal.gx-modal-container .ant-modal-body .visit-notes-tree + .ant-row {
  margin-right: 0 !important;
  margin-top: 12px !important;
  margin-bottom: 5px !important;
}
.ant-modal.gx-modal-container .gx-popup-form {
  background-color: #ffffff;
  padding: 12px 16px;
  margin: 0 -2px;
  border-radius: 8px;
}
.ant-modal.gx-modal-container .notes-confirmation {
  margin-top: 0px;
}
.loc-row,
.loc-row.ant-row {
  margin: 8px 0px 8px;
  padding-bottom: 8px;
  border-bottom: 3px solid #F3F3F3;
}
.loc-row:last-child,
.loc-row.ant-row:last-child {
  border-bottom: none;
}
.ant-table-wrapper.ref-doc-table .ant-table-body tr td p {
  margin-bottom: 5px;
}
.ant-table-placeholder {
  border-bottom: none;
  margin-top: 0px;
}
.powerbi-error-block h3,
.powerbi-error-block p {
  color: #5e5e5e;
}
.notifications-popover .ant-list-items svg {
  max-width: 16px;
  min-width: 16px;
}
.notifications-popover .ant-list-items svg path {
  fill: #7E7E7E;
}
.amrHighlightIcon {
  position: absolute;
  top: 0px;
  right: 6px;
}
.amrHighlightIcon svg path {
  fill: #f00;
}
.complete-visit-modal.ant-modal {
  width: 450px !important;
}
.complete-visit-modal.ant-modal .ant-modal-header {
  background-color: #F3F3F3;
}
.complete-visit-modal.ant-modal .ant-modal-footer {
  border: none;
  padding-bottom: 20px;
}
/*Media Queries*/
@media screen and (max-width: 768px) {
  #root {
    overflow-y: auto;
  }
}
@media screen and (min-width: 1600px) {
  .ant-modal.view-document-modal .ant-btn.ant-btn-circle,
  .drawer-form .ant-btn.ant-btn-circle {
    min-height: 37px;
  }
}
@media screen and (min-width: 1440px) {
  .custom-site {
    width: 170px !important;
  }
}
@media screen and (max-width: 1024px) {
  .custom-site {
    width: 90px !important;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1439) {
  .custom-site {
    width: 110px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/wieldy.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F;;;;CAIC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEAkEgE;AAChE,yCAAyC;AAQzC;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;;;;EAWE,cAAc;AAChB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;;;;;;EAME,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,cAAc;EACd,qFAAqF;AACvF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;EASE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;EAIE,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,iDAAiD;EACjD,YAAY;EACZ,6GAA6G;EAC7G,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;IACE,yBAAyB;IACzB,mDAAmD;EACrD;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,iEAAiE;AACnE;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;EACZ;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE,+DAA+D;AACjE;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4HAA4H;AAC9H;AACA;EACE,gBAAgB;EAChB,4HAA4H;AAC9H;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,yDAAyD;AAC3D;AACA;EACE,uEAAuE;EACvE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,yDAAyD;AAC3D;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uEAA2uB;AAC7uB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kEAAkE;EAClE,yBAAyB;AAC3B;AACA;EACE,oEAAoE;EACpE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,wCAAwC;IACxC,UAAU;EACZ;EACA;IACE,wCAAwC;EAC1C;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;IACxC,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,wCAAwC;EACxC,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;EAIE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,iEAAiE;EACjE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,wCAAwC;EACxC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;;;EAOE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;EAGE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,mCAAmC;AACrC;AACA;;EAEE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uHAAuH;EACvH,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,gHAAgH;EAChH,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,+CAA+C;AACjD;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;AACA;;;;EAIE,8BAA8B;AAChC;AACA;;;;EAIE,4BAA4B;AAC9B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;;;;EAQE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,6FAA6F;EAC7F,iBAAiB;AACnB;AACA;;;EAGE,SAAS;EACT,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;;;EAGE,UAAU;EACV,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;;;;EAME,oCAAoC;AACtC;AACA;;;EAGE,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,wCAAwC;EACxC,eAAe;EACf,yDAAyD;EACzD,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,wCAAwC;EACxC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;;;;;;;;EAeE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;EAeE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;EAGE,SAAS;AACX;AACA;EACE,MAAM;AACR;AACA;;;EAGE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,OAAO;EACP,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;;;;EAQE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,6FAA6F;EAC7F,iBAAiB;AACnB;AACA;;;EAGE,SAAS;EACT,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;;;EAGE,UAAU;EACV,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;;;;EAME,oCAAoC;AACtC;AACA;;;EAGE,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,OAAO;AACT;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;;;;EAQE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,6FAA6F;EAC7F,iBAAiB;AACnB;AACA;;;EAGE,SAAS;EACT,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;;;EAGE,UAAU;EACV,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;;;;EAME,oCAAoC;AACtC;AACA;;;EAGE,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,OAAO;AACT;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;;;;EAQE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,6FAA6F;EAC7F,iBAAiB;AACnB;AACA;;;EAGE,SAAS;EACT,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;;;EAGE,UAAU;EACV,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;;;;EAME,oCAAoC;AACtC;AACA;;;EAGE,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,OAAO;AACT;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,MAAM;EACN,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;;;;;EAME,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;;;;;;EAME,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kGAAkG;AACpG;AACA;EACE,yGAAyG;AAC3G;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,MAAM;EACN,SAAS;EACT,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,yDAAyD;AAC3D;AACA;;EAEE,SAAS;AACX;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;;EAEE,OAAO;EACP,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,yDAAyD;AAC3D;AACA;;EAEE,UAAU;AACZ;AACA;EACE,MAAM;AACR;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,+DAA+D;AACjE;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,UAAU;EACV,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;;;;EAIE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;;;;EAIE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,4BAA4B;AAC9B;AACA;;;;;;EAME,8BAA8B;AAChC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,+BAA+B;AACjC;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;;;EAGE,gCAAgC;AAClC;AACA;;;EAGE,gCAAgC;AAClC;AACA;;;EAGE,WAAW;EACX,uBAAuB;AACzB;AACA;;;EAGE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;;EAGE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;;IAEE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;EAC1D,oBAAoB;AACtB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;EACd,sCAAsC;AACxC;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;;;;EAKE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;;;;;;;EAOE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;;;;;;;EAOE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;;;;;EAQE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,UAAU;EACV,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,UAAU;EACV,qCAAqC;AACvC;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,MAAM;EACN,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,mEAAmE;EACnE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mEAAmE;EACnE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;EACvC,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,4KAA4K;AAC9K;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mHAAmH;AACrH;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;;EAKE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;AACA;;;EAGE,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,eAAe;AACjB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6NAA6N;AAC/N;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iHAAiH;AACnH;AACA;;EAEE,UAAU;EACV,8GAA8G;AAChH;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;EACf,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,+DAA+D;AACjE;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,+DAA+D;AACjE;AACA;;;;;;;;EAQE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,oKAAoK;EACpK,WAAW;AACb;AACA;;;;EAIE,yCAAyC;AAC3C;AACA;;;;EAIE,yCAAyC;AAC3C;AACA;;;;;;;;EAQE,uDAAuD;AACzD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;AACtC;AACA;;;;;;;;EAQE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,yBAAyB;EACzB,UAAU;EACV,kHAAkH;EAClH,WAAW;AACb;AACA;;;;;;;;EAQE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;EAEE,oBAAoB;EACpB,UAAU;EACV,oHAAoH;AACtH;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,OAAO;EACP,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,sBAAsB;AACxB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;;EAEE,qCAAqC;EACrC,oBAAoB;AACtB;AACA;;EAEE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;;;;EAIE,0CAA0C;AAC5C;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,oBAAoB;AACtB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,MAAM;EACN,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;;;EAGE,cAAc;AAChB;AACA;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;;;;;;EAME,cAAc;EACd,6BAA6B;AAC/B;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,2CAA2C;EAC3C,YAAY;AACd;AACA;;EAEE,2CAA2C;AAC7C;AACA;;;;EAIE,gDAAgD;AAClD;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,OAAO;EACP,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE;IACE,iBAAiB;IACjB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,cAAc;EACd,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,MAAM;EACN,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,OAAO;EACT;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kDAAkD;EAClD,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;AAC3B;AACA;;EAEE,UAAU;EACV,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;;EAEE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,OAAO;IACP,UAAU;EACZ;AACF;AACA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;;EAIE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;;;;EAIE,cAAc;EACd,qBAAqB;AACvB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;;;;EAME,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;;EAGE,oBAAoB;AACtB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;;;EAGE,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;EAC9B,2CAA2C;AAC7C;AACA;EACE,SAAS;EACT,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;;;EAGE,QAAQ;EACR,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;EACE,SAAS;EACT,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,2EAA2E;EAC3E,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,QAAQ;IACR,YAAY;EACd;EACA;IACE,QAAQ;IACR,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,yDAAyD;EACzD,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,2CAA2C;AAC7C;AACA;;;EAGE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,yDAAyD;EACzD,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;;;EAGE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,+CAA+C;EAC/C,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,OAAO;EACP,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;AAC9D;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oEAAoE;AACtE;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uDAAuD;EACvD,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,yEAAyE;EACzE,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,SAAS;EACT,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mGAAmG;AACrG;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,+DAA+D;AACjE;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,mDAAmD;AACrD;AACA;EACE,MAAM;EACN,OAAO;AACT;AACA;EACE,MAAM;EACN,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,OAAO;EACP,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,QAAQ;EACR,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,MAAM;IACN,QAAQ;IACR,WAAW;IACX,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,0DAA0D;EAC1D,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;EACA;IACE,wCAAwC;IACxC,yBAAyB;EAC3B;AACF;AACA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;AACjC;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;EAEE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,8CAA8C;AAChD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,QAAQ;EACR,+CAA+C;AACjD;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;AACnB;AACA;;CAEC;AACD;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;EAgBE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,MAAM;EACN,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;;;;;;;;EAQE,SAAS;AACX;AACA;;;;;;;;;;;;;;;;EAgBE,gBAAgB;AAClB;AACA;;;;;;;;EAQE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,gCAAgC;AAClC;AACA;;;;;;;;EAQE,qCAAqC;AACvC;AACA;;;;;;EAME,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,6DAA6D;AAC/D;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,UAAU;EACV,+JAA+J;EAC/J,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+DAA+D;AACjE;AACA;;EAEE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,2DAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iCAAiC;EACjC,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iEAAiE;EACjE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,WAAW;AACb;AACA;;;;EAIE,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,MAAM;EACN,YAAY;EACZ,UAAU;EACV,UAAU;EACV,SAAS;AACX;AACA;;EAEE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;;EAEE,MAAM;EACN,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;;EAEE,gKAAgK;AAClK;AACA;;EAEE,gKAAgK;AAClK;AACA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;EAEE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;EAEE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,yDAAyD;AAC3D;AACA;EACE,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;EAKE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;;;;EAIE,8BAA8B;AAChC;AACA;;;;EAIE,4BAA4B;AAC9B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,yDAAyD;EACzD,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;EACE;IACE;MACE,gBAAgB;IAClB;EACF;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,SAAS;AACX;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,oBAAoB;AACtB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,2CAA2C;EAC3C,kDAAkD;AACpD;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,4CAA4C;EAC5C,iDAAiD;AACnD;AACA;EACE,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;;;EAGE,oBAAoB;AACtB;AACA;;;EAGE,4CAA4C;EAC5C,kDAAkD;AACpD;AACA;EACE,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,6CAA6C;EAC7C,iDAAiD;AACnD;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,8DAA8D;EAC9D,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,iBAAiB;EACjB,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,sDAAsD;EACtD,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,uEAAuE;EACvE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uDAAuD;EACvD,UAAU;EACV,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,OAAO;AACT;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,SAAS;EACT,cAAc;EACd,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,oBAAoB;AACtB;AACA;;;EAGE,WAAW;EACX,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;;;EAGE,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;;;EAGE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;;;EAIE,wBAAwB;EACxB,yDAAyD;AAC3D;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;EACZ;AACF;AACA,kBAAkB;AAClB;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;EAGE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,4BAA4B;AAC9B;AACA;EACE;IACE,kDAAkD;EACpD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,0CAA0C;EAC5C;EACA;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,6CAA6C;IAC7C,wCAAwC;EAC1C;AACF;AACA;EACE,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE;IACE,kDAAkD;EACpD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,0CAA0C;EAC5C;EACA;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,6CAA6C;IAC7C,wCAAwC;EAC1C;AACF;AACA;EACE,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,iDAAiD;IACjD,4CAA4C;EAC9C;EACA;IACE,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF;AACA;EACE,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,gDAAgD;IAChD,2CAA2C;EAC7C;EACA;IACE,iDAAiD;IACjD,4CAA4C;EAC9C;EACA;IACE,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,sDAAsD;EACtD,0CAA0C;EAC1C,4BAA4B;AAC9B;AACA,gEAAgE;AAChE;EACE,qCAAqC;AACvC;AACA,mEAAmE;AACnE;EACE;4CAC0C;EAC1C,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,4BAA4B;AAC9B;AACA,aAAa;AACb;EACE;6CAC2C;EAC3C,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,4BAA4B;AAC9B;AACA,qDAAqD;AACrD;EACE,wBAAwB;AAC1B;AACA;EACE,mDAAmD;EACnD;IACE,wBAAwB;EAC1B;EACA,gEAAgE;EAChE;IACE,yBAAyB;EAC3B;AACF;AACA,cAAc;AACd;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;;;;;;;;EASE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;AACf;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA,kBAAkB;AAClB;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,WAAW;AACX;EACE,sCAAsC;EACtC,cAAc;AAChB;AACA,eAAe;AACf;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,cAAc;AACd;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,yCAAyC;AAC3C;AACA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,uCAAuC;AACzC;AACA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,+BAA+B;AACjC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;AACA,oBAAoB;AACpB;;;;;;;;;;;;EAYE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA,oBAAoB;AACpB,MAAM;AACN;EACE,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;AACjB;AACA,OAAO;AACP;EACE,eAAe;AACjB;AACA,OAAO;AACP;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA,OAAO;AACP;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,OAAO;AACP;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,OAAO;EACP,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,iBAAiB;AACjB;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,iDAAiD;EACjD,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;;;EAGE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,eAAe;AACjB;AACA;;EAEE,4BAA4B;AAC9B;AACA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA,mBAAmB;AACnB;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,+BAA+B;AACjC;AACA;;;;;;EAME,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,cAAc;EAChB;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;EACV,WAAW;AACb;AACA;;;;EAIE,UAAU;EACV,WAAW;AACb;AACA;;;;;;;;EAQE,6DAA6D;AAC/D;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;;;;;;;;EAQE,uDAAuD;AACzD;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;;;;;EAQE,gCAAgC;EAChC,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,+BAA+B;AACjC;AACA;;;;;;;;EAQE,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;EAgBE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;EAClB,QAAQ;AACV;AACA;;;;;;;;EAQE,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;AACA;;;;;;;;EAQE,aAAa;AACf;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;;;EAGE,OAAO;EACP,0BAA0B;AAC5B;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,uDAAuD;AACzD;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;AACA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;;;EAIE,2CAA2C;AAC7C;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,6DAA6D;AAC/D;AACA;;;;;;;;;;;;EAYE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,cAAc;EAChB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;EAQE,4BAA4B;EAC5B,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,aAAa;EACb,MAAM;AACR;AACA;;;;;;;;EAQE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;;;;;EAQE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,6DAA6D;AAC/D;AACA;;;;;;;;;;EAUE,6DAA6D;AAC/D;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,qBAAqB;AACrB;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE;IACE,MAAM;IACN,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE;IACE,MAAM;IACN,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;AACX;AACA,eAAe;AACf;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;EACtD,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qFAAqF;EACrF,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,sDAAsD;AACxD;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;;IAEE,mBAAmB;EACrB;AACF;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA,cAAc;AACd;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE,aAAa;AACf;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gCAAgC;AAClC;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;;;EAGE,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,WAAW;AACb;AACA,eAAe;AACf;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA,cAAc;AACd;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,cAAc;IACd,2BAA2B;EAC7B;AACF;AACA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,OAAO;EACP,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,qCAAqC;IACrC,kCAAkC;IAClC,6BAA6B;IAC7B,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,yCAAyC;EAC3C;AACF;AACA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,iBAAiB;AACnB;AACA,iBAAiB;AACjB;;;;EAIE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,gBAAgB;AAChB;;;;;;EAME,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;AACF;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA,gBAAgB;AAChB;EACE,YAAY;AACd;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,4CAA4C;IAC5C,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,qBAAqB;EACvB;EACA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,6BAA6B;EAC/B;EACA;;IAEE,oBAAoB;EACtB;EACA;;;;;;IAME,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE;;IAEE,6BAA6B;EAC/B;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA,mBAAmB;AACnB,wBAAwB;AACxB;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;EACP,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AACA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,OAAO;EACT;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,oBAAoB;IACpB,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,yCAAyC;IACzC,WAAW;IACX,WAAW;EACb;EACA;IACE,yCAAyC;IACzC,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;EACpB;EACA;;IAEE,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;AACA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,OAAO;AACT;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;IACd,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;AACA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE;;IAEE,sCAAsC;EACxC;EACA;;IAEE,sCAAsC;EACxC;AACF;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,uCAAuC;EACvC,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,QAAQ;EACV;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;;EAME,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,2GAA2G;EAC3G,8EAA8E;EAC9E,2EAA2E;EAC3E,0EAA0E;EAC1E,yEAAyE;AAC3E;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,8GAA8G;EAC9G,iFAAiF;EACjF,8EAA8E;EAC9E,6EAA6E;EAC7E,4EAA4E;EAC5E,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,+GAA+G;EAC/G,kFAAkF;EAClF,+EAA+E;EAC/E,8EAA8E;EAC9E,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;IACxB,sCAAsC;IACtC,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;IAC9B,0BAA0B;IAC1B,sCAAsC;IACtC,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA,iBAAiB;AACjB,4DAA4D;AAC5D;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,QAAQ;IACR,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,QAAQ;IACR,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,OAAO;EACP,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,OAAO;EACP,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;;;;IAIE,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF;AACA,2BAA2B;AAC3B;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;AACA;EACE,OAAO;AACT;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;AACA;;EAEE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE;4CAC0C;EAC1C,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,iBAAiB;AACjB;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;EAUE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAyB;AAC3B;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,gBAAgB;AAChB;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA,cAAc;AACd;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;;EAGE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;EAQE,4BAA4B;EAC5B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;EACzC,+BAA+B;AACjC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,uHAAuH;AACzH;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;;;;;;;;EAQE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,WAAW;AACb;AACA;;EAEE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;;EAEE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;AACjD;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;AAChB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;;EAKE,4BAA4B;AAC9B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;EACE,0CAA0C;AAC5C;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;;EAEE,sCAAsC;EACtC,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,cAAc;AAChB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;;;EAQE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kDAAkD;AACpD;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BE,cAAc;AAChB;AACA;;;;;;;;;EASE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAyB;AAC3B;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;;IAEE,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE;;;;IAIE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;;;;;;EAME,yBAAyB;EACzB,WAAW;AACb;AACA;;;EAGE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;;EAGE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;AACF;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,WAAW;EACX,aAAa;AACf;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,YAAY;EACd;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,mDAAmD;AACrD;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;;EAGE,mDAAmD;EACnD,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,mDAAmD;EACnD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;;EAEE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA,cAAc;AACd;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;;;;EAIE,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;;;EAGE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;;;IAGE,eAAe;EACjB;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;;;;;;;;EAQE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;;;EAIE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,WAAW;AACb;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,YAAY;AACd;AACA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;EACd,YAAY;AACd;AACA;;;;EAIE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;;;;;;;EAQE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;EAgBE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;;;;;;;;;;;;;;;;EAgBE,YAAY;EACZ,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,aAAa;AACf;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,YAAY;EACZ,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;;EAEE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;;;;;;;;;;EAWE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;;EAGE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;;;EAGE,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;;;EAGE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA,gBAAgB;AAChB;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/*\nAuthor         : G-axon\nTemplate Name  : Wieldy Antd React - Admin Template\nVersion        : 1.0\n*/\n/*=============================================================\n    Table of Contents:\n    =============================\n    A. Globals\n        01. Custom Animation\n        02. Colors Class\n\n    B. Base\n        01. Base Styles\n        02. Row Col Styles\n        03. Margin Padding Styles\n        04. Typography Styles\n        05. Flex Styles\n\n    C. Layouts\n        01. Ant Layout Style\n        02. Header Style\n        03. Sidebar Style\n        04. Navbar(Ant Menu) Style\n        05. Footer Styles\n        06. Customizer Style\n        07. Drawer Style\n\n    D. UI Components\n        01. Alert Styles\n        02. Avatar Styles\n        03. BackTop Styles\n        04. Badges Styles\n        05. Button Styles\n        06. Cards Styles\n        07. Cascader Styles\n        08. Chart Styles\n        09. Form Styles\n        10. Icon Styles\n        11. Input Styles\n        12. List Styles\n        13. Loader Styles\n        14. Pagination Styles\n        15. Pickers Styles\n        16. Progress Styles\n        17. Slider Styles\n        18. Steps Styles\n        19. Tables Styles\n        20. Tabs Styles\n        21. Time Lines Style\n\n    E. Apps\n        01. Apps Style\n        02. Mails Apps Styles\n        03. Chat Apps Styles\n        04. Contact Apps Styles\n        05. Calendar Apps Style\n        06. Profile App Style\n        07. Wall App Style\n\n    F. Pages\n        01. Callout Styles\n        02. E-commerce Styles\n        03. Pricing Tables Styles\n        04. Login Styles\n        05. Dashboard Styles\n        06. Error Styles\n        07. Editor Styles\n        08. Testimonial Styles\n        09. Algolia Styles\n\n  =============================================================*/\n/* stylelint-disable at-rule-no-unknown */\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');\n@import '~@fullcalendar/core/main.css';\n@import '~@fullcalendar/daygrid/main.css';\n@import '~@fullcalendar/timegrid/main.css';\n@import '~@fullcalendar/timeline/main.min.css';\n@import '~@fullcalendar/resource-timeline/main.css';\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\narticle,\naside,\ndialog,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\nbody {\n  margin: 0;\n  color: #545454;\n  font-size: 14px;\n  font-family: \"DM Sans\", sans-serif;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  background-color: #f5f5f5;\n  font-feature-settings: 'tnum';\n}\n[tabindex='-1']:focus {\n  outline: none !important;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 500;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  border-bottom: 0;\n  cursor: help;\n}\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 500;\n}\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1em;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: #2EB1EF;\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #58cefc;\n}\na:active {\n  color: #1c8dc9;\n}\na:active,\na:hover {\n  text-decoration: none;\n  outline: 0;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1em;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1em;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: #595959;\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit;\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n[type='search'] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nmark {\n  padding: 0.2em;\n  background-color: #feffe6;\n}\n::selection {\n  color: #fff;\n  background: #2EB1EF;\n}\n.clearfix {\n  zoom: 1;\n}\n.clearfix::before,\n.clearfix::after {\n  display: table;\n  content: '';\n}\n.clearfix::after {\n  clear: both;\n}\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon > * {\n  line-height: 1;\n}\n.anticon svg {\n  display: inline-block;\n}\n.anticon::before {\n  display: none;\n}\n.anticon .anticon-icon {\n  display: block;\n}\n.anticon[tabindex] {\n  cursor: pointer;\n}\n.anticon-spin::before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.anticon-spin {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.fade-enter,\n.fade-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-enter.fade-enter-active,\n.fade-appear.fade-appear-active {\n  animation-name: antFadeIn;\n  animation-play-state: running;\n}\n.fade-leave.fade-leave-active {\n  animation-name: antFadeOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.fade-enter,\n.fade-appear {\n  opacity: 0;\n  animation-timing-function: linear;\n}\n.fade-leave {\n  animation-timing-function: linear;\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.move-up-enter,\n.move-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-enter.move-up-enter-active,\n.move-up-appear.move-up-appear-active {\n  animation-name: antMoveUpIn;\n  animation-play-state: running;\n}\n.move-up-leave.move-up-leave-active {\n  animation-name: antMoveUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-up-enter,\n.move-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-up-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-down-enter,\n.move-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-enter.move-down-enter-active,\n.move-down-appear.move-down-appear-active {\n  animation-name: antMoveDownIn;\n  animation-play-state: running;\n}\n.move-down-leave.move-down-leave-active {\n  animation-name: antMoveDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-down-enter,\n.move-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-down-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-left-enter,\n.move-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-enter.move-left-enter-active,\n.move-left-appear.move-left-appear-active {\n  animation-name: antMoveLeftIn;\n  animation-play-state: running;\n}\n.move-left-leave.move-left-leave-active {\n  animation-name: antMoveLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-left-enter,\n.move-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-left-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-right-enter,\n.move-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-enter.move-right-enter-active,\n.move-right-appear.move-right-appear-active {\n  animation-name: antMoveRightIn;\n  animation-play-state: running;\n}\n.move-right-leave.move-right-leave-active {\n  animation-name: antMoveRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-right-enter,\n.move-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-right-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@keyframes antMoveDownIn {\n  0% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n[ant-click-animating='true'],\n[ant-click-animating-without-extra-node='true'] {\n  position: relative;\n}\nhtml {\n  --antd-wave-shadow-color: #2EB1EF;\n}\n[ant-click-animating-without-extra-node='true']::after,\n.ant-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 #2EB1EF;\n  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n@keyframes waveEffect {\n  100% {\n    box-shadow: 0 0 0 #2EB1EF;\n    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n.slide-up-enter,\n.slide-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-enter.slide-up-enter-active,\n.slide-up-appear.slide-up-appear-active {\n  animation-name: antSlideUpIn;\n  animation-play-state: running;\n}\n.slide-up-leave.slide-up-leave-active {\n  animation-name: antSlideUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-up-enter,\n.slide-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-up-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-down-enter,\n.slide-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-enter.slide-down-enter-active,\n.slide-down-appear.slide-down-appear-active {\n  animation-name: antSlideDownIn;\n  animation-play-state: running;\n}\n.slide-down-leave.slide-down-leave-active {\n  animation-name: antSlideDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-down-enter,\n.slide-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-left-enter,\n.slide-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-enter.slide-left-enter-active,\n.slide-left-appear.slide-left-appear-active {\n  animation-name: antSlideLeftIn;\n  animation-play-state: running;\n}\n.slide-left-leave.slide-left-leave-active {\n  animation-name: antSlideLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-left-enter,\n.slide-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-left-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-right-enter,\n.slide-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-enter.slide-right-enter-active,\n.slide-right-appear.slide-right-appear-active {\n  animation-name: antSlideRightIn;\n  animation-play-state: running;\n}\n.slide-right-leave.slide-right-leave-active {\n  animation-name: antSlideRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-right-enter,\n.slide-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-right-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes antSlideUpIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n.swing-enter,\n.swing-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.swing-enter.swing-enter-active,\n.swing-appear.swing-appear-active {\n  animation-name: antSwingIn;\n  animation-play-state: running;\n}\n@keyframes antSwingIn {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-10px);\n  }\n  40% {\n    transform: translateX(10px);\n  }\n  60% {\n    transform: translateX(-5px);\n  }\n  80% {\n    transform: translateX(5px);\n  }\n}\n.zoom-enter,\n.zoom-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-enter.zoom-enter-active,\n.zoom-appear.zoom-appear-active {\n  animation-name: antZoomIn;\n  animation-play-state: running;\n}\n.zoom-leave.zoom-leave-active {\n  animation-name: antZoomOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-enter,\n.zoom-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-enter.zoom-big-enter-active,\n.zoom-big-appear.zoom-big-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-leave.zoom-big-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-leave {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-enter.zoom-big-fast-enter-active,\n.zoom-big-fast-appear.zoom-big-fast-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-fast-leave.zoom-big-fast-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-fast-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-enter.zoom-up-enter-active,\n.zoom-up-appear.zoom-up-appear-active {\n  animation-name: antZoomUpIn;\n  animation-play-state: running;\n}\n.zoom-up-leave.zoom-up-leave-active {\n  animation-name: antZoomUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-up-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-enter.zoom-down-enter-active,\n.zoom-down-appear.zoom-down-appear-active {\n  animation-name: antZoomDownIn;\n  animation-play-state: running;\n}\n.zoom-down-leave.zoom-down-leave-active {\n  animation-name: antZoomDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-enter.zoom-left-enter-active,\n.zoom-left-appear.zoom-left-appear-active {\n  animation-name: antZoomLeftIn;\n  animation-play-state: running;\n}\n.zoom-left-leave.zoom-left-leave-active {\n  animation-name: antZoomLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-left-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-enter.zoom-right-enter-active,\n.zoom-right-appear.zoom-right-appear-active {\n  animation-name: antZoomRightIn;\n  animation-play-state: running;\n}\n.zoom-right-leave.zoom-right-leave-active {\n  animation-name: antZoomRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-right-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@keyframes antZoomIn {\n  0% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n}\n.ant-motion-collapse-legacy-active {\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-motion-collapse {\n  overflow: hidden;\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-affix {\n  position: fixed;\n  z-index: 10;\n}\n.ant-alert {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding: 8px 15px 8px 37px;\n  word-wrap: break-word;\n  border-radius: 6px;\n}\n.ant-alert.ant-alert-no-icon {\n  padding: 8px 15px;\n}\n.ant-alert.ant-alert-closable {\n  padding-right: 30px;\n}\n.ant-alert-icon {\n  position: absolute;\n  top: 10.1px;\n  left: 16px;\n}\n.ant-alert-description {\n  display: none;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-alert-success {\n  background-color: #f6ffed;\n  border: 1px solid #b7eb8f;\n}\n.ant-alert-success .ant-alert-icon {\n  color: #52c41a;\n}\n.ant-alert-info {\n  background-color: #e6f7ff;\n  border: 1px solid #91d5ff;\n}\n.ant-alert-info .ant-alert-icon {\n  color: #1890ff;\n}\n.ant-alert-warning {\n  background-color: #fff7e6;\n  border: 1px solid #ffd591;\n}\n.ant-alert-warning .ant-alert-icon {\n  color: #fa8c16;\n}\n.ant-alert-error {\n  background-color: #fff1f0;\n  border: 1px solid #ffa39e;\n}\n.ant-alert-error .ant-alert-icon {\n  color: #f5222d;\n}\n.ant-alert-close-icon {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  padding: 0;\n  overflow: hidden;\n  font-size: 12px;\n  line-height: 22px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n.ant-alert-close-icon .anticon-close {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-alert-close-icon .anticon-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-close-text {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-alert-close-text:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-alert-with-description {\n  position: relative;\n  padding: 15px 15px 15px 64px;\n  color: #545454;\n  line-height: 1.3;\n  border-radius: 6px;\n}\n.ant-alert-with-description.ant-alert-no-icon {\n  padding: 15px;\n}\n.ant-alert-with-description .ant-alert-icon {\n  position: absolute;\n  top: 16px;\n  left: 24px;\n  font-size: 24px;\n}\n.ant-alert-with-description .ant-alert-close-icon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-alert-with-description .ant-alert-message {\n  display: block;\n  margin-bottom: 4px;\n  color: #535353;\n  font-size: 16px;\n}\n.ant-alert-message {\n  color: #535353;\n}\n.ant-alert-with-description .ant-alert-description {\n  display: block;\n}\n.ant-alert.ant-alert-closing {\n  height: 0 !important;\n  margin: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  transform-origin: 50% 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-alert-slide-up-leave {\n  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-alert-banner {\n  margin-bottom: 0;\n  border: 0;\n  border-radius: 0;\n}\n@keyframes antAlertSlideUpIn {\n  0% {\n    transform: scaleY(0);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antAlertSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n.ant-anchor {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding-left: 2px;\n}\n.ant-anchor-wrapper {\n  margin-left: -4px;\n  padding-left: 4px;\n  overflow: auto;\n  background-color: #fff;\n}\n.ant-anchor-ink {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n}\n.ant-anchor-ink::before {\n  position: relative;\n  display: block;\n  width: 2px;\n  height: 100%;\n  margin: 0 auto;\n  background-color: #e8e8e8;\n  content: ' ';\n}\n.ant-anchor-ink-ball {\n  position: absolute;\n  left: 50%;\n  display: none;\n  width: 8px;\n  height: 8px;\n  background-color: #fff;\n  border: 2px solid #2EB1EF;\n  border-radius: 8px;\n  transform: translateX(-50%);\n  transition: top 0.3s ease-in-out;\n}\n.ant-anchor-ink-ball.visible {\n  display: inline-block;\n}\n.ant-anchor.fixed .ant-anchor-ink .ant-anchor-ink-ball {\n  display: none;\n}\n.ant-anchor-link {\n  padding: 7px 0 7px 16px;\n  line-height: 1.143;\n}\n.ant-anchor-link-title {\n  position: relative;\n  display: block;\n  margin-bottom: 6px;\n  overflow: hidden;\n  color: #545454;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-anchor-link-title:only-child {\n  margin-bottom: 0;\n}\n.ant-anchor-link-active > .ant-anchor-link-title {\n  color: #2EB1EF;\n}\n.ant-anchor-link .ant-anchor-link {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.ant-select-auto-complete {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-select-auto-complete.ant-select .ant-select-selection {\n  border: 0;\n  box-shadow: none;\n}\n.ant-select-auto-complete.ant-select .ant-select-selection__rendered {\n  height: 100%;\n  margin-right: 0;\n  margin-left: 0;\n  line-height: 36px;\n}\n.ant-select-auto-complete.ant-select .ant-select-selection__placeholder {\n  margin-right: 12px;\n  margin-left: 12px;\n}\n.ant-select-auto-complete.ant-select .ant-select-selection--single {\n  height: auto;\n}\n.ant-select-auto-complete.ant-select .ant-select-search--inline {\n  position: static;\n  float: left;\n}\n.ant-select-auto-complete.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {\n  margin-right: 0 !important;\n}\n.ant-select-auto-complete.ant-select .ant-input {\n  height: 36px;\n  line-height: 1.3;\n  background: transparent;\n  border-width: 1px;\n}\n.ant-select-auto-complete.ant-select .ant-input:focus,\n.ant-select-auto-complete.ant-select .ant-input:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-select-auto-complete.ant-select .ant-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n  background-color: transparent;\n}\n.ant-select-auto-complete.ant-select .ant-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-select-auto-complete.ant-select-lg .ant-select-selection__rendered {\n  line-height: 40px;\n}\n.ant-select-auto-complete.ant-select-lg .ant-input {\n  height: 40px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n.ant-select-auto-complete.ant-select-sm .ant-select-selection__rendered {\n  line-height: 24px;\n}\n.ant-select-auto-complete.ant-select-sm .ant-input {\n  height: 24px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.ant-input-group > .ant-select-auto-complete .ant-select-search__field.ant-input-affix-wrapper {\n  display: inline;\n  float: none;\n}\n.ant-avatar {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  color: #fff;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  background: #ccc;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 50%;\n}\n.ant-avatar-image {\n  background: transparent;\n}\n.ant-avatar-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar.ant-avatar-icon {\n  font-size: 18px;\n}\n.ant-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50%;\n}\n.ant-avatar-lg-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar-lg.ant-avatar-icon {\n  font-size: 24px;\n}\n.ant-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n}\n.ant-avatar-sm-string {\n  position: absolute;\n  left: 50%;\n  transform-origin: 0 center;\n}\n.ant-avatar-sm.ant-avatar-icon {\n  font-size: 14px;\n}\n.ant-avatar-square {\n  border-radius: 6px;\n}\n.ant-avatar > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.ant-back-top {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  right: 100px;\n  bottom: 50px;\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n.ant-back-top-content {\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  background-color: #595959;\n  border-radius: 20px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-back-top-content:hover {\n  background-color: #545454;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-back-top-icon {\n  width: 14px;\n  height: 16px;\n  margin: 12px auto;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAABGdBTUEAALGPC/xhBQAAAbtJREFUWAntmMtKw0AUhhMvS5cuxILgQlRUpIggIoKIIoigG1eC+AA+jo+i6FIXBfeuXIgoeKVeitVWJX5HWhhDksnUpp3FDPyZk3Nm5nycmZKkXhAEOXSA3lG7muTeRzmfy6HneUvIhnYkQK+Q9NhAA0Opg0vBEhjBKHiyb8iGMyQMOYuK41BcBSypAL+MYXSKjtFAW7EAGEO3qN4uMQbbAkXiSfRQJ1H6a+yhlkKRcAoVFYiweYNjtCVQJJpBz2GCiPt7fBOZQpFgDpUikse5HgnkM4Fi4QX0Fpc5wf9EbLqpUCy4jMoJSXWhFwbMNgWKhVbRhy5jirhs9fy/oFhgHVVTJEs7RLZ8sSEoJm6iz7SZDMbJ+/OKERQTttCXQRLToRUmrKWCYuA2+jbN0MB4OQobYShfdTCgn/sL1K36M7TLrN3n+758aPy2rrpR6+/od5E8tf/A1uLS9aId5T7J3CNYihkQ4D9PiMdMC7mp4rjB9kjFjZp8BlnVHJBuO1yFXIV0FdDF3RlyFdJVQBdv5AxVdIsq8apiZ2PyYO1EVykesGfZEESsCkweyR8MUW+V8uJ1gkYipmpdP1pm2aJVPEGzAAAAAElFTkSuQmCC) 100%/100% no-repeat;\n}\n@media screen and (max-width: 768px) {\n  .ant-back-top {\n    right: 60px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .ant-back-top {\n    right: 20px;\n  }\n}\n.ant-badge {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  color: unset;\n  line-height: 1;\n}\n.ant-badge-count {\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  color: #fff;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: center;\n  background: #f5222d;\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-multiple-words {\n  padding: 0 8px;\n}\n.ant-badge-dot {\n  width: 6px;\n  height: 6px;\n  background: #f5222d;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count,\n.ant-badge-dot,\n.ant-badge .ant-scroll-number-custom-component {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  transform: translate(50%, -50%);\n  transform-origin: 100% 0%;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  vertical-align: middle;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #52c41a;\n}\n.ant-badge-status-processing {\n  position: relative;\n  background-color: #2EB1EF;\n}\n.ant-badge-status-processing::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #2EB1EF;\n  border-radius: 50%;\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n  content: '';\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #f5222d;\n}\n.ant-badge-status-warning {\n  background-color: #fa8c16;\n}\n.ant-badge-status-pink {\n  background: #eb2f96;\n}\n.ant-badge-status-magenta {\n  background: #eb2f96;\n}\n.ant-badge-status-red {\n  background: #f5222d;\n}\n.ant-badge-status-volcano {\n  background: #fa541c;\n}\n.ant-badge-status-orange {\n  background: #fa8c16;\n}\n.ant-badge-status-yellow {\n  background: #fadb14;\n}\n.ant-badge-status-gold {\n  background: #faad14;\n}\n.ant-badge-status-cyan {\n  background: #13c2c2;\n}\n.ant-badge-status-lime {\n  background: #a0d911;\n}\n.ant-badge-status-green {\n  background: #52c41a;\n}\n.ant-badge-status-blue {\n  background: #1890ff;\n}\n.ant-badge-status-geekblue {\n  background: #2f54eb;\n}\n.ant-badge-status-purple {\n  background: #722ed1;\n}\n.ant-badge-status-text {\n  margin-left: 8px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper:not(.ant-badge-status) {\n  vertical-align: middle;\n}\n.ant-badge-not-a-wrapper .ant-scroll-number {\n  position: relative;\n  top: auto;\n  display: block;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  transform: none;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n}\n.ant-scroll-number-only {\n  display: inline-block;\n  height: 20px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-scroll-number-only > p.ant-scroll-number-only-unit {\n  height: 20px;\n  margin: 0;\n}\n.ant-scroll-number-symbol {\n  vertical-align: top;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translate(50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n}\n.ant-breadcrumb {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  color: #595959;\n  font-size: 14px;\n}\n.ant-breadcrumb .anticon {\n  font-size: 14px;\n}\n.ant-breadcrumb a {\n  color: #595959;\n  transition: color 0.3s;\n}\n.ant-breadcrumb a:hover {\n  color: #58cefc;\n}\n.ant-breadcrumb > span:last-child {\n  color: #545454;\n}\n.ant-breadcrumb > span:last-child a {\n  color: #545454;\n}\n.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {\n  display: none;\n}\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: #595959;\n}\n.ant-breadcrumb-link > .anticon + span {\n  margin-left: 4px;\n}\n.ant-breadcrumb-overlay-link > .anticon {\n  margin-left: 4px;\n}\n.ant-btn {\n  line-height: 1.299;\n  position: relative;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: solid 1px #d9d9d9;\n  padding: 0 15px;\n  height: 36px;\n  font-size: 14px;\n  line-height: 34px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  color: #545454;\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-btn > .anticon {\n  line-height: 1;\n}\n.ant-btn,\n.ant-btn:active,\n.ant-btn:focus {\n  outline: 0;\n}\n.ant-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-btn:not([disabled]):active {\n  outline: 0;\n  box-shadow: none;\n}\n.ant-btn.disabled,\n.ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-btn.disabled > *,\n.ant-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-btn-lg {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-sm {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n}\n.ant-btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-btn {\n    margin-bottom: 10px;\n  }\n}\n.ant-btn:focus,\n.ant-btn:hover {\n  text-decoration: none;\n}\n.ant-btn:focus,\n.ant-btn.focus {\n  outline: 0;\n}\n.ant-btn.disabled,\n.ant-btn:disabled {\n  opacity: 0.65;\n}\n.ant-btn:not([disabled]):not(.disabled) {\n  cursor: pointer;\n}\n.gx-btn-list .ant-btn {\n  margin-bottom: 6px;\n}\n.gx-sub-popover .ant-btn {\n  border: 0 none;\n  margin-bottom: 5px;\n}\n.gx-sub-popover .ant-btn:focus,\n.gx-sub-popover .ant-btn:hover {\n  background-color: #f5f5f5;\n}\n.gx-sub-popover .ant-btn:not(:last-child) {\n  margin-right: 5px;\n}\n.gx-login-content .ant-btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.ant-btn > a:only-child {\n  color: currentColor;\n}\n.ant-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: #58cefc;\n  background-color: #fff;\n  border-color: #58cefc;\n}\n.ant-btn:hover > a:only-child,\n.ant-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn:hover > a:only-child::after,\n.ant-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:active,\n.ant-btn.active {\n  color: #1c8dc9;\n  background-color: #fff;\n  border-color: #1c8dc9;\n}\n.ant-btn:active > a:only-child,\n.ant-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn:active > a:only-child::after,\n.ant-btn.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-disabled,\n.ant-btn.disabled,\n.ant-btn[disabled],\n.ant-btn-disabled:hover,\n.ant-btn.disabled:hover,\n.ant-btn[disabled]:hover,\n.ant-btn-disabled:focus,\n.ant-btn.disabled:focus,\n.ant-btn[disabled]:focus,\n.ant-btn-disabled:active,\n.ant-btn.disabled:active,\n.ant-btn[disabled]:active,\n.ant-btn-disabled.active,\n.ant-btn.disabled.active,\n.ant-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-disabled > a:only-child,\n.ant-btn.disabled > a:only-child,\n.ant-btn[disabled] > a:only-child,\n.ant-btn-disabled:hover > a:only-child,\n.ant-btn.disabled:hover > a:only-child,\n.ant-btn[disabled]:hover > a:only-child,\n.ant-btn-disabled:focus > a:only-child,\n.ant-btn.disabled:focus > a:only-child,\n.ant-btn[disabled]:focus > a:only-child,\n.ant-btn-disabled:active > a:only-child,\n.ant-btn.disabled:active > a:only-child,\n.ant-btn[disabled]:active > a:only-child,\n.ant-btn-disabled.active > a:only-child,\n.ant-btn.disabled.active > a:only-child,\n.ant-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-disabled > a:only-child::after,\n.ant-btn.disabled > a:only-child::after,\n.ant-btn[disabled] > a:only-child::after,\n.ant-btn-disabled:hover > a:only-child::after,\n.ant-btn.disabled:hover > a:only-child::after,\n.ant-btn[disabled]:hover > a:only-child::after,\n.ant-btn-disabled:focus > a:only-child::after,\n.ant-btn.disabled:focus > a:only-child::after,\n.ant-btn[disabled]:focus > a:only-child::after,\n.ant-btn-disabled:active > a:only-child::after,\n.ant-btn.disabled:active > a:only-child::after,\n.ant-btn[disabled]:active > a:only-child::after,\n.ant-btn-disabled.active > a:only-child::after,\n.ant-btn.disabled.active > a:only-child::after,\n.ant-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus,\n.ant-btn:active,\n.ant-btn.active {\n  text-decoration: none;\n  background: #fff;\n}\n.ant-btn > i,\n.ant-btn > span {\n  display: inline-block;\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  pointer-events: none;\n}\n.ant-btn-primary {\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n  color: #ffffff;\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #fff;\n  background-color: #58cefc;\n  border-color: #58cefc;\n}\n.ant-btn-primary:hover > a:only-child,\n.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:active,\n.ant-btn-primary.active {\n  color: #fff;\n  background-color: #1c8dc9;\n  border-color: #1c8dc9;\n}\n.ant-btn-primary:active > a:only-child,\n.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:active > a:only-child::after,\n.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary-disabled,\n.ant-btn-primary.disabled,\n.ant-btn-primary[disabled],\n.ant-btn-primary-disabled:hover,\n.ant-btn-primary.disabled:hover,\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary-disabled:focus,\n.ant-btn-primary.disabled:focus,\n.ant-btn-primary[disabled]:focus,\n.ant-btn-primary-disabled:active,\n.ant-btn-primary.disabled:active,\n.ant-btn-primary[disabled]:active,\n.ant-btn-primary-disabled.active,\n.ant-btn-primary.disabled.active,\n.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-primary-disabled > a:only-child,\n.ant-btn-primary.disabled > a:only-child,\n.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.ant-btn-primary.disabled,\n.ant-btn-primary:disabled {\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.ant-btn-primary:not([disabled]):not(.disabled):active,\n.ant-btn-primary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {\n  border-right-color: #58cefc;\n  border-left-color: #58cefc;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {\n  border-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {\n  border-right-color: #58cefc;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {\n  border-right-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-left-color: #58cefc;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-left-color: #d9d9d9;\n}\n.ant-btn-ghost {\n  color: #545454;\n  background-color: transparent;\n  border-color: #d9d9d9;\n}\n.ant-btn-ghost > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:hover,\n.ant-btn-ghost:focus {\n  color: #58cefc;\n  background-color: transparent;\n  border-color: #58cefc;\n}\n.ant-btn-ghost:hover > a:only-child,\n.ant-btn-ghost:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:hover > a:only-child::after,\n.ant-btn-ghost:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:active,\n.ant-btn-ghost.active {\n  color: #1c8dc9;\n  background-color: transparent;\n  border-color: #1c8dc9;\n}\n.ant-btn-ghost:active > a:only-child,\n.ant-btn-ghost.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:active > a:only-child::after,\n.ant-btn-ghost.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost-disabled,\n.ant-btn-ghost.disabled,\n.ant-btn-ghost[disabled],\n.ant-btn-ghost-disabled:hover,\n.ant-btn-ghost.disabled:hover,\n.ant-btn-ghost[disabled]:hover,\n.ant-btn-ghost-disabled:focus,\n.ant-btn-ghost.disabled:focus,\n.ant-btn-ghost[disabled]:focus,\n.ant-btn-ghost-disabled:active,\n.ant-btn-ghost.disabled:active,\n.ant-btn-ghost[disabled]:active,\n.ant-btn-ghost-disabled.active,\n.ant-btn-ghost.disabled.active,\n.ant-btn-ghost[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-ghost-disabled > a:only-child,\n.ant-btn-ghost.disabled > a:only-child,\n.ant-btn-ghost[disabled] > a:only-child,\n.ant-btn-ghost-disabled:hover > a:only-child,\n.ant-btn-ghost.disabled:hover > a:only-child,\n.ant-btn-ghost[disabled]:hover > a:only-child,\n.ant-btn-ghost-disabled:focus > a:only-child,\n.ant-btn-ghost.disabled:focus > a:only-child,\n.ant-btn-ghost[disabled]:focus > a:only-child,\n.ant-btn-ghost-disabled:active > a:only-child,\n.ant-btn-ghost.disabled:active > a:only-child,\n.ant-btn-ghost[disabled]:active > a:only-child,\n.ant-btn-ghost-disabled.active > a:only-child,\n.ant-btn-ghost.disabled.active > a:only-child,\n.ant-btn-ghost[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost-disabled > a:only-child::after,\n.ant-btn-ghost.disabled > a:only-child::after,\n.ant-btn-ghost[disabled] > a:only-child::after,\n.ant-btn-ghost-disabled:hover > a:only-child::after,\n.ant-btn-ghost.disabled:hover > a:only-child::after,\n.ant-btn-ghost[disabled]:hover > a:only-child::after,\n.ant-btn-ghost-disabled:focus > a:only-child::after,\n.ant-btn-ghost.disabled:focus > a:only-child::after,\n.ant-btn-ghost[disabled]:focus > a:only-child::after,\n.ant-btn-ghost-disabled:active > a:only-child::after,\n.ant-btn-ghost.disabled:active > a:only-child::after,\n.ant-btn-ghost[disabled]:active > a:only-child::after,\n.ant-btn-ghost-disabled.active > a:only-child::after,\n.ant-btn-ghost.disabled.active > a:only-child::after,\n.ant-btn-ghost[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed {\n  color: #545454;\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: dashed;\n}\n.ant-btn-dashed > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:hover,\n.ant-btn-dashed:focus {\n  color: #58cefc;\n  background-color: #fff;\n  border-color: #58cefc;\n}\n.ant-btn-dashed:hover > a:only-child,\n.ant-btn-dashed:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:hover > a:only-child::after,\n.ant-btn-dashed:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:active,\n.ant-btn-dashed.active {\n  color: #1c8dc9;\n  background-color: #fff;\n  border-color: #1c8dc9;\n}\n.ant-btn-dashed:active > a:only-child,\n.ant-btn-dashed.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:active > a:only-child::after,\n.ant-btn-dashed.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed-disabled,\n.ant-btn-dashed.disabled,\n.ant-btn-dashed[disabled],\n.ant-btn-dashed-disabled:hover,\n.ant-btn-dashed.disabled:hover,\n.ant-btn-dashed[disabled]:hover,\n.ant-btn-dashed-disabled:focus,\n.ant-btn-dashed.disabled:focus,\n.ant-btn-dashed[disabled]:focus,\n.ant-btn-dashed-disabled:active,\n.ant-btn-dashed.disabled:active,\n.ant-btn-dashed[disabled]:active,\n.ant-btn-dashed-disabled.active,\n.ant-btn-dashed.disabled.active,\n.ant-btn-dashed[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-dashed-disabled > a:only-child,\n.ant-btn-dashed.disabled > a:only-child,\n.ant-btn-dashed[disabled] > a:only-child,\n.ant-btn-dashed-disabled:hover > a:only-child,\n.ant-btn-dashed.disabled:hover > a:only-child,\n.ant-btn-dashed[disabled]:hover > a:only-child,\n.ant-btn-dashed-disabled:focus > a:only-child,\n.ant-btn-dashed.disabled:focus > a:only-child,\n.ant-btn-dashed[disabled]:focus > a:only-child,\n.ant-btn-dashed-disabled:active > a:only-child,\n.ant-btn-dashed.disabled:active > a:only-child,\n.ant-btn-dashed[disabled]:active > a:only-child,\n.ant-btn-dashed-disabled.active > a:only-child,\n.ant-btn-dashed.disabled.active > a:only-child,\n.ant-btn-dashed[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed-disabled > a:only-child::after,\n.ant-btn-dashed.disabled > a:only-child::after,\n.ant-btn-dashed[disabled] > a:only-child::after,\n.ant-btn-dashed-disabled:hover > a:only-child::after,\n.ant-btn-dashed.disabled:hover > a:only-child::after,\n.ant-btn-dashed[disabled]:hover > a:only-child::after,\n.ant-btn-dashed-disabled:focus > a:only-child::after,\n.ant-btn-dashed.disabled:focus > a:only-child::after,\n.ant-btn-dashed[disabled]:focus > a:only-child::after,\n.ant-btn-dashed-disabled:active > a:only-child::after,\n.ant-btn-dashed.disabled:active > a:only-child::after,\n.ant-btn-dashed[disabled]:active > a:only-child::after,\n.ant-btn-dashed-disabled.active > a:only-child::after,\n.ant-btn-dashed.disabled.active > a:only-child::after,\n.ant-btn-dashed[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger {\n  color: #fff;\n  background-color: #ff4d4f;\n  border-color: #ff4d4f;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff;\n  background-color: #ff7875;\n  border-color: #ff7875;\n}\n.ant-btn-danger:hover > a:only-child,\n.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:active,\n.ant-btn-danger.active {\n  color: #fff;\n  background-color: #d9363e;\n  border-color: #d9363e;\n}\n.ant-btn-danger:active > a:only-child,\n.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:active > a:only-child::after,\n.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger-disabled,\n.ant-btn-danger.disabled,\n.ant-btn-danger[disabled],\n.ant-btn-danger-disabled:hover,\n.ant-btn-danger.disabled:hover,\n.ant-btn-danger[disabled]:hover,\n.ant-btn-danger-disabled:focus,\n.ant-btn-danger.disabled:focus,\n.ant-btn-danger[disabled]:focus,\n.ant-btn-danger-disabled:active,\n.ant-btn-danger.disabled:active,\n.ant-btn-danger[disabled]:active,\n.ant-btn-danger-disabled.active,\n.ant-btn-danger.disabled.active,\n.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-danger-disabled > a:only-child,\n.ant-btn-danger.disabled > a:only-child,\n.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link {\n  color: #2EB1EF;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus {\n  color: #58cefc;\n  background-color: transparent;\n  border-color: #58cefc;\n}\n.ant-btn-link:hover > a:only-child,\n.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:hover > a:only-child::after,\n.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:active,\n.ant-btn-link.active {\n  color: #1c8dc9;\n  background-color: transparent;\n  border-color: #1c8dc9;\n}\n.ant-btn-link:active > a:only-child,\n.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:active > a:only-child::after,\n.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus,\n.ant-btn-link:active {\n  border-color: transparent;\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-icon-only {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-lg {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  font-size: 18px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only.ant-btn-sm {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-btn-icon-only > i {\n  vertical-align: middle;\n}\n.ant-btn-round {\n  height: 36px;\n  padding: 0 18px;\n  font-size: 14px;\n  border-radius: 36px;\n}\n.ant-btn-round.ant-btn-lg {\n  height: 40px;\n  padding: 0 20px;\n  font-size: 16px;\n  border-radius: 40px;\n}\n.ant-btn-round.ant-btn-sm {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 14px;\n  border-radius: 24px;\n}\n.ant-btn-round.ant-btn-icon-only {\n  width: auto;\n}\n.ant-btn-circle,\n.ant-btn-circle-outline {\n  min-width: 36px;\n  padding-right: 0;\n  padding-left: 0;\n  text-align: center;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-lg,\n.ant-btn-circle-outline.ant-btn-lg {\n  min-width: 40px;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-sm,\n.ant-btn-circle-outline.ant-btn-sm {\n  min-width: 24px;\n  border-radius: 50%;\n}\n.ant-btn::before {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  z-index: 1;\n  display: none;\n  background: #fff;\n  border-radius: inherit;\n  opacity: 0.35;\n  transition: opacity 0.2s;\n  content: '';\n  pointer-events: none;\n}\n.ant-btn .anticon {\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn .anticon.anticon-plus > svg,\n.ant-btn .anticon.anticon-minus > svg {\n  shape-rendering: optimizeSpeed;\n}\n.ant-btn.ant-btn-loading {\n  position: relative;\n}\n.ant-btn.ant-btn-loading:not([disabled]) {\n  pointer-events: none;\n}\n.ant-btn.ant-btn-loading::before {\n  display: block;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 29px;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon:not(:last-child) {\n  margin-left: -14px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 24px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon {\n  margin-left: -17px;\n}\n.ant-btn-group {\n  position: relative;\n  display: inline-block;\n}\n.ant-btn-group > .ant-btn,\n.ant-btn-group > span > .ant-btn {\n  position: relative;\n}\n.ant-btn-group > .ant-btn:hover,\n.ant-btn-group > span > .ant-btn:hover,\n.ant-btn-group > .ant-btn:focus,\n.ant-btn-group > span > .ant-btn:focus,\n.ant-btn-group > .ant-btn:active,\n.ant-btn-group > span > .ant-btn:active,\n.ant-btn-group > .ant-btn.active,\n.ant-btn-group > span > .ant-btn.active {\n  z-index: 2;\n}\n.ant-btn-group > .ant-btn:disabled,\n.ant-btn-group > span > .ant-btn:disabled {\n  z-index: 0;\n}\n.ant-btn-group > .ant-btn-icon-only {\n  font-size: 14px;\n}\n.ant-btn-group-lg > .ant-btn,\n.ant-btn-group-lg > span > .ant-btn {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 0;\n  line-height: 38px;\n}\n.ant-btn-group-lg > .ant-btn.ant-btn-icon-only {\n  width: 40px;\n  height: 40px;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-btn-group-sm > .ant-btn,\n.ant-btn-group-sm > span > .ant-btn {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 0;\n  line-height: 22px;\n}\n.ant-btn-group-sm > .ant-btn > .anticon,\n.ant-btn-group-sm > span > .ant-btn > .anticon {\n  font-size: 14px;\n}\n.ant-btn-group-sm > .ant-btn.ant-btn-icon-only {\n  width: 24px;\n  height: 24px;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn + .ant-btn-group,\n.ant-btn-group span + .ant-btn,\n.ant-btn-group .ant-btn + span,\n.ant-btn-group > span + span,\n.ant-btn-group + .ant-btn,\n.ant-btn-group + .ant-btn-group {\n  margin-left: -1px;\n}\n.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {\n  border-left-color: transparent;\n}\n.ant-btn-group .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn:first-child,\n.ant-btn-group > span:first-child > .ant-btn {\n  margin-left: 0;\n}\n.ant-btn-group > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group > .ant-btn:first-child:not(:last-child),\n.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group > .ant-btn:last-child:not(:first-child),\n.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group > .ant-btn-group {\n  float: left;\n}\n.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {\n  padding-right: 8px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {\n  padding-left: 8px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn:focus > span,\n.ant-btn:active > span {\n  position: relative;\n}\n.ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-left: 8px;\n}\n.ant-btn-background-ghost {\n  color: #fff;\n  background: transparent !important;\n  border-color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  color: #2EB1EF;\n  background-color: transparent;\n  border-color: #2EB1EF;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  color: #58cefc;\n  background-color: transparent;\n  border-color: #58cefc;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:active,\n.ant-btn-background-ghost.ant-btn-primary.active {\n  color: #1c8dc9;\n  background-color: transparent;\n  border-color: #1c8dc9;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled,\n.ant-btn-background-ghost.ant-btn-primary.disabled,\n.ant-btn-background-ghost.ant-btn-primary[disabled],\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger {\n  color: #ff4d4f;\n  background-color: transparent;\n  border-color: #ff4d4f;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:hover,\n.ant-btn-background-ghost.ant-btn-danger:focus {\n  color: #ff7875;\n  background-color: transparent;\n  border-color: #ff7875;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:active,\n.ant-btn-background-ghost.ant-btn-danger.active {\n  color: #d9363e;\n  background-color: transparent;\n  border-color: #d9363e;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled,\n.ant-btn-background-ghost.ant-btn-danger.disabled,\n.ant-btn-background-ghost.ant-btn-danger[disabled],\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link {\n  color: #2EB1EF;\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:hover,\n.ant-btn-background-ghost.ant-btn-link:focus {\n  color: #58cefc;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:active,\n.ant-btn-background-ghost.ant-btn-link.active {\n  color: #1c8dc9;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link-disabled,\n.ant-btn-background-ghost.ant-btn-link.disabled,\n.ant-btn-background-ghost.ant-btn-link[disabled],\n.ant-btn-background-ghost.ant-btn-link-disabled:hover,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-link-disabled:active,\n.ant-btn-background-ghost.ant-btn-link.disabled:active,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active,\n.ant-btn-background-ghost.ant-btn-link-disabled.active,\n.ant-btn-background-ghost.ant-btn-link.disabled.active,\n.ant-btn-background-ghost.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-two-chinese-chars::first-letter {\n  letter-spacing: 0.34em;\n}\n.ant-btn-two-chinese-chars > *:not(.anticon) {\n  margin-right: -0.34em;\n  letter-spacing: 0.34em;\n}\n.ant-btn-block {\n  width: 100%;\n}\n.ant-btn:empty {\n  vertical-align: top;\n}\na.ant-btn {\n  padding-top: 0.1px;\n  line-height: 34px;\n}\na.ant-btn-lg {\n  line-height: 38px;\n}\na.ant-btn-sm {\n  line-height: 22px;\n}\n.ant-fullcalendar {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  border-top: 1px solid #d9d9d9;\n  outline: none;\n}\n.ant-select.ant-fullcalendar-year-select {\n  min-width: 90px;\n}\n.ant-select.ant-fullcalendar-year-select.ant-select-sm {\n  min-width: 70px;\n}\n.ant-select.ant-fullcalendar-month-select {\n  min-width: 80px;\n  margin-left: 8px;\n}\n.ant-select.ant-fullcalendar-month-select.ant-select-sm {\n  min-width: 70px;\n}\n.ant-fullcalendar-header {\n  padding: 11px 16px 11px 0;\n  text-align: right;\n}\n.ant-fullcalendar-header .ant-select-dropdown {\n  text-align: left;\n}\n.ant-fullcalendar-header .ant-radio-group {\n  margin-left: 8px;\n  text-align: left;\n}\n.ant-fullcalendar-header label.ant-radio-button {\n  height: 22px;\n  padding: 0 10px;\n  line-height: 20px;\n}\n.ant-fullcalendar-date-panel {\n  position: relative;\n  outline: none;\n}\n.ant-fullcalendar-calendar-body {\n  padding: 8px 12px;\n}\n.ant-fullcalendar table {\n  width: 100%;\n  max-width: 100%;\n  height: 256px;\n  background-color: transparent;\n  border-collapse: collapse;\n}\n.ant-fullcalendar table,\n.ant-fullcalendar th,\n.ant-fullcalendar td {\n  border: 0;\n}\n.ant-fullcalendar td {\n  position: relative;\n}\n.ant-fullcalendar-calendar-table {\n  margin-bottom: 0;\n  border-spacing: 0;\n}\n.ant-fullcalendar-column-header {\n  width: 33px;\n  padding: 0;\n  line-height: 18px;\n  text-align: center;\n}\n.ant-fullcalendar-column-header .ant-fullcalendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-fullcalendar-week-number-header .ant-fullcalendar-column-header-inner {\n  display: none;\n}\n.ant-fullcalendar-month,\n.ant-fullcalendar-date {\n  text-align: center;\n  transition: all 0.3s;\n}\n.ant-fullcalendar-value {\n  display: block;\n  width: 24px;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0;\n  color: #545454;\n  line-height: 24px;\n  background: transparent;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n.ant-fullcalendar-value:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-fullcalendar-value:active {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-fullcalendar-month-panel-cell .ant-fullcalendar-value {\n  width: 48px;\n}\n.ant-fullcalendar-today .ant-fullcalendar-value,\n.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {\n  box-shadow: 0 0 0 1px #2EB1EF inset;\n}\n.ant-fullcalendar-selected-day .ant-fullcalendar-value,\n.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-fullcalendar-disabled-cell-first-of-row .ant-fullcalendar-value {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-fullcalendar-disabled-cell-last-of-row .ant-fullcalendar-value {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.ant-fullcalendar-last-month-cell .ant-fullcalendar-value,\n.ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-fullcalendar-month-panel-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-fullcalendar-content {\n  position: absolute;\n  bottom: -9px;\n  left: 0;\n  width: 100%;\n}\n.ant-fullcalendar-fullscreen {\n  border-top: 0;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-table {\n  table-layout: fixed;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-header .ant-radio-group {\n  margin-left: 16px;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-header label.ant-radio-button {\n  height: 36px;\n  line-height: 34px;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date {\n  display: block;\n  height: 116px;\n  margin: 0 4px;\n  padding: 4px 8px;\n  color: #545454;\n  text-align: left;\n  border-top: 2px solid #e8e8e8;\n  transition: background 0.3s;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month:active,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date:active {\n  background: #d4f7ff;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-column-header {\n  padding-right: 12px;\n  padding-bottom: 5px;\n  text-align: right;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-value {\n  width: auto;\n  text-align: right;\n  background: transparent;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {\n  color: #545454;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {\n  background: transparent;\n  border-top-color: #2EB1EF;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {\n  box-shadow: none;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {\n  background: #f0fdff;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {\n  color: #2EB1EF;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-content {\n  position: static;\n  width: auto;\n  height: 88px;\n  overflow-y: auto;\n}\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-date,\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-date:hover {\n  cursor: not-allowed;\n}\n.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date,\n.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date:hover {\n  background: transparent;\n}\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-value {\n  width: auto;\n  color: rgba(0, 0, 0, 0.25);\n  border-radius: 0;\n  cursor: not-allowed;\n}\n.ant-card {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  background: #fff;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n.ant-card-hoverable {\n  cursor: pointer;\n}\n.ant-card-hoverable:hover {\n  border-color: rgba(0, 0, 0, 0.09);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n}\n.ant-card-bordered {\n  border: 1px solid #e8e8e8;\n}\n.ant-card-head {\n  min-height: 48px;\n  margin-bottom: -1px;\n  padding: 0 24px;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 4px 4px 0 0;\n  zoom: 1;\n}\n.ant-card-head::before,\n.ant-card-head::after {\n  display: table;\n  content: '';\n}\n.ant-card-head::after {\n  clear: both;\n}\n.ant-card-head::before,\n.ant-card-head::after {\n  display: table;\n  content: '';\n}\n.ant-card-head::after {\n  clear: both;\n}\n.ant-card-head-wrapper {\n  display: flex;\n  align-items: center;\n}\n.ant-card-head-title {\n  display: inline-block;\n  flex: 1;\n  padding: 16px 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-card-head .ant-tabs {\n  clear: both;\n  margin-bottom: -17px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-card-head .ant-tabs-bar {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-card-extra {\n  float: right;\n  margin-left: auto;\n  padding: 16px 0;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-card-body {\n  padding: 24px;\n  zoom: 1;\n}\n.ant-card-body::before,\n.ant-card-body::after {\n  display: table;\n  content: '';\n}\n.ant-card-body::after {\n  clear: both;\n}\n.ant-card-body::before,\n.ant-card-body::after {\n  display: table;\n  content: '';\n}\n.ant-card-body::after {\n  clear: both;\n}\n.ant-card-contain-grid:not(.ant-card-loading) .ant-card-body {\n  margin: -1px 0 0 -1px;\n  padding: 0;\n}\n.ant-card-grid {\n  float: left;\n  width: 33.33%;\n  padding: 24px;\n  border: 0;\n  border-radius: 0;\n  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset, 0 1px 0 0 #e8e8e8 inset;\n  transition: all 0.3s;\n}\n.ant-card-grid-hoverable:hover {\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-card-contain-tabs > .ant-card-head .ant-card-head-title {\n  min-height: 32px;\n  padding-bottom: 0;\n}\n.ant-card-contain-tabs > .ant-card-head .ant-card-extra {\n  padding-bottom: 0;\n}\n.ant-card-cover > * {\n  display: block;\n  width: 100%;\n}\n.ant-card-cover img {\n  border-radius: 4px 4px 0 0;\n}\n.ant-card-actions {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background: #fafafa;\n  border-top: 1px solid #e8e8e8;\n  zoom: 1;\n}\n.ant-card-actions::before,\n.ant-card-actions::after {\n  display: table;\n  content: '';\n}\n.ant-card-actions::after {\n  clear: both;\n}\n.ant-card-actions::before,\n.ant-card-actions::after {\n  display: table;\n  content: '';\n}\n.ant-card-actions::after {\n  clear: both;\n}\n.ant-card-actions > li {\n  float: left;\n  margin: 12px 0;\n  color: #595959;\n  text-align: center;\n}\n.ant-card-actions > li > span {\n  position: relative;\n  display: block;\n  min-width: 32px;\n  font-size: 14px;\n  line-height: 22px;\n  cursor: pointer;\n}\n.ant-card-actions > li > span:hover {\n  color: #2EB1EF;\n  transition: color 0.3s;\n}\n.ant-card-actions > li > span a:not(.ant-btn),\n.ant-card-actions > li > span > .anticon {\n  display: inline-block;\n  width: 100%;\n  color: #595959;\n  line-height: 22px;\n  transition: color 0.3s;\n}\n.ant-card-actions > li > span a:not(.ant-btn):hover,\n.ant-card-actions > li > span > .anticon:hover {\n  color: #2EB1EF;\n}\n.ant-card-actions > li > span > .anticon {\n  font-size: 16px;\n  line-height: 22px;\n}\n.ant-card-actions > li:not(:last-child) {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-card-type-inner .ant-card-head {\n  padding: 0 24px;\n  background: #fafafa;\n}\n.ant-card-type-inner .ant-card-head-title {\n  padding: 12px 0;\n  font-size: 14px;\n}\n.ant-card-type-inner .ant-card-body {\n  padding: 16px 24px;\n}\n.ant-card-type-inner .ant-card-extra {\n  padding: 13.5px 0;\n}\n.ant-card-meta {\n  margin: -4px 0;\n  zoom: 1;\n}\n.ant-card-meta::before,\n.ant-card-meta::after {\n  display: table;\n  content: '';\n}\n.ant-card-meta::after {\n  clear: both;\n}\n.ant-card-meta::before,\n.ant-card-meta::after {\n  display: table;\n  content: '';\n}\n.ant-card-meta::after {\n  clear: both;\n}\n.ant-card-meta-avatar {\n  float: left;\n  padding-right: 16px;\n}\n.ant-card-meta-detail {\n  overflow: hidden;\n}\n.ant-card-meta-detail > div:not(:last-child) {\n  margin-bottom: 8px;\n}\n.ant-card-meta-title {\n  overflow: hidden;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-card-meta-description {\n  color: #595959;\n}\n.ant-card-loading {\n  overflow: hidden;\n}\n.ant-card-loading .ant-card-body {\n  user-select: none;\n}\n.ant-card-loading-content p {\n  margin: 0;\n}\n.ant-card-loading-block {\n  height: 14px;\n  margin: 4px 0;\n  background: linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2));\n  background-size: 600% 600%;\n  border-radius: 4px;\n  animation: card-loading 1.4s ease infinite;\n}\n@keyframes card-loading {\n  0%,\n  100% {\n    background-position: 0 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n.ant-card-small > .ant-card-head {\n  min-height: 36px;\n  padding: 0 12px;\n  font-size: 14px;\n}\n.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-head-title {\n  padding: 8px 0;\n}\n.ant-card-small > .ant-card-head > .ant-card-head-wrapper > .ant-card-extra {\n  padding: 8px 0;\n  font-size: 14px;\n}\n.ant-card-small > .ant-card-body {\n  padding: 12px;\n}\n.ant-carousel {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-carousel .slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.ant-carousel .slick-list {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.ant-carousel .slick-list:focus {\n  outline: none;\n}\n.ant-carousel .slick-list.dragging {\n  cursor: pointer;\n}\n.ant-carousel .slick-list .slick-slide {\n  pointer-events: none;\n}\n.ant-carousel .slick-list .slick-slide input.ant-radio-input,\n.ant-carousel .slick-list .slick-slide input.ant-checkbox-input {\n  visibility: hidden;\n}\n.ant-carousel .slick-list .slick-slide.slick-active {\n  pointer-events: auto;\n}\n.ant-carousel .slick-list .slick-slide.slick-active input.ant-radio-input,\n.ant-carousel .slick-list .slick-slide.slick-active input.ant-checkbox-input {\n  visibility: visible;\n}\n.ant-carousel .slick-slider .slick-track,\n.ant-carousel .slick-slider .slick-list {\n  transform: translate3d(0, 0, 0);\n}\n.ant-carousel .slick-track {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n}\n.ant-carousel .slick-track::before,\n.ant-carousel .slick-track::after {\n  display: table;\n  content: '';\n}\n.ant-carousel .slick-track::after {\n  clear: both;\n}\n.slick-loading .ant-carousel .slick-track {\n  visibility: hidden;\n}\n.ant-carousel .slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir='rtl'] .ant-carousel .slick-slide {\n  float: right;\n}\n.ant-carousel .slick-slide img {\n  display: block;\n}\n.ant-carousel .slick-slide.slick-loading img {\n  display: none;\n}\n.ant-carousel .slick-slide.dragging img {\n  pointer-events: none;\n}\n.ant-carousel .slick-initialized .slick-slide {\n  display: block;\n}\n.ant-carousel .slick-loading .slick-slide {\n  visibility: hidden;\n}\n.ant-carousel .slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n.ant-carousel .slick-arrow.slick-hidden {\n  display: none;\n}\n.ant-carousel .slick-prev,\n.ant-carousel .slick-next {\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  line-height: 0;\n  background: transparent;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n}\n.ant-carousel .slick-prev:hover,\n.ant-carousel .slick-next:hover,\n.ant-carousel .slick-prev:focus,\n.ant-carousel .slick-next:focus {\n  color: transparent;\n  background: transparent;\n  outline: none;\n}\n.ant-carousel .slick-prev:hover::before,\n.ant-carousel .slick-next:hover::before,\n.ant-carousel .slick-prev:focus::before,\n.ant-carousel .slick-next:focus::before {\n  opacity: 1;\n}\n.ant-carousel .slick-prev.slick-disabled::before,\n.ant-carousel .slick-next.slick-disabled::before {\n  opacity: 0.25;\n}\n.ant-carousel .slick-prev {\n  left: -25px;\n}\n.ant-carousel .slick-prev::before {\n  content: '←';\n}\n.ant-carousel .slick-next {\n  right: -25px;\n}\n.ant-carousel .slick-next::before {\n  content: '→';\n}\n.ant-carousel .slick-dots {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 3px;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  list-style: none;\n}\n.ant-carousel .slick-dots-bottom {\n  bottom: 12px;\n}\n.ant-carousel .slick-dots-top {\n  top: 12px;\n}\n.ant-carousel .slick-dots li {\n  position: relative;\n  display: inline-block;\n  margin: 0 2px;\n  padding: 0;\n  text-align: center;\n  vertical-align: top;\n}\n.ant-carousel .slick-dots li button {\n  display: block;\n  width: 16px;\n  height: 3px;\n  padding: 0;\n  color: transparent;\n  font-size: 0;\n  background: #fff;\n  border: 0;\n  border-radius: 1px;\n  outline: none;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: all 0.5s;\n}\n.ant-carousel .slick-dots li button:hover,\n.ant-carousel .slick-dots li button:focus {\n  opacity: 0.75;\n}\n.ant-carousel .slick-dots li.slick-active button {\n  width: 24px;\n  background: #fff;\n  opacity: 1;\n}\n.ant-carousel .slick-dots li.slick-active button:hover,\n.ant-carousel .slick-dots li.slick-active button:focus {\n  opacity: 1;\n}\n.ant-carousel-vertical .slick-dots {\n  top: 50%;\n  bottom: auto;\n  width: 3px;\n  height: auto;\n  transform: translateY(-50%);\n}\n.ant-carousel-vertical .slick-dots-left {\n  left: 12px;\n}\n.ant-carousel-vertical .slick-dots-right {\n  right: 12px;\n}\n.ant-carousel-vertical .slick-dots li {\n  margin: 0 2px;\n  vertical-align: baseline;\n}\n.ant-carousel-vertical .slick-dots li button {\n  width: 3px;\n  height: 16px;\n}\n.ant-carousel-vertical .slick-dots li.slick-active button {\n  width: 3px;\n  height: 24px;\n}\n.ant-cascader {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-cascader-input.ant-input {\n  position: static;\n  width: 100%;\n  padding-right: 24px;\n  background-color: transparent !important;\n  cursor: pointer;\n}\n.ant-cascader-picker-show-search .ant-cascader-input.ant-input {\n  position: relative;\n}\n.ant-cascader-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-cascader-picker-with-value .ant-cascader-picker-label {\n  color: transparent;\n}\n.ant-cascader-picker-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-cascader-picker-disabled .ant-cascader-input {\n  cursor: not-allowed;\n}\n.ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-cascader-picker-show-search.ant-cascader-picker-focused {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-cascader-picker-label {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 20px;\n  margin-top: -10px;\n  padding: 0 20px 0 12px;\n  overflow: hidden;\n  line-height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-cascader-picker-clear {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  z-index: 2;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  line-height: 12px;\n  background: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: color 0.3s ease, opacity 0.15s ease;\n}\n.ant-cascader-picker-clear:hover {\n  color: #595959;\n}\n.ant-cascader-picker:hover .ant-cascader-picker-clear {\n  opacity: 1;\n}\n.ant-cascader-picker-arrow {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  z-index: 1;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  line-height: 12px;\n  transition: transform 0.2s;\n}\n.ant-cascader-picker-arrow.ant-cascader-picker-arrow-expand {\n  transform: rotate(180deg);\n}\n.ant-cascader-picker-label:hover + .ant-cascader-input {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-cascader-picker-small .ant-cascader-picker-clear,\n.ant-cascader-picker-small .ant-cascader-picker-arrow {\n  right: 8px;\n}\n.ant-cascader-menus {\n  position: absolute;\n  z-index: 1050;\n  font-size: 14px;\n  white-space: nowrap;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-cascader-menus ul,\n.ant-cascader-menus ol {\n  margin: 0;\n  list-style: none;\n}\n.ant-cascader-menus-empty,\n.ant-cascader-menus-hidden {\n  display: none;\n}\n.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-bottomLeft,\n.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-topLeft,\n.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-cascader-menu {\n  display: inline-block;\n  min-width: 111px;\n  height: 180px;\n  margin: 0;\n  padding: 4px 0;\n  overflow: auto;\n  vertical-align: top;\n  list-style: none;\n  border-right: 1px solid #e8e8e8;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.ant-cascader-menu:first-child {\n  border-radius: 6px 0 0 6px;\n}\n.ant-cascader-menu:last-child {\n  margin-right: -1px;\n  border-right-color: transparent;\n  border-radius: 0 6px 6px 0;\n}\n.ant-cascader-menu:only-child {\n  border-radius: 6px;\n}\n.ant-cascader-menu-item {\n  padding: 5px 12px;\n  line-height: 22px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-cascader-menu-item:hover {\n  background: #f0fdff;\n}\n.ant-cascader-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-cascader-menu-item-disabled:hover {\n  background: transparent;\n}\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {\n  font-weight: 600;\n  background-color: #fafafa;\n}\n.ant-cascader-menu-item-expand {\n  position: relative;\n  padding-right: 24px;\n}\n.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,\n.ant-cascader-menu-item-loading-icon {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  position: absolute;\n  right: 12px;\n  color: #595959;\n}\n:root .ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,\n:root .ant-cascader-menu-item-loading-icon {\n  font-size: 12px;\n}\n.ant-cascader-menu-item .ant-cascader-menu-item-keyword {\n  color: #f5222d;\n}\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: -0.09em;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: middle;\n  outline: none;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #2EB1EF;\n}\n.ant-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #2EB1EF;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-checkbox:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox::after {\n  visibility: visible;\n}\n.ant-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 22%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-checkbox-checked .ant-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-checkbox-disabled .ant-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-checkbox-disabled .ant-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled:hover::after,\n.ant-checkbox-wrapper:hover .ant-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-wrapper + .ant-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-checkbox-group-item {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-checkbox-group-item + .ant-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #2EB1EF;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-collapse {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-bottom: 0;\n  border-radius: 6px;\n}\n.ant-collapse > .ant-collapse-item {\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-collapse > .ant-collapse-item:last-child,\n.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {\n  border-radius: 0 0 6px 6px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  padding: 12px 16px;\n  padding-left: 40px;\n  color: #535353;\n  line-height: 22px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  left: 16px;\n  display: inline-block;\n  font-size: 12px;\n  transform: translateY(-50%);\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow > * {\n  line-height: 1;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {\n  display: inline-block;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow::before {\n  display: none;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow-icon {\n  display: block;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow svg {\n  transition: transform 0.24s;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {\n  float: right;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header:focus {\n  outline: none;\n}\n.ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {\n  padding-left: 12px;\n}\n.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {\n  padding: 12px 16px;\n  padding-right: 40px;\n}\n.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  right: 16px;\n  left: auto;\n}\n.ant-collapse-anim-active {\n  transition: height 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-collapse-content {\n  overflow: hidden;\n  color: #545454;\n  background-color: #fff;\n  border-top: 1px solid #d9d9d9;\n}\n.ant-collapse-content > .ant-collapse-content-box {\n  padding: 16px;\n}\n.ant-collapse-content-inactive {\n  display: none;\n}\n.ant-collapse-item:last-child > .ant-collapse-content {\n  border-radius: 0 0 6px 6px;\n}\n.ant-collapse-borderless {\n  background-color: #fafafa;\n  border: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item {\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-collapse-borderless > .ant-collapse-item:last-child,\n.ant-collapse-borderless > .ant-collapse-item:last-child .ant-collapse-header {\n  border-radius: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {\n  background-color: transparent;\n  border-top: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {\n  padding-top: 4px;\n}\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-comment {\n  position: relative;\n}\n.ant-comment-inner {\n  display: flex;\n  padding: 16px 0;\n}\n.ant-comment-avatar {\n  position: relative;\n  flex-shrink: 0;\n  margin-right: 12px;\n  cursor: pointer;\n}\n.ant-comment-avatar img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n.ant-comment-content {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 1px;\n  font-size: 14px;\n  word-wrap: break-word;\n}\n.ant-comment-content-author {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n.ant-comment-content-author > a,\n.ant-comment-content-author > span {\n  padding-right: 8px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.ant-comment-content-author-name {\n  color: #595959;\n  font-size: 14px;\n  transition: color 0.3s;\n}\n.ant-comment-content-author-name > * {\n  color: #595959;\n}\n.ant-comment-content-author-name > *:hover {\n  color: #595959;\n}\n.ant-comment-content-author-time {\n  color: #ccc;\n  white-space: nowrap;\n  cursor: auto;\n}\n.ant-comment-content-detail p {\n  white-space: pre-wrap;\n}\n.ant-comment-actions {\n  margin-top: 12px;\n  padding-left: 0;\n}\n.ant-comment-actions > li {\n  display: inline-block;\n  color: #595959;\n}\n.ant-comment-actions > li > span {\n  padding-right: 10px;\n  color: #595959;\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  user-select: none;\n}\n.ant-comment-actions > li > span:hover {\n  color: #595959;\n}\n.ant-comment-nested {\n  margin-left: 44px;\n}\n.ant-calendar-picker-container {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1050;\n  font-family: \"DM Sans\", sans-serif;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-calendar-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  outline: none;\n  cursor: text;\n  transition: opacity 0.3s;\n}\n.ant-calendar-picker-input {\n  outline: none;\n}\n.ant-calendar-picker-input.ant-input {\n  line-height: 1.3;\n}\n.ant-calendar-picker-input.ant-input-sm {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #58cefc;\n}\n.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-calendar-picker-clear,\n.ant-calendar-picker-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -7px;\n  font-size: 12px;\n  line-height: 14px;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-calendar-picker-clear {\n  z-index: 2;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  background: #fff;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-calendar-picker-clear:hover {\n  color: #595959;\n}\n.ant-calendar-picker:hover .ant-calendar-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-calendar-picker-icon {\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  line-height: 1;\n}\n.ant-input-disabled + .ant-calendar-picker-icon {\n  cursor: not-allowed;\n}\n.ant-calendar-picker-small .ant-calendar-picker-clear,\n.ant-calendar-picker-small .ant-calendar-picker-icon {\n  right: 8px;\n}\n.ant-calendar {\n  position: relative;\n  width: 280px;\n  font-size: 14px;\n  line-height: 1.3;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-calendar-input-wrap {\n  height: 34px;\n  padding: 6px 10px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-calendar-input {\n  width: 100%;\n  height: 22px;\n  color: #545454;\n  background: #fff;\n  border: 0;\n  outline: 0;\n  cursor: auto;\n}\n.ant-calendar-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-week-number {\n  width: 286px;\n}\n.ant-calendar-week-number-cell {\n  text-align: center;\n}\n.ant-calendar-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n}\n.ant-calendar-header a:hover {\n  color: #58cefc;\n}\n.ant-calendar-header .ant-calendar-century-select,\n.ant-calendar-header .ant-calendar-decade-select,\n.ant-calendar-header .ant-calendar-year-select,\n.ant-calendar-header .ant-calendar-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: #535353;\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-header .ant-calendar-century-select-arrow,\n.ant-calendar-header .ant-calendar-decade-select-arrow,\n.ant-calendar-header .ant-calendar-year-select-arrow,\n.ant-calendar-header .ant-calendar-month-select-arrow {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-prev-month-btn,\n.ant-calendar-header .ant-calendar-next-month-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: #595959;\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::before,\n.ant-calendar-header .ant-calendar-prev-decade-btn::before,\n.ant-calendar-header .ant-calendar-prev-year-btn::before,\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-prev-century-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-decade-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-year-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-century-btn:hover::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn:hover::after,\n.ant-calendar-header .ant-calendar-prev-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn::after,\n.ant-calendar-header .ant-calendar-prev-decade-btn::after,\n.ant-calendar-header .ant-calendar-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before,\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-next-century-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-decade-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-year-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-century-btn:hover::after,\n.ant-calendar-header .ant-calendar-next-decade-btn:hover::after,\n.ant-calendar-header .ant-calendar-next-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before,\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-header .ant-calendar-next-century-btn::before,\n.ant-calendar-header .ant-calendar-next-decade-btn::before,\n.ant-calendar-header .ant-calendar-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-header .ant-calendar-next-century-btn::after,\n.ant-calendar-header .ant-calendar-next-decade-btn::after,\n.ant-calendar-header .ant-calendar-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn::before,\n.ant-calendar-header .ant-calendar-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-prev-month-btn:hover::before,\n.ant-calendar-header .ant-calendar-prev-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::before,\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-header .ant-calendar-next-month-btn:hover::before,\n.ant-calendar-header .ant-calendar-next-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-next-month-btn::before,\n.ant-calendar-header .ant-calendar-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-body {\n  padding: 8px 12px;\n}\n.ant-calendar table {\n  width: 100%;\n  max-width: 100%;\n  background-color: transparent;\n  border-collapse: collapse;\n}\n.ant-calendar table,\n.ant-calendar th,\n.ant-calendar td {\n  text-align: center;\n  border: 0;\n}\n.ant-calendar-calendar-table {\n  margin-bottom: 0;\n  border-spacing: 0;\n}\n.ant-calendar-column-header {\n  width: 33px;\n  padding: 6px 0;\n  line-height: 18px;\n  text-align: center;\n}\n.ant-calendar-column-header .ant-calendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-calendar-week-number-header .ant-calendar-column-header-inner {\n  display: none;\n}\n.ant-calendar-cell {\n  height: 30px;\n  padding: 3px 0;\n}\n.ant-calendar-date {\n  display: block;\n  width: 24px;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0;\n  color: #545454;\n  line-height: 22px;\n  text-align: center;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-date-panel {\n  position: relative;\n  outline: none;\n}\n.ant-calendar-date:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-calendar-date:active {\n  color: #fff;\n  background: #58cefc;\n}\n.ant-calendar-today .ant-calendar-date {\n  color: #2EB1EF;\n  font-weight: bold;\n  border-color: #2EB1EF;\n}\n.ant-calendar-selected-day .ant-calendar-date {\n  background: #d4f7ff;\n}\n.ant-calendar-last-month-cell .ant-calendar-date,\n.ant-calendar-next-month-btn-day .ant-calendar-date,\n.ant-calendar-last-month-cell .ant-calendar-date:hover,\n.ant-calendar-next-month-btn-day .ant-calendar-date:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border-color: transparent;\n}\n.ant-calendar-disabled-cell .ant-calendar-date {\n  position: relative;\n  width: auto;\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  border: 1px solid transparent;\n  border-radius: 0;\n  cursor: not-allowed;\n}\n.ant-calendar-disabled-cell .ant-calendar-date:hover {\n  background: #f5f5f5;\n}\n.ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date::before {\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 24px;\n  height: 24px;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  content: '';\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {\n  position: relative;\n  padding-right: 5px;\n  padding-left: 5px;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date::before {\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 24px;\n  height: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n  content: ' ';\n}\n.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-calendar-footer {\n  padding: 0 12px;\n  line-height: 38px;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-footer:empty {\n  border-top: 0;\n}\n.ant-calendar-footer-btn {\n  display: block;\n  text-align: center;\n}\n.ant-calendar-footer-extra {\n  text-align: left;\n}\n.ant-calendar .ant-calendar-today-btn,\n.ant-calendar .ant-calendar-clear-btn {\n  display: inline-block;\n  margin: 0 0 0 8px;\n  text-align: center;\n}\n.ant-calendar .ant-calendar-today-btn-disabled,\n.ant-calendar .ant-calendar-clear-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-today-btn:only-child,\n.ant-calendar .ant-calendar-clear-btn:only-child {\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn {\n  position: absolute;\n  top: 7px;\n  right: 5px;\n  display: none;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  overflow: hidden;\n  line-height: 20px;\n  text-align: center;\n  text-indent: -76px;\n}\n.ant-calendar .ant-calendar-clear-btn::after {\n  display: inline-block;\n  width: 20px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  line-height: 1;\n  text-indent: 43px;\n  transition: color 0.3s ease;\n}\n.ant-calendar .ant-calendar-clear-btn:hover::after {\n  color: #595959;\n}\n.ant-calendar .ant-calendar-ok-btn {\n  position: relative;\n  background-image: none;\n  border: 1px solid transparent;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  touch-action: manipulation;\n  display: inline-block;\n  font-weight: 400;\n  color: #545454;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: solid 1px #d9d9d9;\n  padding: 0 15px;\n  height: 36px;\n  line-height: 34px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n  color: #ffffff;\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 6px;\n  line-height: 22px;\n}\n.ant-calendar .ant-calendar-ok-btn > .anticon {\n  line-height: 1;\n}\n.ant-calendar .ant-calendar-ok-btn,\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  outline: 0;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {\n  outline: 0;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > *,\n.ant-calendar .ant-calendar-ok-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-calendar .ant-calendar-ok-btn-lg {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-calendar .ant-calendar-ok-btn-sm {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n}\n.ant-calendar .ant-calendar-ok-btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-calendar .ant-calendar-ok-btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-calendar .ant-calendar-ok-btn {\n    margin-bottom: 10px;\n  }\n}\n.ant-calendar .ant-calendar-ok-btn:focus,\n.ant-calendar .ant-calendar-ok-btn:hover {\n  text-decoration: none;\n}\n.ant-calendar .ant-calendar-ok-btn:focus,\n.ant-calendar .ant-calendar-ok-btn.focus {\n  outline: 0;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn:disabled {\n  opacity: 0.65;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled) {\n  cursor: pointer;\n}\n.gx-btn-list .ant-calendar .ant-calendar-ok-btn {\n  margin-bottom: 6px;\n}\n.gx-sub-popover .ant-calendar .ant-calendar-ok-btn {\n  border: 0 none;\n  margin-bottom: 5px;\n}\n.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:focus,\n.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:hover {\n  background-color: #f5f5f5;\n}\n.gx-sub-popover .ant-calendar .ant-calendar-ok-btn:not(:last-child) {\n  margin-right: 5px;\n}\n.gx-login-content .ant-calendar .ant-calendar-ok-btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn:hover,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  color: #fff;\n  background-color: #58cefc;\n  border-color: #58cefc;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn.active {\n  color: #fff;\n  background-color: #1c8dc9;\n  border-color: #1c8dc9;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn-disabled,\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn-disabled:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn-disabled:active,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn-disabled.active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar .ant-calendar-ok-btn:hover,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn:disabled {\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled):active,\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled,\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn-disabled:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn-disabled:active,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn-disabled.active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn-disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child::after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-calendar-range-picker-input {\n  width: 44%;\n  height: 99%;\n  text-align: center;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n}\n.ant-calendar-range-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-range-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-range-picker-input[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar-range-picker-separator {\n  display: inline-block;\n  min-width: 10px;\n  height: 100%;\n  color: #595959;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: top;\n  pointer-events: none;\n}\n.ant-calendar-range {\n  width: 552px;\n  overflow: hidden;\n}\n.ant-calendar-range .ant-calendar-date-panel::after {\n  display: block;\n  clear: both;\n  height: 0;\n  visibility: hidden;\n  content: '.';\n}\n.ant-calendar-range-part {\n  position: relative;\n  width: 50%;\n}\n.ant-calendar-range-left {\n  float: left;\n}\n.ant-calendar-range-left .ant-calendar-time-picker-inner {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-calendar-range-right {\n  float: right;\n}\n.ant-calendar-range-right .ant-calendar-time-picker-inner {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-calendar-range-middle {\n  position: absolute;\n  left: 50%;\n  z-index: 1;\n  height: 34px;\n  margin: 1px 0 0 0;\n  padding: 0 200px 0 0;\n  color: #595959;\n  line-height: 34px;\n  text-align: center;\n  transform: translateX(-50%);\n  pointer-events: none;\n}\n.ant-calendar-range-right .ant-calendar-date-input-wrap {\n  margin-left: -90px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-range-middle {\n  padding: 0 10px 0 0;\n  transform: translateX(-50%);\n}\n.ant-calendar-range .ant-calendar-today :not(.ant-calendar-disabled-cell) :not(.ant-calendar-last-month-cell) :not(.ant-calendar-next-month-btn-day) .ant-calendar-date {\n  color: #2EB1EF;\n  background: #d4f7ff;\n  border-color: #2EB1EF;\n}\n.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,\n.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date {\n  color: #fff;\n  background: #2EB1EF;\n  border: 1px solid transparent;\n}\n.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date:hover,\n.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date:hover {\n  background: #2EB1EF;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-range-right .ant-calendar-date-input-wrap {\n  margin-left: 0;\n}\n.ant-calendar-range .ant-calendar-input-wrap {\n  position: relative;\n  height: 34px;\n}\n.ant-calendar-range .ant-calendar-input,\n.ant-calendar-range .ant-calendar-time-picker-input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  height: 24px;\n  padding-right: 0;\n  padding-left: 0;\n  line-height: 24px;\n  border: 0;\n  box-shadow: none;\n}\n.ant-calendar-range .ant-calendar-input::-moz-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input:-ms-input-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range .ant-calendar-input::-webkit-input-placeholder,\n.ant-calendar-range .ant-calendar-time-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-calendar-range .ant-calendar-input:placeholder-shown,\n.ant-calendar-range .ant-calendar-time-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-calendar-range .ant-calendar-input:hover,\n.ant-calendar-range .ant-calendar-time-picker-input:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-calendar-range .ant-calendar-input:focus,\n.ant-calendar-range .ant-calendar-time-picker-input:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-calendar-range .ant-calendar-input-disabled,\n.ant-calendar-range .ant-calendar-time-picker-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input-disabled:hover,\n.ant-calendar-range .ant-calendar-time-picker-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-calendar-range .ant-calendar-input[disabled],\n.ant-calendar-range .ant-calendar-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-calendar-range .ant-calendar-input[disabled]:hover,\n.ant-calendar-range .ant-calendar-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-calendar-range .ant-calendar-input,\ntextarea.ant-calendar-range .ant-calendar-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-calendar-range .ant-calendar-input-lg,\n.ant-calendar-range .ant-calendar-time-picker-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-calendar-range .ant-calendar-input-sm,\n.ant-calendar-range .ant-calendar-time-picker-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-calendar-range .ant-calendar-input:focus,\n.ant-calendar-range .ant-calendar-time-picker-input:focus {\n  box-shadow: none;\n}\n.ant-calendar-range .ant-calendar-time-picker-icon {\n  display: none;\n}\n.ant-calendar-range.ant-calendar-week-number {\n  width: 574px;\n}\n.ant-calendar-range.ant-calendar-week-number .ant-calendar-range-part {\n  width: 286px;\n}\n.ant-calendar-range .ant-calendar-year-panel,\n.ant-calendar-range .ant-calendar-month-panel,\n.ant-calendar-range .ant-calendar-decade-panel {\n  top: 34px;\n}\n.ant-calendar-range .ant-calendar-month-panel .ant-calendar-year-panel {\n  top: 0;\n}\n.ant-calendar-range .ant-calendar-decade-panel-table,\n.ant-calendar-range .ant-calendar-year-panel-table,\n.ant-calendar-range .ant-calendar-month-panel-table {\n  height: 208px;\n}\n.ant-calendar-range .ant-calendar-in-range-cell {\n  position: relative;\n  border-radius: 0;\n}\n.ant-calendar-range .ant-calendar-in-range-cell > div {\n  position: relative;\n  z-index: 1;\n}\n.ant-calendar-range .ant-calendar-in-range-cell::before {\n  position: absolute;\n  top: 4px;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  display: block;\n  background: #f0fdff;\n  border: 0;\n  border-radius: 0;\n  content: '';\n}\n.ant-calendar-range .ant-calendar-footer-extra {\n  float: left;\n}\ndiv.ant-calendar-range-quick-selector {\n  text-align: left;\n}\ndiv.ant-calendar-range-quick-selector > a {\n  margin-right: 8px;\n}\n.ant-calendar-range .ant-calendar-header,\n.ant-calendar-range .ant-calendar-month-panel-header,\n.ant-calendar-range .ant-calendar-year-panel-header,\n.ant-calendar-range .ant-calendar-decade-panel-header {\n  border-bottom: 0;\n}\n.ant-calendar-range .ant-calendar-body,\n.ant-calendar-range .ant-calendar-month-panel-body,\n.ant-calendar-range .ant-calendar-year-panel-body,\n.ant-calendar-range .ant-calendar-decade-panel-body {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker {\n  top: 68px;\n  z-index: 2;\n  width: 100%;\n  height: 207px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-panel {\n  height: 267px;\n  margin-top: -34px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-inner {\n  height: 100%;\n  padding-top: 40px;\n  background: none;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-combobox {\n  display: inline-block;\n  height: 100%;\n  background-color: #fff;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select {\n  height: 100%;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select ul {\n  max-height: 100%;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  margin-right: 8px;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-today-btn {\n  height: 22px;\n  margin: 8px 12px;\n  line-height: 22px;\n}\n.ant-calendar-range-with-ranges.ant-calendar-time .ant-calendar-time-picker {\n  height: 233px;\n}\n.ant-calendar-range.ant-calendar-show-time-picker .ant-calendar-body {\n  border-top-color: transparent;\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  top: 40px;\n  width: 100%;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  position: absolute;\n  z-index: 1050;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: none;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  position: relative;\n  float: left;\n  height: 226px;\n  overflow: hidden;\n  font-size: 14px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  margin-left: 0;\n  border-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  width: 100%;\n  max-height: 206px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-calendar-time-picker-select li {\n  width: 100%;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n  text-align: center;\n  list-style: none;\n  cursor: pointer;\n  transition: all .3s;\n  user-select: none;\n}\n.ant-calendar-time-picker-select li:last-child::after {\n  display: block;\n  height: 202px;\n  content: '';\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #f0fdff;\n}\n.ant-calendar-time-picker-select li:focus {\n  color: #2EB1EF;\n  font-weight: 600;\n  outline: none;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  font-weight: 600;\n  background: #f5f5f5;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: #535353;\n  font-weight: 500;\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 6px;\n  outline: none;\n}\n.ant-calendar-month-panel > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.ant-calendar-month-panel-hidden {\n  display: none;\n}\n.ant-calendar-month-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-month-panel-header a:hover {\n  color: #58cefc;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: #535353;\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: #595959;\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:hover::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::before,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-month-panel-body {\n  flex: 1;\n}\n.ant-calendar-month-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-month-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-month-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-month-panel-cell {\n  text-align: center;\n}\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-calendar-month-panel-month {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 8px;\n  color: #545454;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-month-panel-month:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-calendar-year-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 6px;\n  outline: none;\n}\n.ant-calendar-year-panel > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.ant-calendar-year-panel-hidden {\n  display: none;\n}\n.ant-calendar-year-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-year-panel-header a:hover {\n  color: #58cefc;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: #535353;\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: #595959;\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:hover::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::before,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-year-panel-body {\n  flex: 1;\n}\n.ant-calendar-year-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-year-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-year-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-year-panel-cell {\n  text-align: center;\n}\n.ant-calendar-year-panel-year {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 8px;\n  color: #545454;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-year-panel-year:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,\n.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {\n  color: rgba(0, 0, 0, 0.25);\n  user-select: none;\n}\n.ant-calendar-decade-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 6px;\n  outline: none;\n}\n.ant-calendar-decade-panel-hidden {\n  display: none;\n}\n.ant-calendar-decade-panel-header {\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-bottom: 1px solid #e8e8e8;\n  user-select: none;\n  position: relative;\n}\n.ant-calendar-decade-panel-header a:hover {\n  color: #58cefc;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {\n  display: inline-block;\n  padding: 0 2px;\n  color: #535353;\n  font-weight: 500;\n  line-height: 40px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0 5px;\n  color: #595959;\n  font-size: 16px;\n  font-family: Arial, 'Hiragino Sans GB', 'Microsoft Yahei', 'Microsoft Sans Serif', sans-serif;\n  line-height: 40px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {\n  left: 7px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn::after {\n  position: relative;\n  left: -3px;\n  display: inline-block;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  right: 7px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:hover::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::before {\n  position: relative;\n  left: 3px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn::after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn::after {\n  display: inline-block;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {\n  left: 29px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {\n  right: 29px;\n  height: 100%;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  border: 0 solid #aaa;\n  border-width: 1.5px 0 0 1.5px;\n  border-radius: 1px;\n  transform: rotate(-45deg) scale(0.8);\n  transition: all 0.3s;\n  content: '';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:hover::after {\n  border-color: #545454;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::before,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn::after {\n  transform: rotate(135deg) scale(0.8);\n}\n.ant-calendar-decade-panel-body {\n  flex: 1;\n}\n.ant-calendar-decade-panel-footer {\n  border-top: 1px solid #e8e8e8;\n}\n.ant-calendar-decade-panel-footer .ant-calendar-footer-extra {\n  padding: 0 12px;\n}\n.ant-calendar-decade-panel-table {\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.ant-calendar-decade-panel-cell {\n  white-space: nowrap;\n  text-align: center;\n}\n.ant-calendar-decade-panel-decade {\n  display: inline-block;\n  height: 24px;\n  margin: 0 auto;\n  padding: 0 6px;\n  color: #545454;\n  line-height: 24px;\n  text-align: center;\n  background: transparent;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-decade-panel-decade:hover {\n  background: #f0fdff;\n  cursor: pointer;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,\n.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {\n  color: rgba(0, 0, 0, 0.25);\n  user-select: none;\n}\n.ant-calendar-month .ant-calendar-month-header-wrap {\n  position: relative;\n  height: 288px;\n}\n.ant-calendar-month .ant-calendar-month-panel,\n.ant-calendar-month .ant-calendar-year-panel {\n  top: 0;\n  height: 100%;\n}\n.ant-calendar-week-number-cell {\n  opacity: 0.5;\n}\n.ant-calendar-week-number .ant-calendar-body tr {\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-calendar-week-number .ant-calendar-body tr:hover {\n  background: #f0fdff;\n}\n.ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {\n  font-weight: bold;\n  background: #d4f7ff;\n}\n.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day .ant-calendar-date,\n.ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day:hover .ant-calendar-date {\n  color: #545454;\n  background: transparent;\n}\n.ant-descriptions-title {\n  margin-bottom: 20px;\n  color: #535353;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 1.3;\n}\n.ant-descriptions-view {\n  width: 100%;\n  overflow: hidden;\n  border-radius: 6px;\n}\n.ant-descriptions-view table {\n  width: 100%;\n  table-layout: fixed;\n}\n.ant-descriptions-row > th,\n.ant-descriptions-row > td {\n  padding-bottom: 16px;\n}\n.ant-descriptions-row:last-child {\n  border-bottom: none;\n}\n.ant-descriptions-item-label {\n  color: #535353;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-descriptions-item-label::after {\n  position: relative;\n  top: -0.5px;\n  margin: 0 8px 0 2px;\n  content: ' ';\n}\n.ant-descriptions-item-colon::after {\n  content: ':';\n}\n.ant-descriptions-item-no-label::after {\n  margin: 0;\n  content: '';\n}\n.ant-descriptions-item-content {\n  display: table-cell;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-descriptions-item {\n  padding-bottom: 0;\n}\n.ant-descriptions-item > span {\n  display: inline-block;\n}\n.ant-descriptions-middle .ant-descriptions-row > th,\n.ant-descriptions-middle .ant-descriptions-row > td {\n  padding-bottom: 12px;\n}\n.ant-descriptions-small .ant-descriptions-row > th,\n.ant-descriptions-small .ant-descriptions-row > td {\n  padding-bottom: 8px;\n}\n.ant-descriptions-bordered .ant-descriptions-view {\n  border: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-view > table {\n  table-layout: auto;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label,\n.ant-descriptions-bordered .ant-descriptions-item-content {\n  padding: 16px 24px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label:last-child,\n.ant-descriptions-bordered .ant-descriptions-item-content:last-child {\n  border-right: none;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label {\n  background-color: #fafafa;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label::after {\n  display: none;\n}\n.ant-descriptions-bordered .ant-descriptions-row {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-descriptions-bordered .ant-descriptions-row:last-child {\n  border-bottom: none;\n}\n.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label,\n.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content {\n  padding: 12px 24px;\n}\n.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label,\n.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content {\n  padding: 8px 16px;\n}\n.ant-divider {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  background: #e8e8e8;\n}\n.ant-divider,\n.ant-divider-vertical {\n  position: relative;\n  top: -0.06em;\n  display: inline-block;\n  width: 1px;\n  height: 0.9em;\n  margin: 0 8px;\n  vertical-align: middle;\n}\n.ant-divider-horizontal {\n  display: block;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  height: 1px;\n  margin: 24px 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-center,\n.ant-divider-horizontal.ant-divider-with-text-left,\n.ant-divider-horizontal.ant-divider-with-text-right {\n  display: table;\n  margin: 16px 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n  text-align: center;\n  background: transparent;\n}\n.ant-divider-horizontal.ant-divider-with-text-center::before,\n.ant-divider-horizontal.ant-divider-with-text-left::before,\n.ant-divider-horizontal.ant-divider-with-text-right::before,\n.ant-divider-horizontal.ant-divider-with-text-center::after,\n.ant-divider-horizontal.ant-divider-with-text-left::after,\n.ant-divider-horizontal.ant-divider-with-text-right::after {\n  position: relative;\n  top: 50%;\n  display: table-cell;\n  width: 50%;\n  border-top: 1px solid #e8e8e8;\n  transform: translateY(50%);\n  content: '';\n}\n.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text,\n.ant-divider-horizontal.ant-divider-with-text-right .ant-divider-inner-text {\n  display: inline-block;\n  padding: 0 10px;\n}\n.ant-divider-horizontal.ant-divider-with-text-left::before {\n  top: 50%;\n  width: 5%;\n}\n.ant-divider-horizontal.ant-divider-with-text-left::after {\n  top: 50%;\n  width: 95%;\n}\n.ant-divider-horizontal.ant-divider-with-text-right::before {\n  top: 50%;\n  width: 95%;\n}\n.ant-divider-horizontal.ant-divider-with-text-right::after {\n  top: 50%;\n  width: 5%;\n}\n.ant-divider-inner-text {\n  display: inline-block;\n  padding: 0 24px;\n}\n.ant-divider-dashed {\n  background: none;\n  border-color: #e8e8e8;\n  border-style: dashed;\n  border-width: 1px 0 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed,\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed,\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed {\n  border-top: 0;\n}\n.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed::before,\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed::before,\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed::before,\n.ant-divider-horizontal.ant-divider-with-text-center.ant-divider-dashed::after,\n.ant-divider-horizontal.ant-divider-with-text-left.ant-divider-dashed::after,\n.ant-divider-horizontal.ant-divider-with-text-right.ant-divider-dashed::after {\n  border-style: dashed none none;\n}\n.ant-divider-vertical.ant-divider-dashed {\n  border-width: 0 0 0 1px;\n}\n.ant-drawer {\n  position: fixed;\n  z-index: 1000;\n  width: 0%;\n  height: 100%;\n  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1), height 0s ease 0.3s, width 0s ease 0.3s;\n}\n.ant-drawer > * {\n  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1), box-shadow 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);\n}\n.ant-drawer-content-wrapper {\n  position: absolute;\n}\n.ant-drawer .ant-drawer-content {\n  width: 100%;\n  height: 100%;\n}\n.ant-drawer-left,\n.ant-drawer-right {\n  top: 0;\n  width: 0%;\n  height: 100%;\n}\n.ant-drawer-left .ant-drawer-content-wrapper,\n.ant-drawer-right .ant-drawer-content-wrapper {\n  height: 100%;\n}\n.ant-drawer-left.ant-drawer-open,\n.ant-drawer-right.ant-drawer-open {\n  width: 100%;\n  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);\n}\n.ant-drawer-left.ant-drawer-open.no-mask,\n.ant-drawer-right.ant-drawer-open.no-mask {\n  width: 0%;\n}\n.ant-drawer-left.ant-drawer-open .ant-drawer-content-wrapper {\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n}\n.ant-drawer-right {\n  right: 0;\n}\n.ant-drawer-right .ant-drawer-content-wrapper {\n  right: 0;\n}\n.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);\n}\n.ant-drawer-right.ant-drawer-open.no-mask {\n  right: 1px;\n  transform: translateX(1px);\n}\n.ant-drawer-top,\n.ant-drawer-bottom {\n  left: 0;\n  width: 100%;\n  height: 0%;\n}\n.ant-drawer-top .ant-drawer-content-wrapper,\n.ant-drawer-bottom .ant-drawer-content-wrapper {\n  width: 100%;\n}\n.ant-drawer-top.ant-drawer-open,\n.ant-drawer-bottom.ant-drawer-open {\n  height: 100%;\n  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);\n}\n.ant-drawer-top.ant-drawer-open.no-mask,\n.ant-drawer-bottom.ant-drawer-open.no-mask {\n  height: 0%;\n}\n.ant-drawer-top {\n  top: 0;\n}\n.ant-drawer-top.ant-drawer-open .ant-drawer-content-wrapper {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-drawer-bottom {\n  bottom: 0;\n}\n.ant-drawer-bottom .ant-drawer-content-wrapper {\n  bottom: 0;\n}\n.ant-drawer-bottom.ant-drawer-open .ant-drawer-content-wrapper {\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-drawer-bottom.ant-drawer-open.no-mask {\n  bottom: 1px;\n  transform: translateY(1px);\n}\n.ant-drawer.ant-drawer-open .ant-drawer-mask {\n  height: 100%;\n  opacity: 1;\n  transition: none;\n  animation: antdDrawerFadeIn 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);\n}\n.ant-drawer-title {\n  margin: 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n}\n.ant-drawer-content {\n  position: relative;\n  z-index: 1;\n  overflow: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n}\n.ant-drawer-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  display: block;\n  width: 56px;\n  height: 56px;\n  padding: 0;\n  color: #595959;\n  font-weight: 700;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 56px;\n  text-align: center;\n  text-transform: none;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n  text-rendering: auto;\n}\n.ant-drawer-close:focus,\n.ant-drawer-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-drawer-header {\n  position: relative;\n  padding: 16px 24px;\n  color: #545454;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-drawer-header-no-title {\n  color: #545454;\n  background: #fff;\n}\n.ant-drawer-body {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n.ant-drawer-wrapper-body {\n  height: 100%;\n  overflow: auto;\n}\n.ant-drawer-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  opacity: 0;\n  filter: alpha(opacity=45);\n  transition: opacity 0.3s linear, height 0s ease 0.3s;\n}\n.ant-drawer-open-content {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n@keyframes antdDrawerFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ant-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  display: block;\n}\n.ant-dropdown::before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  bottom: -7px;\n  left: -7px;\n  z-index: -9999;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down::before {\n  transition: transform 0.2s;\n}\n.ant-dropdown-wrap-open .anticon-down::before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  position: relative;\n  margin: 0;\n  padding: 4px 0;\n  text-align: left;\n  list-style-type: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.ant-dropdown-menu-item-group-title {\n  padding: 5px 12px;\n  color: #595959;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n}\n.ant-dropdown-menu-submenu-popup > .ant-dropdown-menu {\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu-popup ul,\n.ant-dropdown-menu-submenu-popup li {\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-popup ul {\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n  padding: 0;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  clear: both;\n  margin: 0;\n  padding: 5px 12px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-item > .anticon:first-child,\n.ant-dropdown-menu-submenu-title > .anticon:first-child,\n.ant-dropdown-menu-item > span > .anticon:first-child,\n.ant-dropdown-menu-submenu-title > span > .anticon:first-child {\n  min-width: 12px;\n  margin-right: 8px;\n  font-size: 12px;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  display: block;\n  margin: -5px -12px;\n  padding: 5px 12px;\n  color: #545454;\n  transition: all 0.3s;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #2EB1EF;\n  background-color: #f0fdff;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #f0fdff;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  margin: 4px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow {\n  position: absolute;\n  right: 8px;\n}\n.ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,\n.ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  color: #595959;\n  font-style: normal;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow-icon,\n:root .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  font-size: 12px;\n}\n.ant-dropdown-menu-item-group-list {\n  margin: 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.ant-dropdown-menu-submenu-title {\n  padding-right: 26px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow-icon {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-submenu-selected .ant-dropdown-menu-submenu-title {\n  color: #2EB1EF;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger > .anticon.anticon-down,\n.ant-dropdown-link > .anticon.anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-trigger > .anticon.anticon-down,\n:root .ant-dropdown-link > .anticon.anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-dropdown-button .anticon.anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-dropdown-button .anticon.anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: #003366;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a .ant-dropdown-menu-submenu-arrow::after {\n  color: rgba(255, 255, 255, 0.65);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  color: #fff;\n  background: #2EB1EF;\n}\n.ant-empty {\n  margin: 0 8px;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n}\n.ant-empty-image {\n  height: 100px;\n  margin-bottom: 8px;\n}\n.ant-empty-image img {\n  height: 100%;\n}\n.ant-empty-image svg {\n  height: 100%;\n  margin: auto;\n}\n.ant-empty-description {\n  margin: 0;\n}\n.ant-empty-footer {\n  margin-top: 16px;\n}\n.ant-empty-normal {\n  margin: 32px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-normal .ant-empty-image {\n  height: 40px;\n}\n.ant-empty-small {\n  margin: 8px 0;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-empty-small .ant-empty-image {\n  height: 35px;\n}\n.ant-form {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-form legend {\n  display: block;\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 0;\n  color: #595959;\n  font-size: 16px;\n  line-height: inherit;\n  border: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-form label {\n  font-size: 14px;\n}\n.ant-form input[type='search'] {\n  box-sizing: border-box;\n}\n.ant-form input[type='radio'],\n.ant-form input[type='checkbox'] {\n  line-height: normal;\n}\n.ant-form input[type='file'] {\n  display: block;\n}\n.ant-form input[type='range'] {\n  display: block;\n  width: 100%;\n}\n.ant-form select[multiple],\n.ant-form select[size] {\n  height: auto;\n}\n.ant-form input[type='file']:focus,\n.ant-form input[type='radio']:focus,\n.ant-form input[type='checkbox']:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.ant-form output {\n  display: block;\n  padding-top: 15px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n}\n.ant-form-item-required::before {\n  display: inline-block;\n  margin-right: 4px;\n  color: #f5222d;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n.ant-form-hide-required-mark .ant-form-item-required::before {\n  display: none;\n}\n.ant-form-item-label > label {\n  color: #535353;\n}\n.ant-form-item-label > label::after {\n  content: ':';\n  position: relative;\n  top: -0.5px;\n  margin: 0 8px 0 2px;\n}\n.ant-form-item-label > label.ant-form-item-no-colon::after {\n  content: ' ';\n}\n.ant-form-item {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin-bottom: 20px;\n  vertical-align: top;\n}\n.ant-form-item label {\n  position: relative;\n}\n.ant-form-item label > .anticon {\n  font-size: 14px;\n  vertical-align: top;\n}\n.ant-form-item-control {\n  position: relative;\n  line-height: 40px;\n  zoom: 1;\n}\n.ant-form-item-control::before,\n.ant-form-item-control::after {\n  display: table;\n  content: '';\n}\n.ant-form-item-control::after {\n  clear: both;\n}\n.ant-form-item-control::before,\n.ant-form-item-control::after {\n  display: table;\n  content: '';\n}\n.ant-form-item-control::after {\n  clear: both;\n}\n.ant-form-item-children {\n  position: relative;\n}\n.ant-form-item-with-help {\n  margin-bottom: 2px;\n}\n.ant-form-item-label {\n  display: inline-block;\n  overflow: hidden;\n  line-height: 39.9999px;\n  white-space: nowrap;\n  text-align: right;\n  vertical-align: middle;\n}\n.ant-form-item-label-left {\n  text-align: left;\n}\n.ant-form-item .ant-switch {\n  margin: 2px 0 4px;\n}\n.ant-form-explain,\n.ant-form-extra {\n  clear: both;\n  min-height: 19px;\n  margin-top: 0px;\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.3;\n  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-form-explain {\n  margin-bottom: -1px;\n}\n.ant-form-extra {\n  padding-top: 4px;\n}\n.ant-form-text {\n  display: inline-block;\n  padding-right: 8px;\n}\n.ant-form-split {\n  display: block;\n  text-align: center;\n}\nform .has-feedback .ant-input {\n  padding-right: 30px;\n}\nform .has-feedback .ant-input-affix-wrapper .ant-input-suffix {\n  padding-right: 18px;\n}\nform .has-feedback .ant-input-affix-wrapper .ant-input {\n  padding-right: 49px;\n}\nform .has-feedback .ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input {\n  padding-right: 68px;\n}\nform .has-feedback > .ant-select .ant-select-arrow,\nform .has-feedback > .ant-select .ant-select-selection__clear,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection__clear {\n  right: 30px;\n}\nform .has-feedback > .ant-select .ant-select-selection-selected-value,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {\n  padding-right: 42px;\n}\nform .has-feedback .ant-cascader-picker-arrow {\n  margin-right: 19px;\n}\nform .has-feedback .ant-cascader-picker-clear {\n  right: 30px;\n}\nform .has-feedback .ant-input-search:not(.ant-input-search-enter-button) .ant-input-suffix {\n  right: 30px;\n}\nform .has-feedback .ant-calendar-picker-icon,\nform .has-feedback .ant-time-picker-icon,\nform .has-feedback .ant-calendar-picker-clear,\nform .has-feedback .ant-time-picker-clear {\n  right: 30px;\n}\nform .ant-mentions,\nform textarea.ant-input {\n  height: auto;\n  margin-bottom: 4px;\n}\nform .ant-upload {\n  background: transparent;\n}\nform input[type='radio'],\nform input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n}\nform .ant-radio-inline,\nform .ant-checkbox-inline {\n  display: inline-block;\n  margin-left: 8px;\n  font-weight: normal;\n  vertical-align: middle;\n  cursor: pointer;\n}\nform .ant-radio-inline:first-child,\nform .ant-checkbox-inline:first-child {\n  margin-left: 0;\n}\nform .ant-checkbox-vertical,\nform .ant-radio-vertical {\n  display: block;\n}\nform .ant-checkbox-vertical + .ant-checkbox-vertical,\nform .ant-radio-vertical + .ant-radio-vertical {\n  margin-left: 0;\n}\nform .ant-input-number + .ant-form-text {\n  margin-left: 8px;\n}\nform .ant-input-number-handler-wrap {\n  z-index: 2;\n}\nform .ant-select,\nform .ant-cascader-picker {\n  width: 100%;\n}\nform .ant-input-group .ant-select,\nform .ant-input-group .ant-cascader-picker {\n  width: auto;\n}\nform :not(.ant-input-group-wrapper) > .ant-input-group,\nform .ant-input-group-wrapper {\n  display: inline-block;\n  vertical-align: middle;\n}\nform:not(.ant-form-vertical) :not(.ant-input-group-wrapper) > .ant-input-group,\nform:not(.ant-form-vertical) .ant-input-group-wrapper {\n  position: relative;\n  top: -1px;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  display: block;\n  margin: 0;\n  padding: 0 0 8px;\n  line-height: 1.3;\n  white-space: initial;\n  text-align: left;\n}\n.ant-form-vertical .ant-form-item-label label::after,\n.ant-col-24.ant-form-item-label label::after,\n.ant-col-xl-24.ant-form-item-label label::after {\n  display: none;\n}\n.ant-form-vertical .ant-form-item {\n  padding-bottom: 8px;\n}\n.ant-form-vertical .ant-form-item-control {\n  line-height: 1.3;\n}\n.ant-form-vertical .ant-form-explain {\n  margin-top: 2px;\n  margin-bottom: -5px;\n}\n.ant-form-vertical .ant-form-extra {\n  margin-top: 2px;\n  margin-bottom: -4px;\n}\n@media (max-width: 575px) {\n  .ant-form-item-label,\n  .ant-form-item-control-wrapper {\n    display: block;\n    width: 100%;\n  }\n  .ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-form-item-label label::after {\n    display: none;\n  }\n  .ant-col-xs-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xs-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .ant-col-sm-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-sm-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .ant-col-md-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-md-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-col-lg-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-lg-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-col-xl-24.ant-form-item-label {\n    display: block;\n    margin: 0;\n    padding: 0 0 8px;\n    line-height: 1.3;\n    white-space: initial;\n    text-align: left;\n  }\n  .ant-col-xl-24.ant-form-item-label label::after {\n    display: none;\n  }\n}\n.ant-form-inline .ant-form-item {\n  display: inline-block;\n  margin-right: 16px;\n  margin-bottom: 0;\n}\n.ant-form-inline .ant-form-item-with-help {\n  margin-bottom: 20px;\n}\n.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper,\n.ant-form-inline .ant-form-item > .ant-form-item-label {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-form-inline .ant-form-text {\n  display: inline-block;\n}\n.ant-form-inline .has-feedback {\n  display: inline-block;\n}\n.has-success.has-feedback .ant-form-item-children-icon,\n.has-warning.has-feedback .ant-form-item-children-icon,\n.has-error.has-feedback .ant-form-item-children-icon,\n.is-validating.has-feedback .ant-form-item-children-icon {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  z-index: 1;\n  width: 36px;\n  height: 20px;\n  margin-top: -10px;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  visibility: visible;\n  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  pointer-events: none;\n}\n.has-success.has-feedback .ant-form-item-children-icon svg,\n.has-warning.has-feedback .ant-form-item-children-icon svg,\n.has-error.has-feedback .ant-form-item-children-icon svg,\n.is-validating.has-feedback .ant-form-item-children-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.has-success.has-feedback .ant-form-item-children-icon {\n  color: #52c41a;\n  animation-name: diffZoomIn1 !important;\n}\n.has-warning .ant-form-explain,\n.has-warning .ant-form-split {\n  color: #fa8c16;\n}\n.has-warning .ant-input,\n.has-warning .ant-input:hover {\n  background-color: #fff;\n  border-color: #fa8c16;\n}\n.has-warning .ant-input:focus {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-input:not([disabled]):hover {\n  border-color: #fa8c16;\n}\n.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-input-affix-wrapper .ant-input,\n.has-warning .ant-input-affix-wrapper .ant-input:hover {\n  background-color: #fff;\n  border-color: #fa8c16;\n}\n.has-warning .ant-input-affix-wrapper .ant-input:focus {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #fa8c16;\n}\n.has-warning .ant-input-prefix {\n  color: #fa8c16;\n}\n.has-warning .ant-input-group-addon {\n  color: #fa8c16;\n  background-color: #fff;\n  border-color: #fa8c16;\n}\n.has-warning .has-feedback {\n  color: #fa8c16;\n}\n.has-warning.has-feedback .ant-form-item-children-icon {\n  color: #fa8c16;\n  animation-name: diffZoomIn3 !important;\n}\n.has-warning .ant-select-selection {\n  border-color: #fa8c16;\n}\n.has-warning .ant-select-selection:hover {\n  border-color: #fa8c16;\n}\n.has-warning .ant-select-open .ant-select-selection,\n.has-warning .ant-select-focused .ant-select-selection {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-calendar-picker-icon::after,\n.has-warning .ant-time-picker-icon::after,\n.has-warning .ant-picker-icon::after,\n.has-warning .ant-select-arrow,\n.has-warning .ant-cascader-picker-arrow {\n  color: #fa8c16;\n}\n.has-warning .ant-input-number,\n.has-warning .ant-time-picker-input {\n  border-color: #fa8c16;\n}\n.has-warning .ant-input-number-focused,\n.has-warning .ant-time-picker-input-focused,\n.has-warning .ant-input-number:focus,\n.has-warning .ant-time-picker-input:focus {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-input-number:not([disabled]):hover,\n.has-warning .ant-time-picker-input:not([disabled]):hover {\n  border-color: #fa8c16;\n}\n.has-warning .ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #ffa940;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);\n}\n.has-warning .ant-cascader-picker:hover .ant-cascader-input {\n  border-color: #fa8c16;\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-split {\n  color: #f5222d;\n}\n.has-error .ant-input,\n.has-error .ant-input:hover {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.has-error .ant-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-affix-wrapper .ant-input,\n.has-error .ant-input-affix-wrapper .ant-input:hover {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.has-error .ant-input-affix-wrapper .ant-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #f5222d;\n}\n.has-error .ant-input-prefix {\n  color: #f5222d;\n}\n.has-error .ant-input-group-addon {\n  color: #f5222d;\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.has-error .has-feedback {\n  color: #f5222d;\n}\n.has-error.has-feedback .ant-form-item-children-icon {\n  color: #f5222d;\n  animation-name: diffZoomIn2 !important;\n}\n.has-error .ant-select-selection {\n  border-color: #f5222d;\n}\n.has-error .ant-select-selection:hover {\n  border-color: #f5222d;\n}\n.has-error .ant-select-open .ant-select-selection,\n.has-error .ant-select-focused .ant-select-selection {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-select.ant-select-auto-complete .ant-input:focus {\n  border-color: #f5222d;\n}\n.has-error .ant-input-group-addon .ant-select-selection {\n  border-color: transparent;\n  box-shadow: none;\n}\n.has-error .ant-calendar-picker-icon::after,\n.has-error .ant-time-picker-icon::after,\n.has-error .ant-picker-icon::after,\n.has-error .ant-select-arrow,\n.has-error .ant-cascader-picker-arrow {\n  color: #f5222d;\n}\n.has-error .ant-input-number,\n.has-error .ant-time-picker-input {\n  border-color: #f5222d;\n}\n.has-error .ant-input-number-focused,\n.has-error .ant-time-picker-input-focused,\n.has-error .ant-input-number:focus,\n.has-error .ant-time-picker-input:focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-input-number:not([disabled]):hover,\n.has-error .ant-time-picker-input:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-mention-wrapper .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover {\n  border-color: #f5222d;\n}\n.has-error .ant-mention-wrapper.ant-mention-active:not([disabled]) .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #ff4d4f;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);\n}\n.has-error .ant-cascader-picker:hover .ant-cascader-input {\n  border-color: #f5222d;\n}\n.has-error .ant-transfer-list {\n  border-color: #f5222d;\n}\n.has-error .ant-transfer-list-search:not([disabled]) {\n  border-color: #d9d9d9;\n}\n.has-error .ant-transfer-list-search:not([disabled]):hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.has-error .ant-transfer-list-search:not([disabled]):focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.is-validating.has-feedback .ant-form-item-children-icon {\n  display: inline-block;\n  color: #2EB1EF;\n}\n.ant-advanced-search-form .ant-form-item {\n  margin-bottom: 20px;\n}\n.ant-advanced-search-form .ant-form-item-with-help {\n  margin-bottom: 2px;\n}\n.show-help-enter,\n.show-help-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.show-help-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.show-help-enter.show-help-enter-active,\n.show-help-appear.show-help-appear-active {\n  animation-name: antShowHelpIn;\n  animation-play-state: running;\n}\n.show-help-leave.show-help-leave-active {\n  animation-name: antShowHelpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.show-help-enter,\n.show-help-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.show-help-leave {\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n@keyframes antShowHelpIn {\n  0% {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes antShowHelpOut {\n  to {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n}\n@keyframes diffZoomIn1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn2 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn3 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.ant-row {\n  position: relative;\n  height: auto;\n  margin-right: -16px;\n  margin-left: -16px;\n  zoom: 1;\n  display: block;\n  box-sizing: border-box;\n}\n.ant-row::before,\n.ant-row::after {\n  display: table;\n  content: '';\n}\n.ant-row::after {\n  clear: both;\n}\n.ant-row::before,\n.ant-row::after {\n  display: table;\n  content: '';\n}\n.ant-row::after {\n  clear: both;\n}\n.ant-row + .ant-row::before {\n  clear: both;\n}\n.ant-row-flex {\n  display: flex;\n  flex-flow: row wrap;\n}\n.ant-row-flex::before,\n.ant-row-flex::after {\n  display: flex;\n}\n.ant-row-flex-start {\n  justify-content: flex-start;\n}\n.ant-row-flex-center {\n  justify-content: center;\n}\n.ant-row-flex-end {\n  justify-content: flex-end;\n}\n.ant-row-flex-space-between {\n  justify-content: space-between;\n}\n.ant-row-flex-space-around {\n  justify-content: space-around;\n}\n.ant-row-flex-top {\n  align-items: flex-start;\n}\n.ant-row-flex-middle {\n  align-items: center;\n}\n.ant-row-flex-bottom {\n  align-items: flex-end;\n}\n.ant-col {\n  position: relative;\n  min-height: 1px;\n}\n.ant-col-1, .ant-col-xs-1, .ant-col-sm-1, .ant-col-md-1, .ant-col-lg-1, .ant-col-2, .ant-col-xs-2, .ant-col-sm-2, .ant-col-md-2, .ant-col-lg-2, .ant-col-3, .ant-col-xs-3, .ant-col-sm-3, .ant-col-md-3, .ant-col-lg-3, .ant-col-4, .ant-col-xs-4, .ant-col-sm-4, .ant-col-md-4, .ant-col-lg-4, .ant-col-5, .ant-col-xs-5, .ant-col-sm-5, .ant-col-md-5, .ant-col-lg-5, .ant-col-6, .ant-col-xs-6, .ant-col-sm-6, .ant-col-md-6, .ant-col-lg-6, .ant-col-7, .ant-col-xs-7, .ant-col-sm-7, .ant-col-md-7, .ant-col-lg-7, .ant-col-8, .ant-col-xs-8, .ant-col-sm-8, .ant-col-md-8, .ant-col-lg-8, .ant-col-9, .ant-col-xs-9, .ant-col-sm-9, .ant-col-md-9, .ant-col-lg-9, .ant-col-10, .ant-col-xs-10, .ant-col-sm-10, .ant-col-md-10, .ant-col-lg-10, .ant-col-11, .ant-col-xs-11, .ant-col-sm-11, .ant-col-md-11, .ant-col-lg-11, .ant-col-12, .ant-col-xs-12, .ant-col-sm-12, .ant-col-md-12, .ant-col-lg-12, .ant-col-13, .ant-col-xs-13, .ant-col-sm-13, .ant-col-md-13, .ant-col-lg-13, .ant-col-14, .ant-col-xs-14, .ant-col-sm-14, .ant-col-md-14, .ant-col-lg-14, .ant-col-15, .ant-col-xs-15, .ant-col-sm-15, .ant-col-md-15, .ant-col-lg-15, .ant-col-16, .ant-col-xs-16, .ant-col-sm-16, .ant-col-md-16, .ant-col-lg-16, .ant-col-17, .ant-col-xs-17, .ant-col-sm-17, .ant-col-md-17, .ant-col-lg-17, .ant-col-18, .ant-col-xs-18, .ant-col-sm-18, .ant-col-md-18, .ant-col-lg-18, .ant-col-19, .ant-col-xs-19, .ant-col-sm-19, .ant-col-md-19, .ant-col-lg-19, .ant-col-20, .ant-col-xs-20, .ant-col-sm-20, .ant-col-md-20, .ant-col-lg-20, .ant-col-21, .ant-col-xs-21, .ant-col-sm-21, .ant-col-md-21, .ant-col-lg-21, .ant-col-22, .ant-col-xs-22, .ant-col-sm-22, .ant-col-md-22, .ant-col-lg-22, .ant-col-23, .ant-col-xs-23, .ant-col-sm-23, .ant-col-md-23, .ant-col-lg-23, .ant-col-24, .ant-col-xs-24, .ant-col-sm-24, .ant-col-md-24, .ant-col-lg-24 {\n  position: relative;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n.ant-col-1, .ant-col-xs-1, .ant-col-sm-1, .ant-col-md-1, .ant-col-lg-1, .ant-col-2, .ant-col-xs-2, .ant-col-sm-2, .ant-col-md-2, .ant-col-lg-2, .ant-col-3, .ant-col-xs-3, .ant-col-sm-3, .ant-col-md-3, .ant-col-lg-3, .ant-col-4, .ant-col-xs-4, .ant-col-sm-4, .ant-col-md-4, .ant-col-lg-4, .ant-col-5, .ant-col-xs-5, .ant-col-sm-5, .ant-col-md-5, .ant-col-lg-5, .ant-col-6, .ant-col-xs-6, .ant-col-sm-6, .ant-col-md-6, .ant-col-lg-6, .ant-col-7, .ant-col-xs-7, .ant-col-sm-7, .ant-col-md-7, .ant-col-lg-7, .ant-col-8, .ant-col-xs-8, .ant-col-sm-8, .ant-col-md-8, .ant-col-lg-8, .ant-col-9, .ant-col-xs-9, .ant-col-sm-9, .ant-col-md-9, .ant-col-lg-9, .ant-col-10, .ant-col-xs-10, .ant-col-sm-10, .ant-col-md-10, .ant-col-lg-10, .ant-col-11, .ant-col-xs-11, .ant-col-sm-11, .ant-col-md-11, .ant-col-lg-11, .ant-col-12, .ant-col-xs-12, .ant-col-sm-12, .ant-col-md-12, .ant-col-lg-12, .ant-col-13, .ant-col-xs-13, .ant-col-sm-13, .ant-col-md-13, .ant-col-lg-13, .ant-col-14, .ant-col-xs-14, .ant-col-sm-14, .ant-col-md-14, .ant-col-lg-14, .ant-col-15, .ant-col-xs-15, .ant-col-sm-15, .ant-col-md-15, .ant-col-lg-15, .ant-col-16, .ant-col-xs-16, .ant-col-sm-16, .ant-col-md-16, .ant-col-lg-16, .ant-col-17, .ant-col-xs-17, .ant-col-sm-17, .ant-col-md-17, .ant-col-lg-17, .ant-col-18, .ant-col-xs-18, .ant-col-sm-18, .ant-col-md-18, .ant-col-lg-18, .ant-col-19, .ant-col-xs-19, .ant-col-sm-19, .ant-col-md-19, .ant-col-lg-19, .ant-col-20, .ant-col-xs-20, .ant-col-sm-20, .ant-col-md-20, .ant-col-lg-20, .ant-col-21, .ant-col-xs-21, .ant-col-sm-21, .ant-col-md-21, .ant-col-lg-21, .ant-col-22, .ant-col-xs-22, .ant-col-sm-22, .ant-col-md-22, .ant-col-lg-22, .ant-col-23, .ant-col-xs-23, .ant-col-sm-23, .ant-col-md-23, .ant-col-lg-23, .ant-col-24, .ant-col-xs-24, .ant-col-sm-24, .ant-col-md-24, .ant-col-lg-24 {\n  padding-left: 16px;\n  padding-right: 16px;\n  float: none !important;\n}\n.ant-col-1, .ant-col-2, .ant-col-3, .ant-col-4, .ant-col-5, .ant-col-6, .ant-col-7, .ant-col-8, .ant-col-9, .ant-col-10, .ant-col-11, .ant-col-12, .ant-col-13, .ant-col-14, .ant-col-15, .ant-col-16, .ant-col-17, .ant-col-18, .ant-col-19, .ant-col-20, .ant-col-21, .ant-col-22, .ant-col-23, .ant-col-24 {\n  flex: 0 0 auto;\n  float: left;\n}\n.ant-col-24 {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n}\n.ant-col-push-24 {\n  left: 100%;\n}\n.ant-col-pull-24 {\n  right: 100%;\n}\n.ant-col-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-order-24 {\n  order: 24;\n}\n.ant-col-23 {\n  display: block;\n  box-sizing: border-box;\n  width: 95.83333333%;\n}\n.ant-col-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-order-23 {\n  order: 23;\n}\n.ant-col-22 {\n  display: block;\n  box-sizing: border-box;\n  width: 91.66666667%;\n}\n.ant-col-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-order-22 {\n  order: 22;\n}\n.ant-col-21 {\n  display: block;\n  box-sizing: border-box;\n  width: 87.5%;\n}\n.ant-col-push-21 {\n  left: 87.5%;\n}\n.ant-col-pull-21 {\n  right: 87.5%;\n}\n.ant-col-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-order-21 {\n  order: 21;\n}\n.ant-col-20 {\n  display: block;\n  box-sizing: border-box;\n  width: 83.33333333%;\n}\n.ant-col-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-order-20 {\n  order: 20;\n}\n.ant-col-19 {\n  display: block;\n  box-sizing: border-box;\n  width: 79.16666667%;\n}\n.ant-col-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-order-19 {\n  order: 19;\n}\n.ant-col-18 {\n  display: block;\n  box-sizing: border-box;\n  width: 75%;\n}\n.ant-col-push-18 {\n  left: 75%;\n}\n.ant-col-pull-18 {\n  right: 75%;\n}\n.ant-col-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-order-18 {\n  order: 18;\n}\n.ant-col-17 {\n  display: block;\n  box-sizing: border-box;\n  width: 70.83333333%;\n}\n.ant-col-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-order-17 {\n  order: 17;\n}\n.ant-col-16 {\n  display: block;\n  box-sizing: border-box;\n  width: 66.66666667%;\n}\n.ant-col-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-order-16 {\n  order: 16;\n}\n.ant-col-15 {\n  display: block;\n  box-sizing: border-box;\n  width: 62.5%;\n}\n.ant-col-push-15 {\n  left: 62.5%;\n}\n.ant-col-pull-15 {\n  right: 62.5%;\n}\n.ant-col-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-order-15 {\n  order: 15;\n}\n.ant-col-14 {\n  display: block;\n  box-sizing: border-box;\n  width: 58.33333333%;\n}\n.ant-col-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-order-14 {\n  order: 14;\n}\n.ant-col-13 {\n  display: block;\n  box-sizing: border-box;\n  width: 54.16666667%;\n}\n.ant-col-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-order-13 {\n  order: 13;\n}\n.ant-col-12 {\n  display: block;\n  box-sizing: border-box;\n  width: 50%;\n}\n.ant-col-push-12 {\n  left: 50%;\n}\n.ant-col-pull-12 {\n  right: 50%;\n}\n.ant-col-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-order-12 {\n  order: 12;\n}\n.ant-col-11 {\n  display: block;\n  box-sizing: border-box;\n  width: 45.83333333%;\n}\n.ant-col-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-order-11 {\n  order: 11;\n}\n.ant-col-10 {\n  display: block;\n  box-sizing: border-box;\n  width: 41.66666667%;\n}\n.ant-col-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-order-10 {\n  order: 10;\n}\n.ant-col-9 {\n  display: block;\n  box-sizing: border-box;\n  width: 37.5%;\n}\n.ant-col-push-9 {\n  left: 37.5%;\n}\n.ant-col-pull-9 {\n  right: 37.5%;\n}\n.ant-col-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-order-9 {\n  order: 9;\n}\n.ant-col-8 {\n  display: block;\n  box-sizing: border-box;\n  width: 33.33333333%;\n}\n.ant-col-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-order-8 {\n  order: 8;\n}\n.ant-col-7 {\n  display: block;\n  box-sizing: border-box;\n  width: 29.16666667%;\n}\n.ant-col-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-order-7 {\n  order: 7;\n}\n.ant-col-6 {\n  display: block;\n  box-sizing: border-box;\n  width: 25%;\n}\n.ant-col-push-6 {\n  left: 25%;\n}\n.ant-col-pull-6 {\n  right: 25%;\n}\n.ant-col-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-order-6 {\n  order: 6;\n}\n.ant-col-5 {\n  display: block;\n  box-sizing: border-box;\n  width: 20.83333333%;\n}\n.ant-col-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-order-5 {\n  order: 5;\n}\n.ant-col-4 {\n  display: block;\n  box-sizing: border-box;\n  width: 16.66666667%;\n}\n.ant-col-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-order-4 {\n  order: 4;\n}\n.ant-col-3 {\n  display: block;\n  box-sizing: border-box;\n  width: 12.5%;\n}\n.ant-col-push-3 {\n  left: 12.5%;\n}\n.ant-col-pull-3 {\n  right: 12.5%;\n}\n.ant-col-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-order-3 {\n  order: 3;\n}\n.ant-col-2 {\n  display: block;\n  box-sizing: border-box;\n  width: 8.33333333%;\n}\n.ant-col-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-order-2 {\n  order: 2;\n}\n.ant-col-1 {\n  display: block;\n  box-sizing: border-box;\n  width: 4.16666667%;\n}\n.ant-col-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-order-1 {\n  order: 1;\n}\n.ant-col-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-offset-0 {\n  margin-left: 0;\n}\n.ant-col-order-0 {\n  order: 0;\n}\n.ant-col-xs-1, .ant-col-xs-2, .ant-col-xs-3, .ant-col-xs-4, .ant-col-xs-5, .ant-col-xs-6, .ant-col-xs-7, .ant-col-xs-8, .ant-col-xs-9, .ant-col-xs-10, .ant-col-xs-11, .ant-col-xs-12, .ant-col-xs-13, .ant-col-xs-14, .ant-col-xs-15, .ant-col-xs-16, .ant-col-xs-17, .ant-col-xs-18, .ant-col-xs-19, .ant-col-xs-20, .ant-col-xs-21, .ant-col-xs-22, .ant-col-xs-23, .ant-col-xs-24 {\n  flex: 0 0 auto;\n  float: left;\n}\n.ant-col-xs-24 {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n}\n.ant-col-xs-push-24 {\n  left: 100%;\n}\n.ant-col-xs-pull-24 {\n  right: 100%;\n}\n.ant-col-xs-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-xs-order-24 {\n  order: 24;\n}\n.ant-col-xs-23 {\n  display: block;\n  box-sizing: border-box;\n  width: 95.83333333%;\n}\n.ant-col-xs-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-xs-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-xs-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-xs-order-23 {\n  order: 23;\n}\n.ant-col-xs-22 {\n  display: block;\n  box-sizing: border-box;\n  width: 91.66666667%;\n}\n.ant-col-xs-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-xs-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-xs-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-xs-order-22 {\n  order: 22;\n}\n.ant-col-xs-21 {\n  display: block;\n  box-sizing: border-box;\n  width: 87.5%;\n}\n.ant-col-xs-push-21 {\n  left: 87.5%;\n}\n.ant-col-xs-pull-21 {\n  right: 87.5%;\n}\n.ant-col-xs-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-xs-order-21 {\n  order: 21;\n}\n.ant-col-xs-20 {\n  display: block;\n  box-sizing: border-box;\n  width: 83.33333333%;\n}\n.ant-col-xs-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-xs-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-xs-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-xs-order-20 {\n  order: 20;\n}\n.ant-col-xs-19 {\n  display: block;\n  box-sizing: border-box;\n  width: 79.16666667%;\n}\n.ant-col-xs-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-xs-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-xs-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-xs-order-19 {\n  order: 19;\n}\n.ant-col-xs-18 {\n  display: block;\n  box-sizing: border-box;\n  width: 75%;\n}\n.ant-col-xs-push-18 {\n  left: 75%;\n}\n.ant-col-xs-pull-18 {\n  right: 75%;\n}\n.ant-col-xs-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-xs-order-18 {\n  order: 18;\n}\n.ant-col-xs-17 {\n  display: block;\n  box-sizing: border-box;\n  width: 70.83333333%;\n}\n.ant-col-xs-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-xs-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-xs-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-xs-order-17 {\n  order: 17;\n}\n.ant-col-xs-16 {\n  display: block;\n  box-sizing: border-box;\n  width: 66.66666667%;\n}\n.ant-col-xs-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-xs-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-xs-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-xs-order-16 {\n  order: 16;\n}\n.ant-col-xs-15 {\n  display: block;\n  box-sizing: border-box;\n  width: 62.5%;\n}\n.ant-col-xs-push-15 {\n  left: 62.5%;\n}\n.ant-col-xs-pull-15 {\n  right: 62.5%;\n}\n.ant-col-xs-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-xs-order-15 {\n  order: 15;\n}\n.ant-col-xs-14 {\n  display: block;\n  box-sizing: border-box;\n  width: 58.33333333%;\n}\n.ant-col-xs-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-xs-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-xs-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-xs-order-14 {\n  order: 14;\n}\n.ant-col-xs-13 {\n  display: block;\n  box-sizing: border-box;\n  width: 54.16666667%;\n}\n.ant-col-xs-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-xs-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-xs-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-xs-order-13 {\n  order: 13;\n}\n.ant-col-xs-12 {\n  display: block;\n  box-sizing: border-box;\n  width: 50%;\n}\n.ant-col-xs-push-12 {\n  left: 50%;\n}\n.ant-col-xs-pull-12 {\n  right: 50%;\n}\n.ant-col-xs-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-xs-order-12 {\n  order: 12;\n}\n.ant-col-xs-11 {\n  display: block;\n  box-sizing: border-box;\n  width: 45.83333333%;\n}\n.ant-col-xs-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-xs-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-xs-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-xs-order-11 {\n  order: 11;\n}\n.ant-col-xs-10 {\n  display: block;\n  box-sizing: border-box;\n  width: 41.66666667%;\n}\n.ant-col-xs-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-xs-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-xs-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-xs-order-10 {\n  order: 10;\n}\n.ant-col-xs-9 {\n  display: block;\n  box-sizing: border-box;\n  width: 37.5%;\n}\n.ant-col-xs-push-9 {\n  left: 37.5%;\n}\n.ant-col-xs-pull-9 {\n  right: 37.5%;\n}\n.ant-col-xs-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-xs-order-9 {\n  order: 9;\n}\n.ant-col-xs-8 {\n  display: block;\n  box-sizing: border-box;\n  width: 33.33333333%;\n}\n.ant-col-xs-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-xs-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-xs-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-xs-order-8 {\n  order: 8;\n}\n.ant-col-xs-7 {\n  display: block;\n  box-sizing: border-box;\n  width: 29.16666667%;\n}\n.ant-col-xs-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-xs-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-xs-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-xs-order-7 {\n  order: 7;\n}\n.ant-col-xs-6 {\n  display: block;\n  box-sizing: border-box;\n  width: 25%;\n}\n.ant-col-xs-push-6 {\n  left: 25%;\n}\n.ant-col-xs-pull-6 {\n  right: 25%;\n}\n.ant-col-xs-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-xs-order-6 {\n  order: 6;\n}\n.ant-col-xs-5 {\n  display: block;\n  box-sizing: border-box;\n  width: 20.83333333%;\n}\n.ant-col-xs-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-xs-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-xs-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-xs-order-5 {\n  order: 5;\n}\n.ant-col-xs-4 {\n  display: block;\n  box-sizing: border-box;\n  width: 16.66666667%;\n}\n.ant-col-xs-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-xs-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-xs-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-xs-order-4 {\n  order: 4;\n}\n.ant-col-xs-3 {\n  display: block;\n  box-sizing: border-box;\n  width: 12.5%;\n}\n.ant-col-xs-push-3 {\n  left: 12.5%;\n}\n.ant-col-xs-pull-3 {\n  right: 12.5%;\n}\n.ant-col-xs-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-xs-order-3 {\n  order: 3;\n}\n.ant-col-xs-2 {\n  display: block;\n  box-sizing: border-box;\n  width: 8.33333333%;\n}\n.ant-col-xs-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-xs-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-xs-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-xs-order-2 {\n  order: 2;\n}\n.ant-col-xs-1 {\n  display: block;\n  box-sizing: border-box;\n  width: 4.16666667%;\n}\n.ant-col-xs-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-xs-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-xs-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-xs-order-1 {\n  order: 1;\n}\n.ant-col-xs-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-xs-push-0 {\n  left: auto;\n}\n.ant-col-xs-pull-0 {\n  right: auto;\n}\n.ant-col-xs-offset-0 {\n  margin-left: 0;\n}\n.ant-col-xs-order-0 {\n  order: 0;\n}\n@media (min-width: 576px) {\n  .ant-col-sm-1, .ant-col-sm-2, .ant-col-sm-3, .ant-col-sm-4, .ant-col-sm-5, .ant-col-sm-6, .ant-col-sm-7, .ant-col-sm-8, .ant-col-sm-9, .ant-col-sm-10, .ant-col-sm-11, .ant-col-sm-12, .ant-col-sm-13, .ant-col-sm-14, .ant-col-sm-15, .ant-col-sm-16, .ant-col-sm-17, .ant-col-sm-18, .ant-col-sm-19, .ant-col-sm-20, .ant-col-sm-21, .ant-col-sm-22, .ant-col-sm-23, .ant-col-sm-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-sm-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-sm-push-24 {\n    left: 100%;\n  }\n  .ant-col-sm-pull-24 {\n    right: 100%;\n  }\n  .ant-col-sm-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-sm-order-24 {\n    order: 24;\n  }\n  .ant-col-sm-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-sm-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-sm-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-sm-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-sm-order-23 {\n    order: 23;\n  }\n  .ant-col-sm-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-sm-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-sm-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-sm-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-sm-order-22 {\n    order: 22;\n  }\n  .ant-col-sm-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-sm-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-sm-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-sm-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-sm-order-21 {\n    order: 21;\n  }\n  .ant-col-sm-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-sm-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-sm-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-sm-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-sm-order-20 {\n    order: 20;\n  }\n  .ant-col-sm-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-sm-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-sm-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-sm-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-sm-order-19 {\n    order: 19;\n  }\n  .ant-col-sm-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-sm-push-18 {\n    left: 75%;\n  }\n  .ant-col-sm-pull-18 {\n    right: 75%;\n  }\n  .ant-col-sm-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-sm-order-18 {\n    order: 18;\n  }\n  .ant-col-sm-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-sm-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-sm-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-sm-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-sm-order-17 {\n    order: 17;\n  }\n  .ant-col-sm-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-sm-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-sm-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-sm-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-sm-order-16 {\n    order: 16;\n  }\n  .ant-col-sm-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-sm-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-sm-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-sm-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-sm-order-15 {\n    order: 15;\n  }\n  .ant-col-sm-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-sm-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-sm-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-sm-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-sm-order-14 {\n    order: 14;\n  }\n  .ant-col-sm-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-sm-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-sm-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-sm-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-sm-order-13 {\n    order: 13;\n  }\n  .ant-col-sm-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-sm-push-12 {\n    left: 50%;\n  }\n  .ant-col-sm-pull-12 {\n    right: 50%;\n  }\n  .ant-col-sm-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-sm-order-12 {\n    order: 12;\n  }\n  .ant-col-sm-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-sm-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-sm-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-sm-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-sm-order-11 {\n    order: 11;\n  }\n  .ant-col-sm-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-sm-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-sm-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-sm-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-sm-order-10 {\n    order: 10;\n  }\n  .ant-col-sm-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-sm-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-sm-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-sm-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-sm-order-9 {\n    order: 9;\n  }\n  .ant-col-sm-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-sm-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-sm-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-sm-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-sm-order-8 {\n    order: 8;\n  }\n  .ant-col-sm-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-sm-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-sm-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-sm-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-sm-order-7 {\n    order: 7;\n  }\n  .ant-col-sm-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-sm-push-6 {\n    left: 25%;\n  }\n  .ant-col-sm-pull-6 {\n    right: 25%;\n  }\n  .ant-col-sm-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-sm-order-6 {\n    order: 6;\n  }\n  .ant-col-sm-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-sm-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-sm-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-sm-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-sm-order-5 {\n    order: 5;\n  }\n  .ant-col-sm-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-sm-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-sm-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-sm-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-sm-order-4 {\n    order: 4;\n  }\n  .ant-col-sm-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-sm-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-sm-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-sm-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-sm-order-3 {\n    order: 3;\n  }\n  .ant-col-sm-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-sm-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-sm-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-sm-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-sm-order-2 {\n    order: 2;\n  }\n  .ant-col-sm-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-sm-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-sm-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-sm-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-sm-order-1 {\n    order: 1;\n  }\n  .ant-col-sm-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-push-0 {\n    left: auto;\n  }\n  .ant-col-sm-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-sm-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 768px) {\n  .ant-col-md-1, .ant-col-md-2, .ant-col-md-3, .ant-col-md-4, .ant-col-md-5, .ant-col-md-6, .ant-col-md-7, .ant-col-md-8, .ant-col-md-9, .ant-col-md-10, .ant-col-md-11, .ant-col-md-12, .ant-col-md-13, .ant-col-md-14, .ant-col-md-15, .ant-col-md-16, .ant-col-md-17, .ant-col-md-18, .ant-col-md-19, .ant-col-md-20, .ant-col-md-21, .ant-col-md-22, .ant-col-md-23, .ant-col-md-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-md-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-md-push-24 {\n    left: 100%;\n  }\n  .ant-col-md-pull-24 {\n    right: 100%;\n  }\n  .ant-col-md-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-md-order-24 {\n    order: 24;\n  }\n  .ant-col-md-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-md-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-md-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-md-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-md-order-23 {\n    order: 23;\n  }\n  .ant-col-md-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-md-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-md-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-md-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-md-order-22 {\n    order: 22;\n  }\n  .ant-col-md-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-md-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-md-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-md-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-md-order-21 {\n    order: 21;\n  }\n  .ant-col-md-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-md-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-md-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-md-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-md-order-20 {\n    order: 20;\n  }\n  .ant-col-md-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-md-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-md-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-md-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-md-order-19 {\n    order: 19;\n  }\n  .ant-col-md-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-md-push-18 {\n    left: 75%;\n  }\n  .ant-col-md-pull-18 {\n    right: 75%;\n  }\n  .ant-col-md-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-md-order-18 {\n    order: 18;\n  }\n  .ant-col-md-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-md-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-md-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-md-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-md-order-17 {\n    order: 17;\n  }\n  .ant-col-md-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-md-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-md-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-md-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-md-order-16 {\n    order: 16;\n  }\n  .ant-col-md-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-md-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-md-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-md-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-md-order-15 {\n    order: 15;\n  }\n  .ant-col-md-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-md-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-md-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-md-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-md-order-14 {\n    order: 14;\n  }\n  .ant-col-md-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-md-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-md-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-md-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-md-order-13 {\n    order: 13;\n  }\n  .ant-col-md-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-md-push-12 {\n    left: 50%;\n  }\n  .ant-col-md-pull-12 {\n    right: 50%;\n  }\n  .ant-col-md-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-md-order-12 {\n    order: 12;\n  }\n  .ant-col-md-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-md-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-md-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-md-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-md-order-11 {\n    order: 11;\n  }\n  .ant-col-md-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-md-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-md-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-md-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-md-order-10 {\n    order: 10;\n  }\n  .ant-col-md-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-md-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-md-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-md-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-md-order-9 {\n    order: 9;\n  }\n  .ant-col-md-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-md-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-md-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-md-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-md-order-8 {\n    order: 8;\n  }\n  .ant-col-md-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-md-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-md-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-md-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-md-order-7 {\n    order: 7;\n  }\n  .ant-col-md-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-md-push-6 {\n    left: 25%;\n  }\n  .ant-col-md-pull-6 {\n    right: 25%;\n  }\n  .ant-col-md-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-md-order-6 {\n    order: 6;\n  }\n  .ant-col-md-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-md-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-md-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-md-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-md-order-5 {\n    order: 5;\n  }\n  .ant-col-md-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-md-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-md-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-md-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-md-order-4 {\n    order: 4;\n  }\n  .ant-col-md-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-md-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-md-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-md-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-md-order-3 {\n    order: 3;\n  }\n  .ant-col-md-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-md-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-md-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-md-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-md-order-2 {\n    order: 2;\n  }\n  .ant-col-md-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-md-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-md-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-md-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-md-order-1 {\n    order: 1;\n  }\n  .ant-col-md-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-push-0 {\n    left: auto;\n  }\n  .ant-col-md-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-md-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 992px) {\n  .ant-col-lg-1, .ant-col-lg-2, .ant-col-lg-3, .ant-col-lg-4, .ant-col-lg-5, .ant-col-lg-6, .ant-col-lg-7, .ant-col-lg-8, .ant-col-lg-9, .ant-col-lg-10, .ant-col-lg-11, .ant-col-lg-12, .ant-col-lg-13, .ant-col-lg-14, .ant-col-lg-15, .ant-col-lg-16, .ant-col-lg-17, .ant-col-lg-18, .ant-col-lg-19, .ant-col-lg-20, .ant-col-lg-21, .ant-col-lg-22, .ant-col-lg-23, .ant-col-lg-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-lg-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-lg-push-24 {\n    left: 100%;\n  }\n  .ant-col-lg-pull-24 {\n    right: 100%;\n  }\n  .ant-col-lg-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-lg-order-24 {\n    order: 24;\n  }\n  .ant-col-lg-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-lg-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-lg-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-lg-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-lg-order-23 {\n    order: 23;\n  }\n  .ant-col-lg-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-lg-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-lg-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-lg-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-lg-order-22 {\n    order: 22;\n  }\n  .ant-col-lg-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-lg-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-lg-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-lg-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-lg-order-21 {\n    order: 21;\n  }\n  .ant-col-lg-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-lg-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-lg-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-lg-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-lg-order-20 {\n    order: 20;\n  }\n  .ant-col-lg-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-lg-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-lg-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-lg-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-lg-order-19 {\n    order: 19;\n  }\n  .ant-col-lg-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-lg-push-18 {\n    left: 75%;\n  }\n  .ant-col-lg-pull-18 {\n    right: 75%;\n  }\n  .ant-col-lg-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-lg-order-18 {\n    order: 18;\n  }\n  .ant-col-lg-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-lg-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-lg-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-lg-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-lg-order-17 {\n    order: 17;\n  }\n  .ant-col-lg-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-lg-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-lg-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-lg-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-lg-order-16 {\n    order: 16;\n  }\n  .ant-col-lg-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-lg-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-lg-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-lg-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-lg-order-15 {\n    order: 15;\n  }\n  .ant-col-lg-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-lg-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-lg-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-lg-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-lg-order-14 {\n    order: 14;\n  }\n  .ant-col-lg-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-lg-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-lg-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-lg-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-lg-order-13 {\n    order: 13;\n  }\n  .ant-col-lg-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-lg-push-12 {\n    left: 50%;\n  }\n  .ant-col-lg-pull-12 {\n    right: 50%;\n  }\n  .ant-col-lg-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-lg-order-12 {\n    order: 12;\n  }\n  .ant-col-lg-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-lg-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-lg-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-lg-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-lg-order-11 {\n    order: 11;\n  }\n  .ant-col-lg-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-lg-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-lg-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-lg-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-lg-order-10 {\n    order: 10;\n  }\n  .ant-col-lg-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-lg-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-lg-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-lg-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-lg-order-9 {\n    order: 9;\n  }\n  .ant-col-lg-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-lg-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-lg-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-lg-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-lg-order-8 {\n    order: 8;\n  }\n  .ant-col-lg-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-lg-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-lg-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-lg-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-lg-order-7 {\n    order: 7;\n  }\n  .ant-col-lg-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-lg-push-6 {\n    left: 25%;\n  }\n  .ant-col-lg-pull-6 {\n    right: 25%;\n  }\n  .ant-col-lg-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-lg-order-6 {\n    order: 6;\n  }\n  .ant-col-lg-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-lg-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-lg-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-lg-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-lg-order-5 {\n    order: 5;\n  }\n  .ant-col-lg-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-lg-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-lg-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-lg-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-lg-order-4 {\n    order: 4;\n  }\n  .ant-col-lg-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-lg-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-lg-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-lg-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-lg-order-3 {\n    order: 3;\n  }\n  .ant-col-lg-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-lg-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-lg-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-lg-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-lg-order-2 {\n    order: 2;\n  }\n  .ant-col-lg-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-lg-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-lg-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-lg-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-lg-order-1 {\n    order: 1;\n  }\n  .ant-col-lg-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-push-0 {\n    left: auto;\n  }\n  .ant-col-lg-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-lg-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .ant-col-xl-1, .ant-col-xl-2, .ant-col-xl-3, .ant-col-xl-4, .ant-col-xl-5, .ant-col-xl-6, .ant-col-xl-7, .ant-col-xl-8, .ant-col-xl-9, .ant-col-xl-10, .ant-col-xl-11, .ant-col-xl-12, .ant-col-xl-13, .ant-col-xl-14, .ant-col-xl-15, .ant-col-xl-16, .ant-col-xl-17, .ant-col-xl-18, .ant-col-xl-19, .ant-col-xl-20, .ant-col-xl-21, .ant-col-xl-22, .ant-col-xl-23, .ant-col-xl-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-xl-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-xl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xl-order-24 {\n    order: 24;\n  }\n  .ant-col-xl-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-xl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xl-order-23 {\n    order: 23;\n  }\n  .ant-col-xl-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-xl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xl-order-22 {\n    order: 22;\n  }\n  .ant-col-xl-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-xl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xl-order-21 {\n    order: 21;\n  }\n  .ant-col-xl-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-xl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xl-order-20 {\n    order: 20;\n  }\n  .ant-col-xl-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-xl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xl-order-19 {\n    order: 19;\n  }\n  .ant-col-xl-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-xl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xl-order-18 {\n    order: 18;\n  }\n  .ant-col-xl-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-xl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xl-order-17 {\n    order: 17;\n  }\n  .ant-col-xl-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-xl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xl-order-16 {\n    order: 16;\n  }\n  .ant-col-xl-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-xl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xl-order-15 {\n    order: 15;\n  }\n  .ant-col-xl-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-xl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xl-order-14 {\n    order: 14;\n  }\n  .ant-col-xl-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-xl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xl-order-13 {\n    order: 13;\n  }\n  .ant-col-xl-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-xl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xl-order-12 {\n    order: 12;\n  }\n  .ant-col-xl-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-xl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xl-order-11 {\n    order: 11;\n  }\n  .ant-col-xl-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-xl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xl-order-10 {\n    order: 10;\n  }\n  .ant-col-xl-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-xl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xl-order-9 {\n    order: 9;\n  }\n  .ant-col-xl-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-xl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xl-order-8 {\n    order: 8;\n  }\n  .ant-col-xl-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-xl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xl-order-7 {\n    order: 7;\n  }\n  .ant-col-xl-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-xl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xl-order-6 {\n    order: 6;\n  }\n  .ant-col-xl-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-xl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xl-order-5 {\n    order: 5;\n  }\n  .ant-col-xl-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-xl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xl-order-4 {\n    order: 4;\n  }\n  .ant-col-xl-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-xl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xl-order-3 {\n    order: 3;\n  }\n  .ant-col-xl-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-xl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xl-order-2 {\n    order: 2;\n  }\n  .ant-col-xl-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-xl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xl-order-1 {\n    order: 1;\n  }\n  .ant-col-xl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-push-0 {\n    left: auto;\n  }\n  .ant-col-xl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xl-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1600px) {\n  .ant-col-xxl-1, .ant-col-xxl-2, .ant-col-xxl-3, .ant-col-xxl-4, .ant-col-xxl-5, .ant-col-xxl-6, .ant-col-xxl-7, .ant-col-xxl-8, .ant-col-xxl-9, .ant-col-xxl-10, .ant-col-xxl-11, .ant-col-xxl-12, .ant-col-xxl-13, .ant-col-xxl-14, .ant-col-xxl-15, .ant-col-xxl-16, .ant-col-xxl-17, .ant-col-xxl-18, .ant-col-xxl-19, .ant-col-xxl-20, .ant-col-xxl-21, .ant-col-xxl-22, .ant-col-xxl-23, .ant-col-xxl-24 {\n    flex: 0 0 auto;\n    float: left;\n  }\n  .ant-col-xxl-24 {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n  }\n  .ant-col-xxl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xxl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xxl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xxl-order-24 {\n    order: 24;\n  }\n  .ant-col-xxl-23 {\n    display: block;\n    box-sizing: border-box;\n    width: 95.83333333%;\n  }\n  .ant-col-xxl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xxl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xxl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xxl-order-23 {\n    order: 23;\n  }\n  .ant-col-xxl-22 {\n    display: block;\n    box-sizing: border-box;\n    width: 91.66666667%;\n  }\n  .ant-col-xxl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xxl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xxl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xxl-order-22 {\n    order: 22;\n  }\n  .ant-col-xxl-21 {\n    display: block;\n    box-sizing: border-box;\n    width: 87.5%;\n  }\n  .ant-col-xxl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xxl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xxl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xxl-order-21 {\n    order: 21;\n  }\n  .ant-col-xxl-20 {\n    display: block;\n    box-sizing: border-box;\n    width: 83.33333333%;\n  }\n  .ant-col-xxl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xxl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xxl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xxl-order-20 {\n    order: 20;\n  }\n  .ant-col-xxl-19 {\n    display: block;\n    box-sizing: border-box;\n    width: 79.16666667%;\n  }\n  .ant-col-xxl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xxl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xxl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xxl-order-19 {\n    order: 19;\n  }\n  .ant-col-xxl-18 {\n    display: block;\n    box-sizing: border-box;\n    width: 75%;\n  }\n  .ant-col-xxl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xxl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xxl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xxl-order-18 {\n    order: 18;\n  }\n  .ant-col-xxl-17 {\n    display: block;\n    box-sizing: border-box;\n    width: 70.83333333%;\n  }\n  .ant-col-xxl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xxl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xxl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xxl-order-17 {\n    order: 17;\n  }\n  .ant-col-xxl-16 {\n    display: block;\n    box-sizing: border-box;\n    width: 66.66666667%;\n  }\n  .ant-col-xxl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xxl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xxl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xxl-order-16 {\n    order: 16;\n  }\n  .ant-col-xxl-15 {\n    display: block;\n    box-sizing: border-box;\n    width: 62.5%;\n  }\n  .ant-col-xxl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xxl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xxl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xxl-order-15 {\n    order: 15;\n  }\n  .ant-col-xxl-14 {\n    display: block;\n    box-sizing: border-box;\n    width: 58.33333333%;\n  }\n  .ant-col-xxl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xxl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xxl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xxl-order-14 {\n    order: 14;\n  }\n  .ant-col-xxl-13 {\n    display: block;\n    box-sizing: border-box;\n    width: 54.16666667%;\n  }\n  .ant-col-xxl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xxl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xxl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xxl-order-13 {\n    order: 13;\n  }\n  .ant-col-xxl-12 {\n    display: block;\n    box-sizing: border-box;\n    width: 50%;\n  }\n  .ant-col-xxl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xxl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xxl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xxl-order-12 {\n    order: 12;\n  }\n  .ant-col-xxl-11 {\n    display: block;\n    box-sizing: border-box;\n    width: 45.83333333%;\n  }\n  .ant-col-xxl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xxl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xxl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xxl-order-11 {\n    order: 11;\n  }\n  .ant-col-xxl-10 {\n    display: block;\n    box-sizing: border-box;\n    width: 41.66666667%;\n  }\n  .ant-col-xxl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xxl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xxl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xxl-order-10 {\n    order: 10;\n  }\n  .ant-col-xxl-9 {\n    display: block;\n    box-sizing: border-box;\n    width: 37.5%;\n  }\n  .ant-col-xxl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xxl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xxl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xxl-order-9 {\n    order: 9;\n  }\n  .ant-col-xxl-8 {\n    display: block;\n    box-sizing: border-box;\n    width: 33.33333333%;\n  }\n  .ant-col-xxl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xxl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xxl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xxl-order-8 {\n    order: 8;\n  }\n  .ant-col-xxl-7 {\n    display: block;\n    box-sizing: border-box;\n    width: 29.16666667%;\n  }\n  .ant-col-xxl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xxl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xxl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xxl-order-7 {\n    order: 7;\n  }\n  .ant-col-xxl-6 {\n    display: block;\n    box-sizing: border-box;\n    width: 25%;\n  }\n  .ant-col-xxl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xxl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xxl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xxl-order-6 {\n    order: 6;\n  }\n  .ant-col-xxl-5 {\n    display: block;\n    box-sizing: border-box;\n    width: 20.83333333%;\n  }\n  .ant-col-xxl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xxl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xxl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xxl-order-5 {\n    order: 5;\n  }\n  .ant-col-xxl-4 {\n    display: block;\n    box-sizing: border-box;\n    width: 16.66666667%;\n  }\n  .ant-col-xxl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xxl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xxl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xxl-order-4 {\n    order: 4;\n  }\n  .ant-col-xxl-3 {\n    display: block;\n    box-sizing: border-box;\n    width: 12.5%;\n  }\n  .ant-col-xxl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xxl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xxl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xxl-order-3 {\n    order: 3;\n  }\n  .ant-col-xxl-2 {\n    display: block;\n    box-sizing: border-box;\n    width: 8.33333333%;\n  }\n  .ant-col-xxl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xxl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xxl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xxl-order-2 {\n    order: 2;\n  }\n  .ant-col-xxl-1 {\n    display: block;\n    box-sizing: border-box;\n    width: 4.16666667%;\n  }\n  .ant-col-xxl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xxl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xxl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xxl-order-1 {\n    order: 1;\n  }\n  .ant-col-xxl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-push-0 {\n    left: auto;\n  }\n  .ant-col-xxl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xxl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xxl-order-0 {\n    order: 0;\n  }\n}\n.ant-input {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-input:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-input-group[class*='col-'] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.ant-input-group > [class*='col-'] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*='col-']:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n  text-align: inherit;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-group .ant-input:hover {\n  z-index: 1;\n  border-right-width: 1px;\n}\n.ant-input-group-addon {\n  position: relative;\n  padding: 0 11px;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  text-align: center;\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -5px -11px;\n}\n.ant-input-group-addon .ant-select .ant-select-selection {\n  margin: -1px;\n  background-color: inherit;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selection,\n.ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #2EB1EF;\n}\n.ant-input-group-addon > i:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  content: '';\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,\n.ant-input-group-addon:first-child .ant-select .ant-select-selection {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,\n.ant-input-group-addon:last-child .ant-select .ant-select-selection {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-group-lg .ant-select-selection--single {\n  height: 40px;\n}\n.ant-input-group-sm .ant-select-selection--single {\n  height: 24px;\n}\n.ant-input-group .ant-input-affix-wrapper {\n  display: table-cell;\n  float: left;\n  width: 100%;\n}\n.ant-input-group.ant-input-group-compact {\n  display: block;\n  zoom: 1;\n}\n.ant-input-group.ant-input-group-compact::before,\n.ant-input-group.ant-input-group-compact::after {\n  display: table;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::after {\n  clear: both;\n}\n.ant-input-group.ant-input-group-compact::before,\n.ant-input-group.ant-input-group-compact::after {\n  display: table;\n  content: '';\n}\n.ant-input-group.ant-input-group-compact::after {\n  clear: both;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child),\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child) {\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,\n.ant-input-group.ant-input-group-compact > .ant-input:not(:first-child):not(:last-child):focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > * {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > *:not(:last-child) {\n  margin-right: -1px;\n  border-right-width: 1px;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input {\n  border-right-width: 1px;\n  border-radius: 0;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:hover,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:hover,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:hover,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:hover {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection:focus,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor:focus,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input:focus,\n.ant-input-group.ant-input-group-compact > .ant-input-group-wrapper .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker-focused:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {\n  border-right-width: 1px;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input {\n  vertical-align: top;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n  vertical-align: top;\n}\n.ant-input-affix-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n}\n.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-input-affix-wrapper .ant-input {\n  position: relative;\n  text-align: inherit;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  color: #545454;\n  line-height: 0;\n  transform: translateY(-50%);\n}\n.ant-input-affix-wrapper .ant-input-prefix :not(.anticon),\n.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {\n  line-height: 1.3;\n}\n.ant-input-affix-wrapper .ant-input-disabled ~ .ant-input-suffix .anticon {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  left: 12px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  right: 12px;\n}\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 30px;\n}\n.ant-input-affix-wrapper .ant-input:not(:last-child) {\n  padding-right: 30px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn .ant-input:not(:last-child) {\n  padding-right: 49px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input {\n  padding-right: 22px;\n}\n.ant-input-affix-wrapper .ant-input {\n  min-height: 100%;\n}\n.ant-input-password-icon {\n  color: #595959;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-input-password-icon:hover {\n  color: #333;\n}\n.ant-input-clear-icon {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  vertical-align: 0;\n}\n.ant-input-clear-icon:hover {\n  color: #595959;\n}\n.ant-input-clear-icon:active {\n  color: #545454;\n}\n.ant-input-clear-icon + i {\n  margin-left: 6px;\n}\n.ant-input-textarea-clear-icon {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 8px 8px 0 0;\n}\n.ant-input-textarea-clear-icon:hover {\n  color: #595959;\n}\n.ant-input-textarea-clear-icon:active {\n  color: #545454;\n}\n.ant-input-textarea-clear-icon + i {\n  margin-left: 6px;\n}\n.ant-input-search-icon {\n  color: #595959;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-input-search-icon:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n.ant-input-search-enter-button input {\n  border-right: 0;\n}\n.ant-input-search-enter-button + .ant-input-group-addon,\n.ant-input-search-enter-button input + .ant-input-group-addon {\n  padding: 0;\n  border: 0;\n}\n.ant-input-search-enter-button + .ant-input-group-addon .ant-input-search-button,\n.ant-input-search-enter-button input + .ant-input-group-addon .ant-input-search-button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-input-number {\n  box-sizing: border-box;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  transition: all 0.3s;\n  display: inline-block;\n  width: 90px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-input-number::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input-number:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-input-number:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-input-number-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input-number[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-input-number {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-input-number-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-input-number-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-input-number-handler {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 50%;\n  overflow: hidden;\n  color: #595959;\n  font-weight: bold;\n  line-height: 0;\n  text-align: center;\n  transition: all 0.1s linear;\n}\n.ant-input-number-handler:active {\n  background: #f4f4f4;\n}\n.ant-input-number-handler:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler:hover .ant-input-number-handler-down-inner {\n  color: #58cefc;\n}\n.ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-inner {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 4px;\n  width: 12px;\n  height: 12px;\n  color: #595959;\n  line-height: 12px;\n  transition: all 0.1s linear;\n  user-select: none;\n}\n.ant-input-number-handler-up-inner > *,\n.ant-input-number-handler-down-inner > * {\n  line-height: 1;\n}\n.ant-input-number-handler-up-inner svg,\n.ant-input-number-handler-down-inner svg {\n  display: inline-block;\n}\n.ant-input-number-handler-up-inner::before,\n.ant-input-number-handler-down-inner::before {\n  display: none;\n}\n.ant-input-number-handler-up-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-up-inner .ant-input-number-handler-down-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-up-inner-icon,\n.ant-input-number-handler-down-inner .ant-input-number-handler-down-inner-icon {\n  display: block;\n}\n.ant-input-number:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-input-number-focused {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-input-number-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-input-number-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-input-number-disabled .ant-input-number-input {\n  cursor: not-allowed;\n}\n.ant-input-number-disabled .ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-input-number-input {\n  width: 100%;\n  height: 34px;\n  padding: 0 11px;\n  text-align: left;\n  background-color: transparent;\n  border: 0;\n  border-radius: 6px;\n  outline: 0;\n  transition: all 0.3s linear;\n  -moz-appearance: textfield !important;\n}\n.ant-input-number-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-input-number-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-input-number-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-input-number-input[type='number']::-webkit-inner-spin-button,\n.ant-input-number-input[type='number']::-webkit-outer-spin-button {\n  margin: 0;\n  -webkit-appearance: none;\n}\n.ant-input-number-lg {\n  padding: 0;\n  font-size: 16px;\n}\n.ant-input-number-lg input {\n  height: 38px;\n}\n.ant-input-number-sm {\n  padding: 0;\n}\n.ant-input-number-sm input {\n  height: 22px;\n  padding: 0 7px;\n}\n.ant-input-number-handler-wrap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 22px;\n  height: 100%;\n  background: #fff;\n  border-left: 1px solid #d9d9d9;\n  border-radius: 0 6px 6px 0;\n  opacity: 0;\n  transition: opacity 0.24s linear 0.1s;\n}\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,\n.ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 7px \\9;\n  transform: scale(0.58333333) rotate(0deg);\n  min-width: auto;\n  margin-right: 0;\n}\n:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-up-inner,\n:root .ant-input-number-handler-wrap .ant-input-number-handler .ant-input-number-handler-down-inner {\n  font-size: 12px;\n}\n.ant-input-number-handler-wrap:hover .ant-input-number-handler {\n  height: 40%;\n}\n.ant-input-number:hover .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n.ant-input-number-handler-up {\n  border-top-right-radius: 6px;\n  cursor: pointer;\n}\n.ant-input-number-handler-up-inner {\n  top: 50%;\n  margin-top: -5px;\n  text-align: center;\n}\n.ant-input-number-handler-up:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-down {\n  top: 0;\n  border-top: 1px solid #d9d9d9;\n  border-bottom-right-radius: 6px;\n  cursor: pointer;\n}\n.ant-input-number-handler-down-inner {\n  top: 50%;\n  margin-top: -6px;\n  text-align: center;\n}\n.ant-input-number-handler-down:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-up-disabled,\n.ant-input-number-handler-down-disabled {\n  cursor: not-allowed;\n}\n.ant-input-number-handler-up-disabled:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-disabled:hover .ant-input-number-handler-down-inner {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-layout {\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n  background: #f5f5f5;\n}\n.ant-layout,\n.ant-layout * {\n  box-sizing: border-box;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout,\n.ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: hidden;\n}\n.ant-layout-header,\n.ant-layout-footer {\n  flex: 0 0 auto;\n}\n.ant-layout-header {\n  height: 72px;\n  padding: 0 32px;\n  line-height: 72px;\n  background: #fefefe;\n}\n.ant-layout-footer {\n  padding: 14px 32px;\n  color: #545454;\n  font-size: 14px;\n  background: #fffffe;\n}\n.ant-layout-content {\n  flex: auto;\n  /* fix firefox can't set height smaller than content on flex item */\n  min-height: 0;\n}\n.ant-layout-sider {\n  position: relative;\n  /* fix firefox can't set width smaller than content on flex item */\n  min-width: 0;\n  background: #003366;\n  transition: all 0.2s;\n}\n.ant-layout-sider-children {\n  height: 100%;\n  margin-top: -0.1px;\n  padding-top: 0.1px;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 30px;\n}\n.ant-layout-sider-right {\n  order: 1;\n}\n.ant-layout-sider-trigger {\n  position: fixed;\n  bottom: 0;\n  z-index: 1;\n  height: 30px;\n  color: #ffffff;\n  line-height: 30px;\n  text-align: center;\n  background: #002140;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.ant-layout-sider-zero-width > * {\n  overflow: hidden;\n}\n.ant-layout-sider-zero-width-trigger {\n  position: absolute;\n  top: 72px;\n  right: -36px;\n  z-index: 1;\n  width: 36px;\n  height: 28px;\n  color: #ffffff;\n  font-size: 18px;\n  line-height: 28px;\n  text-align: center;\n  background: #003366;\n  border-radius: 0 6px 6px 0;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-layout-sider-zero-width-trigger:hover {\n  background: #194775;\n}\n.ant-layout-sider-zero-width-trigger-right {\n  left: -36px;\n  border-radius: 6px 0 0 6px;\n}\n.ant-layout-sider-light {\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-trigger {\n  color: #545454;\n  background: #fff;\n}\n.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {\n  color: #545454;\n  background: #fff;\n}\n.ant-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n}\n.ant-list * {\n  outline: none;\n}\n.ant-list-pagination {\n  margin-top: 24px;\n  text-align: right;\n}\n.ant-list-pagination .ant-pagination-options {\n  text-align: left;\n}\n.ant-list-more {\n  margin-top: 12px;\n  text-align: center;\n}\n.ant-list-more button {\n  padding-right: 32px;\n  padding-left: 32px;\n}\n.ant-list-spin {\n  min-height: 40px;\n  text-align: center;\n}\n.ant-list-empty-text {\n  padding: 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  text-align: center;\n}\n.ant-list-items {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n.ant-list-item-content {\n  color: #545454;\n}\n.ant-list-item-meta {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  font-size: 0;\n}\n.ant-list-item-meta-avatar {\n  margin-right: 16px;\n}\n.ant-list-item-meta-content {\n  flex: 1 0;\n}\n.ant-list-item-meta-title {\n  margin-bottom: 4px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-list-item-meta-title > a {\n  color: #545454;\n  transition: all 0.3s;\n}\n.ant-list-item-meta-title > a:hover {\n  color: #2EB1EF;\n}\n.ant-list-item-meta-description {\n  color: #595959;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-list-item-action {\n  flex: 0 0 auto;\n  margin-left: 48px;\n  padding: 0;\n  font-size: 0;\n  list-style: none;\n}\n.ant-list-item-action > li {\n  position: relative;\n  display: inline-block;\n  padding: 0 8px;\n  color: #595959;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  cursor: pointer;\n}\n.ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-item-action-split {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 1px;\n  height: 14px;\n  margin-top: -7px;\n  background-color: #e8e8e8;\n}\n.ant-list-header {\n  background: transparent;\n}\n.ant-list-footer {\n  background: transparent;\n}\n.ant-list-header,\n.ant-list-footer {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ant-list-empty {\n  padding: 16px 0;\n  color: #595959;\n  font-size: 12px;\n  text-align: center;\n}\n.ant-list-split .ant-list-item {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-split .ant-list-item:last-child {\n  border-bottom: none;\n}\n.ant-list-split .ant-list-header {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-loading .ant-list-spin-nested-loading {\n  min-height: 32px;\n}\n.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-lg .ant-list-item {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.ant-list-sm .ant-list-item {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.ant-list-vertical .ant-list-item {\n  align-items: initial;\n}\n.ant-list-vertical .ant-list-item-main {\n  display: block;\n  flex: 1;\n}\n.ant-list-vertical .ant-list-item-extra {\n  margin-left: 40px;\n}\n.ant-list-vertical .ant-list-item-meta {\n  margin-bottom: 16px;\n}\n.ant-list-vertical .ant-list-item-meta-title {\n  margin-bottom: 12px;\n  color: #535353;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-list-vertical .ant-list-item-action {\n  margin-top: 16px;\n  margin-left: auto;\n}\n.ant-list-vertical .ant-list-item-action > li {\n  padding: 0 16px;\n}\n.ant-list-vertical .ant-list-item-action > li:first-child {\n  padding-left: 0;\n}\n.ant-list-grid .ant-col > .ant-list-item {\n  display: block;\n  max-width: 100%;\n  margin-bottom: 16px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.ant-list-item-no-flex {\n  display: block;\n}\n.ant-list:not(.ant-list-vertical) .ant-list-item-no-flex .ant-list-item-action {\n  float: right;\n}\n.ant-list-bordered {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-list-bordered .ant-list-header {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-footer {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.ant-list-bordered .ant-list-item {\n  padding-right: 24px;\n  padding-left: 24px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-list-bordered .ant-list-pagination {\n  margin: 16px 24px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-item {\n  padding-right: 16px;\n  padding-left: 16px;\n}\n.ant-list-bordered.ant-list-sm .ant-list-header,\n.ant-list-bordered.ant-list-sm .ant-list-footer {\n  padding: 8px 16px;\n}\n.ant-list-bordered.ant-list-lg .ant-list-header,\n.ant-list-bordered.ant-list-lg .ant-list-footer {\n  padding: 16px 24px;\n}\n@media screen and (max-width: 768px) {\n  .ant-list-item-action {\n    margin-left: 24px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin-left: 24px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .ant-list-item {\n    flex-wrap: wrap;\n  }\n  .ant-list-item-action {\n    margin-left: 12px;\n  }\n  .ant-list-vertical .ant-list-item {\n    flex-wrap: wrap-reverse;\n  }\n  .ant-list-vertical .ant-list-item-main {\n    min-width: 220px;\n  }\n  .ant-list-vertical .ant-list-item-extra {\n    margin: auto auto 16px;\n  }\n}\n.ant-mentions-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  vertical-align: middle;\n}\n.ant-mentions-wrapper .ant-mentions-editor {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  display: block;\n  height: auto;\n  min-height: 36px;\n  padding: 0;\n  line-height: 1.3;\n}\n.ant-mentions-wrapper .ant-mentions-editor::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-mentions-wrapper .ant-mentions-editor:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions-wrapper .ant-mentions-editor::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions-wrapper .ant-mentions-editor:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-mentions-wrapper .ant-mentions-editor:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-mentions-wrapper .ant-mentions-editor:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-mentions-wrapper .ant-mentions-editor-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-wrapper .ant-mentions-editor-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-mentions-wrapper .ant-mentions-editor[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-wrapper .ant-mentions-editor[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-mentions-wrapper .ant-mentions-editor {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-mentions-wrapper .ant-mentions-editor-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-mentions-wrapper .ant-mentions-editor-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-mentions-wrapper .ant-mentions-editor-wrapper {\n  height: auto;\n  overflow-y: auto;\n}\n.ant-mentions-wrapper.ant-mentions-active:not(.disabled) .ant-mentions-editor {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-mentions-wrapper.disabled .ant-mentions-editor {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-wrapper.disabled .ant-mentions-editor:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-mentions-wrapper .public-DraftEditorPlaceholder-root {\n  position: absolute;\n  pointer-events: none;\n}\n.ant-mentions-wrapper .public-DraftEditorPlaceholder-root .public-DraftEditorPlaceholder-inner {\n  height: auto;\n  padding: 5px 11px;\n  color: #bfbfbf;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  outline: none;\n  opacity: 1;\n}\n.ant-mentions-wrapper .DraftEditor-editorContainer .public-DraftEditor-content {\n  height: auto;\n  padding: 5px 11px;\n}\n.ant-mentions-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  min-width: 120px;\n  max-height: 250px;\n  margin-top: 1.5em;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-mentions-dropdown-placement-top {\n  margin-top: -0.1em;\n}\n.ant-mentions-dropdown-notfound.ant-mentions-dropdown-item {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-mentions-dropdown-notfound.ant-mentions-dropdown-item .anticon-loading {\n  display: block;\n  color: #2EB1EF;\n  text-align: center;\n}\n.ant-mentions-dropdown-item {\n  position: relative;\n  display: block;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #545454;\n  font-weight: normal;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n.ant-mentions-dropdown-item:hover {\n  background-color: #f0fdff;\n}\n.ant-mentions-dropdown-item.focus,\n.ant-mentions-dropdown-item-active {\n  background-color: #f0fdff;\n}\n.ant-mentions-dropdown-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-item-selected,\n.ant-mentions-dropdown-item-selected:hover {\n  color: #545454;\n  font-weight: bold;\n  background-color: #f5f5f5;\n}\n.ant-mentions-dropdown-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-mentions {\n  box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  position: relative;\n  display: inline-block;\n  height: auto;\n  padding: 0;\n  overflow: hidden;\n  line-height: 1.3;\n  white-space: pre-wrap;\n  vertical-align: bottom;\n}\n.ant-mentions::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-mentions:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-mentions:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-mentions:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-mentions-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-mentions[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-mentions {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-mentions-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-mentions-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-mentions-disabled > textarea {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-mentions-disabled > textarea:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-mentions-focused {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-mentions > textarea,\n.ant-mentions-measure {\n  min-height: 34px;\n  margin: 0;\n  padding: 4px 11px;\n  overflow: inherit;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-weight: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  font-style: inherit;\n  font-variant: inherit;\n  font-size-adjust: inherit;\n  font-stretch: inherit;\n  line-height: inherit;\n  direction: inherit;\n  letter-spacing: inherit;\n  white-space: inherit;\n  text-align: inherit;\n  vertical-align: top;\n  word-wrap: break-word;\n  word-break: inherit;\n  tab-size: inherit;\n}\n.ant-mentions > textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: none;\n}\n.ant-mentions > textarea::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-mentions > textarea:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions > textarea::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-mentions > textarea:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-mentions > textarea:read-only {\n  cursor: default;\n}\n.ant-mentions-measure {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  color: transparent;\n  pointer-events: none;\n}\n.ant-mentions-measure > span {\n  display: inline-block;\n  min-height: 1em;\n}\n.ant-mentions-dropdown {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-variant: initial;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-mentions-dropdown-hidden {\n  display: none;\n}\n.ant-mentions-dropdown-menu {\n  max-height: 250px;\n  margin-bottom: 0;\n  padding-left: 0;\n  overflow: auto;\n  list-style: none;\n  outline: none;\n}\n.ant-mentions-dropdown-menu-item {\n  position: relative;\n  display: block;\n  min-width: 100px;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #545454;\n  font-weight: normal;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-mentions-dropdown-menu-item:hover {\n  background-color: #f0fdff;\n}\n.ant-mentions-dropdown-menu-item:first-child {\n  border-radius: 6px 6px 0 0;\n}\n.ant-mentions-dropdown-menu-item:last-child {\n  border-radius: 0 0 6px 6px;\n}\n.ant-mentions-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-mentions-dropdown-menu-item-selected {\n  color: #545454;\n  font-weight: 600;\n  background-color: #fafafa;\n}\n.ant-mentions-dropdown-menu-item-active {\n  background-color: #f0fdff;\n}\n.ant-menu {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  margin-bottom: 0;\n  padding-left: 0;\n  color: #545454;\n  line-height: 0;\n  list-style: none;\n  background: #fff;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  transition: background 0.3s, width 0.2s;\n  zoom: 1;\n}\n.ant-menu::before,\n.ant-menu::after {\n  display: table;\n  content: '';\n}\n.ant-menu::after {\n  clear: both;\n}\n.ant-menu::before,\n.ant-menu::after {\n  display: table;\n  content: '';\n}\n.ant-menu::after {\n  clear: both;\n}\n.ant-menu ul,\n.ant-menu ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-menu-hidden {\n  display: none;\n}\n.ant-menu-item-group-title {\n  padding: 8px 16px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1.3;\n  transition: all 0.3s;\n}\n.ant-menu-submenu,\n.ant-menu-submenu-inline {\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-selected {\n  color: #2EB1EF;\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #f0fdff;\n}\n.ant-menu-submenu .ant-menu-sub {\n  cursor: initial;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item > a {\n  display: block;\n  color: #545454;\n}\n.ant-menu-item > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu-item > a::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: transparent;\n  content: '';\n}\n.ant-menu-item > .ant-badge > a {\n  color: #545454;\n}\n.ant-menu-item > .ant-badge > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu-item-divider {\n  height: 1px;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-menu-item:hover,\n.ant-menu-item-active,\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-submenu-active,\n.ant-menu-submenu-title:hover {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal .ant-menu-item,\n.ant-menu-horizontal .ant-menu-submenu {\n  margin-top: -1px;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: #2EB1EF;\n}\n.ant-menu-item-selected > a,\n.ant-menu-item-selected > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #f0fdff;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-menu-vertical-right {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-vertical.ant-menu-sub,\n.ant-menu-vertical-left.ant-menu-sub,\n.ant-menu-vertical-right.ant-menu-sub {\n  min-width: 160px;\n  padding: 0;\n  border-right: 0;\n  transform-origin: 0 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,\n.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,\n.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {\n  transform-origin: 0 0;\n}\n.ant-menu-horizontal.ant-menu-sub {\n  min-width: 114px;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0 20px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  min-width: 14px;\n  margin-right: 10px;\n  font-size: 14px;\n  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .anticon + span,\n.ant-menu-submenu-title .anticon + span {\n  opacity: 1;\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu > .ant-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  padding: 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-menu-submenu-popup {\n  position: absolute;\n  z-index: 1050;\n  background: #fff;\n  border-radius: 6px;\n}\n.ant-menu-submenu-popup .submenu-title-wrapper {\n  padding-right: 20px;\n}\n.ant-menu-submenu-popup::before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.0001;\n  content: ' ';\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: #fff;\n  border-radius: 6px;\n}\n.ant-menu-submenu > .ant-menu-submenu-title::after {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  width: 10px;\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  position: absolute;\n  width: 6px;\n  height: 1.5px;\n  background: #fff;\n  background: #545454 \\9;\n  background-image: linear-gradient(to right, #545454, #545454);\n  background-image: none \\9;\n  border-radius: 2px;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  content: '';\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateY(-2px);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateY(2px);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {\n  background: linear-gradient(to right, #2EB1EF, #2EB1EF);\n}\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(-45deg) translateX(2px);\n}\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(45deg) translateX(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  transform: translateY(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  transform: rotate(-45deg) translateX(-2px);\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  transform: rotate(45deg) translateX(2px);\n}\n.ant-menu-vertical .ant-menu-submenu-selected,\n.ant-menu-vertical-left .ant-menu-submenu-selected,\n.ant-menu-vertical-right .ant-menu-submenu-selected {\n  color: #2EB1EF;\n}\n.ant-menu-vertical .ant-menu-submenu-selected > a,\n.ant-menu-vertical-left .ant-menu-submenu-selected > a,\n.ant-menu-vertical-right .ant-menu-submenu-selected > a {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal {\n  line-height: 46px;\n  white-space: nowrap;\n  border: 0;\n  border-bottom: 1px solid #e8e8e8;\n  box-shadow: none;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  vertical-align: bottom;\n  border-bottom: 2px solid transparent;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  color: #2EB1EF;\n  border-bottom: 2px solid #2EB1EF;\n}\n.ant-menu-horizontal > .ant-menu-item > a {\n  display: block;\n  color: #545454;\n}\n.ant-menu-horizontal > .ant-menu-item > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal > .ant-menu-item > a::before {\n  bottom: -2px;\n}\n.ant-menu-horizontal > .ant-menu-item-selected > a {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal::after {\n  display: block;\n  clear: both;\n  height: 0;\n  content: '\\20';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item {\n  position: relative;\n}\n.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-inline .ant-menu-item::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border-right: 3px solid #2EB1EF;\n  transform: scaleY(0.0001);\n  opacity: 0;\n  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);\n  content: '';\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  height: 42px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 0 16px;\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 42px;\n  text-overflow: ellipsis;\n}\n.ant-menu-vertical .ant-menu-submenu,\n.ant-menu-vertical-left .ant-menu-submenu,\n.ant-menu-vertical-right .ant-menu-submenu,\n.ant-menu-inline .ant-menu-submenu {\n  padding-bottom: 0.02px;\n}\n.ant-menu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 8px;\n}\n.ant-menu-vertical > .ant-menu-item,\n.ant-menu-vertical-left > .ant-menu-item,\n.ant-menu-vertical-right > .ant-menu-item,\n.ant-menu-inline > .ant-menu-item,\n.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 42px;\n  line-height: 42px;\n}\n.ant-menu-inline {\n  width: 100%;\n}\n.ant-menu-inline .ant-menu-selected::after,\n.ant-menu-inline .ant-menu-item-selected::after {\n  transform: scaleY(1);\n  opacity: 1;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-inline .ant-menu-item,\n.ant-menu-inline .ant-menu-submenu-title {\n  width: calc(100% + 1px);\n}\n.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 34px;\n}\n.ant-menu-inline-collapsed {\n  width: 80px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  padding: 0 32px !important;\n  text-overflow: clip;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .anticon,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {\n  margin: 0;\n  font-size: 16px;\n  line-height: 42px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {\n  display: inline-block;\n  max-width: 0;\n  opacity: 0;\n}\n.ant-menu-inline-collapsed-tooltip {\n  pointer-events: none;\n}\n.ant-menu-inline-collapsed-tooltip .anticon {\n  display: none;\n}\n.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  padding-right: 4px;\n  padding-left: 4px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-root.ant-menu-vertical,\n.ant-menu-root.ant-menu-vertical-left,\n.ant-menu-root.ant-menu-vertical-right,\n.ant-menu-root.ant-menu-inline {\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 42px;\n  line-height: 42px;\n  list-style-position: inside;\n  list-style-type: disc;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding-left: 32px;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n  background: none;\n  border-color: transparent !important;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled > a,\n.ant-menu-submenu-disabled > a {\n  color: rgba(0, 0, 0, 0.25) !important;\n  pointer-events: none;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n  cursor: not-allowed;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  color: #038fdd;\n  background: #003366;\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  opacity: 0.45;\n  transition: all 0.3s;\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background: #038fdd;\n}\n.ant-menu-dark.ant-menu-submenu-popup {\n  background: transparent;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: #004285;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45) inset;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  top: 0;\n  margin-top: 0;\n  border-color: #003366;\n  border-bottom: 0;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {\n  bottom: 0;\n}\n.ant-menu-dark .ant-menu-item,\n.ant-menu-dark .ant-menu-item-group-title,\n.ant-menu-dark .ant-menu-item > a {\n  color: #038fdd;\n}\n.ant-menu-dark.ant-menu-inline,\n.ant-menu-dark.ant-menu-vertical,\n.ant-menu-dark.ant-menu-vertical-left,\n.ant-menu-dark.ant-menu-vertical-right {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {\n  left: 0;\n  margin-left: 0;\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {\n  width: 100%;\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark .ant-menu-submenu-open,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu-title:hover {\n  color: #089265;\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark .ant-menu-submenu-open > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow {\n  opacity: 1;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {\n  background: #089265;\n}\n.ant-menu-dark .ant-menu-item:hover {\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  color: #089265;\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected::after {\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item-selected .anticon {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected .anticon + span {\n  color: #fff;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a {\n  color: rgba(255, 255, 255, 0.35) !important;\n  opacity: 0.8;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {\n  background: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-message {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  top: 16px;\n  left: 0;\n  z-index: 1010;\n  width: 100%;\n  pointer-events: none;\n}\n.ant-message-notice {\n  padding: 8px;\n  text-align: center;\n}\n.ant-message-notice:first-child {\n  margin-top: -8px;\n}\n.ant-message-notice-content {\n  display: inline-block;\n  padding: 10px 16px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: all;\n}\n.ant-message-success .anticon {\n  color: #52c41a;\n}\n.ant-message-error .anticon {\n  color: #f5222d;\n}\n.ant-message-warning .anticon {\n  color: #fa8c16;\n}\n.ant-message-info .anticon,\n.ant-message-loading .anticon {\n  color: #1890ff;\n}\n.ant-message .anticon {\n  position: relative;\n  top: 1px;\n  margin-right: 8px;\n  font-size: 16px;\n}\n.ant-message-notice.move-up-leave.move-up-leave-active {\n  overflow: hidden;\n  animation-name: MessageMoveOut;\n  animation-duration: 0.3s;\n}\n@keyframes MessageMoveOut {\n  0% {\n    max-height: 150px;\n    padding: 8px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n.ant-modal {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: 100px;\n  width: auto;\n  margin: 0 auto;\n  padding-bottom: 24px;\n  pointer-events: none;\n}\n.ant-modal-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  overflow: auto;\n  outline: 0;\n  -webkit-overflow-scrolling: touch;\n}\n.ant-modal-title {\n  margin: 0;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  word-wrap: break-word;\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: auto;\n}\n.ant-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  padding: 0;\n  color: #595959;\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-modal-close-x {\n  display: block;\n  width: 56px;\n  height: 56px;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 56px;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 16px 24px;\n  color: #545454;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-modal-body {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n.ant-modal-footer {\n  padding: 10px 16px;\n  text-align: right;\n  background: transparent;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-modal-footer button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  transform: none;\n  opacity: 0;\n  animation-duration: 0.3s;\n  user-select: none;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n  filter: alpha(opacity=50);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n.ant-modal-centered {\n  text-align: center;\n}\n.ant-modal-centered::before {\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n  content: '';\n}\n.ant-modal-centered .ant-modal {\n  top: 0;\n  display: inline-block;\n  text-align: left;\n  vertical-align: middle;\n}\n@media (max-width: 767px) {\n  .ant-modal {\n    max-width: calc(84vw);\n    margin: 8px auto;\n  }\n  .ant-modal-centered .ant-modal {\n    flex: 1;\n  }\n}\n.ant-modal-confirm .ant-modal-header {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-close {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-body {\n  padding: 32px 32px 24px;\n}\n.ant-modal-confirm-body-wrapper {\n  zoom: 1;\n}\n.ant-modal-confirm-body-wrapper::before,\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  clear: both;\n}\n.ant-modal-confirm-body-wrapper::before,\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  clear: both;\n}\n.ant-modal-confirm-body .ant-modal-confirm-title {\n  display: block;\n  overflow: hidden;\n  color: #535353;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.4;\n}\n.ant-modal-confirm-body .ant-modal-confirm-content {\n  margin-top: 8px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-modal-confirm-body > .anticon {\n  float: left;\n  margin-right: 16px;\n  font-size: 22px;\n}\n.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-left: 38px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns {\n  float: right;\n  margin-top: 24px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {\n  color: #f5222d;\n}\n.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,\n.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {\n  color: #fa8c16;\n}\n.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {\n  color: #1890ff;\n}\n.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {\n  color: #52c41a;\n}\n.ant-notification {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: fixed;\n  z-index: 1010;\n  width: 384px;\n  max-width: calc(100vw - 32px);\n  margin-right: 24px;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-right: 0;\n  margin-left: 24px;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationLeftFadeIn;\n}\n.ant-notification-close-icon {\n  font-size: 14px;\n  cursor: pointer;\n}\n.ant-notification-notice {\n  position: relative;\n  margin-bottom: 16px;\n  padding: 16px 24px;\n  overflow: hidden;\n  line-height: 1.5;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n.ant-notification-notice-message {\n  display: inline-block;\n  margin-bottom: 8px;\n  color: #535353;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  display: block;\n  width: calc(384px - 24px * 2 - 24px - 48px - 100%);\n  max-width: 4px;\n  background-color: transparent;\n  pointer-events: none;\n}\n.ant-notification-notice-message-single-line-auto-margin::before {\n  display: block;\n  content: '';\n}\n.ant-notification-notice-description {\n  font-size: 14px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  margin-bottom: 4px;\n  margin-left: 48px;\n  font-size: 16px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 14px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  margin-left: 4px;\n  font-size: 24px;\n  line-height: 24px;\n}\n.anticon.ant-notification-notice-icon-success {\n  color: #52c41a;\n}\n.anticon.ant-notification-notice-icon-info {\n  color: #1890ff;\n}\n.anticon.ant-notification-notice-icon-warning {\n  color: #fa8c16;\n}\n.anticon.ant-notification-notice-icon-error {\n  color: #f5222d;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  top: 16px;\n  right: 22px;\n  color: #595959;\n  outline: none;\n}\n.ant-notification-notice-close:hover {\n  color: #353535;\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  opacity: 0;\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  animation-duration: 0.24s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-fill-mode: both;\n  animation-duration: 0.2s;\n  animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationFadeIn;\n  animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  animation-name: NotificationFadeOut;\n  animation-play-state: running;\n}\n@keyframes NotificationFadeIn {\n  0% {\n    left: 384px;\n    opacity: 0;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    right: 384px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    max-height: 150px;\n    margin-bottom: 16px;\n    padding-top: 16px 24px;\n    padding-bottom: 16px 24px;\n    opacity: 1;\n  }\n  100% {\n    max-height: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n}\n.ant-page-header {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  padding: 16px 24px;\n  background-color: #fff;\n}\n.ant-page-header-ghost {\n  background-color: inherit;\n}\n.ant-page-header.has-breadcrumb {\n  padding-top: 12px;\n}\n.ant-page-header.has-footer {\n  padding-bottom: 0;\n}\n.ant-page-header-back {\n  float: left;\n  margin: 8px 0;\n  margin-right: 16px;\n  font-size: 16px;\n  line-height: 1;\n}\n.ant-page-header-back-button {\n  color: #2EB1EF;\n  text-decoration: none;\n  outline: none;\n  transition: color 0.3s;\n  color: #000;\n  cursor: pointer;\n}\n.ant-page-header-back-button:focus,\n.ant-page-header-back-button:hover {\n  color: #58cefc;\n}\n.ant-page-header-back-button:active {\n  color: #1c8dc9;\n}\n.ant-page-header .ant-divider-vertical {\n  height: 14px;\n  margin: 0 12px;\n  vertical-align: middle;\n}\n.ant-breadcrumb + .ant-page-header-heading {\n  margin-top: 8px;\n}\n.ant-page-header-heading {\n  width: 100%;\n  overflow: hidden;\n}\n.ant-page-header-heading-title {\n  display: block;\n  float: left;\n  margin-bottom: 0;\n  padding-right: 12px;\n  color: #535353;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 32px;\n}\n.ant-page-header-heading .ant-avatar {\n  float: left;\n  margin-right: 12px;\n}\n.ant-page-header-heading-sub-title {\n  float: left;\n  margin: 5px 0;\n  margin-right: 12px;\n  color: #595959;\n  font-size: 14px;\n  line-height: 22px;\n}\n.ant-page-header-heading-tags {\n  float: left;\n  margin: 4px 0;\n}\n.ant-page-header-heading-extra {\n  float: right;\n}\n.ant-page-header-heading-extra > * {\n  margin-left: 8px;\n}\n.ant-page-header-heading-extra > *:first-child {\n  margin-left: 0;\n}\n.ant-page-header-content {\n  padding-top: 12px;\n  overflow: hidden;\n}\n.ant-page-header-footer {\n  margin-top: 16px;\n}\n.ant-page-header-footer .ant-tabs-bar {\n  margin-bottom: 1px;\n  border-bottom: 0;\n}\n.ant-page-header-footer .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {\n  padding: 8px;\n  font-size: 16px;\n}\n@media (max-width: 576px) {\n  .ant-page-header-heading-extra {\n    display: block;\n    float: unset;\n    width: 100%;\n    padding-top: 12px;\n    overflow: hidden;\n  }\n}\n.ant-pagination {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-pagination ul,\n.ant-pagination ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-pagination::after {\n  display: block;\n  clear: both;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n  content: ' ';\n}\n.ant-pagination-total-text {\n  display: inline-block;\n  height: 32px;\n  margin-right: 8px;\n  line-height: 30px;\n  vertical-align: middle;\n}\n.ant-pagination-item {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  font-family: Arial;\n  line-height: 30px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: 0;\n  cursor: pointer;\n  user-select: none;\n}\n.ant-pagination-item a {\n  display: block;\n  padding: 0 6px;\n  color: #545454;\n  transition: none;\n}\n.ant-pagination-item a:hover {\n  text-decoration: none;\n}\n.ant-pagination-item:focus,\n.ant-pagination-item:hover {\n  border-color: #2EB1EF;\n  transition: all 0.3s;\n}\n.ant-pagination-item:focus a,\n.ant-pagination-item:hover a {\n  color: #2EB1EF;\n}\n.ant-pagination-item-active {\n  font-weight: 500;\n  background: #fff;\n  border-color: #2EB1EF;\n}\n.ant-pagination-item-active a {\n  color: #2EB1EF;\n}\n.ant-pagination-item-active:focus,\n.ant-pagination-item-active:hover {\n  border-color: #58cefc;\n}\n.ant-pagination-item-active:focus a,\n.ant-pagination-item-active:hover a {\n  color: #58cefc;\n}\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  outline: 0;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container,\n.ant-pagination-jump-next .ant-pagination-item-container {\n  position: relative;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 12px \\9;\n  transform: scale(1) rotate(0deg);\n  color: #2EB1EF;\n  letter-spacing: -1px;\n  opacity: 0;\n  transition: all 0.2s;\n}\n:root .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n:root .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  font-size: 12px;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  margin: auto;\n  color: rgba(0, 0, 0, 0.25);\n  letter-spacing: 2px;\n  text-align: center;\n  text-indent: 0.13em;\n  opacity: 1;\n  transition: all 0.2s;\n}\n.ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:focus .ant-pagination-item-link-icon,\n.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,\n.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {\n  opacity: 1;\n}\n.ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,\n.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,\n.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {\n  opacity: 0;\n}\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  margin-right: 8px;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  display: inline-block;\n  min-width: 32px;\n  height: 32px;\n  color: #545454;\n  font-family: Arial;\n  line-height: 32px;\n  text-align: center;\n  vertical-align: middle;\n  list-style: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-pagination-prev,\n.ant-pagination-next {\n  outline: 0;\n}\n.ant-pagination-prev a,\n.ant-pagination-next a {\n  color: #545454;\n  user-select: none;\n}\n.ant-pagination-prev:hover a,\n.ant-pagination-next:hover a {\n  border-color: #58cefc;\n}\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  display: block;\n  height: 100%;\n  font-size: 12px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: none;\n  transition: all 0.3s;\n}\n.ant-pagination-prev:focus .ant-pagination-item-link,\n.ant-pagination-next:focus .ant-pagination-item-link,\n.ant-pagination-prev:hover .ant-pagination-item-link,\n.ant-pagination-next:hover .ant-pagination-item-link {\n  color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-pagination-disabled,\n.ant-pagination-disabled:hover,\n.ant-pagination-disabled:focus {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled a,\n.ant-pagination-disabled:hover a,\n.ant-pagination-disabled:focus a,\n.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination-disabled:hover .ant-pagination-item-link,\n.ant-pagination-disabled:focus .ant-pagination-item-link {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination-slash {\n  margin: 0 10px 0 5px;\n}\n.ant-pagination-options {\n  display: inline-block;\n  margin-left: 16px;\n  vertical-align: middle;\n}\n.ant-pagination-options-size-changer.ant-select {\n  display: inline-block;\n  width: auto;\n  margin-right: 8px;\n}\n.ant-pagination-options-quick-jumper {\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  vertical-align: top;\n}\n.ant-pagination-options-quick-jumper input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n  width: 50px;\n  margin: 0 8px;\n}\n.ant-pagination-options-quick-jumper input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-pagination-options-quick-jumper input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-pagination-options-quick-jumper input:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-pagination-options-quick-jumper input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-pagination-options-quick-jumper input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-pagination-options-quick-jumper input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-pagination-options-quick-jumper input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-pagination-options-quick-jumper input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination-simple .ant-pagination-next {\n  height: 24px;\n  line-height: 24px;\n  vertical-align: top;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {\n  height: 24px;\n  border: 0;\n}\n.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager {\n  display: inline-block;\n  height: 24px;\n  margin-right: 8px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  box-sizing: border-box;\n  height: 100%;\n  margin-right: 8px;\n  padding: 0 6px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #2EB1EF;\n}\n.ant-pagination.mini .ant-pagination-total-text,\n.ant-pagination.mini .ant-pagination-simple-pager {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-item {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 22px;\n}\n.ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.mini .ant-pagination-prev,\n.ant-pagination.mini .ant-pagination-next {\n  min-width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link {\n  background: transparent;\n  border-color: transparent;\n}\n.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link::after,\n.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link::after {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-jump-prev,\n.ant-pagination.mini .ant-pagination-jump-next {\n  height: 24px;\n  margin-right: 0;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-options {\n  margin-left: 2px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper input {\n  height: 24px;\n  padding: 1px 7px;\n  width: 44px;\n}\n.ant-pagination.ant-pagination-disabled {\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item a {\n  color: rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border: none;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {\n  background: #dbdbdb;\n  border-color: transparent;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {\n  color: #fff;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:hover,\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-link:focus {\n  color: #595959;\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-link-icon {\n  opacity: 0;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:focus .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:focus .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {\n  opacity: 1;\n}\n@media only screen and (max-width: 992px) {\n  .ant-pagination-item-after-jump-prev,\n  .ant-pagination-item-before-jump-next {\n    display: none;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .ant-pagination-options {\n    display: none;\n  }\n}\n.ant-popover {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  font-weight: normal;\n  white-space: normal;\n  text-align: left;\n  cursor: auto;\n  user-select: text;\n}\n.ant-popover::after {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n  content: '';\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 10px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 10px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 10px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 10px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15) \\9;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ant-popover {\n    /* IE10+ */\n  }\n  .ant-popover-inner {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n}\n.ant-popover-title {\n  min-width: 177px;\n  min-height: 32px;\n  margin: 0;\n  padding: 5px 16px 4px;\n  color: #535353;\n  font-weight: 500;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-popover-inner-content {\n  padding: 12px 16px;\n  color: #545454;\n}\n.ant-popover-message {\n  position: relative;\n  padding: 4px 0 12px;\n  color: #545454;\n  font-size: 14px;\n}\n.ant-popover-message > .anticon {\n  position: absolute;\n  top: 8px;\n  color: #fa8c16;\n  font-size: 14px;\n}\n.ant-popover-message-title {\n  padding-left: 22px;\n}\n.ant-popover-buttons {\n  margin-bottom: 4px;\n  text-align: right;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow {\n  position: absolute;\n  display: block;\n  width: 8.48528137px;\n  height: 8.48528137px;\n  background: transparent;\n  border-style: solid;\n  border-width: 4.24264069px;\n  transform: rotate(45deg);\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  bottom: 6.2px;\n  border-top-color: transparent;\n  border-right-color: #fff;\n  border-bottom-color: #fff;\n  border-left-color: transparent;\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 6px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #fff;\n  border-left-color: #fff;\n  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  top: 6px;\n  border-top-color: #fff;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: #fff;\n  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 6px;\n  border-top-color: #fff;\n  border-right-color: #fff;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-progress {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-progress-line {\n  position: relative;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-progress-small.ant-progress-line,\n.ant-progress-small.ant-progress-line .ant-progress-text .anticon {\n  font-size: 12px;\n}\n.ant-progress-outer {\n  display: inline-block;\n  width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n}\n.ant-progress-show-info .ant-progress-outer {\n  margin-right: calc(-2em - 8px);\n  padding-right: calc(2em + 8px);\n}\n.ant-progress-inner {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  vertical-align: middle;\n  background-color: #f5f5f5;\n  border-radius: 100px;\n}\n.ant-progress-circle-trail {\n  stroke: #f5f5f5;\n}\n.ant-progress-circle-path {\n  animation: ant-progress-appear 0.3s;\n}\n.ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #2EB1EF;\n}\n.ant-progress-success-bg,\n.ant-progress-bg {\n  position: relative;\n  background-color: #2EB1EF;\n  border-radius: 100px;\n  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;\n}\n.ant-progress-success-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #52c41a;\n}\n.ant-progress-text {\n  display: inline-block;\n  width: 2em;\n  margin-left: 8px;\n  color: #595959;\n  font-size: 1em;\n  line-height: 1;\n  white-space: nowrap;\n  text-align: left;\n  vertical-align: middle;\n  word-break: normal;\n}\n.ant-progress-text .anticon {\n  font-size: 14px;\n}\n.ant-progress-status-active .ant-progress-bg::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  border-radius: 10px;\n  opacity: 0;\n  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;\n  content: '';\n}\n.ant-progress-status-exception .ant-progress-bg {\n  background-color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-status-exception .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #f5222d;\n}\n.ant-progress-status-success .ant-progress-bg {\n  background-color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n.ant-progress-status-success .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path {\n  stroke: #52c41a;\n}\n.ant-progress-circle .ant-progress-inner {\n  position: relative;\n  line-height: 1;\n  background-color: transparent;\n}\n.ant-progress-circle .ant-progress-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  line-height: 1;\n  white-space: normal;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n.ant-progress-circle .ant-progress-text .anticon {\n  font-size: 1.16666667em;\n}\n.ant-progress-circle.ant-progress-status-exception .ant-progress-text {\n  color: #f5222d;\n}\n.ant-progress-circle.ant-progress-status-success .ant-progress-text {\n  color: #52c41a;\n}\n@keyframes ant-progress-active {\n  0% {\n    width: 0;\n    opacity: 0.1;\n  }\n  20% {\n    width: 0;\n    opacity: 0.5;\n  }\n  100% {\n    width: 100%;\n    opacity: 0;\n  }\n}\n.ant-radio-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-radio-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  margin-right: 8px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.ant-radio {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: sub;\n  outline: none;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-input:focus + .ant-radio-inner {\n  border-color: #2EB1EF;\n}\n.ant-radio-input:focus + .ant-radio-inner {\n  box-shadow: 0 0 0 3px rgba(46, 177, 239, 0.08);\n}\n.ant-radio-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #2EB1EF;\n  border-radius: 50%;\n  visibility: hidden;\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  content: '';\n}\n.ant-radio:hover::after,\n.ant-radio-wrapper:hover .ant-radio::after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 100px;\n  transition: all 0.3s;\n}\n.ant-radio-inner::after {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  display: table;\n  width: 8px;\n  height: 8px;\n  background-color: #2EB1EF;\n  border-top: 0;\n  border-left: 0;\n  border-radius: 8px;\n  transform: scale(0);\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  content: ' ';\n}\n.ant-radio-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #2EB1EF;\n}\n.ant-radio-checked .ant-radio-inner::after {\n  transform: scale(1);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled .ant-radio-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n  cursor: not-allowed;\n}\n.ant-radio-disabled .ant-radio-inner::after {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-radio-button-wrapper {\n  position: relative;\n  display: inline-block;\n  height: 36px;\n  margin: 0;\n  padding: 0 15px;\n  color: #545454;\n  line-height: 34px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  border-top-width: 1.02px;\n  border-left: 0;\n  cursor: pointer;\n  transition: color 0.3s, background 0.3s, border-color 0.3s;\n}\n.ant-radio-button-wrapper a {\n  color: #545454;\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  display: block;\n  width: 0;\n  height: 0;\n  margin-left: 0;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 40px;\n  font-size: 16px;\n  line-height: 38px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 24px;\n  padding: 0 7px;\n  line-height: 22px;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  position: absolute;\n  top: 0;\n  left: -1px;\n  display: block;\n  width: 1px;\n  height: 100%;\n  background-color: #d9d9d9;\n  content: '';\n}\n.ant-radio-button-wrapper:first-child {\n  border-left: 1px solid #d9d9d9;\n  border-radius: 6px 0 0 6px;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 6px 6px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 6px;\n}\n.ant-radio-button-wrapper:hover {\n  position: relative;\n  color: #2EB1EF;\n}\n.ant-radio-button-wrapper:focus-within {\n  outline: 3px solid rgba(46, 177, 239, 0.06);\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type='checkbox'],\n.ant-radio-button-wrapper input[type='radio'] {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  z-index: 1;\n  color: #2EB1EF;\n  background: #fff;\n  border-color: #2EB1EF;\n  box-shadow: -1px 0 0 0 #2EB1EF;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {\n  background-color: #2EB1EF !important;\n  opacity: 0.1;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {\n  border-color: #2EB1EF;\n  box-shadow: none !important;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #58cefc;\n  border-color: #58cefc;\n  box-shadow: -1px 0 0 0 #58cefc;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #1c8dc9;\n  border-color: #1c8dc9;\n  box-shadow: -1px 0 0 0 #1c8dc9;\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  outline: 3px solid rgba(46, 177, 239, 0.06);\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: #fff;\n  background: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #fff;\n  background: #58cefc;\n  border-color: #58cefc;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {\n  color: #fff;\n  background: #1c8dc9;\n  border-color: #1c8dc9;\n}\n.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {\n  outline: 3px solid rgba(46, 177, 239, 0.06);\n}\n.ant-radio-button-wrapper-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: #fff;\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n@supports (-moz-appearance: meterbar) and (background-blend-mode: difference, normal) {\n  .ant-radio {\n    vertical-align: text-bottom;\n  }\n}\n.ant-rate {\n  box-sizing: border-box;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  color: #fadb14;\n  font-size: 20px;\n  line-height: unset;\n  list-style: none;\n  outline: none;\n}\n.ant-rate-disabled .ant-rate-star {\n  cursor: default;\n}\n.ant-rate-disabled .ant-rate-star:hover {\n  transform: scale(1);\n}\n.ant-rate-star {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-rate-star:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-rate-star > div:focus {\n  outline: 0;\n}\n.ant-rate-star > div:hover,\n.ant-rate-star > div:focus {\n  transform: scale(1.1);\n}\n.ant-rate-star-first,\n.ant-rate-star-second {\n  color: #e8e8e8;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-rate-star-first .anticon,\n.ant-rate-star-second .anticon {\n  vertical-align: middle;\n}\n.ant-rate-star-first {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  opacity: 0;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-half .ant-rate-star-second {\n  opacity: 1;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-full .ant-rate-star-second {\n  color: inherit;\n}\n.ant-rate-text {\n  display: inline-block;\n  margin-left: 8px;\n  font-size: 14px;\n}\n.ant-result {\n  padding: 48px 32px;\n}\n.ant-result-success .ant-result-icon > .anticon {\n  color: #52c41a;\n}\n.ant-result-error .ant-result-icon > .anticon {\n  color: #f5222d;\n}\n.ant-result-info .ant-result-icon > .anticon {\n  color: #1890ff;\n}\n.ant-result-warning .ant-result-icon > .anticon {\n  color: #fa8c16;\n}\n.ant-result-image {\n  width: 250px;\n  height: 295px;\n  margin: auto;\n}\n.ant-result-icon {\n  margin-bottom: 24px;\n  text-align: center;\n}\n.ant-result-icon > .anticon {\n  font-size: 72px;\n}\n.ant-result-title {\n  color: #535353;\n  font-size: 24px;\n  line-height: 1.8;\n  text-align: center;\n}\n.ant-result-subtitle {\n  color: #595959;\n  font-size: 14px;\n  line-height: 1.6;\n  text-align: center;\n}\n.ant-result-extra {\n  margin-top: 32px;\n  text-align: center;\n}\n.ant-result-extra > * {\n  margin-right: 8px;\n}\n.ant-result-extra > *:last-child {\n  margin-right: 0;\n}\n.ant-result-content {\n  margin-top: 24px;\n  padding: 24px 40px;\n  background-color: #fafafa;\n}\n.ant-select {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  outline: 0;\n}\n.ant-select ul,\n.ant-select ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-select > ul > li > a {\n  padding: 0;\n  background-color: #fff;\n}\n.ant-select-arrow {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  line-height: 1;\n  transform-origin: 50% 50%;\n}\n.ant-select-arrow > * {\n  line-height: 1;\n}\n.ant-select-arrow svg {\n  display: inline-block;\n}\n.ant-select-arrow::before {\n  display: none;\n}\n.ant-select-arrow .ant-select-arrow-icon {\n  display: block;\n}\n.ant-select-arrow .ant-select-arrow-icon svg {\n  transition: transform 0.3s;\n}\n.ant-select-selection {\n  display: block;\n  box-sizing: border-box;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-top-width: 1.02px;\n  border-radius: 6px;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n}\n.ant-select-selection:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-select-focused .ant-select-selection,\n.ant-select-selection:focus,\n.ant-select-selection:active {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-select-selection__clear {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  z-index: 1;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 12px;\n  font-style: normal;\n  line-height: 12px;\n  text-align: center;\n  text-transform: none;\n  background: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: color 0.3s ease, opacity 0.15s ease;\n  text-rendering: auto;\n}\n.ant-select-selection__clear::before {\n  display: block;\n}\n.ant-select-selection__clear:hover {\n  color: #595959;\n}\n.ant-select-selection:hover .ant-select-selection__clear {\n  opacity: 1;\n}\n.ant-select-selection-selected-value {\n  float: left;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-select-no-arrow .ant-select-selection-selected-value {\n  padding-right: 0;\n}\n.ant-select-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-disabled .ant-select-selection {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n.ant-select-disabled .ant-select-selection:hover,\n.ant-select-disabled .ant-select-selection:focus,\n.ant-select-disabled .ant-select-selection:active {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-select-disabled .ant-select-selection__clear {\n  display: none;\n  visibility: hidden;\n  pointer-events: none;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {\n  padding-right: 10px;\n  color: rgba(0, 0, 0, 0.33);\n  background: #f5f5f5;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  display: none;\n}\n.ant-select-selection--single {\n  position: relative;\n  height: 36px;\n  cursor: pointer;\n}\n.ant-select-selection--single .ant-select-selection__rendered {\n  margin-right: 24px;\n}\n.ant-select-no-arrow .ant-select-selection__rendered {\n  margin-right: 11px;\n}\n.ant-select-selection__rendered {\n  position: relative;\n  display: block;\n  margin-right: 11px;\n  margin-left: 11px;\n  line-height: 34px;\n}\n.ant-select-selection__rendered::after {\n  display: inline-block;\n  width: 0;\n  visibility: hidden;\n  content: '.';\n  pointer-events: none;\n}\n.ant-select-lg {\n  font-size: 16px;\n}\n.ant-select-lg .ant-select-selection--single {\n  height: 40px;\n}\n.ant-select-lg .ant-select-selection__rendered {\n  line-height: 38px;\n}\n.ant-select-lg .ant-select-selection--multiple {\n  min-height: 40px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 32px;\n  line-height: 32px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-lg .ant-select-selection--multiple .ant-select-arrow {\n  top: 20px;\n}\n.ant-select-sm .ant-select-selection--single {\n  height: 24px;\n}\n.ant-select-sm .ant-select-selection__rendered {\n  margin-left: 7px;\n  line-height: 22px;\n}\n.ant-select-sm .ant-select-selection--multiple {\n  min-height: 24px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 16px;\n  line-height: 14px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-sm .ant-select-selection--multiple .ant-select-arrow {\n  top: 12px;\n}\n.ant-select-sm .ant-select-selection__clear,\n.ant-select-sm .ant-select-arrow {\n  right: 8px;\n}\n.ant-select-disabled .ant-select-selection__choice__remove {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: default;\n}\n.ant-select-disabled .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-search__field__wrap {\n  position: relative;\n  display: inline-block;\n}\n.ant-select-selection__placeholder,\n.ant-select-search__field__placeholder {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  left: 0;\n  max-width: 100%;\n  height: 20px;\n  margin-top: -10px;\n  overflow: hidden;\n  color: #bfbfbf;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: left;\n  text-overflow: ellipsis;\n}\n.ant-select-search__field__placeholder {\n  left: 12px;\n}\n.ant-select-search__field__mirror {\n  position: absolute;\n  top: 0;\n  left: 0;\n  white-space: pre;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-select-search--inline {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field {\n  width: 100%;\n  height: 100%;\n  font-size: 100%;\n  line-height: 1;\n  background: transparent;\n  border-width: 0;\n  border-radius: 6px;\n  outline: 0;\n}\n.ant-select-search--inline > i {\n  float: right;\n}\n.ant-select-selection--multiple {\n  min-height: 36px;\n  padding-bottom: 3px;\n  cursor: text;\n  zoom: 1;\n}\n.ant-select-selection--multiple::before,\n.ant-select-selection--multiple::after {\n  display: table;\n  content: '';\n}\n.ant-select-selection--multiple::after {\n  clear: both;\n}\n.ant-select-selection--multiple::before,\n.ant-select-selection--multiple::after {\n  display: table;\n  content: '';\n}\n.ant-select-selection--multiple::after {\n  clear: both;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  position: static;\n  float: left;\n  width: auto;\n  max-width: 100%;\n  padding: 0;\n}\n.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {\n  width: 0.75em;\n  max-width: 100%;\n  padding: 1px;\n}\n.ant-select-selection--multiple .ant-select-selection__rendered {\n  height: auto;\n  margin-bottom: -3px;\n  margin-left: 5px;\n}\n.ant-select-selection--multiple .ant-select-selection__placeholder {\n  margin-left: 6px;\n}\n.ant-select-selection--multiple > ul > li,\n.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {\n  height: 28px;\n  margin-top: 3px;\n  line-height: 26px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice {\n  position: relative;\n  float: left;\n  max-width: 99%;\n  margin-right: 4px;\n  padding: 0 20px 0 10px;\n  overflow: hidden;\n  color: #545454;\n  background-color: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  cursor: default;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__disabled {\n  padding: 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__content {\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 4px;\n  color: #595959;\n  font-weight: bold;\n  line-height: inherit;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove > * {\n  line-height: 1;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove svg {\n  display: inline-block;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove::before {\n  display: none;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove .ant-select-selection--multiple .ant-select-selection__choice__remove-icon {\n  display: block;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 12px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.75);\n}\n.ant-select-selection--multiple .ant-select-selection__clear,\n.ant-select-selection--multiple .ant-select-arrow {\n  top: 18px;\n}\n.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,\n.ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-open .ant-select-arrow-icon svg {\n  transform: rotate(180deg);\n}\n.ant-select-open .ant-select-selection {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-select-combobox .ant-select-arrow {\n  display: none;\n}\n.ant-select-combobox .ant-select-search--inline {\n  float: none;\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  box-shadow: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0s;\n}\n.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered,\n.ant-select-combobox.ant-select-show-arrow .ant-select-selection:hover .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-dropdown {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  z-index: 1050;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-variant: initial;\n  background-color: #fff;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-select-dropdown-hidden {\n  display: none;\n}\n.ant-select-dropdown-menu {\n  max-height: 250px;\n  margin-bottom: 0;\n  padding: 4px 0;\n  padding-left: 0;\n  overflow: auto;\n  list-style: none;\n  outline: none;\n}\n.ant-select-dropdown-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {\n  padding-left: 20px;\n}\n.ant-select-dropdown-menu-item-group-title {\n  height: 32px;\n  padding: 0 12px;\n  color: #595959;\n  font-size: 12px;\n  line-height: 32px;\n}\n.ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:first-child:not(:last-child),\n.ant-select-dropdown-menu-item-group:not(:last-child) .ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:last-child {\n  border-radius: 0;\n}\n.ant-select-dropdown-menu-item {\n  position: relative;\n  display: block;\n  padding: 5px 12px;\n  overflow: hidden;\n  color: #545454;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: #f0fdff;\n}\n.ant-select-dropdown-menu-item-selected {\n  color: #545454;\n  font-weight: 600;\n  background-color: #fafafa;\n}\n.ant-select-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: #f0fdff;\n}\n.ant-select-dropdown-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  line-height: 0;\n  background-color: #e8e8e8;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {\n  padding-right: 32px;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item .ant-select-selected-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  color: transparent;\n  font-weight: bold;\n  font-size: 12px;\n  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;\n  transform: translateY(-50%);\n  transition: all 0.2s;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover .ant-select-selected-icon {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled .ant-select-selected-icon {\n  display: none;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected .ant-select-selected-icon,\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover .ant-select-selected-icon {\n  display: inline-block;\n  color: #2EB1EF;\n}\n.ant-select-dropdown--empty.ant-select-dropdown--multiple .ant-select-dropdown-menu-item {\n  padding-right: 12px;\n}\n.ant-select-dropdown-container-open .ant-select-dropdown,\n.ant-select-dropdown-open .ant-select-dropdown {\n  display: block;\n}\n.ant-skeleton {\n  display: table;\n  width: 100%;\n}\n.ant-skeleton-header {\n  display: table-cell;\n  padding-right: 16px;\n  vertical-align: top;\n}\n.ant-skeleton-header .ant-skeleton-avatar {\n  display: inline-block;\n  vertical-align: top;\n  background: #f2f2f2;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.ant-skeleton-header .ant-skeleton-avatar.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-header .ant-skeleton-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n.ant-skeleton-header .ant-skeleton-avatar-lg.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-header .ant-skeleton-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.ant-skeleton-header .ant-skeleton-avatar-sm.ant-skeleton-avatar-circle {\n  border-radius: 50%;\n}\n.ant-skeleton-content {\n  display: table-cell;\n  width: 100%;\n  vertical-align: top;\n}\n.ant-skeleton-content .ant-skeleton-title {\n  width: 100%;\n  height: 16px;\n  margin-top: 16px;\n  background: #f2f2f2;\n}\n.ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n  margin-top: 24px;\n}\n.ant-skeleton-content .ant-skeleton-paragraph {\n  padding: 0;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li {\n  width: 100%;\n  height: 16px;\n  list-style: none;\n  background: #f2f2f2;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {\n  width: 61%;\n}\n.ant-skeleton-content .ant-skeleton-paragraph > li + li {\n  margin-top: 16px;\n}\n.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title {\n  margin-top: 12px;\n}\n.ant-skeleton-with-avatar .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n  margin-top: 28px;\n}\n.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,\n.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {\n  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);\n  background-size: 400% 100%;\n  animation: ant-skeleton-loading 1.4s ease infinite;\n}\n.ant-skeleton.ant-skeleton-active .ant-skeleton-avatar {\n  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);\n  background-size: 400% 100%;\n  animation: ant-skeleton-loading 1.4s ease infinite;\n}\n@keyframes ant-skeleton-loading {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n.ant-slider {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  height: 12px;\n  margin: 14px 6px 10px;\n  padding: 4px 0;\n  cursor: pointer;\n  touch-action: none;\n}\n.ant-slider-vertical {\n  width: 12px;\n  height: 100%;\n  margin: 6px 10px;\n  padding: 0 4px;\n}\n.ant-slider-vertical .ant-slider-rail {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-track {\n  width: 4px;\n}\n.ant-slider-vertical .ant-slider-handle {\n  margin-bottom: -7px;\n  margin-left: -5px;\n}\n.ant-slider-vertical .ant-slider-mark {\n  top: 0;\n  left: 12px;\n  width: 18px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-mark-text {\n  left: 4px;\n  white-space: nowrap;\n}\n.ant-slider-vertical .ant-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-dot {\n  top: auto;\n  left: 2px;\n  margin-bottom: -4px;\n}\n.ant-slider-tooltip .ant-tooltip-inner {\n  min-width: unset;\n}\n.ant-slider-with-marks {\n  margin-bottom: 28px;\n}\n.ant-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n.ant-slider-track {\n  position: absolute;\n  height: 4px;\n  background-color: #abedff;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n.ant-slider-handle {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #abedff;\n  border-radius: 50%;\n  box-shadow: 0;\n  cursor: pointer;\n  transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n.ant-slider-handle:focus {\n  border-color: #58c1f2;\n  outline: none;\n  box-shadow: 0 0 0 5px rgba(46, 177, 239, 0.2);\n}\n.ant-slider-handle.ant-tooltip-open {\n  border-color: #2EB1EF;\n}\n.ant-slider:hover .ant-slider-rail {\n  background-color: #e1e1e1;\n}\n.ant-slider:hover .ant-slider-track {\n  background-color: #82e0ff;\n}\n.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n  border-color: #82e0ff;\n}\n.ant-slider-mark {\n  position: absolute;\n  top: 14px;\n  left: 0;\n  width: 100%;\n  font-size: 14px;\n}\n.ant-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  color: #595959;\n  text-align: center;\n  word-break: keep-all;\n  cursor: pointer;\n}\n.ant-slider-mark-text-active {\n  color: #545454;\n}\n.ant-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.ant-slider-dot {\n  position: absolute;\n  top: -2px;\n  width: 8px;\n  height: 8px;\n  margin-left: -4px;\n  background-color: #fff;\n  border: 2px solid #e8e8e8;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.ant-slider-dot:first-child {\n  margin-left: -4px;\n}\n.ant-slider-dot:last-child {\n  margin-left: -4px;\n}\n.ant-slider-dot-active {\n  border-color: #97d8f7;\n}\n.ant-slider-disabled {\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-track {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-slider-disabled .ant-slider-handle,\n.ant-slider-disabled .ant-slider-dot {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25) !important;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-mark-text,\n.ant-slider-disabled .ant-slider-dot {\n  cursor: not-allowed !important;\n}\n.ant-spin {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  display: none;\n  color: #2EB1EF;\n  text-align: center;\n  vertical-align: middle;\n  opacity: 0;\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-spin-spinning {\n  position: static;\n  display: inline-block;\n  opacity: 1;\n}\n.ant-spin-nested-loading {\n  position: relative;\n}\n.ant-spin-nested-loading > div > .ant-spin {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -10px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 5px;\n  text-shadow: 0 1px 2px #fff;\n}\n.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {\n  margin-top: -20px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {\n  margin: -7px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {\n  padding-top: 2px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {\n  margin-top: -17px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {\n  margin: -16px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {\n  padding-top: 11px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {\n  margin-top: -26px;\n}\n.ant-spin-container {\n  position: relative;\n  transition: opacity 0.3s;\n}\n.ant-spin-container::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: none \\9;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  opacity: 0;\n  transition: all 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-spin-blur {\n  clear: both;\n  overflow: hidden;\n  opacity: 0.5;\n  user-select: none;\n  pointer-events: none;\n}\n.ant-spin-blur::after {\n  opacity: 0.4;\n  pointer-events: auto;\n}\n.ant-spin-tip {\n  color: #595959;\n}\n.ant-spin-dot {\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  width: 1em;\n  height: 1em;\n}\n.ant-spin-dot-item {\n  position: absolute;\n  display: block;\n  width: 9px;\n  height: 9px;\n  background-color: #2EB1EF;\n  border-radius: 100%;\n  transform: scale(0.75);\n  transform-origin: 50% 50%;\n  opacity: 0.3;\n  animation: antSpinMove 1s infinite linear alternate;\n}\n.ant-spin-dot-item:nth-child(1) {\n  top: 0;\n  left: 0;\n}\n.ant-spin-dot-item:nth-child(2) {\n  top: 0;\n  right: 0;\n  animation-delay: 0.4s;\n}\n.ant-spin-dot-item:nth-child(3) {\n  right: 0;\n  bottom: 0;\n  animation-delay: 0.8s;\n}\n.ant-spin-dot-item:nth-child(4) {\n  bottom: 0;\n  left: 0;\n  animation-delay: 1.2s;\n}\n.ant-spin-dot-spin {\n  transform: rotate(45deg);\n  animation: antRotate 1.2s infinite linear;\n}\n.ant-spin-sm .ant-spin-dot {\n  font-size: 14px;\n}\n.ant-spin-sm .ant-spin-dot i {\n  width: 6px;\n  height: 6px;\n}\n.ant-spin-lg .ant-spin-dot {\n  font-size: 32px;\n}\n.ant-spin-lg .ant-spin-dot i {\n  width: 14px;\n  height: 14px;\n}\n.ant-spin.ant-spin-show-text .ant-spin-text {\n  display: block;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ */\n  .ant-spin-blur {\n    background: #fff;\n    opacity: 0.5;\n  }\n}\n@keyframes antSpinMove {\n  to {\n    opacity: 1;\n  }\n}\n@keyframes antRotate {\n  to {\n    transform: rotate(405deg);\n  }\n}\n.ant-statistic {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-statistic-title {\n  margin-bottom: 4px;\n  color: #595959;\n  font-size: 14px;\n}\n.ant-statistic-content {\n  color: #535353;\n  font-size: 24px;\n  font-family: \"DM Sans\", sans-serif;\n}\n.ant-statistic-content-value-decimal {\n  font-size: 16px;\n}\n.ant-statistic-content-prefix,\n.ant-statistic-content-suffix {\n  display: inline-block;\n}\n.ant-statistic-content-prefix {\n  margin-right: 4px;\n}\n.ant-statistic-content-suffix {\n  margin-left: 4px;\n  font-size: 16px;\n}\n.ant-steps {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: flex;\n  width: 100%;\n  font-size: 0;\n}\n.ant-steps-item {\n  position: relative;\n  display: inline-block;\n  flex: 1;\n  overflow: hidden;\n  vertical-align: top;\n}\n.ant-steps-item-container {\n  outline: none;\n}\n.ant-steps-item:last-child {\n  flex: none;\n}\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail,\n.ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-item-icon,\n.ant-steps-item-content {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps-item-icon {\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  font-size: 16px;\n  font-family: \"DM Sans\", sans-serif;\n  line-height: 32px;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 32px;\n  transition: background-color 0.3s, border-color 0.3s;\n}\n.ant-steps-item-icon > .ant-steps-icon {\n  position: relative;\n  top: -1px;\n  color: #2EB1EF;\n  line-height: 1;\n}\n.ant-steps-item-tail {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  width: 100%;\n  padding: 0 10px;\n}\n.ant-steps-item-tail::after {\n  display: inline-block;\n  width: 100%;\n  height: 1px;\n  background: #e8e8e8;\n  border-radius: 1px;\n  transition: background 0.3s;\n  content: '';\n}\n.ant-steps-item-title {\n  position: relative;\n  display: inline-block;\n  padding-right: 16px;\n  color: #545454;\n  font-size: 16px;\n  line-height: 32px;\n}\n.ant-steps-item-title::after {\n  position: absolute;\n  top: 16px;\n  left: 100%;\n  display: block;\n  width: 9999px;\n  height: 1px;\n  background: #e8e8e8;\n  content: '';\n}\n.ant-steps-item-subtitle {\n  display: inline;\n  margin-left: 8px;\n  color: #595959;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-steps-item-description {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-steps-item-wait .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: rgba(0, 0, 0, 0.25);\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #595959;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #595959;\n}\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #2EB1EF;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #2EB1EF;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #2EB1EF;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #535353;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #545454;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-process .ant-steps-item-icon {\n  background: #2EB1EF;\n}\n.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #fff;\n}\n.ant-steps-item-process .ant-steps-item-title {\n  font-weight: 500;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #2EB1EF;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #2EB1EF;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #2EB1EF;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #545454;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #2EB1EF;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #595959;\n}\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #2EB1EF;\n}\n.ant-steps-item-error .ant-steps-item-icon {\n  background-color: #fff;\n  border-color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon {\n  color: #f5222d;\n}\n.ant-steps-item-error .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {\n  color: #f5222d;\n}\n.ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #e8e8e8;\n}\n.ant-steps-item.ant-steps-next-error .ant-steps-item-title::after {\n  background: #f5222d;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-description,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button'] .ant-steps-item-icon .ant-steps-icon {\n  transition: color 0.3s;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle,\n.ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {\n  color: #2EB1EF;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {\n  border-color: #2EB1EF;\n}\n.ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {\n  color: #2EB1EF;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  margin-right: 16px;\n  white-space: nowrap;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {\n  margin-right: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child .ant-steps-item-title {\n  padding-right: 0;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-tail {\n  display: none;\n}\n.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {\n  max-width: 140px;\n  white-space: normal;\n}\n.ant-steps-item-custom .ant-steps-item-icon {\n  height: auto;\n  background: none;\n  border: 0;\n}\n.ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  top: 0;\n  left: 0.5px;\n  width: 32px;\n  height: 32px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #2EB1EF;\n}\n.ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {\n  width: auto;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {\n  margin-right: 12px;\n}\n.ant-steps-small.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item:last-child {\n  margin-right: 0;\n}\n.ant-steps-small .ant-steps-item-icon {\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 24px;\n}\n.ant-steps-small .ant-steps-item-title {\n  padding-right: 12px;\n  font-size: 14px;\n  line-height: 24px;\n}\n.ant-steps-small .ant-steps-item-title::after {\n  top: 12px;\n}\n.ant-steps-small .ant-steps-item-description {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-steps-small .ant-steps-item-tail {\n  top: 8px;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  background: none;\n  border: 0;\n  border-radius: 0;\n}\n.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {\n  font-size: 24px;\n  line-height: 24px;\n  transform: none;\n}\n.ant-steps-vertical {\n  display: block;\n}\n.ant-steps-vertical .ant-steps-item {\n  display: block;\n  overflow: visible;\n}\n.ant-steps-vertical .ant-steps-item-icon {\n  float: left;\n  margin-right: 16px;\n}\n.ant-steps-vertical .ant-steps-item-content {\n  display: block;\n  min-height: 48px;\n  overflow: hidden;\n}\n.ant-steps-vertical .ant-steps-item-title {\n  line-height: 32px;\n}\n.ant-steps-vertical .ant-steps-item-description {\n  padding-bottom: 12px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  width: 1px;\n  height: 100%;\n  padding: 38px 0 6px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {\n  width: 1px;\n  height: 100%;\n}\n.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {\n  display: block;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n  position: absolute;\n  top: 0;\n  left: 12px;\n  padding: 30px 0 6px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {\n  line-height: 24px;\n}\n@media (max-width: 480px) {\n  .ant-steps-horizontal.ant-steps-label-horizontal {\n    display: block;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {\n    display: block;\n    overflow: visible;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {\n    float: left;\n    margin-right: 16px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {\n    display: block;\n    min-height: 48px;\n    overflow: hidden;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {\n    line-height: 32px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-description {\n    padding-bottom: 12px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    position: absolute;\n    top: 0;\n    left: 16px;\n    width: 1px;\n    height: 100%;\n    padding: 38px 0 6px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {\n    width: 1px;\n    height: 100%;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail {\n    display: block;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n    display: none;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-tail {\n    position: absolute;\n    top: 0;\n    left: 12px;\n    padding: 30px 0 6px;\n  }\n  .ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item-container .ant-steps-item-title {\n    line-height: 24px;\n  }\n}\n.ant-steps-label-vertical .ant-steps-item {\n  overflow: visible;\n}\n.ant-steps-label-vertical .ant-steps-item-tail {\n  margin-left: 58px;\n  padding: 3.5px 24px;\n}\n.ant-steps-label-vertical .ant-steps-item-content {\n  display: block;\n  width: 116px;\n  margin-top: 8px;\n  text-align: center;\n}\n.ant-steps-label-vertical .ant-steps-item-icon {\n  display: inline-block;\n  margin-left: 42px;\n}\n.ant-steps-label-vertical .ant-steps-item-title {\n  padding-right: 0;\n}\n.ant-steps-label-vertical .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-label-vertical .ant-steps-item-subtitle {\n  display: block;\n  margin-bottom: 4px;\n  margin-left: 0;\n  line-height: 1.3;\n}\n.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {\n  margin-left: 46px;\n}\n.ant-steps-dot .ant-steps-item-title,\n.ant-steps-dot.ant-steps-small .ant-steps-item-title {\n  line-height: 1.3;\n}\n.ant-steps-dot .ant-steps-item-tail,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail {\n  top: 2px;\n  width: 100%;\n  margin: 0 0 0 70px;\n  padding: 0;\n}\n.ant-steps-dot .ant-steps-item-tail::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {\n  width: calc(100% - 20px);\n  height: 3px;\n  margin-left: 12px;\n}\n.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 2px;\n}\n.ant-steps-dot .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon {\n  width: 8px;\n  height: 8px;\n  margin-left: 67px;\n  padding-right: 0;\n  line-height: 8px;\n  background: transparent;\n  border: 0;\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 100px;\n  transition: all 0.3s;\n  /* expand hover area */\n}\n.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,\n.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after {\n  position: absolute;\n  top: -12px;\n  left: -26px;\n  width: 60px;\n  height: 32px;\n  background: rgba(0, 0, 0, 0.001);\n  content: '';\n}\n.ant-steps-dot .ant-steps-item-content,\n.ant-steps-dot.ant-steps-small .ant-steps-item-content {\n  width: 140px;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n}\n.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot,\n.ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon-dot {\n  top: -1px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {\n  margin-top: 8px;\n  margin-left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n  top: 2px;\n  left: -9px;\n  margin: 0;\n  padding: 22px 0 4px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item:first-child .ant-steps-icon-dot {\n  left: 0;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {\n  left: -2px;\n}\n.ant-steps-navigation {\n  padding-top: 12px;\n}\n.ant-steps-navigation.ant-steps-small .ant-steps-item-container {\n  margin-left: -12px;\n}\n.ant-steps-navigation .ant-steps-item {\n  overflow: visible;\n  text-align: center;\n}\n.ant-steps-navigation .ant-steps-item-container {\n  display: inline-block;\n  height: 100%;\n  margin-left: -16px;\n  padding-bottom: 12px;\n  text-align: left;\n  transition: opacity 0.3s;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-content {\n  max-width: auto;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title {\n  max-width: 100%;\n  padding-right: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-steps-navigation .ant-steps-item-container .ant-steps-item-title::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button'] {\n  cursor: pointer;\n}\n.ant-steps-navigation .ant-steps-item:not(.ant-steps-item-active) .ant-steps-item-container[role='button']:hover {\n  opacity: 0.85;\n}\n.ant-steps-navigation .ant-steps-item:last-child {\n  flex: 1;\n}\n.ant-steps-navigation .ant-steps-item:last-child::after {\n  display: none;\n}\n.ant-steps-navigation .ant-steps-item::after {\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-top: -14px;\n  margin-left: -2px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-bottom: none;\n  border-left: none;\n  transform: rotate(45deg);\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item::before {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: inline-block;\n  width: 0;\n  height: 3px;\n  background-color: #2EB1EF;\n  transition: width 0.3s, left 0.3s;\n  transition-timing-function: ease-out;\n  content: '';\n}\n.ant-steps-navigation .ant-steps-item.ant-steps-item-active::before {\n  left: 0;\n  width: 100%;\n}\n@media (max-width: 480px) {\n  .ant-steps-navigation > .ant-steps-item {\n    margin-right: 0 !important;\n  }\n  .ant-steps-navigation > .ant-steps-item::before {\n    display: none;\n  }\n  .ant-steps-navigation > .ant-steps-item.ant-steps-item-active::before {\n    top: 0;\n    right: 0;\n    left: unset;\n    display: block;\n    width: 3px;\n    height: calc(76%);\n  }\n  .ant-steps-navigation > .ant-steps-item::after {\n    position: relative;\n    top: -2px;\n    left: 50%;\n    display: block;\n    width: 8px;\n    height: 8px;\n    margin-bottom: 8px;\n    text-align: center;\n    transform: rotate(135deg);\n  }\n  .ant-steps-navigation > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    visibility: hidden;\n  }\n}\n.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {\n  margin-left: -16px;\n  padding-left: 16px;\n  background: #fff;\n}\n.ant-steps-flex-not-supported.ant-steps-horizontal.ant-steps-label-horizontal.ant-steps-small .ant-steps-item {\n  margin-left: -12px;\n  padding-left: 12px;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child {\n  overflow: hidden;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item:last-child .ant-steps-icon-dot::after {\n  right: -200px;\n  width: 200px;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::before,\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {\n  position: absolute;\n  top: 0;\n  left: -10px;\n  width: 10px;\n  height: 8px;\n  background: #fff;\n  content: '';\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item .ant-steps-icon-dot::after {\n  right: -10px;\n  left: auto;\n}\n.ant-steps-flex-not-supported.ant-steps-dot .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #ccc;\n}\n.ant-switch {\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  min-width: 44px;\n  height: 22px;\n  line-height: 20px;\n  vertical-align: middle;\n  background-color: rgba(0, 0, 0, 0.25);\n  border: 1px solid transparent;\n  border-radius: 100px;\n  cursor: pointer;\n  transition: all 0.36s;\n  user-select: none;\n}\n.ant-switch-inner {\n  display: block;\n  margin-right: 6px;\n  margin-left: 24px;\n  color: #fff;\n  font-size: 12px;\n}\n.ant-switch-loading-icon,\n.ant-switch::after {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  content: ' ';\n}\n.ant-switch::after {\n  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);\n}\n.ant-switch:not(.ant-switch-disabled):active::before,\n.ant-switch:not(.ant-switch-disabled):active::after {\n  width: 24px;\n}\n.ant-switch-loading-icon {\n  z-index: 1;\n  display: none;\n  font-size: 12px;\n  background: transparent;\n}\n.ant-switch-loading-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-switch-loading .ant-switch-loading-icon {\n  display: inline-block;\n  color: #545454;\n}\n.ant-switch-checked.ant-switch-loading .ant-switch-loading-icon {\n  color: #2EB1EF;\n}\n.ant-switch:focus {\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-switch:focus:hover {\n  box-shadow: none;\n}\n.ant-switch-small {\n  min-width: 28px;\n  height: 16px;\n  line-height: 14px;\n}\n.ant-switch-small .ant-switch-inner {\n  margin-right: 3px;\n  margin-left: 18px;\n  font-size: 12px;\n}\n.ant-switch-small::after {\n  width: 12px;\n  height: 12px;\n}\n.ant-switch-small:active::before,\n.ant-switch-small:active::after {\n  width: 16px;\n}\n.ant-switch-small .ant-switch-loading-icon {\n  width: 12px;\n  height: 12px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-inner {\n  margin-right: 18px;\n  margin-left: 3px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-loading-icon {\n  left: 100%;\n  margin-left: -13px;\n}\n.ant-switch-small.ant-switch-loading .ant-switch-loading-icon {\n  font-weight: bold;\n  transform: scale(0.66667);\n}\n.ant-switch-checked {\n  background-color: #2EB1EF;\n}\n.ant-switch-checked .ant-switch-inner {\n  margin-right: 24px;\n  margin-left: 6px;\n}\n.ant-switch-checked::after {\n  left: 100%;\n  margin-left: -1px;\n  transform: translateX(-100%);\n}\n.ant-switch-checked .ant-switch-loading-icon {\n  left: 100%;\n  margin-left: -19px;\n}\n.ant-switch-loading,\n.ant-switch-disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.ant-switch-loading *,\n.ant-switch-disabled * {\n  cursor: not-allowed;\n}\n.ant-switch-loading::before,\n.ant-switch-disabled::before,\n.ant-switch-loading::after,\n.ant-switch-disabled::after {\n  cursor: not-allowed;\n}\n@keyframes AntSwitchSmallLoadingCircle {\n  0% {\n    transform: rotate(0deg) scale(0.66667);\n    transform-origin: 50% 50%;\n  }\n  100% {\n    transform: rotate(360deg) scale(0.66667);\n    transform-origin: 50% 50%;\n  }\n}\n.ant-table-wrapper {\n  zoom: 1;\n}\n.ant-table-wrapper::before,\n.ant-table-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-table-wrapper::after {\n  clear: both;\n}\n.ant-table-wrapper::before,\n.ant-table-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-table-wrapper::after {\n  clear: both;\n}\n.ant-table {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  clear: both;\n}\n.ant-table-body {\n  transition: opacity 0.3s;\n}\n.ant-table-empty .ant-table-body {\n  overflow-x: auto !important;\n  overflow-y: hidden !important;\n}\n.ant-table table {\n  width: 100%;\n  text-align: left;\n  border-radius: 6px 6px 0 0;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ant-table-layout-fixed table {\n  table-layout: fixed;\n}\n.ant-table-thead > tr > th {\n  color: #535353;\n  font-weight: 500;\n  text-align: left;\n  background: #fafafa;\n  border-bottom: 1px solid #e8e8e8;\n  transition: background 0.3s ease;\n}\n.ant-table-thead > tr > th[colspan]:not([colspan='1']) {\n  text-align: center;\n}\n.ant-table-thead > tr > th .anticon-filter,\n.ant-table-thead > tr > th .ant-table-filter-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 28px;\n  height: 100%;\n  color: #bfbfbf;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-table-thead > tr > th .anticon-filter > svg,\n.ant-table-thead > tr > th .ant-table-filter-icon > svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -5px;\n  margin-left: -6px;\n}\n.ant-table-thead > tr > th .ant-table-filter-selected.anticon {\n  color: #2EB1EF;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner {\n  height: 1em;\n  margin-top: 0.35em;\n  margin-left: 0.57142857em;\n  color: #bfbfbf;\n  line-height: 1em;\n  text-align: center;\n  transition: all 0.3s;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 11px \\9;\n  transform: scale(0.91666667) rotate(0deg);\n  display: block;\n  height: 1em;\n  line-height: 1em;\n  transition: all 0.3s;\n}\n:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up,\n:root .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down {\n  font-size: 12px;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {\n  color: #2EB1EF;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full {\n  margin-top: -0.15em;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-up,\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {\n  height: 0.5em;\n  line-height: 0.5em;\n}\n.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner-full .ant-table-column-sorter-down {\n  margin-top: 0.125em;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions {\n  position: relative;\n  background-clip: padding-box;\n  /* stylelint-disable-next-line */\n  -webkit-background-clip: border-box;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {\n  padding-right: 30px !important;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .anticon-filter.ant-table-filter-open,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters .ant-table-filter-icon.ant-table-filter-open {\n  color: #595959;\n  background: #e5e5e5;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:hover,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:hover {\n  color: #595959;\n  background: #e5e5e5;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .anticon-filter:active,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters:hover .ant-table-filter-icon:active {\n  color: #545454;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {\n  cursor: pointer;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {\n  background: #f2f2f2;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .anticon-filter,\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover .ant-table-filter-icon {\n  background: #f2f2f2;\n}\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-up:not(.on),\n.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:active .ant-table-column-sorter-down:not(.on) {\n  color: #595959;\n}\n.ant-table-thead > tr > th .ant-table-header-column {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters {\n  display: table;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > .ant-table-column-title {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters > *:not(.ant-table-column-sorter) {\n  position: relative;\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  transition: all 0.3s;\n  content: '';\n}\n.ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters:hover::before {\n  background: rgba(0, 0, 0, 0.04);\n}\n.ant-table-thead > tr > th.ant-table-column-has-sorters {\n  user-select: none;\n}\n.ant-table-thead > tr:first-child > th:first-child {\n  border-top-left-radius: 6px;\n}\n.ant-table-thead > tr:first-child > th:last-child {\n  border-top-right-radius: 6px;\n}\n.ant-table-thead > tr:not(:last-child) > th[colspan] {\n  border-bottom: 0;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e8e8e8;\n  transition: all 0.3s, border 0s;\n}\n.ant-table-thead > tr,\n.ant-table-tbody > tr {\n  transition: all 0.3s, height 0s;\n}\n.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #f0fdff;\n}\n.ant-table-thead > tr.ant-table-row-selected > td.ant-table-column-sort,\n.ant-table-tbody > tr.ant-table-row-selected > td.ant-table-column-sort {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover.ant-table-row-selected > td,\n.ant-table-tbody > tr:hover.ant-table-row-selected > td {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover.ant-table-row-selected > td.ant-table-column-sort,\n.ant-table-tbody > tr:hover.ant-table-row-selected > td.ant-table-column-sort {\n  background: #fafafa;\n}\n.ant-table-thead > tr:hover {\n  background: none;\n}\n.ant-table-footer {\n  position: relative;\n  padding: 16px 16px;\n  color: #535353;\n  background: #fafafa;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-table-footer::before {\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #fafafa;\n  content: '';\n}\n.ant-table.ant-table-bordered .ant-table-footer {\n  border: 1px solid #e8e8e8;\n}\n.ant-table-title {\n  position: relative;\n  top: 1px;\n  padding: 16px 0;\n  border-radius: 6px 6px 0 0;\n}\n.ant-table.ant-table-bordered .ant-table-title {\n  padding-right: 16px;\n  padding-left: 16px;\n  border: 1px solid #e8e8e8;\n}\n.ant-table-title + .ant-table-content {\n  position: relative;\n  border-radius: 6px 6px 0 0;\n}\n.ant-table-bordered .ant-table-title + .ant-table-content,\n.ant-table-bordered .ant-table-title + .ant-table-content table,\n.ant-table-bordered .ant-table-title + .ant-table-content .ant-table-thead > tr:first-child > th {\n  border-radius: 0;\n}\n.ant-table-without-column-header .ant-table-title + .ant-table-content,\n.ant-table-without-column-header table {\n  border-radius: 0;\n}\n.ant-table-without-column-header.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-top: 1px solid #e8e8e8;\n  border-radius: 6px;\n}\n.ant-table-tbody > tr.ant-table-row-selected td {\n  color: inherit;\n  background: #fafafa;\n}\n.ant-table-thead > tr > th.ant-table-column-sort {\n  background: #f5f5f5;\n}\n.ant-table-tbody > tr > td.ant-table-column-sort {\n  background: rgba(0, 0, 0, 0.01);\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  padding: 16px 16px;\n  overflow-wrap: break-word;\n}\n.ant-table-expand-icon-th,\n.ant-table-row-expand-icon-cell {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n}\n.ant-table-header {\n  overflow: hidden;\n  background: #fafafa;\n}\n.ant-table-header table {\n  border-radius: 6px 6px 0 0;\n}\n.ant-table-loading {\n  position: relative;\n}\n.ant-table-loading .ant-table-body {\n  background: #fff;\n  opacity: 0.5;\n}\n.ant-table-loading .ant-table-spin-holder {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 20px;\n  margin-left: -30px;\n  line-height: 20px;\n}\n.ant-table-loading .ant-table-with-pagination {\n  margin-top: -20px;\n}\n.ant-table-loading .ant-table-without-pagination {\n  margin-top: 10px;\n}\n.ant-table-bordered .ant-table-header > table,\n.ant-table-bordered .ant-table-body > table,\n.ant-table-bordered .ant-table-fixed-left table,\n.ant-table-bordered .ant-table-fixed-right table {\n  border: 1px solid #e8e8e8;\n  border-right: 0;\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-right: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header + .ant-table-body > table,\n.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {\n  border-top: 0;\n}\n.ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-bordered .ant-table-thead > tr > th,\n.ant-table-bordered .ant-table-tbody > tr > td {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-placeholder {\n  position: relative;\n  z-index: 1;\n  margin-top: -1px;\n  padding: 16px 16px;\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  text-align: center;\n  background: #fff;\n  border-top: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-table-pagination.ant-pagination {\n  float: right;\n  margin: 16px 0;\n}\n.ant-table-filter-dropdown {\n  position: relative;\n  min-width: 96px;\n  margin-left: -8px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  max-height: calc(100vh - 130px);\n  overflow-x: hidden;\n  border: 0;\n  border-radius: 6px 6px 0 0;\n  box-shadow: none;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {\n  padding-right: 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-sub {\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title::after {\n  color: #2EB1EF;\n  font-weight: bold;\n  text-shadow: 0 0 2px #d4f7ff;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item {\n  overflow: hidden;\n}\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0;\n}\n.ant-table-filter-dropdown-btns {\n  padding: 7px 8px;\n  overflow: hidden;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-filter-dropdown-link {\n  color: #2EB1EF;\n}\n.ant-table-filter-dropdown-link:hover {\n  color: #58cefc;\n}\n.ant-table-filter-dropdown-link:active {\n  color: #1c8dc9;\n}\n.ant-table-filter-dropdown-link.confirm {\n  float: left;\n}\n.ant-table-filter-dropdown-link.clear {\n  float: right;\n}\n.ant-table-selection {\n  white-space: nowrap;\n}\n.ant-table-selection-select-all-custom {\n  margin-right: 4px !important;\n}\n.ant-table-selection .anticon-down {\n  color: #bfbfbf;\n  transition: all 0.3s;\n}\n.ant-table-selection-menu {\n  min-width: 96px;\n  margin-top: 5px;\n  margin-left: -30px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-table-selection-menu .ant-action-down {\n  color: #bfbfbf;\n}\n.ant-table-selection-down {\n  display: inline-block;\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n}\n.ant-table-selection-down:hover .anticon-down {\n  color: rgba(0, 0, 0, 0.6);\n}\n.ant-table-row-expand-icon {\n  color: #2EB1EF;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  color: inherit;\n  line-height: 13px;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  outline: none;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-table-row-expand-icon:focus,\n.ant-table-row-expand-icon:hover {\n  color: #58cefc;\n}\n.ant-table-row-expand-icon:active {\n  color: #1c8dc9;\n}\n.ant-table-row-expand-icon:focus,\n.ant-table-row-expand-icon:hover,\n.ant-table-row-expand-icon:active {\n  border-color: currentColor;\n}\n.ant-table-row-expanded::after {\n  content: '-';\n}\n.ant-table-row-collapsed::after {\n  content: '+';\n}\n.ant-table-row-spaced {\n  visibility: hidden;\n}\n.ant-table-row-spaced::after {\n  content: '.';\n}\n.ant-table-row-cell-ellipsis,\n.ant-table-row-cell-ellipsis .ant-table-column-title {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-table-row-cell-ellipsis .ant-table-column-title {\n  display: block;\n}\n.ant-table-row-cell-break-word {\n  word-wrap: break-word;\n  word-break: break-word;\n}\ntr.ant-table-expanded-row,\ntr.ant-table-expanded-row:hover {\n  background: #fbfbfb;\n}\ntr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -16px -16px -17px;\n}\n.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 8px;\n}\n.ant-table-scroll {\n  overflow: auto;\n  overflow-x: hidden;\n}\n.ant-table-scroll table {\n  min-width: 100%;\n}\n.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) {\n  color: transparent;\n}\n.ant-table-scroll table .ant-table-fixed-columns-in-body:not([colspan]) > * {\n  visibility: hidden;\n}\n.ant-table-body-inner {\n  height: 100%;\n}\n.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  position: relative;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-body-inner {\n  overflow: scroll;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  margin-bottom: -20px;\n  padding-bottom: 20px;\n  overflow: scroll;\n  opacity: 0.9999;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {\n  border: 1px solid #e8e8e8;\n  border-width: 0 0 1px 0;\n}\n.ant-table-hide-scrollbar {\n  scrollbar-color: transparent transparent;\n  min-width: unset;\n}\n.ant-table-hide-scrollbar::-webkit-scrollbar {\n  min-width: inherit;\n  background-color: transparent;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar {\n  border: 1px solid #e8e8e8;\n  border-width: 1px 1px 1px 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-scroll .ant-table-header.ant-table-hide-scrollbar .ant-table-thead > tr:only-child > th:last-child {\n  border-right-color: transparent;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-right {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  overflow: hidden;\n  border-radius: 0;\n  transition: box-shadow 0.3s ease;\n}\n.ant-table-fixed-left table,\n.ant-table-fixed-right table {\n  width: auto;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,\n.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {\n  border-radius: 0;\n}\n.ant-table-fixed-left {\n  left: 0;\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.ant-table-fixed-left .ant-table-header {\n  overflow-y: hidden;\n}\n.ant-table-fixed-left .ant-table-body-inner {\n  margin-right: -20px;\n  padding-right: 20px;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {\n  padding-right: 0;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-left table {\n  border-radius: 6px 0 0 0;\n}\n.ant-table-fixed-left .ant-table-thead > tr > th:last-child {\n  border-top-right-radius: 0;\n}\n.ant-table-fixed-right {\n  right: 0;\n  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.15);\n}\n.ant-table-fixed-right,\n.ant-table-fixed-right table {\n  border-radius: 0 6px 0 0;\n}\n.ant-table-fixed-right .ant-table-expanded-row {\n  color: transparent;\n  pointer-events: none;\n}\n.ant-table-fixed-right .ant-table-thead > tr > th:first-child {\n  border-top-left-radius: 0;\n}\n.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {\n  box-shadow: none;\n}\n.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {\n  box-shadow: none;\n}\n.ant-table colgroup > col.ant-table-selection-col {\n  width: 60px;\n}\n.ant-table-thead > tr > th.ant-table-selection-column-custom .ant-table-selection {\n  margin-right: -15px;\n}\n.ant-table-thead > tr > th.ant-table-selection-column,\n.ant-table-tbody > tr > td.ant-table-selection-column {\n  text-align: center;\n}\n.ant-table-thead > tr > th.ant-table-selection-column .ant-radio-wrapper,\n.ant-table-tbody > tr > td.ant-table-selection-column .ant-radio-wrapper {\n  margin-right: 0;\n}\n.ant-table-row[class*='ant-table-row-level-0'] .ant-table-selection-column > span {\n  display: inline-block;\n}\n.ant-table-filter-dropdown .ant-checkbox-wrapper + span,\n.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {\n  padding-left: 8px;\n}\n/**\n* Another fix of Firefox:\n*/\n@supports (-moz-appearance: meterbar) {\n  .ant-table-thead > tr > th.ant-table-column-has-actions {\n    background-clip: padding-box;\n  }\n}\n.ant-table-middle > .ant-table-title,\n.ant-table-middle > .ant-table-content > .ant-table-footer {\n  padding: 12px 8px;\n}\n.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-middle > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,\n.ant-table-middle > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {\n  padding: 12px 8px;\n}\n.ant-table-middle tr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -12px -8px -13px;\n}\n.ant-table-small {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n}\n.ant-table-small > .ant-table-title,\n.ant-table-small > .ant-table-content > .ant-table-footer {\n  padding: 8px 8px;\n}\n.ant-table-small > .ant-table-title {\n  top: 0;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-footer {\n  background-color: transparent;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-footer::before {\n  background-color: transparent;\n}\n.ant-table-small > .ant-table-content > .ant-table-body {\n  margin: 0 8px;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  border: 0;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-tbody > tr > td {\n  padding: 8px 8px;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th {\n  background-color: transparent;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th.ant-table-column-sort {\n  background-color: rgba(0, 0, 0, 0.01);\n}\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  padding: 0;\n}\n.ant-table-small > .ant-table-content .ant-table-header {\n  background-color: transparent;\n  border-radius: 6px 6px 0 0;\n}\n.ant-table-small > .ant-table-content .ant-table-placeholder,\n.ant-table-small > .ant-table-content .ant-table-row:last-child td {\n  border-bottom: 0;\n}\n.ant-table-small.ant-table-bordered {\n  border-right: 0;\n}\n.ant-table-small.ant-table-bordered .ant-table-title {\n  border: 0;\n  border-right: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-content {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-footer {\n  border: 0;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-footer::before {\n  display: none;\n}\n.ant-table-small.ant-table-bordered .ant-table-placeholder {\n  border-right: 0;\n  border-bottom: 0;\n  border-left: 0;\n}\n.ant-table-small.ant-table-bordered .ant-table-thead > tr > th.ant-table-row-cell-last,\n.ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child {\n  border-right: none;\n}\n.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-thead > tr > th:last-child,\n.ant-table-small.ant-table-bordered .ant-table-fixed-left .ant-table-tbody > tr > td:last-child {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-table-small.ant-table-bordered .ant-table-fixed-right {\n  border-right: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-table-small tr.ant-table-expanded-row td > .ant-table-wrapper {\n  margin: -8px -8px -9px;\n}\n.ant-table-small.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  border-radius: 0 0 6px 6px;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {\n  height: 40px;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-ink-bar {\n  visibility: hidden;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {\n  height: 40px;\n  margin: 0;\n  margin-right: 2px;\n  padding: 0 16px;\n  line-height: 38px;\n  background: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {\n  height: 40px;\n  color: #2EB1EF;\n  background: #fff;\n  border-color: #e8e8e8;\n  border-bottom: 1px solid #fff;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active::before {\n  border-top: 2px solid transparent;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-disabled {\n  color: #2EB1EF;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-inactive {\n  padding: 0;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-wrap {\n  margin-bottom: 0;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x {\n  width: 16px;\n  height: 16px;\n  height: 14px;\n  margin-right: -5px;\n  margin-left: 3px;\n  overflow: hidden;\n  color: #595959;\n  font-size: 12px;\n  vertical-align: middle;\n  transition: all 0.3s;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab .ant-tabs-close-x:hover {\n  color: #535353;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-content > .ant-tabs-tabpane,\n.ant-tabs.ant-tabs-editable-card .ant-tabs-card-content > .ant-tabs-tabpane {\n  transition: none !important;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-content > .ant-tabs-tabpane-inactive,\n.ant-tabs.ant-tabs-editable-card .ant-tabs-card-content > .ant-tabs-tabpane-inactive {\n  overflow: hidden;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:hover .anticon-close {\n  opacity: 1;\n}\n.ant-tabs-extra-content {\n  line-height: 42.2px;\n}\n.ant-tabs-extra-content .ant-tabs-new-tab {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  color: #545454;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: center;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-tabs-extra-content .ant-tabs-new-tab:hover {\n  color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-tabs-extra-content .ant-tabs-new-tab svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-tabs.ant-tabs-large .ant-tabs-extra-content {\n  line-height: 52.8px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-extra-content {\n  line-height: 34.2px;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-extra-content {\n  line-height: 40px;\n}\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-nav-container,\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-nav-container {\n  height: 100%;\n}\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab,\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab {\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab-active,\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab-active {\n  padding-bottom: 4px;\n}\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab:last-child,\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab:last-child {\n  margin-bottom: 8px;\n}\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-new-tab,\n.ant-tabs-vertical.ant-tabs-card .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-new-tab {\n  width: 90%;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-nav-wrap {\n  margin-right: 0;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab {\n  margin-right: 1px;\n  border-right: 0;\n  border-radius: 6px 0 0 6px;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left .ant-tabs-card-bar.ant-tabs-left-bar .ant-tabs-tab-active {\n  margin-right: -1px;\n  padding-right: 18px;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-nav-wrap {\n  margin-left: 0;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab {\n  margin-left: 1px;\n  border-left: 0;\n  border-radius: 0 6px 6px 0;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right .ant-tabs-card-bar.ant-tabs-right-bar .ant-tabs-tab-active {\n  margin-left: -1px;\n  padding-left: 18px;\n}\n.ant-tabs .ant-tabs-card-bar.ant-tabs-bottom-bar .ant-tabs-tab {\n  height: auto;\n  border-top: 0;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-tabs .ant-tabs-card-bar.ant-tabs-bottom-bar .ant-tabs-tab-active {\n  padding-top: 1px;\n  padding-bottom: 0;\n  color: #2EB1EF;\n}\n.ant-tabs {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  overflow: hidden;\n  zoom: 1;\n}\n.ant-tabs::before,\n.ant-tabs::after {\n  display: table;\n  content: '';\n}\n.ant-tabs::after {\n  clear: both;\n}\n.ant-tabs::before,\n.ant-tabs::after {\n  display: table;\n  content: '';\n}\n.ant-tabs::after {\n  clear: both;\n}\n.ant-tabs-ink-bar {\n  position: absolute;\n  bottom: 1px;\n  left: 0;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 0;\n  height: 2px;\n  background-color: #2EB1EF;\n  transform-origin: 0 0;\n}\n.ant-tabs-bar {\n  margin: 0 0 16px 0;\n  border-bottom: 1px solid #e8e8e8;\n  outline: none;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-nav-container {\n  position: relative;\n  box-sizing: border-box;\n  margin-bottom: -1px;\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 1.3;\n  white-space: nowrap;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  zoom: 1;\n}\n.ant-tabs-nav-container::before,\n.ant-tabs-nav-container::after {\n  display: table;\n  content: '';\n}\n.ant-tabs-nav-container::after {\n  clear: both;\n}\n.ant-tabs-nav-container::before,\n.ant-tabs-nav-container::after {\n  display: table;\n  content: '';\n}\n.ant-tabs-nav-container::after {\n  clear: both;\n}\n.ant-tabs-nav-container-scrolling {\n  padding-right: 32px;\n  padding-left: 32px;\n}\n.ant-tabs-bottom .ant-tabs-bottom-bar {\n  margin-top: 16px;\n  margin-bottom: 0;\n  border-top: 1px solid #e8e8e8;\n  border-bottom: none;\n}\n.ant-tabs-bottom .ant-tabs-bottom-bar .ant-tabs-ink-bar {\n  top: 1px;\n  bottom: auto;\n}\n.ant-tabs-bottom .ant-tabs-bottom-bar .ant-tabs-nav-container {\n  margin-top: -1px;\n  margin-bottom: 0;\n}\n.ant-tabs-tab-prev,\n.ant-tabs-tab-next {\n  position: absolute;\n  z-index: 2;\n  width: 0;\n  height: 100%;\n  color: #595959;\n  text-align: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  opacity: 0;\n  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n  pointer-events: none;\n}\n.ant-tabs-tab-prev.ant-tabs-tab-arrow-show,\n.ant-tabs-tab-next.ant-tabs-tab-arrow-show {\n  width: 32px;\n  height: 100%;\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-tabs-tab-prev:hover,\n.ant-tabs-tab-next:hover {\n  color: #545454;\n}\n.ant-tabs-tab-prev-icon,\n.ant-tabs-tab-next-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-weight: bold;\n  font-style: normal;\n  font-variant: normal;\n  line-height: inherit;\n  text-align: center;\n  text-transform: none;\n  transform: translate(-50%, -50%);\n}\n.ant-tabs-tab-prev-icon-target,\n.ant-tabs-tab-next-icon-target {\n  display: block;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n}\n:root .ant-tabs-tab-prev-icon-target,\n:root .ant-tabs-tab-next-icon-target {\n  font-size: 12px;\n}\n.ant-tabs-tab-btn-disabled {\n  cursor: not-allowed;\n}\n.ant-tabs-tab-btn-disabled,\n.ant-tabs-tab-btn-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-tabs-tab-next {\n  right: 2px;\n}\n.ant-tabs-tab-prev {\n  left: 0;\n}\n:root .ant-tabs-tab-prev {\n  filter: none;\n}\n.ant-tabs-nav-wrap {\n  margin-bottom: -1px;\n  overflow: hidden;\n}\n.ant-tabs-nav-scroll {\n  overflow: hidden;\n  white-space: nowrap;\n}\n.ant-tabs-nav {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-nav::before,\n.ant-tabs-nav::after {\n  display: table;\n  content: ' ';\n}\n.ant-tabs-nav::after {\n  clear: both;\n}\n.ant-tabs-nav .ant-tabs-tab {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  height: 100%;\n  margin: 0 32px 0 0;\n  padding: 12px 16px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-nav .ant-tabs-tab::before {\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 100%;\n  border-top: 2px solid transparent;\n  border-radius: 6px 6px 0 0;\n  transition: all 0.3s;\n  content: '';\n  pointer-events: none;\n}\n.ant-tabs-nav .ant-tabs-tab:last-child {\n  margin-right: 0;\n}\n.ant-tabs-nav .ant-tabs-tab:hover {\n  color: #58cefc;\n}\n.ant-tabs-nav .ant-tabs-tab:active {\n  color: #1c8dc9;\n}\n.ant-tabs-nav .ant-tabs-tab .anticon {\n  margin-right: 8px;\n}\n.ant-tabs-nav .ant-tabs-tab-active {\n  color: #2EB1EF;\n  font-weight: 500;\n}\n.ant-tabs-nav .ant-tabs-tab-disabled,\n.ant-tabs-nav .ant-tabs-tab-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-tabs .ant-tabs-large-bar .ant-tabs-nav-container {\n  font-size: 16px;\n}\n.ant-tabs .ant-tabs-large-bar .ant-tabs-tab {\n  padding: 16px;\n}\n.ant-tabs .ant-tabs-small-bar .ant-tabs-nav-container {\n  font-size: 14px;\n}\n.ant-tabs .ant-tabs-small-bar .ant-tabs-tab {\n  padding: 8px 16px;\n}\n.ant-tabs-content::before {\n  display: block;\n  overflow: hidden;\n  content: '';\n}\n.ant-tabs .ant-tabs-top-content,\n.ant-tabs .ant-tabs-bottom-content {\n  width: 100%;\n}\n.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane,\n.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane {\n  flex-shrink: 0;\n  width: 100%;\n  -webkit-backface-visibility: hidden;\n  opacity: 1;\n  transition: opacity 0.45s;\n}\n.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive,\n.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive {\n  height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive input,\n.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive input {\n  visibility: hidden;\n}\n.ant-tabs .ant-tabs-top-content.ant-tabs-content-animated,\n.ant-tabs .ant-tabs-bottom-content.ant-tabs-content-animated {\n  display: flex;\n  flex-direction: row;\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  will-change: margin-left;\n}\n.ant-tabs .ant-tabs-left-bar,\n.ant-tabs .ant-tabs-right-bar {\n  height: 100%;\n  border-bottom: 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-arrow-show,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-arrow-show {\n  width: 100%;\n  height: 32px;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-tab {\n  display: block;\n  float: none;\n  margin: 0 0 16px 0;\n  padding: 8px 24px;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab:last-child,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-tab:last-child {\n  margin-bottom: 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-extra-content,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-extra-content {\n  text-align: center;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-scroll,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-scroll {\n  width: auto;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container,\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {\n  height: 100%;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container {\n  margin-bottom: 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {\n  padding: 32px 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {\n  margin-bottom: 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav {\n  width: 100%;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-ink-bar {\n  top: 0;\n  bottom: auto;\n  left: auto;\n  width: 2px;\n  height: 0;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-next,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-next {\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 32px;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab-prev,\n.ant-tabs .ant-tabs-right-bar .ant-tabs-tab-prev {\n  top: 0;\n  width: 100%;\n  height: 32px;\n}\n.ant-tabs .ant-tabs-left-content,\n.ant-tabs .ant-tabs-right-content {\n  width: auto;\n  margin-top: 0 !important;\n  overflow: hidden;\n}\n.ant-tabs .ant-tabs-left-bar {\n  float: left;\n  margin-right: -1px;\n  margin-bottom: 0;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-tab {\n  text-align: right;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-container {\n  margin-right: -1px;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-nav-wrap {\n  margin-right: -1px;\n}\n.ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar {\n  right: 1px;\n}\n.ant-tabs .ant-tabs-left-content {\n  padding-left: 24px;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-tabs .ant-tabs-right-bar {\n  float: right;\n  margin-bottom: 0;\n  margin-left: -1px;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-container {\n  margin-left: -1px;\n}\n.ant-tabs .ant-tabs-right-bar .ant-tabs-nav-wrap {\n  margin-left: -1px;\n}\n.ant-tabs .ant-tabs-right-bar .ant-tabs-ink-bar {\n  left: 1px;\n}\n.ant-tabs .ant-tabs-right-content {\n  padding-right: 24px;\n  border-right: 1px solid #e8e8e8;\n}\n.ant-tabs-top .ant-tabs-ink-bar-animated,\n.ant-tabs-bottom .ant-tabs-ink-bar-animated {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-left .ant-tabs-ink-bar-animated,\n.ant-tabs-right .ant-tabs-ink-bar-animated {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.no-flex > .ant-tabs-content > .ant-tabs-content-animated,\n.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-content-animated {\n  margin-left: 0 !important;\n  transform: none !important;\n}\n.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive,\n.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive {\n  height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive input,\n.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive input {\n  visibility: hidden;\n}\n.ant-tabs-left-content > .ant-tabs-content-animated,\n.ant-tabs-right-content > .ant-tabs-content-animated {\n  margin-left: 0 !important;\n  transform: none !important;\n}\n.ant-tabs-left-content > .ant-tabs-tabpane-inactive,\n.ant-tabs-right-content > .ant-tabs-tabpane-inactive {\n  height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-tabs-left-content > .ant-tabs-tabpane-inactive input,\n.ant-tabs-right-content > .ant-tabs-tabpane-inactive input {\n  visibility: hidden;\n}\n.ant-tag {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  height: auto;\n  margin-right: 8px;\n  padding: 0 7px;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  background: #fafafa;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  cursor: default;\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-tag:hover {\n  opacity: 0.85;\n}\n.ant-tag,\n.ant-tag a,\n.ant-tag a:hover {\n  color: #545454;\n}\n.ant-tag > a:first-child:last-child {\n  display: inline-block;\n  margin: 0 -8px;\n  padding: 0 8px;\n}\n.ant-tag .anticon-close {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  margin-left: 3px;\n  color: #595959;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n:root .ant-tag .anticon-close {\n  font-size: 12px;\n}\n.ant-tag .anticon-close:hover {\n  color: #535353;\n}\n.ant-tag-has-color {\n  border-color: transparent;\n}\n.ant-tag-has-color,\n.ant-tag-has-color a,\n.ant-tag-has-color a:hover,\n.ant-tag-has-color .anticon-close,\n.ant-tag-has-color .anticon-close:hover {\n  color: #fff;\n}\n.ant-tag-checkable {\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #2EB1EF;\n}\n.ant-tag-checkable:active,\n.ant-tag-checkable-checked {\n  color: #fff;\n}\n.ant-tag-checkable-checked {\n  background-color: #2EB1EF;\n}\n.ant-tag-checkable:active {\n  background-color: #1c8dc9;\n}\n.ant-tag-hidden {\n  display: none;\n}\n.ant-tag-pink {\n  color: #eb2f96;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-pink-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-magenta {\n  color: #eb2f96;\n  background: #fff0f6;\n  border-color: #ffadd2;\n}\n.ant-tag-magenta-inverse {\n  color: #fff;\n  background: #eb2f96;\n  border-color: #eb2f96;\n}\n.ant-tag-red {\n  color: #f5222d;\n  background: #fff1f0;\n  border-color: #ffa39e;\n}\n.ant-tag-red-inverse {\n  color: #fff;\n  background: #f5222d;\n  border-color: #f5222d;\n}\n.ant-tag-volcano {\n  color: #fa541c;\n  background: #fff2e8;\n  border-color: #ffbb96;\n}\n.ant-tag-volcano-inverse {\n  color: #fff;\n  background: #fa541c;\n  border-color: #fa541c;\n}\n.ant-tag-orange {\n  color: #fa8c16;\n  background: #fff7e6;\n  border-color: #ffd591;\n}\n.ant-tag-orange-inverse {\n  color: #fff;\n  background: #fa8c16;\n  border-color: #fa8c16;\n}\n.ant-tag-yellow {\n  color: #fadb14;\n  background: #feffe6;\n  border-color: #fffb8f;\n}\n.ant-tag-yellow-inverse {\n  color: #fff;\n  background: #fadb14;\n  border-color: #fadb14;\n}\n.ant-tag-gold {\n  color: #faad14;\n  background: #fffbe6;\n  border-color: #ffe58f;\n}\n.ant-tag-gold-inverse {\n  color: #fff;\n  background: #faad14;\n  border-color: #faad14;\n}\n.ant-tag-cyan {\n  color: #13c2c2;\n  background: #e6fffb;\n  border-color: #87e8de;\n}\n.ant-tag-cyan-inverse {\n  color: #fff;\n  background: #13c2c2;\n  border-color: #13c2c2;\n}\n.ant-tag-lime {\n  color: #a0d911;\n  background: #fcffe6;\n  border-color: #eaff8f;\n}\n.ant-tag-lime-inverse {\n  color: #fff;\n  background: #a0d911;\n  border-color: #a0d911;\n}\n.ant-tag-green {\n  color: #52c41a;\n  background: #f6ffed;\n  border-color: #b7eb8f;\n}\n.ant-tag-green-inverse {\n  color: #fff;\n  background: #52c41a;\n  border-color: #52c41a;\n}\n.ant-tag-blue {\n  color: #1890ff;\n  background: #e6f7ff;\n  border-color: #91d5ff;\n}\n.ant-tag-blue-inverse {\n  color: #fff;\n  background: #1890ff;\n  border-color: #1890ff;\n}\n.ant-tag-geekblue {\n  color: #2f54eb;\n  background: #f0f5ff;\n  border-color: #adc6ff;\n}\n.ant-tag-geekblue-inverse {\n  color: #fff;\n  background: #2f54eb;\n  border-color: #2f54eb;\n}\n.ant-tag-purple {\n  color: #722ed1;\n  background: #f9f0ff;\n  border-color: #d3adf7;\n}\n.ant-tag-purple-inverse {\n  color: #fff;\n  background: #722ed1;\n  border-color: #722ed1;\n}\n.ant-time-picker-panel {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1050;\n  font-family: \"DM Sans\", sans-serif;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  left: -2px;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 6px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-time-picker-panel-input {\n  width: 100%;\n  max-width: 154px;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  border: 0;\n  outline: 0;\n  cursor: auto;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-panel-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-time-picker-panel-input-wrap {\n  position: relative;\n  padding: 7px 2px 7px 12px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: #f5222d;\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  position: relative;\n  float: left;\n  width: 56px;\n  max-height: 192px;\n  overflow: hidden;\n  font-size: 14px;\n  border-left: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  margin-left: 0;\n  border-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  width: 56px;\n  margin: 0;\n  padding: 0 0 160px;\n  list-style: none;\n}\n.ant-time-picker-panel-select li {\n  width: 100%;\n  height: 32px;\n  margin: 0;\n  padding: 0 0 0 12px;\n  line-height: 32px;\n  text-align: left;\n  list-style: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  user-select: none;\n}\n.ant-time-picker-panel-select li:focus {\n  color: #2EB1EF;\n  font-weight: 600;\n  outline: none;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #f0fdff;\n}\nli.ant-time-picker-panel-select-option-selected {\n  font-weight: 600;\n  background: #f5f5f5;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f5f5f5;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\nli.ant-time-picker-panel-select-option-disabled:focus {\n  color: rgba(0, 0, 0, 0.25);\n  font-weight: inherit;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox::before,\n.ant-time-picker-panel-combobox::after {\n  display: table;\n  content: '';\n}\n.ant-time-picker-panel-combobox::after {\n  clear: both;\n}\n.ant-time-picker-panel-combobox::before,\n.ant-time-picker-panel-combobox::after {\n  display: table;\n  content: '';\n}\n.ant-time-picker-panel-combobox::after {\n  clear: both;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e8e8e8;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 128px;\n  outline: none;\n  cursor: text;\n  transition: opacity 0.3s;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 36px;\n  padding: 4px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: #bfbfbf;\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: #bfbfbf;\n}\n.ant-time-picker-input:placeholder-shown {\n  text-overflow: ellipsis;\n}\n.ant-time-picker-input:hover {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-input:focus {\n  border-color: #58cefc;\n  border-right-width: 1px !important;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(46, 177, 239, 0.2);\n}\n.ant-time-picker-input-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  min-height: 36px;\n  line-height: 1.3;\n  vertical-align: bottom;\n  transition: all 0.3s, height 0s;\n}\n.ant-time-picker-input-lg {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-time-picker-input-sm {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-time-picker-input[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 1;\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #d9d9d9;\n  border-right-width: 1px !important;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon,\n.ant-time-picker-clear {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -7px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 14px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  user-select: none;\n}\n.ant-time-picker-icon .ant-time-picker-clock-icon,\n.ant-time-picker-clear .ant-time-picker-clock-icon {\n  display: block;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 1;\n}\n.ant-time-picker-clear {\n  z-index: 2;\n  background: #fff;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-time-picker-clear:hover {\n  color: #595959;\n}\n.ant-time-picker:hover .ant-time-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  height: 40px;\n  padding: 6px 11px;\n  font-size: 16px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  height: 24px;\n  padding: 1px 7px;\n}\n.ant-time-picker-small .ant-time-picker-icon,\n.ant-time-picker-small .ant-time-picker-clear {\n  right: 7px;\n}\n@media not all and (min-resolution: 0.001dpcm) {\n  @supports (-webkit-appearance: none) and (stroke-color: transparent) {\n    .ant-input {\n      line-height: 1.3;\n    }\n  }\n}\n.ant-timeline {\n  box-sizing: border-box;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  font-feature-settings: 'tnum';\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-timeline-item {\n  position: relative;\n  margin: 0;\n  padding: 0 0 20px;\n  font-size: 14px;\n  list-style: none;\n}\n.ant-timeline-item-tail {\n  position: absolute;\n  top: 10px;\n  left: 4px;\n  height: calc(90%);\n  border-left: 2px solid #e8e8e8;\n}\n.ant-timeline-item-pending .ant-timeline-item-head {\n  font-size: 12px;\n  background-color: transparent;\n}\n.ant-timeline-item-pending .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline-item-head {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #fff;\n  border: 2px solid transparent;\n  border-radius: 100px;\n}\n.ant-timeline-item-head-blue {\n  color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-timeline-item-head-red {\n  color: #f5222d;\n  border-color: #f5222d;\n}\n.ant-timeline-item-head-green {\n  color: #52c41a;\n  border-color: #52c41a;\n}\n.ant-timeline-item-head-gray {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-timeline-item-head-custom {\n  position: absolute;\n  top: 5.5px;\n  left: 5px;\n  width: auto;\n  height: auto;\n  margin-top: 0;\n  padding: 3px 1px;\n  line-height: 1;\n  text-align: center;\n  border: 0;\n  border-radius: 0;\n  transform: translate(-50%, -50%);\n}\n.ant-timeline-item-content {\n  position: relative;\n  top: -3.2px;\n  margin: 0 0 0 18px;\n  word-break: break-word;\n}\n.ant-timeline-item-last > .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline-item-last > .ant-timeline-item-content {\n  min-height: 48px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-right .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head,\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {\n  left: 50%;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head {\n  margin-left: -4px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-head-custom,\n.ant-timeline.ant-timeline-right .ant-timeline-item-head-custom {\n  margin-left: 1px;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content,\n.ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {\n  left: calc(46%);\n  width: calc(36%);\n  text-align: left;\n}\n.ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {\n  width: calc(38%);\n  margin: 0;\n  text-align: right;\n}\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-tail,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head,\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-head-custom {\n  left: calc(94%);\n}\n.ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {\n  width: calc(82%);\n}\n.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {\n  display: block;\n  height: calc(86%);\n  border-left: 2px dotted #e8e8e8;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-last .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-tail {\n  top: 15px;\n  display: block;\n  height: calc(85%);\n  border-left: 2px dotted #e8e8e8;\n}\n.ant-timeline.ant-timeline-reverse .ant-timeline-item-pending .ant-timeline-item-content {\n  min-height: 48px;\n}\n.ant-tooltip {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  z-index: 1060;\n  display: block;\n  max-width: 250px;\n  visibility: visible;\n}\n.ant-tooltip-hidden {\n  display: none;\n}\n.ant-tooltip-placement-top,\n.ant-tooltip-placement-topLeft,\n.ant-tooltip-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-tooltip-placement-right,\n.ant-tooltip-placement-rightTop,\n.ant-tooltip-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-tooltip-placement-bottom,\n.ant-tooltip-placement-bottomLeft,\n.ant-tooltip-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-tooltip-placement-left,\n.ant-tooltip-placement-leftTop,\n.ant-tooltip-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-tooltip-inner {\n  min-width: 30px;\n  min-height: 32px;\n  padding: 6px 8px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  word-wrap: break-word;\n  background-color: rgba(0, 0, 0, 0.75);\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.ant-tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 13.07106781px;\n  height: 13.07106781px;\n  overflow: hidden;\n  background: transparent;\n  pointer-events: none;\n}\n.ant-tooltip-arrow::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 5px;\n  height: 5px;\n  margin: auto;\n  background-color: rgba(0, 0, 0, 0.75);\n  content: '';\n  pointer-events: auto;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  bottom: -5.07106781px;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow::before,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow::before,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow::before {\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(-6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  right: 13px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  left: -5.07106781px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow::before,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow::before,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow::before {\n  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  right: -5.07106781px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow::before,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow::before,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow::before {\n  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateX(-6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow {\n  top: 5px;\n}\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  bottom: 5px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  top: -5.07106781px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow::before,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow::before,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow::before {\n  box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.07);\n  transform: translateY(6.53553391px) rotate(45deg);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {\n  left: 13px;\n}\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  right: 13px;\n}\n.ant-transfer-customize-list {\n  display: flex;\n}\n.ant-transfer-customize-list .ant-transfer-operation {\n  flex: none;\n  align-self: center;\n}\n.ant-transfer-customize-list .ant-transfer-list {\n  flex: auto;\n  width: auto;\n  height: auto;\n  min-height: 200px;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-with-search {\n  padding-top: 0;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-search-wrapper {\n  position: relative;\n  padding-bottom: 0;\n}\n.ant-transfer-customize-list .ant-transfer-list-body-customize-wrapper {\n  padding: 12px;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small {\n  border: 0;\n  border-radius: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {\n  background: #fafafa;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small > .ant-table-content .ant-table-row:last-child td {\n  border-bottom: 1px solid #e8e8e8;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-small .ant-table-body {\n  margin: 0;\n}\n.ant-transfer-customize-list .ant-table-wrapper .ant-table-pagination.ant-pagination {\n  margin: 16px 0 4px;\n}\n.ant-transfer {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n}\n.ant-transfer-disabled .ant-transfer-list {\n  background: #f5f5f5;\n}\n.ant-transfer-list {\n  position: relative;\n  display: inline-block;\n  width: 180px;\n  height: 200px;\n  padding-top: 40px;\n  vertical-align: middle;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-transfer-list-with-footer {\n  padding-bottom: 34px;\n}\n.ant-transfer-list-search {\n  padding: 0 24px 0 8px;\n}\n.ant-transfer-list-search-action {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  bottom: 12px;\n  width: 28px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 36px;\n  text-align: center;\n}\n.ant-transfer-list-search-action .anticon {\n  color: rgba(0, 0, 0, 0.25);\n  transition: all 0.3s;\n}\n.ant-transfer-list-search-action .anticon:hover {\n  color: #595959;\n}\nspan.ant-transfer-list-search-action {\n  pointer-events: none;\n}\n.ant-transfer-list-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 9.4px 12px 10.4px;\n  overflow: hidden;\n  color: #545454;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 6px 6px 0 0;\n}\n.ant-transfer-list-header-title {\n  position: absolute;\n  right: 12px;\n}\n.ant-transfer-list-header .ant-checkbox-wrapper + span {\n  padding-left: 8px;\n}\n.ant-transfer-list-body {\n  position: relative;\n  height: 100%;\n  font-size: 14px;\n}\n.ant-transfer-list-body-search-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 12px;\n}\n.ant-transfer-list-body-with-search {\n  padding-top: 60px;\n}\n.ant-transfer-list-content {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  list-style: none;\n}\n.ant-transfer-list-content > .LazyLoad {\n  animation: transferHighlightIn 1s;\n}\n.ant-transfer-list-content-item {\n  min-height: 32px;\n  padding: 6px 12px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-transfer-list-content-item > span {\n  padding-right: 0;\n}\n.ant-transfer-list-content-item-text {\n  padding-left: 8px;\n}\n.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {\n  background-color: #f0fdff;\n  cursor: pointer;\n}\n.ant-transfer-list-content-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-transfer-list-body-not-found {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 0;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n  transform: translateY(-50%);\n}\n.ant-transfer-list-body-with-search .ant-transfer-list-body-not-found {\n  margin-top: 18px;\n}\n.ant-transfer-list-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n}\n.ant-transfer-operation {\n  display: inline-block;\n  margin: 0 8px;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.ant-transfer-operation .ant-btn {\n  display: block;\n}\n.ant-transfer-operation .ant-btn:first-child {\n  margin-bottom: 4px;\n}\n.ant-transfer-operation .ant-btn .anticon {\n  font-size: 12px;\n}\n@keyframes transferHighlightIn {\n  0% {\n    background: #d4f7ff;\n  }\n  100% {\n    background: transparent;\n  }\n}\n.ant-tree.ant-tree-directory {\n  position: relative;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-switcher,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-switcher {\n  position: relative;\n  z-index: 1;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-switcher.ant-tree-switcher-noop,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-switcher.ant-tree-switcher-noop {\n  pointer-events: none;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-checkbox,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-checkbox {\n  position: relative;\n  z-index: 1;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper {\n  border-radius: 0;\n  user-select: none;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper:hover,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper:hover::before,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper:hover::before {\n  background: #f0fdff;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper.ant-tree-node-selected,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper.ant-tree-node-selected {\n  color: #fff;\n  background: transparent;\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before {\n  position: absolute;\n  right: 0;\n  left: 0;\n  height: 24px;\n  transition: all 0.3s;\n  content: '';\n}\n.ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper > span,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper > span {\n  position: relative;\n  z-index: 1;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-switcher,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-switcher {\n  color: #fff;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox .ant-tree-checkbox-inner,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox .ant-tree-checkbox-inner {\n  border-color: #2EB1EF;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked::after,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked::after {\n  border-color: #fff;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner {\n  background: #fff;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-checkbox.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {\n  border-color: #2EB1EF;\n}\n.ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,\n.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before {\n  background: #2EB1EF;\n}\n.ant-tree-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: -0.09em;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: middle;\n  outline: none;\n  cursor: pointer;\n}\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,\n.ant-tree-checkbox:hover .ant-tree-checkbox-inner,\n.ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {\n  border-color: #2EB1EF;\n}\n.ant-tree-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #2EB1EF;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-tree-checkbox:hover::after,\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox::after {\n  visibility: visible;\n}\n.ant-tree-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-tree-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 22%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-tree-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-tree-checkbox-checked .ant-tree-checkbox-inner {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-tree-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-disabled.ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-tree-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-disabled:hover::after,\n.ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-tree-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-tree-checkbox-wrapper.ant-tree-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-tree-checkbox-wrapper + .ant-tree-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-tree-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-tree-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-tree-checkbox-group-item {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-tree-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-tree-checkbox-group-item + .ant-tree-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #2EB1EF;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-tree-checkbox-indeterminate.ant-tree-checkbox-disabled .ant-tree-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-tree {\n  /* see https://github.com/ant-design/ant-design/issues/16259 */\n  box-sizing: border-box;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin: 0;\n  padding: 0;\n}\n.ant-tree-checkbox-checked::after {\n  position: absolute;\n  top: 16.67%;\n  left: 0;\n  width: 100%;\n  height: 66.67%;\n}\n.ant-tree ol,\n.ant-tree ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.ant-tree li {\n  margin: 0;\n  padding: 4px 0;\n  white-space: nowrap;\n  list-style: none;\n  outline: 0;\n}\n.ant-tree li span[draggable],\n.ant-tree li span[draggable='true'] {\n  line-height: 20px;\n  border-top: 2px transparent solid;\n  border-bottom: 2px transparent solid;\n  user-select: none;\n  /* Required to make elements draggable in old WebKit */\n  -khtml-user-drag: element;\n  -webkit-user-drag: element;\n}\n.ant-tree li.drag-over > span[draggable] {\n  color: white;\n  background-color: #2EB1EF;\n  opacity: 0.8;\n}\n.ant-tree li.drag-over-gap-top > span[draggable] {\n  border-top-color: #2EB1EF;\n}\n.ant-tree li.drag-over-gap-bottom > span[draggable] {\n  border-bottom-color: #2EB1EF;\n}\n.ant-tree li.filter-node > span {\n  color: #f5222d !important;\n  font-weight: 500 !important;\n}\n.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-loading-icon,\n.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-loading-icon {\n  position: absolute;\n  left: 0;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  color: #2EB1EF;\n  font-size: 14px;\n  transform: none;\n}\n.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-loading-icon svg,\n.ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-loading-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n:root .ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_open::after,\n:root .ant-tree li.ant-tree-treenode-loading span.ant-tree-switcher.ant-tree-switcher_close::after {\n  opacity: 0;\n}\n.ant-tree li ul {\n  margin: 0;\n  padding: 0 0 0 18px;\n}\n.ant-tree li .ant-tree-node-content-wrapper {\n  display: inline-block;\n  height: 24px;\n  margin: 0;\n  padding: 0 5px;\n  color: #545454;\n  line-height: 24px;\n  text-decoration: none;\n  vertical-align: top;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-tree li .ant-tree-node-content-wrapper:hover {\n  background-color: #f0fdff;\n}\n.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: #d4f7ff;\n}\n.ant-tree li span.ant-tree-checkbox {\n  top: initial;\n  height: 24px;\n  margin: 0 4px 0 2px;\n  padding: 4px 0;\n}\n.ant-tree li span.ant-tree-switcher,\n.ant-tree li span.ant-tree-iconEle {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 24px;\n  text-align: center;\n  vertical-align: top;\n  border: 0 none;\n  outline: none;\n  cursor: pointer;\n}\n.ant-tree li span.ant-tree-iconEle:empty {\n  display: none;\n}\n.ant-tree li span.ant-tree-switcher {\n  position: relative;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {\n  cursor: default;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  display: inline-block;\n  font-weight: bold;\n}\n:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,\n:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {\n  font-size: 12px;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon svg,\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  display: inline-block;\n  font-weight: bold;\n}\n:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,\n:root .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {\n  font-size: 12px;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg,\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {\n  transform: rotate(-90deg);\n}\n.ant-tree li:last-child > span.ant-tree-switcher::before,\n.ant-tree li:last-child > span.ant-tree-iconEle::before {\n  display: none;\n}\n.ant-tree > li:first-child {\n  padding-top: 7px;\n}\n.ant-tree > li:last-child {\n  padding-bottom: 7px;\n}\n.ant-tree-child-tree > li:first-child {\n  padding-top: 8px;\n}\n.ant-tree-child-tree > li:last-child {\n  padding-bottom: 0;\n}\nli.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),\nli.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,\nli.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nli.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-tree-icon__open {\n  margin-right: 2px;\n  vertical-align: top;\n}\n.ant-tree-icon__close {\n  margin-right: 2px;\n  vertical-align: top;\n}\n.ant-tree.ant-tree-show-line li {\n  position: relative;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher {\n  color: #595959;\n  background: #fff;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-tree-switcher-icon,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-select-switcher-icon {\n  display: inline-block;\n  font-weight: normal;\n  font-size: 12px;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-tree-switcher-icon svg,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher-noop .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {\n  display: inline-block;\n  font-weight: normal;\n  font-size: 12px;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon svg,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon {\n  display: inline-block;\n  font-weight: normal;\n  font-size: 12px;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg,\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher.ant-tree-switcher_close .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-tree.ant-tree-show-line li:not(:last-child)::before {\n  position: absolute;\n  left: 12px;\n  width: 1px;\n  height: 100%;\n  height: calc(78%);\n  margin: 22px 0 0;\n  border-left: 1px solid #d9d9d9;\n  content: ' ';\n}\n.ant-tree.ant-tree-icon-hide .ant-tree-treenode-loading .ant-tree-iconEle {\n  display: none;\n}\n.ant-tree.ant-tree-block-node li .ant-tree-node-content-wrapper {\n  width: calc(100% - 24px);\n}\n.ant-tree.ant-tree-block-node li span.ant-tree-checkbox + .ant-tree-node-content-wrapper {\n  width: calc(100% - 46px);\n}\n.ant-select-tree-checkbox {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  top: -0.09em;\n  display: inline-block;\n  line-height: 1;\n  white-space: nowrap;\n  vertical-align: middle;\n  outline: none;\n  cursor: pointer;\n}\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,\n.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,\n.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner {\n  border-color: #2EB1EF;\n}\n.ant-select-tree-checkbox-checked::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #2EB1EF;\n  border-radius: 4px;\n  visibility: hidden;\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: backwards;\n  content: '';\n}\n.ant-select-tree-checkbox:hover::after,\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox::after {\n  visibility: visible;\n}\n.ant-select-tree-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  border-collapse: separate;\n  transition: all 0.3s;\n}\n.ant-select-tree-checkbox-inner::after {\n  position: absolute;\n  top: 50%;\n  left: 22%;\n  display: table;\n  width: 5.71428571px;\n  height: 9.14285714px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(0) translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n  content: ' ';\n}\n.ant-select-tree-checkbox-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n}\n.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {\n  position: absolute;\n  display: table;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: rotate(45deg) scale(1) translate(-50%, -50%);\n  opacity: 1;\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n  content: ' ';\n}\n.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-select-tree-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner::after {\n  border-color: rgba(0, 0, 0, 0.25);\n  animation-name: none;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {\n  background-color: #f5f5f5;\n  border-color: #d9d9d9 !important;\n}\n.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {\n  border-color: #f5f5f5;\n  border-collapse: separate;\n  animation-name: none;\n}\n.ant-select-tree-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-disabled:hover::after,\n.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-disabled::after {\n  visibility: hidden;\n}\n.ant-select-tree-checkbox-wrapper {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n  line-height: unset;\n  cursor: pointer;\n}\n.ant-select-tree-checkbox-wrapper.ant-select-tree-checkbox-wrapper-disabled {\n  cursor: not-allowed;\n}\n.ant-select-tree-checkbox-wrapper + .ant-select-tree-checkbox-wrapper {\n  margin-left: 8px;\n}\n.ant-select-tree-checkbox + span {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-select-tree-checkbox-group {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  display: inline-block;\n}\n.ant-select-tree-checkbox-group-item {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-select-tree-checkbox-group-item:last-child {\n  margin-right: 0;\n}\n.ant-select-tree-checkbox-group-item + .ant-select-tree-checkbox-group-item {\n  margin-left: 0;\n}\n.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: #2EB1EF;\n  border: 0;\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  content: ' ';\n}\n.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner::after {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-tree {\n  box-sizing: border-box;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin: 0;\n  margin-top: -4px;\n  padding: 0 4px;\n}\n.ant-select-tree li {\n  margin: 8px 0;\n  padding: 0;\n  white-space: nowrap;\n  list-style: none;\n  outline: 0;\n}\n.ant-select-tree li.filter-node > span {\n  font-weight: 500;\n}\n.ant-select-tree li ul {\n  margin: 0;\n  padding: 0 0 0 18px;\n}\n.ant-select-tree li .ant-select-tree-node-content-wrapper {\n  display: inline-block;\n  width: calc(100% - 24px);\n  margin: 0;\n  padding: 3px 5px;\n  color: #545454;\n  text-decoration: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-select-tree li .ant-select-tree-node-content-wrapper:hover {\n  background-color: #f0fdff;\n}\n.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {\n  background-color: #d4f7ff;\n}\n.ant-select-tree li span.ant-select-tree-checkbox {\n  margin: 0 4px 0 0;\n}\n.ant-select-tree li span.ant-select-tree-checkbox + .ant-select-tree-node-content-wrapper {\n  width: calc(100% - 46px);\n}\n.ant-select-tree li span.ant-select-tree-switcher,\n.ant-select-tree li span.ant-select-tree-iconEle {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  line-height: 22px;\n  text-align: center;\n  vertical-align: middle;\n  border: 0 none;\n  outline: none;\n  cursor: pointer;\n}\n.ant-select-tree li span.ant-select-icon_loading .ant-select-switcher-loading-icon {\n  position: absolute;\n  left: 0;\n  display: inline-block;\n  color: #2EB1EF;\n  font-size: 14px;\n  transform: none;\n}\n.ant-select-tree li span.ant-select-icon_loading .ant-select-switcher-loading-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-select-tree li span.ant-select-tree-switcher {\n  position: relative;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher-noop {\n  cursor: auto;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon {\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  display: inline-block;\n  font-weight: bold;\n}\n:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon,\n:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon {\n  font-size: 12px;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-tree-switcher-icon svg,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon {\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  display: inline-block;\n  font-weight: bold;\n}\n:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon,\n:root .ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon {\n  font-size: 12px;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-tree-switcher-icon svg,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon svg {\n  transition: transform 0.3s;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-icon svg {\n  transform: rotate(-90deg);\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-loading-icon,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-loading-icon {\n  position: absolute;\n  left: 0;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  color: #2EB1EF;\n  font-size: 14px;\n  transform: none;\n}\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_open .ant-select-switcher-loading-icon svg,\n.ant-select-tree li span.ant-select-tree-switcher.ant-select-tree-switcher_close .ant-select-switcher-loading-icon svg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n}\n.ant-select-tree .ant-select-tree-treenode-loading .ant-select-tree-iconEle {\n  display: none;\n}\n.ant-select-tree-child-tree {\n  display: none;\n}\n.ant-select-tree-child-tree-open {\n  display: block;\n}\nli.ant-select-tree-treenode-disabled > span:not(.ant-select-tree-switcher),\nli.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper,\nli.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nli.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper:hover {\n  background: transparent;\n}\n.ant-select-tree-icon__open {\n  margin-right: 2px;\n  vertical-align: top;\n}\n.ant-select-tree-icon__close {\n  margin-right: 2px;\n  vertical-align: top;\n}\n.ant-select-tree-dropdown {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n}\n.ant-select-tree-dropdown .ant-select-dropdown-search {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  display: block;\n  padding: 4px;\n  background: #fff;\n}\n.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field__wrap {\n  width: 100%;\n}\n.ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 4px 7px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-select-tree-dropdown .ant-select-dropdown-search.ant-select-search--hide {\n  display: none;\n}\n.ant-select-tree-dropdown .ant-select-not-found {\n  display: block;\n  padding: 7px 16px;\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-typography {\n  color: #545454;\n}\n.ant-typography.ant-typography-secondary {\n  color: #595959;\n}\n.ant-typography.ant-typography-warning {\n  color: #fa8c16;\n}\n.ant-typography.ant-typography-danger {\n  color: #f5222d;\n}\n.ant-typography.ant-typography-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  user-select: none;\n}\ndiv.ant-typography,\n.ant-typography p {\n  margin-bottom: 1em;\n}\nh1.ant-typography,\n.ant-typography h1 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 38px;\n  line-height: 1.23;\n}\nh2.ant-typography,\n.ant-typography h2 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 1.35;\n}\nh3.ant-typography,\n.ant-typography h3 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 1.35;\n}\nh4.ant-typography,\n.ant-typography h4 {\n  margin-bottom: 0.5em;\n  color: #535353;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n}\n.ant-typography + h1.ant-typography,\n.ant-typography + h2.ant-typography,\n.ant-typography + h3.ant-typography,\n.ant-typography + h4.ant-typography {\n  margin-top: 1.2em;\n}\n.ant-typography div + h1,\n.ant-typography ul + h1,\n.ant-typography li + h1,\n.ant-typography p + h1,\n.ant-typography h1 + h1,\n.ant-typography h2 + h1,\n.ant-typography h3 + h1,\n.ant-typography h4 + h1,\n.ant-typography div + h2,\n.ant-typography ul + h2,\n.ant-typography li + h2,\n.ant-typography p + h2,\n.ant-typography h1 + h2,\n.ant-typography h2 + h2,\n.ant-typography h3 + h2,\n.ant-typography h4 + h2,\n.ant-typography div + h3,\n.ant-typography ul + h3,\n.ant-typography li + h3,\n.ant-typography p + h3,\n.ant-typography h1 + h3,\n.ant-typography h2 + h3,\n.ant-typography h3 + h3,\n.ant-typography h4 + h3,\n.ant-typography div + h4,\n.ant-typography ul + h4,\n.ant-typography li + h4,\n.ant-typography p + h4,\n.ant-typography h1 + h4,\n.ant-typography h2 + h4,\n.ant-typography h3 + h4,\n.ant-typography h4 + h4 {\n  margin-top: 1.2em;\n}\nspan.ant-typography-ellipsis {\n  display: inline-block;\n}\n.ant-typography a {\n  color: #2EB1EF;\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.ant-typography a:focus,\n.ant-typography a:hover {\n  color: #58cefc;\n}\n.ant-typography a:active {\n  color: #1c8dc9;\n}\n.ant-typography a:active,\n.ant-typography a:hover {\n  text-decoration: none;\n}\n.ant-typography a[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-typography code {\n  margin: 0 0.2em;\n  padding: 0.2em 0.4em 0.1em;\n  font-size: 85%;\n  background: rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 3px;\n}\n.ant-typography mark {\n  padding: 0;\n  background-color: #ffe58f;\n}\n.ant-typography u,\n.ant-typography ins {\n  text-decoration: underline;\n  text-decoration-skip-ink: auto;\n}\n.ant-typography s,\n.ant-typography del {\n  text-decoration: line-through;\n}\n.ant-typography strong {\n  font-weight: 600;\n}\n.ant-typography-expand,\n.ant-typography-edit,\n.ant-typography-copy {\n  color: #2EB1EF;\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  margin-left: 8px;\n}\n.ant-typography-expand:focus,\n.ant-typography-edit:focus,\n.ant-typography-copy:focus,\n.ant-typography-expand:hover,\n.ant-typography-edit:hover,\n.ant-typography-copy:hover {\n  color: #58cefc;\n}\n.ant-typography-expand:active,\n.ant-typography-edit:active,\n.ant-typography-copy:active {\n  color: #1c8dc9;\n}\n.ant-typography-copy-success,\n.ant-typography-copy-success:hover,\n.ant-typography-copy-success:focus {\n  color: #52c41a;\n}\n.ant-typography-edit-content {\n  position: relative;\n}\ndiv.ant-typography-edit-content {\n  left: -12px;\n  margin-top: -5px;\n  margin-bottom: calc(-5em);\n}\n.ant-typography-edit-content-confirm {\n  position: absolute;\n  right: 10px;\n  bottom: 8px;\n  color: #595959;\n  pointer-events: none;\n}\n.ant-typography-edit-content textarea {\n  -moz-transition: none;\n}\n.ant-typography ul,\n.ant-typography ol {\n  margin: 0 0 1em 0;\n  padding: 0;\n}\n.ant-typography ul li,\n.ant-typography ol li {\n  margin: 0 0 0 20px;\n  padding: 0 0 0 4px;\n}\n.ant-typography ul li {\n  list-style-type: circle;\n}\n.ant-typography ul li li {\n  list-style-type: disc;\n}\n.ant-typography ol li {\n  list-style-type: decimal;\n}\n.ant-typography-ellipsis-single-line {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-typography-ellipsis-multiple-line {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  /*! autoprefixer: ignore next */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.ant-upload {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  outline: 0;\n}\n.ant-upload p {\n  margin: 0;\n}\n.ant-upload-btn {\n  display: block;\n  width: 100%;\n  outline: none;\n}\n.ant-upload input[type='file'] {\n  cursor: pointer;\n}\n.ant-upload.ant-upload-select {\n  display: inline-block;\n}\n.ant-upload.ant-upload-disabled {\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-select-picture-card {\n  display: table;\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  vertical-align: top;\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n.ant-upload.ant-upload-select-picture-card > .ant-upload {\n  display: table-cell;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  text-align: center;\n  vertical-align: middle;\n}\n.ant-upload.ant-upload-select-picture-card:hover {\n  border-color: #2EB1EF;\n}\n.ant-upload.ant-upload-drag {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.3s;\n}\n.ant-upload.ant-upload-drag .ant-upload {\n  padding: 16px 0;\n}\n.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {\n  border-color: #1c8dc9;\n}\n.ant-upload.ant-upload-drag.ant-upload-disabled {\n  cursor: not-allowed;\n}\n.ant-upload.ant-upload-drag .ant-upload-btn {\n  display: table;\n  height: 100%;\n}\n.ant-upload.ant-upload-drag .ant-upload-drag-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {\n  border-color: #58cefc;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon {\n  margin-bottom: 20px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {\n  color: #58cefc;\n  font-size: 48px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-text {\n  margin: 0 0 4px;\n  color: #535353;\n  font-size: 16px;\n}\n.ant-upload.ant-upload-drag p.ant-upload-hint {\n  color: #595959;\n  font-size: 14px;\n}\n.ant-upload.ant-upload-drag .anticon-plus {\n  color: rgba(0, 0, 0, 0.25);\n  font-size: 30px;\n  transition: all 0.3s;\n}\n.ant-upload.ant-upload-drag .anticon-plus:hover {\n  color: #595959;\n}\n.ant-upload.ant-upload-drag:hover .anticon-plus {\n  color: #595959;\n}\n.ant-upload-picture-card-wrapper {\n  zoom: 1;\n  display: inline-block;\n  width: 100%;\n}\n.ant-upload-picture-card-wrapper::before,\n.ant-upload-picture-card-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::after {\n  clear: both;\n}\n.ant-upload-picture-card-wrapper::before,\n.ant-upload-picture-card-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-upload-picture-card-wrapper::after {\n  clear: both;\n}\n.ant-upload-list {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  zoom: 1;\n}\n.ant-upload-list::before,\n.ant-upload-list::after {\n  display: table;\n  content: '';\n}\n.ant-upload-list::after {\n  clear: both;\n}\n.ant-upload-list::before,\n.ant-upload-list::after {\n  display: table;\n  content: '';\n}\n.ant-upload-list::after {\n  clear: both;\n}\n.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 14px;\n}\n.ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 28px;\n}\n.ant-upload-list-item {\n  position: relative;\n  height: 22px;\n  margin-top: 8px;\n  font-size: 14px;\n}\n.ant-upload-list-item-name {\n  display: inline-block;\n  width: 100%;\n  padding-left: 22px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ant-upload-list-item-name-icon-count-1 {\n  padding-right: 14px;\n}\n.ant-upload-list-item-card-actions {\n  position: absolute;\n  right: 0;\n  opacity: 0;\n}\n.ant-upload-list-item-card-actions.picture {\n  top: 25px;\n  line-height: 1;\n  opacity: 1;\n}\n.ant-upload-list-item-card-actions .anticon {\n  padding-right: 6px;\n  color: rgba(0, 0, 0, 0.45);\n}\n.ant-upload-list-item-info {\n  height: 100%;\n  padding: 0 12px 0 4px;\n  transition: background-color 0.3s;\n}\n.ant-upload-list-item-info > span {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.ant-upload-list-item-info .anticon-loading,\n.ant-upload-list-item-info .anticon-paper-clip {\n  position: absolute;\n  top: 5px;\n  color: #595959;\n  font-size: 14px;\n}\n.ant-upload-list-item .anticon-close {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px \\9;\n  transform: scale(0.83333333) rotate(0deg);\n  position: absolute;\n  top: 6px;\n  right: 4px;\n  color: #595959;\n  line-height: 0;\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.3s;\n}\n:root .ant-upload-list-item .anticon-close {\n  font-size: 12px;\n}\n.ant-upload-list-item .anticon-close:hover {\n  color: #545454;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-info {\n  background-color: #f0fdff;\n}\n.ant-upload-list-item:hover .anticon-close {\n  opacity: 1;\n}\n.ant-upload-list-item:hover .ant-upload-list-item-card-actions {\n  opacity: 1;\n}\n.ant-upload-list-item-error,\n.ant-upload-list-item-error .anticon-paper-clip,\n.ant-upload-list-item-error .ant-upload-list-item-name {\n  color: #f5222d;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions {\n  opacity: 1;\n}\n.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {\n  color: #f5222d;\n}\n.ant-upload-list-item-progress {\n  position: absolute;\n  bottom: -12px;\n  width: 100%;\n  padding-left: 26px;\n  font-size: 14px;\n  line-height: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item,\n.ant-upload-list-picture-card .ant-upload-list-item {\n  position: relative;\n  height: 66px;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover,\n.ant-upload-list-picture-card .ant-upload-list-item:hover {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-error,\n.ant-upload-list-picture-card .ant-upload-list-item-error {\n  border-color: #f5222d;\n}\n.ant-upload-list-picture .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  padding: 0;\n}\n.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {\n  background: transparent;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading {\n  border-style: dashed;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 48px;\n  height: 48px;\n  font-size: 26px;\n  line-height: 54px;\n  text-align: center;\n  opacity: 0.8;\n}\n.ant-upload-list-picture .ant-upload-list-item-icon,\n.ant-upload-list-picture-card .ant-upload-list-item-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 26px;\n  transform: translate(-50%, -50%);\n}\n.ant-upload-list-picture .ant-upload-list-item-image,\n.ant-upload-list-picture-card .ant-upload-list-item-image {\n  max-width: 100%;\n}\n.ant-upload-list-picture .ant-upload-list-item-thumbnail img,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  display: block;\n  width: 48px;\n  height: 48px;\n  overflow: hidden;\n}\n.ant-upload-list-picture .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: inline-block;\n  box-sizing: border-box;\n  max-width: 100%;\n  margin: 0 0 0 8px;\n  padding-right: 8px;\n  padding-left: 48px;\n  overflow: hidden;\n  line-height: 44px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,\n.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {\n  padding-right: 18px;\n}\n.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,\n.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {\n  padding-right: 36px;\n}\n.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {\n  line-height: 28px;\n}\n.ant-upload-list-picture .ant-upload-list-item-progress,\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 14px;\n  width: calc(100% - 24px);\n  margin-top: 0;\n  padding-left: 56px;\n}\n.ant-upload-list-picture .anticon-close,\n.ant-upload-list-picture-card .anticon-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  line-height: 1;\n  opacity: 1;\n}\n.ant-upload-list-picture-card.ant-upload-list::after {\n  display: none;\n}\n.ant-upload-list-picture-card-container {\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n  float: left;\n  width: 104px;\n  height: 104px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info::before {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: all 0.3s;\n  content: ' ';\n}\n.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n  white-space: nowrap;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {\n  z-index: 10;\n  width: 16px;\n  margin: 0 4px;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye-o:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,\n.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {\n  color: #fff;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,\n.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {\n  opacity: 1;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-name {\n  display: none;\n  margin: 8px 0 0;\n  padding: 0;\n  line-height: 1.3;\n  text-align: center;\n}\n.ant-upload-list-picture-card .anticon-picture + .ant-upload-list-item-name {\n  position: absolute;\n  bottom: 10px;\n  display: block;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {\n  background-color: #fafafa;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {\n  height: auto;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye-o,\n.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {\n  display: none;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-uploading-text {\n  margin-top: 18px;\n  color: #595959;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-progress {\n  bottom: 32px;\n  padding-left: 0;\n}\n.ant-upload-list .ant-upload-success-icon {\n  color: #52c41a;\n  font-weight: bold;\n}\n.ant-upload-list .ant-upload-animate-enter,\n.ant-upload-list .ant-upload-animate-leave,\n.ant-upload-list .ant-upload-animate-inline-enter,\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-upload-list .ant-upload-animate-enter {\n  animation-name: uploadAnimateIn;\n}\n.ant-upload-list .ant-upload-animate-leave {\n  animation-name: uploadAnimateOut;\n}\n.ant-upload-list .ant-upload-animate-inline-enter {\n  animation-name: uploadAnimateInlineIn;\n}\n.ant-upload-list .ant-upload-animate-inline-leave {\n  animation-name: uploadAnimateInlineOut;\n}\n@keyframes uploadAnimateIn {\n  from {\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateOut {\n  to {\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateInlineIn {\n  from {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n@keyframes uploadAnimateInlineOut {\n  to {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n/* color classes */\n.gx-bg-primary {\n  background-color: #2EB1EF !important;\n}\na.gx-bg-primary:hover,\na.gx-bg-primary:focus {\n  background-color: #2EB1EF !important;\n}\n.gx-bg-primary-light {\n  background-color: #82e0ff !important;\n}\n.gx-bg-secondary {\n  background-color: #089265 !important;\n}\na.gx-bg-secondary:hover,\na.gx-bg-secondary:focus {\n  background-color: #089265 !important;\n}\n.gx-bg-success {\n  background-color: #52c41a !important;\n}\na.gx-bg-success:hover,\na.gx-bg-success:focus {\n  background-color: #3f9714 !important;\n}\n.gx-bg-success-dark {\n  background-color: #368011 !important;\n}\na.gx-bg-success-dark:hover,\na.gx-bg-success-dark:focus {\n  background-color: #2c6a0e !important;\n}\n.gx-bg-info {\n  background-color: #1890ff !important;\n}\na.gx-bg-info:hover,\na.gx-bg-info:focus {\n  background-color: #0076e4 !important;\n}\n.gx-bg-warning {\n  background-color: #fa8c16 !important;\n}\na.gx-bg-warning:hover,\na.gx-bg-warning:focus {\n  background-color: #d87205 !important;\n}\n.gx-bg-danger {\n  background-color: #f44336 !important;\n}\na.gx-bg-danger:hover,\na.gx-bg-danger:focus {\n  background-color: #ea1c0d !important;\n}\n.gx-bg-light {\n  background-color: #e8e8e8 !important;\n}\na.gx-bg-light:hover,\na.gx-bg-light:focus {\n  background-color: #d9d9d9 !important;\n}\n.gx-bg-dark {\n  background-color: #000000 !important;\n}\na.gx-bg-dark:hover,\na.gx-bg-dark:focus {\n  background-color: #1a1a1a !important;\n}\n.gx-bg-white {\n  background-color: #ffffff !important;\n}\na.gx-bg-white:hover,\na.gx-bg-white:focus {\n  background-color: #f2f2f2 !important;\n}\n.gx-bg-grey {\n  background-color: #cccccc !important;\n}\na.gx-bg-grey:hover,\na.gx-bg-grey:focus {\n  background-color: #b2b2b2 !important;\n}\n.gx-bg-light-grey {\n  background-color: #fafafa !important;\n}\n.gx-bg-transparent {\n  background-color: transparent !important;\n}\n.gx-bg-pink {\n  background-color: #eb2f96 !important;\n}\na.gx-bg-pink:hover,\na.gx-bg-pink:focus {\n  background-color: #d3147d !important;\n}\n.gx-bg-green {\n  background-color: #52c41a !important;\n}\na.gx-bg-green:hover,\na.gx-bg-green:focus {\n  background-color: #3f9714 !important;\n}\n.gx-bg-green-light {\n  background-color: #caf5b5 !important;\n}\na.gx-bg-green-light:hover,\na.gx-bg-green-light:focus {\n  background-color: #8ae95b !important;\n}\n.gx-bg-red {\n  background-color: #f5222d !important;\n}\na.gx-bg-red:hover,\na.gx-bg-red:focus {\n  background-color: #da0a15 !important;\n}\n.gx-bg-amber {\n  background-color: #fadb14 !important;\n}\na.gx-bg-amber:hover,\na.gx-bg-amber:focus {\n  background-color: #d6ba05 !important;\n}\n.gx-bg-amber-light {\n  background-color: #fdf2aa !important;\n}\na.gx-bg-amber-light:hover,\na.gx-bg-amber-light:focus {\n  background-color: #fcea78 !important;\n}\n.gx-bg-blue {\n  background-color: #1890ff !important;\n}\na.gx-bg-blue:hover,\na.gx-bg-blue:focus {\n  background-color: #0076e4 !important;\n}\n.gx-bg-light-blue {\n  background-color: #329cff !important;\n}\na.gx-bg-light-blue:hover,\na.gx-bg-light-blue:focus {\n  background-color: #4ba9ff !important;\n}\n.gx-bg-indigo {\n  background-color: #3c1991 !important;\n}\na.gx-bg-indigo:hover,\na.gx-bg-indigo:focus {\n  background-color: #2a1166 !important;\n}\n.gx-bg-purple {\n  background-color: #722ed1 !important;\n}\na.gx-bg-purple:hover,\na.gx-bg-purple:focus {\n  background-color: #5b25a7 !important;\n}\n.gx-bg-orange {\n  background-color: #fa8c16 !important;\n}\na.gx-bg-orange:hover,\na.gx-bg-orange:focus {\n  background-color: #d87205 !important;\n}\n.gx-bg-yellow {\n  background-color: #fadb14 !important;\n}\na.gx-bg-yellow:hover,\na.gx-bg-yellow:focus {\n  background-color: #d6ba05 !important;\n}\n.gx-bg-teal {\n  background-color: #20c997 !important;\n}\na.gx-bg-teal:hover,\na.gx-bg-teal:focus {\n  background-color: #199d76 !important;\n}\n.gx-bg-cyan {\n  background-color: #13c2c2 !important;\n}\na.gx-bg-cyan:hover,\na.gx-bg-cyan:focus {\n  background-color: #0e9494 !important;\n}\n.gx-bg-sepia {\n  background-color: #7c3535 !important;\n}\na.gx-bg-sepia:hover,\na.gx-bg-sepia:focus {\n  background-color: #582626 !important;\n}\n.gx-bg-geekblue {\n  background-color: #030852 !important;\n}\na.gx-bg-geekblue:hover,\na.gx-bg-geekblue:focus {\n  background-color: #010321 !important;\n}\n.gx-text-white {\n  color: #ffffff !important;\n}\n.gx-text-primary {\n  color: #2EB1EF !important;\n}\na.gx-text-primary:hover,\na.gx-text-primary:focus {\n  color: #2EB1EF !important;\n}\n.gx-text-secondary {\n  color: #089265 !important;\n}\na.gx-text-secondary:hover,\na.gx-text-secondary:focus {\n  color: #089265 !important;\n}\n.gx-text-success {\n  color: #52c41a !important;\n}\na.gx-text-success:hover,\na.gx-text-success:focus {\n  color: #49ad17 !important;\n}\n.gx-text-success-dark {\n  color: #368011 !important;\n}\na.gx-text-success-dark:hover,\na.gx-text-success-dark:focus {\n  color: #2c6a0e !important;\n}\n.gx-text-info {\n  color: #1890ff !important;\n}\na.gx-text-info:hover,\na.gx-text-info:focus {\n  color: #0084fe !important;\n}\n.gx-text-warning {\n  color: #fa8c16 !important;\n}\na.gx-text-warning:hover,\na.gx-text-warning:focus {\n  color: #f17f05 !important;\n}\n.gx-text-danger {\n  color: #f44336 !important;\n}\na.gx-text-danger:hover,\na.gx-text-danger:focus {\n  color: #f32c1e !important;\n}\n.gx-text-light {\n  color: #ababab !important;\n}\na.gx-text-light:hover,\na.gx-text-light:focus {\n  color: #787878 !important;\n}\n.gx-text-light-grey {\n  color: #cccccc !important;\n}\na.gx-text-light-grey:hover,\na.gx-text-light-grey:focus {\n  color: #bfbfbf !important;\n}\n.gx-text-grey {\n  color: #8c8c8c !important;\n}\na.gx-text-grey:hover,\na.gx-text-grey:focus {\n  color: #262626 !important;\n}\n.gx-text-dark {\n  color: #595959 !important;\n}\na.gx-text-dark:hover,\na.gx-text-dark:focus {\n  color: #4c4c4c !important;\n}\n.gx-text-black {\n  color: #000000 !important;\n}\na.gx-text-black:hover,\na.gx-text-black:focus {\n  color: #4c4c4c !important;\n}\n.gx-text-pink {\n  color: #eb2f96 !important;\n}\na.gx-text-pink:hover,\na.gx-text-pink:focus {\n  color: #e9188a !important;\n}\n.gx-text-green {\n  color: #52c41a !important;\n}\na.gx-text-green:hover,\na.gx-text-green:focus {\n  color: #49ad17 !important;\n}\n.gx-text-red {\n  color: #f5222d !important;\n}\na.gx-text-red:hover,\na.gx-text-red:focus {\n  color: #f30b17 !important;\n}\n.gx-text-amber {\n  color: #fadb14 !important;\n}\na.gx-text-amber:hover,\na.gx-text-amber:focus {\n  color: #efd005 !important;\n}\n.gx-text-blue {\n  color: #1890ff !important;\n}\na.gx-text-blue:hover,\na.gx-text-blue:focus {\n  color: #0084fe !important;\n}\n.gx-text-indigo {\n  color: #3c1991 !important;\n}\na.gx-text-indigo:hover,\na.gx-text-indigo:focus {\n  color: #33157b !important;\n}\n.gx-text-purple {\n  color: #722ed1 !important;\n}\na.gx-text-purple:hover,\na.gx-text-purple:focus {\n  color: #6729bc !important;\n}\n.gx-text-orange {\n  color: #fa8c16 !important;\n}\na.gx-text-orange:hover,\na.gx-text-orange:focus {\n  color: #f17f05 !important;\n}\n.gx-text-yellow {\n  color: #fadb14 !important;\n}\na.gx-text-yellow:hover,\na.gx-text-yellow:focus {\n  color: #efd005 !important;\n}\n.gx-text-teal {\n  color: #20c997 !important;\n}\na.gx-text-teal:hover,\na.gx-text-teal:focus {\n  color: #1cb386 !important;\n}\n.gx-text-cyan {\n  color: #13c2c2 !important;\n}\na.gx-text-cyan:hover,\na.gx-text-cyan:focus {\n  color: #11abab !important;\n}\n.gx-text-muted {\n  color: #8c8c8c !important;\n}\n.gx-text-geekblue {\n  color: #030852 !important;\n}\na.gx-text-geekblue:hover,\na.gx-text-geekblue:focus {\n  color: #10239e !important;\n}\n.gx-text-sepia {\n  color: #7c3535 !important;\n}\na.gx-text-sepia:hover,\na.gx-text-sepia:focus {\n  color: #7c3535 !important;\n}\n.gx-icon-white {\n  color: #ffffff !important;\n}\n.gx-border-primary {\n  border-color: #2EB1EF !important;\n}\n.gx-border-secondary {\n  border-color: #089265 !important;\n}\n.gx-border-success {\n  border-color: #52c41a !important;\n}\n.gx-border-success-dark {\n  border-color: #368011 !important;\n}\n.gx-border-info {\n  border-color: #1890ff !important;\n}\n.gx-border-warning {\n  border-color: #fa8c16 !important;\n}\n.gx-border-danger {\n  border-color: #f44336 !important;\n}\n.gx-border-light {\n  border-color: #bfbfbf !important;\n}\n.gx-border-dark {\n  border-color: #595959 !important;\n}\n.gx-border-white {\n  border-color: #ffffff !important;\n}\n.gx-border-grey {\n  border-color: #bfbfbf !important;\n}\n.gx-border-pink {\n  border-color: #eb2f96 !important;\n}\n.gx-border-green {\n  border-color: #52c41a !important;\n}\n.gx-border-red {\n  border-color: #f5222d !important;\n}\n.gx-border-amber {\n  border-color: #fadb14 !important;\n}\n.gx-border-blue {\n  border-color: #1890ff !important;\n}\n.gx-border-indigo {\n  border-color: #3c1991 !important;\n}\n.gx-border-purple {\n  border-color: #722ed1 !important;\n}\n.gx-border-orange {\n  border-color: #fa8c16 !important;\n}\n.gx-border-yellow {\n  border-color: #fadb14 !important;\n}\n.gx-border-teal {\n  border-color: #1890ff !important;\n}\n.gx-border-cyan {\n  border-color: #13c2c2 !important;\n}\n.gx-border-sepia {\n  border-color: #7c3535 !important;\n}\n.gx-border-geekblue {\n  border-color: #030852 !important;\n}\n.gx-btn-primary,\na.gx-btn-primary,\n.btn-primary {\n  color: #ffffff;\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.gx-btn-primary:hover,\na.gx-btn-primary:hover,\n.btn-primary:hover,\n.gx-btn-primary:focus,\na.gx-btn-primary:focus,\n.btn-primary:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.gx-btn-primary.disabled,\na.gx-btn-primary.disabled,\n.btn-primary.disabled,\n.gx-btn-primary:disabled,\na.gx-btn-primary:disabled,\n.btn-primary:disabled {\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.gx-btn-primary:not([disabled]):not(.disabled):active,\na.gx-btn-primary:not([disabled]):not(.disabled):active,\n.btn-primary:not([disabled]):not(.disabled):active,\n.gx-btn-primary:not([disabled]):not(.disabled).active,\na.gx-btn-primary:not([disabled]):not(.disabled).active,\n.btn-primary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.gx-btn-primary-light,\na.gx-btn-primary-light,\n.btn-primary-light {\n  color: #595959 !important;\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-primary-light:hover,\na.gx-btn-primary-light:hover,\n.btn-primary-light:hover,\n.gx-btn-primary-light:focus,\na.gx-btn-primary-light:focus,\n.btn-primary-light:focus {\n  color: #595959 !important;\n  background-color: #bce6fa !important;\n  border-color: #bce6fa !important;\n}\n.gx-btn-primary-light.disabled,\na.gx-btn-primary-light.disabled,\n.btn-primary-light.disabled,\n.gx-btn-primary-light:disabled,\na.gx-btn-primary-light:disabled,\n.btn-primary-light:disabled {\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-primary-light:not([disabled]):not(.disabled):active,\na.gx-btn-primary-light:not([disabled]):not(.disabled):active,\n.btn-primary-light:not([disabled]):not(.disabled):active,\n.gx-btn-primary-light:not([disabled]):not(.disabled).active,\na.gx-btn-primary-light:not([disabled]):not(.disabled).active,\n.btn-primary-light:not([disabled]):not(.disabled).active {\n  color: #595959;\n  background-color: #ebf8fe !important;\n  border-color: #ebf8fe !important;\n}\n.gx-btn-secondary,\na.gx-btn-secondary {\n  color: #ffffff !important;\n  background-color: #089265 !important;\n  border-color: #089265 !important;\n}\n.gx-btn-secondary:hover,\na.gx-btn-secondary:hover,\n.gx-btn-secondary:focus,\na.gx-btn-secondary:focus {\n  color: #ffffff;\n  background-color: #089265 !important;\n  border-color: #089265 !important;\n}\n.gx-btn-secondary.disabled,\na.gx-btn-secondary.disabled,\n.gx-btn-secondary:disabled,\na.gx-btn-secondary:disabled {\n  background-color: #089265 !important;\n  border-color: #089265 !important;\n}\n.gx-btn-secondary:not([disabled]):not(.disabled):active,\na.gx-btn-secondary:not([disabled]):not(.disabled):active,\n.gx-btn-secondary:not([disabled]):not(.disabled).active,\na.gx-btn-secondary:not([disabled]):not(.disabled).active {\n  color: #ffffff;\n  background-color: #089265 !important;\n  border-color: #089265 !important;\n}\n.gx-btn-success,\na.gx-btn-success {\n  color: #ffffff !important;\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success:hover,\na.gx-btn-success:hover,\n.gx-btn-success:focus,\na.gx-btn-success:focus {\n  color: #ffffff !important;\n  background-color: #3f9714 !important;\n  border-color: #3f9714 !important;\n}\n.gx-btn-success.disabled,\na.gx-btn-success.disabled,\n.gx-btn-success:disabled,\na.gx-btn-success:disabled {\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success:not([disabled]):not(.disabled):active,\na.gx-btn-success:not([disabled]):not(.disabled):active,\n.gx-btn-success:not([disabled]):not(.disabled).active,\na.gx-btn-success:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #3f9714 !important;\n  border-color: #3f9714 !important;\n}\n.gx-btn-success-dark,\na.gx-btn-success-dark {\n  color: #ffffff !important;\n  background-color: #368011 !important;\n  border-color: #368011 !important;\n}\n.gx-btn-success-dark:hover,\na.gx-btn-success-dark:hover,\n.gx-btn-success-dark:focus,\na.gx-btn-success-dark:focus {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-success-dark.disabled,\na.gx-btn-success-dark.disabled,\n.gx-btn-success-dark:disabled,\na.gx-btn-success-dark:disabled {\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-success-dark:not([disabled]):not(.disabled):active,\na.gx-btn-success-dark:not([disabled]):not(.disabled):active,\n.gx-btn-success-dark:not([disabled]):not(.disabled).active,\na.gx-btn-success-dark:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-info,\na.gx-btn-info {\n  color: #ffffff !important;\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-info:hover,\na.gx-btn-info:hover,\n.gx-btn-info:focus,\na.gx-btn-info:focus {\n  color: #ffffff !important;\n  background-color: #0076e4 !important;\n  border-color: #0076e4 !important;\n}\n.gx-btn-info.disabled,\na.gx-btn-info.disabled,\n.gx-btn-info:disabled,\na.gx-btn-info:disabled {\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-info:not([disabled]):not(.disabled):active,\na.gx-btn-info:not([disabled]):not(.disabled):active,\n.gx-btn-info:not([disabled]):not(.disabled).active,\na.gx-btn-info:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0076e4 !important;\n  border-color: #0076e4 !important;\n}\n.gx-btn-warning,\na.gx-btn-warning {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-warning:hover,\na.gx-btn-warning:hover,\n.gx-btn-warning:focus,\na.gx-btn-warning:focus {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-warning.disabled,\na.gx-btn-warning.disabled,\n.gx-btn-warning:disabled,\na.gx-btn-warning:disabled {\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-warning:not([disabled]):not(.disabled):active,\na.gx-btn-warning:not([disabled]):not(.disabled):active,\n.gx-btn-warning:not([disabled]):not(.disabled).active,\na.gx-btn-warning:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-yellow,\na.gx-btn-yellow {\n  color: #262626 !important;\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.gx-btn-yellow:hover,\na.gx-btn-yellow:hover,\n.gx-btn-yellow:focus,\na.gx-btn-yellow:focus {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.gx-btn-yellow.disabled,\na.gx-btn-yellow.disabled,\n.gx-btn-yellow:disabled,\na.gx-btn-yellow:disabled {\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.gx-btn-yellow:not([disabled]):not(.disabled):active,\na.gx-btn-yellow:not([disabled]):not(.disabled):active,\n.gx-btn-yellow:not([disabled]):not(.disabled).active,\na.gx-btn-yellow:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.gx-btn-danger,\na.gx-btn-danger,\n.gx-btn-red,\na.gx-btn-red {\n  color: #ffffff !important;\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-danger:hover,\na.gx-btn-danger:hover,\n.gx-btn-red:hover,\na.gx-btn-red:hover,\n.gx-btn-danger:focus,\na.gx-btn-danger:focus,\n.gx-btn-red:focus,\na.gx-btn-red:focus {\n  color: #ffffff !important;\n  background-color: #ea1c0d !important;\n  border-color: #ea1c0d !important;\n}\n.gx-btn-danger.disabled,\na.gx-btn-danger.disabled,\n.gx-btn-red.disabled,\na.gx-btn-red.disabled,\n.gx-btn-danger:disabled,\na.gx-btn-danger:disabled,\n.gx-btn-red:disabled,\na.gx-btn-red:disabled {\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-danger:not([disabled]):not(.disabled):active,\na.gx-btn-danger:not([disabled]):not(.disabled):active,\n.gx-btn-red:not([disabled]):not(.disabled):active,\na.gx-btn-red:not([disabled]):not(.disabled):active,\n.gx-btn-danger:not([disabled]):not(.disabled).active,\na.gx-btn-danger:not([disabled]):not(.disabled).active,\n.gx-btn-red:not([disabled]):not(.disabled).active,\na.gx-btn-red:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #ea1c0d !important;\n  border-color: #ea1c0d !important;\n}\n.gx-btn-light,\na.gx-btn-light {\n  color: #8c8c8c !important;\n  background-color: #e8e8e8 !important;\n  border-color: #e8e8e8 !important;\n}\n.gx-btn-light:hover,\na.gx-btn-light:hover,\n.gx-btn-light:focus,\na.gx-btn-light:focus {\n  color: #8c8c8c !important;\n  background-color: #d9d9d9 !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-light.disabled,\na.gx-btn-light.disabled,\n.gx-btn-light:disabled,\na.gx-btn-light:disabled {\n  background-color: #f5f5f5 !important;\n  border-color: #f5f5f5 !important;\n}\n.gx-btn-light:not([disabled]):not(.disabled):active,\na.gx-btn-light:not([disabled]):not(.disabled):active,\n.gx-btn-light:not([disabled]):not(.disabled).active,\na.gx-btn-light:not([disabled]):not(.disabled).active {\n  color: #262626 !important;\n  background-color: #e8e8e8 !important;\n  border-color: #e8e8e8 !important;\n}\n.gx-btn-dark,\na.gx-btn-dark {\n  color: #ffffff !important;\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-dark:hover,\na.gx-btn-dark:hover,\n.gx-btn-dark:focus,\na.gx-btn-dark:focus {\n  color: #ffffff !important;\n  background-color: #0c0c0c !important;\n  border-color: #0c0c0c !important;\n}\n.gx-btn-dark.disabled,\na.gx-btn-dark.disabled,\n.gx-btn-dark:disabled,\na.gx-btn-dark:disabled {\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-dark:not([disabled]):not(.disabled):active,\na.gx-btn-dark:not([disabled]):not(.disabled):active,\n.gx-btn-dark:not([disabled]):not(.disabled).active,\na.gx-btn-dark:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0c0c0c !important;\n  border-color: #0c0c0c !important;\n}\n.gx-btn-purple,\na.gx-btn-purple {\n  color: #ffffff !important;\n  background-color: #722ed1 !important;\n  border-color: #722ed1 !important;\n}\n.gx-btn-purple:hover,\na.gx-btn-purple:hover,\n.gx-btn-purple:focus,\na.gx-btn-purple:focus {\n  color: #ffffff !important;\n  background-color: #5b25a7 !important;\n  border-color: #5b25a7 !important;\n}\n.gx-btn-purple.disabled,\na.gx-btn-purple.disabled,\n.gx-btn-purple:disabled,\na.gx-btn-purple:disabled {\n  background-color: #722ed1 !important;\n  border-color: #722ed1 !important;\n}\n.gx-btn-purple:not([disabled]):not(.disabled):active,\na.gx-btn-purple:not([disabled]):not(.disabled):active,\n.gx-btn-purple:not([disabled]):not(.disabled).active,\na.gx-btn-purple:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #5b25a7 !important;\n  border-color: #5b25a7 !important;\n}\n.gx-btn-sepia,\na.gx-btn-sepia {\n  color: #ffffff !important;\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-sepia:hover,\na.gx-btn-sepia:hover,\n.gx-btn-sepia:focus,\na.gx-btn-sepia:focus {\n  color: #ffffff !important;\n  background-color: #461e1e !important;\n  border-color: #461e1e !important;\n}\n.gx-btn-sepia.disabled,\na.gx-btn-sepia.disabled,\n.gx-btn-sepia:disabled,\na.gx-btn-sepia:disabled {\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-sepia:not([disabled]):not(.disabled):active,\na.gx-btn-sepia:not([disabled]):not(.disabled):active,\n.gx-btn-sepia:not([disabled]):not(.disabled).active,\na.gx-btn-sepia:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #461e1e !important;\n  border-color: #461e1e !important;\n}\n.gx-btn-geekblue,\na.gx-btn-geekblue {\n  color: #ffffff !important;\n  background-color: #10239e !important;\n  border-color: #10239e !important;\n}\n.gx-btn-geekblue:hover,\na.gx-btn-geekblue:hover,\n.gx-btn-geekblue:focus,\na.gx-btn-geekblue:focus {\n  color: #ffffff !important;\n  background-color: #0b1970 !important;\n  border-color: #0b1970 !important;\n}\n.gx-btn-geekblue.disabled,\na.gx-btn-geekblue.disabled,\n.gx-btn-geekblue:disabled,\na.gx-btn-geekblue:disabled {\n  background-color: #10239e !important;\n  border-color: #10239e !important;\n}\n.gx-btn-geekblue:not([disabled]):not(.disabled):active,\na.gx-btn-geekblue:not([disabled]):not(.disabled):active,\n.gx-btn-geekblue:not([disabled]):not(.disabled).active,\na.gx-btn-geekblue:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #091459 !important;\n  border-color: #091459 !important;\n}\n.gx-btn-cyan,\na.gx-btn-cyan {\n  color: #ffffff !important;\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.gx-btn-cyan:hover,\na.gx-btn-cyan:hover,\n.gx-btn-cyan:focus,\na.gx-btn-cyan:focus {\n  color: #ffffff !important;\n  background-color: #0e9494 !important;\n  border-color: #0e9494 !important;\n}\n.gx-btn-cyan.disabled,\na.gx-btn-cyan.disabled,\n.gx-btn-cyan:disabled,\na.gx-btn-cyan:disabled {\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.gx-btn-cyan:not([disabled]):not(.disabled):active,\na.gx-btn-cyan:not([disabled]):not(.disabled):active,\n.gx-btn-cyan:not([disabled]):not(.disabled).active,\na.gx-btn-cyan:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #0e8a8a !important;\n  border-color: #0e8a8a !important;\n}\n.gx-btn-white,\na.gx-btn-white {\n  color: #545454 !important;\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-white:hover,\na.gx-btn-white:hover,\n.gx-btn-white:focus,\na.gx-btn-white:focus {\n  color: #545454 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #e6e6e6 !important;\n}\n.gx-btn-white.disabled,\na.gx-btn-white.disabled,\n.gx-btn-white:disabled,\na.gx-btn-white:disabled {\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.gx-btn-white:not([disabled]):not(.disabled):active,\na.gx-btn-white:not([disabled]):not(.disabled):active,\n.gx-btn-white:not([disabled]):not(.disabled).active,\na.gx-btn-white:not([disabled]):not(.disabled).active {\n  color: #545454 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #e6e6e6 !important;\n}\n.gx-btn-orange,\na.gx-btn-orange {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-orange:hover,\na.gx-btn-orange:hover,\n.gx-btn-orange:focus,\na.gx-btn-orange:focus {\n  color: #ffffff !important;\n  background-color: #d87205 !important;\n  border-color: #d87205 !important;\n}\n.gx-btn-orange.disabled,\na.gx-btn-orange.disabled,\n.gx-btn-orange:disabled,\na.gx-btn-orange:disabled {\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-orange:not([disabled]):not(.disabled):active,\na.gx-btn-orange:not([disabled]):not(.disabled):active,\n.gx-btn-orange:not([disabled]):not(.disabled).active,\na.gx-btn-orange:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #ce6d04 !important;\n  border-color: #ce6d04 !important;\n}\n.gx-btn-outline-primary,\na.gx-btn-outline-primary {\n  color: #2EB1EF !important;\n  background-color: transparent !important;\n  border-color: #2EB1EF !important;\n}\n.gx-btn-outline-primary:hover,\na.gx-btn-outline-primary:hover,\n.gx-btn-outline-primary:focus,\na.gx-btn-outline-primary:focus {\n  color: #ffffff !important;\n  background-color: #2EB1EF !important;\n  border-color: #2EB1EF !important;\n}\n.gx-btn-outline-primary.disabled,\na.gx-btn-outline-primary.disabled,\n.gx-btn-outline-primary:disabled,\na.gx-btn-outline-primary:disabled {\n  color: #2EB1EF !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-secondary,\na.gx-btn-outline-secondary {\n  color: #089265 !important;\n  background-color: transparent !important;\n  border-color: #089265 !important;\n}\n.gx-btn-outline-secondary:hover,\na.gx-btn-outline-secondary:hover,\n.gx-btn-outline-secondary:focus,\na.gx-btn-outline-secondary:focus {\n  color: #ffffff !important;\n  background-color: #089265 !important;\n  border-color: #089265 !important;\n}\n.gx-btn-outline-secondary.disabled,\na.gx-btn-outline-secondary.disabled,\n.gx-btn-outline-secondary:disabled,\na.gx-btn-outline-secondary:disabled {\n  color: #089265 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-success,\na.gx-btn-outline-success {\n  color: #52c41a !important;\n  background-color: transparent !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-outline-success:hover,\na.gx-btn-outline-success:hover,\n.gx-btn-outline-success:focus,\na.gx-btn-outline-success:focus {\n  color: #ffffff !important;\n  background-color: #52c41a !important;\n  border-color: #52c41a !important;\n}\n.gx-btn-outline-success.disabled,\na.gx-btn-outline-success.disabled,\n.gx-btn-outline-success:disabled,\na.gx-btn-outline-success:disabled {\n  color: #52c41a !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-success-dark,\na.gx-btn-outline-success-dark {\n  color: #52c41a !important;\n  background-color: transparent !important;\n  border-color: #368011 !important;\n}\n.gx-btn-outline-success-dark:hover,\na.gx-btn-outline-success-dark:hover,\n.gx-btn-outline-success-dark:focus,\na.gx-btn-outline-success-dark:focus {\n  color: #ffffff !important;\n  background-color: #2c6a0e !important;\n  border-color: #2c6a0e !important;\n}\n.gx-btn-outline-success-dark.disabled,\na.gx-btn-outline-success-dark.disabled,\n.gx-btn-outline-success-dark:disabled,\na.gx-btn-outline-success-dark:disabled {\n  color: #2c6a0e !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-info,\na.gx-btn-outline-info {\n  color: #1890ff !important;\n  background-color: transparent !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-outline-info:hover,\na.gx-btn-outline-info:hover,\n.gx-btn-outline-info:focus,\na.gx-btn-outline-info:focus {\n  color: #ffffff !important;\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n.gx-btn-outline-info.disabled,\na.gx-btn-outline-info.disabled,\n.gx-btn-outline-info:disabled,\na.gx-btn-outline-info:disabled {\n  color: #1890ff !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-warning,\na.gx-btn-outline-warning {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-warning:hover,\na.gx-btn-outline-warning:hover,\n.gx-btn-outline-warning:focus,\na.gx-btn-outline-warning:focus {\n  color: #262626 !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-warning.disabled,\na.gx-btn-outline-warning.disabled,\n.gx-btn-outline-warning:disabled,\na.gx-btn-outline-warning:disabled {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-danger,\na.gx-btn-outline-danger,\n.gx-btn-outline-red,\na.gx-btn-outline-red {\n  color: #f44336 !important;\n  background-color: transparent !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-outline-danger:hover,\na.gx-btn-outline-danger:hover,\n.gx-btn-outline-red:hover,\na.gx-btn-outline-red:hover,\n.gx-btn-outline-danger:focus,\na.gx-btn-outline-danger:focus,\n.gx-btn-outline-red:focus,\na.gx-btn-outline-red:focus {\n  color: #ffffff !important;\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.gx-btn-outline-danger.disabled,\na.gx-btn-outline-danger.disabled,\n.gx-btn-outline-red.disabled,\na.gx-btn-outline-red.disabled,\n.gx-btn-outline-danger:disabled,\na.gx-btn-outline-danger:disabled,\n.gx-btn-outline-red:disabled,\na.gx-btn-outline-red:disabled {\n  color: #f44336 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-light,\na.gx-btn-outline-light {\n  color: #8c8c8c !important;\n  background-color: transparent !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-outline-light:hover,\na.gx-btn-outline-light:hover,\n.gx-btn-outline-light:focus,\na.gx-btn-outline-light:focus {\n  color: #8c8c8c !important;\n  background-color: #d9d9d9 !important;\n  border-color: #d9d9d9 !important;\n}\n.gx-btn-outline-light.disabled,\na.gx-btn-outline-light.disabled,\n.gx-btn-outline-light:disabled,\na.gx-btn-outline-light:disabled {\n  color: #e8e8e8 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-dark,\na.gx-btn-outline-dark {\n  color: #262626 !important;\n  background-color: transparent !important;\n  border-color: #262626 !important;\n}\n.gx-btn-outline-dark:hover,\na.gx-btn-outline-dark:hover,\n.gx-btn-outline-dark:focus,\na.gx-btn-outline-dark:focus {\n  color: #ffffff !important;\n  background-color: #262626 !important;\n  border-color: #262626 !important;\n}\n.gx-btn-outline-dark.disabled,\na.gx-btn-outline-dark.disabled,\n.gx-btn-outline-dark:disabled,\na.gx-btn-outline-dark:disabled {\n  color: #262626 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-sepia,\na.gx-btn-outline-sepia {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-outline-sepia:hover,\na.gx-btn-outline-sepia:hover,\n.gx-btn-outline-sepia:focus,\na.gx-btn-outline-sepia:focus {\n  color: #ffffff !important;\n  background-color: #7c3535 !important;\n  border-color: #7c3535 !important;\n}\n.gx-btn-outline-sepia.disabled,\na.gx-btn-outline-sepia.disabled,\n.gx-btn-outline-sepia:disabled,\na.gx-btn-outline-sepia:disabled {\n  color: #7c3535 !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-geekblue,\na.gx-btn-outline-geekblue {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #030852 !important;\n}\n.gx-btn-outline-geekblue:hover,\na.gx-btn-outline-geekblue:hover,\n.gx-btn-outline-geekblue:focus,\na.gx-btn-outline-geekblue:focus {\n  color: #ffffff !important;\n  background-color: #030852 !important;\n  border-color: #030852 !important;\n}\n.gx-btn-outline-geekblue.disabled,\na.gx-btn-outline-geekblue.disabled,\n.gx-btn-outline-geekblue:disabled,\na.gx-btn-outline-geekblue:disabled {\n  color: #2f54eb !important;\n  background-color: transparent !important;\n}\n.gx-btn-outline-orange,\na.gx-btn-outline-orange {\n  color: #ffffff !important;\n  background-color: transparent !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-orange:hover,\na.gx-btn-outline-orange:hover,\n.gx-btn-outline-orange:focus,\na.gx-btn-outline-orange:focus {\n  color: #ffffff !important;\n  background-color: #fa8c16 !important;\n  border-color: #fa8c16 !important;\n}\n.gx-btn-outline-orange.disabled,\na.gx-btn-outline-orange.disabled,\n.gx-btn-outline-orange:disabled,\na.gx-btn-outline-orange:disabled {\n  color: #fa8c16 !important;\n  background-color: transparent !important;\n}\n.gx-badge-primary {\n  background-color: #2EB1EF !important;\n}\n.gx-badge-primary-light {\n  background-color: #82e0ff !important;\n}\n.gx-badge-secondary {\n  background-color: #089265 !important;\n}\n.gx-badge-success {\n  background-color: #52c41a !important;\n}\n.gx-badge-success-dark {\n  background-color: #368011 !important;\n}\n.gx-badge-info {\n  background-color: #1890ff !important;\n}\n.gx-badge-warning {\n  background-color: #fa8c16 !important;\n}\n.gx-badge-danger {\n  background-color: #f44336 !important;\n}\n.gx-badge-light {\n  background-color: #e8e8e8 !important;\n}\n.gx-badge-dark {\n  background-color: #000000 !important;\n}\n.gx-badge-white {\n  background-color: #ffffff !important;\n}\n.gx-badge-grey {\n  background-color: #bfbfbf !important;\n}\n.gx-badge-light-grey {\n  background-color: #d9d9d9 !important;\n}\n.gx-badge-pink {\n  background-color: #eb2f96 !important;\n}\n.gx-badge-green {\n  background-color: #52c41a !important;\n}\n.gx-badge-green-light {\n  background-color: #caf5b5 !important;\n}\n.gx-badge-red {\n  background-color: #f5222d !important;\n}\n.gx-badge-amber {\n  background-color: #fadb14 !important;\n}\n.gx-badge-amber-light {\n  background-color: #fdf2aa !important;\n}\n.gx-badge-blue {\n  background-color: #1890ff !important;\n}\n.gx-badge-light-blue {\n  background-color: #329cff !important;\n}\n.gx-badge-indigo {\n  background-color: #3c1991 !important;\n}\n.gx-badge-purple {\n  background-color: #722ed1 !important;\n}\n.gx-badge-orange {\n  background-color: #fa8c16 !important;\n}\n.gx-badge-yellow {\n  background-color: #fadb14 !important;\n}\n.gx-badge-teal {\n  background-color: #20c997 !important;\n}\n.gx-badge-cyan {\n  background-color: #13c2c2 !important;\n}\n.gx-badge-sepia {\n  background-color: #7c3535 !important;\n}\n.gx-badge-geekblue {\n  background-color: #030852 !important;\n}\n/* Ripple magic */\n.gx-ripple-effect {\n  position: relative;\n  overflow: hidden;\n}\n.gx-ripple-effect:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 5px;\n  height: 5px;\n  background: rgba(255, 255, 255, 0.5);\n  opacity: 0;\n  -webkit-border-radius: 100%;\n  -moz-border-radius: 100%;\n  border-radius: 100%;\n  transform: scale(1, 1) translate(-50%);\n  transform-origin: 50% 50%;\n}\n.gx-ripple-effect:hover:after {\n  animation: ripple 1s ease-out;\n}\n@keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n@-webkit-keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n.gx-pulse-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);\n  animation: pulse 2s infinite;\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n  }\n}\n@keyframes pulse {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);\n  }\n}\n.gx-online-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n@-webkit-keyframes online {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n  }\n}\n@keyframes online {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);\n  }\n}\n.gx-away-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  animation: away 2s infinite;\n}\n@-webkit-keyframes away {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n  }\n}\n@keyframes away {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n    box-shadow: 0 0 0 10px rgba(250, 219, 20, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n    box-shadow: 0 0 0 0 rgba(250, 219, 20, 0);\n  }\n}\n.gx-orange-effect {\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  animation: away 2s infinite;\n}\n@-webkit-keyframes away {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n  }\n}\n@keyframes away {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n    box-shadow: 0 0 0 10px rgba(250, 140, 22, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n    box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);\n  }\n}\n@-webkit-keyframes fxicon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes fxicon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.fxicon-hc-spin {\n  -webkit-animation: fxicon-spin 1.5s infinite linear;\n  animation: fxicon-spin 1.5s infinite linear;\n}\n@-webkit-keyframes fadein {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadein {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadein {\n  -webkit-animation-name: fadein;\n  animation-name: fadein;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n@-webkit-keyframes fadeout {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeout {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeout {\n  -webkit-animation-name: fadeout;\n  animation-name: fadeout;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n  /* This is more usable for users trying to click it. */\n  background-color: rgba(100, 100, 100, 0.1);\n  -webkit-border-radius: 100px;\n}\n/* hover effect for both scrollbar area, and scrollbar 'thumb' */\n::-webkit-scrollbar:hover {\n  background-color: rgba(0, 0, 0, 0.09);\n}\n/* The scrollbar 'thumb' ...that marque oval shape in a scrollbar */\n::-webkit-scrollbar-thumb {\n  /* This is the EXACT color of Mac OS scrollbars.\n     Yes, I pulled out digital color meter */\n  background: #9BA4AC;\n  -webkit-border-radius: 100px;\n}\n::-webkit-scrollbar-thumb:active {\n  background: #9BA4AC;\n  /* Some darker color when you click it */\n  -webkit-border-radius: 100px;\n}\n/*Dark Mode */\n.dark-theme ::-webkit-scrollbar-thumb {\n  /* This is the EXACT color of Mac OS scrollbars.\n      Yes, I pulled out digital color meter */\n  background: #226380;\n  -webkit-border-radius: 100px;\n}\n.dark-theme ::-webkit-scrollbar-thumb:active {\n  background: #226380;\n  /* Some darker color when you click it */\n  -webkit-border-radius: 100px;\n}\n/* Hide the print-only version by default on screen */\n.showWhenPrint {\n  display: none !important;\n}\n@media print {\n  /* 4. Hide the screen-only version (MousePanZoom) */\n  .hideWhenPrint {\n    display: none !important;\n  }\n  /* 5. Show the print-only version and ensure it fills the page */\n  .showWhenPrint {\n    display: block !important;\n  }\n}\n/*Base Styles*/\nbody {\n  overflow: hidden;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  width: 100% !important;\n  position: relative;\n  font-weight: 400;\n}\nbody.framed-layout {\n  padding: 20px;\n  background-color: #2EB1EF;\n}\n@media screen and (max-width: 991px) {\n  body.framed-layout {\n    padding: 0;\n  }\n}\nbody.boxed-layout {\n  background-color: #2EB1EF;\n  max-width: 1280px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n@media screen and (min-width: 1600px) {\n  body.boxed-layout {\n    max-width: 1500px;\n  }\n}\nbody.full-scroll {\n  overflow: inherit;\n}\n#root {\n  height: 100vh;\n}\n.framed-layout #root {\n  height: calc(100vh - 40px);\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout #root {\n    height: 100vh;\n    -webkit-box-shadow: none !important;\n    -moz-box-shadow: none !important;\n    box-shadow: none !important;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.gx-pointer,\n.gx-link {\n  cursor: pointer;\n}\na,\n.gx-link {\n  color: #2EB1EF;\n}\na:hover,\n.gx-link:hover,\na:focus,\n.gx-link:focus {\n  color: #2EB1EF;\n}\na:focus {\n  text-decoration: none;\n}\nol,\nul,\ndl {\n  padding-left: 30px;\n  margin-bottom: 10px;\n}\nimg {\n  max-width: 100%;\n}\n.gx-w-25 {\n  width: 25% !important;\n}\n.gx-w-50 {\n  width: 50% !important;\n}\n.gx-w-75 {\n  width: 75% !important;\n}\n.gx-w-100 {\n  width: 100% !important;\n}\n.gx-h-25 {\n  height: 25% !important;\n}\n.gx-h-50 {\n  height: 50% !important;\n}\n.gx-h-75 {\n  height: 75% !important;\n}\n.gx-h-100 {\n  height: 100% !important;\n}\n.gx-mw-100 {\n  max-width: 100% !important;\n}\n.gx-mh-100 {\n  max-height: 100% !important;\n}\n.gx-minw50 {\n  min-width: 50px;\n}\n.gx-border {\n  border: solid 1px #e8e8e8;\n}\n.gx-border-2 {\n  border: solid 2px #e8e8e8;\n}\n.gx-border-top {\n  border-top: solid 1px #e8e8e8;\n}\n.gx-border-bottom {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-border-bottom-2 {\n  border-bottom: solid 2px #e8e8e8;\n}\n.gx-border-left {\n  border-left: solid 1px #e8e8e8;\n}\n.gx-border-right {\n  border-right: solid 1px #e8e8e8;\n}\n.gx-border-0 {\n  border: 0 none !important;\n}\n.gx-page-heading {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-page-heading {\n    margin-bottom: 20px;\n  }\n}\n.gx-page-title {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.gx-size-200 {\n  height: 200px !important;\n  width: 200px !important;\n  line-height: 200px !important;\n}\n.gx-size-150 {\n  height: 150px !important;\n  width: 150px !important;\n  line-height: 150px !important;\n}\n.gx-size-120 {\n  height: 120px !important;\n  width: 120px !important;\n  line-height: 120px !important;\n}\n.gx-size-100 {\n  height: 100px !important;\n  width: 100px !important;\n  line-height: 100px !important;\n}\n.gx-size-90 {\n  height: 90px !important;\n  width: 90px !important;\n  line-height: 90px !important;\n}\n.gx-size-80 {\n  height: 80px !important;\n  width: 80px !important;\n  line-height: 80px !important;\n}\n.gx-size-60 {\n  height: 60px !important;\n  width: 60px !important;\n  line-height: 60px !important;\n}\n.gx-size-50 {\n  height: 50px !important;\n  width: 50px !important;\n  line-height: 50px !important;\n}\n.gx-size-40 {\n  height: 40px !important;\n  width: 40px !important;\n  line-height: 40px !important;\n}\n.gx-size-36 {\n  height: 36px !important;\n  width: 36px !important;\n  line-height: 36px !important;\n}\n.gx-size-30 {\n  height: 30px !important;\n  width: 30px !important;\n  line-height: 30px !important;\n}\n.gx-size-24 {\n  height: 24px !important;\n  width: 24px !important;\n  line-height: 24px !important;\n}\n.gx-size-20 {\n  height: 20px !important;\n  width: 20px !important;\n  line-height: 20px !important;\n}\n.gx-size-15 {\n  height: 15px !important;\n  width: 15px !important;\n  line-height: 14px !important;\n}\n.gx-size-10 {\n  height: 10px !important;\n  width: 10px !important;\n  line-height: 10px !important;\n}\n.gx-size-8 {\n  height: 8px !important;\n  width: 8px !important;\n  line-height: 8px !important;\n}\n.gx-width-175 {\n  width: 175px !important;\n}\n.gx-img-fluid,\n.gx-img-thumbnail {\n  max-width: 100%;\n  height: auto;\n}\n.gx-img-fluid-full {\n  width: 100%;\n}\n/*Social Style*/\n.gx-social-link {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin: 0 -5px 10px;\n}\n.gx-social-link li {\n  padding: 0 5px;\n  margin-bottom: 5px;\n  line-height: 1;\n}\n.gx-social-link li a,\n.gx-social-link li .gx-link,\n.gx-social-link li i {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  line-height: 34px;\n  font-size: 16px;\n  text-align: center;\n  color: #2EB1EF;\n  border: solid 1px #2EB1EF;\n  border-radius: 50%;\n}\n.gx-social-link li.active a,\n.gx-social-link li.active .gx-link,\n.gx-social-link li.active i,\n.gx-social-link li a:hover,\n.gx-social-link li .gx-link:hover,\n.gx-social-link li i:hover,\n.gx-social-link li a:focus,\n.gx-social-link li .gx-link:focus,\n.gx-social-link li i:focus {\n  color: #ffffff;\n  background: #2EB1EF;\n}\n.gx-card-social .gx-social-link {\n  margin-bottom: 0;\n  -webkit-justify-content: space-around;\n  -ms-justify-content: space-around;\n  justify-content: space-around;\n}\n.gx-float-left {\n  float: left !important;\n}\n.gx-float-right {\n  float: right !important;\n}\n.gx-float-none {\n  float: none !important;\n}\n@media (min-width: 576px) {\n  .gx-float-sm-left {\n    float: left !important;\n  }\n  .gx-float-sm-right {\n    float: right !important;\n  }\n  .gx-float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .gx-float-md-left {\n    float: left !important;\n  }\n  .gx-float-md-right {\n    float: right !important;\n  }\n  .gx-float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .gx-float-lg-left {\n    float: left !important;\n  }\n  .gx-float-lg-right {\n    float: right !important;\n  }\n  .gx-float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .gx-float-xl-left {\n    float: left !important;\n  }\n  .gx-float-xl-right {\n    float: right !important;\n  }\n  .gx-float-xl-none {\n    float: none !important;\n  }\n}\n.gx-position-static {\n  position: static !important;\n}\n.gx-position-relative {\n  position: relative !important;\n}\n.gx-position-absolute {\n  position: absolute !important;\n}\n.gx-position-fixed {\n  position: fixed !important;\n}\n.gx-position-sticky {\n  position: sticky !important;\n}\n.gx-fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.gx-fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n.gx-top-0 {\n  top: 0 !important;\n}\n.gx-bottom-0 {\n  bottom: 0 !important;\n}\n.gx-left-0 {\n  left: 0 !important;\n}\n.gx-right-0 {\n  right: 0 !important;\n}\n/*Embed Responsive Classes*/\n.gx-embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.gx-embed-responsive:before {\n  display: block;\n  content: \"\";\n}\n.gx-embed-responsive .gx-embed-responsive-item,\n.gx-embed-responsive iframe,\n.gx-embed-responsive embed,\n.gx-embed-responsive object,\n.gx-embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.gx-embed-responsive-21by9:before {\n  padding-top: 42.8571428571%;\n}\n.gx-embed-responsive-16by9:before {\n  padding-top: 56.25%;\n}\n.gx-embed-responsive-4by3:before {\n  padding-top: 75%;\n}\n.gx-embed-responsive-1by1:before {\n  padding-top: 100%;\n}\n/*Media Object Classes*/\n.gx-media {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: flex-start;\n  -ms-align-items: flex-start;\n  align-items: flex-start;\n}\n.gx-media-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n/*Overflow styles*/\n.gx-overflow-auto {\n  overflow: auto;\n}\n.gx-z-index-20 {\n  position: relative;\n  z-index: 20;\n}\n/*Hr style*/\nhr {\n  border-color: rgba(250, 250, 250, 0.2);\n  margin: 15px 0;\n}\n/*Status style*/\n.gx-status-pos {\n  position: relative;\n}\n.gx-status-pos .gx-status {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 2px;\n  z-index: 1;\n  width: 12px;\n  height: 12px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-status-pos .gx-status.gx-small {\n  width: 8px;\n  height: 8px;\n}\n.gx-status-pos .gx-status.gx-status-rtl {\n  top: -4px;\n  left: auto;\n  right: -4px;\n}\n.gx-status-pos .gx-status.gx-online {\n  background-color: #52c41a;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n.gx-status-pos .gx-status.gx-offline {\n  background-color: #ffffff;\n  border: solid 1px #52c41a;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  box-shadow: 0 0 0 rgba(82, 196, 26, 0.4);\n  animation: online 2s infinite;\n}\n.gx-status-pos .gx-status.gx-away {\n  background-color: #fadb14;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  box-shadow: 0 0 0 rgba(250, 219, 20, 0.4);\n  animation: away 2s infinite;\n}\n.gx-status-pos .gx-status.gx-orange {\n  background-color: #fa8c16;\n  display: block;\n  -webkit-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  -moz-box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  box-shadow: 0 0 0 rgba(250, 140, 22, 0.4);\n  animation: away 2s infinite;\n}\n.gx-box-shadow {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n.gx-no-box-shadow {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.gx-rounded-xs {\n  -webkit-border-radius: 2px !important;\n  -moz-border-radius: 2px !important;\n  border-radius: 2px !important;\n}\n.gx-rounded-sm {\n  -webkit-border-radius: 4px !important;\n  -moz-border-radius: 4px !important;\n  border-radius: 4px !important;\n}\n.gx-rounded-base {\n  -webkit-border-radius: 6px !important;\n  -moz-border-radius: 6px !important;\n  border-radius: 6px !important;\n}\n.gx-rounded-lg {\n  -webkit-border-radius: 10px !important;\n  -moz-border-radius: 10px !important;\n  border-radius: 10px !important;\n}\n.gx-rounded-xxl {\n  -webkit-border-radius: 30px !important;\n  -moz-border-radius: 30px !important;\n  border-radius: 30px !important;\n}\n.gx-rounded-circle {\n  -webkit-border-radius: 50% !important;\n  -moz-border-radius: 50% !important;\n  border-radius: 50% !important;\n}\n.gx-border-radius-top-left-0 {\n  -moz-border-top-left-radius: 0;\n  -webkit-border-top-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.gx-border-radius-top-right-0 {\n  -moz-border-top-right-radius: 0;\n  -webkit-border-top-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.gx-border-radius-bottom-left-0 {\n  -moz-border-bottom-left-radius: 0;\n  -webkit-border-bottom-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.gx-border-radius-bottom-right-0 {\n  -moz-border-bottom-right-radius: 0;\n  -webkit-border-bottom-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.gx-vertical-align-top {\n  vertical-align: top;\n}\n.gx-vertical-align-middle {\n  vertical-align: middle;\n}\n.gx-vertical-align-bottom {\n  vertical-align: bottom;\n}\n.gx-separator {\n  background-color: #2EB1EF;\n  width: 20px;\n  height: 2px;\n  margin: 0 auto 10px;\n}\n.gx-loader-400 {\n  height: 400px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-loader-400 {\n    height: 300px;\n  }\n}\n.gx-object-cover {\n  object-fit: cover;\n}\n.cke_editable,\n.cke_editor_editor2 {\n  font-family: \"DM Sans\", sans-serif !important;\n}\n.gx-top2 {\n  position: relative;\n  top: 2px;\n}\n@media screen and (max-width: 1366px) {\n  .gx-hide-1366 {\n    display: none;\n  }\n}\n/*flex Styles*/\n.gx-d-flex {\n  display: flex !important;\n}\n.gx-d-none {\n  display: none !important;\n}\n.gx-d-inline-block {\n  display: inline-block !important;\n}\n.gx-d-block {\n  display: block !important;\n}\n.gx-d-inline-flex {\n  display: inline-flex !important;\n}\n.gx-flex-1 {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n/*Display Flex Classes*/\n.gx-flex-row {\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: -ms-flex !important;\n  display: flex !important;\n  -webkit-flex-direction: row !important;\n  -ms-flex-direction: row !important;\n  flex-direction: row !important;\n  -webkit-flex-wrap: wrap !important;\n  -ms-flex-wrap: wrap !important;\n  flex-wrap: wrap !important;\n}\n.gx-flex-column {\n  display: -webkit-flex !important;\n  display: -ms-flexbox !important;\n  display: -ms-flex !important;\n  display: flex !important;\n  -webkit-flex-direction: column !important;\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n  -webkit-flex-wrap: nowrap !important;\n  -ms-flex-wrap: nowrap !important;\n  flex-wrap: nowrap !important;\n}\n.gx-flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.gx-flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.gx-flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.gx-justify-content-start {\n  -webkit-justify-content: flex-start !important;\n  -ms-justify-content: flex-start !important;\n  justify-content: flex-start !important;\n}\n.gx-justify-content-end {\n  -webkit-justify-content: flex-end !important;\n  -ms-justify-content: flex-end !important;\n  justify-content: flex-end !important;\n}\n.gx-justify-content-center {\n  -webkit-justify-content: center !important;\n  -ms-justify-content: center !important;\n  justify-content: center !important;\n}\n.gx-justify-content-between {\n  -webkit-justify-content: space-between !important;\n  -ms-justify-content: space-between !important;\n  justify-content: space-between !important;\n}\n.gx-justify-content-around {\n  -webkit-justify-content: space-around !important;\n  -ms-justify-content: space-around !important;\n  justify-content: space-around !important;\n}\n.gx-align-items-start {\n  -webkit-align-items: flex-start !important;\n  -ms-align-items: flex-start !important;\n  align-items: flex-start !important;\n}\n.gx-align-items-end {\n  -webkit-align-items: flex-end !important;\n  -ms-align-items: flex-end !important;\n  align-items: flex-end !important;\n}\n.gx-align-items-center {\n  -webkit-align-items: center !important;\n  -ms-align-items: center !important;\n  align-items: center !important;\n}\n.gx-align-items-stretch {\n  -webkit-align-items: stretch !important;\n  -ms-align-items: stretch !important;\n  align-items: stretch !important;\n}\n.gx-align-content-start {\n  -webkit-align-content: flex-start !important;\n  -ms-align-content: flex-start !important;\n  align-content: flex-start !important;\n}\n.gx-align-content-end {\n  -webkit-align-content: flex-end !important;\n  -ms-align-content: flex-end !important;\n  align-content: flex-end !important;\n}\n.gx-align-content-center {\n  -webkit-align-content: center !important;\n  -ms-align-content: center !important;\n  align-content: center !important;\n}\n.gx-align-content-between {\n  -webkit-align-content: space-between !important;\n  -ms-align-content: space-between !important;\n  align-content: space-between !important;\n}\n.gx-align-content-around {\n  -webkit-align-content: space-around !important;\n  -ms-align-content: space-around !important;\n  align-content: space-around !important;\n}\n.gx-align-content-stretch {\n  -webkit-align-content: stretch !important;\n  -ms-align-content: stretch !important;\n  align-content: stretch !important;\n}\n.gx-align-self-auto {\n  -webkit-align-self: auto !important;\n  -ms-align-self: auto !important;\n  align-self: auto !important;\n}\n.gx-align-self-start {\n  -webkit-align-self: flex-start !important;\n  -ms-align-self: flex-start !important;\n  align-self: flex-start !important;\n}\n.gx-align-self-end {\n  -webkit-align-self: flex-end !important;\n  -ms-align-self: flex-end !important;\n  align-self: flex-end !important;\n}\n.gx-align-self-center {\n  -webkit-align-self: center !important;\n  -ms-align-self: center !important;\n  align-self: center !important;\n}\n.gx-align-self-baseline {\n  -webkit-align-self: baseline !important;\n  -ms-align-self: baseline !important;\n  align-self: baseline !important;\n}\n.gx-align-self-stretch {\n  -webkit-align-self: stretch !important;\n  -ms-align-self: stretch !important;\n  align-self: stretch !important;\n}\n.gx-order-first {\n  -ms-flex-order: -1;\n  order: -1;\n}\n.gx-order-1 {\n  -ms-flex-order: 1;\n  order: 1;\n}\n.gx-order-2 {\n  -ms-flex-order: 2;\n  order: 2;\n}\n.gx-order-3 {\n  -ms-flex-order: 3;\n  order: 3;\n}\n.gx-order-4 {\n  -ms-flex-order: 4;\n  order: 4;\n}\n.gx-order-5 {\n  -ms-flex-order: 5;\n  order: 5;\n}\n.gx-order-6 {\n  -ms-flex-order: 6;\n  order: 6;\n}\n.gx-order-7 {\n  -ms-flex-order: 7;\n  order: 7;\n}\n.gx-order-8 {\n  -ms-flex-order: 8;\n  order: 8;\n}\n.gx-order-9 {\n  -ms-flex-order: 9;\n  order: 9;\n}\n.gx-order-10 {\n  -ms-flex-order: 10;\n  order: 10;\n}\n.gx-order-11 {\n  -ms-flex-order: 11;\n  order: 11;\n}\n.gx-order-12 {\n  -ms-flex-order: 12;\n  order: 12;\n}\n.gx-offset-1 {\n  margin-left: 8.333333%;\n}\n.gx-offset-2 {\n  margin-left: 16.666667%;\n}\n.gx-offset-3 {\n  margin-left: 25%;\n}\n.gx-offset-4 {\n  margin-left: 33.333333%;\n}\n.gx-offset-5 {\n  margin-left: 41.666667%;\n}\n.gx-offset-6 {\n  margin-left: 50%;\n}\n.gx-offset-7 {\n  margin-left: 58.333333%;\n}\n.gx-offset-8 {\n  margin-left: 66.666667%;\n}\n.gx-offset-9 {\n  margin-left: 75%;\n}\n.gx-offset-10 {\n  margin-left: 83.333333%;\n}\n.gx-offset-11 {\n  margin-left: 91.666667%;\n}\n@media screen and (min-width: 576px) {\n  .gx-d-sm-none {\n    display: none !important;\n  }\n  .gx-d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-sm-block {\n    display: block !important;\n  }\n  .gx-d-sm-flex {\n    display: flex !important;\n  }\n  .gx-d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-sm-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-sm-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-sm-center {\n    align-items: center !important;\n  }\n  .gx-align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-sm-center {\n    align-content: center !important;\n  }\n  .gx-align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-sm-center {\n    align-self: center !important;\n  }\n  .gx-align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-sm-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-sm-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-sm-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-sm-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-sm-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-sm-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-sm-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-sm-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-sm-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-sm-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-sm-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-sm-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-sm-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-sm-0 {\n    margin-left: 0;\n  }\n  .gx-offset-sm-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-sm-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-sm-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-sm-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-sm-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-sm-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-sm-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-sm-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-sm-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-sm-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-sm-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 768px) {\n  .gx-d-md-none {\n    display: none !important;\n  }\n  .gx-d-md-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-md-block {\n    display: block !important;\n  }\n  .gx-d-md-flex {\n    display: flex !important;\n  }\n  .gx-d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-md-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-md-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-md-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-md-center {\n    align-items: center !important;\n  }\n  .gx-align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-md-center {\n    align-content: center !important;\n  }\n  .gx-align-content-md-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-md-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-md-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-md-center {\n    align-self: center !important;\n  }\n  .gx-align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-md-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-md-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-md-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-md-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-md-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-md-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-md-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-md-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-md-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-md-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-md-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-md-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-md-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-md-0 {\n    margin-left: 0;\n  }\n  .gx-offset-md-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-md-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-md-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-md-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-md-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-md-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-md-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-md-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-md-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-md-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-md-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-d-lg-none {\n    display: none !important;\n  }\n  .gx-d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-lg-block {\n    display: block !important;\n  }\n  .gx-d-lg-flex {\n    display: flex !important;\n  }\n  .gx-d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-lg-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-lg-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .gx-justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-lg-center {\n    align-items: center !important;\n  }\n  .gx-align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-lg-center {\n    align-content: center !important;\n  }\n  .gx-align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-lg-center {\n    align-self: center !important;\n  }\n  .gx-align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-lg-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-lg-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-lg-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-lg-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-lg-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-lg-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-lg-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-lg-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-lg-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-lg-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-lg-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-lg-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-lg-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-lg-0 {\n    margin-left: 0;\n  }\n  .gx-offset-lg-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-lg-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-lg-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-lg-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-lg-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-lg-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-lg-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-lg-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-lg-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-lg-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-lg-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-d-xl-none {\n    display: none !important;\n  }\n  .gx-d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .gx-d-xl-block {\n    display: block !important;\n  }\n  .gx-d-xl-flex {\n    display: flex !important;\n  }\n  .gx-d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .gx-flex-xl-row {\n    flex-direction: row !important;\n  }\n  .gx-flex-xl-column {\n    flex-direction: column !important;\n  }\n  .gx-flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .gx-flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .gx-flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .gx-flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .gx-flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gx-justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .gx-justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .gx-justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .gx-justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .gx-align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .gx-align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .gx-align-items-xl-center {\n    align-items: center !important;\n  }\n  .gx-align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .gx-align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .gx-align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .gx-align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .gx-align-content-xl-center {\n    align-content: center !important;\n  }\n  .gx-align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .gx-align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .gx-align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .gx-align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .gx-align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .gx-align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .gx-align-self-xl-center {\n    align-self: center !important;\n  }\n  .gx-align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .gx-align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .gx-order-xl-first {\n    -ms-flex-order: -1;\n    order: -1;\n  }\n  .gx-order-xl-1 {\n    -ms-flex-order: 1;\n    order: 1;\n  }\n  .gx-order-xl-2 {\n    -ms-flex-order: 2;\n    order: 2;\n  }\n  .gx-order-xl-3 {\n    -ms-flex-order: 3;\n    order: 3;\n  }\n  .gx-order-xl-4 {\n    -ms-flex-order: 4;\n    order: 4;\n  }\n  .gx-order-xl-5 {\n    -ms-flex-order: 5;\n    order: 5;\n  }\n  .gx-order-xl-6 {\n    -ms-flex-order: 6;\n    order: 6;\n  }\n  .gx-order-xl-7 {\n    -ms-flex-order: 7;\n    order: 7;\n  }\n  .gx-order-xl-8 {\n    -ms-flex-order: 8;\n    order: 8;\n  }\n  .gx-order-xl-9 {\n    -ms-flex-order: 9;\n    order: 9;\n  }\n  .gx-order-xl-10 {\n    -ms-flex-order: 10;\n    order: 10;\n  }\n  .gx-order-xl-11 {\n    -ms-flex-order: 11;\n    order: 11;\n  }\n  .gx-order-xl-12 {\n    -ms-flex-order: 12;\n    order: 12;\n  }\n  .gx-offset-xl-0 {\n    margin-left: 0;\n  }\n  .gx-offset-xl-1 {\n    margin-left: 8.333333%;\n  }\n  .gx-offset-xl-2 {\n    margin-left: 16.666667%;\n  }\n  .gx-offset-xl-3 {\n    margin-left: 25%;\n  }\n  .gx-offset-xl-4 {\n    margin-left: 33.333333%;\n  }\n  .gx-offset-xl-5 {\n    margin-left: 41.666667%;\n  }\n  .gx-offset-xl-6 {\n    margin-left: 50%;\n  }\n  .gx-offset-xl-7 {\n    margin-left: 58.333333%;\n  }\n  .gx-offset-xl-8 {\n    margin-left: 66.666667%;\n  }\n  .gx-offset-xl-9 {\n    margin-left: 75%;\n  }\n  .gx-offset-xl-10 {\n    margin-left: 83.333333%;\n  }\n  .gx-offset-xl-11 {\n    margin-left: 91.666667%;\n  }\n}\n.ant-row {\n  margin-left: -16px;\n  margin-right: -16px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.ant-row > [class*=ant-col-] {\n  margin: 0 -0.3px;\n}\n.gx-col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (max-width: 480px) {\n  .gx-col-full {\n    width: 100%;\n  }\n}\n/*Margin Padding Styles*/\n.gx-mb-30 {\n  margin-bottom: 30px !important;\n}\n.gx-mb-10 {\n  margin-bottom: 10px !important;\n}\n.gx-m-0 {\n  margin: 0 !important;\n}\n.gx-mt-0,\n.gx-my-0 {\n  margin-top: 0 !important;\n}\n.gx-mr-0,\n.gx-mx-0 {\n  margin-right: 0 !important;\n}\n.gx-mb-0,\n.gx-my-0 {\n  margin-bottom: 0 !important;\n}\n.gx-ml-0,\n.gx-mx-0 {\n  margin-left: 0 !important;\n}\n.gx-m-1 {\n  margin: 0.25rem !important;\n}\n.gx-mt-1,\n.gx-my-1 {\n  margin-top: 0.25rem !important;\n}\n.gx-mr-1,\n.gx-mx-1 {\n  margin-right: 0.25rem !important;\n}\n.gx-mb-1,\n.gx-my-1 {\n  margin-bottom: 0.25rem !important;\n}\n.gx-ml-1,\n.gx-mx-1 {\n  margin-left: 0.25rem !important;\n}\n.gx-m-2 {\n  margin: 0.5rem !important;\n}\n.gx-mt-2,\n.gx-my-2 {\n  margin-top: 0.5rem !important;\n}\n.gx-mr-2,\n.gx-mx-2 {\n  margin-right: 0.5rem !important;\n}\n.gx-mb-2,\n.gx-my-2 {\n  margin-bottom: 0.5rem !important;\n}\n.gx-ml-2,\n.gx-mx-2 {\n  margin-left: 0.5rem !important;\n}\n.gx-m-3 {\n  margin: 1rem !important;\n}\n.gx-mt-3,\n.gx-my-3 {\n  margin-top: 1rem !important;\n}\n.gx-mr-3,\n.gx-mx-3 {\n  margin-right: 1rem !important;\n}\n.gx-mb-3,\n.gx-my-3 {\n  margin-bottom: 1rem !important;\n}\n.gx-ml-3,\n.gx-mx-3 {\n  margin-left: 1rem !important;\n}\n.gx-m-4 {\n  margin: 1.5rem !important;\n}\n.gx-mt-4,\n.gx-my-4 {\n  margin-top: 1.5rem !important;\n}\n.gx-mr-4,\n.gx-mx-4 {\n  margin-right: 1.5rem !important;\n}\n.gx-mb-4,\n.gx-my-4 {\n  margin-bottom: 1.5rem !important;\n}\n.gx-ml-4,\n.gx-mx-4 {\n  margin-left: 1.5rem !important;\n}\n.gx-m-5 {\n  margin: 3rem !important;\n}\n.gx-mt-5,\n.gx-my-5 {\n  margin-top: 3rem !important;\n}\n.gx-mr-5,\n.gx-mx-5 {\n  margin-right: 3rem !important;\n}\n.gx-mb-5,\n.gx-my-5 {\n  margin-bottom: 3rem !important;\n}\n.gx-ml-5,\n.gx-mx-5 {\n  margin-left: 3rem !important;\n}\n.gx-p-0 {\n  padding: 0 !important;\n}\n.gx-pt-0,\n.gx-py-0 {\n  padding-top: 0 !important;\n}\n.gx-pr-0,\n.gx-px-0 {\n  padding-right: 0 !important;\n}\n.gx-pb-0,\n.gx-py-0 {\n  padding-bottom: 0 !important;\n}\n.gx-pl-0,\n.gx-px-0 {\n  padding-left: 0 !important;\n}\n.gx-p-1 {\n  padding: 0.25rem !important;\n}\n.gx-pt-1,\n.gx-py-1 {\n  padding-top: 0.25rem !important;\n}\n.gx-pr-1,\n.gx-px-1 {\n  padding-right: 0.25rem !important;\n}\n.gx-pb-1,\n.gx-py-1 {\n  padding-bottom: 0.25rem !important;\n}\n.gx-pl-1,\n.gx-px-1 {\n  padding-left: 0.25rem !important;\n}\n.gx-p-2 {\n  padding: 0.5rem !important;\n}\n.gx-pt-2,\n.gx-py-2 {\n  padding-top: 0.5rem !important;\n}\n.gx-pr-2,\n.gx-px-2 {\n  padding-right: 0.5rem !important;\n}\n.gx-pb-2,\n.gx-py-2 {\n  padding-bottom: 0.5rem !important;\n}\n.gx-pl-2,\n.gx-px-2 {\n  padding-left: 0.5rem !important;\n}\n.gx-p-3 {\n  padding: 1rem !important;\n}\n.gx-pt-3,\n.gx-py-3 {\n  padding-top: 1rem !important;\n}\n.gx-pr-3,\n.gx-px-3 {\n  padding-right: 1rem !important;\n}\n.gx-pb-3,\n.gx-py-3 {\n  padding-bottom: 1rem !important;\n}\n.gx-pl-3,\n.gx-px-3 {\n  padding-left: 1rem !important;\n}\n.gx-p-4 {\n  padding: 1.5rem !important;\n}\n.gx-pt-4,\n.gx-py-4 {\n  padding-top: 1.5rem !important;\n}\n.gx-pr-4,\n.gx-px-4 {\n  padding-right: 1.5rem !important;\n}\n.gx-pb-4,\n.gx-py-4 {\n  padding-bottom: 1.5rem !important;\n}\n.gx-pl-4,\n.gx-px-4 {\n  padding-left: 1.5rem !important;\n}\n.gx-p-5 {\n  padding: 2rem !important;\n}\n.gx-pt-5,\n.gx-py-5 {\n  padding-top: 2rem !important;\n}\n.gx-pr-5,\n.gx-px-5 {\n  padding-right: 2rem !important;\n}\n.gx-pb-5,\n.gx-py-5 {\n  padding-bottom: 2rem !important;\n}\n.gx-pl-5,\n.gx-px-5 {\n  padding-left: 2rem !important;\n}\n.gx-m-auto {\n  margin: auto !important;\n}\n.gx-mt-auto,\n.gx-my-auto {\n  margin-top: auto !important;\n}\n.gx-mr-auto,\n.gx-mx-auto {\n  margin-right: auto !important;\n}\n.gx-mb-auto,\n.gx-my-auto {\n  margin-bottom: auto !important;\n}\n.gx-ml-auto,\n.gx-mx-auto {\n  margin-left: auto !important;\n}\n@media (min-width: 576px) {\n  .gx-m-sm-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-sm-0,\n  .gx-my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-sm-0,\n  .gx-mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-sm-0,\n  .gx-my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-sm-0,\n  .gx-mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-sm-1,\n  .gx-my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-sm-1,\n  .gx-mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-sm-1,\n  .gx-my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-sm-1,\n  .gx-mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-sm-2,\n  .gx-my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-sm-2,\n  .gx-mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-sm-2,\n  .gx-my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-sm-2,\n  .gx-mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-sm-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-sm-3,\n  .gx-my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-sm-3,\n  .gx-mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-sm-3,\n  .gx-my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-sm-3,\n  .gx-mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-sm-4,\n  .gx-my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-sm-4,\n  .gx-mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-sm-4,\n  .gx-my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-sm-4,\n  .gx-mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-sm-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-sm-5,\n  .gx-my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-sm-5,\n  .gx-mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-sm-5,\n  .gx-my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-sm-5,\n  .gx-mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-sm-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-sm-0,\n  .gx-py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-sm-0,\n  .gx-px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-sm-0,\n  .gx-py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-sm-0,\n  .gx-px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-sm-1,\n  .gx-py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-sm-1,\n  .gx-px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-sm-1,\n  .gx-py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-sm-1,\n  .gx-px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-sm-2,\n  .gx-py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-sm-2,\n  .gx-px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-sm-2,\n  .gx-py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-sm-2,\n  .gx-px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-sm-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-sm-3,\n  .gx-py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-sm-3,\n  .gx-px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-sm-3,\n  .gx-py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-sm-3,\n  .gx-px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-sm-4,\n  .gx-py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-sm-4,\n  .gx-px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-sm-4,\n  .gx-py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-sm-4,\n  .gx-px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-sm-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-sm-5,\n  .gx-py-sm-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-sm-5,\n  .gx-px-sm-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-sm-5,\n  .gx-px-sm-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-sm-auto {\n    margin: auto !important;\n  }\n  .gx-mt-sm-auto,\n  .gx-my-sm-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-sm-auto,\n  .gx-mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-sm-auto,\n  .gx-my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-sm-auto,\n  .gx-mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .gx-m-md-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-md-0,\n  .gx-my-md-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-md-0,\n  .gx-mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-md-0,\n  .gx-my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-md-0,\n  .gx-mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-md-1,\n  .gx-my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-md-1,\n  .gx-mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-md-1,\n  .gx-my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-md-1,\n  .gx-mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-md-2,\n  .gx-my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-md-2,\n  .gx-mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-md-2,\n  .gx-my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-md-2,\n  .gx-mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-md-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-md-3,\n  .gx-my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-md-3,\n  .gx-mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-md-3,\n  .gx-my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-md-3,\n  .gx-mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-md-4,\n  .gx-my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-md-4,\n  .gx-mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-md-4,\n  .gx-my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-md-4,\n  .gx-mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-md-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-md-5,\n  .gx-my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-md-5,\n  .gx-mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-md-5,\n  .gx-my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-md-5,\n  .gx-mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-md-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-md-0,\n  .gx-py-md-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-md-0,\n  .gx-px-md-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-md-0,\n  .gx-py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-md-0,\n  .gx-px-md-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-md-1,\n  .gx-py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-md-1,\n  .gx-px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-md-1,\n  .gx-py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-md-1,\n  .gx-px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-md-2,\n  .gx-py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-md-2,\n  .gx-px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-md-2,\n  .gx-py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-md-2,\n  .gx-px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-md-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-md-3,\n  .gx-py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-md-3,\n  .gx-px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-md-3,\n  .gx-py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-md-3,\n  .gx-px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-md-4,\n  .gx-py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-md-4,\n  .gx-px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-md-4,\n  .gx-py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-md-4,\n  .gx-px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-md-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-md-5,\n  .gx-py-md-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-md-5,\n  .gx-px-md-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-md-5,\n  .gx-py-md-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-md-5,\n  .gx-px-md-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-md-auto {\n    margin: auto !important;\n  }\n  .gx-mt-md-auto,\n  .gx-my-md-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-md-auto,\n  .gx-mx-md-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-md-auto,\n  .gx-my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-md-auto,\n  .gx-mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .gx-m-lg-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-lg-0,\n  .gx-my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-lg-0,\n  .gx-mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-lg-0,\n  .gx-my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-lg-0,\n  .gx-mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-lg-1,\n  .gx-mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-lg-1,\n  .gx-my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-lg-1,\n  .gx-mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-lg-2,\n  .gx-my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-lg-2,\n  .gx-mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-lg-2,\n  .gx-my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-lg-2,\n  .gx-mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-lg-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-lg-3,\n  .gx-my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-lg-3,\n  .gx-mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-lg-3,\n  .gx-my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-lg-3,\n  .gx-mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-lg-4,\n  .gx-my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-lg-4,\n  .gx-mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-lg-4,\n  .gx-my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-lg-4,\n  .gx-mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-lg-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-lg-5,\n  .gx-my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-lg-5,\n  .gx-mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-lg-5,\n  .gx-my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-lg-5,\n  .gx-mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-lg-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-lg-0,\n  .gx-py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-lg-0,\n  .gx-px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-lg-0,\n  .gx-py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-lg-0,\n  .gx-px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-lg-1,\n  .gx-py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-lg-1,\n  .gx-px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-lg-1,\n  .gx-py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-lg-1,\n  .gx-px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-lg-2,\n  .gx-py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-lg-2,\n  .gx-px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-lg-2,\n  .gx-py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-lg-2,\n  .gx-px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-lg-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-lg-3,\n  .gx-py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-lg-3,\n  .gx-px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-lg-3,\n  .gx-py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-lg-3,\n  .gx-px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-lg-4,\n  .gx-py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-lg-4,\n  .gx-px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-lg-4,\n  .gx-py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-lg-4,\n  .gx-px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-lg-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-lg-5,\n  .gx-py-lg-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-lg-5,\n  .gx-px-lg-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-lg-5,\n  .gx-py-lg-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-lg-5,\n  .gx-px-lg-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-lg-auto {\n    margin: auto !important;\n  }\n  .gx-mt-lg-auto,\n  .gx-my-lg-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-lg-auto,\n  .gx-mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-lg-auto,\n  .gx-my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-lg-auto,\n  .gx-mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .gx-m-xl-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-xl-0,\n  .gx-my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-xl-0,\n  .gx-mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-xl-0,\n  .gx-my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-xl-0,\n  .gx-mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-xl-1,\n  .gx-my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-xl-1,\n  .gx-mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-xl-1,\n  .gx-my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-xl-1,\n  .gx-mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-xl-2,\n  .gx-my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-xl-2,\n  .gx-mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-xl-2,\n  .gx-my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-xl-2,\n  .gx-mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-xl-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-xl-3,\n  .gx-my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-xl-3,\n  .gx-mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-xl-3,\n  .gx-my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-xl-3,\n  .gx-mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-xl-4,\n  .gx-my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-xl-4,\n  .gx-mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-xl-4,\n  .gx-my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-xl-4,\n  .gx-mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-xl-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-xl-5,\n  .gx-my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-xl-5,\n  .gx-mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-xl-5,\n  .gx-my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-xl-5,\n  .gx-mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-xl-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-xl-0,\n  .gx-py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-xl-0,\n  .gx-px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-xl-0,\n  .gx-py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-xl-0,\n  .gx-px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-xl-1,\n  .gx-py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-xl-1,\n  .gx-px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-xl-1,\n  .gx-py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-xl-1,\n  .gx-px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-xl-2,\n  .gx-py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-xl-2,\n  .gx-px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-xl-2,\n  .gx-py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-xl-2,\n  .gx-px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-xl-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-xl-3,\n  .gx-py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-xl-3,\n  .gx-px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-xl-3,\n  .gx-py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-xl-3,\n  .gx-px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-xl-4,\n  .gx-py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-xl-4,\n  .gx-px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-xl-4,\n  .gx-py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-xl-4,\n  .gx-px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-xl-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-xl-5,\n  .gx-py-xl-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-xl-5,\n  .gx-px-xl-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-xl-5,\n  .gx-py-xl-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-xl-5,\n  .gx-px-xl-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-xl-auto {\n    margin: auto !important;\n  }\n  .gx-mt-xl-auto,\n  .gx-my-xl-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-xl-auto,\n  .gx-mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-xl-auto,\n  .gx-my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-xl-auto,\n  .gx-mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1368px) {\n  .gx-m-xxl-0 {\n    margin: 0 !important;\n  }\n  .gx-mt-xxl-0,\n  .gx-my-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .gx-mr-xxl-0,\n  .gx-mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .gx-mb-xxl-0,\n  .gx-my-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .gx-ml-xxl-0,\n  .gx-mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .gx-m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .gx-mt-xxl-1,\n  .gx-my-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .gx-mr-xxl-1,\n  .gx-mx-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .gx-mb-xxl-1,\n  .gx-my-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .gx-ml-xxl-1,\n  .gx-mx-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .gx-m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .gx-mt-xxl-2,\n  .gx-my-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .gx-mr-xxl-2,\n  .gx-mx-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .gx-mb-xxl-2,\n  .gx-my-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .gx-ml-xxl-2,\n  .gx-mx-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .gx-m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .gx-mt-xxl-3,\n  .gx-my-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .gx-mr-xxl-3,\n  .gx-mx-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .gx-mb-xxl-3,\n  .gx-my-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .gx-ml-xxl-3,\n  .gx-mx-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .gx-m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .gx-mt-xxl-4,\n  .gx-my-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .gx-mr-xxl-4,\n  .gx-mx-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .gx-mb-xxl-4,\n  .gx-my-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .gx-ml-xxl-4,\n  .gx-mx-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .gx-m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .gx-mt-xxl-5,\n  .gx-my-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .gx-mr-xxl-5,\n  .gx-mx-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .gx-mb-xxl-5,\n  .gx-my-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .gx-ml-xxl-5,\n  .gx-mx-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .gx-p-xxl-0 {\n    padding: 0 !important;\n  }\n  .gx-pt-xxl-0,\n  .gx-py-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .gx-pr-xxl-0,\n  .gx-px-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .gx-pb-xxl-0,\n  .gx-py-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .gx-pl-xxl-0,\n  .gx-px-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .gx-p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .gx-pt-xxl-1,\n  .gx-py-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .gx-pr-xxl-1,\n  .gx-px-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .gx-pb-xxl-1,\n  .gx-py-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .gx-pl-xxl-1,\n  .gx-px-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .gx-p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .gx-pt-xxl-2,\n  .gx-py-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .gx-pr-xxl-2,\n  .gx-px-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .gx-pb-xxl-2,\n  .gx-py-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .gx-pl-xxl-2,\n  .gx-px-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .gx-p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .gx-pt-xxl-3,\n  .gx-py-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .gx-pr-xxl-3,\n  .gx-px-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .gx-pb-xxl-3,\n  .gx-py-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .gx-pl-xxl-3,\n  .gx-px-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .gx-p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .gx-pt-xxl-4,\n  .gx-py-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .gx-pr-xxl-4,\n  .gx-px-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .gx-pb-xxl-4,\n  .gx-py-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .gx-pl-xxl-4,\n  .gx-px-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .gx-p-xxl-5 {\n    padding: 2rem !important;\n  }\n  .gx-pt-xxl-5,\n  .gx-py-xxl-5 {\n    padding-top: 2rem !important;\n  }\n  .gx-pr-xxl-5,\n  .gx-px-xxl-5 {\n    padding-right: 2rem !important;\n  }\n  .gx-pb-xxl-5,\n  .gx-py-xxl-5 {\n    padding-bottom: 2rem !important;\n  }\n  .gx-pl-xxl-5,\n  .gx-px-xxl-5 {\n    padding-left: 2rem !important;\n  }\n  .gx-m-xxl-auto {\n    margin: auto !important;\n  }\n  .gx-mt-xxl-auto,\n  .gx-my-xxl-auto {\n    margin-top: auto !important;\n  }\n  .gx-mr-xxl-auto,\n  .gx-mx-xxl-auto {\n    margin-right: auto !important;\n  }\n  .gx-mb-xxl-auto,\n  .gx-my-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .gx-ml-xxl-auto,\n  .gx-mx-xxl-auto {\n    margin-left: auto !important;\n  }\n}\n/*Typography Styles*/\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  color: #262626;\n  font-weight: 400;\n  line-height: 1.2;\n}\nh1,\n.h1 {\n  font-size: 22px;\n}\n.framed-layout h1,\n.framed-layout .h1 {\n  font-size: 20px;\n}\n@media screen and (max-width: 767px) {\n  .framed-layout h1,\n  .framed-layout .h1 {\n    font-size: 18px;\n  }\n}\n.boxed-layout h1,\n.boxed-layout .h1 {\n  font-size: 18px;\n}\n@media screen and (max-width: 767px) {\n  .boxed-layout h1,\n  .boxed-layout .h1 {\n    font-size: 16px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  h1,\n  .h1 {\n    font-size: 28px;\n  }\n  .boxed-layout h1,\n  .boxed-layout .h1 {\n    font-size: 18px;\n  }\n}\nh2,\n.h2 {\n  font-size: 20px;\n}\nh3,\n.h3 {\n  font-size: 18px;\n}\nh4,\n.h4 {\n  font-size: 16px;\n}\nh5,\n.h5 {\n  font-size: 14px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\n.gx-h1-lg {\n  font-size: 28px;\n}\n.gx-text-strikethrough {\n  text-decoration: line-through !important;\n}\n.gx-text-underline {\n  text-decoration: underline !important;\n}\n/*Font size Classes*/\n/*8px*/\n.gx-fs-xxs {\n  font-size: 8px;\n}\n/*10px*/\n.gx-fs-xs {\n  font-size: 10px;\n}\n/*11px*/\n.gx-fs-11 {\n  font-size: 11px;\n}\n/*12px*/\n.gx-fs-sm {\n  font-size: 12px;\n  line-height: 1.5;\n}\n/*14px*/\n.gx-fs-md {\n  font-size: 14px;\n  line-height: 1;\n}\n/*16px*/\n.gx-fs-lg {\n  font-size: 16px;\n  line-height: 1;\n}\n/*20px*/\n.gx-fs-xl {\n  font-size: 20px;\n  line-height: 1;\n}\n/*24px*/\n.gx-fs-xxl {\n  font-size: 24px;\n  line-height: 1.3;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xxl {\n    font-size: 20px;\n  }\n}\n/*28px*/\n.gx-fs-2xl {\n  font-size: 28px !important;\n  line-height: 1;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-2xl {\n    font-size: 20px !important;\n  }\n}\n/*30px*/\n.gx-fs-xxxl {\n  font-size: 30px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-xxxl {\n    font-size: 28px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xxxl {\n    font-size: 26px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-fs-xxxl {\n    font-size: 24px;\n  }\n}\n/*40px*/\n.gx-fs-xlxl {\n  font-size: 40px;\n  line-height: 1;\n}\n@media screen and (max-width: 1199px) {\n  .gx-fs-xlxl {\n    font-size: 32px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-fs-xlxl {\n    font-size: 28px;\n  }\n}\n/*50px*/\n.gx-fs-icon-lg {\n  font-size: 50px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-icon-lg {\n    font-size: 38px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-fs-icon-lg {\n    font-size: 30px;\n  }\n}\n/*54px*/\n.gx-fs-iconcard {\n  font-size: 54px;\n  line-height: 1;\n}\n@media screen and (max-width: 1366px) {\n  .gx-fs-iconcard {\n    font-size: 34px;\n  }\n}\n.gx-text-lowercase {\n  text-transform: lowercase;\n}\n.gx-text-uppercase {\n  text-transform: uppercase;\n}\n.gx-text-capitalize {\n  text-transform: capitalize;\n}\n.gx-font-weight-light {\n  font-weight: 300;\n}\n.gx-font-weight-normal {\n  font-weight: 400;\n}\n.gx-font-weight-medium {\n  font-weight: 500;\n}\n.gx-font-weight-semi-bold {\n  font-weight: 600;\n}\n.gx-font-weight-bold {\n  font-weight: 700;\n}\n.gx-font-weight-heavy {\n  font-weight: 900;\n}\n.gx-font-italic {\n  font-style: italic;\n}\n.gx-letter-spacing-base {\n  letter-spacing: 3px;\n}\n.gx-letter-spacing-lg {\n  letter-spacing: 6px;\n}\n.gx-letter-spacing-xl {\n  letter-spacing: 8px;\n}\n.gx-text-justify {\n  text-align: justify !important;\n}\n.gx-text-nowrap {\n  white-space: nowrap !important;\n}\n.gx-text-left {\n  text-align: left !important;\n}\n.gx-text-right {\n  text-align: right !important;\n}\n.gx-text-center {\n  text-align: center !important;\n}\n.gx-text-truncate {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* Ant Layout Style */\n.ant-layout {\n  position: relative;\n  background: none;\n}\n.ant-layout > .gx-layout-content {\n  overflow-x: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.full-scroll .ant-layout > .gx-layout-content {\n  overflow-x: inherit;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout {\n  position: relative;\n  background: #f5f5f5;\n}\n.framed-layout .ant-layout,\n.boxed-layout .ant-layout {\n  background: #f5f5f5;\n}\n.framed-layout .ant-layout,\n.boxed-layout .ant-layout {\n  background: #f5f5f5;\n}\n.ant-layout.gx-app-layout {\n  height: 100vh;\n}\n.framed-layout .ant-layout.gx-app-layout {\n  height: calc(100vh - 40px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-layout.gx-app-layout {\n    height: 100vh;\n  }\n}\n.framed-layout.full-scroll .ant-layout.gx-app-layout,\n.boxed-layout.full-scroll .ant-layout.gx-app-layout {\n  overflow-y: scroll;\n}\n.ant-layout.gx-app-layout > .ant-layout {\n  height: 100vh;\n}\n.framed-layout .ant-layout.gx-app-layout > .ant-layout {\n  height: calc(100vh - 40px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-layout.gx-app-layout > .ant-layout {\n    height: 100vh;\n  }\n}\n.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout,\n.full-scroll .ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: inherit;\n}\n.gx-main-content-wrapper {\n  flex: 1;\n}\n.gx-container-wrap .gx-main-content-wrapper {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container-wrap .gx-main-content-wrapper {\n    width: 1400px;\n  }\n}\n.gx-main-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  flex: 1;\n  height: 100%;\n}\n.gx-container {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container {\n    width: 1400px;\n  }\n}\n/* Header Style */\n.ant-layout-header {\n  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  line-height: 1;\n  padding: 0 32px;\n  height: 72px;\n  position: relative;\n  z-index: 10;\n  color: #262626;\n}\n.ant-layout-header .gx-loader-view {\n  position: absolute;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.4);\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: 0;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-header {\n    padding: 0 15px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-layout-header {\n    height: 50px;\n  }\n}\n.gx-nav-header {\n  padding: 0 32px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  background-color: #fefefe;\n}\n.gx-nav-header .ant-menu-horizontal {\n  margin-bottom: -1px;\n  border-bottom-color: transparent;\n}\n.gx-nav-header-below {\n  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  -moz-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.28);\n  position: relative;\n  z-index: 999;\n}\n.ant-dropdown-menu-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-linebar {\n  font-size: 20px;\n}\n.gx-header-horizontal-dark .gx-linebar {\n  color: #ffffff;\n}\n.gx-header-notifications {\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n  width: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-header-notifications > li {\n  font-size: 18px;\n}\n.gx-header-notifications > li h1 {\n  margin-bottom: 0px;\n}\n.gx-header-notifications > li.gx-language {\n  font-size: 14px;\n}\n@media screen and (max-width: 575px) {\n  .gx-header-notifications > li.gx-language .gx-language-name,\n  .gx-header-notifications > li.gx-language .icon {\n    display: none;\n  }\n  .gx-header-notifications > li.gx-language .flag.flag-24 {\n    width: 20px;\n    height: 20px;\n    margin-top: -4px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-notifications > li.gx-notify,\n  .gx-header-notifications > li.gx-msg {\n    margin-top: 2px;\n  }\n  .gx-header-notifications > li.gx-language {\n    margin-bottom: 2px;\n  }\n}\n.gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n  margin-left: 50px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-left: 0;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .gx-header-horizontal-main .gx-header-notifications > li.gx-user-nav {\n    margin-left: 0;\n  }\n}\n.dark-theme .gx-header-notifications > li h1 {\n  color: #E9F6FF;\n}\n.dark-theme .gx-header-notifications .ant-btn-link {\n  line-height: 1;\n}\n.gx-header-horizontal-main .gx-header-notifications li > span {\n  color: #545454;\n}\n.gx-header-horizontal-dark .gx-header-horizontal-main .gx-header-notifications li > span {\n  color: #089265;\n}\n.gx-popover-scroll {\n  height: 280px !important;\n  width: 300px !important;\n  margin: 0 -16px;\n  overflow-y: auto;\n}\n@media screen and (max-width: 575px) {\n  .gx-popover-scroll {\n    height: 280px !important;\n    width: 200px !important;\n  }\n}\n.gx-popover-lang-scroll {\n  height: 220px !important;\n  width: 160px !important;\n  margin: 0 -16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 10px;\n}\n.gx-popover-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  border-bottom: solid 1px #e8e8e8;\n  margin: 0 -16px;\n  padding: 0 16px 12px;\n}\n.gx-sub-popover {\n  list-style: none;\n  margin: 0 16px;\n  padding-left: 0;\n}\n.gx-sub-popover li {\n  padding: 20px 0 14px;\n}\n.gx-popover-lang-scroll .gx-sub-popover li {\n  padding: 5px 0;\n}\n.gx-sub-popover li:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-user-popover {\n  margin: -12px -16px;\n  padding: 7px 0;\n  list-style: none;\n}\n.gx-user-popover li {\n  cursor: pointer;\n  padding: 3px 15px;\n  width: 150px;\n}\n.gx-user-popover li:hover,\n.gx-user-popover li:focus {\n  background-color: #fafafa;\n}\n@media screen and (max-width: 575px) {\n  .gx-user-popover li {\n    width: 100%;\n  }\n}\n.gx-header-horizontal {\n  position: relative;\n  color: #089265;\n  background-color: #ffffff;\n}\n.gx-header-horizontal-dark {\n  position: relative;\n  background-color: #003366;\n  color: #089265;\n}\n.gx-header-horizontal-dark:before {\n  content: '';\n  position: absolute;\n  right: 169px;\n  top: -212px;\n  background-color: rgba(255, 255, 255, 0.2);\n  width: 280px;\n  height: 350px;\n  -webkit-border-radius: 0 0 135px 135px;\n  -moz-border-radius: 0 0 135px 135px;\n  border-radius: 0 0 135px 135px;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n  z-index: 1;\n}\n@media screen and (max-width: 1049px) {\n  .gx-header-horizontal-dark:before {\n    right: 110px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-header-horizontal-dark:before {\n    top: -184px;\n    right: 80px;\n    height: 300px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-dark:before {\n    top: -154px;\n    right: 140px;\n    height: 240px;\n    width: 200px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-horizontal-dark:before {\n    right: 60px;\n    display: none;\n  }\n}\n.gx-header-horizontal-dark > div {\n  position: relative;\n  z-index: 2;\n}\n.gx-header-horizontal-top {\n  padding: 12px 0;\n  font-size: 14px;\n}\n.gx-header-horizontal-top-flex,\n.gx-header-horizontal-nav-flex,\n.gx-header-horizontal-main-flex {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-header-horizontal-top-left {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-right: 15px;\n}\n@media screen and (max-width: 767px) {\n  .gx-header-horizontal-top-left {\n    margin-right: 0;\n    width: 100%;\n  }\n}\n.gx-header-horizontal-main {\n  display: -webkit-block;\n  display: -ms-blockbox;\n  display: -ms-block;\n  display: block;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  padding: 25px 0 35px;\n  height: auto;\n  background-color: transparent;\n}\n@media screen and (max-width: 1199px) {\n  .gx-header-horizontal-main {\n    padding: 20px 0;\n  }\n  .gx-header-horizontal-main .gx-w-logo {\n    padding: 7px 5px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-header-horizontal-main .gx-w-logo {\n    padding-right: 0;\n  }\n}\n.gx-inside-header-horizontal .gx-header-horizontal-main {\n  padding: 0;\n}\n.gx-header-horizontal-nav {\n  background-color: #003366;\n  color: #fffffd;\n}\n.gx-header-horizontal-dark .gx-header-horizontal-nav {\n  background-color: transparent;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav,\n.gx-above-header-horizontal .gx-header-horizontal-nav {\n  background-color: #fefefe;\n  color: #7a7a7a;\n}\n.gx-inside-header-horizontal .gx-logo {\n  margin-right: 25px;\n}\n.gx-inside-header-horizontal:before {\n  top: -230px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal:before {\n    top: -190px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-inside-header-horizontal:before {\n    top: -154px;\n  }\n}\n.gx-above-header-horizontal:before {\n  top: -165px;\n}\n@media screen and (max-width: 991px) {\n  .gx-above-header-horizontal:before {\n    top: -154px;\n  }\n}\n.gx-login-list {\n  list-style: none;\n  margin-left: auto;\n  margin-bottom: 0;\n}\n.gx-login-list li {\n  padding: 0 10px;\n  text-transform: uppercase;\n  color: #089265;\n  font-size: 12px;\n  line-height: 12px;\n  display: inline-block;\n  cursor: pointer;\n}\n.gx-login-list li:not(:first-child) {\n  border-left: solid 1px #e8e8e8;\n}\n.gx-header-horizontal-dark .gx-login-list li:not(:first-child) {\n  border: 0 none;\n}\n@media screen and (max-width: 767px) {\n  .gx-login-list {\n    display: none;\n  }\n}\n.gx-header-search {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-left: 28px;\n}\n.gx-header-search .ant-select-selection {\n  -webkit-border-radius: 0 4px 4px 0;\n  -moz-border-radius: 0 4px 4px 0;\n  border-radius: 0 4px 4px 0;\n  background-color: #003366;\n  border-color: #003366;\n  color: #fffffd;\n  margin-bottom: 0;\n}\n.gx-header-search .ant-select-selection:focus {\n  background-color: #003366;\n  border-color: #003366;\n  color: #fffffd;\n}\n.gx-header-horizontal-dark .gx-header-search .ant-select-selection {\n  color: #fffffd;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.2);\n  margin-left: 1px;\n}\n.gx-header-horizontal-dark .gx-header-search .ant-select-selection:focus {\n  color: #fffffd;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.gx-header-search .ant-select-arrow {\n  color: #fffffd;\n}\n.gx-popover-horizantal .ant-btn {\n  margin: 0 !important;\n  border: 0 none;\n  border-right: solid 1px #e8e8e8;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  height: 24px;\n  line-height: 24px;\n}\n.gx-popover-horizantal .gx-popover-search-bar {\n  margin: 0;\n}\n.gx-popover-horizantal .gx-popover-search-bar .ant-input {\n  height: 24px;\n  line-height: 24px;\n}\n@media screen and (max-width: 575px) {\n  .gx-popover-horizantal {\n    left: 0 !important;\n    padding-top: 0;\n    margin-top: -9px;\n  }\n  .gx-popover-horizantal .ant-popover-inner-content {\n    width: 100vw;\n  }\n  .gx-popover-horizantal .ant-popover-arrow {\n    display: none;\n  }\n  .gx-popover-horizantal .gx-popover-search-bar {\n    width: 100%;\n  }\n  .gx-popover-horizantal .gx-popover-scroll,\n  .gx-popover-horizantal .gx-popover-lang-scroll {\n    width: 100% !important;\n    margin: 0;\n  }\n  .gx-popover-horizantal .gx-sub-popover {\n    margin: 0;\n    padding-left: 5px;\n  }\n}\n.gx-no-header-horizontal {\n  padding: 14px 32px 13px 79px;\n  text-align: center;\n  position: relative;\n}\n.gx-no-header-horizontal-top {\n  padding: 10px 20px;\n  background-color: #d9f7be;\n  color: #237804;\n  border-radius: 4px;\n  display: inline-block;\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal-top {\n    width: 100%;\n    font-size: 12px;\n  }\n}\n.gx-no-header-horizontal-top-center {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-no-header-horizontal .gx-linebar {\n  position: absolute;\n  left: 32px;\n  top: 15px;\n  z-index: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal .gx-linebar {\n    left: 15px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-no-header-horizontal {\n    padding: 14px 15px 13px 60px;\n  }\n}\n.notifications-popover .gx-popover-scroll {\n  padding: 0 10px;\n}\n.dark-theme .notifications-popover .gx-popover-header,\n.dark-theme .notifications-popover .ant-list-items li.ant-list-item {\n  border-bottom-color: #0a2238;\n}\n/* Sidebar Style */\n.gx-app-sidebar {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  -ms-transition: all 0.2s ease;\n  -o-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.ant-layout-sider {\n  background-color: #fffffc;\n  color: #545454;\n  flex: 0 0 auto !important;\n  max-width: none !important;\n  min-width: 10px !important;\n  width: 280px !important;\n  overflow: hidden;\n}\n@media screen and (max-width: 1366px) {\n  .ant-layout-sider {\n    width: 240px !important;\n  }\n}\n.ant-layout-sider-collapsed {\n  width: 80px !important;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-sider-collapsed.gx-mini-custom-sidebar {\n    width: 0 !important;\n    min-width: 0 !important;\n  }\n}\n.ant-layout-sider.gx-collapsed-sidebar {\n  width: 0 !important;\n  min-width: 0 !important;\n}\n@media screen and (max-width: 991px) {\n  .ant-layout-sider {\n    width: 0 !important;\n    min-width: 0 !important;\n  }\n}\n.gx-layout-sider-dark {\n  background-color: #003366;\n  color: #038fdd;\n}\n.gx-layout-sider-header {\n  padding: 15px 20px;\n  -webkit-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.08);\n  position: relative;\n  z-index: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-layout-sider-header {\n    height: 50px;\n  }\n}\n.gx-layout-sider-header .gx-linebar {\n  position: absolute;\n  left: 20px;\n  z-index: 1;\n  top: 15px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n.ant-layout-sider-collapsed .gx-layout-sider-header .gx-linebar {\n  left: 20px;\n}\n@media screen and (max-width: 991px) {\n  .gx-layout-sider-header .gx-linebar {\n    display: none;\n  }\n}\n.ant-layout-sider-collapsed .gx-layout-sider-header {\n  padding: 15px;\n  display: flex;\n  justify-content: center;\n}\n.gx-drawer-sidebar .gx-layout-sider-header {\n  padding-left: 30px;\n}\n.gx-drawer-sidebar-dark .gx-layout-sider-header {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.gx-layout-sider-dark .gx-layout-sider-header {\n  background-color: rgba(0, 0, 0, 0.3);\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.gx-mini-custom-sidebar .gx-layout-sider-header {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  background-color: transparent;\n}\n.gx-custom-sidebar .gx-layout-sider-header {\n  padding-left: 30px;\n  background-color: transparent;\n}\n.gx-mini-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header,\n.gx-custom-sidebar.ant-layout-sider-lite .gx-layout-sider-header {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  border-right: 1px solid #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-layout-sider-header {\n    padding-left: 30px;\n  }\n}\n.gx-layout-sider-header,\n.gx-layout-sider-dark .gx-layout-sider-header {\n  background-color: transparent;\n  box-shadow: none;\n}\n.gx-app-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #04A0A1;\n}\n.gx-sidebar-content {\n  position: relative;\n  border-right: 1px solid #e8e8e8;\n}\n.gx-layout-sider-dark .gx-sidebar-content,\n.gx-drawer-sidebar-dark .gx-sidebar-content {\n  border-right: 0 none;\n}\n.gx-sidebar-content .ant-menu .ant-menu-item,\n.gx-sidebar-content .ant-menu .ant-menu-item a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n@media screen and (min-width: 1600px) {\n  .gx-sidebar-content .ant-menu .ant-menu-item,\n  .gx-sidebar-content .ant-menu .ant-menu-item a {\n    font-size: 16px;\n  }\n}\n.gx-sidebar-content .ant-menu .ant-menu-item-selected a,\n.gx-sidebar-content .ant-menu .ant-menu-item a-selected a {\n  color: #ffffff;\n}\n.gx-sidebar-content .ant-menu .ant-menu-item-selected a svg path,\n.gx-sidebar-content .ant-menu .ant-menu-item a-selected a svg path {\n  fill: #ffffff;\n}\n.gx-sidebar-content .ant-menu-item .anticon-rocket {\n  font-size: 18px;\n}\n.gx-sidebar-notifications {\n  padding: 30px 10px 10px;\n  margin: 0 20px 10px;\n  border-bottom: solid 1px #e8e8e8;\n}\n.ant-layout-sider-dark .gx-sidebar-notifications,\n.gx-drawer-sidebar-dark .gx-sidebar-notifications {\n  border-bottom-color: #038fdd;\n}\n@media screen and (max-width: 991px) {\n  .gx-sidebar-notifications {\n    display: none;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-sidebar-notifications.gx-no-header-notifications {\n    display: block;\n  }\n}\n.gx-app-nav {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin: 0 -20px;\n  color: #2EB1EF;\n}\n.ant-layout-sider-dark .gx-app-nav,\n.gx-drawer-sidebar-dark .gx-app-nav {\n  color: #038fdd;\n}\n.gx-app-nav li {\n  padding: 0 20px;\n  font-size: 20px;\n}\n.gx-app-nav li .icon {\n  cursor: pointer;\n}\n.ant-layout-sider-collapsed .gx-app-nav {\n  display: none;\n}\n.gx-mini-custom-sidebar .gx-app-nav {\n  display: block;\n  margin-top: 15px;\n}\n.gx-mini-custom-sidebar .gx-app-nav li:not(:last-child) {\n  margin-bottom: 5px;\n}\n.gx-avatar-name {\n  cursor: pointer;\n}\n.ant-layout-sider-collapsed .gx-avatar-name {\n  display: none;\n}\n.ant-layout-sider-collapsed .gx-avatar-row {\n  margin-bottom: 0 !important;\n}\n.gx-avatar-row .ant-avatar {\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  position: relative;\n  left: 0;\n}\n.ant-layout-sider-collapsed .gx-avatar-row .ant-avatar {\n  margin: 0 !important;\n  left: -10px;\n}\n.gx-app-sidebar.ant-layout-sider .ant-menu-item-group-title {\n  padding: 10px 20px;\n  font-size: 16px;\n}\n.gx-app-sidebar.ant-layout-sider .ant-menu-inline .ant-menu-item {\n  padding-left: 30px !important;\n}\n.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item {\n  padding: 0 30px !important;\n}\n.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item.logout-item {\n  padding: 0px 26px 0px 32px !important;\n}\n.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item.logout-item svg {\n  margin-left: 3px;\n}\n.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item > span,\n.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item a > span {\n  display: none;\n}\n.gx-layouts-view .gx-pointer {\n  display: block;\n  margin-bottom: 15px;\n}\n.gx-layouts-view .gx-pointer img {\n  width: 100%;\n}\n.gx-layouts-view .gx-pointer.active {\n  box-shadow: 0 0 10px 0 #2EB1EF;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  border-radius: 8px;\n}\n/* Ant Menu Style */\n.ant-menu {\n  color: #545454;\n  background: #fff;\n}\n.ant-menu-horizontal {\n  background: none;\n}\n.ant-menu-item-group-title {\n  color: #fff;\n  font-size: 11px;\n  line-height: 1.3;\n  padding: 10px 30px;\n}\n.ant-menu-submenu-popup .ant-menu-item-group-title {\n  padding-left: 20px;\n}\n.ant-layout-sider .ant-menu-item-group-title {\n  padding-top: 40px;\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #f0fdff;\n}\n.ant-menu-item .icon {\n  min-width: 14px;\n  margin-right: 2px;\n}\n.ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-item .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-menu-sub .ant-menu-item .icon {\n  font-size: 12px;\n}\n.ant-menu-item > a {\n  color: #545454;\n}\n.ant-menu-item > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu-item-divider {\n  background-color: #e8e8e8;\n}\n.ant-menu-submenu-inline {\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n.ant-menu-item:hover,\n.ant-menu-item-active,\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-submenu-active,\n.ant-menu-submenu-title:hover {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: #2EB1EF;\n}\n.ant-menu-item-selected > a {\n  color: #545454;\n}\n.ant-menu-item-selected > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #f0fdff;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: 1px solid #e8e8e8;\n}\n.ant-layout-sider .ant-menu-inline,\n.ant-layout-sider .ant-menu-vertical,\n.ant-layout-sider .ant-menu-vertical-left,\n.gx-drawer-sidebar .ant-menu-inline,\n.gx-drawer-sidebar .ant-menu-vertical,\n.gx-drawer-sidebar .ant-menu-vertical-left {\n  border-right: 0 none;\n}\n.ant-menu-vertical-right {\n  border-left: 1px solid #e8e8e8;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  padding: 0 20px;\n}\n.gx-inside-header-horizontal .ant-menu-item,\n.gx-inside-header-horizontal .ant-menu-submenu-title {\n  padding: 0 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .ant-menu-item,\n  .gx-inside-header-horizontal .ant-menu-submenu-title {\n    padding: 0 6px;\n  }\n}\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  margin-right: 02px;\n}\n.ant-menu > .ant-menu-item-divider {\n  background-color: #e8e8e8;\n}\n.ant-menu-sub > li > a {\n  position: relative;\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: #fff;\n  border-radius: 0;\n}\n.ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 54px !important;\n}\n.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,\n.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {\n  padding-left: 80px !important;\n}\n.ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item,\n.ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-sub .ant-menu-item {\n  padding-left: 106px !important;\n}\n.ant-menu-submenu-popup {\n  border-radius: 0;\n  z-index: 1050 !important;\n}\n.ant-menu-submenu-popup .ant-menu-sub.ant-menu .ant-menu-item {\n  padding-left: 20px !important;\n}\n.ant-menu-submenu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-submenu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-submenu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-submenu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 0;\n}\n.gx-app-sidebar .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 22px;\n  right: auto;\n}\n.ant-drawer .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 22px;\n  right: auto;\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {\n  background-image: linear-gradient(to right, #545454, #545454);\n}\n.gx-app-sidebar .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.gx-app-sidebar .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-left .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-vertical-right .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-drawer .ant-menu-submenu-inline .ant-menu-submenu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  left: 60px;\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before,\n.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {\n  background: linear-gradient(to right, #2EB1EF, #2EB1EF);\n}\n.ant-menu-vertical .ant-menu-submenu-selected,\n.ant-menu-vertical-left .ant-menu-submenu-selected,\n.ant-menu-vertical-right .ant-menu-submenu-selected {\n  color: #2EB1EF;\n}\n.ant-menu-vertical .ant-menu-submenu-selected > a,\n.ant-menu-vertical-left .ant-menu-submenu-selected > a,\n.ant-menu-vertical-right .ant-menu-submenu-selected > a {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal {\n  border-bottom: 1px solid #e8e8e8;\n  line-height: 46px;\n  padding: 0;\n}\n.ant-layout-header .ant-menu-horizontal {\n  border-bottom: 0 none;\n  line-height: 70px;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  border-bottom: 2px solid transparent;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom: 2px solid #2EB1EF;\n  color: #2EB1EF;\n}\n.ant-menu-horizontal > .ant-menu-item > a,\n.ant-menu-horizontal > .ant-menu-submenu > a {\n  color: #545454;\n}\n.ant-menu-horizontal > .ant-menu-item > a:hover,\n.ant-menu-horizontal > .ant-menu-submenu > a:hover {\n  color: #2EB1EF;\n}\n.ant-menu-horizontal > .ant-menu-item > a:before,\n.ant-menu-horizontal > .ant-menu-submenu > a:before {\n  bottom: -2px;\n}\n.ant-menu-vertical .ant-menu-item:not(:last-child),\n.ant-menu-vertical-left .ant-menu-item:not(:last-child),\n.ant-menu-vertical-right .ant-menu-item:not(:last-child),\n.ant-menu-inline .ant-menu-item:not(:last-child) {\n  margin-bottom: 0;\n}\n.ant-menu-vertical .ant-menu-item:after,\n.ant-menu-vertical-left .ant-menu-item:after,\n.ant-menu-vertical-right .ant-menu-item:after,\n.ant-menu-inline .ant-menu-item:after {\n  border-right: 3px solid #2EB1EF;\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 30px 0 20px !important;\n  font-size: 14px;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-overflow: inherit;\n}\n.ant-layout-sider .ant-menu-vertical .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical-left .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical-right .ant-menu-item,\n.ant-layout-sider .ant-menu-inline .ant-menu-item,\n.ant-layout-sider .ant-menu-vertical .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical .ant-menu-item,\n.ant-drawer .ant-menu-vertical-left .ant-menu-item,\n.ant-drawer .ant-menu-vertical-right .ant-menu-item,\n.ant-drawer .ant-menu-inline .ant-menu-item,\n.ant-drawer .ant-menu-vertical .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-drawer .ant-menu-inline .ant-menu-submenu-title {\n  padding-left: 40px !important;\n}\n.ant-menu-vertical .ant-menu-item .icon,\n.ant-menu-vertical-left .ant-menu-item .icon,\n.ant-menu-vertical-right .ant-menu-item .icon,\n.ant-menu-inline .ant-menu-item .icon,\n.ant-menu-vertical .ant-menu-submenu-title .icon,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon,\n.ant-menu-inline .ant-menu-submenu-title .icon {\n  min-width: 14px;\n  margin-right: 02px;\n}\n.ant-menu-vertical .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-inline .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-inline .ant-menu-submenu-title .icon[class^=\"icon-\"]::before,\n.ant-menu-vertical .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-inline .ant-menu-item .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-left .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-vertical-right .ant-menu-submenu-title .icon[class*=\" icon-\"]::before,\n.ant-menu-inline .ant-menu-submenu-title .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .icon + span,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .icon + span {\n  max-width: 0;\n  display: inline-block;\n  opacity: 0;\n}\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-item .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-left .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-vertical-right .ant-menu-submenu-title .ant-menu-submenu-arrow,\n.ant-layout-sider-collapsed .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-card .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-card .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 54px !important;\n}\n.ant-layout-sider .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-layout-sider .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-left.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-vertical-right.ant-menu-sub .ant-menu-submenu-title,\n.ant-drawer .ant-menu-inline.ant-menu-sub .ant-menu-submenu-title {\n  padding-left: 80px !important;\n}\n.ant-menu-inline .ant-menu-submenu-title {\n  padding-right: 30px !important;\n}\n.ant-menu-inline-collapsed {\n  width: 80px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  padding: 0 32px !important;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none;\n}\n.ant-menu-inline-collapsed > .ant-menu-item .icon + span,\n.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .icon + span,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .icon + span {\n  max-width: 0;\n  display: inline-block;\n  opacity: 0;\n}\n.ant-menu-inline-collapsed-tooltip .icon {\n  display: none;\n}\n.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  padding-left: 4px;\n  padding-right: 4px;\n  display: none;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  line-height: 42px;\n  height: 42px;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding: 0 30px 0 80px;\n  line-height: 42px;\n  height: 42px;\n  text-transform: uppercase;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-item-disabled > a,\n.ant-menu-submenu-disabled > a {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #2EB1EF;\n}\n.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: linear-gradient(to right, #2EB1EF, #2EB1EF);\n}\n.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  color: #038fdd;\n  background: #003366;\n}\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: #038fdd;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: none;\n  box-shadow: none;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom-color: #003366;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  border-color: #003366;\n}\n.ant-menu-dark .ant-menu-item .icon {\n  min-width: 14px;\n  margin-right: 2px;\n}\n.ant-menu-dark .ant-menu-item .icon[class^=\"icon-\"]::before,\n.ant-menu-dark .ant-menu-item .icon[class*=\" icon-\"]::before {\n  position: relative;\n  top: 2px;\n}\n.ant-menu-dark .ant-menu-item-group-title {\n  color: #038fdd;\n}\n.ant-menu-dark .ant-menu-item {\n  color: #038fdd;\n}\n.ant-menu-dark .ant-menu-item > a {\n  color: #038fdd;\n}\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-item-selected > a {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu-title:hover,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > a {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before,\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow:before {\n  background: #089265;\n}\n.ant-menu-dark .ant-menu-submenu-open {\n  color: #ffffff;\n}\n.ant-menu-dark.ant-menu-inline-collapsed .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open .ant-menu-submenu-title span,\n.ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-active .ant-menu-submenu-title span {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  color: #089265;\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover {\n  color: #089265;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: transparent;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {\n  color: #038fdd;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title:hover,\n.ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-selected .ant-menu-submenu-title:hover {\n  color: #089265;\n}\n.ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #262626;\n}\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:after,\n.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-vertical:hover > .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-layout-sider .ant-menu .ant-menu-item .icon,\n.ant-drawer .ant-menu .ant-menu-item .icon {\n  font-size: 20px;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title .icon,\n.ant-layout-sider .ant-menu .ant-menu-submenu .ant-menu-item .icon,\n.ant-drawer .ant-menu .ant-menu-submenu .ant-menu-item .icon {\n  font-size: 14px;\n  margin-right: 12px;\n}\n.ant-layout-sider .ant-menu .ant-menu-submenu-title span,\n.ant-drawer .ant-menu .ant-menu-submenu-title span {\n  display: flex;\n}\n.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  background-image: linear-gradient(to right, #2EB1EF, #2EB1EF);\n}\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::after,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before,\n.ant-menu-submenu-popup.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-open .ant-menu-item > a:hover > .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {\n  background: #ffffff;\n}\n.gx-navbar-nav {\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-navbar-nav li {\n  padding: 0 5px;\n}\n.gx-navbar-nav li a {\n  display: block;\n  padding: 4px 10px;\n  background-color: #2EB1EF;\n  color: #ffffff;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-profile-banner .gx-navbar-nav li a {\n  background-color: transparent;\n  color: #ffffff;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.gx-navbar-nav li a * {\n  color: #bfbfbf;\n}\n.gx-navbar-nav li a:hover,\n.gx-navbar-nav li a:focus {\n  background-color: #1199d9;\n  color: #ffffff;\n}\n.gx-profile-banner .gx-navbar-nav li a:hover,\n.gx-profile-banner .gx-navbar-nav li a:focus {\n  background-color: transparent;\n  color: #089265;\n}\n.gx-profile-banner .gx-navbar-nav li {\n  padding: 0 15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner .gx-navbar-nav li {\n    padding: 0 6px;\n  }\n}\n.gx-profile-banner .gx-navbar-nav {\n  margin: 0 -15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner .gx-navbar-nav {\n    -webkit-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    margin: 0 -6px;\n  }\n}\n.gx-header-horizontal-nav .ant-menu-horizontal {\n  border-bottom: 0 none;\n}\n.gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #ffffff;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title,\n.gx-above-header-horizontal .gx-header-horizontal-nav .ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #7a7a7a;\n}\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom-color: #089265;\n  color: #089265;\n}\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,\n.gx-header-horizontal-nav .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  color: #089265;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu {\n  border-bottom: 0 none;\n  margin-top: 0;\n  top: 0;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected {\n  position: relative;\n  border-bottom: 0 none;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  position: relative;\n}\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  content: \"\\e049\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  text-align: center;\n  font-family: \"gaxon\" !important;\n  font-size: 31px;\n  line-height: 5px;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  color: #f5f5f5;\n}\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  color: #003366;\n}\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: #089265;\n}\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: #ffffff;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  margin-top: -7px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:first-child {\n  -webkit-border-radius: 10px 10px 0 0;\n  -moz-border-radius: 10px 10px 0 0;\n  border-radius: 10px 10px 0 0;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.ant-menu-submenu > .ant-menu .ant-menu-item:last-child {\n  -webkit-border-radius: 0 0 10px 10px;\n  -moz-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu > .ant-menu {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #089265;\n  color: #003366;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {\n  color: #003366;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #089265;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background-image: linear-gradient(to right, #089265, #089265);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\n  background-image: linear-gradient(to right, #089265, #089265);\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item > a:hover,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item:hover,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-item-active,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-active,\n.gx-submenu-popup-curve.ant-menu-submenu-popup .ant-menu-submenu-title:hover {\n  color: #089265;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: transparent;\n  color: #089265;\n}\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-inside-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-below-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a,\n.gx-submenu-popup-curve.ant-menu-submenu-popup.gx-above-submenu-popup-curve .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a {\n  color: #089265;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed {\n  padding-bottom: 10px;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  padding: 0 20px !important;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > span,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > span,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > span {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item > a,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item > a {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item.ant-menu-item-selected > a,\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item.ant-menu-item-selected > a {\n  color: #003366;\n  background-color: #089265;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n.gx-mini-custom-sidebar .ant-menu-inline-collapsed > .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title > span {\n  color: #003366;\n  background-color: #089265;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-item .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-left .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-vertical-right .ant-menu-submenu-title .icon,\n.gx-mini-custom-sidebar .ant-menu-inline .ant-menu-submenu-title .icon {\n  margin-right: 0;\n}\n.gx-no-header-submenu-popup .ant-menu-sub {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n/* Footer Style */\n.ant-layout-footer {\n  border-top: solid 1px #e8e8e8;\n  background-color: transparent;\n}\n@media screen and (max-width: 575px) {\n  .ant-layout-footer {\n    padding: 14px 15px;\n  }\n}\n.gx-container-wrap .ant-layout-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.gx-container-wrap .gx-layout-footer-content {\n  width: 94vw;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n@media screen and (min-width: 768px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 720px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 920px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1100px;\n  }\n}\n@media screen and (min-width: 1367px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1200px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .gx-container-wrap .gx-layout-footer-content {\n    width: 1400px;\n  }\n}\n/* Customizer Style */\n.gx-customizer {\n  height: calc(100vh - 30px) !important;\n}\n.gx-customizer-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n}\n.gx-customizer-item .ant-radio-group .ant-radio-button {\n  display: none;\n}\n.gx-customizer-option {\n  position: absolute;\n  right: 0;\n  top: 150px;\n  z-index: 99;\n}\n.full-scroll .gx-customizer-option {\n  position: fixed;\n}\n.full-scroll.boxed-layout .gx-customizer-option {\n  position: absolute;\n}\n.full-scroll.framed-layout .gx-customizer-option {\n  right: 20px;\n}\n@media screen and (max-width: 991px) {\n  .full-scroll.framed-layout .gx-customizer-option {\n    right: 0;\n  }\n}\n.horizontal-layout.full-scroll .gx-customizer-option {\n  top: 200px;\n}\n@media screen and (max-width: 575px) {\n  .gx-customizer {\n    width: 250px !important;\n  }\n  .gx-customizer .ant-radio-button-wrapper {\n    padding: 0 10px;\n  }\n}\n.gx-customizer .gx-list-inline {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.framed-layout .gx-customizer {\n  height: calc(100vh - 70px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-customizer {\n    height: calc(100vh - 30px) !important;\n  }\n}\n.gx-color-option {\n  margin-bottom: 0;\n  padding-left: 0;\n}\n.gx-color-option li {\n  font-size: 36px;\n  line-height: 1;\n}\n.gx-color-option li .gx-link {\n  width: 40px;\n  height: 40px;\n  display: block;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.gx-color-option li .gx-link:before {\n  font-family: \"gaxon\";\n  font-size: 20px;\n  content: \"\\30\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  display: none;\n}\n.gx-color-option li .gx-link.active:before {\n  display: block;\n}\n.gx-color-option li .gx-link:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 20px;\n  height: 40px;\n  background-color: #9283D4;\n}\n.gx-color-option li .gx-link.gx-color-red:after {\n  background-color: #FF2B7A;\n}\n.gx-color-option li .gx-link.gx-color-blue:after {\n  background-color: #3DA4E6;\n}\n.gx-color-option li .gx-link.gx-color-dark-blue:after {\n  background-color: #0469B9;\n}\n.gx-color-option li .gx-link.gx-color-orange:after {\n  background-color: #F18805;\n}\n.gx-color-option li .gx-link.gx-color-light-blue:after {\n  background-color: #6A95FF;\n}\n.gx-color-option li .gx-link.gx-color-deep-orange:after {\n  background-color: #F87060;\n}\n.gx-color-option li .gx-link.gx-color-light-purple1:after {\n  background-color: #A172E7;\n}\n.gx-color-option li .gx-link.gx-color-light-purple2:after {\n  background-color: #956FE7;\n}\n.gx-cus-customiz {\n  padding-right: 20px;\n}\n.gx-layout-option li,\n.gx-nav-option li {\n  margin-bottom: 10px;\n}\n.gx-layout-option li span,\n.gx-nav-option li span {\n  position: relative;\n  display: block;\n}\n.gx-layout-option li span:before,\n.gx-nav-option li span:before {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  font-family: \"gaxon\" !important;\n  content: \"\\30\";\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  display: none;\n  width: 20px;\n  font-size: 12px;\n  height: 20px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  background-color: #2EB1EF;\n  text-align: center;\n  padding: 2px;\n  color: #ffffff;\n}\n.gx-layout-option li span.active:before,\n.gx-nav-option li span.active:before {\n  display: block;\n}\n/* Drawer Style */\n.ant-drawer {\n  overflow: hidden;\n}\n.ant-drawer-body {\n  padding: 0;\n}\n.gx-drawer-sidebar-dark .ant-drawer-content {\n  background-color: #003366;\n  color: #038fdd;\n}\n.framed-layout .ant-drawer-content-wrapper {\n  top: 20px;\n  bottom: 20px;\n  height: calc(100vh - 40px);\n  -webkit-border-radius: 11px 0 0 11px;\n  -moz-border-radius: 11px 0 0 11px;\n  border-radius: 11px 0 0 11px;\n  overflow: hidden;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-content-wrapper {\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.ant-drawer-right .ant-drawer-content-wrapper {\n  padding: 20px;\n}\n@media screen and (max-width: 991px) {\n  .ant-drawer-right .ant-drawer-content-wrapper {\n    width: 300px !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-drawer-right .ant-drawer-content-wrapper {\n    width: 280px !important;\n  }\n}\n.framed-layout .ant-drawer-right .ant-drawer-content-wrapper {\n  top: 20px;\n  bottom: 20px;\n  height: calc(100vh - 40px);\n  -webkit-border-radius: 0 11px 11px 0;\n  -moz-border-radius: 0 11px 11px 0;\n  border-radius: 0 11px 11px 0;\n  overflow: hidden;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-right .ant-drawer-content-wrapper {\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    -webkit-border-radius: 0 !important;\n    -moz-border-radius: 0 !important;\n    border-radius: 0 !important;\n  }\n}\n.framed-layout .ant-drawer-content-wrapper,\n.boxed-layout .ant-drawer-content-wrapper {\n  position: absolute;\n}\n.boxed-layout .ant-drawer {\n  max-width: 1280px;\n  margin: 0 auto;\n}\n@media screen and (min-width: 1600px) {\n  .boxed-layout .ant-drawer {\n    max-width: 1500px;\n  }\n}\n.framed-layout .ant-drawer-open {\n  width: calc(100% - 40px);\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .ant-drawer-open {\n    width: 100%;\n  }\n}\n.ant-drawer-close {\n  top: -11px;\n}\n.ant-drawer-close-x {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n}\n.ant-drawer-mask {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n/*Alert Styles*/\n.gx-custom-sweet-alert h2 {\n  color: #ffffff;\n}\n.notification {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.notification .title {\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n}\n.gx-sweet-alert-top-space {\n  padding-top: 40px !important;\n}\n/*Avatar Styles*/\n.gx-avatar-img {\n  height: 50px;\n  width: 50px;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  border: solid 1px #e8e8e8;\n}\n.gx-avatar-img-lg {\n  height: 100px;\n  width: 100px;\n}\n.ant-avatar {\n  position: relative;\n}\n.ant-avatar.gx-size-150 > * {\n  line-height: 150px;\n}\n.ant-avatar.gx-size-120 > * {\n  line-height: 120px;\n}\n.ant-avatar.gx-size-100 > * {\n  line-height: 100px;\n}\n.ant-avatar.gx-size-80 > * {\n  line-height: 80px;\n}\n.ant-avatar.gx-size-60 > * {\n  line-height: 60px;\n}\n.ant-avatar.gx-size-50 > * {\n  line-height: 50px;\n}\n.ant-avatar.gx-size-40 > * {\n  line-height: 40px;\n}\n.ant-avatar.gx-size-36 > * {\n  line-height: 36px;\n}\n.ant-avatar.gx-size-30 > * {\n  line-height: 30px;\n}\n.ant-avatar.gx-size-24 > * {\n  line-height: 24px;\n}\n.ant-avatar.gx-size-20 > * {\n  line-height: 20px;\n}\n.ant-avatar.gx-size-15 > * {\n  line-height: 14px;\n}\n.gx-customers-list .ant-avatar {\n  width: 70px;\n  height: 70px;\n}\n@media (max-width: 1500px) {\n  .gx-customers-list .ant-avatar {\n    width: 60px;\n    height: 60px;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-customers-list .ant-avatar {\n    width: 48px;\n    height: 48px;\n  }\n}\n@media (max-width: 1199px) {\n  .gx-customers-list .ant-avatar {\n    width: 60px;\n    height: 60px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .gx-customers-list .ant-avatar {\n    width: 52px;\n    height: 52px;\n  }\n}\n.gx-avatar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  overflow: hidden;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  height: 50px;\n  width: 50px;\n  position: relative;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  border: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-user-nav .gx-avatar {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-user-nav .gx-avatar {\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n  }\n}\n.gx-header-horizontal-main .gx-avatar {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n}\n@media screen and (max-width: 991px) {\n  .gx-header-horizontal-main .gx-avatar {\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n  }\n}\n.gx-user-thumb {\n  position: relative;\n}\n.ant-tag {\n  margin-bottom: 8px;\n}\n.ant-tag:hover {\n  opacity: 1;\n}\n.gx-badge {\n  display: inline-block;\n  padding: 5px 8px 4px;\n  font-size: 75%;\n  margin-bottom: 6px;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-badge:not(:last-child) {\n  margin-right: 12px;\n}\n.gx-chat-date .gx-badge {\n  margin-bottom: 0;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 16px;\n  padding: 2px;\n}\n.gx-user-thumb .gx-badge {\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 1;\n  margin: 0;\n  display: block;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  line-height: 16px;\n}\n.gx-badge-outline {\n  background-color: transparent;\n  border: solid 1px #e8e8e8;\n}\n.gx-badge-radius-sm .ant-badge-count {\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n#components-back-top-demo-custom .ant-back-top {\n  bottom: 100px;\n}\n#components-back-top-demo-custom .ant-back-top-inner {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  border-radius: 4px;\n  background-color: #1088e9;\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n}\n/*Button Styles*/\n.ant-btn {\n  line-height: 34px;\n}\n.ant-btn-sm {\n  line-height: 24px;\n}\n.ant-btn-group > .ant-btn-sm {\n  line-height: 24px;\n}\n.ant-btn-lg {\n  line-height: 40px;\n}\n.ant-btn-group > .ant-btn-lg {\n  line-height: 40px;\n}\n.ant-btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n.ant-btn-group .ant-btn:not(:last-child),\n.ant-transfer-operation .ant-btn:not(:last-child) {\n  margin-right: 0;\n}\n@media (max-width: 1599px) {\n  .gx-product-footer .ant-btn:not(:last-child) {\n    margin-right: 6px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-btn {\n    margin-bottom: 10px;\n  }\n}\n.ant-input-search .ant-btn {\n  margin-bottom: 0;\n}\n.gx-customizer-option .ant-btn {\n  padding: 0 18px;\n  font-size: 18px;\n  height: 42px;\n  line-height: 42px;\n  margin-bottom: 0;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.05);\n  -webkit-border-radius: 30px 0 0 30px;\n  -moz-border-radius: 30px 0 0 30px;\n  border-radius: 30px 0 0 30px;\n  background-color: #fa8c16;\n  background: -webkit-gradient(linear, left top, right top, from(#fa8c16), to(#f5222d));\n  background: -webkit-linear-gradient(left, #fa8c16, #f5222d);\n  background: -moz-linear-gradient(left, #fa8c16, #f5222d);\n  background: -ms-linear-gradient(left, #fa8c16, #f5222d);\n  background: -o-linear-gradient(left, #fa8c16, #f5222d);\n  border: 0 none;\n  color: #ffffff;\n}\n.gx-customizer-option .ant-btn:hover,\n.gx-customizer-option .ant-btn:focus {\n  background-color: #f5222d;\n  background: -webkit-gradient(linear, left top, right top, from(#f5222d), to(#fa8c16));\n  background: -webkit-linear-gradient(left, #f5222d, #fa8c16);\n  background: -moz-linear-gradient(left, #f5222d, #fa8c16);\n  background: -ms-linear-gradient(left, #f5222d, #fa8c16);\n  background: -o-linear-gradient(left, #f5222d, #fa8c16);\n}\n.gx-customizer-option .ant-btn .icon:before {\n  display: block;\n}\n.horizontal-layout.full-scroll .gx-customizer-option .ant-btn {\n  margin-right: 0;\n}\n.gx-module-add-task .ant-btn {\n  height: 36px;\n}\n.gx-module-add-task .ant-btn .icon:before {\n  position: relative;\n  top: 2px;\n}\n.ant-modal-footer .ant-btn,\n.ant-modal-confirm-btns .ant-btn {\n  margin-bottom: 0;\n}\n.gx-login-content .ant-btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.boxed-layout .ant-btn-group .ant-btn {\n  padding: 0 12px;\n}\n@media (max-width: 1366px) {\n  .ant-btn-group .ant-btn {\n    padding: 0 12px;\n  }\n}\n@media (max-width: 1366px) {\n  .gx-product-footer .ant-btn {\n    padding: 0 10px;\n    height: 32px;\n    font-size: 12px;\n    line-height: 32px;\n  }\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  border-color: #2EB1EF;\n  color: #2EB1EF;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.ant-btn-group:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .ant-btn-group:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n.ant-radio-group .ant-radio-button-wrapper {\n  margin-bottom: 6px;\n}\nbutton {\n  outline: none;\n}\n.ant-confirm .ant-confirm-btns button + button {\n  margin-bottom: 8px;\n}\n.ant-modal.ant-confirm .ant-confirm-btns button + button,\n.ant-modal.ant-confirm .ant-btn {\n  margin-bottom: 0;\n}\n.gx-btn,\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #545454;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: solid 1px #d9d9d9;\n  padding: 0 15px;\n  height: 36px;\n  font-size: 14px;\n  line-height: 34px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n.gx-btn:not(:last-child),\n.btn:not(:last-child) {\n  margin-right: 15px;\n}\n@media screen and (max-width: 575px) {\n  .gx-btn:not(:last-child),\n  .btn:not(:last-child) {\n    margin-right: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-btn,\n  .btn {\n    margin-bottom: 10px;\n  }\n}\n.gx-btn:focus,\n.btn:focus,\n.gx-btn:hover,\n.btn:hover {\n  text-decoration: none;\n}\n.gx-btn:focus,\n.btn:focus,\n.gx-btn.focus,\n.btn.focus {\n  outline: 0;\n}\n.gx-btn.disabled,\n.btn.disabled,\n.gx-btn:disabled,\n.btn:disabled {\n  opacity: 0.65;\n}\n.gx-btn:not([disabled]):not(.disabled),\n.btn:not([disabled]):not(.disabled) {\n  cursor: pointer;\n}\n.gx-btn-list .gx-btn,\n.gx-btn-list .btn {\n  margin-bottom: 6px;\n}\n.gx-sub-popover .gx-btn,\n.gx-sub-popover .btn {\n  border: 0 none;\n  margin-bottom: 5px;\n}\n.gx-sub-popover .gx-btn:focus,\n.gx-sub-popover .btn:focus,\n.gx-sub-popover .gx-btn:hover,\n.gx-sub-popover .btn:hover {\n  background-color: #f5f5f5;\n}\n.gx-sub-popover .gx-btn:not(:last-child),\n.gx-sub-popover .btn:not(:last-child) {\n  margin-right: 5px;\n}\n.gx-login-content .gx-btn,\n.gx-login-content .btn {\n  padding: 9px 20px !important;\n  height: auto;\n  line-height: 1;\n}\n.gx-btn-block {\n  display: block;\n  width: 100%;\n}\na.gx-btn.disabled,\nfieldset[disabled] a.gx-btn {\n  pointer-events: none;\n}\n.gx-btn-rounded {\n  -webkit-border-radius: 50px !important;\n  -moz-border-radius: 50px !important;\n  border-radius: 50px !important;\n}\n.gx-btn-link {\n  font-size: 14px;\n  font-weight: 400;\n  color: #2EB1EF;\n  background-color: transparent;\n}\n.gx-btn-link:hover {\n  color: #2EB1EF;\n  text-decoration: underline;\n  background-color: transparent;\n  border-color: transparent;\n}\n.gx-btn-link:focus,\n.gx-btn-link.focus {\n  text-decoration: underline;\n  border-color: transparent;\n}\n.gx-btn-link:disabled,\n.gx-btn-link.disabled {\n  color: #bfbfbf;\n}\n.gx-btn-lg,\n.gx-btn-group-lg > .gx-btn {\n  padding: 0 15px;\n  font-size: 16px;\n  line-height: 40px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  height: 40px;\n}\n.gx-btn-sm,\n.gx-btn-group-sm > .gx-btn {\n  padding: 0 7px;\n  font-size: 12px;\n  line-height: 24px;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  height: 24px;\n}\n.gx-btn-xs {\n  font-size: 10px;\n  padding: 0 6px;\n  height: 26px;\n  line-height: 25px;\n}\n.gx-btn-block {\n  display: block;\n  width: 100%;\n}\n.gx-btn-block + .gx-btn-block {\n  margin-top: 0.5rem;\n}\n.gx-icon-btn {\n  width: 40px;\n  height: 40px;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  cursor: pointer;\n}\n.gx-icon-btn:focus,\n.gx-icon-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.gx-layout-sider-dark .gx-icon-btn:focus,\n.gx-layout-sider-dark .gx-icon-btn:hover {\n  background-color: #003366;\n}\n.gx-popover-header .gx-icon-btn {\n  width: 30px;\n  height: 30px;\n}\n.gx-icon-btn .icon-star-o:before,\n.gx-icon-btn .icon-star:before {\n  position: relative;\n  top: 3px;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-box-content .gx-icon-btn.icon {\n    font-size: 16px;\n  }\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper {\n  height: 24px;\n  line-height: 24px;\n  border: 0 none;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  margin-left: 0;\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  color: #ffffff;\n}\n.gx-radio-group-link.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none;\n}\n@media screen and (max-width: 575px) {\n  .gx-radio-group-link-news {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-radio-group-link .ant-radio-button-wrapper {\n    padding: 0 8px;\n  }\n}\n.gx-radio-group-link-bg-light {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {\n  padding: 0 10px;\n  margin-left: 5px;\n  margin-right: 5px;\n  background-color: #e8e8e8;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  color: #ffffff;\n}\n.gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none;\n}\n/*Card Styles*/\n.ant-card {\n  margin-bottom: 32px;\n}\n.ant-card-head {\n  background: none;\n}\n.ant-card-head-title {\n  font-weight: 400;\n}\n.ant-card-grid {\n  text-align: center;\n  width: 25%;\n}\n@media screen and (max-width: 767px) {\n  .ant-card-grid {\n    width: 33.33%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-card-grid {\n    width: 50%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .ant-card {\n    margin-bottom: 20px;\n  }\n}\n.ant-card-body .ant-card-head {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.ant-card-type-inner .ant-card-head {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.ant-card-wider-padding .ant-card-body > :last-child {\n  margin-bottom: 0;\n}\n.gx-card-center-vertical {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-card-img {\n  position: relative;\n  overflow: hidden;\n}\n.gx-card-img .ant-card-body {\n  position: relative;\n}\n.gx-card-img .gx-badge-up {\n  position: absolute;\n  right: 60px;\n  top: -20px;\n  z-index: 1;\n  padding: 5px;\n  margin: 0;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  line-height: 36px;\n  text-align: center;\n}\n.gx-card-img .gx-badge-up-right {\n  right: 10px;\n  top: -15px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  line-height: 32px !important;\n}\n.gx-card-img-center .ant-card-cover {\n  text-align: center;\n}\n.gx-card-img-center .ant-card-cover > * {\n  width: auto;\n  display: inline-block;\n}\n.gx-card-body-border-top .ant-card-cover {\n  padding-top: 24px;\n}\n.gx-card-body-border-top .ant-card-body {\n  border-top: solid 1px #e8e8e8;\n  margin-top: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-body-border-top .ant-card-body {\n    margin-bottom: 20px;\n  }\n}\n.gx-ant-card-actions {\n  list-style: none;\n  margin: 0 -10px 10px;\n  padding-left: 0;\n}\n.gx-ant-card-actions li {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 10px;\n}\n.gx-ant-card-actions li:not(:last-child) {\n  border-right: solid 1px #e8e8e8;\n}\n.gx-card {\n  margin-bottom: 32px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card {\n    margin-bottom: 20px;\n  }\n}\n.gx-card-head {\n  padding: 24px;\n}\n.gx-card-head .gx-card-title {\n  margin-bottom: 0;\n}\n.gx-card-head + .gx-card-body {\n  padding-top: 0;\n}\n.gx-card .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 10px;\n  padding: 0 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-head {\n    padding: 0 24px;\n  }\n}\n.gx-card .ant-card-head-title {\n  padding: 25px 0 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-head-title {\n    padding-top: 20px;\n  }\n}\n.gx-card-body,\n.gx-card .ant-card-body {\n  padding: 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-card-body,\n  .gx-card .ant-card-body {\n    padding: 24px;\n  }\n}\n.gx-card.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card.ant-card-hoverable:hover {\n  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.45);\n}\n.gx-card .ant-card-cover {\n  padding: 24px;\n  padding-bottom: 0;\n}\n@media screen and (max-width: 991px) {\n  .gx-card .ant-card-cover {\n    padding: 24px;\n    padding-bottom: 0;\n  }\n}\n.gx-card-metrics {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-card-metrics.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card-metrics .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 10px;\n}\n.gx-card-metrics .ant-card-head-title {\n  padding: 20px 0 0;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n.gx-card-widget {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-card-widget.ant-card-bordered {\n  border: 0 none;\n}\n.gx-card-widget .ant-card-head {\n  border-bottom: 0 none;\n  min-height: 24px;\n  padding: 24px 24px 0;\n}\n.gx-card-widget .ant-card-head-wrapper {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-card-widget .ant-card-head-title {\n  padding: 0;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n.gx-card-widget.gx-ch-capitalize .ant-card-head-title {\n  text-transform: capitalize;\n  font-size: 14px;\n}\n.gx-card-widget .ant-card-extra {\n  padding: 0;\n}\n.gx-card-widget .ant-card-extra .gx-btn {\n  margin-bottom: 0;\n}\n.gx-card-widget .ant-card-body {\n  padding: 24px;\n}\n.gx-card-equal-height {\n  height: calc(100% - 32px);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-equal-height {\n    height: calc(100% - 20px);\n  }\n}\n.gx-card-equal-height .ant-card-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-card-equal-height .ant-card-body .gx-rechart {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-card-equal-height .ant-card-body .gx-rechart .recharts-responsive-container {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: flex;\n}\n.gx-card-sm-p .ant-card-head {\n  min-height: 10px;\n}\n.gx-card-sm-p .ant-card-head-title {\n  padding: 14px 14px 0;\n}\n.gx-card-sm-p .ant-card-body {\n  padding: 14px;\n}\n.gx-card-sm-px .ant-card-head {\n  min-height: 10px;\n}\n.gx-card-sm-px .ant-card-head-title {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.gx-card-sm-px .ant-card-body {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.gx-entry-header {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-entry-header {\n    margin-bottom: 20px;\n  }\n}\n.gx-entry-header .gx-entry-heading {\n  margin-bottom: 0;\n}\n.gx-entry-header .gx-entry-description {\n  margin-bottom: 0;\n  font-size: 13px;\n}\n.gx-card-full {\n  overflow: hidden;\n}\n.gx-card-full .gx-card-body {\n  padding: 0;\n}\n.gx-card-full .gx-card-body .recharts-legend-wrapper {\n  padding: 0 24px;\n}\n.gx-card-full .ant-card-body {\n  padding: 0;\n}\n.gx-card-full .ant-card-body .recharts-legend-wrapper {\n  padding: 0 24px;\n}\n.gx-card-full .recharts-default-legend {\n  margin: 0 -10px !important;\n}\n.gx-card-full .recharts-default-legend li {\n  padding: 0 10px;\n  margin: 0 !important;\n  display: inline-block;\n  vertical-align: top;\n}\n.gx-card-full .recharts-default-legend li .recharts-legend-item-text {\n  margin-left: 10px;\n}\n.gx-card-overview {\n  margin-bottom: 32px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  padding: 24px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-overview {\n    margin-bottom: 20px;\n  }\n}\n.gx-card-overview .gx-card-title {\n  margin-bottom: 20px;\n}\n.gx-card-profile .ant-card-head {\n  padding-top: 15px;\n  padding-bottom: 16px;\n}\n.gx-card-profile.gx-card-tabs .ant-card-head {\n  border-bottom: 1px solid #e8e8e8;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-profile.gx-card-tabs .ant-card-head {\n    border-bottom: 0 none;\n  }\n}\n.gx-card-profile .ant-card-body,\n.gx-card-profile.gx-card-tabs .ant-card-body {\n  padding-top: 0;\n}\n.gx-card-profile.gx-card-tabs .ant-tabs {\n  margin-top: -49px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-profile.gx-card-tabs .ant-tabs {\n    margin-top: 0;\n  }\n}\n.gx-card-profile .ant-tabs-tab {\n  padding-top: 15px;\n  padding-bottom: 18px;\n}\n.gx-card-profile .ant-card-head-title,\n.gx-card-profile.gx-card-tabs .ant-card-head-title {\n  font-size: 20px;\n  text-transform: capitalize;\n}\n.gx-card-profile.gx-card-tabs .ant-tabs-nav-container {\n  font-size: 14px;\n  color: #8c8c8c;\n}\n.gx-card-profile-sm.gx-card-widget .ant-card-body {\n  padding-top: 10px;\n}\n@media (max-width: 1366px) {\n  .gx-card-1367-p .ant-card-head {\n    min-height: 10px;\n  }\n  .gx-card-1367-p .ant-card-head-title {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n  .gx-card-1367-p .ant-card-body {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n}\n.ant-divider-horizontal.ant-divider-with-text,\n.ant-divider-horizontal.ant-divider-with-text-left,\n.ant-divider-horizontal.ant-divider-with-text-right {\n  font-size: 14px;\n}\n/*Cascader Styles*/\n.ant-cascader-picker {\n  width: 100%;\n}\n/*Chart Styles*/\n.recharts-default-tooltip {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  color: #089265;\n}\n.recharts-tooltip-item-list li {\n  color: #2EB1EF !important;\n}\n/*Form Styles*/\n.ant-form .ant-row {\n  margin-left: 0;\n  margin-right: 0;\n}\n.ant-form-inline {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n.ant-form-inline .ant-row {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-form-inline .ant-form-item {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .ant-form-inline .ant-form-item {\n    display: block;\n  }\n}\n.ant-form-horizontal .ant-row {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.ant-form-vertical .ant-form-item {\n  padding-bottom: 0;\n}\n.ant-form-vertical .ant-row {\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.ant-form-extra {\n  word-break: break-all;\n}\n@media (max-width: 575px) {\n  .ant-form-item-label {\n    padding-bottom: 0;\n  }\n}\n.ant-form-item-with-help {\n  margin-bottom: 20px;\n}\n.ant-advanced-search-form .gx-btn-link:hover {\n  text-decoration: none;\n}\n.ant-form-item-control > .ant-form-item:last-child,\n.ant-form-item [class^=\"ant-col-\"] > .ant-form-item:only-child {\n  margin-bottom: 0;\n}\n.gx-form-row0 .ant-row {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.gx-login-form {\n  max-width: 350px;\n}\n.gx-login-form .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.ant-form-inline .gx-form-item-one-fourth {\n  width: 25%;\n}\n@media (max-width: 575px) {\n  .ant-form-inline .gx-form-item-one-fourth {\n    width: 100%;\n  }\n}\n.ant-form-inline .gx-form-item-two-fourth {\n  width: 50%;\n}\n@media (max-width: 575px) {\n  .ant-form-inline .gx-form-item-two-fourth {\n    width: 100%;\n  }\n}\n.gx-form-inline-currency {\n  margin: 0 -8px;\n}\n.gx-form-inline-currency .ant-form-item {\n  padding: 0 8px;\n}\n.gx-form-inline-currency .gx-form-item-one-fourth {\n  width: 30%;\n}\n@media (max-width: 575px) {\n  .gx-form-inline-currency .gx-form-item-one-fourth {\n    width: 40%;\n    display: inline-block;\n  }\n}\n.gx-form-inline-currency .gx-form-item-two-fourth {\n  width: 40%;\n}\n@media (max-width: 575px) {\n  .gx-form-inline-currency .gx-form-item-two-fourth {\n    width: 100%;\n    display: block;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 15px;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 15px;\n  }\n  .ant-form-item,\n  .ant-form-item-with-help {\n    margin-bottom: 12px;\n  }\n  .ant-advanced-search-form .ant-form-item {\n    margin-bottom: 12px;\n  }\n}\n@media (max-width: 991px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 15px;\n  }\n}\n@media (max-width: 767px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 15px;\n  }\n}\n@media (max-width: 575px) {\n  .ant-form-item-label[class*='ant-col-'] {\n    padding: 0 15px;\n    margin-bottom: 8px;\n  }\n  .ant-advanced-search-form .ant-btn,\n  .ant-advanced-search-form .gx-btn-link {\n    display: block;\n    margin: 0 0 10px !important;\n  }\n}\n/*Input Styles*/\n.ant-input-search {\n  margin-bottom: 16px;\n}\n.ant-input-search > .ant-input-suffix > .ant-input-search-button {\n  margin-right: 0;\n}\n.ant-input-group > [class*=\"col-\"] {\n  padding-left: 0;\n  float: left !important;\n}\n.ant-transfer-list {\n  margin-bottom: 10px;\n}\n.gx-form-group {\n  margin-bottom: 10px;\n}\n.gx-search-bar {\n  position: relative;\n}\n.gx-search-bar .gx-form-group {\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0;\n}\n.gx-search-bar input[type=\"search\"] {\n  padding-right: 35px;\n  background: rgba(250, 250, 250, 0.1);\n}\n.ant-layout-header .gx-search-bar input[type=\"search\"],\n.ant-popover-content .gx-search-bar input[type=\"search\"] {\n  border: 0 none;\n}\n.gx-search-bar input[type=\"search\"]:focus {\n  box-shadow: none;\n  background-color: rgba(250, 250, 250, 0.3);\n}\n.gx-search-bar .gx-search-icon {\n  background-color: transparent;\n  border: 0 none;\n  color: #d9d9d9;\n  height: 32px;\n  width: 30px;\n  line-height: 36px;\n  text-align: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.gx-algolia-header .gx-search-bar .gx-search-icon {\n  margin-top: 2px;\n  text-align: left;\n}\n.gx-search-bar .ant-input-lg + .gx-search-icon {\n  height: 40px;\n  line-height: 45px;\n}\n.gx-lt-icon-search-bar input[type=\"search\"] {\n  padding-right: 16px;\n  padding-left: 35px;\n  border: 0 none;\n}\n.gx-lt-icon-search-bar .gx-search-icon {\n  left: 0;\n  right: auto;\n}\n.gx-algolia-header .gx-lt-icon-search-bar {\n  margin-right: 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-algolia-header .gx-lt-icon-search-bar {\n    width: 140px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .gx-algolia-header .gx-lt-icon-search-bar {\n    margin-right: 0;\n    margin-bottom: 10px;\n    width: auto;\n  }\n}\n.gx-lt-icon-search-bar-lg {\n  width: 350px;\n}\n.gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  height: 46px;\n  padding: 10px 18px 10px 40px;\n}\n@media screen and (max-width: 991px) {\n  .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n    height: 38px;\n    padding: 5px 18px 5px 40px;\n  }\n}\n.gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  background-color: #f5f5f5;\n  height: 36px;\n  -webkit-border-radius: 4px 0 0 4px;\n  -moz-border-radius: 4px 0 0 4px;\n  border-radius: 4px 0 0 4px;\n  border: solid 1px #e8e8e8;\n}\n.gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"]:focus {\n  background-color: #f2f2f2;\n}\n.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  border-color: rgba(255, 255, 255, 0.2);\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n.gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"]:focus {\n  background-color: transparent;\n}\n.gx-lt-icon-search-bar-lg .gx-search-icon {\n  width: 35px;\n  height: 46px;\n  line-height: 50px;\n  font-size: 16px;\n  left: 0;\n  right: auto;\n}\n@media screen and (max-width: 991px) {\n  .gx-lt-icon-search-bar-lg .gx-search-icon {\n    height: 38px;\n    line-height: 40px;\n  }\n}\n.gx-header-search .gx-lt-icon-search-bar-lg .gx-search-icon {\n  height: 36px;\n  line-height: 40px;\n}\n.gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {\n  width: 200px;\n  margin-right: 10px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-inside-header-horizontal .gx-lt-icon-search-bar-lg {\n    width: 120px;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-lt-icon-search-bar-lg {\n    width: 150px;\n  }\n}\n.gx-popover-search-bar {\n  width: 150px;\n  margin: -10px -14px;\n}\n.gx-chat-search-bar {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  min-width: 100px;\n  width: auto;\n}\n.gx-chat-search-bar input[type=\"search\"] {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n  height: 40px;\n  border: 0 none;\n}\n.gx-chat-search-bar input[type=\"search\"]:focus {\n  background-color: #ffffff;\n}\n.gx-chat-search-bar .gx-search-icon {\n  height: 40px;\n  line-height: 44px;\n}\n.ant-transfer-list {\n  width: 150px;\n}\n@media screen and (max-width: 575px) {\n  .ant-transfer-list {\n    width: 100%;\n  }\n}\n.gx-select-sm {\n  font-size: 12px;\n}\n.gx-select-sm .ant-select-selection {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.gx-select-sm .ant-select-selection--single {\n  height: 24px;\n}\n.gx-select-sm .ant-select-selection__rendered {\n  line-height: 22px;\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.gx-select-sm .ant-select-selection-selected-value {\n  padding-right: 20px;\n}\n.gx-select-sm .ant-select-arrow {\n  right: 6px;\n}\n.gx-select-sm .ant-select-dropdown {\n  font-size: 12px;\n}\n.gx-form-inline-label-up .ant-form-item > .ant-form-item-control-wrapper,\n.gx-form-inline-label-up .ant-form-item > .ant-form-item-label {\n  display: block;\n}\n.gx-form-inline-label-up .ant-form-item-label {\n  text-align: left;\n  color: #bfbfbf;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n.gx-form-inline-label-up .ant-select-selection--single,\n.gx-form-inline-label-up .ant-input {\n  height: 30px;\n}\n.gx-form-inline-label-up .ant-select-selection__rendered {\n  line-height: 28px;\n}\n@media screen and (max-width: 575px) {\n  .gx-ant-transfer-width .ant-transfer-list {\n    width: 100% !important;\n  }\n}\n@media screen and (max-width: 475px) {\n  .ant-input-group.ant-input-group-compact > * {\n    -webkit-border-radius: 4px !important;\n    -moz-border-radius: 4px !important;\n    border-radius: 4px !important;\n    width: 100% !important;\n  }\n  .ant-input-group.ant-input-group-compact > *:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  .ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n  .ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n  .ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n  .ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n    border-radius: 4px;\n  }\n  .ant-input-group.ant-input-group-compact .gx-border-lt-xs {\n    border-left: 1px solid #d9d9d9 !important;\n  }\n}\n/*Icon Styles*/\n.gx-icon-views {\n  position: relative;\n  text-align: center;\n  padding: 16px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  margin-bottom: 15px;\n  height: calc(85%);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-icon-views .icon {\n  margin-bottom: 12px;\n  font-size: 20px;\n  -webkit-transition: all 0.3s ease-out;\n  -moz-transition: all 0.3s ease-out;\n  -ms-transition: all 0.3s ease-out;\n  -o-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  line-height: 1;\n  display: block;\n}\n.gx-icon-views:hover {\n  background-color: #2EB1EF;\n  cursor: pointer;\n  color: #ffffff;\n}\n.gx-icon-views:hover .icon {\n  -webkit-transform: scale(1.4);\n  -moz-transform: scale(1.4);\n  -ms-transform: scale(1.4);\n  -o-transform: scale(1.4);\n  transform: scale(1.4);\n}\n.gx-icon-text {\n  display: block;\n  font-size: 12px;\n}\n/*List Styles*/\n.ant-list-vertical .ant-list-item-main {\n  min-width: 200px;\n}\n@media screen and (max-width: 480px) {\n  .ant-list-vertical .ant-list-item-extra {\n    margin-bottom: 10px;\n  }\n}\n.gx-list-item .ant-list-item-extra-wrap {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {\n  margin-left: 20px;\n}\n@media screen and (max-width: 575px) {\n  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n  .gx-list-item .ant-list-item-extra-wrap .ant-list-item-extra img {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-list-item .ant-list-item-extra-wrap {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-user-list {\n  width: 100%;\n  padding-bottom: 10px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-user-list:not(:first-child) {\n  padding-top: 20px;\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list:not(:first-child) {\n    padding-top: 0;\n  }\n}\n.gx-user-list.gx-card-list {\n  padding: 30px;\n  background: #fff;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  margin-bottom: 32px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n.gx-user-list.gx-card-list .gx-avatar-img {\n  margin-right: 25px;\n}\n@media screen and (max-width: 767px) {\n  .gx-user-list.gx-card-list {\n    padding: 20px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list.gx-card-list {\n    margin-bottom: 20px;\n  }\n}\n.gx-user-list .gx-avatar-img {\n  margin-right: 20px;\n  margin-bottom: 10px;\n}\n.gx-user-list h3 {\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n.gx-user-list .gx-link[class*=\"gx-meta-\"] {\n  display: inline-block;\n  color: #545454;\n  font-size: 12px;\n  font-weight: 500;\n}\n.gx-user-list .gx-link[class*=\"gx-meta-\"] i {\n  margin-right: 6px;\n  vertical-align: middle;\n}\n.gx-user-list .gx-description {\n  width: calc(100% - 120px);\n}\n@media screen and (max-width: 575px) {\n  .gx-user-list .gx-description {\n    width: 100%;\n  }\n}\n.gx-user-list .gx-btn-list li:not(:last-child) {\n  margin-right: 10px;\n}\n.gx-list-inline {\n  margin-left: -5px;\n  margin-right: -5px;\n  padding-left: 0;\n  list-style: none;\n}\n.gx-list-inline li {\n  padding: 0 5px;\n  display: inline-block;\n}\n.gx-list-inline-lg {\n  margin-left: -10px;\n  margin-right: -10px;\n  padding-left: 0;\n  list-style: none;\n}\n.gx-list-inline-lg li {\n  padding: 0 10px;\n  display: inline-block;\n}\n.gx-card-strip {\n  margin-bottom: 10px;\n}\n.gx-card-strip:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-card-list .gx-description {\n  width: calc(100% - 230px);\n  margin-top: 5px;\n}\n@media screen and (max-width: 767px) {\n  .gx-card-list .gx-description {\n    width: calc(100% - 80px);\n  }\n}\n.gx-card-list .gx-card-list-footer {\n  padding-left: 15px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  min-width: 150px;\n}\n.gx-card-list .gx-card-list-footer .ant-btn {\n  display: block;\n  margin-right: 0;\n  width: 120px;\n}\n.gx-card-list .gx-card-list-footer .ant-btn:last-child {\n  margin-bottom: 0;\n}\n@media screen and (max-width: 767px) {\n  .gx-card-list .gx-card-list-footer {\n    padding-left: 0;\n    min-width: 10px;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .gx-card-list .gx-card-list-footer .ant-btn {\n    width: auto;\n    margin-right: 12px;\n    margin-bottom: 0;\n  }\n}\n.gx-list-group {\n  list-style: none;\n  padding-left: 0;\n}\n.gx-list-group li {\n  margin-bottom: 6px;\n}\n.gx-list-group li i {\n  margin-right: 12px;\n}\n.gx-dot-list {\n  list-style: none;\n  margin: 0 -3px 10px;\n  padding-left: 0;\n}\n.gx-dot-list li {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 3px;\n}\n@media screen and (max-width: 575px) {\n  .gx-dot-list {\n    margin-bottom: 5px;\n  }\n}\n/*Loader Styles*/\n.ant-spin {\n  margin-right: 16px;\n  margin-bottom: 10px;\n}\n.gx-loader-container {\n  text-align: center;\n  background-color: #f5f5f5;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  padding: 30px 50px;\n  margin-right: 0;\n  display: block;\n}\n/*Pagination Styles*/\n.ant-pagination > li {\n  margin-bottom: 10px;\n}\n.ant-pagination > li.ant-pagination-options,\n.ant-pagination > li.ant-pagination-total-text {\n  margin-bottom: 0;\n}\n.ant-pagination.mini:not(:last-child) {\n  margin-bottom: 10px;\n}\n.ant-pagination.mini li {\n  margin-bottom: 5px !important;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  line-height: 30px;\n}\n/*Pickers Styles*/\n.photoshop-picker,\n.swatches-picker,\n.alpha-picker,\n.hue-picker {\n  width: 100% !important;\n}\n.gx-alpha-pickers {\n  position: relative;\n  min-height: 250px;\n}\n.ant-calendar-footer .ant-calendar-ok-btn {\n  margin-bottom: 0;\n}\n/*Progress Styles*/\n.ant-progress-line {\n  margin-right: 8px;\n  margin-bottom: 8px;\n}\n.ant-progress-circle {\n  margin-right: 8px;\n  margin-bottom: 8px;\n}\n/*Steps Styles*/\n.ant-steps-dot {\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 10px 0;\n}\n.ant-steps-dot .ant-steps-item {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .ant-steps-dot .ant-steps-item-description {\n    display: none;\n  }\n}\n/*Slider Styles*/\n.ant-carousel h1,\n.ant-carousel h2,\n.ant-carousel h3,\n.ant-carousel h4,\n.ant-carousel h5,\n.ant-carousel h6 {\n  line-height: inherit;\n  margin-bottom: 0;\n}\n.gx-vertical-slider {\n  position: relative;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -15px;\n}\n.gx-vertical-slider-item {\n  width: 33.33%;\n  padding: 0 15px;\n  height: 300px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-vertical-slider-item {\n    width: 50%;\n    margin-bottom: 15px;\n  }\n}\n.ant-carousel-vertical .gx-vertical-slide .slick-slide {\n  height: 160px;\n}\n.slick-slider {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .slick-slider {\n    margin-bottom: 20px;\n  }\n}\n.slick-slider .slick-prev {\n  left: -10px;\n}\n.slick-slider .slick-prev:before {\n  color: #000000;\n}\n.slick-slider .slick-next {\n  right: -10px;\n}\n.slick-slider .slick-next:before {\n  color: #000000;\n}\n.slick-slider img {\n  width: 100%;\n  object-fit: cover;\n}\n.slick-dots li button:before {\n  display: none;\n}\n.gx-slick-slider .slick-dots {\n  bottom: 26px;\n  padding: 0 24px;\n  text-align: left;\n}\n.gx-slick-slider .slick-dots li {\n  width: 10px !important;\n  height: 10px !important;\n}\n.gx-slick-slider .slick-dots li button {\n  width: 10px !important;\n  height: 10px !important;\n}\n.gx-slick-slider .slick-dots li button:before {\n  width: 10px !important;\n  height: 10px !important;\n  line-height: 10px !important;\n  color: transparent;\n  border: solid 2px #000000;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  display: block;\n}\n.gx-slick-slider .slick-dots li.slick-active button {\n  width: 12px !important;\n  height: 12px !important;\n}\n.gx-slick-slider .slick-dots li.slick-active button:before {\n  color: transparent;\n  border-color: #2EB1EF;\n  width: 12px !important;\n  height: 12px !important;\n  line-height: 12px !important;\n}\n.gx-slide-item {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n@media screen and (max-width: 480px) {\n  .gx-slide-item {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n}\n.gx-slider {\n  position: relative;\n}\n.gx-slider-img {\n  position: relative;\n  padding-bottom: 24px;\n}\n.gx-slider-img .gx-img-up {\n  position: absolute;\n  left: 24px;\n  bottom: -5px;\n  z-index: 1;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  width: auto;\n  max-width: 64px;\n}\n.gx-slider-content {\n  padding: 24px;\n}\n.gx-slick-slider {\n  margin-bottom: 0;\n  padding-bottom: 24px;\n}\n.gx-slick-slider-dot-top {\n  padding-top: 70px;\n  padding-right: 24px;\n  padding-bottom: 58px;\n}\n@media (max-width: 1366px) {\n  .gx-slick-slider-dot-top {\n    padding-top: 40px;\n    padding-bottom: 10px;\n  }\n}\n.gx-slick-slider-dot-top .slick-dots {\n  bottom: auto;\n  top: 30px;\n  padding-left: 0;\n}\n@media (max-width: 1366px) {\n  .gx-slick-slider-dot-top .slick-dots {\n    top: 10px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-slick-slider-dot-top {\n    padding-left: 24px;\n  }\n}\n.gx-slick-slider-lt-thumb {\n  height: 100%;\n  position: relative;\n}\n.gx-slick-slider-lt-thumb img {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n@media screen and (max-width: 575px) {\n  .gx-slick-slider-lt-thumb img {\n    position: relative;\n    left: auto;\n    top: auto;\n  }\n}\n.ant-modal .slides {\n  position: relative;\n}\n.ant-modal .slides .slick-prev,\n.ant-modal .slides .slick-next {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  margin-top: -10px;\n}\n.ant-modal .slides .slick-prev {\n  left: 20px;\n}\n.ant-modal .slides .slick-next {\n  right: 20px;\n}\n.ant-modal .slick-slider {\n  margin-bottom: 0;\n}\n/*Tables Styles*/\n.ant-table-small > .ant-table-content {\n  border: none;\n}\n.ant-table-small > .ant-table-content > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table,\n.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table {\n  padding: 0;\n}\n.ant-table-small > .ant-table-content > .ant-table-body {\n  margin: 0;\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  word-break: normal;\n}\n.dark-theme .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {\n  background: transparent !important;\n  border-bottom-color: transparent !important;\n}\n.gx-table-responsive .ant-table {\n  min-height: .01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .gx-table-responsive .ant-table {\n    width: 100%;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: solid 1px #e8e8e8;\n  }\n  .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {\n    border: 0 none;\n    border-bottom: solid 1px #e8e8e8;\n  }\n  .gx-table-responsive .ant-table .ant-table-tbody > tr:last-child > td {\n    border-bottom: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-header > table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-body > table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-left table,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-fixed-right table {\n    border-top: 0 none;\n    border-left: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-title {\n    border: 0 none;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {\n    border: 0 none;\n    border-top: solid 1px #e8e8e8;\n  }\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-thead > tr > th:last-child,\n  .gx-table-responsive .ant-table.ant-table-bordered .ant-table-tbody > tr > td:last-child {\n    border-right: 0 none;\n  }\n  .gx-table-responsive .ant-table-body > table > thead > tr > th,\n  .gx-table-responsive .ant-table-body > table > tbody > tr > th,\n  .gx-table-responsive .ant-table-body > table > tfoot > tr > th,\n  .gx-table-responsive .ant-table-body > table > thead > tr > td,\n  .gx-table-responsive .ant-table-body > table > tbody > tr > td,\n  .gx-table-responsive .ant-table-body > table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n}\n.gx-table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent;\n}\n.gx-table th,\n.gx-table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: solid 1px #e8e8e8;\n}\n.gx-table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e8e8e8;\n}\n.gx-table tbody + tbody {\n  border-top: 2px solid #e8e8e8;\n}\n.gx-table-bordered {\n  border: 1px solid #e8e8e8;\n}\n.gx-table-bordered th,\n.gx-table-bordered td {\n  border: 1px solid #e8e8e8;\n}\n.gx-table-bordered thead th,\n.gx-table-bordered thead td {\n  border-bottom-width: 2px;\n}\n.gx-table-no-bordered {\n  border: 0 none;\n}\n.gx-table-no-bordered th,\n.gx-table-no-bordered td {\n  border: 0 none;\n}\n.gx-table-no-bordered thead th,\n.gx-table-no-bordered thead td {\n  border-bottom-width: 2px;\n}\n.gx-table-no-bordered .ant-table {\n  border: 0 none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-table-no-bordered .ant-table-thead > tr > th {\n  font-weight: 300;\n  text-transform: uppercase;\n  font-size: 11px;\n}\n.gx-table-no-bordered .ant-table-tbody > tr > td {\n  border-bottom: 0 none;\n}\n.gx-table-thead-uppercase thead th {\n  text-transform: uppercase;\n}\n.gx-table-padding-lg thead th,\n.gx-table-padding-lg tbody td {\n  padding: 20px 30px !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-table-padding-lg thead th,\n  .gx-table-padding-lg tbody td {\n    padding: 15px 20px !important;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-table-padding-lg thead th,\n  .gx-table-padding-lg tbody td {\n    padding: 10px !important;\n  }\n}\n.gx-table-padding-lg .ant-table-pagination {\n  float: none;\n  text-align: center;\n  margin: 22px 0;\n}\n@media screen and (max-width: 991px) {\n  .gx-table-padding-lg .ant-table-pagination {\n    margin: 16px 0;\n  }\n}\n/*Time Lines Style*/\n/*Antd Time Lines Style*/\n.ant-timeline-item {\n  padding: 0;\n}\n.ant-timeline-item:not(:last-child) {\n  padding-bottom: 20px;\n}\n@media screen and (max-width: 575px) {\n  .ant-timeline-item:not(:last-child) {\n    padding-bottom: 15px;\n  }\n}\n.gx-timeline-info {\n  position: relative;\n}\n.gx-timeline-info:not(:last-child) {\n  padding-bottom: 20px;\n}\n.gx-timeline-info-day {\n  margin-bottom: 15px;\n  font-size: 12px;\n  color: #595959;\n}\n.gx-timeline-info .ant-timeline {\n  padding-top: 0;\n  padding-left: 0;\n}\n.gx-timeline-info .ant-timeline-item-head-custom {\n  padding: 0;\n  margin-right: 15px;\n  position: relative;\n  left: 0;\n  top: 0;\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n.gx-timeline-info .ant-timeline-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: flex-start;\n  -ms-align-items: flex-start;\n  align-items: flex-start;\n}\n.gx-timeline-info .ant-timeline-item-content {\n  padding-left: 0;\n  top: 0;\n  margin-left: 0;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  color: #595959;\n}\n.gx-timeline-info .ant-timeline-item-content .gx-link {\n  color: #262626;\n}\n.gx-timeline-info .ant-timeline-item-content .gx-link:hover,\n.gx-timeline-info .ant-timeline-item-content .gx-link:focus {\n  color: #2EB1EF;\n}\n.gx-timeline-info .ant-timeline-item-tail {\n  display: none;\n}\n.gx-img-more {\n  width: 60px;\n  height: 40px;\n  background-color: #ffffff;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  border: solid 1px #e8e8e8;\n}\n/*Custom Time Lines Style*/\n.gx-timeline-left {\n  float: left;\n  margin-right: 20px;\n}\n.gx-timeline-right {\n  float: right;\n  margin-left: 20px;\n}\n.gx-timeline-circle {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-timeline-section {\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n.gx-timeline-item {\n  padding-bottom: 25px;\n  padding-left: 80px;\n  position: relative;\n}\n.gx-timeline-item:before {\n  border-left: solid 2px #e8e8e8;\n  content: \"\";\n  left: 25px;\n  position: absolute;\n  top: 25px;\n  bottom: -20px;\n  width: 2px;\n  z-index: 1;\n}\n.gx-timeline-item:first-child:before {\n  border-left-style: dashed;\n}\n.gx-timeline-item:last-child:before {\n  border-left-style: dashed;\n  bottom: 25px;\n}\n.gx-timeline-badge {\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  left: 0;\n  top: 16px;\n  z-index: 2;\n  font-size: 16px;\n  color: #ffffff;\n  text-align: center;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n.gx-timeline-badge.gx-timeline-img {\n  background-color: transparent;\n}\n.gx-timeline-badge.gx-timeline-img:after {\n  display: none;\n}\n.gx-timeline-badge:after {\n  position: absolute;\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  background-color: transparent;\n  border: 4px solid #e8e8e8;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  left: 4px;\n  top: 4px;\n  z-index: 1;\n}\n.gx-timeline-badge [class^=\"gx-\"]:before,\n.gx-timeline-badge [class*=\"gx-\"]:before {\n  line-height: 50px;\n}\n.gx-timeline-img > img,\n.gx-timeline-header-img > img {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n.gx-timeline-panel {\n  padding: 20px 30px;\n  position: relative;\n  background-color: #ffffff;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  border: solid 1px #e8e8e8;\n}\n.gx-timeline-panel:after,\n.gx-timeline-panel:before {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  display: inline-block;\n  top: 30px;\n}\n.gx-timeline-panel:before {\n  border-color: transparent #e8e8e8;\n  border-width: 10px 17px 10px 0;\n  left: -18px;\n}\n.gx-timeline-panel:after {\n  border-color: transparent #ffffff;\n  border-width: 10px 16px 10px 0;\n  left: -16px;\n}\n.gx-timeline-no-padding {\n  padding: 0;\n}\n.gx-timeline-panel-header {\n  margin-bottom: 10px;\n}\n.gx-timeline-header-img {\n  margin-bottom: 10px;\n}\n.gx-timeline-inverted .gx-timeline-left {\n  float: right;\n  margin-right: 0;\n  margin-left: 20px;\n}\n.gx-timeline-heading {\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.gx-timeline-body {\n  clear: both;\n}\n/*Gxtl Center Style*/\n.gx-timeline-center .gx-timeline-item {\n  clear: both;\n  float: right;\n  width: 50%;\n  padding-left: 55px;\n}\n.gx-timeline-center .gx-timeline-item:before {\n  left: 0;\n}\n.gx-timeline-center .gx-timeline-badge {\n  left: -25px;\n  right: auto;\n}\n.gx-timeline-center .gx-timeline-time {\n  position: absolute;\n  top: 32px;\n  left: -150px;\n  right: auto;\n  z-index: 2;\n}\n.gx-timeline-center .gx-timeline-inverted {\n  float: left;\n  text-align: right;\n  padding-left: 0;\n  padding-right: 55px;\n}\n.gx-timeline-center .gx-timeline-inverted:before {\n  border-left: 0 none;\n  border-right: solid 2px #e8e8e8;\n  left: auto;\n  right: -2px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n  left: auto;\n  right: -25px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {\n  border-width: 10px 0 10px 17px;\n  left: auto;\n  right: -18px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {\n  border-width: 10px 0 10px 16px;\n  left: auto;\n  right: -16px;\n}\n.gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n  position: absolute;\n  top: 32px;\n  right: -150px;\n  left: auto;\n  z-index: 2;\n}\n/*Gxtl Zigzag Style*/\n.gx-timeline-zigzag .gx-timeline-item {\n  padding-left: 150px;\n}\n.gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n  margin-top: -80px;\n}\n.gx-timeline-zigzag .gx-timeline-img {\n  width: 90px;\n  height: 90px;\n  left: 5px;\n}\n.gx-timeline-zigzag .gx-timeline-img > img {\n  width: 100%;\n}\n.gx-timeline-zigzag .gx-timeline-inverted .gx-timeline-img {\n  right: 5px !important;\n}\n.gx-timeline-zigzag .gx-timeline-item:before {\n  -webkit-transform: rotate(35deg);\n  -moz-transform: rotate(35deg);\n  -ms-transform: rotate(35deg);\n  -o-transform: rotate(35deg);\n  transform: rotate(35deg);\n  top: 20px;\n  bottom: 20px;\n}\n.gx-timeline-zigzag .gx-timeline-inverted {\n  padding-left: 0;\n  padding-right: 150px;\n}\n.gx-timeline-zigzag .gx-timeline-inverted:before {\n  -webkit-transform: rotate(-35deg);\n  -moz-transform: rotate(-35deg);\n  -ms-transform: rotate(-35deg);\n  -o-transform: rotate(-35deg);\n  transform: rotate(-35deg);\n}\n.gx-timeline-zigzag .gx-timeline-item:first-child:before {\n  border-left-style: solid;\n}\n.gx-timeline-zigzag .gx-timeline-item:last-child:before {\n  display: none;\n}\n.gx-timeline-item:last-child:before {\n  bottom: 25px;\n}\n@media screen and (max-width: 991px) {\n  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n    margin-top: -60px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:before {\n    bottom: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-item {\n    padding-left: 120px;\n  }\n  .gx-timeline-zigzag .gx-timeline-inverted {\n    padding-right: 120px;\n    padding-left: 0;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-timeline-center .gx-timeline-item {\n    float: none;\n    padding-left: 80px;\n    width: auto;\n  }\n  .gx-timeline-center .gx-timeline-item:before {\n    left: 25px;\n  }\n  .gx-timeline-center .gx-timeline-badge {\n    left: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted {\n    float: none;\n    text-align: left;\n    padding-right: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted:before {\n    border-left: solid 2px #e8e8e8;\n    border-right: 0 none;\n    left: 24px;\n    right: auto;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-badge {\n    right: auto;\n    left: 0;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:before {\n    border-width: 10px 17px 10px 0 !important;\n    left: -18px;\n    right: auto;\n  }\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-panel:after {\n    border-width: 10px 16px 10px 0 !important;\n    left: -16px;\n    right: auto;\n  }\n  .gx-timeline-inverted .gx-timeline-panel-header {\n    float: none;\n  }\n  .gx-timeline-inverted .gx-timeline-left {\n    float: left;\n    margin-left: 0;\n    margin-right: 20px;\n  }\n  .gx-timeline-zigzag .gx-timeline-panel {\n    max-height: none;\n    min-height: 10px;\n    overflow-y: visible;\n  }\n  .gx-timeline-zigzag .gx-timeline-item {\n    padding-left: 100px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item + .gx-timeline-item {\n    margin-top: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:before {\n    transform: none;\n    top: 25px;\n    bottom: -25px;\n    left: 45px;\n  }\n  .gx-timeline-zigzag .gx-timeline-item:last-child:before {\n    bottom: 0;\n  }\n  .gx-timeline-zigzag .gx-timeline-inverted:before {\n    transform: none;\n  }\n  .gx-timeline-center .gx-timeline-time,\n  .gx-timeline-center .gx-timeline-inverted .gx-timeline-time {\n    position: relative;\n    top: auto;\n    left: auto;\n    right: auto;\n    margin-bottom: 6px;\n  }\n  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::before,\n  .gx-timeline-center .gx-timeline-time-item .gx-timeline-panel::after {\n    top: 10px;\n  }\n}\n@media screen and (max-width: 399px) {\n  .gx-timeline-left {\n    float: none;\n    margin-right: 0;\n  }\n  .gx-timeline-right {\n    float: none;\n    margin-left: 0;\n  }\n  .gx-timeline-inverted .gx-timeline-left {\n    float: none;\n    margin-right: 0;\n  }\n}\n/*Tabs Styles*/\n.gx-tabs-half .ant-tabs-bar {\n  margin-bottom: 0;\n}\n.gx-tabs-half .ant-tabs-nav {\n  display: block;\n}\n.gx-tabs-half .ant-tabs-nav .ant-tabs-tab {\n  margin: 0;\n  width: 50%;\n  text-align: center;\n}\n.gx-tabs-half .ant-tabs-nav .ant-tabs-ink-bar {\n  width: 50%;\n}\n.gx-card-tabs .ant-card-head-title {\n  text-transform: capitalize;\n  font-size: 16px;\n}\n.gx-card-tabs .ant-card-extra {\n  position: relative;\n  z-index: 2;\n}\n.gx-card-tabs .ant-tabs {\n  margin-top: -40px;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-tabs .ant-tabs {\n    margin-top: 0;\n  }\n}\n.gx-card-tabs .ant-tabs-tab {\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-right: 15px;\n}\n.gx-card-tabs .ant-tabs-tab-active {\n  font-weight: 400;\n}\n.gx-card-tabs .ant-tabs-nav-container {\n  font-size: 16px;\n  text-align: center;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-tabs .ant-tabs-nav-container {\n    text-align: left;\n  }\n}\n.gx-card-tabs .ant-card-body {\n  padding-top: 4px;\n}\n.gx-card-tabs-right .ant-tabs-nav-container {\n  text-align: right;\n}\n@media screen and (max-width: 575px) {\n  .gx-card-tabs-right .ant-tabs-nav-container {\n    text-align: left;\n  }\n}\n/* Apps Style */\n.gx-app-module {\n  position: relative;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: -32px -32px 0;\n  flex: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-app-module {\n    margin: -20px -15px 0;\n  }\n}\n.gx-container-wrap .gx-app-module {\n  margin: 0;\n  margin-bottom: 32px;\n}\n.gx-module-side {\n  position: relative;\n  z-index: 2;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 0 1 230px;\n  -ms-flex: 0 1 230px;\n  flex: 0 1 230px;\n  min-width: 230px;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side {\n    min-width: 260px;\n    background-color: #ffffff;\n  }\n}\n.gx-module-side-header {\n  padding: 10px;\n  min-height: 79px;\n  border-bottom: solid 1px #e8e8e8;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  background-color: #fbfbfb;\n  color: #545454;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side-header {\n    min-height: 72px;\n  }\n}\n.gx-module-logo {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  font-size: 20px;\n}\n.gx-module-logo i {\n  font-size: 28px;\n  line-height: 18px;\n}\n.gx-module-user-info,\n.gx-module-side-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-module-user-detail {\n  font-size: 12px;\n}\n.gx-module-add-task {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 24px;\n}\n.gx-module-add-task .ant-btn {\n  margin-bottom: 0;\n}\n.gx-module-nav {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-module-nav li {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-module-nav li .gx-link {\n  padding: 5px 29px;\n  color: #999999;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  text-decoration: none;\n}\n.gx-module-nav li .gx-link:hover,\n.gx-module-nav li .gx-link:focus {\n  color: #000000;\n}\n.gx-module-nav li .gx-link.active {\n  color: #2EB1EF;\n}\n.gx-module-nav li i {\n  margin-right: 16px;\n  font-size: 16px;\n}\n.gx-module-nav li span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.gx-module-nav li.gx-module-nav-label {\n  padding: 12px 29px;\n}\n.gx-module-box {\n  position: relative;\n  z-index: 2;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: calc(100% - 231px);\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box {\n    max-width: 100%;\n  }\n}\n.gx-module-box-header {\n  padding: 10px 26px;\n  min-height: 79px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  background-color: #ffffff;\n  border-bottom: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-header {\n    position: relative;\n    min-height: 58px;\n    padding: 5px 26px 5px 110px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-header .gx-drawer-btn {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 1;\n    border-right: solid 1px #e8e8e8;\n    height: 58px;\n    width: 98px;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    -webkit-align-items: center;\n    -ms-align-items: center;\n    align-items: center;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n    font-size: 22px;\n    text-align: center;\n  }\n}\n.gx-module-box-header-inner {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n}\n.gx-module-box-header-right {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-left: auto;\n}\n.gx-module-box-content {\n  background-color: #ffffff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-module-box-topbar {\n  padding: 8px 28px;\n  min-height: 65px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-module-box-topbar label.ant-checkbox-wrapper {\n  margin-right: 10px;\n}\n.gx-module-box-topbar .ant-dropdown-trigger {\n  cursor: pointer;\n  margin-right: 10px;\n}\n.gx-module-box-topbar .ant-dropdown-trigger .icon:before {\n  position: relative;\n  top: 3px;\n}\n.gx-module-box-topbar-todo {\n  padding-left: 28px;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-box-topbar {\n    min-height: 58px;\n    padding-left: 28px;\n    padding-right: 28px;\n  }\n}\n.gx-module-list-icon {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  padding-right: 10px;\n}\n.gx-module-list-icon .gx-bar-icon .gx-icon-menu:before {\n  top: 3px;\n  position: relative;\n}\n.gx-toolbar-separator {\n  border-left: solid 1px #e8e8e8;\n  height: 100%;\n  width: 1px;\n  margin: 0 12px;\n}\n.gx-module-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n.gx-module-list-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  padding: 15px 28px;\n  z-index: 5;\n  position: relative;\n  cursor: pointer;\n}\n.gx-module-list-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-module-list-item.gx-mail-cell {\n  -webkit-align-items: start;\n  -ms-align-items: start;\n  align-items: start;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-list-item {\n    padding-bottom: 10px;\n    padding-top: 10px;\n  }\n}\n.gx-module-detail-header {\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-module-detail-header {\n    margin-bottom: 0;\n  }\n}\n.gx-module-list-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: calc(100% - 140px);\n}\n@media screen and (max-width: 575px) {\n  .gx-module-list-info {\n    max-width: calc(100% - 100px);\n  }\n}\n.gx-module-todo-content {\n  position: relative;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-module-todo-content .gx-subject {\n  margin-bottom: 5px;\n}\n.gx-module-todo-right {\n  margin-left: 8px;\n}\n.gx-module-sidenav {\n  background-color: #ffffff;\n  border-right: solid 1px #e8e8e8;\n  position: relative;\n  z-index: 9;\n}\n.gx-module-sidenav .gx-chat-sidenav-main {\n  max-width: 300px;\n  min-width: 300px;\n  width: 90%;\n}\n.gx-module-date {\n  max-width: 160px;\n}\n.gx-module-detail-item {\n  padding: 10px 28px;\n}\n.gx-task-title {\n  font-size: 18px;\n}\n@media screen and (max-width: 991px) {\n  .gx-task-title {\n    font-size: 16px;\n  }\n}\n.gx-chat-todo-avatar {\n  margin-right: 15px;\n}\n.gx-module-side-scroll {\n  height: calc(100vh - 201px) !important;\n}\n.framed-layout .gx-module-side-scroll {\n  height: calc(100vh - 241px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-side-scroll {\n    height: calc(100vh - 72px) !important;\n  }\n  .framed-layout .gx-module-side-scroll {\n    height: calc(100vh - 72px) !important;\n  }\n}\n.gx-module-side-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-module-content-scroll {\n  height: calc(100vh - 266px) !important;\n}\n.framed-layout .gx-module-content-scroll {\n  height: calc(100vh - 306px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-module-content-scroll {\n    height: calc(100vh - 238px) !important;\n  }\n  .framed-layout .gx-module-content-scroll {\n    height: calc(100vh - 238px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-module-content-scroll {\n    height: calc(100vh - 216px) !important;\n  }\n}\n.gx-module-content-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-todo-detail-content-scroll {\n  height: calc(100vh - 319px) !important;\n}\n.framed-layout .gx-todo-detail-content-scroll {\n  height: calc(100vh - 359px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-todo-detail-content-scroll {\n    height: calc(100vh - 291px) !important;\n  }\n  .framed-layout .gx-todo-detail-content-scroll {\n    height: calc(100vh - 291px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-todo-detail-content-scroll {\n    height: calc(100vh - 270px) !important;\n  }\n}\n.gx-todo-detail-content-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-loader-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.gx-loader-view .ant-spin {\n  margin: 0;\n}\n.gx-app-module .gx-loader-view {\n  height: calc(100vh - 266px) !important;\n}\n.framed-layout .gx-app-module .gx-loader-view {\n  height: calc(100vh - 306px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-app-module .gx-loader-view {\n    height: calc(100vh - 238px) !important;\n  }\n  .framed-layout .gx-app-module .gx-loader-view {\n    height: calc(100vh - 238px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-app-module .gx-loader-view {\n    height: calc(100vh - 244px) !important;\n  }\n}\n.gx-chat-module .gx-loader-view {\n  height: calc(100vh - 122px) !important;\n}\n.framed-layout .gx-chat-module .gx-loader-view {\n  height: calc(100vh - 162px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-chat-module .gx-loader-view {\n    height: calc(100vh - 122px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-chat-module .gx-loader-view {\n    height: calc(100vh - 100px) !important;\n  }\n}\n.gx-module-default {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  height: 100%;\n  padding: 15px;\n}\n.gx-no-content-found {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  font-size: 16px;\n}\n.gx-task-des,\n.gx-task-input {\n  padding-left: 0;\n}\n/*Mails Apps Styles*/\n.gx-module-box-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.gx-module-box-column,\n.gx-module-list-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  width: 100%;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-mail-list-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding-left: 10px;\n  max-width: calc(100% - 150px);\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n@media screen and (max-width: 575px) {\n  .gx-mail-list-info {\n    max-width: 100%;\n    margin-top: 10px;\n    padding-left: 0;\n  }\n}\n.gx-mail-user-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-left: 10px;\n}\n.gx-mail-user-info .gx-avatar {\n  margin-right: 10px;\n}\n.gx-mail-user-info .gx-badge {\n  margin-bottom: 0;\n}\n.gx-mail-user-des {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-bottom: 3px;\n}\n.gx-mail-user-des .gx-time,\n.gx-mail-user-des .gx-icon-btn {\n  margin-left: auto;\n}\n.gx-mail-detail-inner {\n  padding: 24px;\n}\n@media screen and (max-width: 991px) {\n  .gx-mail-detail-inner {\n    padding-right: 28px;\n    padding-left: 28px;\n  }\n}\n.gx-mail-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media screen and (max-width: 498px) {\n  .gx-mail-header {\n    display: block;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-mail-header-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-mail-header-content .gx-subject {\n  margin-bottom: 5px;\n}\n.gx-show-link {\n  cursor: pointer;\n  margin-bottom: 8px;\n  color: #2EB1EF;\n}\n.gx-show-detail {\n  margin-bottom: 12px;\n}\n.gx-module-list-content .gx-subject {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gx-module-list-content .gx-message {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  color: #8d8d8d;\n  font-size: 13px;\n}\n.gx-module-list-content .gx-message p {\n  margin-bottom: 8px;\n}\n.gx-size {\n  margin: 5px 0;\n}\n.gx-sender-name {\n  margin-right: 0;\n  font-weight: 500;\n  font-size: 15px;\n}\n.gx-send-subject {\n  width: calc(100% - 220px);\n}\n@media screen and (max-width: 575px) {\n  .gx-send-subject {\n    width: calc(100% - 180px);\n    margin-right: 6px;\n  }\n}\n.gx-mail-header-actions {\n  -webkit-justify-content: flex-end;\n  -ms-justify-content: flex-end;\n  justify-content: flex-end;\n  min-width: 100px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-mail-header-actions .icon-btn:not(:last-child) {\n  margin-right: 3px;\n}\n@media screen and (max-width: 498px) {\n  .gx-mail-header-actions {\n    -webkit-justify-content: flex-start;\n    -ms-justify-content: flex-start;\n    justify-content: flex-start;\n    min-width: 10px;\n  }\n}\n.gx-attachment-block {\n  position: relative;\n}\n.gx-attachment-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -10px;\n}\n@media screen and (max-width: 575px) {\n  .gx-attachment-row {\n    margin: 0 -5px;\n  }\n}\n.gx-attachment-col {\n  padding: 0 10px;\n}\n.gx-attachment-col img {\n  width: 80px;\n}\n.gx-attachment-col .size {\n  padding-top: 5px;\n}\n@media screen and (max-width: 575px) {\n  .gx-attachment-col {\n    padding: 0 5px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-mail-list {\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    max-width: 100%;\n    border-right: 0 none;\n  }\n  .gx-mail-detail {\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n}\n/*Chat Apps Styles*/\n.gx-chat-module {\n  position: relative;\n}\n.gx-chat-module-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  background-color: #fafafa;\n  position: relative;\n  width: 100%;\n}\n.gx-chat-sidenav {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 0 1 315px;\n  -ms-flex: 0 1 315px;\n  flex: 0 1 315px;\n  min-width: 315px;\n  border-right: solid 1px #e8e8e8;\n}\n.gx-chat-sidenav-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding: 25px 20px 12px;\n  background-color: #fbfbfb;\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-chat-user-hd {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-bottom: 25px;\n}\n.gx-chat-search-wrapper {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-bottom: 0;\n}\n.gx-chat-avatar {\n  min-width: 50px;\n}\n.gx-chat-user-row .gx-chat-avatar {\n  padding: 0 5px;\n  min-width: 10px;\n}\n.gx-chat-user-hd .gx-chat-avatar {\n  cursor: pointer;\n}\n.gx-chat-sidenav-scroll {\n  height: calc(100vh - 295px) !important;\n}\n.framed-layout .gx-chat-sidenav-scroll {\n  height: calc(100vh - 335px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-sidenav-scroll {\n    height: calc(100vh - 175px) !important;\n  }\n  .framed-layout .gx-chat-sidenav-scroll {\n    height: calc(100vh - 175px) !important;\n  }\n}\n.gx-chat-sidenav-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-sidenav-scroll-tab-1,\n.gx-chat-sidenav-scroll-tab-2 {\n  height: calc(100vh - 320px) !important;\n}\n.framed-layout .gx-chat-sidenav-scroll-tab-1,\n.framed-layout .gx-chat-sidenav-scroll-tab-2 {\n  height: calc(100vh - 360px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-sidenav-scroll-tab-1,\n  .gx-chat-sidenav-scroll-tab-2 {\n    height: calc(100vh - 198px) !important;\n  }\n  .framed-layout .gx-chat-sidenav-scroll-tab-1,\n  .framed-layout .gx-chat-sidenav-scroll-tab-2 {\n    height: calc(100vh - 198px) !important;\n  }\n}\n.gx-chat-sidenav-scroll-tab-1 > div:first-child,\n.gx-chat-sidenav-scroll-tab-2 > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-list-scroll {\n  height: calc(100vh - 268px) !important;\n}\n.framed-layout .gx-chat-list-scroll {\n  height: calc(100vh - 308px) !important;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-list-scroll {\n    height: calc(100vh - 242px) !important;\n  }\n  .framed-layout .gx-chat-list-scroll {\n    height: calc(100vh - 282px) !important;\n  }\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-chat-list-scroll {\n    height: calc(100vh - 242px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-chat-list-scroll {\n    height: calc(100vh - 220px) !important;\n  }\n}\n.gx-chat-list-scroll > div:first-child {\n  overflow-y: scroll !important;\n}\n.gx-chat-sidenav-content {\n  background-color: #ffffff;\n}\n.gx-chat-sidenav-title {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #1890ff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-sidenav-title {\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-chat-sidenav-title {\n    font-size: 15px;\n  }\n}\n.gx-chat-tabs-header {\n  background-color: #fbfbfb !important;\n}\n.gx-chat-user {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-chat-user.gx-chat-user-center {\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-chat-user.gx-chat-user-center .gx-chat-avatar {\n  margin-left: auto;\n}\n.gx-chat-user-item {\n  padding: 16px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  cursor: pointer;\n  max-height: 96px;\n}\n.gx-chat-user-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-chat-user-item.active,\n.gx-chat-user-item:hover {\n  background-color: #f0fdff;\n}\n.gx-chat-user-row {\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-chat-info {\n  max-width: calc(100% - 80px);\n  padding: 0 5px;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-chat-info p {\n  margin-bottom: 0;\n}\n.gx-chat-info .h4 {\n  display: block;\n  margin-bottom: 3px;\n}\n.gx-chat-info-des {\n  color: #595959;\n  font-size: 13px;\n}\n.gx-chat-contact-col {\n  max-width: calc(100% - 50px);\n  padding: 0 5px;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-chat-contact-col p {\n  margin-bottom: 0;\n}\n.gx-chat-contact-col .h4 {\n  display: block;\n  margin-bottom: 3px;\n}\n.gx-chat-date {\n  padding: 0 5px;\n  text-align: right;\n}\n.gx-fs-80 {\n  font-size: 80px !important;\n  line-height: 80px !important;\n}\n.gx-comment-box .gx-fs-80 {\n  text-align: center;\n  margin-bottom: 12px;\n}\n@media screen and (max-width: 575px) {\n  .gx-fs-80 {\n    font-size: 60px !important;\n    line-height: 60px !important;\n  }\n}\n.gx-comment-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  height: calc(100vh - 122px) !important;\n}\n.framed-layout .gx-comment-box {\n  height: calc(100vh - 162px) !important;\n}\n@media screen and (max-width: 991px) {\n  .framed-layout .gx-comment-box {\n    height: calc(100vh - 122px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-comment-box {\n    height: calc(100vh - 100px) !important;\n  }\n}\n.gx-chat-box {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  max-width: 100%;\n  position: relative;\n  z-index: 2;\n}\n.gx-chat-main {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n.gx-chat-main-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  border-bottom: solid 1px #e8e8e8;\n  padding: 16px;\n  background-color: #ffffff;\n  width: 100%;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-main-header {\n    padding: 8px 16px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-main-header {\n    padding: 8px 30px;\n  }\n}\n.gx-chat-main-header-info {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-right: auto;\n}\n.gx-chat-contact-name {\n  font-size: 20px;\n  font-weight: 500;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-contact-name {\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-chat-contact-name {\n    font-size: 15px;\n  }\n}\n.gx-chat-main-footer {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  border-top: solid 1px #e8e8e8;\n  padding: 6px 16px;\n  background-color: #ffffff;\n  width: 100%;\n}\n.gx-chat-main-footer .gx-form-group {\n  margin-bottom: 0;\n}\n.gx-chat-item {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  padding: 16px;\n}\n@media screen and (max-width: 991px) {\n  .gx-chat-item {\n    padding: 16px 30px;\n  }\n}\n.gx-chat-item .gx-bubble-block {\n  width: calc(100% - 40px);\n}\n.gx-chat-item .gx-bubble {\n  padding: 12px 15px;\n  background-color: #ffffff;\n  -webkit-border-radius: 20px 20px 20px 0px;\n  -moz-border-radius: 20px 20px 20px 0px;\n  border-radius: 20px 20px 20px 0px;\n  position: relative;\n  margin-left: 16px;\n  max-width: 600px;\n  border: solid 1px #d9d9d9;\n  display: inline-block;\n}\n.gx-chat-item.gx-flex-row-reverse .gx-bubble-block {\n  text-align: right;\n}\n.gx-chat-item.gx-flex-row-reverse .gx-bubble {\n  margin-right: 16px;\n  margin-left: 0;\n  background-color: #f0fdff;\n  -webkit-border-radius: 20px 20px 0 20px;\n  -moz-border-radius: 20px 20px 0 20px;\n  border-radius: 20px 20px 0 20px;\n  text-align: left;\n}\n.gx-chat-item .ant-avatar {\n  display: block;\n}\n.gx-chat-btn {\n  font-size: 38px !important;\n  margin-right: 20px;\n}\ntextarea.gx-chat-textarea {\n  height: 40px;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-chat-sent {\n  min-width: 40px;\n  line-height: 40px;\n  font-size: 18px;\n  text-align: center;\n  cursor: pointer;\n}\n.gx-last-message-time {\n  font-size: 11px;\n  color: #8c8c8c;\n}\n@media screen and (max-width: 1199px) {\n  .gx-chat-main-header .gx-size-60 {\n    height: 50px !important;\n    width: 50px !important;\n    line-height: 50px;\n  }\n  .gx-chat-main-header button {\n    margin-bottom: 0;\n  }\n  .gx-chat-main-header-info .gx-status-pos {\n    max-width: 50px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-module-default h1 {\n    font-size: 17px;\n  }\n}\n/*Contact Apps Styles*/\n.gx-contact-item {\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 8px 28px;\n}\n.gx-contact-item:not(:last-child) {\n  border-bottom: solid 1px #e8e8e8;\n}\n.gx-dragndrop-item {\n  padding: 24px 16px;\n}\n.gx-dragndrop-item .gx-draggable-icon {\n  margin-left: -16px;\n}\n@media screen and (max-width: 575px) {\n  .gx-dragndrop-item {\n    padding-right: 5px;\n  }\n}\n.gx-contact-list-info {\n  padding-left: 10px;\n}\n.gx-contact-list-info .gx-email {\n  word-break: break-all;\n}\n.gx-contact-list-info .gx-toolbar-separator {\n  display: inline-block;\n}\n@media screen and (max-width: 575px) {\n  .gx-contact-list-info .gx-toolbar-separator {\n    display: none;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-contact-list-info {\n    padding-left: 0;\n    max-width: calc(100% - 50px);\n  }\n  .gx-contact-list-info .gx-job-title {\n    display: none;\n  }\n}\n.gx-module-contact-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-module-contact-right {\n  margin-left: 8px;\n}\n.gx-contact-name {\n  font-size: 15px;\n}\n.gx-draggable-icon {\n  cursor: all-scroll;\n  color: #8c8c8c;\n}\n.gx-draggable-icon:hover,\n.gx-draggable-icon:focus,\n.gx-draggable-icon:active {\n  cursor: all-scroll;\n  color: #262626;\n}\n.gx-module-side-nav {\n  padding: 20px 0;\n}\n.gx-modal-box-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-modal-box-row .gx-modal-box-avatar {\n  -webkit-order: 2;\n  -ms-order: 2;\n  order: 2;\n  margin-left: 16px;\n}\n.gx-modal-box-row .gx-modal-box-avatar .ant-avatar {\n  width: 120px;\n  height: 120px;\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row .gx-modal-box-avatar {\n    -webkit-order: 1;\n    -ms-order: 1;\n    order: 1;\n    margin-left: 0;\n    margin-bottom: 16px;\n    text-align: center;\n  }\n}\n.gx-modal-box-row .gx-modal-box-form-item {\n  -webkit-order: 1;\n  -ms-order: 1;\n  order: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row .gx-modal-box-form-item {\n    -webkit-order: 2;\n    -ms-order: 2;\n    order: 2;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-modal-box-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n}\n.gx-dragndrop-actions {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n/* Calendar Apps Style */\n.gx-rbc-calendar {\n  overflow: hidden;\n  padding-bottom: 32px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 575px) {\n  .gx-rbc-calendar {\n    margin-bottom: 20px;\n  }\n}\n.gx-rbc-calendar .rbc-calendar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  height: 100%;\n}\n.rbc-event {\n  background-color: #2EB1EF;\n}\n.rbc-event.rbc-selected {\n  background-color: #1c8dc9;\n}\n.rbc-slot-selection {\n  background-color: #abedff;\n}\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  color: #ffffff;\n  background-image: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  background-color: #82e0ff;\n  border-color: #2EB1EF;\n}\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus,\n.rbc-toolbar button:focus,\n.rbc-toolbar button:hover {\n  color: #ffffff;\n  background-color: #82e0ff;\n  border-color: #2EB1EF;\n}\n.rbc-month-row {\n  min-height: 100px;\n}\n.rbc-event {\n  min-height: 50px;\n}\n.rbc-btn-group button {\n  cursor: pointer;\n}\n@media screen and (max-width: 867px) {\n  .rbc-toolbar {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    -webkit-align-items: flex-start;\n    -ms-align-items: flex-start;\n    align-items: flex-start;\n  }\n  .rbc-toolbar .rbc-toolbar-label {\n    margin: 8px 0;\n  }\n}\n@media screen and (max-width: 467px) {\n  .rbc-toolbar {\n    font-size: 12px;\n  }\n  .rbc-toolbar button {\n    padding: 5px 10px;\n  }\n}\n/* Calendar Components Style */\n.gx-com-calendar .ant-fullcalendar-header .ant-select {\n  margin-left: 8px;\n  margin-bottom: 8px;\n}\n@media screen and (max-width: 349px) {\n  .gx-com-calendar {\n    margin: 0 -20px;\n  }\n}\n.gx-com-calendar-card {\n  border: solid 1px #e8e8e8;\n  max-width: 300px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n@media screen and (max-width: 349px) {\n  .gx-com-calendar-card .gx-com-calendar {\n    margin: 0;\n  }\n}\n.gx-profileon {\n  margin-bottom: 20px;\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.gx-profileon-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 20px;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.9)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n}\n.gx-profileon-content * {\n  color: #ffffff;\n}\n.gx-agents-list .gx-profileon-content {\n  padding: 10px;\n}\n.gx-profileon-thumb {\n  position: relative;\n}\n.gx-profileon-thumb > img {\n  width: 100%;\n}\n.gx-profileon-thumb-htctrcrop {\n  overflow: hidden;\n  padding-bottom: 80%;\n  position: relative;\n}\n.gx-profileon-thumb-htctrcrop > img {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  width: 100%;\n}\n.gx-profileon-title {\n  margin-bottom: 5px;\n}\n.gx-agents-list .gx-profileon {\n  margin-bottom: 0;\n}\n.gx-follower {\n  border-bottom: solid 1px #d9d9d9;\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n.gx-follower-list {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -5px;\n}\n.gx-profile-banner .gx-follower-list {\n  margin: 0 -20px;\n}\n.gx-follower-list li {\n  color: #8c8c8c;\n  font-size: 14px;\n  padding: 0 5px;\n  width: 33.33%;\n}\n.gx-profile-banner .gx-follower-list li {\n  color: #ffffff;\n  padding: 0 20px;\n  width: auto;\n}\n.gx-follower-list li:not(:first-child) {\n  border-left: solid 1px #d9d9d9;\n}\n.gx-profile-banner .gx-follower-list li:not(:first-child) {\n  border-left-color: #ffffff;\n}\n.gx-follower-title {\n  display: block;\n  color: #262626;\n  font-size: 14px;\n}\n.gx-profile-banner .gx-follower-title {\n  color: #ffffff;\n}\n.gx-wall-scroll {\n  height: calc(100vh - 154px) !important;\n}\n.framed-layout .gx-wall-scroll {\n  height: calc(100vh - 192px) !important;\n}\n@media screen and (max-width: 991px) {\n  .gx-wall-scroll {\n    height: calc(100vh - 124px) !important;\n  }\n  .framed-layout .gx-wall-scroll {\n    height: calc(100vh - 124px) !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-wall-scroll {\n    height: calc(100vh - 132px) !important;\n  }\n}\n.gx-wall-postlist {\n  padding: 5px;\n}\n.gx-entry-sec {\n  position: relative;\n  margin-bottom: 20px;\n}\n.ant-card .gx-entry-sec,\n.gx-card .gx-entry-sec {\n  margin-bottom: 0;\n}\n.gx-entry-title {\n  border-bottom: solid 1px #d9d9d9;\n  padding-bottom: 15px;\n  margin-bottom: 20px;\n  font-size: 16px;\n  position: relative;\n}\n.gx-entry-title:before {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  z-index: 1;\n  height: 3px;\n  width: 42px;\n  background-color: #2EB1EF;\n}\n.ant-card .gx-entry-title:before,\n.gx-card .gx-entry-title:before {\n  display: none;\n}\n.ant-card .gx-entry-title,\n.gx-card .gx-entry-title {\n  border-bottom: 0 none;\n  margin-bottom: 15px;\n  padding-bottom: 0;\n}\n.gx-fnd-list {\n  list-style: none;\n  padding-left: 0;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -5px 20px;\n}\n.gx-fnd-list li {\n  width: 33.33%;\n  padding: 0 5px;\n}\n@media (max-width: 399px) {\n  .gx-fnd-list li {\n    width: 50%;\n  }\n}\n.gx-user-fnd {\n  position: relative;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.gx-user-fnd > img {\n  width: 100%;\n}\n.gx-user-fnd-content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  padding: 10px;\n  background-color: rgba(0, 0, 0, 0.1);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(rgba(0, 0, 0, 0.95)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.95));\n  color: #ffffff;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-user-fnd-content h6 {\n  color: #ffffff;\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n  margin-bottom: 0;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gx-user-fnd-content .ant-badge {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 1;\n  margin: 0;\n  width: 10px;\n  height: 10px;\n  display: block;\n}\n.gx-user-fnd-content .ant-badge-status-dot {\n  width: 10px;\n  height: 10px;\n  display: block;\n  top: 0;\n  border: solid 1px #ffffff;\n}\n.gx-gallery-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0 -0.5px 15px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-gallery-list li {\n  padding: 0 0.5px;\n  margin-bottom: 1px;\n  width: 33.33%;\n}\n@media (max-width: 399px) {\n  .gx-gallery-list li {\n    width: 50%;\n  }\n}\n.gx-gallery-list li > img {\n  width: 100%;\n}\n.gx-gallery-thumb {\n  position: relative;\n  cursor: pointer;\n}\n.gx-gallery-thumb:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.01);\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.01)), to(rgba(0, 0, 0, 0.95)));\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.95));\n}\n.gx-gallery-thumb-content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  padding: 10px;\n  color: #ffffff;\n}\n.gx-gallery-thumb-content h6 {\n  color: #ffffff;\n  margin-bottom: 0;\n  font-size: 10px;\n}\n.gx-wall-user-info {\n  margin-bottom: 6px;\n}\n.gx-wall-user-title {\n  margin-bottom: 4px;\n}\n.gx-gallery-item {\n  position: relative;\n  margin-bottom: 15px;\n}\n.gx-gallery-item img {\n  width: 100%;\n  cursor: pointer;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.gx-gallery-item-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  color: #ffffff;\n}\n.gx-gallery-grid {\n  margin: 0 -5px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.gx-gallery-grid .gx-gallery-item {\n  padding: 0 5px;\n}\n.gx-gallery-grid .gx-gallery-item-content {\n  left: 5px;\n  right: 5px;\n}\n.gx-gallery-2 .gx-gallery-item,\n.gx-gallery-4 .gx-gallery-item,\n.gx-gallery-4-more .gx-gallery-item {\n  width: 50%;\n}\n.gx-gallery-3 .gx-gallery-item {\n  width: 33.33%;\n}\n.gx-wall-comment-box {\n  padding: 0 30px;\n}\n@media screen and (max-width: 1199px) {\n  .gx-wall-comment-box {\n    padding: 0 20px;\n  }\n}\n@media screen and (max-width: 1100px) {\n  .gx-wall-comment-box {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-wall-comment-box {\n    padding: 0 30px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-wall-comment-box {\n    padding-right: 0;\n    padding-left: 15px;\n  }\n}\n.gx-profile-banner {\n  padding: 32px;\n  padding-bottom: 88px;\n  margin: -32px;\n  margin-bottom: -58px;\n  background-color: #003366;\n  color: #ffffff;\n  position: relative;\n}\n@media screen and (max-width: 575px) {\n  .gx-profile-banner {\n    padding: 20px 15px;\n    padding-bottom: 83px;\n    margin: -20px -15px;\n    margin-bottom: -58px;\n  }\n}\n.gx-profile-banner:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.gx-profile-banner > div {\n  position: relative;\n  z-index: 2;\n}\n.gx-profile-banner-top {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  margin-bottom: 40px;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    margin-bottom: 25px;\n  }\n}\n.gx-profile-banner-top-left {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top-left {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    margin-bottom: 25px;\n  }\n}\n.gx-profile-banner-avatar {\n  margin-right: 1.5rem;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-avatar {\n    margin-bottom: 8px;\n    margin-right: 0;\n  }\n}\n.gx-profile-banner-top-right {\n  text-align: center;\n  margin-left: auto;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-top-right {\n    margin-left: 0;\n  }\n}\n.gx-profile-banner-bottom {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media (max-width: 575px) {\n  .gx-profile-banner-bottom {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .gx-profile-banner-bottom .gx-tab-list {\n    margin-bottom: 10px;\n  }\n}\n.gx-profile-banner h1,\n.gx-profile-banner h2,\n.gx-profile-banner h3,\n.gx-profile-banner h4,\n.gx-profile-banner h5,\n.gx-profile-banner h6,\n.gx-profile-banner .h1,\n.gx-profile-banner .h2,\n.gx-profile-banner .h3,\n.gx-profile-banner .h4,\n.gx-profile-banner .h5,\n.gx-profile-banner .h6 {\n  color: #ffffff;\n}\n.gx-profile-banner .gx-link {\n  color: #ffffff;\n}\n.gx-profile-banner .gx-link:hover,\n.gx-profile-banner .gx-link:focus {\n  color: #089265;\n}\n.gx-profile-content {\n  position: relative;\n  z-index: 2;\n}\n.gx-profile-setting {\n  margin-left: auto;\n}\n@media (max-width: 575px) {\n  .gx-profile-setting {\n    margin-left: 0;\n  }\n}\n@media (max-width: 575px) {\n  .gx-profile-content-right {\n    display: -webkit-flex !important;\n    display: -ms-flexbox !important;\n    display: -ms-flex !important;\n    display: flex !important;\n    -webkit-flex-direction: row !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n    -webkit-flex-wrap: wrap !important;\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n    -webkit-align-items: center !important;\n    -ms-align-items: center !important;\n    align-items: center !important;\n  }\n  .gx-profile-content-right .gx-text-truncate {\n    width: auto;\n    margin-left: auto;\n  }\n}\n.gx-pro-contact-list:not(:last-child) {\n  margin-bottom: 1rem;\n}\n/*Callout Styles*/\n/*Different size images set in Equal block height and width*/\n.gx-thumb-equal,\n.gx-grid-thumb-equal {\n  position: relative;\n  padding-bottom: 68%;\n  height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n.gx-thumb-cover,\n.gx-grid-thumb-cover {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.gx-thumb-cover-img,\n.gx-grid-thumb-cover img {\n  height: auto;\n  max-width: 100%;\n  min-height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n.gx-product-image .gx-grid-thumb-equal {\n  padding-bottom: 82%;\n}\n/*Product listing page styles*/\n.gx-product-row {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  text-align: right;\n}\n.gx-product-row.even {\n  text-align: left;\n}\n.gx-product-col {\n  order: 1;\n  width: 50%;\n}\n.odd .gx-product-thumb {\n  order: 2;\n}\n.gx-product-content {\n  padding: 20px 55px;\n}\n.gx-product-content p {\n  margin-bottom: 10px;\n}\n.gx-product-row .gx-grid-thumb-equal {\n  padding-bottom: 69%;\n}\n.gx-product-thumb img {\n  width: 100%;\n}\n.gx-product-content h4 {\n  margin-bottom: 25px;\n}\n@media screen and (max-width: 1230px) {\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 71%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    text-align: center;\n  }\n  .gx-product-row.even {\n    text-align: center;\n  }\n  .gx-product-content h4 {\n    margin-bottom: 10px;\n  }\n  .gx-product-content {\n    padding: 20px 35px;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 100%;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 40%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    text-align: right;\n  }\n  .gx-product-row.even {\n    text-align: left;\n  }\n  .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 120%;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 50%;\n  }\n  .odd .gx-product-thumb {\n    order: 2;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 70%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: -ms-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    text-align: center;\n  }\n  .gx-product-row.even {\n    text-align: center;\n  }\n  .gx-product-row:last-child .gx-product-col {\n    padding-bottom: 0;\n  }\n  .gx-product-row:last-child .ant-btn {\n    margin-bottom: 0;\n  }\n  .gx-product-content {\n    padding: 20px 0;\n  }\n  .gx-product-col,\n  .odd .gx-product-thumb {\n    order: 1;\n    width: 100%;\n  }\n  .gx-product-row .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n  .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n}\n/*E-commerce Styles*/\n.gx-product-item {\n  overflow: hidden;\n  background: #fff;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n@media screen and (max-width: 575px) {\n  .gx-product-item {\n    margin-bottom: 20px;\n  }\n}\n.gx-product-body {\n  padding: 24px;\n}\n.gx-product-body + .gx-product-footer {\n  padding-top: 0;\n}\n.gx-product-body :last-child {\n  margin-bottom: 0;\n}\n.gx-product-image > img {\n  width: 100%;\n}\n.gx-product-footer {\n  padding: 24px;\n  padding-bottom: 15px;\n}\n.gx-product-horizontal {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-product-horizontal .gx-product-image {\n  width: 25%;\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 33.33333%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 25%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-image {\n    width: 100%;\n  }\n}\n.gx-product-horizontal .gx-product-body {\n  width: 53%;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 55%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 41.66667%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 50%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-body {\n    width: 100%;\n  }\n}\n.gx-product-horizontal .gx-product-body + .gx-product-footer {\n  padding-top: 24px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-body + .gx-product-footer {\n    padding-top: 0;\n  }\n}\n.gx-product-horizontal .gx-product-footer {\n  width: 22%;\n  text-align: center;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-footer {\n    width: 20%;\n  }\n}\n.gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-footer .ant-btn:not(:last-child) {\n    margin-left: 0;\n  }\n}\n.gx-product-horizontal .gx-product-footer .ant-btn:last-child {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-footer {\n    width: 100%;\n    text-align: left;\n  }\n}\n.gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n  padding-bottom: 82%;\n}\n@media screen and (min-width: 1400px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 55%;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 80%;\n  }\n}\n@media screen and (max-width: 1080px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 90%;\n  }\n}\n@media screen and (max-width: 1000px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 110%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 80%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 88%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 128%;\n  }\n}\n@media screen and (max-width: 849px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 110%;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n  .horizontal-layout .gx-product-horizontal .gx-product-image .gx-grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n}\n.gx-product-vertical {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  height: calc(100% - 32px);\n}\n@media screen and (max-width: 575px) {\n  .gx-product-vertical {\n    height: calc(100% - 20px);\n  }\n}\n.gx-product-vertical .gx-product-body {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-product-title {\n  font-size: 20px;\n}\n/*Pricing Tables Styles*/\n.gx-price-tables {\n  position: relative;\n}\n.gx-package {\n  position: relative;\n  margin-bottom: 15px;\n  overflow: hidden;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  -ms-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  height: calc(100% - 15px);\n  -webkit-transform: scale(0.95);\n  -moz-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  transform: scale(0.95);\n}\n.gx-package:hover,\n.gx-package:focus,\n.gx-package:active {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.55);\n}\n.gx-pt-dark .gx-package:hover,\n.gx-pt-dark .gx-package:focus,\n.gx-pt-dark .gx-package:active {\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n.gx-pt-classic .gx-package {\n  border: 0 none;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.gx-package.gx-highlight {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  z-index: 2;\n}\n.gx-package-header {\n  padding: 30px;\n  text-align: center;\n}\n.gx-package-header > .gx-price {\n  display: inline-block;\n  font-size: 36px;\n  font-weight: 500;\n  margin-left: 0;\n  margin-bottom: 12px;\n  color: #ffffff;\n}\n.gx-package-header > .gx-price > i {\n  display: inline-block;\n  margin-right: 6px;\n  font-weight: bold;\n}\n.gx-package-header h5 {\n  color: inherit;\n}\n.gx-package-header.gx-text-black > .gx-price {\n  color: #595959 !important;\n}\n@media only screen and (max-width: 991px) {\n  .gx-package-header {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.gx-package-body {\n  padding: 50px 30px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n@media only screen and (max-width: 991px) {\n  .gx-package-body {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.gx-package-items {\n  list-style: none;\n  font-size: 14px;\n  margin: 0 0 20px;\n  padding-left: 0;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-package-items li {\n  margin-bottom: 16px;\n  zoom: 1;\n  line-height: inherit;\n}\n.gx-package-items li::before,\n.gx-package-items li::after {\n  display: table;\n  content: '';\n}\n.gx-package-items li::after {\n  clear: both;\n}\n.gx-package-items li::before,\n.gx-package-items li::after {\n  display: table;\n  content: '';\n}\n.gx-package-items li::after {\n  clear: both;\n}\n.gx-package-items li i {\n  float: left;\n  min-width: 20px;\n  margin-right: 16px;\n  line-height: inherit;\n}\n.gx-package-items li span {\n  display: block;\n  overflow: hidden;\n}\n.gx-package-footer {\n  padding-top: 30px;\n}\n.gx-package-footer .ant-btn {\n  text-transform: capitalize;\n  border: 0 none;\n  margin-bottom: 0;\n}\n@media only screen and (max-width: 767px) {\n  .gx-package:hover,\n  .gx-package:focus,\n  .gx-package:active,\n  .gx-package.gx-highlight {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.gx-text-black .gx-text-white {\n  color: #595959 !important;\n}\n.gx-pt-circle .gx-package-header {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  height: 224px;\n  width: 224px;\n  margin: 40px auto 0;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-pt-circle .gx-package-header .gx-price {\n  margin-top: 30px;\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header .gx-price {\n    font-size: 26px;\n    margin-top: 12px;\n    margin-bottom: 6px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header .gx-letter-spacing-base {\n    letter-spacing: 1px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .gx-pt-circle .gx-package-header {\n    height: 150px;\n    width: 150px;\n  }\n}\n/*Login & Auth flow Styles*/\n.login-container,\n.auth-layout-container {\n  background-color: #EDF5F7;\n  height: 100%;\n}\n.dark-theme .login-container,\n.dark-theme .auth-layout-container {\n  background-color: #051B30;\n}\n.auth-layout-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gx-app-login-wrap {\n  height: 100%;\n  display: flex;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  gap: 15px;\n}\n@media screen and (min-width: 1700px) {\n  .gx-app-login-wrap {\n    max-width: 1600px;\n    margin: 0 auto;\n  }\n}\n@media screen and (max-width: 768px) {\n  .gx-app-login-wrap {\n    flex-direction: column;\n    height: auto;\n  }\n}\n.gx-app-graphic-content {\n  flex: 1;\n}\n@media screen and (max-width: 768px) {\n  .gx-app-graphic-content {\n    max-width: 325px;\n  }\n}\n.gx-app-login-content {\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  gap: 40px;\n}\n.gx-app-login-content .ant-form {\n  width: 400px;\n  padding: 0 15px;\n}\n.gx-app-login-content .ant-form-item-label {\n  line-height: 32px;\n  width: 100%;\n  text-align: left;\n}\n.gx-app-login-content .ant-form-item-label label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n}\n@media screen and (min-width: 1700px) {\n  .gx-app-login-content .ant-form-item-label label {\n    font-size: 18px;\n  }\n}\n.gx-app-login-content .ant-form-item-label label a {\n  color: #9BA4AC;\n  font-size: 14px;\n}\n@media screen and (min-width: 1700px) {\n  .gx-app-login-content .ant-form-item-label label a {\n    font-size: 16px;\n  }\n}\n.gx-app-login-content .ant-form-item-label label:before,\n.gx-app-login-content .ant-form-item-label label:after {\n  display: none;\n}\n.gx-app-login-content .ant-input {\n  min-height: 40px;\n  background-color: transparent;\n}\n@media screen and (min-width: 1600px) {\n  .gx-app-login-content .ant-input {\n    min-height: 50px;\n    font-size: 16px;\n  }\n}\n.gx-app-login-content .ant-input:focus {\n  box-shadow: none;\n}\n.gx-app-login-content .gx-btn {\n  height: auto;\n}\n.gx-app-login-content .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.gx-app-login-content .ant-form-item-control-wrapper .ant-btn-primary {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 0px 10px;\n}\n@media screen and (min-width: 1600px) {\n  .gx-app-login-content .ant-form-item-control-wrapper .ant-btn-primary {\n    font-size: 16px;\n  }\n}\n.gx-app-login-content .ant-form-item-children {\n  display: block;\n}\n.gx-app-login-content .copy {\n  color: #9BA4AC;\n  margin-bottom: 0px;\n}\n.gx-app-login-content p {\n  color: #595959;\n}\n.authenticator-heading {\n  font-size: 23px;\n  color: #051B30;\n  margin: 0;\n}\n.dark-theme .authenticator-heading {\n  color: #ffffff;\n}\n.verify-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n}\n.verify-container .ant-btn-primary {\n  max-width: 440px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.verify-container .verify-container-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-width: 425px;\n  max-width: 440px;\n  min-height: 275px;\n  padding: 25px 20px;\n  background: #ffffff;\n  color: white;\n  gap: 15px;\n  border-radius: 16px;\n  margin-bottom: 50px;\n}\n.dark-theme .verify-container .verify-container-block {\n  background: #0B2B41;\n}\n.verify-container .verify-container-block .authenticator-qr {\n  max-width: 200px;\n}\n@media screen and (min-width: 1700px) {\n  .verify-container .verify-container-block .authenticator-qr {\n    max-width: 250px;\n  }\n}\n.verify-container .verify-container-block .label-otp {\n  font-weight: 500;\n  font-size: 18px;\n  color: #606E7B;\n}\n.dark-theme .verify-container .verify-container-block .label-otp {\n  color: #ffffff;\n}\n.verify-container .verify-container-block.forgot-password {\n  padding: 15px 20px;\n}\n.verify-container .verify-container-block.forgot-password .ant-form-item {\n  margin-bottom: 10px;\n}\n.verify-container .verify-container-block .ant-select .ant-select-selection {\n  height: 42px;\n}\n.verify-container .verify-container-block .ant-select .ant-select-selection .ant-select-selection__rendered {\n  line-height: 42px;\n}\n.verify-container .verify-container-block p {\n  color: #606E7B;\n}\n.dark-theme .verify-container .verify-container-block p {\n  color: #ffffff;\n}\n.verify-container .clarity-submit-button {\n  margin-top: 40px;\n  padding-left: 30px;\n  padding-right: 30px;\n  color: #051B30;\n  font-weight: 500;\n}\n.dark-theme .verify-container .clarity-submit-button {\n  color: #ffffff;\n}\n@media screen and (min-width: 1700px) {\n  .verify-container .clarity-submit-button {\n    margin-top: 80px;\n  }\n}\n.user-role-card {\n  min-height: 290px;\n  min-width: 280px;\n  background-color: #ffffff !important;\n  color: #FFFFFF;\n  border-radius: 10px;\n  margin: 0;\n  border: 0.5px solid #D8DFE5;\n}\n.dark-theme .user-role-card {\n  background-color: #0B2B41 !important;\n  border: 0.5px solid #0B2B41;\n}\n.user-role-card svg path {\n  fill: #BDBDBD;\n  stroke: #BDBDBD;\n}\n.dark-theme .user-role-card svg path {\n  fill: #214A66;\n  stroke: #214A66;\n}\n.user-role-card svg.receptionist path {\n  fill: #BDBDBD;\n  stroke: #BDBDBD;\n}\n.dark-theme .user-role-card svg.receptionist path {\n  fill: #214A66;\n  stroke: #214A66;\n}\n.role-sub-container {\n  min-height: 240px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.user-card-title {\n  font-weight: 500;\n  font-size: 22px;\n  margin: 0;\n  color: #051B30;\n}\n.dark-theme .user-card-title {\n  color: #ffffff;\n}\n.user-role-card.selected,\n.user-role-card:hover {\n  border-color: #0590DE;\n}\n.dark-theme .user-role-card.selected,\n.dark-theme .user-role-card:hover {\n  border-color: #46baf1;\n}\n.user-role-card.selected .role-sub-container svg path,\n.user-role-card:hover .role-sub-container svg path {\n  fill: #0590DE;\n  stroke: #0590DE;\n}\n.dark-theme .user-role-card.selected .role-sub-container svg path,\n.dark-theme .user-role-card:hover .role-sub-container svg path {\n  fill: #DCDCDC;\n  stroke: #DCDCDC;\n}\n.dark-theme .gx-app-login-content .ant-input {\n  background-color: transparent;\n  border-color: #20313e;\n}\n.dark-theme .gx-app-login-content .ant-input:hover,\n.dark-theme .gx-app-login-content .ant-input:focus {\n  border-color: #2b4d66 !important;\n}\n.dark-theme .gx-app-login-content .ant-form-item-label label {\n  color: #ffffff;\n}\n.dark-theme .ant-checkbox-wrapper {\n  color: #9BA4AC;\n}\n.dark-theme .gx-signin-form .ant-checkbox-inner {\n  background-color: transparent;\n  border: 1px solid #0590DE;\n}\n.dark-theme .gx-signin-form .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: transparent;\n  border: 1px solid #0590DE;\n}\n.gx-app-social-block {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n}\n.gx-app-social-block .gx-social-link,\n.gx-app-social-block .gx-social-link li {\n  margin: 0;\n}\n.gx-app-social-block .gx-social-link span {\n  border: solid 1px #2EB1EF;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  color: #2EB1EF;\n}\n.gx-app-social-block .gx-social-link span:hover,\n.gx-app-social-block .gx-social-link span:focus {\n  color: #ffffff;\n  background-color: #2EB1EF;\n}\n.gx-app-social-block p {\n  margin-bottom: 0;\n}\n/*Dashboard Styles*/\n.dashboard-container {\n  padding: 16px;\n  color: #fff;\n}\n.dashboard-container .ant-card-head {\n  color: #14293C;\n}\n.dashboard-header {\n  margin-bottom: 16px;\n}\n.dashboard-header .dashboard-header-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.stats-row .stat-card,\n.stats-row .stat-card .ant-card-body {\n  color: #14293C;\n  border: none;\n  padding: 8px;\n}\n.stat-card h2 {\n  font-size: 45px;\n  margin: 0;\n}\n.dark-theme .stat-card h2 {\n  color: #081C26;\n}\n.stat-card p {\n  font-size: 14px;\n  margin: 4px 0;\n}\n@media screen and (min-width: 1600px) {\n  .stat-card p {\n    font-size: 18px;\n    font-weight: 500;\n  }\n}\n.stat-card span.gx-out-of-count {\n  font-size: 11px;\n  margin: 5px -16px -16px;\n  display: block;\n  background: #DAE3E7;\n  padding: 12px 8px;\n  font-weight: 500;\n  color: #051B30;\n  min-height: 43px;\n  display: flex;\n  align-items: center;\n}\n@media screen and (min-width: 1600px) {\n  .stat-card span.gx-out-of-count {\n    font-size: 14px;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .stat-card span.gx-out-of-count.appointments {\n    font-size: 13px;\n    padding: 8px 6px;\n    line-height: 1.2;\n  }\n}\n.dark-theme .stat-card span.gx-out-of-count {\n  background: #14293C;\n  color: #ffffff;\n  font-weight: 400;\n}\n.ant-card.todays-stats.ant-card-bordered {\n  border: none;\n  margin-bottom: 20px;\n  background: transparent;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-head {\n  border: none;\n  min-height: 40px;\n  line-height: 1;\n  padding: 0 5px;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-head .ant-card-head-title {\n  font-weight: 500;\n}\n.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-head .ant-card-head-title {\n  font-weight: 400;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body {\n  padding: 10px 20px;\n  max-height: 450px;\n  overflow-y: auto;\n  background-color: #ffffff;\n}\n.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-body {\n  background-color: #14283C;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item {\n  border-bottom: none;\n}\n@media screen and (min-width: 1600px) {\n  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item {\n    font-size: 15px;\n  }\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item strong {\n  font-size: 14px;\n  margin: 6px 0;\n  display: block;\n}\n@media screen and (min-width: 1600px) {\n  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item strong {\n    font-size: 17px;\n  }\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item .short-inf {\n  font-size: 11px;\n  font-weight: 400;\n}\n@media screen and (min-width: 1600px) {\n  .ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item .short-inf {\n    font-size: 13px;\n  }\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item svg path {\n  fill: #89939d;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-body .ant-list-split li.ant-list-item svg path {\n  fill: #999;\n}\n.ant-card.todays-stats.ant-card-bordered a {\n  color: #37A2B7;\n  font-weight: 600;\n}\n.ant-card.todays-stats.ant-card-bordered .ant-card-head {\n  overflow: visible;\n}\n.appointments-overview-extra {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 18px;\n  line-height: 1;\n  margin-top: -36px;\n  padding-bottom: 4px;\n}\n.appointments-overview-extra .appointments-overview-refresh {\n  color: #37a2b7;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  line-height: 1;\n}\n.appointments-overview-extra .appointments-overview-refresh:hover {\n  color: #4db5ca;\n}\n.ant-card.todays-stats .ant-list {\n  color: #051B30;\n  font-weight: 500;\n}\n.dark-theme .ant-card.todays-stats .ant-list {\n  color: #E9F6FF;\n}\n.ant-card.todays-stats .ant-list .ant-list-item .appId {\n  color: #717171;\n}\n.dark-theme .ant-card.todays-stats .ant-list .ant-list-item .appId {\n  color: #D9D9D9;\n}\n.ant-card.todays-stats .ant-list .ant-list-item p {\n  color: #8a8a8a;\n  font-size: 12px;\n}\n.dark-theme .ant-card.todays-stats .ant-list .ant-list-item p {\n  color: #BDBDBD;\n}\n@media screen and (min-width: 1600px) {\n  .ant-card.todays-stats .ant-list .ant-list-item p {\n    font-size: 14px;\n  }\n}\n.appId {\n  color: #8a8a8a;\n}\n.dark-theme .appId {\n  color: #BDBDBD;\n}\n.unreported-card {\n  border: none;\n  margin-bottom: 0px;\n  border-radius: 4px;\n}\n.unreported-card .ant-card-body {\n  padding: 16px;\n  gap: 8px;\n  display: flex;\n  max-height: 350px;\n  overflow-y: auto;\n  justify-content: space-between;\n  font-weight: 500;\n}\n.dark-theme .unreported-card .ant-card-body {\n  font-weight: 300;\n}\n.unreported-card .ant-card-body div strong {\n  margin: 5px 0;\n  display: block;\n  color: #051B30;\n  font-weight: 600;\n}\n.unreported-card .ant-card-body div p {\n  font-size: 13px;\n  margin: 0px;\n  font-weight: 600;\n}\n.dark-theme .unreported-card .ant-card-body div p {\n  font-weight: 500;\n}\n.unreported-card .ant-card-body:before,\n.unreported-card .ant-card-body:after {\n  display: none;\n}\n.unreported-card .ant-card-body span.ant-tag,\n.ant-card.todays-stats .ant-tag {\n  margin: 0px;\n  background-color: transparent;\n  border: transparent;\n  font-weight: 600;\n}\n@media screen and (min-width: 1600px) {\n  .unreported-card .ant-card-body span.ant-tag,\n  .ant-card.todays-stats .ant-tag {\n    font-size: 14px;\n  }\n}\n.unreported-card-container > .ant-row {\n  overflow-x: auto;\n  max-width: 100%;\n  flex-wrap: nowrap;\n  padding-bottom: 10px;\n}\n.unreported-card-container > .ant-row::-webkit-scrollbar {\n  height: 7px !important;\n  width: 4px !important;\n}\n.unreported-card-container > .ant-row::-webkit-scrollbar-thumb:horizontal {\n  /* This is the EXACT color of Mac OS scrollbars.\n     Yes, I pulled out digital color meter */\n  -webkit-border-radius: 100px;\n}\n.unreported-card-container > .ant-row::-webkit-scrollbar-thumb:horizontal:active {\n  -webkit-border-radius: 100px;\n}\n.dark-theme .dashboard-container {\n  background-color: #071b2c;\n}\n.dark-theme .dashboard-container .ant-select-selection {\n  border-color: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .stats-row .stat-card .ant-card-body {\n  padding: 8px;\n}\n.dark-theme .ant-card.todays-stats.ant-card-bordered .ant-card-head {\n  background: #051B30;\n}\n.dark-theme .unreported-card {\n  background-color: #14283C;\n  color: #ffffff;\n}\n.dark-theme .unreported-card .ant-card-body div strong {\n  color: #E9F6FF;\n}\n/*Algolia Styles*/\n.gx-algolia-sidebar {\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  width: 280px !important;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-sidebar {\n    width: 100% !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-algolia-sidebar {\n    margin-bottom: 20px;\n  }\n}\n.gx-algolia-sidebar [class^=\"ais-\"] {\n  font-size: 14px;\n}\n.gx-algolia-sidebar-content {\n  padding: 24px;\n}\n.gx-algolia-sidebar .ais-ClearRefinements {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a {\n  color: #545454;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {\n  color: #2EB1EF;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-count {\n  padding: 0 5px;\n  font-size: 12px;\n  color: #8c8c8c;\n  background-color: transparent;\n  border-radius: 0;\n}\n.gx-algolia-sidebar .ais-Panel {\n  margin-bottom: 20px;\n}\n.gx-algolia-sidebar .ais-Panel-header {\n  margin-bottom: 8px;\n  padding-bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-bottom: 0 none;\n}\n.gx-algolia-sidebar .ais-RefinementList-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-sidebar .ais-RefinementList-checkbox {\n  margin-right: 12px;\n}\n.gx-algolia-sidebar .ais-RefinementList-labelText {\n  font-size: 14px;\n}\n.gx-algolia-sidebar .ais-RefinementList-count {\n  padding: 0 5px;\n  font-size: 14px;\n  color: #8c8c8c;\n  background-color: transparent;\n  border-radius: 0;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected {\n  font-weight: normal;\n}\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Breadcrumb-item--selected > a,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-HierarchicalMenu-item--selected > a,\n.gx-algolia-sidebar .ais-HierarchicalMenu-list .ais-Menu-item--selected > a {\n  color: #2EB1EF;\n}\n.gx-algolia-sidebar .ais-RatingMenu-item--selected {\n  font-weight: 600;\n}\n.gx-algolia-layout-has-sider {\n  flex-wrap: nowrap;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-layout-has-sider {\n    flex-wrap: wrap;\n  }\n}\n.gx-algolia-category-title {\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: #8c8c8c;\n}\n.gx-algolia-main {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  width: 100%;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding-left: 30px;\n  margin-bottom: 32px;\n}\n.gx-algolia-main [class^=\"ais-\"] {\n  font-size: 14px;\n}\n@media screen and (max-width: 767px) {\n  .gx-algolia-main {\n    padding-left: 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-algolia-main {\n    margin-bottom: 20px;\n  }\n}\n.gx-algolia-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n.gx-algolia-sort-by {\n  margin-left: auto;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n.gx-algolia-sort-by label {\n  margin-right: 15px;\n}\n@media screen and (max-width: 400px) {\n  .gx-algolia-sort-by {\n    margin-left: 0;\n  }\n}\n.gx-algolia-footer {\n  padding: 10px;\n}\n.gx-algolia-footer .ais-Pagination-list {\n  flex-wrap: wrap;\n}\n.gx-algolia-footer .ais-Pagination-list li {\n  margin-bottom: 5px;\n}\n.gx-algolia-content .ais-Stats {\n  margin-bottom: 10px;\n}\n.gx-product-name [class^=\"ais-\"] {\n  font-size: 16px;\n}\n.gx-algolia-refinementList {\n  width: 100%;\n}\n.gx-algolia-refinementList li.ais-RefinementList-item {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ais-RangeInput-submit,\n.ais-ClearRefinements-button,\n.ais-CurrentRefinements-reset,\n.ais-GeoSearch-redo,\n.ais-GeoSearch-reset,\n.ais-HierarchicalMenu-showMore,\n.ais-InfiniteHits-loadMore,\n.ais-InfiniteResults-loadMore,\n.ais-Menu-showMore,\n.ais-RefinementList-showMore {\n  background-color: #2EB1EF;\n}\n.ais-RangeInput-submit:focus,\n.ais-ClearRefinements-button:focus,\n.ais-CurrentRefinements-reset:focus,\n.ais-GeoSearch-redo:focus,\n.ais-GeoSearch-reset:focus,\n.ais-HierarchicalMenu-showMore:focus,\n.ais-InfiniteHits-loadMore:focus,\n.ais-InfiniteResults-loadMore:focus,\n.ais-Menu-showMore:focus,\n.ais-RefinementList-showMore:focus,\n.ais-RangeInput-submit:hover,\n.ais-ClearRefinements-button:hover,\n.ais-CurrentRefinements-reset:hover,\n.ais-GeoSearch-redo:hover,\n.ais-GeoSearch-reset:hover,\n.ais-HierarchicalMenu-showMore:hover,\n.ais-InfiniteHits-loadMore:hover,\n.ais-InfiniteResults-loadMore:hover,\n.ais-Menu-showMore:hover,\n.ais-RefinementList-showMore:hover {\n  background-color: #2EB1EF;\n}\n.ais-Breadcrumb-link,\n.ais-HierarchicalMenu-link,\n.ais-Menu-link,\n.ais-Pagination-link,\n.ais-RatingMenu-link {\n  color: #2EB1EF;\n}\n.ais-Breadcrumb-link:focus,\n.ais-HierarchicalMenu-link:focus,\n.ais-Menu-link:focus,\n.ais-Pagination-link:focus,\n.ais-RatingMenu-link:focus,\n.ais-Breadcrumb-link:hover,\n.ais-HierarchicalMenu-link:hover,\n.ais-Menu-link:hover,\n.ais-Pagination-link:hover,\n.ais-RatingMenu-link:hover {\n  color: #2EB1EF;\n}\n.ais-Pagination-item--selected .ais-Pagination-link {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n/*Error Styles*/\n.gx-page-error-container {\n  position: relative;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: -ms-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.gx-page-error-content {\n  margin: 0 auto;\n  width: 380px;\n  max-width: 94%;\n}\n.gx-page-error-content h2 {\n  margin-bottom: 50px;\n}\n@media screen and (max-width: 767px) {\n  .gx-page-error-content h2 {\n    margin-bottom: 20px;\n  }\n}\n.gx-error-code {\n  color: #595959;\n  font-size: 160px;\n  text-align: center;\n  line-height: 1;\n  font-weight: 500;\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\n}\n@media screen and (max-width: 991px) {\n  .gx-error-code {\n    font-size: 130px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gx-error-code {\n    font-size: 100px;\n  }\n}\n@media screen and (max-width: 575px) {\n  .gx-error-code {\n    font-size: 80px;\n  }\n}\n/*Editor Styles*/\n.rdw-editor-toolbar .rdw-inline-wrapper {\n  flex-wrap: wrap;\n}\n@media screen and (max-width: 399px) {\n  .rdw-editor-toolbar .rdw-inline-wrapper .rdw-option-wrapper {\n    margin-bottom: 8px;\n  }\n}\n/*Testimonial Styles*/\n.gx-testimonial {\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 575px) {\n  .gx-testimonial {\n    margin-bottom: 20px;\n  }\n}\n.gx-classic-testimonial .ant-avatar {\n  margin: 0 auto;\n  margin-bottom: 30px;\n  width: 120px;\n  height: 120px;\n}\n.gx-classic-testimonial .ant-avatar img {\n  width: 100%;\n  height: 100%;\n}\n@media screen and (max-width: 575px) {\n  .gx-classic-testimonial .ant-avatar {\n    width: 80px;\n    height: 80px;\n    margin-bottom: 15px;\n  }\n}\n.gx-testimonial-bg {\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 30px;\n  overflow: hidden;\n  position: relative;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n@media screen and (max-width: 575px) {\n  .gx-testimonial-bg {\n    padding: 16px;\n  }\n}\n.gx-testimonial-bg .ant-avatar {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  overflow: hidden;\n  border: 4px solid #2EB1EF;\n}\n.gx-testimonial-bg .ant-avatar img {\n  width: 100%;\n  height: 100%;\n}\n@media screen and (max-width: 450px) {\n  .gx-testimonial-bg .ant-avatar {\n    width: 50px;\n    height: 50px;\n  }\n}\n.gx-testimonial-bg .gx-description {\n  color: #d9d9d9;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 25px;\n  margin-bottom: 15px;\n}\n.gx-testimonial-bg .gx-title {\n  color: #2EB1EF;\n  margin-bottom: 2px;\n}\n.gx-testimonial-des {\n  position: relative;\n  padding-left: 30px;\n}\n.gx-testimonial-des:before {\n  font-family: \"gaxon\";\n  font-size: 20px;\n  content: \"\\e066\";\n  color: #ffffff;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n@media screen and (max-width: 475px) {\n  .gx-standard .gx-media {\n    flex-direction: column;\n  }\n}\n/*Base Styles*/\nbody.dark-theme.framed-layout,\nbody.dark-theme.boxed-layout {\n  background-color: #000102;\n}\n.ant-drawer-header {\n  padding: 5px;\n  background: transparent;\n  border: none;\n  margin-bottom: 7px;\n}\n.ant-drawer-close {\n  padding: 0;\n  margin: 0;\n  top: -12px;\n  right: 5px;\n  width: 40px;\n  height: 40px;\n}\n.ant-drawer-title {\n  font-size: 20px;\n  color: #051B30;\n  font-weight: 600;\n}\n@media screen and (min-width: 1600px) {\n  .ant-drawer-title {\n    font-size: 22px;\n  }\n}\n.ant-drawer-body {\n  padding: 10px;\n}\n.ant-drawer-body > .ant-row {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n.dark-theme {\n  color: #E9F6FF;\n  background-color: #051B30;\n}\n.dark-theme .gx-link {\n  color: #b6e1ff;\n}\n.dark-theme .gx-link:hover,\n.dark-theme .gx-link:focus {\n  color: #f8fcff;\n}\n.dark-theme .gx-social-link li .gx-link {\n  color: #E9F6FF;\n}\n.dark-theme .gx-social-link li.active .gx-link,\n.dark-theme .gx-social-link li .gx-link:hover,\n.dark-theme .gx-social-link li .gx-link:focus {\n  color: #ffffff;\n}\n.dark-theme h1,\n.dark-theme h2,\n.dark-theme h3,\n.dark-theme h4,\n.dark-theme h5,\n.dark-theme h6,\n.dark-theme .h1,\n.dark-theme .h2,\n.dark-theme .h3,\n.dark-theme .h4,\n.dark-theme .h5,\n.dark-theme .h6 {\n  color: #ffffff;\n}\n.dark-theme .ant-modal h1,\n.dark-theme .ant-modal h2,\n.dark-theme .ant-modal h3,\n.dark-theme .ant-modal h4,\n.dark-theme .ant-modal h5,\n.dark-theme .ant-modal h6,\n.dark-theme .ant-modal .h1,\n.dark-theme .ant-modal .h2,\n.dark-theme .ant-modal .h3,\n.dark-theme .ant-modal .h4,\n.dark-theme .ant-modal .h5,\n.dark-theme .ant-modal .h6 {\n  color: #051B30;\n}\n.dark-theme .gx-drawer-sidebar-dark .ant-drawer-content {\n  background-color: #051B30;\n  color: #E9F6FF;\n}\n.dark-theme .ant-drawer-close {\n  color: #051B30;\n}\n.dark-theme .ant-layout,\n.dark-theme .ant-layout.ant-layout-has-sider > .ant-layout {\n  background: #051B30;\n}\n.dark-theme .ant-layout-header {\n  background: #051B30;\n  color: #ffffff;\n}\n.dark-theme .gx-news-content {\n  color: #E9F6FF;\n}\n.dark-theme .gx-header-horizontal {\n  background: #030e19;\n}\n.dark-theme .gx-header-horizontal-main {\n  color: #E9F6FF;\n  background: none;\n}\n.dark-theme .gx-header-horizontal-dark:before {\n  background: #072847;\n}\n.dark-theme .gx-header-horizontal-dark .gx-header-search .gx-lt-icon-search-bar-lg input[type=\"search\"] {\n  border-color: #e8e8e8;\n}\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  color: #030e19;\n}\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-above-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: #089265;\n}\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-selected > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-selected > .ant-menu-submenu-title:before {\n  color: #051B30;\n}\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu:hover > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-active > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-item-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-below-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before,\n.dark-theme .gx-inside-header-horizontal .gx-header-horizontal-nav-curve .ant-menu-horizontal > .ant-menu-submenu-open > .ant-menu-submenu-title:before {\n  color: #089265;\n}\n.dark-theme .gx-menu-horizontal .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.dark-theme .gx-menu-horizontal .ant-menu-item-active > .ant-menu-submenu-title,\n.dark-theme .gx-menu-horizontal .ant-menu-submenu-active > .ant-menu-submenu-title,\n.dark-theme .gx-menu-horizontal .ant-menu-item-open > .ant-menu-submenu-title,\n.dark-theme .gx-menu-horizontal .ant-menu-submenu-open > .ant-menu-submenu-title {\n  color: #089265;\n}\n.dark-theme .ant-layout-footer {\n  background: #051B30;\n  color: #E9F6FF;\n  border-top-color: #495762;\n}\n.dark-theme .gx-nav-header {\n  background-color: #051B30;\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-menu {\n  color: #E9F6FF;\n  background: #051B30;\n}\n.dark-theme .ant-menu-inline,\n.dark-theme .ant-menu-vertical,\n.dark-theme .ant-menu-vertical-left {\n  border-right-color: #495762;\n}\n.dark-theme .ant-menu-dark {\n  color: #E9F6FF;\n  background: #051B30;\n  padding-bottom: 20px;\n}\n.dark-theme .ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.dark-theme .ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.dark-theme .ant-result-title,\n.dark-theme .ant-result-subtitle {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-submenu-title:hover {\n  color: #089265;\n}\n.dark-theme .ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-dark .ant-menu-submenu-selected .ant-menu-sub .ant-menu-submenu-title:hover {\n  color: #089265;\n}\n.dark-theme .ant-menu-dark .ant-menu-sub {\n  color: #E9F6FF;\n  background: none;\n}\n.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:after,\n.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.dark-theme .ant-menu-dark .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {\n  background: #089265;\n}\n.dark-theme .ant-menu-item > a {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-item > a:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-item-selected > a:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-dark.ant-menu-submenu-popup,\n.dark-theme .ant-menu-submenu-popup {\n  background: #051B30;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.dark-theme .ant-menu-dark.ant-menu-submenu-popup .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:after,\n.dark-theme .ant-menu-dark.ant-menu-submenu-popup .ant-menu-sub .ant-menu-submenu-title:hover .ant-menu-submenu-arrow:before {\n  background: #ffffff;\n}\n.dark-theme .ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.dark-theme .ant-menu-submenu-popup.ant-menu-light .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  background: #089265;\n}\n.dark-theme .ant-menu-dark.ant-menu-horizontal {\n  border-bottom-color: #051B30;\n}\n.dark-theme .ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.dark-theme .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  border-color: #051B30;\n}\n.dark-theme .ant-menu-horizontal {\n  border-bottom-color: #495762;\n  background: #051B30;\n}\n.dark-theme .gx-header-horizontal-nav .ant-menu-horizontal {\n  background: none;\n}\n.dark-theme .ant-menu-horizontal > .ant-menu-item:hover,\n.dark-theme .ant-menu-horizontal > .ant-menu-submenu:hover,\n.dark-theme .ant-menu-horizontal > .ant-menu-item-active,\n.dark-theme .ant-menu-horizontal > .ant-menu-submenu-active,\n.dark-theme .ant-menu-horizontal > .ant-menu-item-open,\n.dark-theme .ant-menu-horizontal > .ant-menu-submenu-open,\n.dark-theme .ant-menu-horizontal > .ant-menu-item-selected,\n.dark-theme .ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom-color: #E9F6FF;\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-horizontal > .ant-menu-item > a,\n.dark-theme .ant-menu-horizontal > .ant-menu-submenu > a {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #18344f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-layout-sider .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: rgba(255, 255, 255, 0.12);\n}\n.dark-theme .ant-layout-sider.gx-mini-custom-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: transparent;\n}\n.dark-theme .ant-layout-sider.gx-mini-custom-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected > a:hover {\n  color: #003366;\n}\n.dark-theme .ant-menu-submenu > .ant-menu,\n.dark-theme .ant-menu-item:active,\n.dark-theme .ant-menu-submenu-title:active {\n  background-color: #18344f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-layout-sider .ant-menu-submenu > .ant-menu,\n.dark-theme .ant-layout-sider .ant-menu-item:active,\n.dark-theme .ant-layout-sider .ant-menu-submenu-title:active {\n  background-color: transparent;\n}\n.dark-theme .ant-menu-item-group-title,\n.dark-theme .ant-menu-item-selected,\n.dark-theme .ant-menu-submenu-selected .ant-menu-submenu-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-item:hover,\n.dark-theme .ant-menu-item-active,\n.dark-theme .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.dark-theme .ant-menu-submenu-active {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-item-disabled,\n.dark-theme .ant-menu-submenu-disabled {\n  color: #69c2ff !important;\n}\n.dark-theme .ant-menu-dark .ant-menu-item-group-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-dark .ant-menu-item {\n  color: #9BA4AC;\n}\n.dark-theme .ant-menu-dark .ant-menu-item svg path {\n  fill: #9BA4AC;\n}\n.dark-theme .ant-menu-dark .ant-menu-item:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-dark .ant-menu-item:hover svg path {\n  fill: #ffffff;\n}\n.dark-theme .ant-menu-dark .ant-menu-item.stroke svg path {\n  fill: none;\n}\n.dark-theme .ant-menu-dark .ant-menu-item.stroke > a:hover svg path {\n  fill: none;\n  stroke: #fff;\n}\n.dark-theme .ant-menu-dark .ant-menu-item > a {\n  color: #9BA4AC;\n}\n.dark-theme .ant-menu-dark .ant-menu-item > a svg {\n  width: 20px;\n  height: 20px;\n}\n.dark-theme .ant-menu-dark .ant-menu-item > a:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-dark .ant-menu-item > a:hover svg path {\n  fill: #ffffff;\n}\n.dark-theme .ant-menu-dark .ant-menu-item-selected > a {\n  color: #ffffff;\n}\n.dark-theme .ant-menu-submenu-horizontal > .ant-menu-submenu-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.dark-theme .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.dark-theme .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.dark-theme .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,\n.dark-theme .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.dark-theme .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.dark-theme .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,\n.dark-theme .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {\n  background: #ffffff;\n}\n.dark-theme .ant-menu-vertical .ant-menu-item::after,\n.dark-theme .ant-menu-vertical-left .ant-menu-item::after,\n.dark-theme .ant-menu-vertical-right .ant-menu-item::after,\n.dark-theme .ant-menu-inline .ant-menu-item::after {\n  border-right-color: #08090a;\n}\n.dark-theme .ant-layout-sider,\n.dark-theme .gx-layout-sider-dark {\n  background-color: #051B30;\n  color: #a1a1a1;\n  -webkit-box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);\n  -moz-box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);\n  box-shadow: 0px 0 4px rgba(0, 0, 0, 0.35);\n  border-right: 1px solid #062039;\n}\n.dark-theme .gx-task-list-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-task-list-item:hover .gx-text-hover {\n  color: #b6e1ff;\n}\n.dark-theme .gx-card-ticketlist .gx-task-list-item:hover {\n  background-color: transparent;\n}\n.dark-theme .gx-card-ticketlist .gx-task-list-item:hover .gx-task-item-title {\n  color: #f8fcff;\n}\n.dark-theme .gx-card-testimonial-content {\n  background-color: #051B30;\n}\n.dark-theme .gx-card-testimonial-content:before {\n  border-right-color: #051B30;\n}\n.dark-theme .gx-progress-task-list + .gx-progress-task-list {\n  border-top-color: #495762;\n}\n.dark-theme .gx-card-ticketlist .gx-link {\n  color: #b6e1ff;\n}\n.dark-theme .gx-overview-description {\n  border-left-color: #495762;\n}\n@media screen and (max-width: 767px) {\n  .dark-theme .gx-overview-description {\n    border-top-color: #495762;\n    border-bottom-color: #495762;\n  }\n}\n.dark-theme .gx-revenu-total {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-revenu-col:not(:last-child) {\n  border-right-color: #495762;\n}\n.dark-theme .gx-product-item {\n  background: #12273B;\n}\n.dark-theme .gx-app-login-main-content {\n  background-color: #12273B;\n}\n.dark-theme .gx-app-social-block .gx-social-link span {\n  border-color: #051B30;\n  color: #051B30;\n}\n.dark-theme .gx-app-social-block .gx-social-link span:hover,\n.dark-theme .gx-app-social-block .gx-social-link span:focus {\n  color: #E9F6FF;\n  background-color: #051B30;\n}\n.dark-theme .gx-avatar-img,\n.dark-theme .gx-avatar,\n.dark-theme .gx-badge-outline {\n  border-color: #495762;\n}\n.dark-theme .gx-btn,\n.dark-theme .btn {\n  color: #545454;\n  border-color: #d9d9d9;\n}\n.dark-theme .gx-sub-popover .gx-btn:focus,\n.dark-theme .gx-sub-popover .btn:focus,\n.dark-theme .gx-sub-popover .gx-btn:hover,\n.dark-theme .gx-sub-popover .btn:hover {\n  background-color: #E9F6FF;\n}\n.dark-theme .gx-btn-link {\n  color: #b6e1ff;\n  background-color: transparent;\n}\n.dark-theme .gx-btn-link:hover {\n  color: #f8fcff;\n}\n.dark-theme .gx-ant-card-actions > li:not(:last-child) {\n  border-right-color: #495762;\n}\n.dark-theme .ant-card {\n  color: #E9F6FF;\n  background: #12273B;\n}\n.dark-theme .ant-card-bordered {\n  border-color: #495762;\n}\n.dark-theme .ant-card-head {\n  border-color: #495762;\n}\n.dark-theme .ant-card-head-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-card-type-inner .ant-card-head {\n  background: #12273B;\n}\n.dark-theme .ant-card-meta-title,\n.dark-theme .ant-card-meta-description {\n  color: #E9F6FF;\n}\n.dark-theme .ant-card-actions {\n  border-top-color: #495762;\n  background: #12273B;\n}\n.dark-theme .ant-card-actions > li {\n  color: #E9F6FF;\n}\n.dark-theme .ant-card-actions > li:not(:last-child) {\n  border-right-color: #495762;\n}\n.dark-theme .ant-card-actions > li > span:hover {\n  color: #f8fcff;\n}\n.dark-theme .ant-card-grid {\n  box-shadow: 1px 0 0 0 #495762, 0 1px 0 0 #495762, 1px 1px 0 0 #495762, 1px 0 0 0 #495762 inset, 0 1px 0 0 #495762 inset;\n}\n.dark-theme .ant-card-grid:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.dark-theme .gx-card {\n  background-color: #12273B;\n}\n.dark-theme .gx-card-overview {\n  background-color: #12273B;\n}\n.dark-theme .gx-card-metrics,\n.dark-theme .gx-card-widget {\n  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.dark-theme .gx-icon-views:hover {\n  background-color: #051B30;\n  color: #E9F6FF;\n}\n.dark-theme .gx-search-bar input[type=\"search\"] {\n  background: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .gx-search-bar input[type=\"search\"]:focus {\n  background-color: rgba(250, 250, 250, 0.3);\n}\n.dark-theme .gx-search-bar .gx-search-icon {\n  color: #d9d9d9;\n}\n.dark-theme .gx-chat-search-bar input[type=\"search\"]:focus {\n  background-color: #12273B;\n}\n.dark-theme .gx-user-list.gx-card-list {\n  background: #12273B;\n}\n.dark-theme .gx-user-list .gx-link[class*=\"gx-meta-\"] {\n  color: #E9F6FF;\n}\n.dark-theme .gx-card-strip:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-loader-container {\n  background-color: #bfbfbf;\n}\n.dark-theme .gx-table th,\n.dark-theme .gx-table td {\n  border-top-color: #495762;\n}\n.dark-theme .gx-table thead th {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-table tbody + tbody {\n  border-top-color: #495762;\n}\n.dark-theme .gx-table-bordered {\n  border-color: #495762;\n}\n.dark-theme .gx-table-bordered th,\n.dark-theme .gx-table-bordered td {\n  border-color: #495762;\n}\n.dark-theme .gx-timeline-item:before {\n  border-left-color: #495762;\n}\n.dark-theme .gx-timeline-badge {\n  color: #12273B;\n}\n.dark-theme .gx-timeline-badge:after {\n  border-color: #495762;\n}\n.dark-theme .gx-timeline-panel {\n  background-color: #12273B;\n  border-color: #495762;\n}\n.dark-theme .gx-timeline-panel:before {\n  border-color: transparent #495762;\n}\n.dark-theme .gx-timeline-panel:after {\n  border-color: transparent #12273B;\n}\n.dark-theme .gx-timeline-center .gx-timeline-inverted:before {\n  border-right-color: #495762;\n}\n.dark-theme .gx-timeline-info .ant-timeline-item-content {\n  color: #E9F6FF;\n}\n.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link {\n  color: #cfecff;\n}\n.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link:hover,\n.dark-theme .gx-timeline-info .ant-timeline-item-content .gx-link:focus {\n  color: #ffffff;\n}\n.dark-theme .gx-img-more {\n  background-color: #0b1824;\n}\n.dark-theme .ant-tabs {\n  color: #0a355e;\n}\n.dark-theme .ant-tabs-nav .ant-tabs-tab-active,\n.dark-theme .ant-tabs-nav .ant-tabs-tab:hover {\n  color: #051B30;\n}\n.dark-theme .ant-tabs-ink-bar {\n  background-color: #051B30;\n}\n.dark-theme .ant-tabs-bar {\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-tabs-tab-prev,\n.dark-theme .ant-tabs-tab-next {\n  color: #E9F6FF;\n}\n.dark-theme .ant-tabs-tab-prev:hover,\n.dark-theme .ant-tabs-tab-next:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-tabs-tab-btn-disabled,\n.dark-theme .ant-tabs-tab-btn-disabled:hover {\n  color: #1da3ff;\n}\n.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {\n  border-bottom-color: #f5f5f5 !important;\n  background: #142c43;\n  color: #D3D3D3;\n  margin-right: 5px;\n}\n.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {\n  background: #12273B;\n  border-color: #1c3c5a;\n  border-bottom-color: #f5f5f5;\n  color: #ffffff;\n}\n.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {\n  color: #E9F6FF;\n}\n.dark-theme .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-checkbox-wrapper {\n  color: #E9F6FF;\n}\n.dark-theme .ant-checkbox-disabled + span {\n  color: #50b7ff;\n}\n.dark-theme .ant-checkbox-checked::after,\n.dark-theme .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.dark-theme .ant-checkbox:hover .ant-checkbox-inner,\n.dark-theme .ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #2a5b89;\n}\n.dark-theme .ant-checkbox-checked .ant-checkbox-inner,\n.dark-theme .ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #2a5b89;\n  border-color: #2a5b89;\n}\n.dark-theme .ant-timeline {\n  color: #E9F6FF;\n}\n.dark-theme .ant-timeline-item-head {\n  background-color: transparent;\n}\n.dark-theme .ant-timeline-item-tail {\n  border-left-color: #5a6c79;\n}\n.dark-theme .ant-timeline-item-head-blue {\n  border-color: #5a6c79;\n  color: #f8fcff;\n}\n.dark-theme .ant-popover-inner,\n.dark-theme .ant-popover-arrow {\n  background-color: #12273B;\n}\n.dark-theme .ant-popover-inner {\n  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);\n  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.28);\n}\n.dark-theme .ant-popover-inner-content,\n.dark-theme .ant-popover-message {\n  color: #E9F6FF;\n}\n.dark-theme .ant-popover-title {\n  border-bottom-color: #495762;\n  color: #E9F6FF;\n}\n.dark-theme .ant-popover-arrow {\n  border-color: #12273B !important;\n}\n.dark-theme .gx-sub-popover li:not(:last-child),\n.dark-theme .gx-popover-header {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-user-popover li:hover,\n.dark-theme .gx-user-popover li:focus {\n  background-color: #18344f;\n}\n.dark-theme .ant-divider {\n  color: #E9F6FF;\n  background: #495762;\n}\n.dark-theme .ant-divider.ant-divider-with-text,\n.dark-theme .ant-divider.ant-divider-with-text-left,\n.dark-theme .ant-divider.ant-divider-with-text-right {\n  background: none;\n}\n.dark-theme .gx-card-body-border-top .ant-card-body {\n  border-top-color: #495762;\n}\n.dark-theme .ant-list {\n  color: #E9F6FF;\n}\n.dark-theme .ant-list-split .ant-list-item,\n.dark-theme .ant-list-split .ant-list-header,\n.dark-theme .ant-list-something-after-last-item .ant-spin-container > .ant-list-item:last-child {\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-list-item-meta-description,\n.dark-theme .ant-list-vertical .ant-list-item-content,\n.dark-theme .ant-list-item-action > li {\n  color: #E9F6FF;\n}\n.dark-theme .ant-list-bordered {\n  border-color: #495762;\n}\n.dark-theme .ant-list-item-action-split {\n  background-color: #495762;\n}\n.dark-theme .gx-btn-light,\n.dark-theme .gx-link.gx-btn-light {\n  color: #E9F6FF !important;\n  background-color: #051B30 !important;\n  border-color: #051B30 !important;\n}\n.dark-theme .gx-btn-light:hover,\n.dark-theme .gx-link.gx-btn-light:hover,\n.dark-theme .gx-btn-light:focus,\n.dark-theme .gx-link.gx-btn-light:focus {\n  background-color: #000102 !important;\n  border-color: #000102 !important;\n}\n.dark-theme .ant-table {\n  color: #E9F6FF;\n}\n.dark-theme .ant-table-thead > tr > th {\n  background: #051B30;\n  color: #E9F6FF;\n  border-bottom-color: #051B30;\n}\n.dark-theme .ant-table-tbody > tr > td {\n  border-bottom-color: #051B30;\n}\n.dark-theme .ant-table-thead > tr.ant-table-row-hover > td,\n.dark-theme .ant-table-tbody > tr.ant-table-row-hover > td,\n.dark-theme .ant-table-thead > tr:hover > td,\n.dark-theme .ant-table-tbody > tr:hover > td {\n  background: #18344f;\n}\n.dark-theme .ant-table-tbody > tr.ant-table-row-selected td {\n  background: #18344f;\n}\n.dark-theme .ant-table-small {\n  border: none;\n}\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th,\n.dark-theme .ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-body-outer > .ant-table-body-inner > table > .ant-table-thead > tr > th {\n  background: #18344f;\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-table.ant-table-bordered .ant-table-title,\n.dark-theme .ant-table-bordered .ant-table-header > table,\n.dark-theme .ant-table-bordered .ant-table-body > table,\n.dark-theme .ant-table-bordered .ant-table-fixed-left table,\n.dark-theme .ant-table-bordered .ant-table-fixed-right table,\n.dark-theme .ant-table.ant-table-bordered .ant-table-footer {\n  border-color: #495762;\n}\n.dark-theme .ant-table-header {\n  background: #18344f;\n}\n.dark-theme .ant-table-footer {\n  background: #18344f;\n}\n.dark-theme .ant-table-footer:before {\n  background: transparent;\n}\n.dark-theme .ant-table-bordered .ant-table-thead > tr > th,\n.dark-theme .ant-table-bordered .ant-table-tbody > tr > td {\n  border-right-color: #495762;\n}\n.dark-theme .ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  background: #12273B;\n}\n.dark-theme .ant-table-fixed-left table,\n.dark-theme .ant-table-fixed-right table {\n  background: #18344f;\n}\n.dark-theme .ant-table-thead > tr > th .anticon-filter:hover,\n.dark-theme .ant-table-thead > tr > th .ant-table-filter-icon:hover {\n  color: #ffffff;\n}\n.dark-theme .ant-table-column-sorter {\n  color: #E9F6FF;\n}\n.dark-theme .ant-table-column-sorter-up:hover .anticon,\n.dark-theme .ant-table-column-sorter-down:hover .anticon,\n.dark-theme .ant-table-column-sorter-up.on .anticon-caret-up,\n.dark-theme .ant-table-column-sorter-down.on .anticon-caret-up,\n.dark-theme .ant-table-column-sorter-up.on .anticon-caret-down,\n.dark-theme .ant-table-column-sorter-down.on .anticon-caret-down {\n  color: #ffffff;\n}\n.dark-theme .ant-table-row-expand-icon {\n  background: none;\n}\n.dark-theme tr.ant-table-expanded-row,\n.dark-theme tr.ant-table-expanded-row:hover {\n  background: #18344f;\n}\n.dark-theme .ant-pagination {\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-item {\n  background-color: #0c1a27;\n  border-color: #495762;\n}\n.dark-theme .ant-pagination-item-active,\n.dark-theme .ant-pagination-item:hover,\n.dark-theme .ant-pagination-item:focus {\n  border-color: #495762;\n}\n.dark-theme .ant-pagination-item-active .gx-link,\n.dark-theme .ant-pagination-item:hover .gx-link,\n.dark-theme .ant-pagination-item:focus .gx-link {\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-disabled a,\n.dark-theme .ant-pagination-disabled:hover a,\n.dark-theme .ant-pagination-disabled:focus a,\n.dark-theme .ant-pagination-disabled .ant-pagination-item-link,\n.dark-theme .ant-pagination-disabled:hover .ant-pagination-item-link,\n.dark-theme .ant-pagination-disabled:focus .ant-pagination-item-link {\n  color: #051B30;\n}\n.dark-theme .ant-pagination-prev,\n.dark-theme .ant-pagination-next,\n.dark-theme .ant-pagination-jump-prev,\n.dark-theme .ant-pagination-jump-next {\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-prev .ant-pagination-item-link,\n.dark-theme .ant-pagination-next .ant-pagination-item-link {\n  background-color: #CACACA;\n  border-color: #CACACA;\n}\n.dark-theme .ant-pagination-prev:focus .ant-pagination-item-link,\n.dark-theme .ant-pagination-next:focus .ant-pagination-item-link,\n.dark-theme .ant-pagination-prev:hover .ant-pagination-item-link,\n.dark-theme .ant-pagination-next:hover .ant-pagination-item-link {\n  border-color: #495762;\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-jump-prev:focus:after,\n.dark-theme .ant-pagination-jump-next:focus:after,\n.dark-theme .ant-pagination-jump-prev:hover:after,\n.dark-theme .ant-pagination-jump-next:hover:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-simple .ant-pagination-simple-pager input {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: rgba(250, 250, 250, 0.3);\n}\n.dark-theme .ant-pagination-options-quick-jumper input {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-pagination-options-quick-jumper input:hover {\n  border-color: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .ant-pagination-options-quick-jumper input:focus {\n  border-color: #495762;\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-badge {\n  color: #E9F6FF;\n}\n.dark-theme .ant-badge-status-text {\n  color: #E9F6FF;\n}\n.dark-theme .ant-badge-count {\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n}\n.dark-theme .ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #495762;\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-cascader-menus {\n  background: #0c1a27;\n}\n.dark-theme .ant-cascader-menu {\n  border-right-color: #495762;\n}\n.dark-theme .ant-cascader-menu-item:hover {\n  background: #08121c;\n}\n.dark-theme .ant-cascader-picker,\n.dark-theme .ant-cascader-picker-clear {\n  background-color: transparent;\n  color: #E9F6FF;\n}\n.dark-theme .ant-cascader-picker-arrow,\n.dark-theme .ant-cascader-menu-item-expand:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),\n.dark-theme .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {\n  background: #18344f;\n}\n.dark-theme .ant-form-item,\n.dark-theme .ant-form-item-label label,\n.dark-theme .ant-form-explain,\n.dark-theme .ant-form-extra {\n  color: #b1b1b1;\n}\n.dark-theme .ant-input {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #fff;\n}\n.dark-theme .ant-input:focus,\n.dark-theme .ant-input:hover {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-input-disabled {\n  background-color: #f5f5f5 !important;\n}\n.dark-theme .ant-input-number {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-number:focus,\n.dark-theme .ant-input-number:hover {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #495762;\n}\n.dark-theme .ant-input-group-addon {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-group-addon .ant-select-open .ant-select-selection,\n.dark-theme .ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-search-icon {\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-affix-wrapper .ant-input-prefix,\n.dark-theme .ant-input-affix-wrapper .ant-input-suffix {\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-affix-wrapper .ant-input-prefix i,\n.dark-theme .ant-input-affix-wrapper .ant-input-suffix i {\n  color: #E9F6FF;\n}\n.dark-theme .ant-input-affix-wrapper .ant-input-prefix i :not(.anticon),\n.dark-theme .ant-input-affix-wrapper .ant-input-suffix i :not(.anticon) {\n  margin-top: 5px;\n}\n.dark-theme .ant-input.gx-chat-textarea {\n  background-color: #12273B !important;\n  border-color: #12273B;\n  color: #E9F6FF;\n}\n.dark-theme .ant-input.gx-chat-textarea:focus {\n  border-color: #495762;\n}\n.dark-theme .ant-modal .ant-input {\n  background-color: #ffffff;\n  border-color: #dde2e6;\n  color: #595959;\n}\n.dark-theme .ant-modal .ant-input:focus,\n.dark-theme .ant-modal .ant-input:hover {\n  border-color: #cfd6db;\n}\n.dark-theme .ant-modal .ant-upload-list-item-info .anticon-paper-clip {\n  color: #595959;\n}\n.dark-theme .ant-mention-wrapper {\n  color: #E9F6FF;\n}\n.dark-theme .ant-mention-wrapper.disabled .ant-mention-editor {\n  background-color: rgba(232, 232, 232, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-mention-wrapper.ant-mention-active:not(.disabled) .ant-mention-editor {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-mention-wrapper .ant-mention-editor {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-mention-wrapper .ant-mention-editor:focus {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-select {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-selection {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: #dde2e6;\n}\n.dark-theme .ant-select-selection:hover {\n  border-color: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .ant-select-arrow {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-focused .ant-select-selection,\n.dark-theme .ant-select-selection:focus,\n.dark-theme .ant-select-selection:active {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-select-dropdown {\n  color: #E9F6FF;\n  background-color: #12273B;\n}\n.dark-theme .ant-select-dropdown-menu-item {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-dropdown-menu-item:hover {\n  background-color: #0a1520;\n}\n.dark-theme .ant-select-dropdown-menu-item-selected,\n.dark-theme .ant-select-dropdown-menu-item-selected:hover,\n.dark-theme .ant-select-dropdown-menu-item-active {\n  background-color: #08121c;\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-auto-complete.ant-select .ant-input:focus,\n.dark-theme .ant-select-auto-complete.ant-select .ant-input:hover {\n  border-color: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .ant-select-dropdown-menu-item-group-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-auto-complete.ant-select textarea.ant-input {\n  background: rgba(250, 250, 250, 0.1) !important;\n}\n.dark-theme .ant-select-tree,\n.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper:hover,\n.dark-theme .ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {\n  background-color: #18344f;\n}\n.dark-theme .ant-select-tree-dropdown .ant-select-dropdown-search .ant-select-search__field,\n.dark-theme .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner,\n.dark-theme .ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {\n  border-color: #18344f;\n  background-color: #18344f;\n}\n.dark-theme .ant-select-show-search .ant-select-selection {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.dark-theme .ant-transfer-list-search-action,\n.dark-theme .ant-transfer-list-search-action i {\n  color: #E9F6FF;\n}\n.dark-theme .ant-transfer-list {\n  border-color: #1c3c5a;\n  color: #E9F6FF;\n}\n.dark-theme .ant-transfer-list-body-with-search {\n  background-color: #18344f;\n}\n.dark-theme .ant-transfer-list-header {\n  background-color: #18344f;\n  border-color: #1c3c5a;\n  color: #E9F6FF;\n}\n.dark-theme .ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover {\n  background-color: #1c3c5a;\n}\n.dark-theme .ant-transfer-list-footer {\n  border-top-color: #1c3c5a;\n  background-color: #18344f;\n}\n.dark-theme .ant-transfer-list-content-item-disabled {\n  color: #1da3ff;\n}\n.dark-theme .ant-calendar {\n  background-color: #18344f;\n  border-color: #18344f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-today .ant-calendar-date {\n  border-color: #30689d;\n  color: #30689d;\n  background-color: #244e76;\n}\n.dark-theme .ant-calendar-selected-date .ant-calendar-date,\n.dark-theme .ant-calendar-selected-start-date .ant-calendar-date,\n.dark-theme .ant-calendar-selected-end-date .ant-calendar-date,\n.dark-theme .ant-calendar-selected-day .ant-calendar-date {\n  background: #30689d;\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover,\n.dark-theme .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month,\n.dark-theme .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year,\n.dark-theme .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover,\n.dark-theme .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade,\n.dark-theme .ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {\n  background: #30689d;\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-month-panel-month:hover,\n.dark-theme .ant-calendar-year-panel-year:hover,\n.dark-theme .ant-calendar-decade-panel-decade:hover {\n  background: #244e76;\n}\n.dark-theme .ant-calendar-input {\n  color: #E9F6FF;\n  background-color: #18344f;\n}\n.dark-theme .ant-calendar-month-panel,\n.dark-theme .ant-calendar-year-panel,\n.dark-theme .ant-calendar-decade-panel {\n  background-color: #18344f;\n}\n.dark-theme .ant-calendar-header,\n.dark-theme .ant-calendar-input-wrap,\n.dark-theme .ant-calendar-month-panel-header,\n.dark-theme .ant-calendar-year-panel-header,\n.dark-theme .ant-calendar-decade-panel-header {\n  border-bottom-color: #1c3c5a;\n}\n.dark-theme .ant-calendar-footer,\n.dark-theme .ant-calendar-range .ant-calendar-body,\n.dark-theme .ant-calendar-range .ant-calendar-month-panel-body,\n.dark-theme .ant-calendar-range .ant-calendar-year-panel-body {\n  border-top-color: #1c3c5a;\n}\n.dark-theme .ant-calendar-picker-icon,\n.dark-theme .ant-calendar-picker-icon:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-header .ant-calendar-prev-century-btn,\n.dark-theme .ant-calendar-header .ant-calendar-next-century-btn,\n.dark-theme .ant-calendar-header .ant-calendar-prev-decade-btn,\n.dark-theme .ant-calendar-header .ant-calendar-next-decade-btn,\n.dark-theme .ant-calendar-header .ant-calendar-prev-month-btn,\n.dark-theme .ant-calendar-header .ant-calendar-next-month-btn,\n.dark-theme .ant-calendar-header .ant-calendar-prev-year-btn,\n.dark-theme .ant-calendar-header .ant-calendar-next-year-btn,\n.dark-theme .ant-calendar-header .ant-calendar-century-select,\n.dark-theme .ant-calendar-header .ant-calendar-decade-select,\n.dark-theme .ant-calendar-header .ant-calendar-year-select,\n.dark-theme .ant-calendar-header .ant-calendar-month-select {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar .ant-calendar-disabled-cell .ant-calendar-date {\n  background-color: rgba(250, 250, 250, 0.1);\n}\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,\n.dark-theme .ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,\n.dark-theme .ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,\n.dark-theme .ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-date {\n  color: #E9F6FF;\n}\n.dark-theme .ant-calendar-date:hover {\n  background: #244e76;\n}\n.dark-theme .ant-calendar-last-month-cell .ant-calendar-date,\n.dark-theme .ant-calendar-next-month-btn-day .ant-calendar-date,\n.dark-theme .ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,\n.dark-theme .ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year,\n.dark-theme .ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,\n.dark-theme .ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {\n  color: #83ccff;\n}\n.dark-theme .ant-calendar-picker-clear {\n  color: #E9F6FF;\n  background: none;\n}\n.dark-theme .ant-calendar .ant-calendar-ok-btn {\n  border-radius: 4px;\n  color: #fff;\n  text-transform: uppercase;\n}\n.dark-theme .ant-calendar-range .ant-calendar-in-range-cell:before {\n  background-color: #1a3956;\n}\n.dark-theme .ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {\n  background: #1a3956;\n}\n.dark-theme .ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day .ant-calendar-date,\n.dark-theme .ant-calendar-week-number .ant-calendar-body tr .ant-calendar-selected-day:hover .ant-calendar-date,\n.dark-theme .ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: #E9F6FF;\n}\n.dark-theme .ant-fullcalendar {\n  color: #E9F6FF;\n  border-top-color: #495762;\n}\n.dark-theme .ant-fullcalendar-value {\n  color: #E9F6FF;\n}\n.dark-theme .ant-fullcalendar-value:hover {\n  background: #18344f;\n}\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-date {\n  color: #E9F6FF;\n  border-top-color: #1c3c5a;\n}\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {\n  background: #18344f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {\n  border-top-color: #1c3c5a;\n}\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date,\n.dark-theme .ant-fullcalendar-last-month-cell .ant-fullcalendar-value,\n.dark-theme .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {\n  color: #83ccff;\n}\n.dark-theme .ant-fullcalendar-selected-day .ant-fullcalendar-value,\n.dark-theme .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {\n  background: #18344f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-fullcalendar-today .ant-fullcalendar-value,\n.dark-theme .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {\n  box-shadow: 0 0 0 1px #30689d inset;\n  background: #30689d;\n}\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,\n.dark-theme .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {\n  color: #E9F6FF;\n  background-color: transparent;\n  box-shadow: none;\n}\n.dark-theme .ant-time-picker-panel,\n.dark-theme .ant-time-picker-icon,\n.dark-theme .ant-time-picker-icon:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-time-picker-panel-inner {\n  background-color: #18344f;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.dark-theme .ant-time-picker-panel-input-wrap {\n  border-bottom-color: #1c3c5a;\n}\n.dark-theme .ant-time-picker-panel-input-wrap .ant-time-picker-panel-input {\n  background-color: transparent;\n}\n.dark-theme .ant-time-picker-panel-input-wrap .gx-link,\n.dark-theme .ant-time-picker-panel-input-wrap .gx-link:hover,\n.dark-theme .ant-time-picker-panel-input-wrap .gx-link:focus,\n.dark-theme .ant-time-picker-panel-input-wrap .gx-link.ant-time-picker-panel-clear-btn:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-time-picker-input {\n  background-color: rgba(250, 250, 250, 0.1);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #E9F6FF;\n}\n.dark-theme .ant-time-picker-input:focus,\n.dark-theme .ant-time-picker-input:hover {\n  border-color: rgba(245, 245, 245, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n.dark-theme .ant-time-picker-panel-select {\n  border-left-color: #1c3c5a;\n}\n.dark-theme .ant-time-picker-panel-select li:hover {\n  background: #1a3956;\n}\n.dark-theme li.ant-time-picker-panel-select-option-selected {\n  background: #1c3c5a;\n}\n.dark-theme .ant-slider-mark-text {\n  color: #1da3ff;\n}\n.dark-theme .ant-slider-mark-text-active {\n  color: #ffffff;\n}\n.dark-theme .ant-slider-track {\n  background-color: #18344f;\n}\n.dark-theme .ant-slider-active {\n  border-color: #18344f;\n}\n.dark-theme .ant-radio {\n  color: #E9F6FF;\n}\n.dark-theme .ant-radio-wrapper:hover .ant-radio .ant-radio-inner,\n.dark-theme .ant-radio:hover .ant-radio-inner,\n.dark-theme .ant-radio-focused .ant-radio-inner {\n  border-color: #2a5b89;\n}\n.dark-theme .ant-radio-checked:after {\n  border-color: #2a5b89;\n}\n.dark-theme .ant-radio-checked .ant-radio-inner {\n  border-color: #2a5b89;\n}\n.dark-theme .ant-radio-disabled + span {\n  color: #E9F6FF;\n}\n.dark-theme .ant-radio-button-wrapper {\n  color: #2a5b89;\n  background-color: transparent;\n  border-color: #2a5b89;\n}\n.dark-theme .ant-radio-button-wrapper:hover,\n.dark-theme .ant-radio-button-wrapper:focus {\n  color: #E9F6FF;\n}\n.dark-theme .ant-radio-button-wrapper-checked {\n  box-shadow: none;\n  border-color: #77a7d5;\n  color: #77a7d5;\n}\n.dark-theme .ant-radio-button-wrapper-checked:hover,\n.dark-theme .ant-radio-button-wrapper-checked:focus {\n  color: #E9F6FF;\n}\n.dark-theme .ant-radio-button-wrapper-checked:first-child {\n  border-color: #77a7d5;\n  color: #77a7d5;\n}\n.dark-theme .ant-radio-button-wrapper:not(:first-child):before {\n  background-color: #2a5b89;\n}\n.dark-theme .ant-radio-button-wrapper-checked:before {\n  background-color: #2a5b89 !important;\n}\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper {\n  color: #2a5b89;\n}\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:hover,\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper:focus {\n  color: #1e4162;\n}\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  color: #E9F6FF;\n  background-color: #13c2c2;\n}\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:hover,\n.dark-theme .gx-radio-group-link-bg-light.ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:focus {\n  color: #ffffff;\n}\n.dark-theme .ant-btn {\n  color: #535353;\n}\n.dark-theme .ant-btn:hover,\n.dark-theme .ant-btn:focus {\n  color: #535353;\n  border-color: #112437;\n}\n.dark-theme .ant-btn-primary {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.dark-theme .ant-btn-primary:hover,\n.dark-theme .ant-btn-primary:focus {\n  background-color: #12a3e8;\n  border-color: #12a3e8;\n  color: #ffffff;\n}\n.dark-theme .ant-btn-primary.disabled,\n.dark-theme .ant-btn-primary:disabled,\n.dark-theme .ant-btn-primary:not([disabled]):not(.disabled):active,\n.dark-theme .ant-btn-primary:not([disabled]):not(.disabled).active {\n  background-color: #060d14;\n  border-color: #060d14;\n}\n.dark-theme .ant-btn-danger {\n  color: #f44336;\n  background-color: transparent;\n  border-color: #f44336;\n}\n.dark-theme .ant-btn-danger:hover,\n.dark-theme .ant-btn-danger:focus {\n  color: #ffffff;\n  background-color: #f44336;\n  border-color: #f44336;\n}\n.dark-theme .ant-btn-background-ghost.ant-btn-primary {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n  color: #ffffff;\n}\n.dark-theme .ant-btn-background-ghost.ant-btn-primary:hover,\n.dark-theme .ant-btn-background-ghost.ant-btn-primary:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.dark-theme .verify-container .ant-btn {\n  color: #ffffff;\n}\n.dark-theme .gx-header-search .ant-select-selection {\n  background-color: #060d14;\n  border-color: #e8e8e8;\n  color: #E9F6FF;\n  margin-left: -1px;\n}\n.dark-theme .gx-header-search .ant-select-selection:focus {\n  color: #E9F6FF;\n  background-color: #000000;\n  border-color: #e8e8e8;\n}\n.dark-theme .gx-header-search .ant-select-arrow {\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload {\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload.ant-upload-drag {\n  background-color: #0e1f2f;\n  border-color: #0e1f2f;\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload.ant-upload-drag p.ant-upload-text,\n.dark-theme .ant-upload.ant-upload-drag p.ant-upload-hint {\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {\n  border-color: #495762;\n}\n.dark-theme .ant-upload-list-item a,\n.dark-theme .ant-upload-list-item-info .anticon-loading,\n.dark-theme .ant-upload-list-item-info .anticon-paper-clip {\n  color: #E9F6FF;\n}\n.dark-theme .ant-upload-list-item:hover .ant-upload-list-item-info {\n  background-color: #18344f;\n}\n.dark-theme .ant-upload.ant-upload-select-picture-card {\n  background-color: #0e1f2f;\n  border-color: #0e1f2f;\n}\n.dark-theme .ant-upload.ant-upload-select-picture-card:hover {\n  border-color: #495762;\n}\n.dark-theme .ant-switch {\n  color: #ffffff;\n}\n.dark-theme .ant-switch-checked {\n  background-color: #0c1a27;\n}\n.dark-theme .gx-bg-grey {\n  background-color: #999999 !important;\n}\n.dark-theme .ant-breadcrumb {\n  color: #bfbfbf;\n}\n.dark-theme .ant-breadcrumb-separator,\n.dark-theme .ant-breadcrumb > span:last-child {\n  color: #bfbfbf;\n}\n.dark-theme .ant-dropdown {\n  color: #E9F6FF;\n}\n.dark-theme .ant-dropdown-menu {\n  background-color: #08121c;\n}\n.dark-theme .ant-dropdown-menu-item,\n.dark-theme .ant-dropdown-menu-submenu-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-dropdown-menu-item:hover,\n.dark-theme .ant-dropdown-menu-submenu-title:hover {\n  background-color: #142c43;\n}\n.dark-theme .ant-dropdown-menu-item .ant-dropdown-menu-submenu-arrow:after,\n.dark-theme .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow:after {\n  color: #E9F6FF;\n}\n.dark-theme .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.dark-theme .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow::after {\n  color: #83ccff;\n}\n.dark-theme .ant-steps-item {\n  color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #12273B;\n  border-color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-process .ant-steps-item-icon {\n  background-color: #18344f;\n  border-color: #18344f;\n}\n.dark-theme .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {\n  color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-wait .ant-steps-item-icon {\n  background-color: #12273B;\n  border-color: #1e4162;\n}\n.dark-theme .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {\n  color: #1e4162;\n}\n.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-description,\n.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-description,\n.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-description {\n  color: #83ccff;\n}\n.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title,\n.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title,\n.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title {\n  color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title:after,\n.dark-theme .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title:after,\n.dark-theme .ant-steps-item-process > .ant-steps-item-tail:after,\n.dark-theme .ant-steps-item-error > .ant-steps-item-content > .ant-steps-item-title:after {\n  background-color: #495762;\n}\n.dark-theme .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after,\n.dark-theme .ant-steps-item-finish > .ant-steps-item-tail:after {\n  background-color: #E9F6FF;\n}\n.dark-theme .ant-steps-item-error .ant-steps-item-icon {\n  background-color: #12273B;\n}\n.dark-theme .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,\n.dark-theme .ant-steps-item-finish > .ant-steps-item-tail:after,\n.dark-theme .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #000102;\n}\n.dark-theme .ant-steps-item-process > .ant-steps-item-tail:after,\n.dark-theme .ant-steps-item-wait > .ant-steps-item-tail:after {\n  background-color: #1c3c5a;\n}\n.dark-theme .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {\n  background: #1c3c5a;\n}\n.dark-theme .steps-content {\n  border-color: #495762;\n  background-color: #18344f;\n}\n.dark-theme .ant-collapse {\n  background-color: #18344f;\n  border-color: #1e4162;\n  color: #E9F6FF;\n}\n.dark-theme .ant-collapse.gx-collapse-custom {\n  background-color: transparent;\n}\n.dark-theme .ant-collapse.gx-collapse-custom .ant-collapse-item {\n  background-color: #18344f;\n}\n.dark-theme .ant-collapse > .ant-collapse-item {\n  border-color: #1e4162;\n}\n.dark-theme .ant-collapse .ant-collapse {\n  border-color: #2c6091;\n}\n.dark-theme .ant-collapse .ant-collapse > .ant-collapse-item {\n  border-color: #2c6091;\n}\n.dark-theme .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  color: #E9F6FF;\n}\n.dark-theme .ant-collapse-content {\n  color: #E9F6FF;\n  background-color: #20466a;\n  border-top-color: #1e4162;\n}\n.dark-theme .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,\n.dark-theme .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {\n  color: #1da3ff;\n}\n.dark-theme .ant-carousel {\n  color: #E9F6FF;\n}\n.dark-theme .ant-carousel .slick-slide {\n  background-color: #18344f;\n}\n.dark-theme .ant-tree {\n  color: #E9F6FF;\n}\n.dark-theme .ant-tree li .ant-tree-node-content-wrapper {\n  color: #E9F6FF;\n}\n.dark-theme .ant-tree li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),\n.dark-theme .ant-tree li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,\n.dark-theme .ant-tree li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {\n  color: #1da3ff;\n}\n.dark-theme .ant-tree li .ant-tree-node-content-wrapper:hover,\n.dark-theme .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: transparent;\n  color: #12273B;\n  font-weight: 700;\n}\n.dark-theme .ant-tree-checkbox-wrapper:hover .ant-tree-checkbox-inner,\n.dark-theme .ant-tree-checkbox:hover .ant-tree-checkbox-inner,\n.dark-theme .ant-tree-checkbox-input:focus + .ant-tree-checkbox-inner {\n  border-color: #0c1a27;\n}\n.dark-theme .ant-tree-checkbox-checked .ant-tree-checkbox-inner,\n.dark-theme .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {\n  background-color: #0c1a27;\n  border-color: #0c1a27 !important;\n}\n.dark-theme .ant-tree.ant-tree-show-line li span.ant-tree-switcher {\n  background: transparent;\n  color: #E9F6FF;\n}\n.dark-theme .ant-tag-checkable {\n  color: #E9F6FF;\n}\n.dark-theme .ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #ffffff;\n}\n.dark-theme .ant-progress-text,\n.dark-theme .ant-progress-circle .ant-progress-text {\n  color: #E9F6FF;\n}\n.dark-theme .ant-anchor-wrapper {\n  background-color: transparent;\n}\n.dark-theme .ant-anchor-link-active > .ant-anchor-link-title {\n  color: #b6e1ff;\n}\n.dark-theme .rdw-editor-wrapper {\n  color: #006cb6;\n  background-color: #fff;\n}\n.dark-theme .rdw-editor-wrapper + textarea {\n  color: #006cb6;\n}\n.dark-theme .gx-contact-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-draggable-icon {\n  color: #E9F6FF;\n}\n.dark-theme .gx-draggable-icon:hover,\n.dark-theme .gx-draggable-icon:focus,\n.dark-theme .gx-draggable-icon:active {\n  color: #ffffff;\n}\n.dark-theme .sweet-alert,\n.dark-theme .gx-map-content {\n  color: #006cb6;\n}\n.dark-theme .sweet-alert h1,\n.dark-theme .gx-map-content h1,\n.dark-theme .sweet-alert h2,\n.dark-theme .gx-map-content h2,\n.dark-theme .sweet-alert h3,\n.dark-theme .gx-map-content h3,\n.dark-theme .sweet-alert h4,\n.dark-theme .gx-map-content h4,\n.dark-theme .sweet-alert h5,\n.dark-theme .gx-map-content h5,\n.dark-theme .sweet-alert h6,\n.dark-theme .gx-map-content h6,\n.dark-theme .sweet-alert .h1,\n.dark-theme .gx-map-content .h1,\n.dark-theme .sweet-alert .h2,\n.dark-theme .gx-map-content .h2,\n.dark-theme .sweet-alert .h3,\n.dark-theme .gx-map-content .h3,\n.dark-theme .sweet-alert .h4,\n.dark-theme .gx-map-content .h4,\n.dark-theme .sweet-alert .h5,\n.dark-theme .gx-map-content .h5,\n.dark-theme .sweet-alert .h6,\n.dark-theme .gx-map-content .h6 {\n  color: #006cb6;\n}\n@media screen and (max-width: 991px) {\n  .dark-theme .gx-module-side {\n    background-color: #ffffff;\n  }\n}\n.dark-theme .gx-module-side-header {\n  border-bottom-color: #495762;\n  background-color: #12273B;\n  color: #E9F6FF;\n}\n.dark-theme .gx-module-nav li .gx-link {\n  color: #E9F6FF;\n}\n.dark-theme .gx-module-nav li .gx-link:hover,\n.dark-theme .gx-module-nav li .gx-link:focus,\n.dark-theme .gx-module-nav li .gx-link.active {\n  color: #ffffff;\n}\n.dark-theme .gx-module-box-header {\n  background-color: #12273B;\n  border-bottom-color: #495762;\n}\n@media screen and (max-width: 991px) {\n  .dark-theme .gx-module-box-header .gx-drawer-btn {\n    border-right-color: #495762;\n  }\n}\n.dark-theme .gx-module-box-content {\n  background-color: #12273B;\n}\n.dark-theme .gx-module-box-topbar,\n.dark-theme .gx-module-list-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-toolbar-separator {\n  border-left-color: #495762;\n}\n.dark-theme .gx-module-sidenav {\n  background-color: #12273B;\n  border-right-color: #495762;\n}\n.dark-theme .rbc-event {\n  background-color: #2a5b89;\n}\n.dark-theme .rbc-event.rbc-selected {\n  background-color: #060d14;\n}\n.dark-theme .rbc-slot-selection {\n  background-color: #1e4162;\n}\n.dark-theme .rbc-toolbar button {\n  color: #E9F6FF;\n  border-color: #E9F6FF;\n}\n.dark-theme .rbc-toolbar button:active,\n.dark-theme .rbc-toolbar button.rbc-active,\n.dark-theme .rbc-toolbar button:active:hover,\n.dark-theme .rbc-toolbar button.rbc-active:hover,\n.dark-theme .rbc-toolbar button:active:focus,\n.dark-theme .rbc-toolbar button.rbc-active:focus,\n.dark-theme .rbc-toolbar button:focus,\n.dark-theme .rbc-toolbar button:hover {\n  color: #051B30;\n  background-color: #E9F6FF;\n  border-color: #E9F6FF;\n}\n.dark-theme .rbc-date-cell .gx-link {\n  color: #E9F6FF;\n}\n.dark-theme .rbc-date-cell .gx-link:hover,\n.dark-theme .rbc-date-cell .gx-link:focus {\n  color: #ffffff;\n}\n.dark-theme .rbc-off-range-bg {\n  background: #1e4162;\n}\n.dark-theme .rbc-off-range-bg .gx-link {\n  color: #1da3ff;\n}\n.dark-theme .rbc-off-range-bg .gx-link:hover,\n.dark-theme .rbc-off-range-bg .gx-link:focus {\n  color: #E9F6FF;\n}\n.dark-theme .gx-com-calendar-card {\n  border-color: #495762;\n}\n.dark-theme .gx-chat-module-box {\n  background-color: #12273B;\n}\n.dark-theme .gx-chat-sidenav {\n  border-right-color: #495762;\n}\n.dark-theme .gx-chat-sidenav-header {\n  background-color: #18344f;\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-chat-sidenav-content {\n  background-color: #12273B;\n}\n.dark-theme .gx-chat-sidenav-title {\n  color: #E9F6FF;\n}\n.dark-theme .gx-chat-tabs-header {\n  background-color: #18344f !important;\n}\n.dark-theme .gx-chat-user-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-chat-user-item.active,\n.dark-theme .gx-chat-user-item:hover {\n  background-color: #162f47;\n}\n.dark-theme .gx-chat-info-des {\n  color: #E9F6FF;\n}\n.dark-theme .gx-chat-main-header {\n  border-bottom-color: #495762;\n  background-color: #12273B;\n}\n.dark-theme .gx-chat-main-footer {\n  border-top-color: #495762;\n  background-color: #12273B;\n}\n.dark-theme .gx-chat-item .gx-bubble {\n  background-color: #142c43;\n  border-color: #495762;\n}\n.dark-theme .gx-chat-item.gx-flex-row-reverse .gx-bubble {\n  background-color: #18344f;\n}\n.dark-theme .gx-error-code {\n  color: #E9F6FF;\n  text-shadow: 10px 6px 8px rgba(255, 117, 117, 0.8);\n}\n.dark-theme .gx-btn-yellow,\n.dark-theme .gx-link.gx-btn-yellow {\n  color: #262626 !important;\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.dark-theme .gx-btn-yellow:hover,\n.dark-theme .gx-link.gx-btn-yellow:hover,\n.dark-theme .gx-btn-yellow:focus,\n.dark-theme .gx-link.gx-btn-yellow:focus {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.dark-theme .gx-btn-yellow.disabled,\n.dark-theme .gx-link.gx-btn-yellow.disabled,\n.dark-theme .gx-btn-yellow:disabled,\n.dark-theme .gx-link.gx-btn-yellow:disabled {\n  background-color: #fadb14 !important;\n  border-color: #fadb14 !important;\n}\n.dark-theme .gx-btn-yellow:not([disabled]):not(.disabled):active,\n.dark-theme .gx-link.gx-btn-yellow:not([disabled]):not(.disabled):active,\n.dark-theme .gx-btn-yellow:not([disabled]):not(.disabled).active,\n.dark-theme .gx-link.gx-btn-yellow:not([disabled]):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #d6ba05 !important;\n  border-color: #d6ba05 !important;\n}\n.dark-theme .gx-package {\n  background-color: #ffffff;\n  color: #595959;\n}\n.dark-theme .gx-package-header > .gx-price {\n  color: #ffffff;\n}\n.dark-theme .gx-package-header.gx-text-white {\n  color: #595959 !important;\n}\n.dark-theme .gx-customizer-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-layout-sider-dark .gx-sidebar-notifications,\n.dark-theme .gx-drawer-sidebar-dark .gx-sidebar-notifications {\n  border-bottom-color: #495762;\n}\n.dark-theme .ant-layout-sider-dark .gx-app-nav,\n.dark-theme .gx-drawer-sidebar-dark .gx-app-nav {\n  color: #E9F6FF;\n}\n.dark-theme .gx-text-grey {\n  color: #E9F6FF !important;\n}\n.dark-theme .gx-currentplan-col .gx-bg-dark {\n  background-color: #E9F6FF !important;\n}\n.dark-theme .gx-chart-up {\n  color: #52c41a;\n}\n.dark-theme .gx-bg-geekblue .gx-chart-up,\n.dark-theme .gx-overlay-primary .gx-chart-up,\n.dark-theme .gx-overlay-pink .gx-chart-down {\n  color: #ffffff;\n}\n.dark-theme .gx-chart-down {\n  color: #f5222d;\n}\n.dark-theme .gx-text-black {\n  color: #ffffff !important;\n}\n.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a {\n  color: #E9F6FF;\n}\n.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a:hover,\n.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-list li a:focus {\n  color: #2EB1EF;\n}\n.dark-theme .gx-algolia-sidebar .ais-HierarchicalMenu-count {\n  color: #E9F6FF;\n}\n.dark-theme .ais-Breadcrumb,\n.dark-theme .ais-ClearRefinements,\n.dark-theme .ais-CurrentRefinements,\n.dark-theme .ais-GeoSearch,\n.dark-theme .ais-HierarchicalMenu,\n.dark-theme .ais-Hits,\n.dark-theme .ais-Results,\n.dark-theme .ais-HitsPerPage,\n.dark-theme .ais-ResultsPerPage,\n.dark-theme .ais-InfiniteHits,\n.dark-theme .ais-InfiniteResults,\n.dark-theme .ais-Menu,\n.dark-theme .ais-MenuSelect,\n.dark-theme .ais-NumericMenu,\n.dark-theme .ais-NumericSelector,\n.dark-theme .ais-Pagination,\n.dark-theme .ais-Panel,\n.dark-theme .ais-PoweredBy,\n.dark-theme .ais-RangeInput,\n.dark-theme .ais-RangeSlider,\n.dark-theme .ais-RatingMenu,\n.dark-theme .ais-RefinementList,\n.dark-theme .ais-RefinementList-count,\n.dark-theme .ais-SearchBox,\n.dark-theme .ais-SortBy,\n.dark-theme .ais-Stats,\n.dark-theme .ais-ToggleRefinement,\n.dark-theme .ais-RatingMenu-count,\n.dark-theme .gx-algolia-category-title {\n  color: #E9F6FF;\n}\n.dark-theme .ais-SearchBox-input,\n.dark-theme .ais-RangeInput-input,\n.dark-theme .ais-MenuSelect-select,\n.dark-theme .ais-NumericSelector-select,\n.dark-theme .ais-HitsPerPage-select,\n.dark-theme .ais-ResultsPerPage-select,\n.dark-theme .ais-SortBy-select,\n.dark-theme .gx-link.ais-Pagination-link:hover,\n.dark-theme .gx-link.ais-Pagination-link:focus {\n  color: #051B30;\n}\n.dark-theme .gx-link.ais-Pagination-link--selected:hover,\n.dark-theme .gx-link.ais-Pagination-link--selected:focus {\n  color: #ffffff;\n}\n.dark-theme .ais-RangeInput-submit,\n.dark-theme .ais-ClearRefinements-button,\n.dark-theme .ais-CurrentRefinements-reset,\n.dark-theme .ais-GeoSearch-redo,\n.dark-theme .ais-GeoSearch-reset,\n.dark-theme .ais-HierarchicalMenu-showMore,\n.dark-theme .ais-InfiniteHits-loadMore,\n.dark-theme .ais-InfiniteResults-loadMore,\n.dark-theme .ais-Menu-showMore,\n.dark-theme .ais-RefinementList-showMore {\n  background-color: #E9F6FF;\n  color: #051B30;\n}\n.dark-theme .ais-RangeInput-submit:focus,\n.dark-theme .ais-ClearRefinements-button:focus,\n.dark-theme .ais-CurrentRefinements-reset:focus,\n.dark-theme .ais-GeoSearch-redo:focus,\n.dark-theme .ais-GeoSearch-reset:focus,\n.dark-theme .ais-HierarchicalMenu-showMore:focus,\n.dark-theme .ais-InfiniteHits-loadMore:focus,\n.dark-theme .ais-InfiniteResults-loadMore:focus,\n.dark-theme .ais-Menu-showMore:focus,\n.dark-theme .ais-RefinementList-showMore:focus,\n.dark-theme .ais-RangeInput-submit:hover,\n.dark-theme .ais-ClearRefinements-button:hover,\n.dark-theme .ais-CurrentRefinements-reset:hover,\n.dark-theme .ais-GeoSearch-redo:hover,\n.dark-theme .ais-GeoSearch-reset:hover,\n.dark-theme .ais-HierarchicalMenu-showMore:hover,\n.dark-theme .ais-InfiniteHits-loadMore:hover,\n.dark-theme .ais-InfiniteResults-loadMore:hover,\n.dark-theme .ais-Menu-showMore:hover,\n.dark-theme .ais-RefinementList-showMore:hover {\n  background-color: #E9F6FF;\n}\n.dark-theme .ais-Breadcrumb-link,\n.dark-theme .ais-HierarchicalMenu-link,\n.dark-theme .ais-Menu-link,\n.dark-theme .ais-Pagination-link,\n.dark-theme .ais-RatingMenu-link {\n  color: #051B30;\n}\n.dark-theme .ais-Breadcrumb-link:focus,\n.dark-theme .ais-HierarchicalMenu-link:focus,\n.dark-theme .ais-Menu-link:focus,\n.dark-theme .ais-Pagination-link:focus,\n.dark-theme .ais-RatingMenu-link:focus,\n.dark-theme .ais-Breadcrumb-link:hover,\n.dark-theme .ais-HierarchicalMenu-link:hover,\n.dark-theme .ais-Menu-link:hover,\n.dark-theme .ais-Pagination-link:hover,\n.dark-theme .ais-RatingMenu-link:hover {\n  color: #051B30;\n}\n.dark-theme .ais-Pagination-item--selected .ais-Pagination-link {\n  background-color: #2EB1EF;\n  border-color: #495762;\n}\n.dark-theme .gx-card-profile.gx-card-tabs .ant-card-head,\n.dark-theme .gx-featured-item:not(:last-child) {\n  border-bottom-color: #495762;\n}\n.dark-theme .gx-follower-list li,\n.dark-theme .gx-follower-title {\n  color: #E9F6FF;\n}\n.dark-theme .gx-header-horizontal-main .gx-header-notifications li > span {\n  color: #E9F6FF;\n}\n.dark-theme .gx-profile-banner {\n  background-color: #051b30;\n}\n.dark-theme .gx-text-primary {\n  color: #13c2c2 !important;\n}\n.dark-theme .gx-text-primary.gx-icon-white {\n  color: #ffffff !important;\n}\n.dark-theme .gx-link.gx-text-primary:hover,\n.dark-theme .gx-link.gx-text-primary:focus {\n  color: #006d75 !important;\n}\n.dark-theme .gx-bg-primary {\n  background-color: #13c2c2 !important;\n}\n.dark-theme .gx-link.gx-bg-primary:hover,\n.dark-theme .gx-link.gx-bg-primary:focus {\n  background-color: #006d75 !important;\n}\n.dark-theme .gx-border-primary {\n  border-color: #13c2c2 !important;\n}\n.dark-theme .gx-btn-primary,\n.dark-theme .gx-link.gx-btn-primary,\n.dark-theme .btn-primary {\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.dark-theme .gx-btn-primary:hover,\n.dark-theme .gx-link.gx-btn-primary:hover,\n.dark-theme .btn-primary:hover,\n.dark-theme .gx-btn-primary:focus,\n.dark-theme .gx-link.gx-btn-primary:focus,\n.dark-theme .btn-primary:focus {\n  background-color: #006d75 !important;\n  border-color: #006d75 !important;\n}\n.dark-theme .gx-btn-primary.disabled,\n.dark-theme .gx-link.gx-btn-primary.disabled,\n.dark-theme .btn-primary.disabled,\n.dark-theme .gx-btn-primary:disabled,\n.dark-theme .gx-link.gx-btn-primary:disabled,\n.dark-theme .btn-primary:disabled {\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.dark-theme .gx-btn-primary:not([disabled]):not(.disabled):active,\n.dark-theme .gx-link.gx-btn-primary:not([disabled]):not(.disabled):active,\n.dark-theme .btn-primary:not([disabled]):not(.disabled):active,\n.dark-theme .gx-btn-primary:not([disabled]):not(.disabled).active,\n.dark-theme .gx-link.gx-btn-primary:not([disabled]):not(.disabled).active,\n.dark-theme .btn-primary:not([disabled]):not(.disabled).active {\n  background-color: #006d75 !important;\n  border-color: #006d75 !important;\n}\n.dark-theme .gx-btn-outline-primary,\n.dark-theme .gx-link.gx-btn-outline-primary {\n  color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.dark-theme .gx-btn-outline-primary:hover,\n.dark-theme .gx-link.gx-btn-outline-primary:hover,\n.dark-theme .gx-btn-outline-primary:focus,\n.dark-theme .gx-link.gx-btn-outline-primary:focus {\n  color: #ffffff !important;\n  background-color: #13c2c2 !important;\n  border-color: #13c2c2 !important;\n}\n.dark-theme .gx-btn-outline-primary.disabled,\n.dark-theme .gx-link.gx-btn-outline-primary.disabled,\n.dark-theme .gx-btn-outline-primary:disabled,\n.dark-theme .gx-link.gx-btn-outline-primary:disabled {\n  color: #13c2c2 !important;\n}\n.dark-theme .gx-badge-primary,\n.dark-theme .gx-entry-title:before {\n  background-color: #13c2c2 !important;\n}\n.dark-theme .gx-bg-white .gx-text-grey {\n  color: #051B30 !important;\n}\n@media screen and (max-width: 991px) {\n  .dark-theme .gx-popover-horizantal .gx-search-bar input[type=\"search\"] {\n    background: none !important;\n  }\n  .dark-theme .gx-popover-horizantal .gx-search-bar input[type=\"search\"]:focus,\n  .dark-theme .gx-popover-horizantal .gx-search-bar input[type=\"search\"]:hover {\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n  }\n  .dark-theme .gx-popover-horizantal .ant-btn {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  .dark-theme .gx-popover-horizantal .ant-btn:hover,\n  .dark-theme .gx-popover-horizantal .ant-btn:focus {\n    background-color: transparent;\n    border-color: transparent;\n  }\n}\n@media screen and (max-width: 767px) {\n  .dark-theme .gx-table-responsive .ant-table {\n    border: #495762;\n  }\n  .dark-theme .gx-table-responsive .ant-table.ant-table-bordered .ant-table-footer {\n    border-top-color: #495762;\n  }\n  .dark-theme .ant-card-bordered.gx-card-full .gx-table-responsive .ant-table {\n    border-bottom-color: #495762;\n  }\n  .dark-theme .gx-timeline-center .gx-timeline-inverted:before {\n    border-left-color: #495762;\n  }\n}\n@media screen and (max-width: 475px) {\n  .dark-theme .ant-input-group.ant-input-group-compact .gx-border-lt-xs {\n    border-left-color: #495762 !important;\n  }\n}\n@media screen and (min-width: 1600px) {\n  h4,\n  .h4 {\n    font-size: 18px;\n  }\n}\n.ant-tag-blue {\n  font-weight: 400;\n}\n.ant-btn-primary,\n.ant-btn,\n.ant-btn.ant-btn-secondary,\n.ant-btn-primary.ant-btn {\n  min-height: 36px;\n  color: #ffffff;\n  font-size: 14px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-btn-primary,\n  .ant-btn,\n  .ant-btn.ant-btn-secondary,\n  .ant-btn-primary.ant-btn {\n    min-height: 40px;\n    font-size: 16px;\n  }\n}\n.ant-btn.ant-btn-primary {\n  color: #ffffff;\n}\n.ant-btn.ant-btn-primary:hover,\n.ant-btn.ant-btn-primary:focus {\n  color: #ffffff;\n}\n.ant-btn.ant-btn-secondary {\n  background-color: #D9D9D9;\n  color: #545454;\n  font-weight: 500;\n}\n.ant-btn.ant-btn-secondary:hover,\n.ant-btn.ant-btn-secondary:focus {\n  background-color: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.ant-btn.ant-btn-secondary.ant-btn-sm {\n  font-size: 12px;\n  min-height: 34px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-btn.ant-btn-secondary.ant-btn-sm {\n    font-size: 14px;\n    min-height: 36px;\n  }\n}\n.green-button,\n.drawer-form .green-button.ant-btn,\n.green-button.ant-btn {\n  background-color: #14B983;\n  color: #ffffff;\n  height: 40px;\n  font-weight: 600;\n  border-radius: 20px;\n  border: none;\n  font-size: 12px;\n  min-height: 38px;\n  padding: 0 12px;\n}\n@media screen and (min-width: 1600px) {\n  .green-button,\n  .drawer-form .green-button.ant-btn,\n  .green-button.ant-btn {\n    min-height: 40px;\n    font-size: 14px;\n  }\n}\n.green-button:hover,\n.drawer-form .green-button.ant-btn:hover,\n.green-button.ant-btn:hover,\n.green-button:focus,\n.drawer-form .green-button.ant-btn:focus,\n.green-button.ant-btn:focus {\n  background-color: #12a273;\n  color: #fff;\n}\n.green-button.rounded-4,\n.drawer-form .green-button.ant-btn.rounded-4,\n.green-button.ant-btn.rounded-4 {\n  border-radius: 4px;\n}\n.btn-note.ant-btn,\n.dark-theme .btn-note.ant-btn {\n  padding: 6px 12px;\n  line-height: 1.2;\n  border-color: #8d97a0;\n  color: #545454;\n}\n.btn-note.ant-btn:hover,\n.dark-theme .btn-note.ant-btn:hover,\n.btn-note.ant-btn:focus,\n.dark-theme .btn-note.ant-btn:focus {\n  border-color: #8d97a0;\n}\n.dark-light-note {\n  font-weight: 500;\n  color: #383838;\n}\n.dark-theme .dark-light-note {\n  color: #ffffff;\n}\n.view-full-calendar {\n  color: #37A2B7;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n}\n@media screen and (min-width: 1600px) {\n  .view-full-calendar {\n    font-size: 16px;\n  }\n}\n.white-note {\n  font-size: 18px;\n  color: #ffffff;\n}\n.ant-btn {\n  margin-bottom: 0px;\n}\n.ant-form-item label {\n  font-weight: 600;\n}\n.ant-btn.ant-btn-primary.secondary {\n  background-color: #14B983;\n  border-color: #14B983;\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n.ant-btn.ant-btn-primary.secondary:hover,\n.ant-btn.ant-btn-primary.secondary:focus {\n  background-color: #13ab79;\n  border-color: #14B983;\n}\n.ant-btn.prior-scans-visit-link {\n  border: none;\n  color: #2EB1EF;\n  padding: 0px;\n}\n.ant-btn.prior-scans-visit-link:hover,\n.ant-btn.prior-scans-visit-link:focus {\n  color: #1199d9;\n}\n.dark-theme .ant-btn.ant-btn-link,\n.ant-btn.ant-btn-link {\n  color: #2EB1EF;\n  font-size: 13px;\n}\n@media screen and (min-width: 1600px) {\n  .dark-theme .ant-btn.ant-btn-link,\n  .ant-btn.ant-btn-link {\n    font-size: 15px;\n  }\n}\n.dark-theme .ant-btn.ant-btn-link:hover,\n.ant-btn.ant-btn-link:hover,\n.dark-theme .ant-btn.ant-btn-link:focus,\n.ant-btn.ant-btn-link:focus {\n  color: #1199d9;\n}\nbutton.ant-btn.calendar-button:hover,\nbutton.ant-btn.calendar-button:focus {\n  color: #fff;\n}\n.ant-modal-confirm-btns .ant-btn {\n  color: #6A6A6A;\n  background: #E6E6E6;\n  border-color: transparent;\n}\n.ant-modal-confirm-btns .ant-btn:hover,\n.ant-modal-confirm-btns .ant-btn:focus {\n  color: #6A6A6A;\n  background: #d9d9d9;\n  border-color: transparent;\n}\n.ant-modal-confirm-btns .ant-btn-primary {\n  background-color: #2EB1EF;\n  border-color: #2EB1EF;\n}\n.ant-modal-confirm-btns .ant-btn-primary:hover,\n.ant-modal-confirm-btns .ant-btn-primary:focus {\n  background-color: #16a8ed;\n  border-color: #16a8ed;\n  color: #ffffff;\n}\n.ant-btn.drawer-action-button,\n.dark-theme .ant-btn.drawer-action-button {\n  background-color: #CBD1D0;\n  color: #051B30;\n  border-radius: 10px;\n  border: none;\n  margin: 0px;\n}\n.ant-btn.drawer-action-button:hover,\n.dark-theme .ant-btn.drawer-action-button:hover,\n.ant-btn.drawer-action-buttonfocus,\n.dark-theme .ant-btn.drawer-action-buttonfocus {\n  background-color: #c3cac9;\n}\n.ant-btn.drawer-download-button,\n.dark-theme .ant-btn.drawer-download-button {\n  border: 1px solid #CBD1D0 !important;\n  color: #6B6B6B !important;\n  border-radius: 10px;\n  border: none;\n  margin: 0px;\n}\n.ant-btn.drawer-download-button:hover,\n.dark-theme .ant-btn.drawer-download-button:hover,\n.ant-btn.drawer-download-buttonfocus,\n.dark-theme .ant-btn.drawer-download-buttonfocus {\n  border: 1px solid #c3cac9 !important;\n}\n.ant-btn.delete-appointment-btn,\n.dark-theme .ant-btn.delete-appointment-btn {\n  background-color: #c44b55;\n  color: #FFFFFF;\n  border: none;\n  margin: 0px;\n}\n.ant-btn.delete-appointment-btn:hover,\n.dark-theme .ant-btn.delete-appointment-btn:hover,\n.ant-btn.delete-appointment-btnfocus,\n.dark-theme .ant-btn.delete-appointment-btnfocus {\n  background-color: #c03f4a;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout {\n  background-color: #F1F1F1;\n}\n.ant-layout-header {\n  height: auto;\n  padding: 16px 25px;\n  box-shadow: none;\n  background-color: #F1F1F1;\n}\n.ant-layout-header .ant-select-selection-selected-value {\n  color: #081C26;\n}\n.dark-theme .ant-layout-header .ant-select-selection-selected-value {\n  color: #E9F6FF;\n}\n.gx-header-notifications .ant-select-selection {\n  background-color: transparent;\n  border-color: #9BA4AC;\n  box-shadow: none;\n}\n.gx-header-notifications .ant-select-selection span.ant-select-arrow {\n  color: #081C26;\n}\n.gx-card {\n  background-color: transparent;\n  box-shadow: none;\n}\n.dark-theme .gx-card {\n  background-color: transparent;\n  box-shadow: none;\n}\n.gx-card .ant-card-body {\n  padding: 10px 8px;\n}\n.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar {\n  width: 6px;\n}\n.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-track {\n  height: 6px;\n  background: #f5f5f5;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-track {\n  background: #0B2B41;\n}\n.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb {\n  background: #226380;\n}\n.gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-body::-webkit-scrollbar-thumb:hover {\n  background: #256c8c;\n}\n.gx-card.listing-wrapper .ant-btn-link {\n  min-height: 30px;\n}\n.gx-card.listing-wrapper .ant-btn.search-btn {\n  background-color: #ffffff;\n  border-color: #e3e3e3;\n  color: #545454;\n  margin: 0px;\n  border-radius: 6px;\n}\n.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn {\n  background-color: #082139;\n  border-color: #082139;\n  color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn:hover,\n.dark-theme .gx-card.listing-wrapper .ant-btn.search-btn:focus {\n  background-color: #0b2e4f;\n}\n.gx-card.listing-wrapper .ant-btn.search-btn:hover,\n.gx-card.listing-wrapper .ant-btn.search-btn:focus {\n  background-color: #e3e3e3;\n}\n.drawer-form h2 {\n  color: #051B30;\n  font-size: 16px;\n}\n.drawer-form .ant-switch {\n  height: 26px;\n}\n.drawer-form .ant-switch.ant-switch-checked {\n  background-color: #14B983;\n}\n.drawer-form .ant-switch::after {\n  top: 3px;\n}\n.drawer-form .ant-btn {\n  color: #535353;\n}\n.drawer-form .ant-btn.ant-btn-primary {\n  color: #ffffff;\n}\n.drawer-form .ant-form-item-label label {\n  font-weight: 600;\n}\n.tabs-wrapper.ris-users-tab .ant-switch-checked {\n  background-color: #2EB1EF;\n}\n.dark-theme .ant-layout-header .ant-select-selection {\n  border-radius: 10px;\n  background-color: #12273B;\n  border-color: #12273B;\n}\n.dark-theme .gx-header-notifications .ant-select-selection .ant-select-arrow {\n  color: #E9F6FF;\n}\n.dark-theme .ant-select-disabled .ant-select-selection {\n  background-color: rgba(232, 232, 232, 0.4);\n  border-color: rgba(232, 232, 232, 0.4);\n  color: #595959;\n}\n.dark-theme .ant-btn-primary {\n  color: #ffffff;\n}\n.dark-theme .ant-btn-link {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  color: #82C9D7;\n  line-height: 1.5;\n  height: auto;\n  margin: 0px;\n  padding: 0px;\n}\n.dark-theme .ant-btn-link:hover,\n.dark-theme .ant-btn-link:focus {\n  background-color: transparent;\n  border-color: transparent;\n  color: #82C9D7;\n}\n.dark-theme .ant-select-dropdown.drawer-dropdown {\n  background: #fff;\n  color: #051B30;\n}\n.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item {\n  color: #051B30;\n  transition: .2s ease;\n}\n.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item:hover,\n.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected,\n.dark-theme .ant-select-dropdown.drawer-dropdown .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {\n  color: #2e3a49;\n  background-color: #f1f5f5;\n}\n.dark-theme .drawer-form .ant-form-item-label label {\n  color: #6B6B6B;\n}\n.dark-theme tr.ant-table-expanded-row,\n.dark-theme tr.ant-table-expanded-row .ant-table-thead > tr > th,\n.dark-theme tr.ant-table-expanded-row .ant-table-tbody > tr > td,\n.dark-theme tr.ant-table-expanded-row:hover {\n  background: #082139;\n  font-size: 12px;\n  font-weight: 400;\n  padding: 10px;\n  border: none;\n}\n.dark-theme .examinations-table .ant-table {\n  max-height: calc(100vh - 275px);\n}\n.dark-theme .examinations-table .ant-table-body .ant-table-row-expand-icon {\n  font-size: 18px;\n  color: #265077;\n  border-color: #354D65;\n}\n.dark-theme .examinations-table .ant-table-thead > tr > th {\n  font-size: 14px;\n  font-weight: 600;\n  background: #051B30;\n  color: #E9F6FF;\n  border-color: #051B30;\n}\n.dark-theme .examinations-table .ant-table-tbody > tr > td,\n.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  padding: 12px 16px;\n  background: transparent;\n  font-weight: 300;\n  border-bottom: none;\n  background: #051B30;\n}\n.dark-theme .examinations-table .ant-table-tbody > tr > td .status-icon,\n.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .status-icon {\n  width: 12px;\n  height: 12px;\n}\n.dark-theme .examinations-table .ant-table-tbody > tr > td .icon,\n.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .icon {\n  color: #354D65;\n}\n.dark-theme .examinations-table .ant-table-tbody > tr > td .undo-icon,\n.dark-theme .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .undo-icon {\n  color: #265077;\n  font-size: 22px;\n}\n.dark-theme .examinations-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #082139;\n  font-weight: 300;\n  border-bottom: none;\n}\n.dark-theme .examinations-table .ant-select-disabled .ant-select-selection {\n  color: #ddd;\n}\n.dark-theme .patient-visits-sidebar .ant-tree li .ant-tree-node-content-wrapper,\n.dark-theme .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,\n.dark-theme .ant-tree li span.ant-tree-switcher .ant-tree-switcher-icon,\n.dark-theme .patient-visits-sidebar .ant-tree .ant-tree-child-tree li .ant-tree-switcher_close .ant-tree-switcher-icon {\n  color: #6A6D71;\n  font-weight: 400;\n}\n.dark-theme .visit-history .patient-visits-sidebar .ant-tree li .ant-tree-node-content-wrapper,\n.dark-theme .visit-history .patient-visits-sidebar .ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,\n.dark-theme .visit-history .patient-visits-sidebar .ant-tree li span.ant-tree-switcher .ant-tree-switcher-icon,\n.dark-theme .visit-history .patient-visits-sidebar .ant-tree .ant-tree-child-tree li .ant-tree-switcher_close .ant-tree-switcher-icon {\n  color: #ffffff;\n}\n.dark-theme .ant-modal .invoices-table .ant-select,\n.dark-theme .ant-modal .invoices-table .ant-select-selection-selected-value {\n  color: #000000;\n}\n.dark-theme .ant-modal .invoices-table .ant-select-selection {\n  border-color: #d9d9d9;\n  margin: 4px;\n  font-size: 14px;\n}\n.dark-theme .ant-modal .invoices-table .ant-calendar-picker {\n  padding-right: 4px;\n}\n.dark-theme .white-box .examinations-table .ant-table-thead > tr > th {\n  background-color: #fff;\n  color: #6B6B6B;\n}\n.ant-tree-treenode-switcher-close::before {\n  display: none;\n}\n.ant-tree-treenode-switcher-close.ant-tree-treenode-selected,\n.visit-history .ant-tree-treenode-selected {\n  background-color: #03AD6F;\n  padding: 5px;\n  border-radius: 4px;\n}\n.ant-tree-treenode-switcher-close.ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper,\n.visit-history .ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper {\n  color: #ffffff;\n  font-weight: 500;\n}\n.ant-modal-body .ant-tree-treenode-switcher-close.ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper,\n.ant-modal-body .visit-history .ant-tree-treenode-selected .ant-tree-node-selected.ant-tree-node-content-wrapper {\n  color: #000000;\n}\n.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected,\n.ant-tree li .ant-tree-node-content-wrapper:hover {\n  background-color: transparent;\n}\n.ant-modal-body .ant-tree-treenode-switcher-close.ant-tree-treenode-selected {\n  background-color: transparent;\n}\n.white-box .examinations-table {\n  padding: 0 8px;\n}\n.white-box .examinations-table table {\n  display: block;\n}\n.white-box .examinations-table table thead.ant-table-thead {\n  display: none;\n}\n.white-box .examinations-table .ant-table-tbody {\n  display: block;\n  width: 100%;\n}\n.white-box .examinations-table .ant-table-tbody > tr > td,\n.white-box .examinations-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.white-box .examinations-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: transparent;\n  width: 190px;\n  padding: 4px;\n  border-bottom: none;\n}\n.white-box .examinations-table .ant-table-tbody > tr {\n  display: flex\n;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.quick-codes.white-box .examinations-table .ant-table-tbody > tr {\n  border-bottom: 3px solid #f3f3f3;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n.quick-codes.white-box .examinations-table .ant-table-tbody > tr:last-child {\n  border-bottom: none;\n}\n.quick-codes.white-box .examinations-table .ant-table.ant-table-scroll-position-left {\n  padding-right: 10px;\n}\n.quick-codes.white-box .patient-info-button {\n  margin-left: auto !important;\n}\n.dark-theme .white-box .examinations-table .gx-link {\n  color: #8B9293;\n  background-color: #f5f5f5;\n  padding: 6px 9px;\n  border-radius: 3px;\n  margin-top: 0px;\n  display: inline-block;\n}\n.dark-theme .white-box .examinations-table .ant-select-selection-selected-value,\n.white-box .examinations-table .ant-select-selection-selected-value,\n.white-box .examinations-table input.ant-select-search__field {\n  color: #6B6B6B;\n}\n.dark-theme .ant-modal-body .examinations-table .ant-table-tbody > tr > td,\n.ant-modal-body .examinations-table .ant-table-tbody > tr > td {\n  color: #ffffff;\n}\n.ant-input-disabled {\n  color: #545454 !important;\n}\n.rad-tab-label .ant-badge .ant-badge-count {\n  color: #38424B;\n}\n.search-patient {\n  margin-left: 10px;\n  width: 100%;\n}\n.search-site {\n  margin-left: 20px;\n}\n.btn-panel {\n  display: block;\n  margin: auto;\n}\n.worklist-block .ant-form-item,\n.patient-report-card .ant-form-item {\n  margin-bottom: 4px !important;\n}\n.worklist-block .ant-form-item-label {\n  text-align: left !important;\n}\n.worklist-block {\n  margin-bottom: 20px;\n}\n#dob,\n#startDate,\n#endDate {\n  width: 100% !important;\n  margin-bottom: 0px !important;\n}\n.patient-visits-sidebar.report-sidebar {\n  height: 350px;\n  overflow-y: auto;\n}\n.patient-visits-sidebar.report-sidebar::-webkit-scrollbar,\n.notes-sidebar::-webkit-scrollbar {\n  height: 7px !important;\n  width: 4px !important;\n}\n#visit-table::-webkit-scrollbar,\n#visit-table .ant-table-thead::-webkit-scrollbar {\n  height: 6px !important;\n}\n.cke_contents {\n  height: 500px;\n}\n.report-editor .cke_contents {\n  height: 316px !important;\n}\n.report-editor-icon {\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n}\n.report-editor-icon:hover {\n  cursor: pointer;\n}\n.custom-header {\n  width: 600px;\n}\n.view-report {\n  text-align: center !important;\n  width: 103px !important;\n}\n#visit-table .ant-table-selection-column {\n  padding: 0px !important;\n}\n#custom-sidebar > div::-webkit-scrollbar {\n  height: 3px !important;\n}\n.gx-app-logo img {\n  max-width: 155px;\n}\n.report-sidebar-container {\n  border: 1px solid #f3f3f3;\n  padding-left: 6px !important;\n  padding-right: 0px !important;\n  width: 100%;\n  margin: auto !important;\n  border-radius: 8px;\n}\n.report-sidebar-container.visit-history {\n  border: none;\n  padding-left: 0px !important;\n}\nsection.visit-info-history-panel {\n  display: flex;\n  gap: 20px;\n}\n.mini-logo {\n  margin-right: auto;\n}\n#visit-table,\n#review-pending-report-table {\n  font-size: 12px !important;\n}\n.custom-ant-input .ant-input {\n  height: 31px !important;\n  font-size: 12px !important;\n}\n.custom-radio-group span {\n  font-size: 12px !important;\n}\n.custom-width {\n  width: 300px;\n}\n.custom-search {\n  margin-top: -5px !important;\n  margin-bottom: 0px !important;\n}\n.custom-select {\n  font-size: 12px;\n}\n.custom-select .ant-select-selection__placeholder {\n  line-height: 18px;\n}\n.custom-select .ant-select-selection__rendered,\n.custom-select .ant-select-selection--single {\n  line-height: 30px;\n  height: 30px;\n}\n@media screen and (min-width: 1600px) {\n  .custom-select {\n    font-size: 14px;\n  }\n}\n.custom-input.ant-input {\n  font-size: 12px;\n  line-height: 30px;\n  height: 30px;\n}\n@media screen and (min-width: 1600px) {\n  .custom-input.ant-input {\n    font-size: 14px;\n  }\n}\n.calendar-select.ant-select .ant-select-selection {\n  height: 40px;\n}\n.calendar-select.ant-select .ant-select-selection .ant-select-selection__rendered {\n  line-height: 40px;\n}\n@media screen and (min-width: 1600px) {\n  .calendar-select.ant-select {\n    font-size: 16px;\n  }\n}\n.white-box .custom-select .ant-select-selection__rendered,\n.white-box .custom-select .ant-select-selection--single,\n.white-box .custom-input.ant-input {\n  border-color: #f3f3f3;\n}\n.macro-editor {\n  top: 5px !important;\n}\n.macro-editor .cke_contents {\n  height: 200px !important;\n}\n#review-pending-report-table button {\n  margin: auto;\n  display: block;\n}\n.report-viewer-sidebar {\n  overflow-x: scroll;\n  overflow-y: auto;\n  height: 436px !important;\n  padding: 0px !important;\n}\n.report-viewer-sidebar::-webkit-scrollbar {\n  height: 7px !important;\n  width: 4px !important;\n}\n.report-viewer-sidebar-container {\n  padding-right: 0px !important;\n}\n.country-label .ant-form-item-label {\n  padding-left: 0px !important;\n}\n.react-pdf__Page__canvas {\n  width: 100% !important;\n  height: auto !important;\n}\n.html-render-section {\n  border: 1px solid #f3f3f3;\n  padding: 1rem;\n  width: 100%;\n  border-radius: 4px;\n  color: #222;\n}\n.html-render-section body {\n  background-color: white !important;\n}\n.report-btn-container {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-bottom: 10px;\n  gap: 4px;\n}\n.report-viewer-editor-container {\n  margin: 10px 0px;\n}\n.mip-submit {\n  float: right !important;\n}\n.accounts-table .ant-table-tbody > tr > td,\n.gx-card.listing-wrapper .accounts-table .ant-table-tbody > tr > td,\n.accounts-table .ant-table-thead > tr > th,\n.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th {\n  text-align: center;\n}\n.accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header,\n.gx-card.listing-wrapper .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  overflow: hidden;\n}\n.dark-theme .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header,\n.dark-theme .gx-card.listing-wrapper .accounts-table .ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  background: #051B30;\n}\n.accounts-table .ant-table-thead > tr > th,\n.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 48px;\n  line-height: 48px;\n  padding: 0 16px;\n}\n.accounts-table .ant-table-thead > tr > th > span,\n.gx-card.listing-wrapper .accounts-table .ant-table-thead > tr > th > span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.accounts-table .ant-table-tbody > tr:hover > td,\n.gx-card.listing-wrapper .accounts-table .ant-table-tbody > tr:hover > td {\n  background: inherit !important;\n}\n.patient-section {\n  position: absolute;\n  top: -14px;\n  font-size: 15px;\n  font-weight: 500;\n  background: white;\n  padding: 4px 05px 3px;\n  letter-spacing: 0.2px;\n  border: 1px solid #f3f3f3;\n  border-radius: 5px;\n}\n@media screen and (min-width: 1600px) {\n  .patient-section {\n    font-size: 17px;\n  }\n}\n.dark-theme .patient-claim-form-parent .ant-col .ant-form-item-control-wrapper {\n  width: 100% !important;\n}\n.add-examination-button {\n  outline: none;\n  border: none;\n  color: #ffffff;\n  font-size: 12px;\n  width: 70px;\n  padding: 4px 4px 6px;\n  background: transparent;\n  cursor: pointer;\n  line-height: 1.75;\n}\n@media screen and (min-width: 1600px) {\n  .add-examination-button {\n    font-size: 12px;\n    width: 70px;\n  }\n}\n.claiming-form-label-disabled {\n  color: #989b9d;\n  font-weight: 500;\n}\n.warning-component {\n  width: 100%;\n  min-height: 65px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 08px;\n  gap: 8px;\n  padding: 14px 20px;\n}\n.claiming-form-parent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex-grow: 1;\n  min-height: 445px;\n}\n.claiming-form-input-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  gap: 5px;\n  flex-grow: 1;\n  max-width: 200px;\n  margin-bottom: 10px;\n}\n.claiming-form-radio {\n  width: 215px !important;\n  overflow: hidden !important;\n  color: #323a43 !important;\n  border-radius: 06px !important;\n}\n.claiming-form-radio .ant-radio-wrapper {\n  color: #323a43 !important;\n  font-size: 12px !important;\n}\n.dark-theme .ant-checkbox-checked .ant-checkbox-inner.claiming-checkbox-disabled {\n  background: #f5f5f5 !important;\n  color: #696b6d !important;\n}\n.dark-theme .ant-checkbox-indeterminate .ant-checkbox-inner.claiming-checkbox-disabled {\n  background: #f5f5f5 !important;\n  color: #696b6d !important;\n}\n.claiming-form-input {\n  border: 0.5px solid #d9d9d9;\n  border-radius: 05px;\n  font-size: 11px;\n  outline: none;\n  width: 100%;\n  padding: 08px;\n}\n.claiming-form-input-disabled {\n  border: 0.5px solid #f5f5f5 !important;\n  border-radius: 05px;\n  font-size: 11px !important;\n  outline: none;\n  width: 100%;\n  padding: 08px;\n  color: #696b6d !important;\n  border-color: #dde2e6 !important;\n}\n.claiming-buttons-div {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n  height: 50px;\n  width: 100%;\n  border-radius: 0px 0px 8px 8px;\n  margin: 10px 0px;\n}\n.claiming-button {\n  cursor: pointer;\n  margin: 0px !important;\n}\n.claiming-form-parent-input {\n  padding: 08px;\n  border: 0.5px solid #4b545c29;\n  border-radius: 08px;\n  background: #4b545c29;\n  color: #323a43;\n  outline: none;\n}\n.claiming-form-status-badge {\n  padding: 5px 10px;\n  font-size: 11px;\n  line-height: 1;\n  border-radius: 11px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n@media screen and (min-width: 1600px) {\n  .claiming-form-status-badge {\n    font-size: 13px;\n  }\n}\n.message-overlay {\n  position: absolute;\n  top: -20%;\n  left: 0;\n  z-index: 999999;\n  backdrop-filter: blur(4px);\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  border-radius: 06px !important;\n}\n.message-parent {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.message-container {\n  min-width: 400px;\n  max-width: 450px;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  padding: 10px 30px;\n  text-align: center;\n}\n.add-examination-row {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  display: flex;\n  padding: 0;\n  border-radius: 0 8px 0 8px;\n  border: none;\n  background: #2EB1EF;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n.add-examination-row button + button {\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n.visit-detail-bg {\n  color: #ffffff;\n  padding: 15px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  border-radius: 4px;\n}\n.visit-detail-bg h3 {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0px 0px 10px;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg h3 {\n    font-size: 18px;\n  }\n}\n.visit-detail-bg .ant-form .ant-row {\n  margin: 0px;\n}\n.visit-detail-bg .ant-form .ant-row.ant-form-item {\n  flex-direction: column;\n  display: flex;\n  align-items: flex-start;\n  padding: 0px;\n  margin-right: 6px;\n  margin-bottom: 6px;\n}\n.visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {\n  color: #7E7E7E;\n  font-weight: 600;\n}\n.visit-detail-bg .patient-info-input,\n.visit-detail-bg .ant-calendar-picker-input {\n  width: 220px;\n  height: 38px;\n  border-radius: 4px;\n}\n.visit-detail-bg .patient-info-select {\n  width: 220px;\n  height: 38px;\n  border-radius: 4px;\n}\n.visit-detail-bg .patient-info-select.ref-doc {\n  width: 525px;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg .patient-info-select.ref-doc {\n    width: 600px;\n  }\n}\n.visit-detail-bg .patient-info-select.cc-doc {\n  width: 475px;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg .patient-info-select.cc-doc {\n    width: 550px;\n  }\n}\n.visit-detail-bg .ant-table-wrapper.examinations-table .ant-table {\n  max-height: 220px;\n}\n.visit-detail-bg .ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,\n.visit-detail-bg .ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-right: 25px;\n}\n.visit-detail-bg .ant-select-selection.ant-select-selection--multiple {\n  max-height: 85px;\n  overflow-y: auto;\n}\n.visit-detail-bg .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {\n  height: 18px;\n  line-height: 10px;\n  padding: 3px 20px 3px 10px;\n  font-size: 13px;\n}\n.visit-detail-bg .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 11px;\n  top: 2px;\n}\n.patient-info-input.short-input,\n.patient-info-select.short-input {\n  width: 130px;\n  min-width: 130px;\n}\n@media screen and (min-width: 1600px) {\n  .patient-info-input.short-input,\n  .patient-info-select.short-input {\n    width: 150px;\n    min-width: 150px;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .patient-info-input.short-input,\n  .patient-info-select.short-input {\n    width: 180px;\n    min-width: 180px;\n  }\n}\n@media screen and (min-width: 2000px) {\n  .patient-info-input.short-input,\n  .patient-info-select.short-input {\n    width: 200px;\n  }\n}\n.visit-detail-bg-container .ant-form .ant-row {\n  margin: 0px;\n}\n.visit-detail-bg-container .ant-form .ant-row.ant-form-item {\n  flex-direction: column;\n  display: flex;\n  align-items: flex-start;\n  padding: 0px;\n  margin-right: 6px;\n  margin-bottom: 6px;\n}\n.dark-theme .visit-detail-bg {\n  background-color: #081F37;\n}\n.dark-theme .visit-detail-bg .patient-info-input,\n.dark-theme .visit-detail-bg .ant-calendar-picker-input {\n  background-color: rgba(20, 40, 60, 0.65);\n  border-color: rgba(20, 40, 60, 0.65);\n  color: #ffffff;\n}\n.dark-theme .visit-detail-bg .patient-info-select {\n  color: #ffffff;\n}\n.dark-theme .visit-detail-bg .patient-info-select .ant-select-selection {\n  background-color: rgba(20, 40, 60, 0.65);\n  border-color: rgba(20, 40, 60, 0.65);\n}\n.dark-theme .visit-detail-bg .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #082139 !important;\n}\n.dark-theme .visit-detail-bg .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {\n  background-color: #051B30;\n  color: #ffffff;\n  border-color: #051B30;\n}\n.dark-theme .visit-detail-bg .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  color: #9BA4AC;\n}\n.dark-theme .visit-detail-bg .ant-btn[disabled],\n.dark-theme .visit-detail-bg .ant-btn[disabled]:hover,\n.dark-theme .visit-detail-bg .ant-btn[disabled]:focus {\n  background: transparent;\n  border-color: inherit !important;\n}\n.gx-card.listing-wrapper .visit-detail-bg .patient-info-input.ant-input,\n.gx-card.listing-wrapper .visit-detail-bg .ant-calendar-picker-input,\n.gx-card.listing-wrapper .visit-detail-bg .patient-info-select.ant-select .ant-select-selection {\n  background-color: #F8F8F8;\n  border-color: #F8F8F8;\n}\n.dark-theme .gx-card.listing-wrapper .visit-detail-bg .patient-info-input.ant-input,\n.dark-theme .gx-card.listing-wrapper .visit-detail-bg .ant-calendar-picker-input,\n.dark-theme .gx-card.listing-wrapper .visit-detail-bg .patient-info-select.ant-select .ant-select-selection {\n  background-color: rgba(20, 40, 60, 0.65);\n  border-color: rgba(20, 40, 60, 0.65);\n}\n.ant-form-item-required::before {\n  font-size: 12px;\n  vertical-align: text-top;\n}\n.patient-info-button {\n  border-radius: 05px;\n  padding: 8px;\n  height: 30px;\n  min-height: 30px;\n  line-height: 12px;\n  font-size: 10px;\n  min-width: 100px;\n  margin: 0 !important;\n  background-color: #ffffff;\n  border-color: #37A2B7;\n  color: #37A2B7;\n  font-weight: 500;\n}\n.patient-info-button:hover,\n.patient-info-button:focus {\n  background-color: #04A0A1;\n  color: #ffffff;\n  border-color: #04A0A1;\n}\n@media screen and (min-width: 1600px) {\n  .patient-info-button {\n    font-size: 12px;\n    min-height: 34px;\n    padding: 8px 10px;\n  }\n}\n.patient-info-button button.ant-btn {\n  border: none;\n  height: auto;\n  min-height: auto;\n  line-height: 1;\n  color: #fff;\n  font-size: 11px;\n}\n@media screen and (min-width: 1600px) {\n  .patient-info-button button.ant-btn {\n    font-size: 12px;\n  }\n}\n.dark-theme .patient-info-button {\n  background-color: #051B30;\n  border: 1px solid #0590DE;\n  color: #ffffff !important;\n}\n.dark-theme .patient-info-button:hover,\n.dark-theme .patient-info-button:focus {\n  background-color: #072542;\n  border-color: #0590DE !important;\n  color: #ffffff !important;\n}\n.white-box .patient-info-button {\n  border-color: #089265 !important;\n  background: transparent;\n  color: #089265 !important;\n  border-radius: 20px;\n  min-height: 34px;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 6px 18px;\n}\n.white-box .patient-info-button:hover,\n.white-box .patient-info-button:focus {\n  background: #089265 !important;\n  border-color: #089265 !important;\n  color: #ffffff !important;\n}\n.edi-span {\n  color: #484848;\n  background-color: #d7d7d7;\n  border: 0.5px solid #484848;\n  border-radius: 08px;\n  padding: 10px;\n  margin-top: 10px;\n  font-weight: 600;\n}\n.visit-audit-input,\n.visit-audit-input::placeholder {\n  background: #FFFFFF;\n  border: 1px solid #f3f3f3 !important;\n  border-radius: 08px;\n  width: 198px;\n  height: 33px;\n  color: #6b6b6b !important;\n  margin: 1px;\n}\n.visit-notes-tree {\n  background: #fff;\n  padding: 15px;\n}\n.visit-notes-tree.ant-row {\n  margin: 0px;\n}\n.visit-notes-tree .notes-sidebar {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.ant-form .ant-row.visit-notes-tree .ant-row {\n  margin-left: -15px;\n}\n.notes-heading {\n  color: #051b30 !important;\n  font-weight: 600;\n  margin-top: 10px;\n}\n.notes-heading span {\n  color: #959595;\n  font-style: italic;\n  font-size: 11px;\n  font-weight: 300;\n}\n.add-location-button,\n.add-location-button:hover,\n.add-location-button:focus {\n  background: #019461;\n  color: #FFFFFF !important;\n  border-radius: 20px;\n  border: none;\n}\n.scan-doc-radio.ant-radio-button-wrapper {\n  display: inline-flex;\n  align-items: center;\n  width: 140px;\n  height: auto;\n  min-height: 38px;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 4px;\n  background-color: #E6EAEB;\n  border: 1px solid #D6D6D6;\n  color: #666666;\n  margin: 3px 10px 3px 0px;\n  font-size: 13px;\n  box-shadow: none;\n}\n@media screen and (min-width: 1600px) {\n  .scan-doc-radio.ant-radio-button-wrapper {\n    font-size: 14px;\n  }\n}\n.scan-doc-radio.ant-radio-button-wrapper.ant-radio-button-wrapper-checked {\n  border-color: #051B30;\n  background-color: #cfd7d9;\n  color: #051B30;\n}\n.scan-doc-radio.ant-radio-button-wrapper:hover,\n.scan-doc-radio.ant-radio-button-wrapper:focus {\n  color: #051B30;\n  background-color: #cfd7d9;\n  border-color: #051B30;\n}\n.scan-doc-radio.ant-radio-button-wrapper:not(:first-child):before {\n  display: none;\n}\n.eligibilty-exam-form-parent {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.eligibilty-form-parent {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  max-height: 450px;\n  overflow-y: auto;\n}\n.eligibility-form-checkbx .ant-checkbox {\n  transform: scale(1.3);\n  transform-origin: top left;\n  margin-left: 15px;\n  width: 50%;\n}\n.eligibility-summary-parent {\n  border-radius: 08px;\n  padding: 08px 10px;\n  min-height: 94px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 10px;\n}\n.eligibility-form-select {\n  width: 215px !important;\n  color: #323a43 !important;\n  border-radius: 06px !important;\n  border-color: #d9d9d9 !important;\n}\n.dark-theme .ant-modal-content .ant-select.eligibility-form-select-disabled {\n  background-color: #f5f5f5 !important;\n  width: 215px !important;\n  color: #545454 !important;\n  border-color: #d9d9d9 !important;\n}\n.dark-theme .ant-input-disabled.eligibility-form-input-disabled {\n  background-color: #f5f5f5 !important;\n  color: #545454 !important;\n  border-color: #d9d9d9 !important;\n}\n.dark-theme .ant-select-auto-complete.ant-select .ant-input-disabled {\n  background-color: rgba(29, 58, 87, 0.65) !important;\n}\n.dark-theme .form-desc .ant-popover-inner-content {\n  background: #fff !important;\n  color: #333;\n}\n.dark-theme .form-desc .ant-popover-arrow {\n  background: #fff !important;\n  border-color: #fff !important;\n}\n.dark-theme .form-desc .ant-descriptions-item-content {\n  background: #fff !important;\n  color: #535353 !important;\n}\n.gx-app-login-content .ant-form-item-label {\n  line-height: 50px;\n}\n.dark-theme .gx-app-login-content .ant-input {\n  background-color: transparent !important;\n}\n.dark-theme .visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {\n  color: #bebebe;\n  font-size: 13px;\n}\n@media screen and (min-width: 1600px) {\n  .dark-theme .visit-detail-bg .ant-form .ant-row.ant-form-item .ant-form-item-label > label {\n    font-size: 14px;\n  }\n}\n.dark-theme .visit-detail-bg .patient-info-input.ant-input-disabled,\n.dark-theme .visit-detail-bg .ant-calendar-picker-input.ant-input-disabled,\n.dark-theme .visit-detail-bg .patient-info-input .ant-input-disabled {\n  background-color: rgba(29, 58, 87, 0.65) !important;\n  color: #ffffff !important;\n}\n.dark-theme .visit-detail-bg .patient-info-select,\n.dark-theme .visit-detail-bg .visit-custom-select {\n  color: #ffffff;\n}\n.dark-theme .visit-detail-bg .patient-info-select .ant-select-selection,\n.dark-theme .visit-detail-bg .visit-custom-select .ant-select-selection {\n  background-color: rgba(20, 40, 60, 0.65);\n  border-color: rgba(20, 40, 60, 0.65);\n}\n.dark-theme .visit-detail-bg .patient-info-select.ant-select-disabled,\n.dark-theme .visit-detail-bg .visit-custom-select.ant-select-disabled {\n  color: rgba(255, 255, 255, 0.3) !important;\n}\n.dark-theme .visit-detail-bg .patient-info-select.ant-select-disabled .ant-select-selection,\n.dark-theme .visit-detail-bg .visit-custom-select.ant-select-disabled .ant-select-selection {\n  background-color: rgba(29, 58, 87, 0.65) !important;\n  border-color: rgba(29, 58, 87, 0.65) !important;\n  color: rgba(255, 255, 255, 0.3) !important;\n}\n.dark-theme .visit-detail-bg .form-select .ant-select-selection {\n  background-color: rgba(20, 40, 60, 0.65);\n  border-color: rgba(20, 40, 60, 0.65);\n  line-height: 38px;\n  height: 36px;\n}\n.dark-theme .visit-detail-bg .form-select .ant-select-selection .ant-select-selection__placeholder {\n  line-height: 20px;\n}\n.dark-theme .visit-detail-bg .form-select.ant-select-disabled .ant-select-selection {\n  background-color: rgba(29, 58, 87, 0.65);\n  border-color: rgba(250, 250, 250, 0.1);\n  color: #b9b9b9;\n}\n.dark-theme .green-button {\n  background-color: #14B983;\n  color: #ffffff;\n  height: 40px;\n  font-weight: 600;\n  border-radius: 20px;\n  border: none;\n  font-size: 12px;\n  min-height: 38px;\n}\n@media screen and (min-width: 1600px) {\n  .dark-theme .green-button {\n    min-height: 40px;\n    font-size: 14px;\n  }\n}\n.dark-theme .green-button:hover,\n.dark-theme .green-button :focus {\n  background-color: #12a273;\n  color: #fff;\n}\n.dark-theme .site__card {\n  background-color: #434f5a !important;\n}\n.dark-theme .custom-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  min-width: 425px;\n  min-height: 400px;\n  background: #0B2B41 !important;\n  color: white;\n  border-radius: 16px;\n}\n.dark-theme .authenticator-heading {\n  font-size: 25px;\n  color: #FFFFFF;\n  margin: 0;\n}\n.dark-theme .sub-heading {\n  font-weight: 300;\n  font-size: 20px;\n  color: #E9F6FF;\n}\n.dark-theme .ant-layout-sider,\n.dark-theme .gx-layout-sider-dark {\n  color: #fff !important;\n}\n.dark-theme .ant-calendar-year-panel-year {\n  color: #fff;\n}\n.dark-theme .rbc-timeslot-group {\n  border-bottom: 0px !important;\n}\n.dark-theme .rbc-time-content > * + * > * {\n  border-left: 0px !important;\n}\n.patientinfo-form .ant-form-item-label[class*='ant-col-'] {\n  padding: 0px !important;\n}\n.patientinfo-form .ant-form-item-sm .ant-form-item-label {\n  text-align: right !important;\n}\n.user-role-selection .cardH {\n  background: #fff !important;\n}\n.gx-login-header img {\n  max-width: 100px;\n  margin: auto;\n  display: block;\n}\n.rbc-time-content > * + * > * {\n  border: 1px solid #ffffff !important;\n}\n.rbc-events-container {\n  border: 1px solid #ffffff !important;\n}\n.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {\n  border: 1px solid #ffffff !important;\n  background-color: #D8DDE2 !important;\n  color: #051B30;\n}\n.rbc-time-slot {\n  display: flex;\n  align-items: center;\n}\n.calendar-container {\n  margin: 0px;\n  height: 100% !important;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar {\n  padding: 15px !important;\n  padding-top: 0px !important;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-view {\n  padding: 0px 3px;\n  border: 1px solid #D8DFE5;\n  border-radius: 5px;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .ant-form {\n  position: sticky;\n  top: 0px;\n  z-index: 999;\n  background: #051B30;\n  margin-bottom: 2px;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header {\n  position: sticky;\n  top: 36px;\n  z-index: 10;\n  padding: 20px 0px;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header .rbc-header {\n  border-bottom: none;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header .rbc-time-header-content {\n  display: flex;\n  gap: 08px;\n  border: none;\n}\n.calendar-container .rbc-addons-dnd.rbc-calendar .ant-form,\n.calendar-container .rbc-addons-dnd.rbc-calendar .rbc-time-header {\n  background: #F1F1F1;\n}\n.calendar-container .rbc-toolbar {\n  position: sticky !important;\n  top: 0px !important;\n  z-index: 999;\n  background: #E0E0E0 !important;\n  padding-top: 15px !important;\n}\n.calendar-container .selected__row {\n  background-color: transparent !important;\n}\n.calendar-container #calendar .ant-card-body {\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n.calendar-container .rbc-time-view-resources .rbc-header,\n.calendar-container .rbc-time-view-resources .rbc-day-bg {\n  color: #051B30;\n  font-weight: 600;\n}\n.calendar-container .rbc-time-view-resources .rbc-time-header-gutter {\n  background-color: transparent;\n  border: none;\n}\n.calendar-container .calendar-button-navigation {\n  margin: 0;\n  background: transparent;\n  border: none;\n  color: #606E7B;\n  padding: 0;\n  font-size: 10px;\n}\n.calendar-container .calendar-button-navigation span {\n  color: #606E7B;\n}\n.calendar-container .calendar-button-navigation:hover {\n  background: none;\n  color: #038fde;\n}\n.calendar-container .calendar-select {\n  width: 80px;\n}\n.calendar-container .calendar-button {\n  margin: 0;\n  background: transparent;\n  border: none;\n  color: #606E7B;\n}\n.calendar-container .calendar-button span {\n  color: #606E7B;\n}\n.calendar-container .calendar-date-picker.ant-calendar-picker,\n.calendar-container .calendar-date-picker.ant-calendar-picker + span {\n  color: #14283C !important;\n  font-weight: 500 !important;\n  font-size: 14px;\n}\n.calendar-container .calendar-date-picker.ant-calendar-picker .ant-calendar-picker-icon,\n.calendar-container .calendar-date-picker.ant-calendar-picker + span .ant-calendar-picker-icon {\n  color: #14283C;\n}\n.calendar-container .calendar-date-picker .ant-calendar-picker-input,\n.calendar-container .calendar-date-picker .ant-calendar-picker-input::placeholder {\n  color: #14283C;\n}\n.dashboard-calendar .calendar-container .rbc-addons-dnd.rbc-calendar {\n  padding: 0px !important;\n}\n#calendar .rbc-timeslot-group {\n  min-height: 40px !important;\n}\n#calendar .rbc-day-slot .rbc-event-content {\n  overflow: auto;\n}\n#calendar .rbc-day-slot .rbc-event-content .ant-dropdown-trigger {\n  height: 100%;\n}\n#calendar .rbc-day-slot .rbc-event {\n  min-height: 40px;\n  padding: 5px;\n}\n#calendar .rbc-day-slot .rbc-time-slot {\n  border: none;\n}\n.calendar-card {\n  height: 97% !important;\n  margin-bottom: 0px !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  z-index: 10;\n}\n.calendar-card .ant-card-body {\n  height: 100%;\n}\n/*Agenda View*/\n.rbc-agenda-view {\n  border: 1px solid #e8e8e8;\n  padding: 5px;\n  border-radius: 6px;\n  background: #ffffff;\n}\n.dark-theme .rbc-agenda-view {\n  background: transparent;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  border: none;\n  color: #ffffff;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 8px;\n  border: none;\n  min-width: 180px !important;\n  color: #606E7B;\n}\n.dark-theme .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  color: #D8DFE5;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th:nth-child(3) {\n  text-align: center;\n}\n@media screen and (min-width: 1600px) {\n  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n    font-size: 14px;\n  }\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr {\n  border: none !important;\n  color: #383838 !important;\n  opacity: 1 !important;\n  border-bottom: 2px solid #d2dae1 !important;\n  font-weight: 600;\n}\n.dark-theme .rbc-agenda-view table.rbc-agenda-table tbody > tr {\n  color: #ffffff !important;\n  border-color: #0b2e4f;\n  font-weight: 500;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 10px;\n  min-width: 180px !important;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border: none;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr:last-child {\n  border: none !important;\n}\n.rbc-agenda-table tbody tr[style] {\n  background-color: transparent !important;\n}\n.dark-theme .calendar-button {\n  color: #BDBDBD;\n}\n.dark-theme .calendar-button span {\n  color: #BDBDBD;\n}\n.dark-theme .calendar-button-selected {\n  color: #ffffff;\n}\n.dark-theme .rbc-time-header {\n  background: #071b2c;\n}\n.dark-theme .rbc-today {\n  background-color: transparent !important;\n}\n.dark-theme .rbc-label {\n  color: #BDBDBD;\n}\n.dark-theme .rbc-time-content {\n  border-top: none;\n}\n.dark-theme .rbc-time-view-resources .rbc-time-gutter {\n  background-color: transparent !important;\n  border: none;\n}\n.dark-theme .rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {\n  border: 1px solid #051B30 !important;\n  background-color: #051B30 !important;\n  color: #ffffff;\n}\n.dark-theme .calendar-container .rbc-calendar {\n  background-color: transparent !important;\n}\n.dark-theme .calendar-container .rbc-calendar .rbc-time-view {\n  border: 1px solid #e8e8e8;\n}\n.dark-theme .calendar-container .rbc-calendar .rbc-time-header,\n.dark-theme .calendar-container .rbc-calendar .ant-form {\n  background: #051B30;\n}\n.dark-theme .calendar-container .rbc-calendar .rbc-toolbar {\n  background: #E0E0E0 !important;\n}\n.dark-theme .calendar-container .rbc-time-view-resources .rbc-header,\n.dark-theme .calendar-container .rbc-time-view-resources .rbc-day-bg {\n  color: #ffffff;\n  font-weight: 500;\n}\n.dark-theme .calendar-container .calendar-button,\n.dark-theme .calendar-container .calendar-button span,\n.dark-theme .calendar-container .calendar-button-navigation span {\n  color: #BDBDBD;\n}\n.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker,\n.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker + span {\n  color: #ffffff !important;\n}\n.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker .ant-calendar-picker-icon,\n.dark-theme .calendar-container .calendar-date-picker.ant-calendar-picker + span .ant-calendar-picker-icon {\n  color: #BDBDBD;\n}\n.dark-theme .rbc-time-content > * + * > * {\n  border: 1px solid #051B30 !important;\n}\n.dark-theme .rbc-events-container {\n  border: 1px solid #051B30 !important;\n}\n.dark-theme .appointment-view-card .ant-form-item,\n.dark-theme .appointment-view-card .ant-form-item-label label,\n.dark-theme .appointment-view-card .ant-form-extra,\n.dark-theme .appointment-view-card .custom-input .ant-form-item label {\n  color: #545454 !important;\n}\n.dark-theme .appointment-view-card .appointment-card-extra {\n  color: #E0E0E0 !important;\n}\n.has-error .ant-input,\n.has-error .ant-input:hover,\n.has-error .ant-input-affix-wrapper .ant-input,\n.has-error .ant-input-affix-wrapper .ant-input:hover {\n  background-color: transparent;\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-explain {\n  font-size: 11px;\n}\n@media screen and (min-width: 1600px) {\n  .has-error .ant-form-explain,\n  .has-error .ant-form-explain {\n    font-size: 12px;\n  }\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-split {\n  color: #f5222d;\n}\n.dark-theme .has-error .ant-form-explain,\n.dark-theme .has-error .ant-form-split {\n  color: #f5222d;\n}\n.invoices-table .ant-input {\n  text-align: right;\n  margin: 3px 0;\n}\n.invoices-table .invoice-item {\n  border-bottom: 1px solid #ddd;\n}\n.ant-popover-buttons {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.custom-datepicker {\n  width: 100% !important;\n}\n.gx-avatar-name {\n  font-size: 12px;\n}\n.editable-cell {\n  position: relative;\n}\n.editable-cell-value-wrap {\n  cursor: pointer;\n}\n.editable-row:hover .editable-cell-value-wrap,\n.mrt-input,\n.editable-cell-value-wrap,\n.editable-row .editable-cell-value-wrap,\n.editable-cell-value-wrap {\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  padding: 7px 11px !important;\n  height: 29px !important;\n  width: 98px !important;\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.report-editor-search {\n  width: 270px !important;\n}\n.report-sidebar-tree-icon {\n  line-height: 28px !important;\n}\n.report-sidebar .ant-tree-icon__docu,\n.report-sidebar .ant-tree-icon__open {\n  display: none !important;\n}\n.cke_bottom .cke_reset_all,\n.cke_path {\n  display: none !important;\n}\n.ant-divider-horizontal {\n  margin: 6px 0 !important;\n}\n.gx-app-sidebar.gx-mini-sidebar .sidebar-username {\n  margin-left: 50px !important;\n}\n.gx-app-sidebar.gx-mini-sidebar .gx-avatar-name {\n  font-size: 12px;\n  margin-left: 18px;\n}\n.create-visit-icon:hover {\n  cursor: pointer;\n}\n.gx-main-content-wrapper {\n  padding: 15px;\n  width: 100%;\n}\n#calendar .gx-card-body,\n#calendar .ant-card-body,\n#calendar .ant-card-head,\n#calendar .ant-card-head-title {\n  padding-left: 0px !important;\n}\n#calendar .ant-card-extra,\n#calendar .ant-card-head-title {\n  padding-bottom: 0px !important;\n  padding-top: 0px;\n}\n#calendar .ant-card-body {\n  padding-top: 0px !important;\n}\n.ant-tree.ant-tree-show-line li span.ant-tree-switcher {\n  background: transparent !important;\n}\n.dark-theme .rbc-time-header-content > .rbc-row.rbc-row-resource {\n  color: #fff !important;\n  border: none;\n}\n.dark-theme .rbc-time-header-content .rbc-allday-cell {\n  display: none !important;\n}\n.rbc-label {\n  font-size: 12px;\n}\n@media screen and (min-width: 1600px) {\n  .rbc-label {\n    font-size: 15px;\n    font-weight: 500;\n  }\n}\n.dark-theme .calendar-container.lineup .rbc-label {\n  color: #fff;\n}\n.rbc-day-slot .rbc-events-container {\n  margin-right: 0px !important;\n}\n.rbc-event-label {\n  display: none !important;\n}\n.add-modality-btn {\n  float: right;\n}\n.dark-theme .ant-descriptions-item-content {\n  color: #fff !important;\n}\n.dark-theme .calendar-date-setup-header-changes {\n  color: #fff !important;\n}\n.calendar-card {\n  color: #545454 !important;\n}\n@media screen and (max-width: 767px) {\n  .report-sidebar-container {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n}\n.cutom-login-modal {\n  width: 385px !important;\n}\n.ant-modal-header,\n.ant-modal-body,\n.custom-login-body {\n  margin-top: 10px;\n}\n.custom-login-body.ant-drawer {\n  margin-top: 0px;\n}\n.terms-container {\n  margin: auto !important;\n  padding: 20px;\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .report-viewer-sidebar {\n    height: 503px !important;\n    padding: 0px !important;\n  }\n}\n.report-viewer-sidebar .ant-card-body {\n  padding: 5px;\n}\n.gx-header-horizontal-nav .gx-avatar {\n  height: 40px;\n  width: 40px;\n}\n.gx-header-horizontal-top {\n  padding: 7px 0px !important;\n}\n.custom-calendar .ant-calendar-picker-icon {\n  display: none !important;\n}\n.patient-modal .ant-modal-footer .ant-btn,\n.examination-modal .ant-modal-footer .ant-btn,\n.doctor-modal .ant-modal-footer .ant-btn {\n  height: auto;\n  font-size: 14px;\n  border-radius: 4px;\n}\n@media screen and (min-width: 1600px) {\n  .patient-modal .ant-modal-footer .ant-btn,\n  .examination-modal .ant-modal-footer .ant-btn,\n  .doctor-modal .ant-modal-footer .ant-btn {\n    font-size: 16px;\n  }\n}\n.examination-modal {\n  width: 800px !important;\n}\n.examination-modal .ant-form-item-label[class*='ant-col-'] {\n  padding: 0 0px !important;\n}\n.examination-modal .ant-form .ant-row {\n  margin-left: 0;\n}\n.examination-modal .ant-modal-body {\n  padding-top: 0;\n}\n.hl7-modal {\n  top: 0px !important;\n}\n.visit-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n.visit-footer .ant-btn-sm {\n  margin-bottom: 0px !important;\n}\n.btn-sidebar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.btn-sidebar-container .ant-btn-sm {\n  min-width: 70px;\n  float: right;\n  margin-right: 0px;\n}\n.note {\n  background-color: transparent;\n}\n.note-modal .notes-sidebar {\n  height: 150px !important;\n  overflow: scroll;\n  padding: 20px;\n}\n.note-modal .ant-modal-body {\n  padding-bottom: 0px;\n}\n.note-modal .btn-note {\n  padding: 2px 14px;\n  border: none;\n}\n@media screen and (min-width: 1024px) {\n  .active-appointment-form .ant-time-picker {\n    width: 100% !important;\n  }\n  .active-appointment-form .ant-input-number {\n    width: 80% !important;\n  }\n  .active-appointment-form .description-input {\n    width: 103% !important;\n    margin-left: -15px !important;\n  }\n}\n.instructions .ant-form-item-label > label::after {\n  content: none;\n}\n.edit-appointment-patient .ant-form-item-control-wrapper {\n  display: block !important;\n}\n.upload-document label::after {\n  content: none !important;\n}\n@media screen and (min-width: 767px) and (max-width: 1023px) {\n  .active-appointment-form .ant-input-number {\n    width: 75% !important;\n  }\n  .site__card .site__card-head-title {\n    width: 115px !important;\n  }\n}\n.delete-attachment {\n  position: absolute !important;\n  right: 20px;\n  top: 70px;\n}\n.print-attachment {\n  position: absolute !important;\n  right: 20px;\n  top: 70px;\n}\n.visit-delete-attachment {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}\n.custom-delete-btn {\n  height: 28px;\n  line-height: 28px;\n  min-width: 28px;\n}\n/* appointment calendar */\n.rbc-event.roster-event {\n  width: 20% !important;\n  left: 0 !important;\n  right: auto !important;\n  border: none !important;\n}\n@media screen and (min-width: 1600px) {\n  .rbc-event.roster-event {\n    width: 15% !important;\n  }\n}\n.rbc-event:not(.roster-event) {\n  left: auto !important;\n  right: 0 !important;\n}\n.menu-section-title {\n  font-size: 12px;\n  display: block;\n  font-weight: 500;\n  color: #05b9ba;\n}\n@media screen and (min-width: 1600px) {\n  .menu-section-title {\n    font-size: 13px;\n  }\n}\n.dark-theme .menu-section-title {\n  color: #ffffff;\n}\n.sidebar-footer {\n  position: absolute;\n  bottom: 5px;\n  left: 0;\n  right: 0;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  justify-content: space-between;\n}\n.sidebar-footer p {\n  margin-bottom: 0px;\n}\n.ant-layout-sider-collapsed .sidebar-footer {\n  padding: 8px;\n  justify-content: center;\n}\n.gx-layout-sider-header > svg.toggle-icon {\n  right: -6px;\n  position: absolute;\n  width: 30px;\n  height: 36px;\n  cursor: pointer;\n}\n.ant-layout-sider-collapsed svg.toggle-icon {\n  transform: rotateY(180deg);\n}\n.ant-layout-sider-collapsed .gx-site-logo {\n  margin-right: 8px;\n}\n.gx-layout-sider-scrollbar {\n  height: calc(100vh - 145px) !important;\n}\n.gx-layout-sider-scrollbar::-webkit-scrollbar {\n  width: 3px;\n}\n.gx-app-sidebar:not(.ant-layout-sider-collapsed) #custom-sidebar .ant-menu,\n.gx-drawer-sidebar #custom-sidebar .ant-menu {\n  padding-bottom: 96px;\n}\n.dark-mode-toggle .custom-switch.ant-switch {\n  width: auto;\n  padding: 6px 8px;\n  height: auto;\n}\n.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch {\n  padding: 10px;\n  min-width: 38px;\n}\n.dark-mode-toggle .custom-switch.ant-switch .ant-switch-inner {\n  font-size: 14px;\n  font-weight: 600;\n}\n.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch .ant-switch-inner {\n  display: none;\n}\n.dark-mode-toggle .custom-switch.ant-switch::after {\n  width: 20px;\n  height: 20px;\n  top: 6px;\n}\n.ant-layout-sider-collapsed .dark-mode-toggle .custom-switch.ant-switch::after {\n  width: 14px;\n  height: 14px;\n  top: 3px;\n}\n.dark-mode-toggle .custom-switch.ant-switch.ant-switch-checked::after,\n.dark-mode-toggle.success .ant-switch-checked {\n  background: #37A2B7;\n}\n.dark-mode-toggle .ant-switch-checked {\n  background-color: #0c1a27;\n}\n.dark-mode-toggle .custom-switch.ant-switch.ant-switch-checked::after {\n  background: #ffffff;\n}\n.dark-mode-toggle.critical .ant-switch-checked {\n  background-color: #EF5555;\n}\n.ant-menu-inline-collapsed-tooltip a {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n/*Custom styled modal*/\n.ant-modal-confirm.styled-modal .ant-modal-body {\n  padding: 25px;\n  height: 275px;\n  width: 420px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.ant-modal-confirm.styled-modal .ant-modal-confirm-body {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.ant-modal-confirm.styled-modal .ant-modal-confirm-btns {\n  float: none;\n  margin-top: 0px;\n}\n.ant-modal-confirm.styled-modal .ant-modal-confirm-btns button.ant-btn {\n  min-height: 40px;\n  padding: 0 25px;\n}\n/*Confirm modal Cancel visit*/\n.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-body > .anticon {\n  margin-right: 10px;\n}\n.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-left: 0px;\n}\n.ant-modal-confirm-confirm.cancel-visit-modal .ant-modal-confirm-btns button + button {\n  margin-left: 0px;\n}\n.dark-theme .rbc-time-content .rbc-current-time-indicator {\n  border-color: #FFFFFF !important;\n}\nform.edit-appointment-patient .ant-btn.ant-btn-primary {\n  box-shadow: none;\n}\nform.edit-appointment-patient .search-box .ant-btn.ant-btn-primary {\n  min-height: 40px;\n}\nform.edit-appointment-patient .search-box .ant-input {\n  background: #E8E8E8;\n  border: none;\n  margin-bottom: 0px;\n  color: #7E7E7E;\n  outline: none;\n  height: 40px;\n}\nform.edit-appointment-patient .search-box .ant-input:hover,\nform.edit-appointment-patient .search-box .ant-input:focus {\n  border: none;\n  outline: none;\n}\nform.edit-appointment-patient .search-box .ant-input::placeholder {\n  color: #a9b1b8;\n}\nform.edit-appointment-patient .search-box .ant-form-item .anticon {\n  color: #7E7E7E;\n}\nform.edit-appointment-patient .search-box .ant-form-item .anticon.anticon-close-circle {\n  height: 20px;\n  width: 20px;\n}\n.lock-event {\n  display: block;\n  min-height: 30px;\n  width: 100%;\n}\n.ant-popover-inner,\n.ant-popover-arrow {\n  background-color: #ffffff;\n  box-shadow: 0 0 4px rgba(61, 60, 60, 0.28);\n}\n.dark-theme .ant-popover-inner,\n.dark-theme .ant-popover-arrow {\n  background-color: #051B30;\n}\n.ant-popover-title {\n  color: #000000;\n  border: none;\n}\n.dark-theme .ant-popover-title {\n  color: #E9F6FF;\n}\n.ant-popover-inner-content {\n  padding: 10px 16px 12px;\n}\n.ant-popover-inner-content .ant-card.appointment-card {\n  padding: 0px;\n  margin: 0px;\n  background: transparent;\n  font-size: 12px;\n  max-width: 325px;\n  color: #1e1e1e;\n  font-weight: 500;\n}\n.dark-theme .ant-popover-inner-content .ant-card.appointment-card {\n  color: #ffffff;\n  font-weight: 400;\n}\n.ant-popover-inner-content .ant-card.appointment-card .ant-card-body {\n  padding: 0px;\n}\n.ant-popover-inner-content .ant-card.appointment-card .appointment-status {\n  background: #e0fafa;\n  border: 1px solid #9ef0f0;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #295e64;\n}\n.dark-theme .ant-popover-inner-content .ant-card.appointment-card .appointment-status {\n  background: #1a3c40;\n  color: #9ef0f0;\n  border-color: transparent;\n}\n.ant-popover-inner-content .ant-card.appointment-card .appointment-status::before {\n  content: \"●\";\n  font-size: 14px;\n  margin-right: 4px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-popover-inner-content .ant-card.appointment-card .appointment-status::before {\n    font-size: 16px;\n  }\n}\n.ant-popover-inner-content .ant-card.appointment-card .patient-info {\n  margin-top: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #051B30;\n}\n.dark-theme .ant-popover-inner-content .ant-card.appointment-card .patient-info {\n  color: #ffffff;\n}\n.ant-popover-inner-content .ant-card.appointment-card.minWidth {\n  min-width: 300px;\n}\n.no-data-note {\n  font-size: 15px;\n  color: #051B30;\n  padding: 10px 5px;\n  border-radius: 4px;\n  line-height: 1.4;\n  margin: 0px;\n}\n.dark-theme .no-data-note {\n  background-color: #14283C;\n  color: #9BA4AC;\n}\n.white-box {\n  background: #FFF;\n  border-radius: 8px;\n  padding: 12px;\n  width: 100%;\n  margin-top: 10px;\n}\n.white-box .add-new-slot-button {\n  min-width: 128px;\n  height: auto;\n  color: #089265;\n  border: 1px solid #089265;\n  border-radius: 20px;\n  font-weight: 600;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n}\n.white-box .add-new-slot-button:hover,\n.white-box .add-new-slot-button:focus {\n  color: #089265;\n  border: 1px solid #089265;\n  box-shadow: none;\n}\n.white-box .remove-event-button {\n  background: #ECECEC;\n  color: #8B9293;\n  border: none;\n  padding: 8px 12px;\n  min-height: 38px;\n  line-height: 1.3;\n}\n.white-box .remove-event-button:hover,\n.white-box .remove-event-button:focus {\n  background: #d3d3d3;\n  color: #8B9293;\n  border: none;\n}\n.white-box .appointment-form-input,\n.white-box .form-input {\n  padding: 0 8px;\n  border: 1px solid #F3F3F3;\n  min-width: 190px;\n  max-width: 190px;\n  font-size: 12px;\n  color: #6B6B6B;\n  border-radius: 4px;\n  min-height: 38px;\n  line-height: 1.8;\n}\n.white-box .appointment-form-input:hover,\n.white-box .form-input:hover,\n.white-box .appointment-form-input:focus,\n.white-box .form-input:focus {\n  box-shadow: none;\n  border-color: #e4e4e4;\n}\n.white-box .appointment-form-input .ant-calendar-picker-input.ant-input,\n.white-box .form-input .ant-calendar-picker-input.ant-input,\n.white-box .appointment-form-input .ant-time-picker-input,\n.white-box .form-input .ant-time-picker-input {\n  border: none;\n  box-shadow: none;\n  color: #6B6B6B;\n  padding: 0px 4px;\n  height: 36px;\n  margin: 0px;\n  border-radius: 0;\n}\n.white-box .appointment-form-input .ant-calendar-picker-input.ant-input:hover,\n.white-box .form-input .ant-calendar-picker-input.ant-input:hover,\n.white-box .appointment-form-input .ant-time-picker-input:hover,\n.white-box .form-input .ant-time-picker-input:hover,\n.white-box .appointment-form-input .ant-calendar-picker-input.ant-input:focus,\n.white-box .form-input .ant-calendar-picker-input.ant-input:focus,\n.white-box .appointment-form-input .ant-time-picker-input:focus,\n.white-box .form-input .ant-time-picker-input:focus {\n  border: none;\n  box-shadow: none;\n}\n.white-box .appointment-form-input .ant-calendar-picker-input.ant-input::placeholder,\n.white-box .form-input .ant-calendar-picker-input.ant-input::placeholder {\n  color: #a9b1b8;\n}\n.white-box .appointment-form-input .ant-select-arrow .ant-select-arrow-icon,\n.white-box .form-input .ant-select-arrow .ant-select-arrow-icon,\n.white-box .appointment-form-input .anticon,\n.white-box .form-input .anticon {\n  color: #6B6B6B;\n}\n.white-box .appointment-form-input.ant-calendar-picker,\n.white-box .form-input.ant-calendar-picker {\n  padding: 0;\n}\n@media screen and (min-width: 1600px) {\n  .white-box .appointment-form-input,\n  .white-box .form-input {\n    font-size: 14px;\n  }\n}\n.white-box .form-select {\n  border: 1px solid #F3F3F3;\n  min-width: 190px;\n  max-width: 190px;\n  border-radius: 4px;\n  min-height: 36px;\n}\n.white-box .form-select .ant-select-selection {\n  border: none;\n  box-shadow: none;\n}\n.white-box .form-select .ant-select-selection__rendered {\n  top: 1px;\n  line-height: 36px;\n}\n.white-box .form-select .ant-select-selection__rendered .ant-select-selection__placeholder,\n.white-box .form-select .ant-select-selection__rendered .ant-select-search__field__placeholder {\n  margin-top: -12px;\n  color: #a9b1b8;\n}\n.white-box .form-select .ant-select-arrow {\n  top: 16px;\n}\n.white-box .form-select .ant-select-selection-selected-value {\n  color: #6B6B6B;\n  line-height: 35px;\n}\n.white-box .form-select .ant-select-arrow .ant-select-arrow-icon,\n.white-box .form-select .anticon {\n  color: #6B6B6B;\n}\n.white-box .form-select.ant-select-auto-complete.ant-select .ant-input {\n  color: #6B6B6B;\n  border: none;\n}\n.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:hover,\n.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:focus,\n.white-box .form-select.ant-select-auto-complete.ant-select .ant-input:active {\n  border: none;\n  box-shadow: none;\n}\n.white-box .form-select .ant-select-search--inline .ant-select-search__field {\n  color: #6B6B6B;\n}\n.white-box .ant-select-selection-selected-value {\n  color: #fff;\n}\n.white-box .appointment-form-input::placeholder {\n  color: #a9b1b8;\n}\n.white-box .view-appointment-patient.drawer-form .ant-form-item,\n.white-box .drawer-form .ant-form-item {\n  margin-right: 6px;\n}\n.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label,\n.white-box .drawer-form .ant-form-item .ant-form-item-label {\n  min-width: 96px;\n  text-align: left;\n}\n.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label,\n.white-box .drawer-form .ant-form-item .ant-form-item-label label {\n  color: #6B6B6B;\n  padding-left: 7px;\n  font-size: 12px;\n  font-weight: 600;\n}\n.white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label::before,\n.white-box .drawer-form .ant-form-item .ant-form-item-label label::before {\n  position: absolute;\n  left: 0px;\n  top: -5px;\n  font-size: 12px;\n}\n@media screen and (min-width: 1600px) {\n  .white-box .view-appointment-patient.drawer-form .ant-form-item .ant-form-item-label label,\n  .white-box .drawer-form .ant-form-item .ant-form-item-label label {\n    font-size: 14px;\n  }\n}\n.white-box .appointment-form-input.ant-calendar-picker .ant-form-item-control,\n.white-box .form-input .ant-time-picker-input .ant-form-item-control,\n.white-box .appointment-form-input.ant-calendar-picker > .ant-form-item-label,\n.white-box .form-input .ant-time-picker-input > .ant-form-item-label {\n  line-height: 24px;\n}\n.white-box .ant-form-item {\n  padding: 0px;\n  margin: 0px 3px 10px;\n  border: none;\n  box-shadow: none;\n}\n.white-box .ant-form-item .ant-form-item-control,\n.white-box .ant-form-item > .ant-form-item-label {\n  line-height: 32px;\n}\n.white-box h3 {\n  color: #051B30;\n  font-weight: 600;\n  font-size: 16px;\n  margin: 0px 0px 10px;\n}\n.white-box .ant-list-item,\n.white-box .ant-list-item-meta-description,\n.white-box .ant-list-item-meta-title {\n  color: #051B30;\n}\n.white-box .ant-list-split.ant-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n.white-box .ant-list-split .ant-list-item {\n  border-color: #F3F3F3;\n  padding: 6px 0;\n}\n.white-box .ant-list-item,\n.white-box .ant-list-item-meta-description,\n.white-box .ant-list-item-meta-title {\n  color: #051B30;\n}\n.white-box .ant-list-split.ant-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n.white-box .ant-list-split .ant-list-item {\n  border-color: #F3F3F3;\n  padding: 6px 0;\n}\n.white-box .ant-tabs .ant-tabs-bar {\n  border-bottom-color: #f5f5f5;\n}\n.white-box .ant-tabs .ant-tabs-ink-bar {\n  background-color: #0590DE;\n}\n.white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab {\n  color: #AAADAF;\n}\n.white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  color: #051B30;\n}\n@media screen and (min-width: 1600px) {\n  .white-box .ant-tabs .ant-tabs-nav .ant-tabs-tab {\n    font-size: 15px;\n  }\n}\n.white-box .scan-form-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-bottom: 15px;\n}\n.white-box .scan-form-row .ant-form-item-label label {\n  color: #6B6B6B;\n  font-weight: 600;\n}\n.white-box .ant-row-flex [class*='ant-col-'] {\n  padding: 0px;\n}\n.white-box .textarea-full,\n.white-box .textarea-full > .ant-form-item-control-wrapper {\n  width: 100%;\n}\n.white-box .textarea-full .form-input,\n.white-box .textarea-full > .ant-form-item-control-wrapper .form-input {\n  max-width: 98%;\n}\n.white-box.vertical {\n  margin: 0;\n}\n.white-box.vertical .ant-form-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.white-box.vertical .ant-form-item.full-width,\n.white-box.vertical .ant-form-item.full-width .ant-col {\n  width: 100%;\n  text-align: left;\n}\n.white-box.vertical .ant-form-item.full-width .form-input,\n.white-box.vertical .ant-form-item.full-width .ant-col .form-input,\n.white-box.vertical .ant-form-item.full-width .form-select,\n.white-box.vertical .ant-form-item.full-width .ant-col .form-select {\n  max-width: 100%;\n}\n.white-box.vertical .ant-form-item.recurring-dates input[type=\"text\"] {\n  border-radius: 20px;\n  border-color: #089265;\n  min-height: 36px;\n  padding-left: 15px;\n  color: #089265;\n}\n.white-box.vertical .ant-form-item.recurring-dates input[type=\"text\"]::placeholder {\n  color: #089265;\n}\n.white-box.vertical .ant-form-item.horizontal {\n  flex-direction: row;\n  align-items: center;\n}\n.white-box.vertical .ant-form-item .ant-form-item-label {\n  line-height: 2;\n}\n.white-box.vertical .ant-tabs {\n  overflow: visible;\n}\n.white-box .invoices-table {\n  color: #000000;\n}\n.white-box .invoices-table .ant-input,\n.white-box .invoices-table .ant-select,\n.white-box .invoices-table .ant-select-selection-selected-value {\n  color: #000000;\n  border-color: #f3f3f3;\n}\n.white-box .invoices-table .ant-select-selection {\n  border-color: #d9d9d9;\n  margin: 4px;\n  font-size: 14px;\n}\n.white-box .invoices-table .ant-calendar-picker {\n  padding-right: 4px;\n}\n.white-box .invoices-table .ant-calendar-picker .ant-calendar-picker-input {\n  color: #000000;\n  padding-right: 26px;\n}\n.white-box .invoices-table .ant-calendar-picker .ant-calendar-picker-icon {\n  color: #6B6B6B !important;\n}\n.white-box .invoices-table .ant-select-arrow .anticon {\n  color: #6B6B6B !important;\n}\n.white-box.listing-wrapper {\n  color: #222;\n  font-weight: 500;\n}\n.white-box.listing-wrapper .ant-table-body {\n  overflow-y: auto;\n}\n@media screen and (min-width: 1600px) {\n  .white-box.listing-wrapper .ant-table-body {\n    max-height: 400px;\n  }\n}\n.white-box.listing-wrapper .ant-table-body .ant-table-thead {\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n}\n.white-box.listing-wrapper .ant-table-body .ant-table-tbody > tr > td {\n  border-bottom-color: #ddd;\n  padding: 8px;\n  color: #222;\n}\n.white-box.listing-wrapper .ant-table-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background-color: #fefefe;\n}\n.white-box.listing-wrapper.no-white-onhover .ant-table-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background-color: transparent;\n}\n.white-box.listing-wrapper .no-data .ant-table-thead {\n  display: none;\n}\n.white-box .send-guidelines {\n  margin-bottom: 0px;\n  margin-left: 5px;\n  min-height: 38px;\n  line-height: 1;\n}\n.white-box .search-resources-input {\n  border: none;\n  background-color: #F8F8F8;\n  min-height: 40px;\n}\n.white-box .search-resources-input::placeholder {\n  color: #9BA4AC;\n}\n.white-box .search-resources-input .ant-input-suffix {\n  font-size: 18px;\n  top: 44%;\n}\n.white-box .search-resources-input .ant-input-suffix .ant-input-search-icon {\n  color: #595959;\n}\n.white-box.listing-wrapper .table-height-limit .ant-table-body {\n  max-height: 350px;\n}\n.white-box.listing-wrapper .warnings-drawer-table .ant-table-body {\n  max-height: calc(100vh - 250px);\n}\n.white-box .ant-input-password.form-input.ant-input-affix-wrapper {\n  padding: 0px;\n}\n.white-box .ant-input-password.form-input.ant-input-affix-wrapper input.ant-input {\n  min-height: 40px;\n  color: #000;\n}\n.dark-theme .white-box .ant-input-affix-wrapper .ant-input-suffix i {\n  color: #545454 !important;\n}\n.ant-form-inline .white-box .ant-form-item,\n.white-box .ant-form-inline .ant-form-item {\n  margin-bottom: 5px;\n}\n.ant-form-inline {\n  margin-left: 0px;\n  margin-right: -4px;\n}\n.ant-form-inline .white-box .ant-form-item,\n.white-box .ant-form-inline .ant-form-item {\n  margin-bottom: 5px;\n}\n.ant-form-inline {\n  margin-left: 0px;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  padding: 0 0 3px;\n}\n.checkbox-wrapper {\n  padding: 5px 0;\n}\n.checkbox-wrapper .ant-form-item {\n  margin: 0px 5px 10px;\n}\n.checkbox-wrapper .ant-form-item .ant-form-item-label {\n  padding-bottom: 0px;\n}\n.room-selector {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  padding: 0 8px;\n  flex-wrap: wrap;\n}\n.room-selector h3 {\n  margin-right: 6px;\n}\n.room-selector .room-selector-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n.room-selector .ant-radio-button-wrapper {\n  border: none;\n  background: #f1f5f5;\n  margin-left: 0;\n  border-radius: 6px !important;\n  padding: 11px 13px;\n  font-weight: 600;\n  color: #2e3a49;\n  transition: all 0.3s;\n  line-height: 1;\n}\n.room-selector .ant-radio-button-wrapper-checked {\n  background: #2ca6b9;\n  color: #fff !important;\n}\n.room-selector .ant-radio-button-wrapper:hover {\n  border-color: transparent;\n  background: #2ca6b9;\n  color: #fff;\n}\n.room-selector .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none !important;\n  background-color: transparent;\n}\n.ant-drawer-body {\n  width: 100%;\n  height: 97%;\n}\n.dark-theme .ant-drawer-body .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),\n.ant-input-search .ant-input,\n.ant-input-search .ant-input:hover {\n  border: none;\n  box-shadow: none;\n  color: #535353;\n}\n.tabs-wrapper .ant-tabs .ant-tabs-bar,\n.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-bar {\n  border-bottom-color: #D8DFE5;\n  border-bottom-width: 2px;\n  margin-bottom: 10px;\n}\n.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab,\n.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab {\n  color: #9BA4AC;\n}\n@media screen and (min-width: 1600px) {\n  .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab,\n  .dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab {\n    font-size: 18px;\n  }\n}\n.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,\n.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  color: #ffffff;\n}\n.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar,\n.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar {\n  background-color: #3CB2C9;\n}\n.dark-theme .tabs-wrapper .ant-tabs .ant-tabs-bar {\n  border-bottom-color: #0E2835;\n}\n.tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,\n.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active,\n.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n  color: #000;\n}\n.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-bar,\n.white-box .tabs-wrapper .ant-tabs .ant-tabs-bar,\n.white-table-container .ant-tabs .ant-tabs-bar,\n.dark-theme .white-table-container .ant-tabs .ant-tabs-bar {\n  border-color: #f5f5f5;\n}\n.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,\n.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,\n.white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab,\n.dark-theme .white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab {\n  color: #AAADAF;\n}\n.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,\n.white-box .tabs-wrapper .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,\n.white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active,\n.dark-theme .white-table-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active {\n  color: #3CB2C9;\n}\n.dark-theme .white-box .tabs-wrapper .ant-tabs-tabpane .ant-card-body,\n.white-box .tabs-wrapper .ant-tabs-tabpane .ant-card-body,\n.white-table-container .ant-tabs-tabpane .ant-card-body,\n.dark-theme .white-table-container .ant-tabs-tabpane .ant-card-body {\n  padding: 0px;\n}\n.dark-theme .white-box .tabs-wrapper .ant-tabs .ant-checkbox-wrapper,\n.white-box .tabs-wrapper .ant-tabs .ant-checkbox-wrapper,\n.white-table-container .ant-tabs .ant-checkbox-wrapper,\n.dark-theme .white-table-container .ant-tabs .ant-checkbox-wrapper {\n  color: #051B30;\n  font-weight: 600;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper,\n.white-box .tabs-wrapper .gx-card.listing-wrapper,\n.white-table-container .gx-card.listing-wrapper,\n.dark-theme .white-table-container .gx-card.listing-wrapper {\n  box-shadow: none;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table,\n.white-table-container .gx-card.listing-wrapper .ant-table,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table {\n  color: #383838;\n  border: none;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,\n.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-thead > tr > th {\n  border: none;\n  color: #383838;\n  background: #ffffff;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,\n.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td {\n  background: #ffffff;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,\n.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-input {\n  background-color: transparent;\n  color: #6B6B6B;\n  border-color: #F3F3F3;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,\n.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr > td .ant-switch.ant-switch-checked {\n  background-color: #03AD6F;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #F8F8F8;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next {\n  border-color: #f5f5f5;\n  background: #f5f5f5;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev.ant-pagination-disabled,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next.ant-pagination-disabled {\n  color: #D2D2D2;\n  line-height: 1.8;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus {\n  background: #dcdcdc;\n  color: #051B30;\n  border: none;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:hover .ant-pagination-item-link,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:hover .ant-pagination-item-link,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev:focus .ant-pagination-item-link,\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next:focus .ant-pagination-item-link {\n  border: none;\n  color: #051B30;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item {\n  background-color: #ffffff;\n  color: #444444;\n  border-color: #F3F3F3;\n  margin: 0 5px;\n}\n.dark-theme .white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,\n.white-box .tabs-wrapper .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,\n.white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a,\n.dark-theme .white-table-container .gx-card.listing-wrapper .ant-table-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a {\n  color: #444444;\n}\n.white-table-container #sites-table .ant-table-body {\n  max-height: 200px;\n  overflow-y: auto;\n}\n.white-table-container #sites-table .ant-table-thead {\n  position: sticky;\n  top: 0px;\n  background: #fff;\n  z-index: 10;\n}\n.gx-card.listing-wrapper .ant-form-inline .ant-row {\n  padding-left: 4px;\n  padding-right: 4px;\n  margin-bottom: 0px;\n}\n.gx-card.listing-wrapper .ant-form-inline .ant-row .ant-form-item-control {\n  line-height: normal;\n}\n.gx-card.listing-wrapper .ant-form-inline .ant-row {\n  padding-left: 4px;\n  padding-right: 4px;\n  margin-bottom: 0px;\n}\n.gx-card.listing-wrapper .ant-form-inline .ant-row .ant-form-item-control {\n  line-height: normal;\n}\n.gx-card.listing-wrapper .ant-select {\n  color: #9BA4AC;\n}\n.gx-card.listing-wrapper .ant-select .ant-select-selection {\n  min-height: 40px;\n  border: 1px solid transparent;\n}\n.gx-card.listing-wrapper .ant-select .ant-select-selection:hover,\n.gx-card.listing-wrapper .ant-select .ant-select-selection:focus {\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.gx-card.listing-wrapper .ant-select .ant-select-selection .ant-select-selection__rendered {\n  line-height: 38px;\n  color: #545454;\n  margin-left: 10px;\n}\n.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection .ant-select-selection__rendered {\n  color: #ffffff;\n}\n.gx-card.listing-wrapper .ant-table-tbody td .ant-select .ant-select-selection {\n  background-color: #e4e4e4;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody td .ant-select .ant-select-selection {\n  background-color: #051B30;\n}\n.gx-card.listing-wrapper .ant-input {\n  min-height: 40px;\n  border: 1px solid transparent;\n}\n.gx-card.listing-wrapper .ant-input:hover,\n.gx-card.listing-wrapper .ant-input:focus {\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.gx-card.listing-wrapper .ant-input ::placeholder {\n  color: #9BA4AC;\n}\n.gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions {\n  background: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions {\n  background: transparent;\n}\n.gx-card.listing-wrapper .ant-table-thead > tr > th.ant-table-column-has-actions:hover {\n  background: #ffffff;\n}\n.gx-card.listing-wrapper .ant-table-body .ant-table-row-expand-icon {\n  font-size: 18px;\n  color: #265077;\n  border-color: #354D65;\n}\n.gx-card.listing-wrapper .ant-table-thead > tr > th {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px;\n  background: #ffffff;\n  border: none;\n}\n.gx-card.listing-wrapper .ant-table-tbody > tr > td,\n.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  padding: 12px 16px;\n  background: #ffffff;\n  font-weight: 500;\n  border-bottom: none;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr > td,\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  font-weight: 400;\n}\n@media screen and (min-width: 1600px) {\n  .gx-card.listing-wrapper .ant-table-tbody > tr > td,\n  .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n    font-size: 14px;\n  }\n}\n.gx-card.listing-wrapper .ant-table-tbody > tr > td .status-icon,\n.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .status-icon {\n  width: 12px;\n  height: 12px;\n}\n.gx-card.listing-wrapper .ant-table-tbody > tr > td .icon,\n.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .icon {\n  color: #265077;\n}\n.gx-card.listing-wrapper .ant-table-tbody > tr > td .undo-icon,\n.gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td .undo-icon {\n  color: #265077;\n  font-size: 22px;\n  cursor: pointer;\n}\n.gx-card.listing-wrapper .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #f3f2f2;\n}\n.gx-card.listing-wrapper .icon-cmp-refresh {\n  color: #354D65;\n  font-size: 18px;\n  position: absolute;\n  top: 10px;\n  right: 5px;\n}\n.gx-card.listing-wrapper .icon-cmp-refresh.tab-icon {\n  right: 5px;\n  top: -40px;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item {\n  background-color: #ffffff;\n  border-color: #E5E5E5;\n  margin-bottom: 0px;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item {\n  background-color: #0c1a27;\n  border-color: #1c2730;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item a {\n  color: #545454;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item a {\n  color: #B8DFFB;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active {\n  border-color: #37A2B7;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active a {\n  color: #545454;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-item.ant-pagination-item-active a {\n  color: #ffffff;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next {\n  margin-bottom: 0px;\n  border: 1px solid #DDDDDD;\n  background-color: #DDDDDD;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next {\n  border: 1px solid #1c2730;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev a,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next a,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev a,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next a {\n  border: none;\n  background-color: #DDDDDD;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis {\n  color: #B8DFFB;\n  background-color: #ffffff;\n}\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:hover,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:hover,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:hover,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:hover,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:focus,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:focus,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:focus,\n.gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:focus {\n  background-color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis {\n  background-color: #0c1a27;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:hover,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:hover,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:hover,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:hover,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-prev span.ant-pagination-item-ellipsis:focus,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-next span.ant-pagination-item-ellipsis:focus,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-prev span.ant-pagination-item-ellipsis:focus,\n.dark-theme .gx-card.listing-wrapper .ant-table-pagination.ant-pagination > li.ant-pagination-jump-next span.ant-pagination-item-ellipsis:focus {\n  background-color: #0c1a27;\n}\n.gx-card.listing-wrapper .ant-calendar-picker {\n  width: 100%;\n}\n.gx-card.listing-wrapper .ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {\n  height: 18px;\n  color: #7E7E7E;\n  line-height: 10px;\n  padding: 3px 20px 3px 10px;\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n}\n.dark-theme .gx-card.listing-wrapper .ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li.ant-select-selection__choice {\n  background-color: #051B30;\n  border-color: #051B30;\n  color: #9BA4AC;\n}\n.gx-card.listing-wrapper .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 11px;\n  color: #9BA4AC;\n  top: 2px;\n}\n.dark-theme .gx-card.listing-wrapper .ant-input {\n  background-color: #082139;\n  border-color: #082139;\n  color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-input:hover,\n.dark-theme .gx-card.listing-wrapper .ant-input:focus {\n  border-color: #082139;\n}\n.dark-theme .gx-card.listing-wrapper .ant-btn {\n  min-height: 40px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection {\n  background-color: #082139;\n  border-color: #082139;\n  color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-select .ant-select-selection {\n  background-color: #082139;\n  border-color: #082139;\n  color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper .ant-form-inline .ant-row .ant-checkbox-wrapper .ant-checkbox-inner {\n  background-color: #082139;\n  border-color: #0a2946;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-thead > tr > th {\n  background: #051B30;\n  color: #E9F6FF;\n  border-color: #051B30;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr > td,\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #051B30;\n}\n.dark-theme .gx-card.listing-wrapper .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #082139;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-card-body {\n  padding: 0px;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-table-thead > tr > th {\n  background: #081C26 !important;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr > td,\n.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #081C26;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {\n  background: #152831;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue {\n  background: transparent;\n  color: #AAAAAA;\n  border-color: #AAAAAA;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.receptionist {\n  color: #97D3F4;\n  border-color: #97D3F4;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.admin {\n  color: #ffffff;\n  border-color: #ffffff;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.mis,\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.mrt {\n  color: #D59DD5;\n  border-color: #D59DD5;\n}\n.dark-theme .gx-card.listing-wrapper.admin .ant-tag-geekblue.typ {\n  color: #B9BDAC;\n  border-color: #B9BDAC;\n}\n.ant-drawer-right .ant-drawer-content-wrapper,\n.ant-drawer-right .ant-drawer-content {\n  min-width: 675px;\n  max-width: 675px;\n  background: #F3F3F3;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body {\n  padding: 0px;\n  padding-right: 10px;\n  overflow: auto;\n  padding-bottom: 10px;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar {\n  width: 5px;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-track,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-track {\n  background: #f5f5f5;\n  border-radius: 4px;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-thumb,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-thumb {\n  background-color: #c1c1c1;\n  border-radius: 4px;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body::-webkit-scrollbar-thumb:hover,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body::-webkit-scrollbar-thumb:hover {\n  background-color: #a8a8a8;\n}\n.ant-drawer-right .ant-drawer-content-wrapper .ant-drawer-body .ant-table-wrapper .ant-table-thead > tr > th,\n.ant-drawer-right .ant-drawer-content .ant-drawer-body .ant-table-wrapper .ant-table-thead > tr > th {\n  font-weight: 600;\n}\n.ant-drawer-right .ant-drawer-content-wrapper {\n  padding-right: 8px;\n}\n.ant-drawer-right .ant-drawer-content {\n  min-width: calc(675px - 40px);\n  overflow: unset;\n}\n.ant-drawer-right .ant-drawer-wrapper-body {\n  overflow: unset;\n}\n.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper,\n.ant-drawer-right.invoice-drawer .ant-drawer-content {\n  min-width: 750px;\n  max-width: 750px;\n  padding-right: 20px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper,\n  .ant-drawer-right.invoice-drawer .ant-drawer-content {\n    min-width: 800px;\n    max-width: 800px;\n  }\n}\n.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table,\n.ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table {\n  font-size: 13px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table,\n  .ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table {\n    font-size: 14px;\n  }\n}\n.ant-drawer-right.invoice-drawer .ant-drawer-content-wrapper .invoices-table tr td,\n.ant-drawer-right.invoice-drawer .ant-drawer-content .invoices-table tr td {\n  padding: 4px;\n  color: #000000;\n}\n.overlapping-drawer.ant-drawer-open {\n  transform: translateX(0px) !important;\n}\n.white-bg .ant-calendar {\n  background-color: #f3f3f3;\n}\n.white-bg .ant-calendar-input {\n  color: #222;\n  background-color: #f3f3f3;\n}\n.white-bg .ant-calendar-header .ant-calendar-prev-century-btn,\n.white-bg .ant-calendar-header .ant-calendar-prev-decade-btn,\n.white-bg .ant-calendar-header .ant-calendar-next-decade-btn,\n.white-bg .ant-calendar-header .ant-calendar-prev-month-btn,\n.white-bg .ant-calendar-header .ant-calendar-next-month-btn,\n.white-bg .ant-calendar-header .ant-calendar-prev-year-btn,\n.white-bg .ant-calendar-header .ant-calendar-next-year-btn,\n.white-bg .ant-calendar-header .ant-calendar-century-select,\n.white-bg .ant-calendar-header .ant-calendar-decade-select,\n.white-bg .ant-calendar-header .ant-calendar-year-select,\n.white-bg .ant-calendar-header .ant-calendar-month-select {\n  color: #222;\n}\n.white-bg .ant-calendar-date {\n  color: #222;\n}\n.white-bg .ant-calendar-date:hover,\n.white-bg .ant-calendar-date:focus,\n.white-bg .ant-calendar-date:active {\n  color: #fff;\n}\n.ant-calendar-picker .ant-calendar-range-picker-separator {\n  vertical-align: text-top;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-select,\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-combobox {\n  border-color: #1c3c5a;\n  background: #18344f;\n}\n.ant-calendar-time .ant-calendar-day-select,\n.ant-calendar-month-panel-month,\n.ant-calendar-decade-panel-decade {\n  color: #E9F6FF;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-time-picker-inner {\n  padding-top: 35px;\n}\n.ant-calendar-range-right .ant-calendar-time-picker-inner {\n  border-color: #1c3c5a;\n}\n.dark-theme .ant-calendar .ant-calendar-ok-btn.ant-calendar-ok-btn-disabled {\n  background-color: #818181;\n  border-color: #818181;\n  cursor: not-allowed;\n}\n.ant-calendar-range.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  font-size: 15px;\n  color: #fff;\n}\nli.ant-calendar-time-picker-select-option-selected,\n.ant-calendar-time-picker-select li:hover {\n  background: #13283c;\n}\n.ant-modal-title {\n  font-size: 18px;\n  color: #051B30;\n}\n@media screen and (min-width: 1600px) {\n  .ant-modal-title {\n    font-size: 20px;\n  }\n}\n.ant-modal.patients-search-modal .ant-modal-body {\n  background: #F3F3F3;\n}\n.ant-modal.patients-search-modal .ant-modal-body .ant-table-body .ant-table-thead > tr > th {\n  background: #c3cac9;\n  color: #222;\n  font-size: 15px;\n  border-color: #bbb;\n}\n.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr > td {\n  border-bottom-color: #eee;\n  color: #575757;\n}\n.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,\n.ant-modal.patients-search-modal .ant-modal-body .ant-table-tbody > tr.ant-table-row-selected td {\n  background: #c0c8c7;\n}\n.dark-theme .ant-upload-list-item:hover .ant-upload-list-item-info {\n  background-color: transparent;\n}\n.dark-theme .white-box .ant-upload-list-item-info .anticon-paper-clip {\n  color: #595959;\n}\n.ant-modal.view-document-modal {\n  top: 25px;\n}\n.ant-modal.view-document-modal .ant-modal-body,\n.ant-modal.view-document-modal .ant-modal-header,\n.ant-modal.view-document-modal .ant-modal-footer {\n  margin-top: 0px;\n  background: #f8f8f8;\n  padding: 15px;\n}\n.ant-modal.view-document-modal .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open,\n.ant-modal.view-document-modal .ant-modal.view-document-modal .ant-tree li span.ant-tree-switcher,\n.ant-modal.view-document-modal .ant-modal.view-document-modal .ant-tree-node-content-wrapper {\n  color: #222 !important;\n  font-size: 14px;\n}\n.ant-modal.view-document-modal .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open {\n  font-weight: bold;\n}\n.dark-theme .ant-modal-body .ant-tree li .ant-tree-node-content-wrapper,\n.dark-theme .ant-tree.ant-tree-show-line li span.ant-tree-switcher {\n  color: #545454;\n}\n.ant-tree li .ant-tree-node-content-wrapper {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.visit-detail-bg.change-password-wrapper form.ant-form {\n  display: flex;\n  flex-wrap: wrap;\n}\n.visit-detail-bg.change-password-wrapper form.ant-form .patient-info-input.ant-input-affix-wrapper {\n  width: 275px;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg.change-password-wrapper form.ant-form .patient-info-input.ant-input-affix-wrapper {\n    width: 325px;\n  }\n}\n.visit-detail-bg.change-password-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n}\n.visit-detail-bg.change-password-wrapper .patient-info-input.ant-input-affix-wrapper {\n  width: 275px;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg.change-password-wrapper .patient-info-input.ant-input-affix-wrapper {\n    width: 325px;\n  }\n}\n.visit-detail-bg.change-password-wrapper .pwd-policy {\n  font-size: 12px;\n  font-style: italic;\n  color: #9BA4AC;\n}\n@media screen and (min-width: 1600px) {\n  .visit-detail-bg.change-password-wrapper .pwd-policy {\n    font-size: 13px;\n  }\n}\n.ant-modal.report-viewer-modal .ant-modal-body {\n  padding: 5px;\n  padding-top: 0px;\n  margin-top: 0px;\n  max-height: 800px;\n  overflow: auto;\n}\n.ant-modal.report-viewer-modal .ant-modal-body .report-btn-container .ant-btn-primary.ant-btn-circle {\n  min-height: 34px;\n  min-width: 33px;\n}\n@media screen and (min-width: 1600px) {\n  .ant-modal.report-viewer-modal .ant-modal-body .ant-btn-primary {\n    min-height: 40px;\n  }\n}\n.ant-modal.report-viewer-modal .ant-modal-body .ant-btn:not(:last-child) {\n  margin-right: 12px;\n}\n.ant-menu-light li.ant-menu-item svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-menu-light li.ant-menu-item svg path {\n  fill: #444444;\n}\n.dark-theme .ant-modal-body .ant-time-picker-input,\n.dark-theme .ant-modal-body .ant-select-selection,\n.dark-theme .ant-modal-body .ant-table {\n  color: #595959;\n}\n.dark-theme .ant-modal-body .examinations-table .ant-time-picker-input,\n.dark-theme .ant-modal-body .examinations-table .ant-select-selection {\n  color: #ffffff;\n}\n.dark-theme .ant-drawer-body .ant-table {\n  color: #595959;\n}\n.dark-theme .ant-drawer-body .examinations-table,\n.dark-theme .ant-drawer-body .examinations-table .ant-table {\n  color: #ffffff;\n}\n.dark-theme .ant-modal.scan-modal .ant-modal-body label.ant-radio-button-wrapper {\n  font-size: 13px !important;\n  color: #111;\n  border-radius: 4px;\n  margin: 2px;\n  border: 1px solid #ccc !important;\n}\n.dark-theme .ant-modal.scan-modal .ant-modal-body label.ant-radio-button-wrapper:hover {\n  color: #60bbe7;\n}\n.dark-theme .ant-modal.scan-modal .ant-modal-body .ant-select-selection:hover {\n  border-color: #dde2e6;\n}\n.ant-btn.end-visit-close-btn {\n  position: absolute;\n  top: -50px;\n  right: -25px;\n  border: none;\n  box-shadow: none;\n  color: #000;\n  font-size: 16px;\n  width: 32px;\n  padding: 4px;\n  min-height: 32px;\n}\n.view-images-btn {\n  background-color: #00796b !important;\n  border-color: #00796b !important;\n  color: #fff !important;\n}\n.ant-card.white-card {\n  background: #ffffff;\n  border: none;\n  color: #383838;\n}\n.ant-card.white-card .ant-card-body {\n  padding: 0px;\n}\n.notes-confirmation {\n  margin-top: 15px;\n}\n.ant-modal.gx-modal-container .ant-modal-header,\n.ant-modal.gx-modal-container .ant-modal-footer {\n  background-color: #F3F3F3;\n}\n.ant-modal.gx-modal-container .ant-modal-header .ant-modal-title,\n.ant-modal.gx-modal-container .ant-modal-footer .ant-modal-title {\n  font-weight: 600;\n}\n.ant-modal.gx-modal-container .ant-modal-footer {\n  padding: 10px 18px;\n}\n.ant-modal.gx-modal-container .ant-modal-body {\n  background-color: #F3F3F3;\n  margin-top: 0px;\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.ant-modal.gx-modal-container .ant-modal-body .ant-form-item-label label {\n  color: #6B6B6B;\n  font-weight: 600;\n}\n.ant-modal.gx-modal-container .ant-modal-body .visit-notes-tree {\n  border-radius: 8px;\n}\n.ant-modal.gx-modal-container .ant-modal-body .ant-table {\n  background-color: #fff;\n}\n.ant-modal.gx-modal-container .ant-modal-body .visit-notes-tree + .ant-row {\n  margin-right: 0 !important;\n  margin-top: 12px !important;\n  margin-bottom: 5px !important;\n}\n.ant-modal.gx-modal-container .gx-popup-form {\n  background-color: #ffffff;\n  padding: 12px 16px;\n  margin: 0 -2px;\n  border-radius: 8px;\n}\n.ant-modal.gx-modal-container .notes-confirmation {\n  margin-top: 0px;\n}\n.loc-row,\n.loc-row.ant-row {\n  margin: 8px 0px 8px;\n  padding-bottom: 8px;\n  border-bottom: 3px solid #F3F3F3;\n}\n.loc-row:last-child,\n.loc-row.ant-row:last-child {\n  border-bottom: none;\n}\n.ant-table-wrapper.ref-doc-table .ant-table-body tr td p {\n  margin-bottom: 5px;\n}\n.ant-table-placeholder {\n  border-bottom: none;\n  margin-top: 0px;\n}\n.powerbi-error-block h3,\n.powerbi-error-block p {\n  color: #5e5e5e;\n}\n.notifications-popover .ant-list-items svg {\n  max-width: 16px;\n  min-width: 16px;\n}\n.notifications-popover .ant-list-items svg path {\n  fill: #7E7E7E;\n}\n.amrHighlightIcon {\n  position: absolute;\n  top: 0px;\n  right: 6px;\n}\n.amrHighlightIcon svg path {\n  fill: #f00;\n}\n.complete-visit-modal.ant-modal {\n  width: 450px !important;\n}\n.complete-visit-modal.ant-modal .ant-modal-header {\n  background-color: #F3F3F3;\n}\n.complete-visit-modal.ant-modal .ant-modal-footer {\n  border: none;\n  padding-bottom: 20px;\n}\n/*Media Queries*/\n@media screen and (max-width: 768px) {\n  #root {\n    overflow-y: auto;\n  }\n}\n@media screen and (min-width: 1600px) {\n  .ant-modal.view-document-modal .ant-btn.ant-btn-circle,\n  .drawer-form .ant-btn.ant-btn-circle {\n    min-height: 37px;\n  }\n}\n@media screen and (min-width: 1440px) {\n  .custom-site {\n    width: 170px !important;\n  }\n}\n@media screen and (max-width: 1024px) {\n  .custom-site {\n    width: 90px !important;\n  }\n}\n@media screen and (min-width: 1024px) and (max-width: 1439) {\n  .custom-site {\n    width: 110px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
